(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 64785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
  }));
}

const ForwardRef = React.forwardRef(PlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 88305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function XMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
  }));
}

const ForwardRef = React.forwardRef(XMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AcademicCapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"
  }));
}

const ForwardRef = React.forwardRef(AcademicCapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AdjustmentsHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
  }));
}

const ForwardRef = React.forwardRef(AdjustmentsHorizontalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AdjustmentsVerticalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
  }));
}

const ForwardRef = React.forwardRef(AdjustmentsVerticalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 33186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 4.5l-15 15m0 0h11.25m-11.25 0V8.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 2115:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 67716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownOnSquareStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownOnSquareStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownTrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownTrayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 74177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftOnRectangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftOnRectangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 13323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowPathIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
  }));
}

const ForwardRef = React.forwardRef(ArrowPathIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowPathRoundedSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
  }));
}

const ForwardRef = React.forwardRef(ArrowPathRoundedSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94646:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightOnRectangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightOnRectangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 50605:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 83387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57793:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTopRightOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowTopRightOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTrendingDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendingDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 10546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTrendingUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendingUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 27051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76480:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 29906:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpOnSquareStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpOnSquareStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpTrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpTrayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 35718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 15l-6 6m0 0l-6-6m6 6V9a6 6 0 0112 0v3"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 10811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9l6-6m0 0l6 6m-6-6v12a6 6 0 01-12 0v-3"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8541:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsPointingInIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"
  }));
}

const ForwardRef = React.forwardRef(ArrowsPointingInIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 32173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsPointingOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
  }));
}

const ForwardRef = React.forwardRef(ArrowsPointingOutIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsRightLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
  }));
}

const ForwardRef = React.forwardRef(ArrowsRightLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
  }));
}

const ForwardRef = React.forwardRef(ArrowsUpDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AtSymbolIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"
  }));
}

const ForwardRef = React.forwardRef(AtSymbolIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 62707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BackspaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"
  }));
}

const ForwardRef = React.forwardRef(BackspaceIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BackwardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953l7.108-4.062A1.125 1.125 0 0121 8.688v8.123zM11.25 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953L9.567 7.71a1.125 1.125 0 011.683.977v8.123z"
  }));
}

const ForwardRef = React.forwardRef(BackwardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BanknotesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
  }));
}

const ForwardRef = React.forwardRef(BanknotesIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 9h16.5m-16.5 6.75h16.5"
  }));
}

const ForwardRef = React.forwardRef(Bars2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 24608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3BottomLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
  }));
}

const ForwardRef = React.forwardRef(Bars3BottomLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 20748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3BottomRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
  }));
}

const ForwardRef = React.forwardRef(Bars3BottomRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3CenterLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
  }));
}

const ForwardRef = React.forwardRef(Bars3CenterLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 23630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
  }));
}

const ForwardRef = React.forwardRef(Bars3Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 9752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars4Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
  }));
}

const ForwardRef = React.forwardRef(Bars4Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 78259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BarsArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25"
  }));
}

const ForwardRef = React.forwardRef(BarsArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 78988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BarsArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
  }));
}

const ForwardRef = React.forwardRef(BarsArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 70384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery0Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"
  }));
}

const ForwardRef = React.forwardRef(Battery0Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 34343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery100Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"
  }));
}

const ForwardRef = React.forwardRef(Battery100Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 54954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery50Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5zM3.75 18h15A2.25 2.25 0 0021 15.75v-6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 001.5 9.75v6A2.25 2.25 0 003.75 18z"
  }));
}

const ForwardRef = React.forwardRef(Battery50Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 1165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BeakerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
  }));
}

const ForwardRef = React.forwardRef(BeakerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
  }));
}

const ForwardRef = React.forwardRef(BellAlertIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
  }));
}

const ForwardRef = React.forwardRef(BellIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
  }));
}

const ForwardRef = React.forwardRef(BellSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellSnoozeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M10.5 8.25h3l-3 4.5h3"
  }));
}

const ForwardRef = React.forwardRef(BellSnoozeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 78653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BoltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
  }));
}

const ForwardRef = React.forwardRef(BoltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BoltSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.412 15.655L9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457L3 3m5.457 5.457l7.086 7.086m0 0L21 21"
  }));
}

const ForwardRef = React.forwardRef(BoltSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
  }));
}

const ForwardRef = React.forwardRef(BookOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
  }));
}

const ForwardRef = React.forwardRef(BookmarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 011.743-1.342 48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664L19.5 19.5"
  }));
}

const ForwardRef = React.forwardRef(BookmarkSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9"
  }));
}

const ForwardRef = React.forwardRef(BookmarkSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 2946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BriefcaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(BriefcaseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BugAntIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082"
  }));
}

const ForwardRef = React.forwardRef(BugAntIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 95100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingLibraryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
  }));
}

const ForwardRef = React.forwardRef(BuildingLibraryIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 86878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingOffice2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
  }));
}

const ForwardRef = React.forwardRef(BuildingOffice2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 43943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingOfficeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
  }));
}

const ForwardRef = React.forwardRef(BuildingOfficeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingStorefrontIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"
  }));
}

const ForwardRef = React.forwardRef(BuildingStorefrontIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CakeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.87c1.355 0 2.697.055 4.024.165C17.155 8.51 18 9.473 18 10.608v2.513m-3-4.87v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.38a48.474 48.474 0 00-6-.37c-2.032 0-4.034.125-6 .37m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265zm-3 0a.375.375 0 11-.53 0L9 2.845l.265.265zm6 0a.375.375 0 11-.53 0L15 2.845l.265.265z"
  }));
}

const ForwardRef = React.forwardRef(CakeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalculatorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
  }));
}

const ForwardRef = React.forwardRef(CalculatorIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 84565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalendarDaysIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
  }));
}

const ForwardRef = React.forwardRef(CalendarDaysIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
  }));
}

const ForwardRef = React.forwardRef(CalendarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"
  }));
}

const ForwardRef = React.forwardRef(CameraIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
  }));
}

const ForwardRef = React.forwardRef(ChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartBarSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
  }));
}

const ForwardRef = React.forwardRef(ChartBarSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartPieIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
  }));
}

const ForwardRef = React.forwardRef(ChartPieIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 27931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleBottomCenterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleBottomCenterIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleBottomCenterTextIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleBottomCenterTextIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55232:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftEllipsisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftEllipsisIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 50904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleOvalLeftEllipsisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleOvalLeftEllipsisIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 53952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleOvalLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleOvalLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckBadgeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
  }));
}

const ForwardRef = React.forwardRef(CheckBadgeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CheckCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12.75l6 6 9-13.5"
  }));
}

const ForwardRef = React.forwardRef(CheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1460:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 67042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 19.5L8.25 12l7.5-7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
  }));
}

const ForwardRef = React.forwardRef(ChevronUpDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
  }));
}

const ForwardRef = React.forwardRef(ChevronUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CircleStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
  }));
}

const ForwardRef = React.forwardRef(CircleStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 10568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentListIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"
  }));
}

const ForwardRef = React.forwardRef(ClipboardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 65670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(ClockIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
  }));
}

const ForwardRef = React.forwardRef(CloudArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
  }));
}

const ForwardRef = React.forwardRef(CloudArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"
  }));
}

const ForwardRef = React.forwardRef(CloudIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CodeBracketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 33003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CodeBracketSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 35996:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Cog6ToothIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = React.forwardRef(Cog6ToothIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Cog8ToothIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = React.forwardRef(Cog8ToothIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
  }));
}

const ForwardRef = React.forwardRef(CogIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 83871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CommandLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(CommandLineIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ComputerDesktopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"
  }));
}

const ForwardRef = React.forwardRef(ComputerDesktopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CpuChipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z"
  }));
}

const ForwardRef = React.forwardRef(CpuChipIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CreditCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
  }));
}

const ForwardRef = React.forwardRef(CreditCardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 86013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
  }));
}

const ForwardRef = React.forwardRef(CubeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 31929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CubeTransparentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
  }));
}

const ForwardRef = React.forwardRef(CubeTransparentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyBangladeshiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 7.5l.415-.207a.75.75 0 011.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 005.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyBangladeshiIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 65406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyDollarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 38623:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyEuroIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyPoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyPoundIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyRupeeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 8.25H9m6 3H9m3 6l-3-3h1.5a3 3 0 100-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyRupeeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyYenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 7.5l3 4.5m0 0l3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CurrencyYenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 6707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CursorArrowRaysIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"
  }));
}

const ForwardRef = React.forwardRef(CursorArrowRaysIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CursorArrowRippleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5"
  }));
}

const ForwardRef = React.forwardRef(CursorArrowRippleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DevicePhoneMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
  }));
}

const ForwardRef = React.forwardRef(DevicePhoneMobileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DeviceTabletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(DeviceTabletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"
  }));
}

const ForwardRef = React.forwardRef(DocumentCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 16410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentDuplicateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
  }));
}

const ForwardRef = React.forwardRef(DocumentDuplicateIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentMagnifyingGlassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
  }));
}

const ForwardRef = React.forwardRef(DocumentMagnifyingGlassIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 21751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 26894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentTextIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
  }));
}

const ForwardRef = React.forwardRef(DocumentTextIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisHorizontalCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(EllipsisHorizontalCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 74818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
  }));
}

const ForwardRef = React.forwardRef(EllipsisHorizontalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisVerticalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
  }));
}

const ForwardRef = React.forwardRef(EllipsisVerticalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 88409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EnvelopeOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ExclamationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ExclamationCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 89381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ExclamationTriangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 23541:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeDropperIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 11.25l1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 10-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25L12.75 9"
  }));
}

const ForwardRef = React.forwardRef(EyeDropperIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = React.forwardRef(EyeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 84700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
  }));
}

const ForwardRef = React.forwardRef(EyeSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FaceFrownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
  }));
}

const ForwardRef = React.forwardRef(FaceFrownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FaceSmileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
  }));
}

const ForwardRef = React.forwardRef(FaceSmileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 39929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FilmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0118 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0118 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 016 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
  }));
}

const ForwardRef = React.forwardRef(FilmIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49039:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FingerPrintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"
  }));
}

const ForwardRef = React.forwardRef(FingerPrintIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FireIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
  }));
}

const ForwardRef = React.forwardRef(FireIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 83515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FlagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"
  }));
}

const ForwardRef = React.forwardRef(FlagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 70233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
  }));
}

const ForwardRef = React.forwardRef(FolderArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40806:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
  }));
}

const ForwardRef = React.forwardRef(FolderIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 13.5H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
  }));
}

const ForwardRef = React.forwardRef(FolderMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776"
  }));
}

const ForwardRef = React.forwardRef(FolderOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 65031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
  }));
}

const ForwardRef = React.forwardRef(FolderPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 21447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ForwardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"
  }));
}

const ForwardRef = React.forwardRef(ForwardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FunnelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
  }));
}

const ForwardRef = React.forwardRef(FunnelIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 43923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GifIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
  }));
}

const ForwardRef = React.forwardRef(GifIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GiftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(GiftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GiftTopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 004.875-4.875V12m6.375 5.25a4.875 4.875 0 01-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 013.182 3.182zM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 113.182-3.182z"
  }));
}

const ForwardRef = React.forwardRef(GiftTopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
  }));
}

const ForwardRef = React.forwardRef(GlobeAltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52115:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAmericasIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 01-.98-.314l-.295-.295a1.125 1.125 0 010-1.591l.13-.132a1.125 1.125 0 011.3-.21l.603.302a.809.809 0 001.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 001.528-1.732l.146-.292M6.115 5.19A9 9 0 1017.18 4.64M6.115 5.19A8.965 8.965 0 0112 3c1.929 0 3.716.607 5.18 1.64"
  }));
}

const ForwardRef = React.forwardRef(GlobeAmericasIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAsiaAustraliaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 00-8.862 12.872M12.75 3.031a9 9 0 016.69 14.036m0 0l-.177-.529A2.25 2.25 0 0017.128 15H16.5l-.324-.324a1.453 1.453 0 00-2.328.377l-.036.073a1.586 1.586 0 01-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 01-5.276 3.67m0 0a9 9 0 01-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"
  }));
}

const ForwardRef = React.forwardRef(GlobeAsiaAustraliaIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 53403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeEuropeAfricaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525"
  }));
}

const ForwardRef = React.forwardRef(GlobeEuropeAfricaIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandRaisedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"
  }));
}

const ForwardRef = React.forwardRef(HandRaisedIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandThumbDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 15h2.25m8.024-9.75c.011.05.028.1.052.148.591 1.2.924 2.55.924 3.977a8.96 8.96 0 01-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398C20.613 14.547 19.833 15 19 15h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 00.303-.54m.023-8.25H16.48a4.5 4.5 0 01-1.423-.23l-3.114-1.04a4.5 4.5 0 00-1.423-.23H6.504c-.618 0-1.217.247-1.605.729A11.95 11.95 0 002.25 12c0 .434.023.863.068 1.285C2.427 14.306 3.346 15 4.372 15h3.126c.618 0 .991.724.725 1.282A7.471 7.471 0 007.5 19.5a2.25 2.25 0 002.25 2.25.75.75 0 00.75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 002.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384"
  }));
}

const ForwardRef = React.forwardRef(HandThumbDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandThumbUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"
  }));
}

const ForwardRef = React.forwardRef(HandThumbUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HashtagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"
  }));
}

const ForwardRef = React.forwardRef(HashtagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 7765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HeartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
  }));
}

const ForwardRef = React.forwardRef(HeartIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 60220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
  }));
}

const ForwardRef = React.forwardRef(HomeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HomeModernIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"
  }));
}

const ForwardRef = React.forwardRef(HomeModernIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function IdentificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"
  }));
}

const ForwardRef = React.forwardRef(IdentificationIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"
  }));
}

const ForwardRef = React.forwardRef(InboxArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 86163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
  }));
}

const ForwardRef = React.forwardRef(InboxIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(InboxStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InformationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
  }));
}

const ForwardRef = React.forwardRef(InformationCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function KeyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z"
  }));
}

const ForwardRef = React.forwardRef(KeyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"
  }));
}

const ForwardRef = React.forwardRef(LanguageIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 39393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LifebuoyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.712 4.33a9.027 9.027 0 011.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 00-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 010 9.424m-4.138-5.976a3.736 3.736 0 00-.88-1.388 3.737 3.737 0 00-1.388-.88m2.268 2.268a3.765 3.765 0 010 2.528m-2.268-4.796a3.765 3.765 0 00-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 01-1.388.88m2.268-2.268l4.138 3.448m0 0a9.027 9.027 0 01-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0l-3.448-4.138m3.448 4.138a9.014 9.014 0 01-9.424 0m5.976-4.138a3.765 3.765 0 01-2.528 0m0 0a3.736 3.736 0 01-1.388-.88 3.737 3.737 0 01-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 01-1.652-1.306 9.027 9.027 0 01-1.306-1.652m0 0l4.138-3.448M4.33 16.712a9.014 9.014 0 010-9.424m4.138 5.976a3.765 3.765 0 010-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 011.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 00-1.652 1.306A9.025 9.025 0 004.33 7.288"
  }));
}

const ForwardRef = React.forwardRef(LifebuoyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LightBulbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
  }));
}

const ForwardRef = React.forwardRef(LightBulbIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
  }));
}

const ForwardRef = React.forwardRef(LinkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ListBulletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
  }));
}

const ForwardRef = React.forwardRef(ListBulletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 78515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LockClosedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(LockClosedIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 74170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LockOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(LockOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 123:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 32440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
  }));
}

const ForwardRef = React.forwardRef(MapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MapPinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
  }));
}

const ForwardRef = React.forwardRef(MapPinIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 81723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MegaphoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"
  }));
}

const ForwardRef = React.forwardRef(MegaphoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 89244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MicrophoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z"
  }));
}

const ForwardRef = React.forwardRef(MicrophoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(MinusCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 21746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12h-15"
  }));
}

const ForwardRef = React.forwardRef(MinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 58946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 12H6"
  }));
}

const ForwardRef = React.forwardRef(MinusSmallIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MoonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
  }));
}

const ForwardRef = React.forwardRef(MoonIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 13772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MusicalNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"
  }));
}

const ForwardRef = React.forwardRef(MusicalNoteIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function NewspaperIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"
  }));
}

const ForwardRef = React.forwardRef(NewspaperIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function NoSymbolIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
  }));
}

const ForwardRef = React.forwardRef(NoSymbolIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaintBrushIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"
  }));
}

const ForwardRef = React.forwardRef(PaintBrushIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaperAirplaneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
  }));
}

const ForwardRef = React.forwardRef(PaperAirplaneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaperClipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
  }));
}

const ForwardRef = React.forwardRef(PaperClipIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90402:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PauseCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(PauseCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 50188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 5.25v13.5m-7.5-13.5v13.5"
  }));
}

const ForwardRef = React.forwardRef(PauseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PencilIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
  }));
}

const ForwardRef = React.forwardRef(PencilIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4063:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PencilSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
  }));
}

const ForwardRef = React.forwardRef(PencilSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 38675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneArrowDownLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"
  }));
}

const ForwardRef = React.forwardRef(PhoneArrowDownLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneArrowUpRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 3.75v4.5m0-4.5h-4.5m4.5 0l-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"
  }));
}

const ForwardRef = React.forwardRef(PhoneArrowUpRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 43361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
  }));
}

const ForwardRef = React.forwardRef(PhoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97991:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 3.75L18 6m0 0l2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z"
  }));
}

const ForwardRef = React.forwardRef(PhoneXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhotoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
  }));
}

const ForwardRef = React.forwardRef(PhotoIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
  }));
}

const ForwardRef = React.forwardRef(PlayCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92284:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
  }));
}

const ForwardRef = React.forwardRef(PlayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayPauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 010 1.954l-7.108 4.061A1.125 1.125 0 013 16.811z"
  }));
}

const ForwardRef = React.forwardRef(PlayPauseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(PlusCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 16084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4.5v15m7.5-7.5h-15"
  }));
}

const ForwardRef = React.forwardRef(PlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 88519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v12m6-6H6"
  }));
}

const ForwardRef = React.forwardRef(PlusSmallIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PowerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.636 5.636a9 9 0 1012.728 0M12 3v9"
  }));
}

const ForwardRef = React.forwardRef(PowerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 60355:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PresentationChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
  }));
}

const ForwardRef = React.forwardRef(PresentationChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PresentationChartLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"
  }));
}

const ForwardRef = React.forwardRef(PresentationChartLineIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PrinterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"
  }));
}

const ForwardRef = React.forwardRef(PrinterIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 45983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PuzzlePieceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z"
  }));
}

const ForwardRef = React.forwardRef(PuzzlePieceIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QrCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
  }));
}

const ForwardRef = React.forwardRef(QrCodeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QuestionMarkCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(QuestionMarkCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 62754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QueueListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"
  }));
}

const ForwardRef = React.forwardRef(QueueListIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RadioIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 7.5l16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 004.5 21h15a2.25 2.25 0 002.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0012 6.75zm-1.683 6.443l-.005.005-.006-.005.006-.005.005.005zm-.005 2.127l-.005-.006.005-.005.005.005-.005.005zm-2.116-.006l-.005.006-.006-.006.005-.005.006.005zm-.005-2.116l-.006-.005.006-.005.005.005-.005.005zM9.255 10.5v.008h-.008V10.5h.008zm3.249 1.88l-.007.004-.003-.007.006-.003.004.006zm-1.38 5.126l-.003-.006.006-.004.004.007-.006.003zm.007-6.501l-.003.006-.007-.003.004-.007.006.004zm1.37 5.129l-.007-.004.004-.006.006.003-.004.007zm.504-1.877h-.008v-.007h.008v.007zM9.255 18v.008h-.008V18h.008zm-3.246-1.87l-.007.004L6 16.127l.006-.003.004.006zm1.366-5.119l-.004-.006.006-.004.004.007-.006.003zM7.38 17.5l-.003.006-.007-.003.004-.007.006.004zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007zm-.5 1.873h-.008v-.007h.008v.007zM17.25 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zm0 4.5a.75.75 0 110-1.5.75.75 0 010 1.5z"
  }));
}

const ForwardRef = React.forwardRef(RadioIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ReceiptPercentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
  }));
}

const ForwardRef = React.forwardRef(ReceiptPercentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14356:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ReceiptRefundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 9.75h4.875a2.625 2.625 0 010 5.25H12M8.25 9.75L10.5 7.5M8.25 9.75L10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185z"
  }));
}

const ForwardRef = React.forwardRef(ReceiptRefundIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RectangleGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
  }));
}

const ForwardRef = React.forwardRef(RectangleGroupIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 26291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RectangleStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"
  }));
}

const ForwardRef = React.forwardRef(RectangleStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RocketLaunchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  }));
}

const ForwardRef = React.forwardRef(RocketLaunchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 35421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RssIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 19.5v-.75a7.5 7.5 0 00-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
  }));
}

const ForwardRef = React.forwardRef(RssIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 74759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ScaleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z"
  }));
}

const ForwardRef = React.forwardRef(ScaleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ScissorsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.848 8.25l1.536.887M7.848 8.25a3 3 0 11-5.196-3 3 3 0 015.196 3zm1.536.887a2.165 2.165 0 011.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 11-5.196 3 3 3 0 015.196-3zm1.536-.887a2.165 2.165 0 001.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863l2.077-1.199m0-3.328a4.323 4.323 0 012.068-1.379l5.325-1.628a4.5 4.5 0 012.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.331 4.331 0 0010.607 12m3.736 0l7.794 4.5-.802.215a4.5 4.5 0 01-2.48-.043l-5.326-1.629a4.324 4.324 0 01-2.068-1.379M14.343 12l-2.882 1.664"
  }));
}

const ForwardRef = React.forwardRef(ScissorsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ServerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ServerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ServerStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ServerStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
  }));
}

const ForwardRef = React.forwardRef(ShareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShieldCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
  }));
}

const ForwardRef = React.forwardRef(ShieldCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShieldExclamationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ShieldExclamationIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShoppingBagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
  }));
}

const ForwardRef = React.forwardRef(ShoppingBagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShoppingCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
  }));
}

const ForwardRef = React.forwardRef(ShoppingCartIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SignalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
  }));
}

const ForwardRef = React.forwardRef(SignalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 74024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SignalSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3l8.735 8.735m0 0a.374.374 0 11.53.53m-.53-.53l.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 010 5.304m2.121-7.425a6.75 6.75 0 010 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 01-1.06-2.122m-1.061 4.243a6.75 6.75 0 01-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12z"
  }));
}

const ForwardRef = React.forwardRef(SignalSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
  }));
}

const ForwardRef = React.forwardRef(SparklesIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SpeakerWaveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"
  }));
}

const ForwardRef = React.forwardRef(SpeakerWaveIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SpeakerXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.531V19.94a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.506-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.395C2.806 8.757 3.63 8.25 4.51 8.25H6.75z"
  }));
}

const ForwardRef = React.forwardRef(SpeakerXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 26561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Square2StackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"
  }));
}

const ForwardRef = React.forwardRef(Square2StackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Square3Stack3DIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"
  }));
}

const ForwardRef = React.forwardRef(Square3Stack3DIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Squares2X2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
  }));
}

const ForwardRef = React.forwardRef(Squares2X2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 9351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SquaresPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(SquaresPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 45401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
  }));
}

const ForwardRef = React.forwardRef(StarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 67103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StopCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z"
  }));
}

const ForwardRef = React.forwardRef(StopCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"
  }));
}

const ForwardRef = React.forwardRef(StopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SunIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
  }));
}

const ForwardRef = React.forwardRef(SunIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 50911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SwatchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"
  }));
}

const ForwardRef = React.forwardRef(SwatchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TableCellsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
  }));
}

const ForwardRef = React.forwardRef(TableCellsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 6h.008v.008H6V6z"
  }));
}

const ForwardRef = React.forwardRef(TagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TicketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
  }));
}

const ForwardRef = React.forwardRef(TicketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 84703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
  }));
}

const ForwardRef = React.forwardRef(TrashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TrophyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
  }));
}

const ForwardRef = React.forwardRef(TrophyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TruckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
  }));
}

const ForwardRef = React.forwardRef(TruckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 65177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(TvIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = React.forwardRef(UserCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 89954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
  }));
}

const ForwardRef = React.forwardRef(UserGroupIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
  }));
}

const ForwardRef = React.forwardRef(UserIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
  }));
}

const ForwardRef = React.forwardRef(UserMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
  }));
}

const ForwardRef = React.forwardRef(UserPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
  }));
}

const ForwardRef = React.forwardRef(UsersIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VariableIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.745 3A23.933 23.933 0 003 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 011.105.402l2.402 7.206a.75.75 0 001.104.401l1.445-.889m-8.25.75l.213.09a1.687 1.687 0 002.062-.617l4.45-6.676a1.688 1.688 0 012.062-.618l.213.09"
  }));
}

const ForwardRef = React.forwardRef(VariableIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VideoCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
  }));
}

const ForwardRef = React.forwardRef(VideoCameraIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VideoCameraSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
  }));
}

const ForwardRef = React.forwardRef(VideoCameraSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ViewColumnsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z"
  }));
}

const ForwardRef = React.forwardRef(ViewColumnsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 19436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ViewfinderCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = React.forwardRef(ViewfinderCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"
  }));
}

const ForwardRef = React.forwardRef(WalletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WifiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"
  }));
}

const ForwardRef = React.forwardRef(WifiIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WindowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z"
  }));
}

const ForwardRef = React.forwardRef(WindowIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 31025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WrenchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.867 19.125h.008v.008h-.008v-.008z"
  }));
}

const ForwardRef = React.forwardRef(WrenchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22682:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WrenchScrewdriverIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
  }));
}

const ForwardRef = React.forwardRef(WrenchScrewdriverIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function XCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(XCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function XMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}

const ForwardRef = React.forwardRef(XMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports.AcademicCapIcon = __webpack_require__(61965)
module.exports.AdjustmentsHorizontalIcon = __webpack_require__(30778)
module.exports.AdjustmentsVerticalIcon = __webpack_require__(55279)
module.exports.ArchiveBoxArrowDownIcon = __webpack_require__(79188)
module.exports.ArchiveBoxXMarkIcon = __webpack_require__(36580)
module.exports.ArchiveBoxIcon = __webpack_require__(420)
module.exports.ArrowDownCircleIcon = __webpack_require__(33186)
module.exports.ArrowDownLeftIcon = __webpack_require__(87549)
module.exports.ArrowDownOnSquareStackIcon = __webpack_require__(67716)
module.exports.ArrowDownOnSquareIcon = __webpack_require__(2115)
module.exports.ArrowDownRightIcon = __webpack_require__(57866)
module.exports.ArrowDownTrayIcon = __webpack_require__(90980)
module.exports.ArrowDownIcon = __webpack_require__(75931)
module.exports.ArrowLeftCircleIcon = __webpack_require__(47398)
module.exports.ArrowLeftOnRectangleIcon = __webpack_require__(74177)
module.exports.ArrowLeftIcon = __webpack_require__(44622)
module.exports.ArrowLongDownIcon = __webpack_require__(22388)
module.exports.ArrowLongLeftIcon = __webpack_require__(96365)
module.exports.ArrowLongRightIcon = __webpack_require__(79198)
module.exports.ArrowLongUpIcon = __webpack_require__(13323)
module.exports.ArrowPathRoundedSquareIcon = __webpack_require__(56424)
module.exports.ArrowPathIcon = __webpack_require__(36942)
module.exports.ArrowRightCircleIcon = __webpack_require__(25277)
module.exports.ArrowRightOnRectangleIcon = __webpack_require__(94646)
module.exports.ArrowRightIcon = __webpack_require__(25171)
module.exports.ArrowSmallDownIcon = __webpack_require__(3131)
module.exports.ArrowSmallLeftIcon = __webpack_require__(50605)
module.exports.ArrowSmallRightIcon = __webpack_require__(85152)
module.exports.ArrowSmallUpIcon = __webpack_require__(83387)
module.exports.ArrowTopRightOnSquareIcon = __webpack_require__(57793)
module.exports.ArrowTrendingDownIcon = __webpack_require__(52732)
module.exports.ArrowTrendingUpIcon = __webpack_require__(10546)
module.exports.ArrowUpCircleIcon = __webpack_require__(42127)
module.exports.ArrowUpLeftIcon = __webpack_require__(98866)
module.exports.ArrowUpOnSquareStackIcon = __webpack_require__(29906)
module.exports.ArrowUpOnSquareIcon = __webpack_require__(76480)
module.exports.ArrowUpRightIcon = __webpack_require__(77409)
module.exports.ArrowUpTrayIcon = __webpack_require__(94434)
module.exports.ArrowUpIcon = __webpack_require__(27051)
module.exports.ArrowUturnDownIcon = __webpack_require__(35718)
module.exports.ArrowUturnLeftIcon = __webpack_require__(30581)
module.exports.ArrowUturnRightIcon = __webpack_require__(10811)
module.exports.ArrowUturnUpIcon = __webpack_require__(28660)
module.exports.ArrowsPointingInIcon = __webpack_require__(8541)
module.exports.ArrowsPointingOutIcon = __webpack_require__(32173)
module.exports.ArrowsRightLeftIcon = __webpack_require__(49727)
module.exports.ArrowsUpDownIcon = __webpack_require__(80582)
module.exports.AtSymbolIcon = __webpack_require__(90989)
module.exports.BackspaceIcon = __webpack_require__(62707)
module.exports.BackwardIcon = __webpack_require__(85789)
module.exports.BanknotesIcon = __webpack_require__(71248)
module.exports.Bars2Icon = __webpack_require__(24997)
module.exports.Bars3BottomLeftIcon = __webpack_require__(24608)
module.exports.Bars3BottomRightIcon = __webpack_require__(20748)
module.exports.Bars3CenterLeftIcon = __webpack_require__(82920)
module.exports.Bars3Icon = __webpack_require__(23630)
module.exports.Bars4Icon = __webpack_require__(9752)
module.exports.BarsArrowDownIcon = __webpack_require__(78259)
module.exports.BarsArrowUpIcon = __webpack_require__(78988)
module.exports.Battery0Icon = __webpack_require__(70384)
module.exports.Battery100Icon = __webpack_require__(34343)
module.exports.Battery50Icon = __webpack_require__(54954)
module.exports.BeakerIcon = __webpack_require__(1165)
module.exports.BellAlertIcon = __webpack_require__(61525)
module.exports.BellSlashIcon = __webpack_require__(66326)
module.exports.BellSnoozeIcon = __webpack_require__(46472)
module.exports.BellIcon = __webpack_require__(12965)
module.exports.BoltSlashIcon = __webpack_require__(59102)
module.exports.BoltIcon = __webpack_require__(78653)
module.exports.BookOpenIcon = __webpack_require__(77116)
module.exports.BookmarkSlashIcon = __webpack_require__(71314)
module.exports.BookmarkSquareIcon = __webpack_require__(99695)
module.exports.BookmarkIcon = __webpack_require__(24187)
module.exports.BriefcaseIcon = __webpack_require__(2946)
module.exports.BugAntIcon = __webpack_require__(42475)
module.exports.BuildingLibraryIcon = __webpack_require__(95100)
module.exports.BuildingOffice2Icon = __webpack_require__(86878)
module.exports.BuildingOfficeIcon = __webpack_require__(43943)
module.exports.BuildingStorefrontIcon = __webpack_require__(96704)
module.exports.CakeIcon = __webpack_require__(73383)
module.exports.CalculatorIcon = __webpack_require__(79141)
module.exports.CalendarDaysIcon = __webpack_require__(84565)
module.exports.CalendarIcon = __webpack_require__(92363)
module.exports.CameraIcon = __webpack_require__(79849)
module.exports.ChartBarSquareIcon = __webpack_require__(97347)
module.exports.ChartBarIcon = __webpack_require__(96959)
module.exports.ChartPieIcon = __webpack_require__(99069)
module.exports.ChatBubbleBottomCenterTextIcon = __webpack_require__(59201)
module.exports.ChatBubbleBottomCenterIcon = __webpack_require__(27931)
module.exports.ChatBubbleLeftEllipsisIcon = __webpack_require__(55232)
module.exports.ChatBubbleLeftRightIcon = __webpack_require__(63034)
module.exports.ChatBubbleLeftIcon = __webpack_require__(50904)
module.exports.ChatBubbleOvalLeftEllipsisIcon = __webpack_require__(46712)
module.exports.ChatBubbleOvalLeftIcon = __webpack_require__(53952)
module.exports.CheckBadgeIcon = __webpack_require__(61009)
module.exports.CheckCircleIcon = __webpack_require__(8657)
module.exports.CheckIcon = __webpack_require__(73957)
module.exports.ChevronDoubleDownIcon = __webpack_require__(91422)
module.exports.ChevronDoubleLeftIcon = __webpack_require__(64453)
module.exports.ChevronDoubleRightIcon = __webpack_require__(1460)
module.exports.ChevronDoubleUpIcon = __webpack_require__(34043)
module.exports.ChevronDownIcon = __webpack_require__(4836)
module.exports.ChevronLeftIcon = __webpack_require__(67042)
module.exports.ChevronRightIcon = __webpack_require__(28732)
module.exports.ChevronUpDownIcon = __webpack_require__(66763)
module.exports.ChevronUpIcon = __webpack_require__(97381)
module.exports.CircleStackIcon = __webpack_require__(47254)
module.exports.ClipboardDocumentCheckIcon = __webpack_require__(10568)
module.exports.ClipboardDocumentListIcon = __webpack_require__(72705)
module.exports.ClipboardDocumentIcon = __webpack_require__(73621)
module.exports.ClipboardIcon = __webpack_require__(44950)
module.exports.ClockIcon = __webpack_require__(65670)
module.exports.CloudArrowDownIcon = __webpack_require__(56741)
module.exports.CloudArrowUpIcon = __webpack_require__(72495)
module.exports.CloudIcon = __webpack_require__(28471)
module.exports.CodeBracketSquareIcon = __webpack_require__(33003)
module.exports.CodeBracketIcon = __webpack_require__(87381)
module.exports.Cog6ToothIcon = __webpack_require__(35996)
module.exports.Cog8ToothIcon = __webpack_require__(91350)
module.exports.CogIcon = __webpack_require__(64016)
module.exports.CommandLineIcon = __webpack_require__(83871)
module.exports.ComputerDesktopIcon = __webpack_require__(3447)
module.exports.CpuChipIcon = __webpack_require__(28940)
module.exports.CreditCardIcon = __webpack_require__(42088)
module.exports.CubeTransparentIcon = __webpack_require__(31929)
module.exports.CubeIcon = __webpack_require__(86013)
module.exports.CurrencyBangladeshiIcon = __webpack_require__(94058)
module.exports.CurrencyDollarIcon = __webpack_require__(65406)
module.exports.CurrencyEuroIcon = __webpack_require__(38623)
module.exports.CurrencyPoundIcon = __webpack_require__(4840)
module.exports.CurrencyRupeeIcon = __webpack_require__(92787)
module.exports.CurrencyYenIcon = __webpack_require__(11983)
module.exports.CursorArrowRaysIcon = __webpack_require__(6707)
module.exports.CursorArrowRippleIcon = __webpack_require__(98721)
module.exports.DevicePhoneMobileIcon = __webpack_require__(14942)
module.exports.DeviceTabletIcon = __webpack_require__(42270)
module.exports.DocumentArrowDownIcon = __webpack_require__(76236)
module.exports.DocumentArrowUpIcon = __webpack_require__(590)
module.exports.DocumentChartBarIcon = __webpack_require__(11164)
module.exports.DocumentCheckIcon = __webpack_require__(37429)
module.exports.DocumentDuplicateIcon = __webpack_require__(16410)
module.exports.DocumentMagnifyingGlassIcon = __webpack_require__(57858)
module.exports.DocumentMinusIcon = __webpack_require__(21751)
module.exports.DocumentPlusIcon = __webpack_require__(15974)
module.exports.DocumentTextIcon = __webpack_require__(26894)
module.exports.DocumentIcon = __webpack_require__(54549)
module.exports.EllipsisHorizontalCircleIcon = __webpack_require__(48331)
module.exports.EllipsisHorizontalIcon = __webpack_require__(74818)
module.exports.EllipsisVerticalIcon = __webpack_require__(37948)
module.exports.EnvelopeOpenIcon = __webpack_require__(88409)
module.exports.EnvelopeIcon = __webpack_require__(41339)
module.exports.ExclamationCircleIcon = __webpack_require__(28835)
module.exports.ExclamationTriangleIcon = __webpack_require__(89381)
module.exports.EyeDropperIcon = __webpack_require__(23541)
module.exports.EyeSlashIcon = __webpack_require__(84700)
module.exports.EyeIcon = __webpack_require__(51017)
module.exports.FaceFrownIcon = __webpack_require__(14571)
module.exports.FaceSmileIcon = __webpack_require__(44571)
module.exports.FilmIcon = __webpack_require__(39929)
module.exports.FingerPrintIcon = __webpack_require__(49039)
module.exports.FireIcon = __webpack_require__(22966)
module.exports.FlagIcon = __webpack_require__(83515)
module.exports.FolderArrowDownIcon = __webpack_require__(70233)
module.exports.FolderMinusIcon = __webpack_require__(11407)
module.exports.FolderOpenIcon = __webpack_require__(37776)
module.exports.FolderPlusIcon = __webpack_require__(65031)
module.exports.FolderIcon = __webpack_require__(40806)
module.exports.ForwardIcon = __webpack_require__(21447)
module.exports.FunnelIcon = __webpack_require__(56758)
module.exports.GifIcon = __webpack_require__(43923)
module.exports.GiftTopIcon = __webpack_require__(55380)
module.exports.GiftIcon = __webpack_require__(24223)
module.exports.GlobeAltIcon = __webpack_require__(42450)
module.exports.GlobeAmericasIcon = __webpack_require__(52115)
module.exports.GlobeAsiaAustraliaIcon = __webpack_require__(14858)
module.exports.GlobeEuropeAfricaIcon = __webpack_require__(53403)
module.exports.HandRaisedIcon = __webpack_require__(25220)
module.exports.HandThumbDownIcon = __webpack_require__(98051)
module.exports.HandThumbUpIcon = __webpack_require__(64783)
module.exports.HashtagIcon = __webpack_require__(98310)
module.exports.HeartIcon = __webpack_require__(7765)
module.exports.HomeModernIcon = __webpack_require__(14770)
module.exports.HomeIcon = __webpack_require__(60220)
module.exports.IdentificationIcon = __webpack_require__(49817)
module.exports.InboxArrowDownIcon = __webpack_require__(34109)
module.exports.InboxStackIcon = __webpack_require__(82364)
module.exports.InboxIcon = __webpack_require__(86163)
module.exports.InformationCircleIcon = __webpack_require__(34740)
module.exports.KeyIcon = __webpack_require__(55581)
module.exports.LanguageIcon = __webpack_require__(48287)
module.exports.LifebuoyIcon = __webpack_require__(39393)
module.exports.LightBulbIcon = __webpack_require__(30608)
module.exports.LinkIcon = __webpack_require__(55689)
module.exports.ListBulletIcon = __webpack_require__(71394)
module.exports.LockClosedIcon = __webpack_require__(78515)
module.exports.LockOpenIcon = __webpack_require__(74170)
module.exports.MagnifyingGlassCircleIcon = __webpack_require__(123)
module.exports.MagnifyingGlassMinusIcon = __webpack_require__(32440)
module.exports.MagnifyingGlassPlusIcon = __webpack_require__(59388)
module.exports.MagnifyingGlassIcon = __webpack_require__(96420)
module.exports.MapPinIcon = __webpack_require__(41203)
module.exports.MapIcon = __webpack_require__(28568)
module.exports.MegaphoneIcon = __webpack_require__(81723)
module.exports.MicrophoneIcon = __webpack_require__(89244)
module.exports.MinusCircleIcon = __webpack_require__(80532)
module.exports.MinusSmallIcon = __webpack_require__(58946)
module.exports.MinusIcon = __webpack_require__(21746)
module.exports.MoonIcon = __webpack_require__(77317)
module.exports.MusicalNoteIcon = __webpack_require__(13772)
module.exports.NewspaperIcon = __webpack_require__(49354)
module.exports.NoSymbolIcon = __webpack_require__(110)
module.exports.PaintBrushIcon = __webpack_require__(36025)
module.exports.PaperAirplaneIcon = __webpack_require__(82242)
module.exports.PaperClipIcon = __webpack_require__(61149)
module.exports.PauseCircleIcon = __webpack_require__(90402)
module.exports.PauseIcon = __webpack_require__(50188)
module.exports.PencilSquareIcon = __webpack_require__(4063)
module.exports.PencilIcon = __webpack_require__(40779)
module.exports.PhoneArrowDownLeftIcon = __webpack_require__(38675)
module.exports.PhoneArrowUpRightIcon = __webpack_require__(66960)
module.exports.PhoneXMarkIcon = __webpack_require__(97991)
module.exports.PhoneIcon = __webpack_require__(43361)
module.exports.PhotoIcon = __webpack_require__(8583)
module.exports.PlayCircleIcon = __webpack_require__(51550)
module.exports.PlayPauseIcon = __webpack_require__(66855)
module.exports.PlayIcon = __webpack_require__(92284)
module.exports.PlusCircleIcon = __webpack_require__(64966)
module.exports.PlusSmallIcon = __webpack_require__(88519)
module.exports.PlusIcon = __webpack_require__(16084)
module.exports.PowerIcon = __webpack_require__(34657)
module.exports.PresentationChartBarIcon = __webpack_require__(60355)
module.exports.PresentationChartLineIcon = __webpack_require__(5013)
module.exports.PrinterIcon = __webpack_require__(54633)
module.exports.PuzzlePieceIcon = __webpack_require__(45983)
module.exports.QrCodeIcon = __webpack_require__(4781)
module.exports.QuestionMarkCircleIcon = __webpack_require__(40100)
module.exports.QueueListIcon = __webpack_require__(62754)
module.exports.RadioIcon = __webpack_require__(59886)
module.exports.ReceiptPercentIcon = __webpack_require__(36103)
module.exports.ReceiptRefundIcon = __webpack_require__(14356)
module.exports.RectangleGroupIcon = __webpack_require__(285)
module.exports.RectangleStackIcon = __webpack_require__(26291)
module.exports.RocketLaunchIcon = __webpack_require__(14529)
module.exports.RssIcon = __webpack_require__(35421)
module.exports.ScaleIcon = __webpack_require__(74759)
module.exports.ScissorsIcon = __webpack_require__(99005)
module.exports.ServerStackIcon = __webpack_require__(71423)
module.exports.ServerIcon = __webpack_require__(54420)
module.exports.ShareIcon = __webpack_require__(15158)
module.exports.ShieldCheckIcon = __webpack_require__(99851)
module.exports.ShieldExclamationIcon = __webpack_require__(24280)
module.exports.ShoppingBagIcon = __webpack_require__(5835)
module.exports.ShoppingCartIcon = __webpack_require__(77414)
module.exports.SignalSlashIcon = __webpack_require__(74024)
module.exports.SignalIcon = __webpack_require__(56178)
module.exports.SparklesIcon = __webpack_require__(8271)
module.exports.SpeakerWaveIcon = __webpack_require__(93265)
module.exports.SpeakerXMarkIcon = __webpack_require__(75408)
module.exports.Square2StackIcon = __webpack_require__(26561)
module.exports.Square3Stack3DIcon = __webpack_require__(69276)
module.exports.Squares2X2Icon = __webpack_require__(22927)
module.exports.SquaresPlusIcon = __webpack_require__(9351)
module.exports.StarIcon = __webpack_require__(45401)
module.exports.StopCircleIcon = __webpack_require__(67103)
module.exports.StopIcon = __webpack_require__(63249)
module.exports.SunIcon = __webpack_require__(15345)
module.exports.SwatchIcon = __webpack_require__(50911)
module.exports.TableCellsIcon = __webpack_require__(99216)
module.exports.TagIcon = __webpack_require__(71858)
module.exports.TicketIcon = __webpack_require__(72351)
module.exports.TrashIcon = __webpack_require__(84703)
module.exports.TrophyIcon = __webpack_require__(14457)
module.exports.TruckIcon = __webpack_require__(11131)
module.exports.TvIcon = __webpack_require__(65177)
module.exports.UserCircleIcon = __webpack_require__(46811)
module.exports.UserGroupIcon = __webpack_require__(89954)
module.exports.UserMinusIcon = __webpack_require__(30157)
module.exports.UserPlusIcon = __webpack_require__(4959)
module.exports.UserIcon = __webpack_require__(69137)
module.exports.UsersIcon = __webpack_require__(94889)
module.exports.VariableIcon = __webpack_require__(981)
module.exports.VideoCameraSlashIcon = __webpack_require__(97720)
module.exports.VideoCameraIcon = __webpack_require__(15021)
module.exports.ViewColumnsIcon = __webpack_require__(91327)
module.exports.ViewfinderCircleIcon = __webpack_require__(19436)
module.exports.WalletIcon = __webpack_require__(11017)
module.exports.WifiIcon = __webpack_require__(12700)
module.exports.WindowIcon = __webpack_require__(87842)
module.exports.WrenchScrewdriverIcon = __webpack_require__(22682)
module.exports.WrenchIcon = __webpack_require__(31025)
module.exports.XCircleIcon = __webpack_require__(90476)
module.exports.XMarkIcon = __webpack_require__(75993)

/***/ }),

/***/ 22363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AcademicCapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912l-.003.002-.34.18a.75.75 0 01-.707 0A50.009 50.009 0 007.5 12.174v-.224c0-.131.067-.248.172-.311a54.614 54.614 0 014.653-2.52.75.75 0 00-.65-1.352 56.129 56.129 0 00-4.78 2.589 1.858 1.858 0 00-.859 1.228 49.803 49.803 0 00-4.634-1.527.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z"
  }));
}

const ForwardRef = React.forwardRef(AcademicCapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AdjustmentsHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.75h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5zM12 6a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 6zM12 18a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 18zM3.75 6.75h1.5a.75.75 0 100-1.5h-1.5a.75.75 0 000 1.5zM5.25 18.75h-1.5a.75.75 0 010-1.5h1.5a.75.75 0 010 1.5zM3 12a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 013 12zM9 3.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM12.75 12a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM9 15.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
  }));
}

const ForwardRef = React.forwardRef(AdjustmentsHorizontalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 9617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AdjustmentsVerticalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 12a.75.75 0 01-.75-.75v-7.5a.75.75 0 111.5 0v7.5A.75.75 0 016 12zM18 12a.75.75 0 01-.75-.75v-7.5a.75.75 0 011.5 0v7.5A.75.75 0 0118 12zM6.75 20.25v-1.5a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0zM18.75 18.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 011.5 0zM12.75 5.25v-1.5a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0zM12 21a.75.75 0 01-.75-.75v-7.5a.75.75 0 011.5 0v7.5A.75.75 0 0112 21zM3.75 15a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM12 11.25a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM15.75 15a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0z"
  }));
}

const ForwardRef = React.forwardRef(AdjustmentsVerticalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zM12 10.5a.75.75 0 01.75.75v4.94l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-4.94a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46004:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zm6.163 3.75A.75.75 0 0110 12h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArchiveBoxXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zm6.133 2.845a.75.75 0 011.06 0l1.72 1.72 1.72-1.72a.75.75 0 111.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 11-1.06 1.06L12 15.685l-1.72 1.72a.75.75 0 11-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArchiveBoxXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-.53 14.03a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V8.25a.75.75 0 00-1.5 0v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v16.19l6.22-6.22a.75.75 0 111.06 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06l6.22 6.22V3a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.03 3.97a.75.75 0 010 1.06L6.31 18.75h9.44a.75.75 0 010 1.5H4.5a.75.75 0 01-.75-.75V8.25a.75.75 0 011.5 0v9.44L18.97 3.97a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5a.75.75 0 01.75.75V7.5h-1.5V2.25A.75.75 0 0112 1.5zM11.25 7.5v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownOnSquareStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 6.75h-3a3 3 0 00-3 3v7.5a3 3 0 003 3h7.5a3 3 0 003-3v-7.5a3 3 0 00-3-3h-3V1.5a.75.75 0 00-1.5 0v5.25zm0 0h1.5v5.69l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72V6.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.151 21.75a2.999 2.999 0 002.599 1.5h7.5a3 3 0 003-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 01-4.5 4.5H7.151z"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownOnSquareStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 53048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.97 3.97a.75.75 0 011.06 0l13.72 13.72V8.25a.75.75 0 011.5 0V19.5a.75.75 0 01-.75.75H8.25a.75.75 0 010-1.5h9.44L3.97 5.03a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 21881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowDownTrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownTrayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 60311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLeftOnRectangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm5.03 4.72a.75.75 0 010 1.06l-1.72 1.72h10.94a.75.75 0 010 1.5H10.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLeftOnRectangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v16.19l2.47-2.47a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 111.06-1.06l2.47 2.47V3a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.28 7.72a.75.75 0 010 1.06l-2.47 2.47H21a.75.75 0 010 1.5H4.81l2.47 2.47a.75.75 0 11-1.06 1.06l-3.75-3.75a.75.75 0 010-1.06l3.75-3.75a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.72 7.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 010 1.06l-3.75 3.75a.75.75 0 11-1.06-1.06l2.47-2.47H3a.75.75 0 010-1.5h16.19l-2.47-2.47a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowLongUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 011.06 0l3.75 3.75a.75.75 0 01-1.06 1.06l-2.47-2.47V21a.75.75 0 01-1.5 0V4.81L8.78 7.28a.75.75 0 01-1.06-1.06l3.75-3.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowPathIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.755 10.059a7.5 7.5 0 0112.548-3.364l1.903 1.903h-3.183a.75.75 0 100 1.5h4.992a.75.75 0 00.75-.75V4.356a.75.75 0 00-1.5 0v3.18l-1.9-1.9A9 9 0 003.306 9.67a.75.75 0 101.45.388zm15.408 3.352a.75.75 0 00-.919.53 7.5 7.5 0 01-12.548 3.364l-1.902-1.903h3.183a.75.75 0 000-1.5H2.984a.75.75 0 00-.75.75v4.992a.75.75 0 001.5 0v-3.18l1.9 1.9a9 9 0 0015.059-4.035.75.75 0 00-.53-.918z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowPathIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowPathRoundedSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 013.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 00-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 00-4.392-4.392 49.422 49.422 0 00-7.436 0A4.756 4.756 0 003.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 101.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 013.01-3.01c1.19-.09 2.392-.135 3.605-.135zm-6.97 6.22a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 004.392 4.392 49.413 49.413 0 007.436 0 4.756 4.756 0 004.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 00-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 01-3.01 3.01 47.953 47.953 0 01-7.21 0 3.256 3.256 0 01-3.01-3.01 47.759 47.759 0 01-.1-1.759L6.97 15.53a.75.75 0 001.06-1.06l-3-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowPathRoundedSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 58545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowRightOnRectangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightOnRectangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 19935:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a.75.75 0 01.75.75v13.19l5.47-5.47a.75.75 0 111.06 1.06l-6.75 6.75a.75.75 0 01-1.06 0l-6.75-6.75a.75.75 0 111.06-1.06l5.47 5.47V4.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 58714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 12a.75.75 0 01-.75.75H6.31l5.47 5.47a.75.75 0 11-1.06 1.06l-6.75-6.75a.75.75 0 010-1.06l6.75-6.75a.75.75 0 111.06 1.06l-5.47 5.47H19.5a.75.75 0 01.75.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 89007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowSmallUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 20.25a.75.75 0 01-.75-.75V6.31l-5.47 5.47a.75.75 0 01-1.06-1.06l6.75-6.75a.75.75 0 011.06 0l6.75 6.75a.75.75 0 11-1.06 1.06l-5.47-5.47V19.5a.75.75 0 01-.75.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowSmallUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 32446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTopRightOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 2.25H21a.75.75 0 01.75.75v5.25a.75.75 0 01-1.5 0V4.81L8.03 17.03a.75.75 0 01-1.06-1.06L19.19 3.75h-3.44a.75.75 0 010-1.5zm-10.5 4.5a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5h10.5a1.5 1.5 0 001.5-1.5V10.5a.75.75 0 011.5 0v8.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V8.25a3 3 0 013-3h8.25a.75.75 0 010 1.5H5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowTopRightOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTrendingDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.72 5.47a.75.75 0 011.06 0L9 11.69l3.756-3.756a.75.75 0 01.985-.066 12.698 12.698 0 014.575 6.832l.308 1.149 2.277-3.943a.75.75 0 111.299.75l-3.182 5.51a.75.75 0 01-1.025.275l-5.511-3.181a.75.75 0 01.75-1.3l3.943 2.277-.308-1.149a11.194 11.194 0 00-3.528-5.617l-3.809 3.81a.75.75 0 01-1.06 0L1.72 6.53a.75.75 0 010-1.061z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendingDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowTrendingUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.22 6.268a.75.75 0 01.968-.432l5.942 2.28a.75.75 0 01.431.97l-2.28 5.941a.75.75 0 11-1.4-.537l1.63-4.251-1.086.483a11.2 11.2 0 00-5.45 5.174.75.75 0 01-1.199.19L9 12.31l-6.22 6.22a.75.75 0 11-1.06-1.06l6.75-6.75a.75.75 0 011.06 0l3.606 3.605a12.694 12.694 0 015.68-4.973l1.086-.484-4.251-1.631a.75.75 0 01-.432-.97z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendingUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.53 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v5.69a.75.75 0 001.5 0v-5.69l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06l-6.22-6.22V21a.75.75 0 01-1.5 0V4.81l-6.22 6.22a.75.75 0 11-1.06-1.06l7.5-7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 39467:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 6.31v9.44a.75.75 0 01-1.5 0V4.5a.75.75 0 01.75-.75h11.25a.75.75 0 010 1.5H6.31l13.72 13.72a.75.75 0 11-1.06 1.06L5.25 6.31z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 13448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.47 1.72a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72V7.5h-1.5V4.06L9.53 5.78a.75.75 0 01-1.06-1.06l3-3zM11.25 7.5V15a.75.75 0 001.5 0V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpOnSquareStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.97.97a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v3.44h-1.5V3.31L8.03 5.03a.75.75 0 01-1.06-1.06l3-3zM9.75 6.75v6a.75.75 0 001.5 0v-6h3a3 3 0 013 3v7.5a3 3 0 01-3 3h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.151 21.75a2.999 2.999 0 002.599 1.5h7.5a3 3 0 003-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 01-4.5 4.5H7.151z"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpOnSquareStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 3.75H19.5a.75.75 0 01.75.75v11.25a.75.75 0 01-1.5 0V6.31L5.03 20.03a.75.75 0 01-1.06-1.06L17.69 5.25H8.25a.75.75 0 010-1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUpTrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06l-3.22-3.22V16.5a.75.75 0 01-1.5 0V4.81L8.03 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zM3 15.75a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUpTrayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75A5.25 5.25 0 009.75 9v10.19l4.72-4.72a.75.75 0 111.06 1.06l-6 6a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l4.72 4.72V9a6.75 6.75 0 0113.5 0v3a.75.75 0 01-1.5 0V9c0-2.9-2.35-5.25-5.25-5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 32654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.53 2.47a.75.75 0 010 1.06L4.81 8.25H15a6.75 6.75 0 010 13.5h-3a.75.75 0 010-1.5h3a5.25 5.25 0 100-10.5H4.81l4.72 4.72a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06l6-6a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.47 2.47a.75.75 0 011.06 0l6 6a.75.75 0 010 1.06l-6 6a.75.75 0 11-1.06-1.06l4.72-4.72H9a5.25 5.25 0 100 10.5h3a.75.75 0 010 1.5H9a6.75 6.75 0 010-13.5h10.19l-4.72-4.72a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowUturnUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.53 9.53a.75.75 0 01-1.06 0l-4.72-4.72V15a6.75 6.75 0 01-13.5 0v-3a.75.75 0 011.5 0v3a5.25 5.25 0 1010.5 0V4.81L9.53 9.53a.75.75 0 01-1.06-1.06l6-6a.75.75 0 011.06 0l6 6a.75.75 0 010 1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowUturnUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsPointingInIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.22 3.22a.75.75 0 011.06 0l3.97 3.97V4.5a.75.75 0 011.5 0V9a.75.75 0 01-.75.75H4.5a.75.75 0 010-1.5h2.69L3.22 4.28a.75.75 0 010-1.06zm17.56 0a.75.75 0 010 1.06l-3.97 3.97h2.69a.75.75 0 010 1.5H15a.75.75 0 01-.75-.75V4.5a.75.75 0 011.5 0v2.69l3.97-3.97a.75.75 0 011.06 0zM3.75 15a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-2.69l-3.97 3.97a.75.75 0 01-1.06-1.06l3.97-3.97H4.5a.75.75 0 01-.75-.75zm10.5 0a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-2.69l3.97 3.97a.75.75 0 11-1.06 1.06l-3.97-3.97v2.69a.75.75 0 01-1.5 0V15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowsPointingInIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsPointingOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V5.56l-3.97 3.97a.75.75 0 11-1.06-1.06l3.97-3.97h-2.69a.75.75 0 01-.75-.75zm-12 0A.75.75 0 013.75 3h4.5a.75.75 0 010 1.5H5.56l3.97 3.97a.75.75 0 01-1.06 1.06L4.5 5.56v2.69a.75.75 0 01-1.5 0v-4.5zm11.47 11.78a.75.75 0 111.06-1.06l3.97 3.97v-2.69a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75h-4.5a.75.75 0 010-1.5h2.69l-3.97-3.97zm-4.94-1.06a.75.75 0 010 1.06L5.56 19.5h2.69a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v2.69l3.97-3.97a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowsPointingOutIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsRightLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.97 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 11-1.06-1.06l3.22-3.22H7.5a.75.75 0 010-1.5h11.69l-3.22-3.22a.75.75 0 010-1.06zm-7.94 9a.75.75 0 010 1.06l-3.22 3.22H16.5a.75.75 0 010 1.5H4.81l3.22 3.22a.75.75 0 11-1.06 1.06l-4.5-4.5a.75.75 0 010-1.06l4.5-4.5a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowsRightLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 78013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ArrowsUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.97 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06L8.25 4.81V16.5a.75.75 0 01-1.5 0V4.81L3.53 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zm9.53 4.28a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V7.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowsUpDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function AtSymbolIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.834 6.166a8.25 8.25 0 100 11.668.75.75 0 011.06 1.06c-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0A9.722 9.722 0 0121.75 12c0 .975-.296 1.887-.809 2.571-.514.685-1.28 1.179-2.191 1.179-.904 0-1.666-.487-2.18-1.164a5.25 5.25 0 11-.82-6.26V8.25a.75.75 0 011.5 0V12c0 .682.208 1.27.509 1.671.3.401.659.579.991.579.332 0 .69-.178.991-.579.3-.4.509-.99.509-1.671a8.222 8.222 0 00-2.416-5.834zM15.75 12a3.75 3.75 0 10-7.5 0 3.75 3.75 0 007.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(AtSymbolIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BackspaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.515 10.674a1.875 1.875 0 000 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 003-3V6.75a3 3 0 00-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374zM12.53 9.22a.75.75 0 10-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 101.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 101.06-1.06L15.31 12l1.72-1.72a.75.75 0 10-1.06-1.06l-1.72 1.72-1.72-1.72z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BackspaceIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BackwardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.195 18.44c1.25.713 2.805-.19 2.805-1.629v-2.34l6.945 3.968c1.25.714 2.805-.188 2.805-1.628V8.688c0-1.44-1.555-2.342-2.805-1.628L12 11.03v-2.34c0-1.44-1.555-2.343-2.805-1.629l-7.108 4.062c-1.26.72-1.26 2.536 0 3.256l7.108 4.061z"
  }));
}

const ForwardRef = React.forwardRef(BackwardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BanknotesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 14.625v-9.75zM8.25 9.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM18.75 9a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-.008zM4.5 9.75A.75.75 0 015.25 9h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V9.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18a.75.75 0 000 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 00-.75-.75H2.25z"
  }));
}

const ForwardRef = React.forwardRef(BanknotesIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 9zm0 6.75a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 74868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3BottomLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars3BottomLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3BottomRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm8.25 5.25a.75.75 0 01.75-.75h8.25a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars3BottomRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 20208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3CenterLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars3CenterLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars3Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars3Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 9760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Bars4Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 5.25zm0 4.5A.75.75 0 013.75 9h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 9.75zm0 4.5a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Bars4Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 88707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BarsArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.5A.75.75 0 013 3.75h14.25a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm0 4.5A.75.75 0 013 8.25h9.75a.75.75 0 010 1.5H3A.75.75 0 012.25 9zm15-.75A.75.75 0 0118 9v10.19l2.47-2.47a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 111.06-1.06l2.47 2.47V9a.75.75 0 01.75-.75zm-15 5.25a.75.75 0 01.75-.75h9.75a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BarsArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BarsArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.5A.75.75 0 013 3.75h14.25a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm14.47 3.97a.75.75 0 011.06 0l3.75 3.75a.75.75 0 11-1.06 1.06L18 10.81V21a.75.75 0 01-1.5 0V10.81l-2.47 2.47a.75.75 0 11-1.06-1.06l3.75-3.75zM2.25 9A.75.75 0 013 8.25h9.75a.75.75 0 010 1.5H3A.75.75 0 012.25 9zm0 4.5a.75.75 0 01.75-.75h5.25a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BarsArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery0Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.75 9.75a3 3 0 013-3h15a3 3 0 013 3v.038c.856.173 1.5.93 1.5 1.837v2.25c0 .907-.644 1.664-1.5 1.838v.037a3 3 0 01-3 3h-15a3 3 0 01-3-3v-6zm19.5 0a1.5 1.5 0 00-1.5-1.5h-15a1.5 1.5 0 00-1.5 1.5v6a1.5 1.5 0 001.5 1.5h15a1.5 1.5 0 001.5-1.5v-6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Battery0Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 52255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery100Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6.75a3 3 0 00-3 3v6a3 3 0 003 3h15a3 3 0 003-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 00-3-3h-15zm15 1.5a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5v-6a1.5 1.5 0 011.5-1.5h15zM4.5 9.75a.75.75 0 00-.75.75V15c0 .414.336.75.75.75H18a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75H4.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Battery100Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 16304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Battery50Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75a.75.75 0 00-.75.75V15c0 .414.336.75.75.75h6.75A.75.75 0 0012 15v-4.5a.75.75 0 00-.75-.75H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6.75a3 3 0 00-3 3v6a3 3 0 003 3h15a3 3 0 003-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 00-3-3h-15zm15 1.5a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5v-6a1.5 1.5 0 011.5-1.5h15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Battery50Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 56644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BeakerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.798v5.02a3 3 0 01-.879 2.121l-2.377 2.377a9.845 9.845 0 015.091 1.013 8.315 8.315 0 005.713.636l.285-.071-3.954-3.955a3 3 0 01-.879-2.121v-5.02a23.614 23.614 0 00-3 0zm4.5.138a.75.75 0 00.093-1.495A24.837 24.837 0 0012 2.25a25.048 25.048 0 00-3.093.191A.75.75 0 009 3.936v4.882a1.5 1.5 0 01-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88 2.686.46 5.447.698 8.262.698 2.816 0 5.576-.239 8.262-.697 2.373-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0115 8.818V3.936z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BeakerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BellAlertIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 50794:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BellIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM20.57 16.476c-.223.082-.448.161-.674.238L7.319 4.137A6.75 6.75 0 0118.75 9v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 9c0-.184.007-.366.022-.546l10.384 10.384a3.751 3.751 0 01-7.396-1.119 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BellSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 17050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BellSnoozeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0zm.75-10.5a.75.75 0 000 1.5h1.599l-2.223 3.334A.75.75 0 0010.5 13.5h3a.75.75 0 000-1.5h-1.599l2.223-3.334A.75.75 0 0013.5 7.5h-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BellSnoozeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BoltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BoltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22153:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BoltSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.798 11.012l-3.188 3.416L9.462 6.28l4.24-4.542a.75.75 0 011.272.71L12.982 9.75h7.268a.75.75 0 01.548 1.262zM3.202 12.988L6.39 9.572l8.148 8.148-4.24 4.542a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262zM3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18z"
  }));
}

const ForwardRef = React.forwardRef(BoltSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z"
  }));
}

const ForwardRef = React.forwardRef(BookOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 20174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.32 2.577a49.255 49.255 0 0111.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 01-1.085.67L12 18.089l-7.165 3.583A.75.75 0 013.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BookmarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM20.25 5.507v11.561L5.853 2.671c.15-.043.306-.075.467-.094a49.255 49.255 0 0111.36 0c1.497.174 2.57 1.46 2.57 2.93zM3.75 21V6.932l14.063 14.063L12 18.088l-7.165 3.583A.75.75 0 013.75 21z"
  }));
}

const ForwardRef = React.forwardRef(BookmarkSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79508:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BookmarkSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3H6zm1.5 1.5a.75.75 0 00-.75.75V16.5a.75.75 0 001.085.67L12 15.089l4.165 2.083a.75.75 0 001.085-.671V5.25a.75.75 0 00-.75-.75h-9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BookmarkSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BriefcaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z"
  }));
}

const ForwardRef = React.forwardRef(BriefcaseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BugAntIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.478 1.6a.75.75 0 01.273 1.025 3.72 3.72 0 00-.425 1.122c.058.057.118.114.18.168A4.491 4.491 0 0112 2.25c1.413 0 2.673.651 3.497 1.668.06-.054.12-.11.178-.167a3.717 3.717 0 00-.426-1.126.75.75 0 111.298-.75 5.22 5.22 0 01.671 2.045.75.75 0 01-.187.582c-.241.27-.505.52-.787.749a4.495 4.495 0 01.216 2.1c-.106.792-.753 1.295-1.417 1.403-.182.03-.364.057-.547.081.152.227.273.476.359.741a23.122 23.122 0 003.832-.802 23.241 23.241 0 00-.345-2.634.75.75 0 011.474-.28c.21 1.115.348 2.256.404 3.418a.75.75 0 01-.516.749c-1.527.5-3.119.855-4.76 1.05-.074.38-.22.735-.423 1.05a24.61 24.61 0 015.943 1.358.75.75 0 01.492.75 24.665 24.665 0 01-1.189 6.25.75.75 0 01-1.425-.47 23.141 23.141 0 001.077-5.307c-.5-.168-1.009-.32-1.524-.454.068.234.104.484.104.746 0 3.956-2.521 7.5-6 7.5-3.478 0-6-3.544-6-7.5 0-.262.037-.511.104-.746-.514.134-1.022.286-1.522.454a23.14 23.14 0 001.077 5.308.75.75 0 01-1.425.468 24.663 24.663 0 01-1.19-6.25.75.75 0 01.493-.749 24.593 24.593 0 014.964-1.24h.01c.321-.046.644-.085.969-.118a2.982 2.982 0 01-.424-1.05 24.614 24.614 0 01-4.76-1.05.75.75 0 01-.516-.75c.057-1.161.194-2.302.405-3.417a.75.75 0 011.474.28c-.164.862-.28 1.74-.345 2.634 1.237.37 2.517.641 3.832.802.085-.265.207-.514.359-.74a18.732 18.732 0 01-.547-.082c-.664-.108-1.311-.611-1.417-1.403a4.535 4.535 0 01.217-2.103 6.788 6.788 0 01-.788-.751.75.75 0 01-.187-.583 5.22 5.22 0 01.67-2.04.75.75 0 011.026-.273z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BugAntIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingLibraryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.584 2.376a.75.75 0 01.832 0l9 6a.75.75 0 11-.832 1.248L12 3.901 3.416 9.624a.75.75 0 01-.832-1.248l9-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 10.332v9.918H21a.75.75 0 010 1.5H3a.75.75 0 010-1.5h.75v-9.918a.75.75 0 01.634-.74A49.109 49.109 0 0112 9c2.59 0 5.134.202 7.616.592a.75.75 0 01.634.74zm-7.5 2.418a.75.75 0 00-1.5 0v6.75a.75.75 0 001.5 0v-6.75zm3-.75a.75.75 0 01.75.75v6.75a.75.75 0 01-1.5 0v-6.75a.75.75 0 01.75-.75zM9 12.75a.75.75 0 00-1.5 0v6.75a.75.75 0 001.5 0v-6.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.875a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
  }));
}

const ForwardRef = React.forwardRef(BuildingLibraryIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingOffice2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5H15v-18a.75.75 0 000-1.5H3zM6.75 19.5v-2.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 010 1.5h-.75A.75.75 0 016 6.75zM6.75 9a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM6 12.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 6a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zm-.75 3.75A.75.75 0 0110.5 9h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 12a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM16.5 6.75v15h5.25a.75.75 0 000-1.5H21v-12a.75.75 0 000-1.5h-4.5zm1.5 4.5a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 2.25a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75v-.008a.75.75 0 00-.75-.75h-.008zM18 17.25a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BuildingOffice2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 93549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingOfficeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5h-.75V3.75a.75.75 0 000-1.5h-15zM9 6a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H9zm-.75 3.75A.75.75 0 019 9h1.5a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM9 12a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H9zm3.75-5.25A.75.75 0 0113.5 6H15a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM13.5 9a.75.75 0 000 1.5H15A.75.75 0 0015 9h-1.5zm-.75 3.75a.75.75 0 01.75-.75H15a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM9 19.5v-2.25a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-4.5A.75.75 0 019 19.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BuildingOfficeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function BuildingStorefrontIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 007.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 004.902-5.652l-1.3-1.299a1.875 1.875 0 00-1.325-.549H5.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 009.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 002.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 010 1.5H2.25a.75.75 0 010-1.5H3zm3-6a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75v-3zm8.25-.75a.75.75 0 00-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-5.25a.75.75 0 00-.75-.75h-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(BuildingStorefrontIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 81738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CakeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.784l-.796.796a1.125 1.125 0 101.591 0L15 1.784zM12 1.784l-.796.796a1.125 1.125 0 101.591 0L12 1.784zM9 1.784l-.796.796a1.125 1.125 0 101.591 0L9 1.784zM9.75 7.547c.498-.02.998-.035 1.5-.042V6.75a.75.75 0 011.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 011.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 00-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 011.5 0v.797zM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 012.585.364 2.605 2.605 0 002.33 0 4.104 4.104 0 013.67 0 2.605 2.605 0 002.33 0 4.104 4.104 0 013.67 0 2.605 2.605 0 002.33 0 4.104 4.104 0 012.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0012 12.75zM21.75 18.131a2.604 2.604 0 00-1.915.165 4.104 4.104 0 01-3.67 0 2.604 2.604 0 00-2.33 0 4.104 4.104 0 01-3.67 0 2.604 2.604 0 00-2.33 0 4.104 4.104 0 01-3.67 0 2.604 2.604 0 00-1.915-.165v2.494c0 1.036.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494z"
  }));
}

const ForwardRef = React.forwardRef(CakeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalculatorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.32 1.827a49.255 49.255 0 0111.36 0c1.497.174 2.57 1.46 2.57 2.93V19.5a3 3 0 01-3 3H6.75a3 3 0 01-3-3V4.757c0-1.47 1.073-2.756 2.57-2.93zM7.5 11.25a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H8.25a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H8.25zm-.75 3a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H8.25a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V18a.75.75 0 00-.75-.75H8.25zm1.748-6a.75.75 0 01.75-.75h.007a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.007a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75h-.007zm-.75 3a.75.75 0 01.75-.75h.007a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.007a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 00.75-.75V18a.75.75 0 00-.75-.75h-.007zm1.754-6a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75h-.008zm-.75 3a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V18a.75.75 0 00-.75-.75h-.008zm1.748-6a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 1.5a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75h-.008zm-8.25-6A.75.75 0 018.25 6h7.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-.75zm9 9a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CalculatorIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalendarDaysIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM8.25 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM10.5 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12.75 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.25 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CalendarDaysIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CalendarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3.75 3.75 0 100 7.5A3.75 3.75 0 0012 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.344 3.071a49.52 49.52 0 015.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 01-3 3h-15a3 3 0 01-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 001.11-.71l.822-1.315a2.942 2.942 0 012.332-1.39zM6.75 12.75a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm12-1.5a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CameraIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z"
  }));
}

const ForwardRef = React.forwardRef(ChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartBarSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 013-3h12a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm4.5 7.5a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 01.75-.75zm3.75-1.5a.75.75 0 00-1.5 0v4.5a.75.75 0 001.5 0V12zm2.25-3a.75.75 0 01.75.75v6.75a.75.75 0 01-1.5 0V9.75A.75.75 0 0113.5 9zm3.75-1.5a.75.75 0 00-1.5 0v9a.75.75 0 001.5 0v-9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChartBarSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChartPieIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 13.5a8.25 8.25 0 018.25-8.25.75.75 0 01.75.75v6.75H18a.75.75 0 01.75.75 8.25 8.25 0 01-16.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 3a.75.75 0 01.75-.75 8.25 8.25 0 018.25 8.25.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75V3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChartPieIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 88630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleBottomCenterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleBottomCenterIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleBottomCenterTextIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleBottomCenterTextIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftEllipsisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 001.28.53l4.184-4.183a.39.39 0 01.266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0012 2.25zM8.25 8.625a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zm2.625 1.125a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm4.875-1.125a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftEllipsisIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 31617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 00-.266.112L8.78 21.53A.75.75 0 017.5 21v-3.955a48.842 48.842 0 01-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleLeftRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleLeftRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleOvalLeftEllipsisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.804 21.644A6.707 6.707 0 006 21.75a6.721 6.721 0 003.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 01-.814 1.686.75.75 0 00.44 1.223zM8.25 10.875a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zM10.875 12a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm4.875-1.125a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleOvalLeftEllipsisIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChatBubbleOvalLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.337 21.718a6.707 6.707 0 01-.533-.074.75.75 0 01-.44-1.223 3.73 3.73 0 00.814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 01-4.246.997z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChatBubbleOvalLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckBadgeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckBadgeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.03 4.72a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 11.69l6.97-6.97a.75.75 0 011.06 0zm0 6a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06L12 17.69l6.97-6.97a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.28 3.97a.75.75 0 010 1.06L6.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0zm6 0a.75.75 0 010 1.06L12.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 17248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.72 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 010-1.06zm6 0a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 45368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDoubleUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 4.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 6.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5zm.53 7.59l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 12.31z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDoubleUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 71230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 4.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 01-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 01-1.06-1.06l3.75-3.75zm-3.75 9.75a.75.75 0 011.06 0L12 17.69l3.22-3.22a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronUpDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ChevronUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 70726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CircleStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 001.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 001.897 1.384C6.809 12.164 9.315 12.75 12 12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 001.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 001.897 1.384C6.809 15.914 9.315 16.5 12 16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 001.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 001.897 1.384C6.809 19.664 9.315 20.25 12 20.25z"
  }));
}

const ForwardRef = React.forwardRef(CircleStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76322:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zm9.586 4.594a.75.75 0 00-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.116-.062l3-3.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 21267:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 01-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0113.5 1.5H15a3 3 0 012.663 1.618zM12 4.5A1.5 1.5 0 0113.5 3H15a1.5 1.5 0 011.5 1.5H12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 019 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0116.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963 5.23 5.23 0 00-3.434-1.279h-1.875a.375.375 0 01-.375-.375V10.5z"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardDocumentListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zM6 12a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V12zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM6 15a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V15zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM6 18a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V18zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ClipboardDocumentListIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClipboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3A1.501 1.501 0 009 4.5h6A1.5 1.5 0 0013.5 3h-3zm-2.693.178A3 3 0 0110.5 1.5h3a3 3 0 012.694 1.678c.497.042.992.092 1.486.15 1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 01-3 3H6.75a3 3 0 01-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93.493-.057.989-.107 1.487-.15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ClipboardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98827:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ClockIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 38055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6 6 0 00-5.98 6.496A5.25 5.25 0 006.75 20.25H18a4.5 4.5 0 002.206-8.423 3.75 3.75 0 00-4.133-4.303A6.001 6.001 0 0010.5 3.75zm2.25 6a.75.75 0 00-1.5 0v4.94l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V9.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CloudArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49991:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6 6 0 00-5.98 6.496A5.25 5.25 0 006.75 20.25H18a4.5 4.5 0 002.206-8.423 3.75 3.75 0 00-4.133-4.303A6.001 6.001 0 0010.5 3.75zm2.03 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v4.94a.75.75 0 001.5 0v-4.94l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CloudArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CloudIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 9.75a6 6 0 0111.573-2.226 3.75 3.75 0 014.133 4.303A4.5 4.5 0 0118 20.25H6.75a5.25 5.25 0 01-2.23-10.004 6.072 6.072 0 01-.02-.496z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CloudIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CodeBracketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.447 3.027a.75.75 0 01.527.92l-4.5 16.5a.75.75 0 01-1.448-.394l4.5-16.5a.75.75 0 01.921-.526zM16.72 6.22a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 010-1.06zm-9.44 0a.75.75 0 010 1.06L2.56 12l4.72 4.72a.75.75 0 11-1.06 1.06L.97 12.53a.75.75 0 010-1.06l5.25-5.25a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CodeBracketSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 013-3h12a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm14.25 6a.75.75 0 01-.22.53l-2.25 2.25a.75.75 0 11-1.06-1.06L15.44 12l-1.72-1.72a.75.75 0 111.06-1.06l2.25 2.25c.141.14.22.331.22.53zm-10.28-.53a.75.75 0 000 1.06l2.25 2.25a.75.75 0 101.06-1.06L8.56 12l1.72-1.72a.75.75 0 10-1.06-1.06l-2.25 2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Cog6ToothIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Cog6ToothIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Cog8ToothIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 01-.517.608 7.45 7.45 0 00-.478.198.798.798 0 01-.796-.064l-.453-.324a1.875 1.875 0 00-2.416.2l-.243.243a1.875 1.875 0 00-.2 2.416l.324.453a.798.798 0 01.064.796 7.448 7.448 0 00-.198.478.798.798 0 01-.608.517l-.55.092a1.875 1.875 0 00-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 01-.064.796l-.324.453a1.875 1.875 0 00.2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 01.796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 01.517-.608 7.52 7.52 0 00.478-.198.798.798 0 01.796.064l.453.324a1.875 1.875 0 002.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 01-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 001.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 01-.608-.517 7.507 7.507 0 00-.198-.478.798.798 0 01.064-.796l.324-.453a1.875 1.875 0 00-.2-2.416l-.243-.243a1.875 1.875 0 00-2.416-.2l-.453.324a.798.798 0 01-.796.064 7.462 7.462 0 00-.478-.198.798.798 0 01-.517-.608l-.091-.55a1.875 1.875 0 00-1.85-1.566h-.344zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Cog8ToothIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 75589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 01-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 016.126 3.537zM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 010 .75l-1.732 3.001c-.229.396-.76.498-1.067.16A5.231 5.231 0 016.75 12c0-1.362.519-2.603 1.37-3.536zM10.878 17.13c-.447-.097-.623-.608-.394-1.003l1.733-3.003a.75.75 0 01.65-.375h3.465c.457 0 .81.408.672.843a5.252 5.252 0 01-6.126 3.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12.75a.75.75 0 000-1.5h-.783a8.22 8.22 0 00-.237-1.357l.734-.267a.75.75 0 10-.513-1.41l-.735.268a8.24 8.24 0 00-.689-1.191l.6-.504a.75.75 0 10-.964-1.149l-.6.504a8.3 8.3 0 00-1.054-.885l.391-.678a.75.75 0 10-1.299-.75l-.39.677a8.188 8.188 0 00-1.295-.471l.136-.77a.75.75 0 00-1.477-.26l-.136.77a8.364 8.364 0 00-1.377 0l-.136-.77a.75.75 0 10-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 00-1.3.75l.392.678a8.29 8.29 0 00-1.054.885l-.6-.504a.75.75 0 00-.965 1.149l.6.503a8.243 8.243 0 00-.689 1.192L3.8 8.217a.75.75 0 10-.513 1.41l.735.267a8.222 8.222 0 00-.238 1.355h-.783a.75.75 0 000 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 10.513 1.41l.735-.268c.197.417.428.816.69 1.192l-.6.504a.75.75 0 10.963 1.149l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 101.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.771a.75.75 0 101.477.26l.137-.772a8.376 8.376 0 001.376 0l.136.773a.75.75 0 101.477-.26l-.136-.772a8.19 8.19 0 001.294-.47l.391.677a.75.75 0 101.3-.75l-.393-.679a8.282 8.282 0 001.054-.885l.601.504a.75.75 0 10.964-1.15l-.6-.503a8.24 8.24 0 00.69-1.191l.735.268a.75.75 0 10.512-1.41l-.734-.268c.115-.438.195-.892.237-1.356h.784zm-2.657-3.06a6.744 6.744 0 00-1.19-2.053 6.784 6.784 0 00-1.82-1.51A6.704 6.704 0 0012 5.25a6.801 6.801 0 00-1.225.111 6.7 6.7 0 00-2.15.792 6.784 6.784 0 00-2.952 3.489.758.758 0 01-.036.099A6.74 6.74 0 005.251 12a6.739 6.739 0 003.355 5.835l.01.006.01.005a6.706 6.706 0 002.203.802c.007 0 .014.002.021.004a6.792 6.792 0 002.301 0l.022-.004a6.707 6.707 0 002.228-.816 6.781 6.781 0 001.762-1.483l.009-.01.009-.012a6.744 6.744 0 001.18-2.064c.253-.708.39-1.47.39-2.264a6.74 6.74 0 00-.408-2.308z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CogIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 39491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CommandLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 6a3 3 0 013-3h13.5a3 3 0 013 3v12a3 3 0 01-3 3H5.25a3 3 0 01-3-3V6zm3.97.97a.75.75 0 011.06 0l2.25 2.25a.75.75 0 010 1.06l-2.25 2.25a.75.75 0 01-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 010-1.06zm4.28 4.28a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CommandLineIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ComputerDesktopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 5.25a3 3 0 013-3h13.5a3 3 0 013 3V15a3 3 0 01-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 01-.53 1.28h-9a.75.75 0 01-.53-1.28l.621-.622a2.25 2.25 0 00.659-1.59V18h-3a3 3 0 01-3-3V5.25zm1.5 0v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ComputerDesktopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87898:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CpuChipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5h-9v9h9v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 2.25A.75.75 0 019 3v.75h2.25V3a.75.75 0 011.5 0v.75H15V3a.75.75 0 011.5 0v.75h.75a3 3 0 013 3v.75H21A.75.75 0 0121 9h-.75v2.25H21a.75.75 0 010 1.5h-.75V15H21a.75.75 0 010 1.5h-.75v.75a3 3 0 01-3 3h-.75V21a.75.75 0 01-1.5 0v-.75h-2.25V21a.75.75 0 01-1.5 0v-.75H9V21a.75.75 0 01-1.5 0v-.75h-.75a3 3 0 01-3-3v-.75H3A.75.75 0 013 15h.75v-2.25H3a.75.75 0 010-1.5h.75V9H3a.75.75 0 010-1.5h.75v-.75a3 3 0 013-3h.75V3a.75.75 0 01.75-.75zM6 6.75A.75.75 0 016.75 6h10.5a.75.75 0 01.75.75v10.5a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V6.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CpuChipIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CreditCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75a3 3 0 00-3 3v.75h21v-.75a3 3 0 00-3-3h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.5 9.75h-21v7.5a3 3 0 003 3h15a3 3 0 003-3v-7.5zm-18 3.75a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CreditCardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z"
  }));
}

const ForwardRef = React.forwardRef(CubeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CubeTransparentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.622 1.602a.75.75 0 01.756 0l2.25 1.313a.75.75 0 01-.756 1.295L12 3.118 10.128 4.21a.75.75 0 11-.756-1.295l2.25-1.313zM5.898 5.81a.75.75 0 01-.27 1.025l-1.14.665 1.14.665a.75.75 0 11-.756 1.295L3.75 8.806v.944a.75.75 0 01-1.5 0V7.5a.75.75 0 01.372-.648l2.25-1.312a.75.75 0 011.026.27zm12.204 0a.75.75 0 011.026-.27l2.25 1.312a.75.75 0 01.372.648v2.25a.75.75 0 01-1.5 0v-.944l-1.122.654a.75.75 0 11-.756-1.295l1.14-.665-1.14-.665a.75.75 0 01-.27-1.025zm-9 5.25a.75.75 0 011.026-.27L12 11.882l1.872-1.092a.75.75 0 11.756 1.295l-1.878 1.096V15a.75.75 0 01-1.5 0v-1.82l-1.878-1.095a.75.75 0 01-.27-1.025zM3 13.5a.75.75 0 01.75.75v1.82l1.878 1.095a.75.75 0 11-.756 1.295l-2.25-1.312a.75.75 0 01-.372-.648v-2.25A.75.75 0 013 13.5zm18 0a.75.75 0 01.75.75v2.25a.75.75 0 01-.372.648l-2.25 1.312a.75.75 0 11-.756-1.295l1.878-1.096V14.25a.75.75 0 01.75-.75zm-9 5.25a.75.75 0 01.75.75v.944l1.122-.654a.75.75 0 11.756 1.295l-2.25 1.313a.75.75 0 01-.756 0l-2.25-1.313a.75.75 0 11.756-1.295l1.122.654V19.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CubeTransparentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 93680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyBangladeshiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75zM10.5 7.963a1.5 1.5 0 00-2.17-1.341l-.415.207a.75.75 0 00.67 1.342L9 7.963V9.75h-.75a.75.75 0 100 1.5H9v4.688c0 .563.26 1.198.867 1.525A4.501 4.501 0 0016.41 14.4c.199-.977-.636-1.649-1.415-1.649h-.745a.75.75 0 100 1.5h.656a3.002 3.002 0 01-4.327 1.893.113.113 0 01-.045-.051.336.336 0 01-.034-.154V11.25h5.25a.75.75 0 000-1.5H10.5V7.963z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyBangladeshiIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 01-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004zM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 01-.921.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v.816a3.836 3.836 0 00-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 01-.921-.421l-.879-.66a.75.75 0 00-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 001.5 0v-.81a4.124 4.124 0 001.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 00-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 00.933-1.175l-.415-.33a3.836 3.836 0 00-1.719-.755V6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyDollarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.902 7.098a3.75 3.75 0 013.903-.884.75.75 0 10.498-1.415A5.25 5.25 0 008.005 9.75H7.5a.75.75 0 000 1.5h.054a5.281 5.281 0 000 1.5H7.5a.75.75 0 000 1.5h.505a5.25 5.25 0 006.494 2.701.75.75 0 00-.498-1.415 3.75 3.75 0 01-4.252-1.286h3.001a.75.75 0 000-1.5H9.075a3.77 3.77 0 010-1.5h3.675a.75.75 0 000-1.5h-3c.105-.14.221-.274.348-.402z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyEuroIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyPoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM9.763 9.51a2.25 2.25 0 013.828-1.351.75.75 0 001.06-1.06 3.75 3.75 0 00-6.38 2.252c-.033.307 0 .595.032.822l.154 1.077H8.25a.75.75 0 000 1.5h.421l.138.964a3.75 3.75 0 01-.358 2.208l-.122.242a.75.75 0 00.908 1.047l1.539-.512a1.5 1.5 0 01.948 0l.655.218a3 3 0 002.29-.163l.666-.333a.75.75 0 10-.67-1.342l-.667.333a1.5 1.5 0 01-1.145.082l-.654-.218a3 3 0 00-1.898 0l-.06.02a5.25 5.25 0 00.053-1.794l-.108-.752H12a.75.75 0 000-1.5H9.972l-.184-1.29a1.863 1.863 0 01-.025-.45z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyPoundIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 79040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyRupeeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM9 7.5A.75.75 0 009 9h1.5c.98 0 1.813.626 2.122 1.5H9A.75.75 0 009 12h3.622a2.251 2.251 0 01-2.122 1.5H9a.75.75 0 00-.53 1.28l3 3a.75.75 0 101.06-1.06L10.8 14.988A3.752 3.752 0 0014.175 12H15a.75.75 0 000-1.5h-.825A3.733 3.733 0 0013.5 9H15a.75.75 0 000-1.5H9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyRupeeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CurrencyYenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM9.624 7.084a.75.75 0 00-1.248.832l2.223 3.334H9a.75.75 0 000 1.5h2.25v1.5H9a.75.75 0 000 1.5h2.25v1.5a.75.75 0 001.5 0v-1.5H15a.75.75 0 000-1.5h-2.25v-1.5H15a.75.75 0 000-1.5h-1.599l2.223-3.334a.75.75 0 10-1.248-.832L12 10.648 9.624 7.084z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyYenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 60218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CursorArrowRaysIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5a.75.75 0 01.75.75V4.5a.75.75 0 01-1.5 0V2.25A.75.75 0 0112 1.5zM5.636 4.136a.75.75 0 011.06 0l1.592 1.591a.75.75 0 01-1.061 1.06l-1.591-1.59a.75.75 0 010-1.061zm12.728 0a.75.75 0 010 1.06l-1.591 1.592a.75.75 0 01-1.06-1.061l1.59-1.591a.75.75 0 011.061 0zm-6.816 4.496a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68zM3 10.5a.75.75 0 01.75-.75H6a.75.75 0 010 1.5H3.75A.75.75 0 013 10.5zm14.25 0a.75.75 0 01.75-.75h2.25a.75.75 0 010 1.5H18a.75.75 0 01-.75-.75zm-8.962 3.712a.75.75 0 010 1.061l-1.591 1.591a.75.75 0 11-1.061-1.06l1.591-1.592a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CursorArrowRaysIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function CursorArrowRippleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CursorArrowRippleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 86064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DevicePhoneMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.625.75A3.375 3.375 0 005.25 4.125v15.75a3.375 3.375 0 003.375 3.375h6.75a3.375 3.375 0 003.375-3.375V4.125A3.375 3.375 0 0015.375.75h-6.75zM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 017.5 19.875V4.125z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(DevicePhoneMobileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 68802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DeviceTabletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.125 1.5A3.375 3.375 0 003.75 4.875v14.25A3.375 3.375 0 007.125 22.5h9.75a3.375 3.375 0 003.375-3.375V4.875A3.375 3.375 0 0016.875 1.5h-9.75zM6 4.875c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 016 19.125V4.875z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(DeviceTabletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm5.845 17.03a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V12a.75.75 0 00-1.5 0v4.19l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm6.905 9.97a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72V18a.75.75 0 001.5 0v-4.19l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentArrowUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zM9.75 17.25a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zm2.25-3a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zm3.75-1.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-5.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5zm6.61 10.936a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"
  }));
}

const ForwardRef = React.forwardRef(DocumentCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentDuplicateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 013.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0121 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 017.5 16.125V3.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0017.25 7.5h-1.875A.375.375 0 0115 7.125V5.25zM4.875 6H6v10.125A3.375 3.375 0 009.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V7.875C3 6.839 3.84 6 4.875 6z"
  }));
}

const ForwardRef = React.forwardRef(DocumentDuplicateIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"
  }));
}

const ForwardRef = React.forwardRef(DocumentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentMagnifyingGlassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 16.5a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 001.06-1.06l-1.047-1.048A3.375 3.375 0 1011.625 18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentMagnifyingGlassIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zM9.75 14.25a.75.75 0 000 1.5H15a.75.75 0 000-1.5H9.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zM12.75 12a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V18a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
  }));
}

const ForwardRef = React.forwardRef(DocumentPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function DocumentTextIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"
  }));
}

const ForwardRef = React.forwardRef(DocumentTextIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 62823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisHorizontalCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm0 8.625a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zM15.375 12a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zM7.5 10.875a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EllipsisHorizontalCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 14267:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EllipsisHorizontalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 99814:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EllipsisVerticalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EllipsisVerticalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 26314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EnvelopeOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5a3 3 0 003-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 01-.712 1.321l-5.683-3.06a1.5 1.5 0 00-1.422 0l-5.683 3.06a.75.75 0 01-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 003 3h15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.589v-.745a3 3 0 011.578-2.641l7.5-4.039a3 3 0 012.844 0l7.5 4.039A3 3 0 0122.5 8.844v.745l-8.426 4.926-.652-.35a3 3 0 00-2.844 0l-.652.35L1.5 9.59z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 6970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ExclamationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ExclamationCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 51806:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ExclamationTriangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeDropperIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.098 2.598a3.75 3.75 0 113.622 6.275l-1.72.46V12a.75.75 0 01-.22.53l-.75.75a.75.75 0 01-1.06 0l-.97-.97-7.94 7.94a2.56 2.56 0 01-1.81.75 1.06 1.06 0 00-.75.31l-.97.97a.75.75 0 01-1.06 0l-.75-.75a.75.75 0 010-1.06l.97-.97a1.06 1.06 0 00.31-.75c0-.68.27-1.33.75-1.81L11.69 9l-.97-.97a.75.75 0 010-1.06l.75-.75A.75.75 0 0112 6h2.666l.461-1.72c.165-.617.49-1.2.971-1.682zm-3.348 7.463L4.81 18a1.06 1.06 0 00-.31.75c0 .318-.06.63-.172.922a2.56 2.56 0 01.922-.172c.281 0 .551-.112.75-.31l7.94-7.94-1.19-1.19z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EyeDropperIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EyeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function EyeSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
  }));
}

const ForwardRef = React.forwardRef(EyeSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 32771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FaceFrownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 00-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 01-.189-.866c0-.298.059-.605.189-.866zm-4.34 7.964a.75.75 0 01-1.061-1.06 5.236 5.236 0 013.73-1.538 5.236 5.236 0 013.695 1.538.75.75 0 11-1.061 1.06 3.736 3.736 0 00-2.639-1.098 3.736 3.736 0 00-2.664 1.098z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FaceFrownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FaceSmileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 00-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 01-.189-.866c0-.298.059-.605.189-.866zm2.023 6.828a.75.75 0 10-1.06-1.06 3.75 3.75 0 01-5.304 0 .75.75 0 00-1.06 1.06 5.25 5.25 0 007.424 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FaceSmileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FilmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 18.375V5.625zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-1.5A.375.375 0 003 5.625zm16.125-.375a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0021 7.125v-1.5a.375.375 0 00-.375-.375h-1.5zM21 9.375A.375.375 0 0020.625 9h-1.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-1.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-1.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 00.375-.375v-1.5zM4.875 18.75a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-1.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h1.5zM3.375 15h1.5a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-1.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375zm0-3.75h1.5a.375.375 0 00.375-.375v-1.5A.375.375 0 004.875 9h-1.5A.375.375 0 003 9.375v1.5c0 .207.168.375.375.375zm4.125 0a.75.75 0 000 1.5h9a.75.75 0 000-1.5h-9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FilmIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FingerPrintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a6.715 6.715 0 00-3.722 1.118.75.75 0 11-.828-1.25 8.25 8.25 0 0112.8 6.883c0 3.014-.574 5.897-1.62 8.543a.75.75 0 01-1.395-.551A21.69 21.69 0 0018.75 10.5 6.75 6.75 0 0012 3.75zM6.157 5.739a.75.75 0 01.21 1.04A6.715 6.715 0 005.25 10.5c0 1.613-.463 3.12-1.265 4.393a.75.75 0 01-1.27-.8A6.715 6.715 0 003.75 10.5c0-1.68.503-3.246 1.367-4.55a.75.75 0 011.04-.211zM12 7.5a3 3 0 00-3 3c0 3.1-1.176 5.927-3.105 8.056a.75.75 0 11-1.112-1.008A10.459 10.459 0 007.5 10.5a4.5 4.5 0 119 0c0 .547-.022 1.09-.067 1.626a.75.75 0 01-1.495-.123c.041-.495.062-.996.062-1.503a3 3 0 00-3-3zm0 2.25a.75.75 0 01.75.75A15.69 15.69 0 018.97 20.738a.75.75 0 01-1.14-.975A14.19 14.19 0 0011.25 10.5a.75.75 0 01.75-.75zm3.239 5.183a.75.75 0 01.515.927 19.415 19.415 0 01-2.585 5.544.75.75 0 11-1.243-.84 17.912 17.912 0 002.386-5.116.75.75 0 01.927-.515z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FingerPrintIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 29518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FireIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.963 2.286a.75.75 0 00-1.071-.136 9.742 9.742 0 00-3.539 6.177A7.547 7.547 0 016.648 6.61a.75.75 0 00-1.152-.082A9 9 0 1015.68 4.534a7.46 7.46 0 01-2.717-2.248zM15.75 14.25a3.75 3.75 0 11-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 011.925-3.545 3.75 3.75 0 013.255 3.717z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FireIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 61354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FlagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2.25a.75.75 0 01.75.75v.54l1.838-.46a9.75 9.75 0 016.725.738l.108.054a8.25 8.25 0 005.58.652l3.109-.732a.75.75 0 01.917.81 47.784 47.784 0 00.005 10.337.75.75 0 01-.574.812l-3.114.733a9.75 9.75 0 01-6.594-.77l-.108-.054a8.25 8.25 0 00-5.69-.625l-2.202.55V21a.75.75 0 01-1.5 0V3A.75.75 0 013 2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FlagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44898:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 003-3V9a3 3 0 00-3-3h-5.379a.75.75 0 01-.53-.22L11.47 3.66A2.25 2.25 0 009.879 3H4.5a3 3 0 00-3 3v12a3 3 0 003 3h15zm-6.75-10.5a.75.75 0 00-1.5 0v4.19l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V10.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FolderArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 49988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21a3 3 0 003-3v-4.5a3 3 0 00-3-3h-15a3 3 0 00-3 3V18a3 3 0 003 3h15zM1.5 10.146V6a3 3 0 013-3h5.379a2.25 2.25 0 011.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 013 3v1.146A4.483 4.483 0 0019.5 9h-15a4.483 4.483 0 00-3 1.146z"
  }));
}

const ForwardRef = React.forwardRef(FolderIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 003-3V9a3 3 0 00-3-3h-5.379a.75.75 0 01-.53-.22L11.47 3.66A2.25 2.25 0 009.879 3H4.5a3 3 0 00-3 3v12a3 3 0 003 3h15zM9 12.75a.75.75 0 000 1.5h6a.75.75 0 000-1.5H9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FolderMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 00-3-3h-3.879a.75.75 0 01-.53-.22L11.47 3.66A2.25 2.25 0 009.879 3H6a3 3 0 00-3 3v3.162A3.756 3.756 0 014.094 9h15.812zM4.094 10.5a2.25 2.25 0 00-2.227 2.568l.857 6A2.25 2.25 0 004.951 21H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-2.227-2.568H4.094z"
  }));
}

const ForwardRef = React.forwardRef(FolderOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FolderPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 003-3V9a3 3 0 00-3-3h-5.379a.75.75 0 01-.53-.22L11.47 3.66A2.25 2.25 0 009.879 3H4.5a3 3 0 00-3 3v12a3 3 0 003 3h15zm-6.75-10.5a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V10.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FolderPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ForwardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.055 7.06c-1.25-.714-2.805.189-2.805 1.628v8.123c0 1.44 1.555 2.342 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.342 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L14.805 7.06C13.555 6.346 12 7.25 12 8.688v2.34L5.055 7.06z"
  }));
}

const ForwardRef = React.forwardRef(ForwardIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function FunnelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.792 2.938A49.069 49.069 0 0112 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 011.541 1.836v1.044a3 3 0 01-.879 2.121l-6.182 6.182a1.5 1.5 0 00-.439 1.061v2.927a3 3 0 01-1.658 2.684l-1.757.878A.75.75 0 019.75 21v-5.818a1.5 1.5 0 00-.44-1.06L3.13 7.938a3 3 0 01-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FunnelIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 27168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GifIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.75a3 3 0 00-3 3v10.5a3 3 0 003 3h15a3 3 0 003-3V6.75a3 3 0 00-3-3h-15zm9 4.5a.75.75 0 00-1.5 0v7.5a.75.75 0 001.5 0v-7.5zm1.5 0a.75.75 0 01.75-.75h3a.75.75 0 010 1.5H16.5v2.25H18a.75.75 0 010 1.5h-1.5v3a.75.75 0 01-1.5 0v-7.5zM6.636 9.78c.404-.575.867-.78 1.25-.78s.846.205 1.25.78a.75.75 0 001.228-.863C9.738 8.027 8.853 7.5 7.886 7.5c-.966 0-1.852.527-2.478 1.417-.62.882-.908 2-.908 3.083 0 1.083.288 2.201.909 3.083.625.89 1.51 1.417 2.477 1.417.967 0 1.852-.527 2.478-1.417a.75.75 0 00.136-.431V12a.75.75 0 00-.75-.75h-1.5a.75.75 0 000 1.5H9v1.648c-.37.44-.774.602-1.114.602-.383 0-.846-.205-1.25-.78C6.226 13.638 6 12.837 6 12c0-.837.226-1.638.636-2.22z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(GifIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 78326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GiftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3a1.875 1.875 0 000 3.75h1.875v4.5H3.375A1.875 1.875 0 011.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0112 2.753a3.375 3.375 0 015.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 10-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3zM11.25 12.75H3v6.75a2.25 2.25 0 002.25 2.25h6v-9zM12.75 12.75v9h6.75a2.25 2.25 0 002.25-2.25v-6.75h-9z"
  }));
}

const ForwardRef = React.forwardRef(GiftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GiftTopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3v4.046a3 3 0 00-4.277 4.204H1.5v-6A2.25 2.25 0 013.75 3h7.5zM12.75 3v4.011a3 3 0 014.239 4.239H22.5v-6A2.25 2.25 0 0020.25 3h-7.5zM22.5 12.75h-8.983a4.125 4.125 0 004.108 3.75.75.75 0 010 1.5 5.623 5.623 0 01-4.875-2.817V21h7.5a2.25 2.25 0 002.25-2.25v-6zM11.25 21v-5.817A5.623 5.623 0 016.375 18a.75.75 0 010-1.5 4.126 4.126 0 004.108-3.75H1.5v6A2.25 2.25 0 003.75 21h7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.085 10.354c.03.297.038.575.036.805a7.484 7.484 0 01-.805-.036c-.833-.084-1.677-.325-2.195-.843a1.5 1.5 0 012.122-2.12c.517.517.759 1.36.842 2.194zM12.877 10.354c-.03.297-.038.575-.036.805.23.002.508-.006.805-.036.833-.084 1.677-.325 2.195-.843A1.5 1.5 0 0013.72 8.16c-.518.518-.76 1.362-.843 2.194z"
  }));
}

const ForwardRef = React.forwardRef(GiftTopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.721 12.752a9.711 9.711 0 00-.945-5.003 12.754 12.754 0 01-4.339 2.708 18.991 18.991 0 01-.214 4.772 17.165 17.165 0 005.498-2.477zM14.634 15.55a17.324 17.324 0 00.332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 00.332 4.647 17.385 17.385 0 005.268 0zM9.772 17.119a18.963 18.963 0 004.456 0A17.182 17.182 0 0112 21.724a17.18 17.18 0 01-2.228-4.605zM7.777 15.23a18.87 18.87 0 01-.214-4.774 12.753 12.753 0 01-4.34-2.708 9.711 9.711 0 00-.944 5.004 17.165 17.165 0 005.498 2.477zM21.356 14.752a9.765 9.765 0 01-7.478 6.817 18.64 18.64 0 001.988-4.718 18.627 18.627 0 005.49-2.098zM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 001.988 4.718 9.765 9.765 0 01-7.478-6.816zM13.878 2.43a9.755 9.755 0 016.116 3.986 11.267 11.267 0 01-3.746 2.504 18.63 18.63 0 00-2.37-6.49zM12 2.276a17.152 17.152 0 012.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0112 2.276zM10.122 2.43a18.629 18.629 0 00-2.37 6.49 11.266 11.266 0 01-3.746-2.504 9.754 9.754 0 016.116-3.985z"
  }));
}

const ForwardRef = React.forwardRef(GlobeAltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAmericasIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM6.262 6.072a8.25 8.25 0 1010.562-.766 4.5 4.5 0 01-1.318 1.357L14.25 7.5l.165.33a.809.809 0 01-1.086 1.085l-.604-.302a1.125 1.125 0 00-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 01-2.288 4.04l-.723.724a1.125 1.125 0 01-1.298.21l-.153-.076a1.125 1.125 0 01-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 01-.21-1.298L9.75 12l-1.64-1.64a6 6 0 01-1.676-3.257l-.172-1.03z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(GlobeAmericasIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 7321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeAsiaAustraliaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25a.75.75 0 01.75.75c0 1.12-.492 2.126-1.27 2.812a.75.75 0 11-.992-1.124A2.243 2.243 0 0015 9a.75.75 0 01.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM4.575 15.6a8.25 8.25 0 009.348 4.425 1.966 1.966 0 00-1.84-1.275.983.983 0 01-.97-.822l-.073-.437c-.094-.565.25-1.11.8-1.267l.99-.282c.427-.123.783-.418.982-.816l.036-.073a1.453 1.453 0 012.328-.377L16.5 15h.628a2.25 2.25 0 011.983 1.186 8.25 8.25 0 00-6.345-12.4c.044.262.18.503.389.676l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 01-1.161.886l-.143.048a1.107 1.107 0 00-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 01-1.652.928l-.679-.906a1.125 1.125 0 00-1.906.172L4.575 15.6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(GlobeAsiaAustraliaIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 27233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function GlobeEuropeAfricaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM8.547 4.505a8.25 8.25 0 1011.672 8.214l-.46-.46a2.252 2.252 0 01-.422-.586l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 01-1.384-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.279-2.132z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(GlobeEuropeAfricaIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandRaisedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.875a1.125 1.125 0 012.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 012.25 0v10.937a4.505 4.505 0 00-3.25 2.373 8.963 8.963 0 014-.935A.75.75 0 0018 15v-2.266a3.368 3.368 0 01.988-2.37 1.125 1.125 0 011.591 1.59 1.118 1.118 0 00-.329.79v3.006h-.005a6 6 0 01-1.752 4.007l-1.736 1.736a6 6 0 01-4.242 1.757H10.5a7.5 7.5 0 01-7.5-7.5V6.375a1.125 1.125 0 012.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 012.25 0v6.526c.495-.1.997-.151 1.5-.151V1.875z"
  }));
}

const ForwardRef = React.forwardRef(HandRaisedIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandThumbDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.73 5.25h1.035A7.465 7.465 0 0118 9.375a7.465 7.465 0 01-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 01-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.498 4.498 0 00-.322 1.672V21a.75.75 0 01-.75.75 2.25 2.25 0 01-2.25-2.25c0-1.152.26-2.243.723-3.218C7.74 15.724 7.366 15 6.748 15H3.622c-1.026 0-1.945-.694-2.054-1.715A12.134 12.134 0 011.5 12c0-2.848.992-5.464 2.649-7.521.388-.482.987-.729 1.605-.729H9.77a4.5 4.5 0 011.423.23l3.114 1.04a4.5 4.5 0 001.423.23zM21.669 13.773c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.959 8.959 0 01-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227z"
  }));
}

const ForwardRef = React.forwardRef(HandThumbDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 19113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HandThumbUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.493 18.75c-.425 0-.82-.236-.975-.632A7.48 7.48 0 016 15.375c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75 2.25 2.25 0 012.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23h-.777zM2.331 10.977a11.969 11.969 0 00-.831 4.398 12 12 0 00.52 3.507c.26.85 1.084 1.368 1.973 1.368H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 01-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227z"
  }));
}

const ForwardRef = React.forwardRef(HandThumbUpIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HashtagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.097 1.515a.75.75 0 01.589.882L10.666 7.5h4.47l1.079-5.397a.75.75 0 111.47.294L16.665 7.5h3.585a.75.75 0 010 1.5h-3.885l-1.2 6h3.585a.75.75 0 010 1.5h-3.885l-1.08 5.397a.75.75 0 11-1.47-.294l1.02-5.103h-4.47l-1.08 5.397a.75.75 0 01-1.47-.294l1.02-5.103H3.75a.75.75 0 110-1.5h3.885l1.2-6H5.25a.75.75 0 010-1.5h3.885l1.08-5.397a.75.75 0 01.882-.588zM10.365 9l-1.2 6h4.47l1.2-6h-4.47z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(HashtagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 31718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HeartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z"
  }));
}

const ForwardRef = React.forwardRef(HeartIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z"
  }));
}

const ForwardRef = React.forwardRef(HomeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 22049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function HomeModernIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.006 3.705a.75.75 0 00-.512-1.41L6 6.838V3a.75.75 0 00-.75-.75h-1.5A.75.75 0 003 3v4.93l-1.006.365a.75.75 0 00.512 1.41l16.5-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.019 11.115L18 5.667V9.09l4.006 1.456a.75.75 0 11-.512 1.41l-.494-.18v8.475h.75a.75.75 0 010 1.5H2.25a.75.75 0 010-1.5H3v-9.129l.019-.006zM18 20.25v-9.565l1.5.545v9.02H18zm-9-6a.75.75 0 00-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 00.75-.75V15a.75.75 0 00-.75-.75H9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(HomeModernIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 40856:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function IdentificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.75a3 3 0 00-3 3v10.5a3 3 0 003 3h15a3 3 0 003-3V6.75a3 3 0 00-3-3h-15zm4.125 3a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-3.873 8.703a4.126 4.126 0 017.746 0 .75.75 0 01-.351.92 7.47 7.47 0 01-3.522.877 7.47 7.47 0 01-3.522-.877.75.75 0 01-.351-.92zM15 8.25a.75.75 0 000 1.5h3.75a.75.75 0 000-1.5H15zM14.25 12a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H15a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h3.75a.75.75 0 000-1.5H15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(IdentificationIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 26515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.478 5.559A1.5 1.5 0 016.912 4.5H9A.75.75 0 009 3H6.912a3 3 0 00-2.868 2.118l-2.411 7.838a3 3 0 00-.133.882V18a3 3 0 003 3h15a3 3 0 003-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0017.088 3H15a.75.75 0 000 1.5h2.088a1.5 1.5 0 011.434 1.059l2.213 7.191H17.89a3 3 0 00-2.684 1.658l-.256.513a1.5 1.5 0 01-1.342.829h-3.218a1.5 1.5 0 01-1.342-.83l-.256-.512a3 3 0 00-2.684-1.658H3.265l2.213-7.191z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v6.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 011.06-1.06l1.72 1.72V3a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(InboxArrowDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.912 3a3 3 0 00-2.868 2.118l-2.411 7.838a3 3 0 00-.133.882V18a3 3 0 003 3h15a3 3 0 003-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0017.088 3H6.912zm13.823 9.75l-2.213-7.191A1.5 1.5 0 0017.088 4.5H6.912a1.5 1.5 0 00-1.434 1.059L3.265 12.75H6.11a3 3 0 012.684 1.658l.256.513a1.5 1.5 0 001.342.829h3.218a1.5 1.5 0 001.342-.83l.256-.512a3 3 0 012.684-1.658h2.844z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(InboxIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InboxStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 9.832v1.793c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875V9.832a3 3 0 00-.722-1.952l-3.285-3.832A3 3 0 0016.215 3h-8.43a3 3 0 00-2.278 1.048L2.222 7.88A3 3 0 001.5 9.832zM7.785 4.5a1.5 1.5 0 00-1.139.524L3.881 8.25h3.165a3 3 0 012.496 1.336l.164.246a1.5 1.5 0 001.248.668h2.092a1.5 1.5 0 001.248-.668l.164-.246a3 3 0 012.496-1.336h3.165l-2.765-3.226a1.5 1.5 0 00-1.139-.524h-8.43z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.813 15c-.725 0-1.313.588-1.313 1.313V18a3 3 0 003 3h15a3 3 0 003-3v-1.688c0-.724-.588-1.312-1.313-1.312h-4.233a3 3 0 00-2.496 1.336l-.164.246a1.5 1.5 0 01-1.248.668h-2.092a1.5 1.5 0 01-1.248-.668l-.164-.246A3 3 0 007.046 15H2.812z"
  }));
}

const ForwardRef = React.forwardRef(InboxStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function InformationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(InformationCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 72205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function KeyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 1.5a6.75 6.75 0 00-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 00-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 00.75-.75v-1.5h1.5A.75.75 0 009 19.5V18h1.5a.75.75 0 00.53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1015.75 1.5zm0 3a.75.75 0 000 1.5A2.25 2.25 0 0118 8.25a.75.75 0 001.5 0 3.75 3.75 0 00-3.75-3.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(KeyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 73701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2.25a.75.75 0 01.75.75v1.506a49.38 49.38 0 015.343.371.75.75 0 11-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 01-2.969 6.323c.317.384.65.753.998 1.107a.75.75 0 11-1.07 1.052A18.902 18.902 0 019 13.687a18.823 18.823 0 01-5.656 4.482.75.75 0 11-.688-1.333 17.323 17.323 0 005.396-4.353A18.72 18.72 0 015.89 8.598a.75.75 0 011.388-.568A17.21 17.21 0 009 11.224a17.17 17.17 0 002.391-5.165 48.038 48.038 0 00-8.298.307.75.75 0 01-.186-1.489 49.159 49.159 0 015.343-.371V3A.75.75 0 019 2.25zM15.75 9a.75.75 0 01.68.433l5.25 11.25a.75.75 0 01-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 01-1.36-.634l5.25-11.25A.75.75 0 0115.75 9zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(LanguageIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LifebuoyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.449 8.448L16.388 11a4.52 4.52 0 010 2.002l3.061 2.55a8.275 8.275 0 000-7.103zM15.552 19.45L13 16.388a4.52 4.52 0 01-2.002 0l-2.55 3.061a8.275 8.275 0 007.103 0zM4.55 15.552L7.612 13a4.52 4.52 0 010-2.002L4.551 8.45a8.275 8.275 0 000 7.103zM8.448 4.55L11 7.612a4.52 4.52 0 012.002 0l2.55-3.061a8.275 8.275 0 00-7.103 0zm8.657-.86a9.776 9.776 0 011.79 1.415 9.776 9.776 0 011.414 1.788 9.764 9.764 0 010 10.211 9.777 9.777 0 01-1.415 1.79 9.777 9.777 0 01-1.788 1.414 9.764 9.764 0 01-10.212 0 9.776 9.776 0 01-1.788-1.415 9.776 9.776 0 01-1.415-1.788 9.764 9.764 0 010-10.212 9.774 9.774 0 011.415-1.788A9.774 9.774 0 016.894 3.69a9.764 9.764 0 0110.211 0zM14.121 9.88a2.985 2.985 0 00-1.11-.704 3.015 3.015 0 00-2.022 0 2.985 2.985 0 00-1.11.704c-.326.325-.56.705-.704 1.11a3.015 3.015 0 000 2.022c.144.405.378.785.704 1.11.325.326.705.56 1.11.704.652.233 1.37.233 2.022 0a2.985 2.985 0 001.11-.704c.326-.325.56-.705.704-1.11a3.016 3.016 0 000-2.022 2.985 2.985 0 00-.704-1.11z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(LifebuoyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LightBulbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 .75a8.25 8.25 0 00-4.135 15.39c.686.398 1.115 1.008 1.134 1.623a.75.75 0 00.577.706c.352.083.71.148 1.074.195.323.041.6-.218.6-.544v-4.661a6.714 6.714 0 01-.937-.171.75.75 0 11.374-1.453 5.261 5.261 0 002.626 0 .75.75 0 11.374 1.452 6.712 6.712 0 01-.937.172v4.66c0 .327.277.586.6.545.364-.047.722-.112 1.074-.195a.75.75 0 00.577-.706c.02-.615.448-1.225 1.134-1.623A8.25 8.25 0 0012 .75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.013 19.9a.75.75 0 01.877-.597 11.319 11.319 0 004.22 0 .75.75 0 11.28 1.473 12.819 12.819 0 01-4.78 0 .75.75 0 01-.597-.876zM9.754 22.344a.75.75 0 01.824-.668 13.682 13.682 0 002.844 0 .75.75 0 11.156 1.492 15.156 15.156 0 01-3.156 0 .75.75 0 01-.668-.824z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(LightBulbIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 95823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.902 4.098a3.75 3.75 0 00-5.304 0l-4.5 4.5a3.75 3.75 0 001.035 6.037.75.75 0 01-.646 1.353 5.25 5.25 0 01-1.449-8.45l4.5-4.5a5.25 5.25 0 117.424 7.424l-1.757 1.757a.75.75 0 11-1.06-1.06l1.757-1.757a3.75 3.75 0 000-5.304zm-7.389 4.267a.75.75 0 011-.353 5.25 5.25 0 011.449 8.45l-4.5 4.5a5.25 5.25 0 11-7.424-7.424l1.757-1.757a.75.75 0 111.06 1.06l-1.757 1.757a3.75 3.75 0 105.304 5.304l4.5-4.5a3.75 3.75 0 00-1.035-6.037.75.75 0 01-.354-1z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(LinkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 19705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ListBulletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.625 6.75a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm4.875 0A.75.75 0 018.25 6h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75zM2.625 12a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zM7.5 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12A.75.75 0 017.5 12zm-4.875 5.25a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm4.875 0a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ListBulletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 44523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LockClosedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(LockClosedIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 48625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function LockOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 01-1.5 0V6.75a3.75 3.75 0 10-7.5 0v3a3 3 0 013 3v6.75a3 3 0 01-3 3H3.75a3 3 0 01-3-3v-6.75a3 3 0 013-3h9v-3c0-2.9 2.35-5.25 5.25-5.25z"
  }));
}

const ForwardRef = React.forwardRef(LockOpenIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 20178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.875a2.625 2.625 0 115.25 0 2.625 2.625 0 01-5.25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.125 4.5a4.125 4.125 0 102.338 7.524l2.007 2.006a.75.75 0 101.06-1.06l-2.006-2.007a4.125 4.125 0 00-3.399-6.463z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5zm4.5 0a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 25202:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MagnifyingGlassPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5zm8.25-3.75a.75.75 0 01.75.75v2.25h2.25a.75.75 0 010 1.5h-2.25v2.25a.75.75 0 01-1.5 0v-2.25H7.5a.75.75 0 010-1.5h2.25V7.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MagnifyingGlassPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.161 2.58a1.875 1.875 0 011.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0121.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 01-1.676 0l-4.994-2.497a.375.375 0 00-.336 0l-3.868 1.935A1.875 1.875 0 012.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437zM9 6a.75.75 0 01.75.75V15a.75.75 0 01-1.5 0V6.75A.75.75 0 019 6zm6.75 3a.75.75 0 00-1.5 0v8.25a.75.75 0 001.5 0V9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MapPinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MapPinIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MegaphoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.881 4.346A23.112 23.112 0 018.25 6H7.5a5.25 5.25 0 00-.88 10.427 21.593 21.593 0 001.378 3.94c.464 1.004 1.674 1.32 2.582.796l.657-.379c.88-.508 1.165-1.592.772-2.468a17.116 17.116 0 01-.628-1.607c1.918.258 3.76.75 5.5 1.446A21.727 21.727 0 0018 11.25c0-2.413-.393-4.735-1.119-6.904zM18.26 3.74a23.22 23.22 0 011.24 7.51 23.22 23.22 0 01-1.24 7.51c-.055.161-.111.322-.17.482a.75.75 0 101.409.516 24.555 24.555 0 001.415-6.43 2.992 2.992 0 00.836-2.078c0-.806-.319-1.54-.836-2.078a24.65 24.65 0 00-1.415-6.43.75.75 0 10-1.409.516c.059.16.116.321.17.483z"
  }));
}

const ForwardRef = React.forwardRef(MegaphoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MicrophoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z"
  }));
}

const ForwardRef = React.forwardRef(MicrophoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MinusCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47151:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MinusSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MinusSmallIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 43598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MoonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MoonIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 60129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function MusicalNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.952 1.651a.75.75 0 01.298.599V16.303a3 3 0 01-2.176 2.884l-1.32.377a2.553 2.553 0 11-1.403-4.909l2.311-.66a1.5 1.5 0 001.088-1.442V6.994l-9 2.572v9.737a3 3 0 01-2.176 2.884l-1.32.377a2.553 2.553 0 11-1.402-4.909l2.31-.66a1.5 1.5 0 001.088-1.442V9.017 5.25a.75.75 0 01.544-.721l10.5-3a.75.75 0 01.658.122z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(MusicalNoteIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function NewspaperIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 003 3h15a3 3 0 01-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125zM12 9.75a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H12zm-.75-2.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM6 12.75a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5H6zm-.75 3.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM6 6.75a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-3A.75.75 0 009 6.75H6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 01-3 0V6.75z"
  }));
}

const ForwardRef = React.forwardRef(NewspaperIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function NoSymbolIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.72 5.66l11.62 11.62A8.25 8.25 0 006.72 5.66zm10.56 12.68L5.66 6.72a8.25 8.25 0 0011.62 11.62zM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(NoSymbolIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 19367:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaintBrushIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 00-3.471 2.987 10.04 10.04 0 014.815 4.815 18.748 18.748 0 002.987-3.472l3.386-5.079A1.902 1.902 0 0020.599 1.5zm-8.3 14.025a18.76 18.76 0 001.896-1.207 8.026 8.026 0 00-4.513-4.513A18.75 18.75 0 008.475 11.7l-.278.5a5.26 5.26 0 013.601 3.602l.502-.278zM6.75 13.5A3.75 3.75 0 003 17.25a1.5 1.5 0 01-1.601 1.497.75.75 0 00-.7 1.123 5.25 5.25 0 009.8-2.62 3.75 3.75 0 00-3.75-3.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PaintBrushIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55934:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaperAirplaneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"
  }));
}

const ForwardRef = React.forwardRef(PaperAirplaneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PaperClipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.97 3.659a2.25 2.25 0 00-3.182 0l-10.94 10.94a3.75 3.75 0 105.304 5.303l7.693-7.693a.75.75 0 011.06 1.06l-7.693 7.693a5.25 5.25 0 11-7.424-7.424l10.939-10.94a3.75 3.75 0 115.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 015.91 15.66l7.81-7.81a.75.75 0 011.061 1.06l-7.81 7.81a.75.75 0 001.054 1.068L18.97 6.84a2.25 2.25 0 000-3.182z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PaperClipIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PauseCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM9 8.25a.75.75 0 00-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 00.75-.75V9a.75.75 0 00-.75-.75H9zm5.25 0a.75.75 0 00-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 00.75-.75V9a.75.75 0 00-.75-.75h-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PauseCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 5.25a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H7.5a.75.75 0 01-.75-.75V5.25zm7.5 0A.75.75 0 0115 4.5h1.5a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H15a.75.75 0 01-.75-.75V5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PauseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 41565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PencilIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
  }));
}

const ForwardRef = React.forwardRef(PencilIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PencilSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
  }));
}

const ForwardRef = React.forwardRef(PencilSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 12123:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneArrowDownLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 9.75a.75.75 0 01-.75.75h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v2.69l4.72-4.72a.75.75 0 111.06 1.06L16.06 9h2.69a.75.75 0 01.75.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PhoneArrowDownLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneArrowUpRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V5.56l-4.72 4.72a.75.75 0 11-1.06-1.06l4.72-4.72h-2.69a.75.75 0 01-.75-.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PhoneArrowUpRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 34599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PhoneIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhoneXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.22 3.22a.75.75 0 011.06 0L18 4.94l1.72-1.72a.75.75 0 111.06 1.06L19.06 6l1.72 1.72a.75.75 0 01-1.06 1.06L18 7.06l-1.72 1.72a.75.75 0 11-1.06-1.06L16.94 6l-1.72-1.72a.75.75 0 010-1.06zM1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PhoneXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PhotoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PhotoIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 89090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PlayCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 82329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PlayIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 10664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlayPauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 6.75a.75.75 0 00-.75.75V18a.75.75 0 00.75.75h.75a.75.75 0 00.75-.75V7.5a.75.75 0 00-.75-.75H15zM20.25 6.75a.75.75 0 00-.75.75V18c0 .414.336.75.75.75H21a.75.75 0 00.75-.75V7.5a.75.75 0 00-.75-.75h-.75zM5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L5.055 7.061z"
  }));
}

const ForwardRef = React.forwardRef(PlayPauseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 17191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PlusCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 38779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PlusSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.25a.75.75 0 01.75.75v5.25H18a.75.75 0 010 1.5h-5.25V18a.75.75 0 01-1.5 0v-5.25H6a.75.75 0 010-1.5h5.25V6a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PlusSmallIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 57675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PowerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v9a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM6.166 5.106a.75.75 0 010 1.06 8.25 8.25 0 1011.668 0 .75.75 0 111.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PowerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 81320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PresentationChartBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 2.25a.75.75 0 000 1.5H3v10.5a3 3 0 003 3h1.21l-1.172 3.513a.75.75 0 001.424.474l.329-.987h8.418l.33.987a.75.75 0 001.422-.474l-1.17-3.513H18a3 3 0 003-3V3.75h.75a.75.75 0 000-1.5H2.25zm6.04 16.5l.5-1.5h6.42l.5 1.5H8.29zm7.46-12a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6zm-3 2.25a.75.75 0 00-1.5 0v3.75a.75.75 0 001.5 0V9zm-3 2.25a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PresentationChartBarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92231:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PresentationChartLineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 2.25a.75.75 0 000 1.5H3v10.5a3 3 0 003 3h1.21l-1.172 3.513a.75.75 0 001.424.474l.329-.987h8.418l.33.987a.75.75 0 001.422-.474l-1.17-3.513H18a3 3 0 003-3V3.75h.75a.75.75 0 000-1.5H2.25zm6.54 15h6.42l.5 1.5H8.29l.5-1.5zm8.085-8.995a.75.75 0 10-.75-1.299 12.81 12.81 0 00-3.558 3.05L11.03 8.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 001.146-.102 11.312 11.312 0 013.612-3.321z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PresentationChartLineIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 70928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PrinterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 003 3h.27l-.155 1.705A1.875 1.875 0 007.232 22.5h9.536a1.875 1.875 0 001.867-2.045l-.155-1.705h.27a3 3 0 003-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0018 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM16.5 6.205v-2.83A.375.375 0 0016.125 3h-8.25a.375.375 0 00-.375.375v2.83a49.353 49.353 0 019 0zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 01-.374.409H7.232a.375.375 0 01-.374-.409l.526-5.784a.373.373 0 01.333-.337 41.741 41.741 0 018.566 0zm.967-3.97a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H18a.75.75 0 01-.75-.75V10.5zM15 9.75a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V10.5a.75.75 0 00-.75-.75H15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(PrinterIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function PuzzlePieceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 01.878.645 49.17 49.17 0 01.376 5.452.657.657 0 01-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 00-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 01-.595 4.845.75.75 0 01-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 01-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 01-.658.643 49.118 49.118 0 01-4.708-.36.75.75 0 01-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 005.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 00.659-.663 47.703 47.703 0 00-.31-4.82.75.75 0 01.83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 00.657-.642z"
  }));
}

const ForwardRef = React.forwardRef(PuzzlePieceIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 33533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QrCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 013 9.375v-4.5zM4.875 4.5a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 01-1.875-1.875v-4.5zm1.875-.375a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75A.75.75 0 016 7.5v-.75zm9.75 0A.75.75 0 0116.5 6h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 013 19.125v-4.5zm1.875-.375a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zm7.875-.75a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm6 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zM6 16.5a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm9.75 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm-3 3a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm6 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(QrCodeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QuestionMarkCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 01-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 01-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 01-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584zM12 18a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(QuestionMarkCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 97152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function QueueListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3.75a2.625 2.625 0 100 5.25h12.75a2.625 2.625 0 000-5.25H5.625zM3.75 11.25a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zM3 15.75a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75zM3.75 18.75a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75z"
  }));
}

const ForwardRef = React.forwardRef(QueueListIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 69706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RadioIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.432 4.103a.75.75 0 00-.364-1.455L4.128 6.632l-.2.033C2.498 6.904 1.5 8.158 1.5 9.575v9.175a3 3 0 003 3h15a3 3 0 003-3V9.574c0-1.416-.997-2.67-2.429-2.909a49.016 49.016 0 00-7.255-.658l7.616-1.904zm-9.585 8.56a.75.75 0 010 1.06l-.005.006a.75.75 0 01-1.06 0l-.006-.005a.75.75 0 010-1.061l.005-.005a.75.75 0 011.06 0l.006.005zM9.781 15.85a.75.75 0 001.061 0l.005-.005a.75.75 0 000-1.061l-.005-.005a.75.75 0 00-1.06 0l-.006.005a.75.75 0 000 1.06l.005.006zm-1.055-1.066a.75.75 0 010 1.06l-.005.006a.75.75 0 01-1.061 0l-.005-.005a.75.75 0 010-1.06l.005-.006a.75.75 0 011.06 0l.006.005zM7.66 13.73a.75.75 0 001.061 0l.005-.006a.75.75 0 000-1.06l-.005-.005a.75.75 0 00-1.06 0l-.006.005a.75.75 0 000 1.06l.005.006zM9.255 9.75a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75V10.5a.75.75 0 01.75-.75h.008zm3.624 3.28a.75.75 0 00.275-1.025L13.15 12a.75.75 0 00-1.025-.275l-.006.004a.75.75 0 00-.275 1.024l.004.007a.75.75 0 001.024.274l.007-.003zm-1.38 5.126a.75.75 0 01-1.024-.274l-.004-.007a.75.75 0 01.275-1.024l.006-.004a.75.75 0 011.025.274l.004.007a.75.75 0 01-.275 1.024l-.006.004zm.282-6.776a.75.75 0 00-.274-1.025l-.007-.003a.75.75 0 00-1.024.274l-.004.007a.75.75 0 00.274 1.024l.007.004a.75.75 0 001.024-.274l.004-.007zm1.369 5.129a.75.75 0 01-1.025.274l-.006-.003a.75.75 0 01-.275-1.025l.004-.006a.75.75 0 011.025-.275l.006.004a.75.75 0 01.275 1.024l-.004.007zm-.145-1.502a.75.75 0 00.75-.75v-.007a.75.75 0 00-.75-.75h-.008a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008zm-3.75 2.243a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75V18a.75.75 0 01.75-.75h.008zm-2.871-.47a.75.75 0 00.274-1.025l-.003-.006a.75.75 0 00-1.025-.275l-.006.004a.75.75 0 00-.275 1.025l.004.006a.75.75 0 001.024.274l.007-.003zm1.366-5.12a.75.75 0 01-1.025-.274l-.004-.006a.75.75 0 01.275-1.025l.006-.003a.75.75 0 011.025.274l.004.007a.75.75 0 01-.275 1.024l-.006.004zm.281 6.215a.75.75 0 00-.275-1.024l-.006-.004a.75.75 0 00-1.025.274l-.003.007a.75.75 0 00.274 1.024l.007.004a.75.75 0 001.024-.274l.004-.007zM6.655 12.76a.75.75 0 01-1.025.274l-.006-.003a.75.75 0 01-.275-1.025L5.353 12a.75.75 0 011.025-.275l.006.004a.75.75 0 01.275 1.024l-.004.007zm-1.15 2.248a.75.75 0 00.75-.75v-.007a.75.75 0 00-.75-.75h-.008a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008zM17.25 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm1.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(RadioIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 23968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ReceiptPercentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 001.029.696l3.471-1.388 3.472 1.388a.75.75 0 00.556 0l3.472-1.388 3.471 1.388a.75.75 0 001.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0012 1.5zm3.53 7.28a.75.75 0 00-1.06-1.06l-6 6a.75.75 0 101.06 1.06l6-6zM8.625 9a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm5.625 3.375a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ReceiptPercentIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ReceiptRefundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 001.029.696l3.471-1.388 3.472 1.388a.75.75 0 00.556 0l3.472-1.388 3.471 1.388a.75.75 0 001.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0012 1.5zm-.97 6.53a.75.75 0 10-1.06-1.06L7.72 9.22a.75.75 0 000 1.06l2.25 2.25a.75.75 0 101.06-1.06l-.97-.97h3.065a1.875 1.875 0 010 3.75H12a.75.75 0 000 1.5h1.125a3.375 3.375 0 100-6.75h-3.064l.97-.97z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ReceiptRefundIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3006:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RectangleGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 011.5 10.875v-3.75zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 01-1.875-1.875v-8.25zM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 013 18.375v-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(RectangleGroupIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RectangleStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.566 4.657A4.505 4.505 0 016.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0015.75 3h-7.5a3 3 0 00-2.684 1.657zM2.25 12a3 3 0 013-3h13.5a3 3 0 013 3v6a3 3 0 01-3 3H5.25a3 3 0 01-3-3v-6zM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 016.75 6h10.5a3 3 0 012.683 1.657A4.505 4.505 0 0018.75 7.5H5.25z"
  }));
}

const ForwardRef = React.forwardRef(RectangleStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RocketLaunchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 01.75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 019.75 22.5a.75.75 0 01-.75-.75v-4.131A15.838 15.838 0 016.382 15H2.25a.75.75 0 01-.75-.75 6.75 6.75 0 017.815-6.666zM15 6.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26 17.242a.75.75 0 10-.897-1.203 5.243 5.243 0 00-2.05 5.022.75.75 0 00.625.627 5.243 5.243 0 005.022-2.051.75.75 0 10-1.202-.897 3.744 3.744 0 01-3.008 1.51c0-1.23.592-2.323 1.51-3.008z"
  }));
}

const ForwardRef = React.forwardRef(RocketLaunchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function RssIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 4.5a.75.75 0 01.75-.75h.75c8.284 0 15 6.716 15 15v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75C18 11.708 12.292 6 5.25 6H4.5a.75.75 0 01-.75-.75V4.5zm0 6.75a.75.75 0 01.75-.75h.75a8.25 8.25 0 018.25 8.25v.75a.75.75 0 01-.75.75H12a.75.75 0 01-.75-.75v-.75a6 6 0 00-6-6H4.5a.75.75 0 01-.75-.75v-.75zm0 7.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(RssIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 64862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ScaleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v.756a49.106 49.106 0 019.152 1 .75.75 0 01-.152 1.485h-1.918l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 0118.75 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 01-.262 1.453h-8.37a.75.75 0 01-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 015.25 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84L4.168 6.241H2.25a.75.75 0 01-.152-1.485 49.105 49.105 0 019.152-1V3a.75.75 0 01.75-.75zm4.878 13.543l1.872-7.662 1.872 7.662h-3.744zm-9.756 0L5.25 8.131l-1.872 7.662h3.744z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ScaleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 18049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ScissorsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.128 9.155a3.751 3.751 0 11.713-1.321l1.136.656a.75.75 0 01.222 1.104l-.006.007a.75.75 0 01-1.032.157 1.421 1.421 0 00-.113-.072l-.92-.531zm-4.827-3.53a2.25 2.25 0 013.994 2.063.756.756 0 00-.122.23 2.25 2.25 0 01-3.872-2.293zM13.348 8.272a5.073 5.073 0 00-3.428 3.57c-.101.387-.158.79-.165 1.202a1.415 1.415 0 01-.707 1.201l-.96.554a3.751 3.751 0 10.734 1.309l13.729-7.926a.75.75 0 00-.181-1.374l-.803-.215a5.25 5.25 0 00-2.894.05l-5.325 1.629zm-9.223 7.03a2.25 2.25 0 102.25 3.897 2.25 2.25 0 00-2.25-3.897zM12 12.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.372 12.615a.75.75 0 01.75 0l5.43 3.135a.75.75 0 01-.182 1.374l-.802.215a5.25 5.25 0 01-2.894-.051l-5.147-1.574a.75.75 0 01-.156-1.367l3-1.732z"
  }));
}

const ForwardRef = React.forwardRef(ScissorsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ServerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.08 5.227A3 3 0 016.979 3H17.02a3 3 0 012.9 2.227l2.113 7.926A5.228 5.228 0 0018.75 12H5.25a5.228 5.228 0 00-3.284 1.153L4.08 5.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 13.5a3.75 3.75 0 100 7.5h13.5a3.75 3.75 0 100-7.5H5.25zm10.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ServerIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 81020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ServerStackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.507 4.048A3 3 0 017.785 3h8.43a3 3 0 012.278 1.048l1.722 2.008A4.533 4.533 0 0019.5 6h-15c-.243 0-.482.02-.715.056l1.722-2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 10.5a3 3 0 013-3h15a3 3 0 110 6h-15a3 3 0 01-3-3zm15 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 15a3 3 0 100 6h15a3 3 0 100-6h-15zm11.25 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zM19.5 18a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ServerStackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 18239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 4.5a3 3 0 11.825 2.066l-8.421 4.679a3.002 3.002 0 010 1.51l8.421 4.679a3 3 0 11-.729 1.31l-8.421-4.678a3 3 0 110-4.132l8.421-4.679a3 3 0 01-.096-.755z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ShareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 18656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShieldCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ShieldCheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShieldExclamationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.484 2.17a.75.75 0 011.032 0 11.209 11.209 0 007.877 3.08.75.75 0 01.722.515 12.74 12.74 0 01.635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 01-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 01.722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zM12 15a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75v-.008a.75.75 0 00-.75-.75H12z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ShieldExclamationIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 86030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShoppingBagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 004.25 22.5h15.5a1.875 1.875 0 001.865-2.071l-1.263-12a1.875 1.875 0 00-1.865-1.679H16.5V6a4.5 4.5 0 10-9 0zM12 3a3 3 0 00-3 3v.75h6V6a3 3 0 00-3-3zm-3 8.25a3 3 0 106 0v-.75a.75.75 0 011.5 0v.75a4.5 4.5 0 11-9 0v-.75a.75.75 0 011.5 0v.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ShoppingBagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 98946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ShoppingCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25a.75.75 0 000 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 00-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 000-1.5H5.378A2.25 2.25 0 017.5 15h11.218a.75.75 0 00.674-.421 60.358 60.358 0 002.96-7.228.75.75 0 00-.525-.965A60.864 60.864 0 005.68 4.509l-.232-.867A1.875 1.875 0 003.636 2.25H2.25zM3.75 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
  }));
}

const ForwardRef = React.forwardRef(ShoppingCartIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 67223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SignalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.636 4.575a.75.75 0 010 1.06 9 9 0 000 12.729.75.75 0 01-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 011.06 0zm12.728 0a.75.75 0 011.06 0c4.101 4.1 4.101 10.749 0 14.85a.75.75 0 11-1.06-1.061 9 9 0 000-12.728.75.75 0 010-1.06zM7.757 6.696a.75.75 0 010 1.061 6 6 0 000 8.485.75.75 0 01-1.06 1.061 7.5 7.5 0 010-10.607.75.75 0 011.06 0zm8.486 0a.75.75 0 011.06 0 7.5 7.5 0 010 10.607.75.75 0 01-1.06-1.06 6 6 0 000-8.486.75.75 0 010-1.06zM9.879 8.818a.75.75 0 010 1.06 3 3 0 000 4.243.75.75 0 11-1.061 1.06 4.5 4.5 0 010-6.363.75.75 0 011.06 0zm4.242 0a.75.75 0 011.061 0 4.5 4.5 0 010 6.364.75.75 0 01-1.06-1.06 3 3 0 000-4.244.75.75 0 010-1.06zM10.875 12a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(SignalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 39308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SignalSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.47 2.47a.75.75 0 011.06 0l8.407 8.407a1.125 1.125 0 011.186 1.186l1.462 1.461a3.001 3.001 0 00-.464-3.645.75.75 0 111.061-1.061 4.501 4.501 0 01.486 5.79l1.072 1.072a6.001 6.001 0 00-.497-7.923.75.75 0 011.06-1.06 7.501 7.501 0 01.505 10.05l1.064 1.065a9 9 0 00-.508-12.176.75.75 0 011.06-1.06c3.923 3.922 4.093 10.175.512 14.3l1.594 1.594a.75.75 0 11-1.06 1.06l-2.106-2.105-2.121-2.122h-.001l-4.705-4.706a.747.747 0 01-.127-.126L2.47 3.53a.75.75 0 010-1.061zm1.189 4.422a.75.75 0 01.326 1.01 9.004 9.004 0 001.651 10.462.75.75 0 11-1.06 1.06C1.27 16.12.63 11.165 2.648 7.219a.75.75 0 011.01-.326zM5.84 9.134a.75.75 0 01.472.95 6 6 0 001.444 6.159.75.75 0 01-1.06 1.06A7.5 7.5 0 014.89 9.606a.75.75 0 01.95-.472zm2.341 2.653a.75.75 0 01.848.638c.088.62.37 1.218.849 1.696a.75.75 0 01-1.061 1.061 4.483 4.483 0 01-1.273-2.546.75.75 0 01.637-.848z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(SignalSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 55940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0116.5 15z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(SparklesIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 23952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SpeakerWaveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM18.584 5.106a.75.75 0 011.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 11-1.06-1.06 8.25 8.25 0 000-11.668.75.75 0 010-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.932 7.757a.75.75 0 011.061 0 6 6 0 010 8.486.75.75 0 01-1.06-1.061 4.5 4.5 0 000-6.364.75.75 0 010-1.06z"
  }));
}

const ForwardRef = React.forwardRef(SpeakerWaveIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SpeakerXMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM17.78 9.22a.75.75 0 10-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 001.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 101.06-1.06L20.56 12l1.72-1.72a.75.75 0 00-1.06-1.06l-1.72 1.72-1.72-1.72z"
  }));
}

const ForwardRef = React.forwardRef(SpeakerXMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Square2StackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6a3 3 0 00-3-3H6a3 3 0 00-3 3v7.5a3 3 0 003 3v-6A4.5 4.5 0 0110.5 6h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5a3 3 0 013 3V18a3 3 0 01-3 3h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3H18z"
  }));
}

const ForwardRef = React.forwardRef(Square2StackIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 62476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Square3Stack3DIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.644 1.59a.75.75 0 01.712 0l9.75 5.25a.75.75 0 010 1.32l-9.75 5.25a.75.75 0 01-.712 0l-9.75-5.25a.75.75 0 010-1.32l9.75-5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.265 10.602l7.668 4.129a2.25 2.25 0 002.134 0l7.668-4.13 1.37.739a.75.75 0 010 1.32l-9.75 5.25a.75.75 0 01-.71 0l-9.75-5.25a.75.75 0 010-1.32l1.37-.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933 19.231l-7.668-4.13-1.37.739a.75.75 0 000 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 000-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 01-2.134-.001z"
  }));
}

const ForwardRef = React.forwardRef(Square3Stack3DIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 36521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function Squares2X2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(Squares2X2Icon);
module.exports = ForwardRef;

/***/ }),

/***/ 36823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SquaresPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v2.25a3 3 0 003 3h2.25a3 3 0 003-3V6a3 3 0 00-3-3H6zM15.75 3a3 3 0 00-3 3v2.25a3 3 0 003 3H18a3 3 0 003-3V6a3 3 0 00-3-3h-2.25zM6 12.75a3 3 0 00-3 3V18a3 3 0 003 3h2.25a3 3 0 003-3v-2.25a3 3 0 00-3-3H6zM17.625 13.5a.75.75 0 00-1.5 0v2.625H13.5a.75.75 0 000 1.5h2.625v2.625a.75.75 0 001.5 0v-2.625h2.625a.75.75 0 000-1.5h-2.625V13.5z"
  }));
}

const ForwardRef = React.forwardRef(SquaresPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 24977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(StarIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 96135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StopCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 01-1.313-1.313V9.564z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(StopCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 15849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function StopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 7.5a3 3 0 013-3h9a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(StopIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 31610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SunIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z"
  }));
}

const ForwardRef = React.forwardRef(SunIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function SwatchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 11-9 0V4.125zm4.5 14.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257zM12.738 17.625l6.474-6.474a1.875 1.875 0 000-2.651L15.5 4.787a1.875 1.875 0 00-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375z"
  }));
}

const ForwardRef = React.forwardRef(SwatchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TableCellsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 18.375V5.625zM21 9.375A.375.375 0 0020.625 9h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zM10.875 18.75a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5zM3.375 15h7.5a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375zm0-3.75h7.5a.375.375 0 00.375-.375v-1.5A.375.375 0 0010.875 9h-7.5A.375.375 0 003 9.375v1.5c0 .207.168.375.375.375z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TableCellsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2.25a3 3 0 00-3 3v4.318a3 3 0 00.879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 005.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 00-2.122-.879H5.25zM6.375 7.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TagIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 80882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TicketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TicketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 59283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TrashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TrophyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 00-.584.859 6.753 6.753 0 006.138 5.6 6.73 6.73 0 002.743 1.346A6.707 6.707 0 019.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 00-2.25 2.25c0 .414.336.75.75.75h15a.75.75 0 00.75-.75 2.25 2.25 0 00-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 01-1.112-3.173 6.73 6.73 0 002.743-1.347 6.753 6.753 0 006.139-5.6.75.75 0 00-.585-.858 47.077 47.077 0 00-3.07-.543V2.62a.75.75 0 00-.658-.744 49.22 49.22 0 00-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 00-.657.744zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 013.16 5.337a45.6 45.6 0 012.006-.343v.256zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 01-2.863 3.207 6.72 6.72 0 00.857-3.294z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TrophyIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 28243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TruckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 116 0h3a.75.75 0 00.75-.75V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM15.75 6.75a.75.75 0 00-.75.75v11.25c0 .087.015.17.042.248a3 3 0 015.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 00-3.732-10.104 1.837 1.837 0 00-1.47-.725H15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
  }));
}

const ForwardRef = React.forwardRef(TruckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 66619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function TvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6h-15v9h15V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v11.25C1.5 17.16 2.34 18 3.375 18H9.75v1.5H6A.75.75 0 006 21h12a.75.75 0 000-1.5h-3.75V18h6.375c1.035 0 1.875-.84 1.875-1.875V4.875C22.5 3.839 21.66 3 20.625 3H3.375zm0 13.5h17.25a.375.375 0 00.375-.375V4.875a.375.375 0 00-.375-.375H3.375A.375.375 0 003 4.875v11.25c0 .207.168.375.375.375z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(TvIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 63140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(UserCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 77674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z"
  }));
}

const ForwardRef = React.forwardRef(UserGroupIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 46658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(UserIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 76145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.375 2.25a4.125 4.125 0 100 8.25 4.125 4.125 0 000-8.25zM10.375 12a7.125 7.125 0 00-7.124 7.247.75.75 0 00.363.63 13.067 13.067 0 006.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 00.364-.63l.001-.12v-.002A7.125 7.125 0 0010.375 12zM16 9.75a.75.75 0 000 1.5h6a.75.75 0 000-1.5h-6z"
  }));
}

const ForwardRef = React.forwardRef(UserMinusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UserPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM3.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM19.75 7.5a.75.75 0 00-1.5 0v2.25H16a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H22a.75.75 0 000-1.5h-2.25V7.5z"
  }));
}

const ForwardRef = React.forwardRef(UserPlusIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function UsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z"
  }));
}

const ForwardRef = React.forwardRef(UsersIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 91407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VariableIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.253 2.292a.75.75 0 01.955.461A28.123 28.123 0 0121.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 11-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 01.461-.954zm-14.227.013a.75.75 0 01.414.976A23.183 23.183 0 003.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 01-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 01.976-.414zm4.275 5.052a1.5 1.5 0 012.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 012.978-.892l.213.09a.75.75 0 11-.584 1.381l-.214-.09a.937.937 0 00-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 11.786 1.278l-1.444.889a1.5 1.5 0 01-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 01-2.978.892l-.213-.09a.75.75 0 01.584-1.381l.214.09a.938.938 0 001.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 11-.786-1.278l1.444-.89z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(VariableIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 11147:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VideoCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5a3 3 0 00-3 3v9a3 3 0 003 3h8.25a3 3 0 003-3v-9a3 3 0 00-3-3H4.5zM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06z"
  }));
}

const ForwardRef = React.forwardRef(VideoCameraIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 53371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function VideoCameraSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.5 17.69c0 .471-.202.86-.504 1.124l-4.746-4.746V7.939l2.69-2.689c.944-.945 2.56-.276 2.56 1.06v11.38zM15.75 7.5v5.068L7.682 4.5h5.068a3 3 0 013 3zM1.5 7.5c0-.782.3-1.494.79-2.028l12.846 12.846A2.995 2.995 0 0112.75 19.5H4.5a3 3 0 01-3-3v-9z"
  }));
}

const ForwardRef = React.forwardRef(VideoCameraSlashIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 47798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ViewColumnsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75H9v16.5h6V3.75zM16.5 20.25h3.375c1.035 0 1.875-.84 1.875-1.875V5.625c0-1.036-.84-1.875-1.875-1.875H16.5v16.5zM4.125 3.75H7.5v16.5H4.125a1.875 1.875 0 01-1.875-1.875V5.625c0-1.036.84-1.875 1.875-1.875z"
  }));
}

const ForwardRef = React.forwardRef(ViewColumnsIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 92066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function ViewfinderCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v1.5a.75.75 0 001.5 0V6A1.5 1.5 0 016 4.5h1.5a.75.75 0 000-1.5H6zM16.5 3a.75.75 0 000 1.5H18A1.5 1.5 0 0119.5 6v1.5a.75.75 0 001.5 0V6a3 3 0 00-3-3h-1.5zM12 8.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM4.5 16.5a.75.75 0 00-1.5 0V18a3 3 0 003 3h1.5a.75.75 0 000-1.5H6A1.5 1.5 0 014.5 18v-1.5zM21 16.5a.75.75 0 00-1.5 0V18a1.5 1.5 0 01-1.5 1.5h-1.5a.75.75 0 000 1.5H18a3 3 0 003-3v-1.5z"
  }));
}

const ForwardRef = React.forwardRef(ViewfinderCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 87012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.273 5.625A4.483 4.483 0 015.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0018.75 3H5.25a3 3 0 00-2.977 2.625zM2.273 8.625A4.483 4.483 0 015.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0018.75 6H5.25a3 3 0 00-2.977 2.625zM5.25 9a3 3 0 00-3 3v6a3 3 0 003 3h13.5a3 3 0 003-3v-6a3 3 0 00-3-3H15a.75.75 0 00-.75.75 2.25 2.25 0 01-4.5 0A.75.75 0 009 9H5.25z"
  }));
}

const ForwardRef = React.forwardRef(WalletIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WifiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(WifiIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 10558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WindowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 6a3 3 0 013-3h13.5a3 3 0 013 3v12a3 3 0 01-3 3H5.25a3 3 0 01-3-3V6zm18 3H3.75v9a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V9zm-15-3.75A.75.75 0 004.5 6v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75H5.25zm1.5.75a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H7.5a.75.75 0 01-.75-.75V6zm3-.75A.75.75 0 009 6v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V6a.75.75 0 00-.75-.75H9.75z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(WindowIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 85183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WrenchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.75a5.25 5.25 0 016.775-5.025.75.75 0 01.313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 011.248.313 5.25 5.25 0 01-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 112.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0112 6.75zM4.117 19.125a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(WrenchIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 7747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function WrenchScrewdriverIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.75a5.25 5.25 0 016.775-5.025.75.75 0 01.313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 011.248.313 5.25 5.25 0 01-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 112.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0112 6.75zM4.117 19.125a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.076 8.64l-2.201-2.2V4.874a.75.75 0 00-.364-.643l-3.75-2.25a.75.75 0 00-.916.113l-.75.75a.75.75 0 00-.113.916l2.25 3.75a.75.75 0 00.643.364h1.564l2.062 2.062 1.575-1.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.556 17.329l4.183 4.182a3.375 3.375 0 004.773-4.773l-3.306-3.305a6.803 6.803 0 01-1.53.043c-.394-.034-.682-.006-.867.042a.589.589 0 00-.167.063l-3.086 3.748zm3.414-1.36a.75.75 0 011.06 0l1.875 1.876a.75.75 0 11-1.06 1.06L15.97 17.03a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(WrenchScrewdriverIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function XCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(XCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);

function XMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(XMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 53752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports.AcademicCapIcon = __webpack_require__(22363)
module.exports.AdjustmentsHorizontalIcon = __webpack_require__(11918)
module.exports.AdjustmentsVerticalIcon = __webpack_require__(9617)
module.exports.ArchiveBoxArrowDownIcon = __webpack_require__(15081)
module.exports.ArchiveBoxXMarkIcon = __webpack_require__(8596)
module.exports.ArchiveBoxIcon = __webpack_require__(46004)
module.exports.ArrowDownCircleIcon = __webpack_require__(73818)
module.exports.ArrowDownLeftIcon = __webpack_require__(95882)
module.exports.ArrowDownOnSquareStackIcon = __webpack_require__(25061)
module.exports.ArrowDownOnSquareIcon = __webpack_require__(91128)
module.exports.ArrowDownRightIcon = __webpack_require__(53048)
module.exports.ArrowDownTrayIcon = __webpack_require__(21881)
module.exports.ArrowDownIcon = __webpack_require__(91525)
module.exports.ArrowLeftCircleIcon = __webpack_require__(60311)
module.exports.ArrowLeftOnRectangleIcon = __webpack_require__(15821)
module.exports.ArrowLeftIcon = __webpack_require__(1889)
module.exports.ArrowLongDownIcon = __webpack_require__(96644)
module.exports.ArrowLongLeftIcon = __webpack_require__(36950)
module.exports.ArrowLongRightIcon = __webpack_require__(97229)
module.exports.ArrowLongUpIcon = __webpack_require__(64446)
module.exports.ArrowPathRoundedSquareIcon = __webpack_require__(14336)
module.exports.ArrowPathIcon = __webpack_require__(51965)
module.exports.ArrowRightCircleIcon = __webpack_require__(5866)
module.exports.ArrowRightOnRectangleIcon = __webpack_require__(80087)
module.exports.ArrowRightIcon = __webpack_require__(58545)
module.exports.ArrowSmallDownIcon = __webpack_require__(19935)
module.exports.ArrowSmallLeftIcon = __webpack_require__(58714)
module.exports.ArrowSmallRightIcon = __webpack_require__(93835)
module.exports.ArrowSmallUpIcon = __webpack_require__(89007)
module.exports.ArrowTopRightOnSquareIcon = __webpack_require__(32446)
module.exports.ArrowTrendingDownIcon = __webpack_require__(64401)
module.exports.ArrowTrendingUpIcon = __webpack_require__(36837)
module.exports.ArrowUpCircleIcon = __webpack_require__(59957)
module.exports.ArrowUpLeftIcon = __webpack_require__(39467)
module.exports.ArrowUpOnSquareStackIcon = __webpack_require__(25803)
module.exports.ArrowUpOnSquareIcon = __webpack_require__(13448)
module.exports.ArrowUpRightIcon = __webpack_require__(51416)
module.exports.ArrowUpTrayIcon = __webpack_require__(93184)
module.exports.ArrowUpIcon = __webpack_require__(72666)
module.exports.ArrowUturnDownIcon = __webpack_require__(76108)
module.exports.ArrowUturnLeftIcon = __webpack_require__(32654)
module.exports.ArrowUturnRightIcon = __webpack_require__(12410)
module.exports.ArrowUturnUpIcon = __webpack_require__(40057)
module.exports.ArrowsPointingInIcon = __webpack_require__(44746)
module.exports.ArrowsPointingOutIcon = __webpack_require__(97742)
module.exports.ArrowsRightLeftIcon = __webpack_require__(28803)
module.exports.ArrowsUpDownIcon = __webpack_require__(78013)
module.exports.AtSymbolIcon = __webpack_require__(41317)
module.exports.BackspaceIcon = __webpack_require__(46216)
module.exports.BackwardIcon = __webpack_require__(30568)
module.exports.BanknotesIcon = __webpack_require__(93571)
module.exports.Bars2Icon = __webpack_require__(1229)
module.exports.Bars3BottomLeftIcon = __webpack_require__(74868)
module.exports.Bars3BottomRightIcon = __webpack_require__(57056)
module.exports.Bars3CenterLeftIcon = __webpack_require__(20208)
module.exports.Bars3Icon = __webpack_require__(76677)
module.exports.Bars4Icon = __webpack_require__(9760)
module.exports.BarsArrowDownIcon = __webpack_require__(88707)
module.exports.BarsArrowUpIcon = __webpack_require__(66501)
module.exports.Battery0Icon = __webpack_require__(41242)
module.exports.Battery100Icon = __webpack_require__(52255)
module.exports.Battery50Icon = __webpack_require__(16304)
module.exports.BeakerIcon = __webpack_require__(56644)
module.exports.BellAlertIcon = __webpack_require__(22546)
module.exports.BellSlashIcon = __webpack_require__(77845)
module.exports.BellSnoozeIcon = __webpack_require__(17050)
module.exports.BellIcon = __webpack_require__(50794)
module.exports.BoltSlashIcon = __webpack_require__(22153)
module.exports.BoltIcon = __webpack_require__(5663)
module.exports.BookOpenIcon = __webpack_require__(48805)
module.exports.BookmarkSlashIcon = __webpack_require__(52716)
module.exports.BookmarkSquareIcon = __webpack_require__(79508)
module.exports.BookmarkIcon = __webpack_require__(20174)
module.exports.BriefcaseIcon = __webpack_require__(40995)
module.exports.BugAntIcon = __webpack_require__(48878)
module.exports.BuildingLibraryIcon = __webpack_require__(76492)
module.exports.BuildingOffice2Icon = __webpack_require__(75161)
module.exports.BuildingOfficeIcon = __webpack_require__(93549)
module.exports.BuildingStorefrontIcon = __webpack_require__(22884)
module.exports.CakeIcon = __webpack_require__(81738)
module.exports.CalculatorIcon = __webpack_require__(61790)
module.exports.CalendarDaysIcon = __webpack_require__(4490)
module.exports.CalendarIcon = __webpack_require__(57969)
module.exports.CameraIcon = __webpack_require__(82738)
module.exports.ChartBarSquareIcon = __webpack_require__(8057)
module.exports.ChartBarIcon = __webpack_require__(4764)
module.exports.ChartPieIcon = __webpack_require__(92344)
module.exports.ChatBubbleBottomCenterTextIcon = __webpack_require__(91574)
module.exports.ChatBubbleBottomCenterIcon = __webpack_require__(88630)
module.exports.ChatBubbleLeftEllipsisIcon = __webpack_require__(75303)
module.exports.ChatBubbleLeftRightIcon = __webpack_require__(37129)
module.exports.ChatBubbleLeftIcon = __webpack_require__(31617)
module.exports.ChatBubbleOvalLeftEllipsisIcon = __webpack_require__(91813)
module.exports.ChatBubbleOvalLeftIcon = __webpack_require__(51380)
module.exports.CheckBadgeIcon = __webpack_require__(24434)
module.exports.CheckCircleIcon = __webpack_require__(76294)
module.exports.CheckIcon = __webpack_require__(47556)
module.exports.ChevronDoubleDownIcon = __webpack_require__(5547)
module.exports.ChevronDoubleLeftIcon = __webpack_require__(699)
module.exports.ChevronDoubleRightIcon = __webpack_require__(17248)
module.exports.ChevronDoubleUpIcon = __webpack_require__(45368)
module.exports.ChevronDownIcon = __webpack_require__(71230)
module.exports.ChevronLeftIcon = __webpack_require__(454)
module.exports.ChevronRightIcon = __webpack_require__(63167)
module.exports.ChevronUpDownIcon = __webpack_require__(51184)
module.exports.ChevronUpIcon = __webpack_require__(22417)
module.exports.CircleStackIcon = __webpack_require__(70726)
module.exports.ClipboardDocumentCheckIcon = __webpack_require__(76322)
module.exports.ClipboardDocumentListIcon = __webpack_require__(12058)
module.exports.ClipboardDocumentIcon = __webpack_require__(21267)
module.exports.ClipboardIcon = __webpack_require__(87937)
module.exports.ClockIcon = __webpack_require__(98827)
module.exports.CloudArrowDownIcon = __webpack_require__(38055)
module.exports.CloudArrowUpIcon = __webpack_require__(49991)
module.exports.CloudIcon = __webpack_require__(52457)
module.exports.CodeBracketSquareIcon = __webpack_require__(82850)
module.exports.CodeBracketIcon = __webpack_require__(40507)
module.exports.Cog6ToothIcon = __webpack_require__(82651)
module.exports.Cog8ToothIcon = __webpack_require__(5942)
module.exports.CogIcon = __webpack_require__(75589)
module.exports.CommandLineIcon = __webpack_require__(39491)
module.exports.ComputerDesktopIcon = __webpack_require__(93314)
module.exports.CpuChipIcon = __webpack_require__(87898)
module.exports.CreditCardIcon = __webpack_require__(41442)
module.exports.CubeTransparentIcon = __webpack_require__(85863)
module.exports.CubeIcon = __webpack_require__(48175)
module.exports.CurrencyBangladeshiIcon = __webpack_require__(93680)
module.exports.CurrencyDollarIcon = __webpack_require__(90238)
module.exports.CurrencyEuroIcon = __webpack_require__(72958)
module.exports.CurrencyPoundIcon = __webpack_require__(55714)
module.exports.CurrencyRupeeIcon = __webpack_require__(79040)
module.exports.CurrencyYenIcon = __webpack_require__(69025)
module.exports.CursorArrowRaysIcon = __webpack_require__(60218)
module.exports.CursorArrowRippleIcon = __webpack_require__(22893)
module.exports.DevicePhoneMobileIcon = __webpack_require__(86064)
module.exports.DeviceTabletIcon = __webpack_require__(68802)
module.exports.DocumentArrowDownIcon = __webpack_require__(36416)
module.exports.DocumentArrowUpIcon = __webpack_require__(4848)
module.exports.DocumentChartBarIcon = __webpack_require__(5818)
module.exports.DocumentCheckIcon = __webpack_require__(69332)
module.exports.DocumentDuplicateIcon = __webpack_require__(98234)
module.exports.DocumentMagnifyingGlassIcon = __webpack_require__(12894)
module.exports.DocumentMinusIcon = __webpack_require__(42034)
module.exports.DocumentPlusIcon = __webpack_require__(46550)
module.exports.DocumentTextIcon = __webpack_require__(37425)
module.exports.DocumentIcon = __webpack_require__(46311)
module.exports.EllipsisHorizontalCircleIcon = __webpack_require__(62823)
module.exports.EllipsisHorizontalIcon = __webpack_require__(14267)
module.exports.EllipsisVerticalIcon = __webpack_require__(99814)
module.exports.EnvelopeOpenIcon = __webpack_require__(56452)
module.exports.EnvelopeIcon = __webpack_require__(26314)
module.exports.ExclamationCircleIcon = __webpack_require__(6970)
module.exports.ExclamationTriangleIcon = __webpack_require__(51806)
module.exports.EyeDropperIcon = __webpack_require__(97589)
module.exports.EyeSlashIcon = __webpack_require__(85120)
module.exports.EyeIcon = __webpack_require__(80070)
module.exports.FaceFrownIcon = __webpack_require__(32771)
module.exports.FaceSmileIcon = __webpack_require__(73374)
module.exports.FilmIcon = __webpack_require__(63351)
module.exports.FingerPrintIcon = __webpack_require__(92855)
module.exports.FireIcon = __webpack_require__(29518)
module.exports.FlagIcon = __webpack_require__(61354)
module.exports.FolderArrowDownIcon = __webpack_require__(44898)
module.exports.FolderMinusIcon = __webpack_require__(40517)
module.exports.FolderOpenIcon = __webpack_require__(41198)
module.exports.FolderPlusIcon = __webpack_require__(12556)
module.exports.FolderIcon = __webpack_require__(49988)
module.exports.ForwardIcon = __webpack_require__(1358)
module.exports.FunnelIcon = __webpack_require__(52064)
module.exports.GifIcon = __webpack_require__(27168)
module.exports.GiftTopIcon = __webpack_require__(77326)
module.exports.GiftIcon = __webpack_require__(78326)
module.exports.GlobeAltIcon = __webpack_require__(3769)
module.exports.GlobeAmericasIcon = __webpack_require__(91180)
module.exports.GlobeAsiaAustraliaIcon = __webpack_require__(7321)
module.exports.GlobeEuropeAfricaIcon = __webpack_require__(27233)
module.exports.HandRaisedIcon = __webpack_require__(63125)
module.exports.HandThumbDownIcon = __webpack_require__(11761)
module.exports.HandThumbUpIcon = __webpack_require__(19113)
module.exports.HashtagIcon = __webpack_require__(46345)
module.exports.HeartIcon = __webpack_require__(31718)
module.exports.HomeModernIcon = __webpack_require__(22049)
module.exports.HomeIcon = __webpack_require__(52283)
module.exports.IdentificationIcon = __webpack_require__(40856)
module.exports.InboxArrowDownIcon = __webpack_require__(26515)
module.exports.InboxStackIcon = __webpack_require__(15734)
module.exports.InboxIcon = __webpack_require__(72156)
module.exports.InformationCircleIcon = __webpack_require__(63448)
module.exports.KeyIcon = __webpack_require__(72205)
module.exports.LanguageIcon = __webpack_require__(73701)
module.exports.LifebuoyIcon = __webpack_require__(1656)
module.exports.LightBulbIcon = __webpack_require__(5489)
module.exports.LinkIcon = __webpack_require__(95823)
module.exports.ListBulletIcon = __webpack_require__(19705)
module.exports.LockClosedIcon = __webpack_require__(44523)
module.exports.LockOpenIcon = __webpack_require__(48625)
module.exports.MagnifyingGlassCircleIcon = __webpack_require__(20178)
module.exports.MagnifyingGlassMinusIcon = __webpack_require__(11051)
module.exports.MagnifyingGlassPlusIcon = __webpack_require__(25202)
module.exports.MagnifyingGlassIcon = __webpack_require__(77664)
module.exports.MapPinIcon = __webpack_require__(55019)
module.exports.MapIcon = __webpack_require__(80149)
module.exports.MegaphoneIcon = __webpack_require__(854)
module.exports.MicrophoneIcon = __webpack_require__(98441)
module.exports.MinusCircleIcon = __webpack_require__(788)
module.exports.MinusSmallIcon = __webpack_require__(47151)
module.exports.MinusIcon = __webpack_require__(64283)
module.exports.MoonIcon = __webpack_require__(43598)
module.exports.MusicalNoteIcon = __webpack_require__(60129)
module.exports.NewspaperIcon = __webpack_require__(69970)
module.exports.NoSymbolIcon = __webpack_require__(64290)
module.exports.PaintBrushIcon = __webpack_require__(19367)
module.exports.PaperAirplaneIcon = __webpack_require__(55934)
module.exports.PaperClipIcon = __webpack_require__(94875)
module.exports.PauseCircleIcon = __webpack_require__(34127)
module.exports.PauseIcon = __webpack_require__(36310)
module.exports.PencilSquareIcon = __webpack_require__(85351)
module.exports.PencilIcon = __webpack_require__(41565)
module.exports.PhoneArrowDownLeftIcon = __webpack_require__(12123)
module.exports.PhoneArrowUpRightIcon = __webpack_require__(619)
module.exports.PhoneXMarkIcon = __webpack_require__(55073)
module.exports.PhoneIcon = __webpack_require__(34599)
module.exports.PhotoIcon = __webpack_require__(56869)
module.exports.PlayCircleIcon = __webpack_require__(89090)
module.exports.PlayPauseIcon = __webpack_require__(10664)
module.exports.PlayIcon = __webpack_require__(82329)
module.exports.PlusCircleIcon = __webpack_require__(17191)
module.exports.PlusSmallIcon = __webpack_require__(55672)
module.exports.PlusIcon = __webpack_require__(38779)
module.exports.PowerIcon = __webpack_require__(57675)
module.exports.PresentationChartBarIcon = __webpack_require__(81320)
module.exports.PresentationChartLineIcon = __webpack_require__(92231)
module.exports.PrinterIcon = __webpack_require__(70928)
module.exports.PuzzlePieceIcon = __webpack_require__(5122)
module.exports.QrCodeIcon = __webpack_require__(33533)
module.exports.QuestionMarkCircleIcon = __webpack_require__(87091)
module.exports.QueueListIcon = __webpack_require__(97152)
module.exports.RadioIcon = __webpack_require__(69706)
module.exports.ReceiptPercentIcon = __webpack_require__(23968)
module.exports.ReceiptRefundIcon = __webpack_require__(54096)
module.exports.RectangleGroupIcon = __webpack_require__(3006)
module.exports.RectangleStackIcon = __webpack_require__(954)
module.exports.RocketLaunchIcon = __webpack_require__(47506)
module.exports.RssIcon = __webpack_require__(4676)
module.exports.ScaleIcon = __webpack_require__(64862)
module.exports.ScissorsIcon = __webpack_require__(18049)
module.exports.ServerStackIcon = __webpack_require__(81020)
module.exports.ServerIcon = __webpack_require__(42313)
module.exports.ShareIcon = __webpack_require__(18239)
module.exports.ShieldCheckIcon = __webpack_require__(18656)
module.exports.ShieldExclamationIcon = __webpack_require__(5027)
module.exports.ShoppingBagIcon = __webpack_require__(86030)
module.exports.ShoppingCartIcon = __webpack_require__(98946)
module.exports.SignalSlashIcon = __webpack_require__(39308)
module.exports.SignalIcon = __webpack_require__(67223)
module.exports.SparklesIcon = __webpack_require__(55940)
module.exports.SpeakerWaveIcon = __webpack_require__(23952)
module.exports.SpeakerXMarkIcon = __webpack_require__(46590)
module.exports.Square2StackIcon = __webpack_require__(56266)
module.exports.Square3Stack3DIcon = __webpack_require__(62476)
module.exports.Squares2X2Icon = __webpack_require__(36521)
module.exports.SquaresPlusIcon = __webpack_require__(36823)
module.exports.StarIcon = __webpack_require__(24977)
module.exports.StopCircleIcon = __webpack_require__(96135)
module.exports.StopIcon = __webpack_require__(15849)
module.exports.SunIcon = __webpack_require__(31610)
module.exports.SwatchIcon = __webpack_require__(47414)
module.exports.TableCellsIcon = __webpack_require__(54651)
module.exports.TagIcon = __webpack_require__(85111)
module.exports.TicketIcon = __webpack_require__(80882)
module.exports.TrashIcon = __webpack_require__(59283)
module.exports.TrophyIcon = __webpack_require__(94673)
module.exports.TruckIcon = __webpack_require__(28243)
module.exports.TvIcon = __webpack_require__(66619)
module.exports.UserCircleIcon = __webpack_require__(63140)
module.exports.UserGroupIcon = __webpack_require__(77674)
module.exports.UserMinusIcon = __webpack_require__(76145)
module.exports.UserPlusIcon = __webpack_require__(323)
module.exports.UserIcon = __webpack_require__(46658)
module.exports.UsersIcon = __webpack_require__(30330)
module.exports.VariableIcon = __webpack_require__(91407)
module.exports.VideoCameraSlashIcon = __webpack_require__(53371)
module.exports.VideoCameraIcon = __webpack_require__(11147)
module.exports.ViewColumnsIcon = __webpack_require__(47798)
module.exports.ViewfinderCircleIcon = __webpack_require__(92066)
module.exports.WalletIcon = __webpack_require__(87012)
module.exports.WifiIcon = __webpack_require__(4187)
module.exports.WindowIcon = __webpack_require__(10558)
module.exports.WrenchScrewdriverIcon = __webpack_require__(7747)
module.exports.WrenchIcon = __webpack_require__(85183)
module.exports.XCircleIcon = __webpack_require__(56448)
module.exports.XMarkIcon = __webpack_require__(5899)

/***/ }),

/***/ 44959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* MIT license */
/* eslint-disable no-mixed-operators */
const cssKeywords = __webpack_require__(11103);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
	reverseKeywords[cssKeywords[key]] = key;
}

const convert = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

module.exports = convert;

// Hide .channels and .labels properties
for (const model of Object.keys(convert)) {
	if (!('channels' in convert[model])) {
		throw new Error('missing channels property: ' + model);
	}

	if (!('labels' in convert[model])) {
		throw new Error('missing channel labels property: ' + model);
	}

	if (convert[model].labels.length !== convert[model].channels) {
		throw new Error('channel and label counts mismatch: ' + model);
	}

	const {channels, labels} = convert[model];
	delete convert[model].channels;
	delete convert[model].labels;
	Object.defineProperty(convert[model], 'channels', {value: channels});
	Object.defineProperty(convert[model], 'labels', {value: labels});
}

convert.rgb.hsl = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const min = Math.min(r, g, b);
	const max = Math.max(r, g, b);
	const delta = max - min;
	let h;
	let s;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	const l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	let rdif;
	let gdif;
	let bdif;
	let h;
	let s;

	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const v = Math.max(r, g, b);
	const diff = v - Math.min(r, g, b);
	const diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = 0;
		s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}

		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	const r = rgb[0];
	const g = rgb[1];
	let b = rgb[2];
	const h = convert.rgb.hsl(rgb)[0];
	const w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;

	const k = Math.min(1 - r, 1 - g, 1 - b);
	const c = (1 - r - k) / (1 - k) || 0;
	const m = (1 - g - k) / (1 - k) || 0;
	const y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

function comparativeDistance(x, y) {
	/*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/
	return (
		((x[0] - y[0]) ** 2) +
		((x[1] - y[1]) ** 2) +
		((x[2] - y[2]) ** 2)
	);
}

convert.rgb.keyword = function (rgb) {
	const reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	let currentClosestDistance = Infinity;
	let currentClosestKeyword;

	for (const keyword of Object.keys(cssKeywords)) {
		const value = cssKeywords[keyword];

		// Compute comparative distance
		const distance = comparativeDistance(rgb, value);

		// Check if its less, if so set as closest
		if (distance < currentClosestDistance) {
			currentClosestDistance = distance;
			currentClosestKeyword = keyword;
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	let r = rgb[0] / 255;
	let g = rgb[1] / 255;
	let b = rgb[2] / 255;

	// Assume sRGB
	r = r > 0.04045 ? (((r + 0.055) / 1.055) ** 2.4) : (r / 12.92);
	g = g > 0.04045 ? (((g + 0.055) / 1.055) ** 2.4) : (g / 12.92);
	b = b > 0.04045 ? (((b + 0.055) / 1.055) ** 2.4) : (b / 12.92);

	const x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	const y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	const z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	const xyz = convert.rgb.xyz(rgb);
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	const h = hsl[0] / 360;
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;
	let t2;
	let t3;
	let val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	const t1 = 2 * l - t2;

	const rgb = [0, 0, 0];
	for (let i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}

		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	const h = hsl[0];
	let s = hsl[1] / 100;
	let l = hsl[2] / 100;
	let smin = s;
	const lmin = Math.max(l, 0.01);

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	const v = (l + s) / 2;
	const sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	const h = hsv[0] / 60;
	const s = hsv[1] / 100;
	let v = hsv[2] / 100;
	const hi = Math.floor(h) % 6;

	const f = h - Math.floor(h);
	const p = 255 * v * (1 - s);
	const q = 255 * v * (1 - (s * f));
	const t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	const h = hsv[0];
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;
	const vmin = Math.max(v, 0.01);
	let sl;
	let l;

	l = (2 - s) * v;
	const lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	const h = hwb[0] / 360;
	let wh = hwb[1] / 100;
	let bl = hwb[2] / 100;
	const ratio = wh + bl;
	let f;

	// Wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	const i = Math.floor(6 * h);
	const v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	const n = wh + f * (v - wh); // Linear interpolation

	let r;
	let g;
	let b;
	/* eslint-disable max-statements-per-line,no-multi-spaces */
	switch (i) {
		default:
		case 6:
		case 0: r = v;  g = n;  b = wh; break;
		case 1: r = n;  g = v;  b = wh; break;
		case 2: r = wh; g = v;  b = n; break;
		case 3: r = wh; g = n;  b = v; break;
		case 4: r = n;  g = wh; b = v; break;
		case 5: r = v;  g = wh; b = n; break;
	}
	/* eslint-enable max-statements-per-line,no-multi-spaces */

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	const c = cmyk[0] / 100;
	const m = cmyk[1] / 100;
	const y = cmyk[2] / 100;
	const k = cmyk[3] / 100;

	const r = 1 - Math.min(1, c * (1 - k) + k);
	const g = 1 - Math.min(1, m * (1 - k) + k);
	const b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	const x = xyz[0] / 100;
	const y = xyz[1] / 100;
	const z = xyz[2] / 100;
	let r;
	let g;
	let b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// Assume sRGB
	r = r > 0.0031308
		? ((1.055 * (r ** (1.0 / 2.4))) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * (g ** (1.0 / 2.4))) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * (b ** (1.0 / 2.4))) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let x;
	let y;
	let z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	const y2 = y ** 3;
	const x2 = x ** 3;
	const z2 = z ** 3;
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let h;

	const hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	const c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	const l = lch[0];
	const c = lch[1];
	const h = lch[2];

	const hr = h / 360 * 2 * Math.PI;
	const a = c * Math.cos(hr);
	const b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args, saturation = null) {
	const [r, g, b] = args;
	let value = saturation === null ? convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	let ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// Optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	const r = args[0];
	const g = args[1];
	const b = args[2];

	// We use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	const ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	let color = args % 10;

	// Handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	const mult = (~~(args > 50) + 1) * 0.5;
	const r = ((color & 1) * mult) * 255;
	const g = (((color >> 1) & 1) * mult) * 255;
	const b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// Handle greyscale
	if (args >= 232) {
		const c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	let rem;
	const r = Math.floor(args / 36) / 5 * 255;
	const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	const b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	const integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	let colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(char => {
			return char + char;
		}).join('');
	}

	const integer = parseInt(colorString, 16);
	const r = (integer >> 16) & 0xFF;
	const g = (integer >> 8) & 0xFF;
	const b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const max = Math.max(Math.max(r, g), b);
	const min = Math.min(Math.min(r, g), b);
	const chroma = (max - min);
	let grayscale;
	let hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;

	const c = l < 0.5 ? (2.0 * s * l) : (2.0 * s * (1.0 - l));

	let f = 0;
	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;

	const c = s * v;
	let f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	const h = hcg[0] / 360;
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	const pure = [0, 0, 0];
	const hi = (h % 1) * 6;
	const v = hi % 1;
	const w = 1 - v;
	let mg = 0;

	/* eslint-disable max-statements-per-line */
	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}
	/* eslint-enable max-statements-per-line */

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const v = c + g * (1.0 - c);
	let f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const l = g * (1.0 - c) + 0.5 * c;
	let s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;
	const v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	const w = hwb[1] / 100;
	const b = hwb[2] / 100;
	const v = 1 - b;
	const c = v - w;
	let g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hsv = convert.gray.hsl;

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	const val = Math.round(gray[0] / 100 * 255) & 0xFF;
	const integer = (val << 16) + (val << 8) + val;

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),

/***/ 50841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const conversions = __webpack_require__(44959);
const route = __webpack_require__(19325);

const convert = {};

const models = Object.keys(conversions);

function wrapRaw(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];
		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		return fn(args);
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];

		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		const result = fn(args);

		// We're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (let len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(fromModel => {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	const routes = route(fromModel);
	const routeModels = Object.keys(routes);

	routeModels.forEach(toModel => {
		const fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),

/***/ 19325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const conversions = __webpack_require__(44959);

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	const graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	const models = Object.keys(conversions);

	for (let len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	const graph = buildGraph();
	const queue = [fromModel]; // Unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		const current = queue.pop();
		const adjacents = Object.keys(conversions[current]);

		for (let len = adjacents.length, i = 0; i < len; i++) {
			const adjacent = adjacents[i];
			const node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	const path = [graph[toModel].parent, toModel];
	let fn = conversions[graph[toModel].parent][toModel];

	let cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	const graph = deriveBFS(fromModel);
	const conversion = {};

	const models = Object.keys(graph);
	for (let len = models.length, i = 0; i < len; i++) {
		const toModel = models[i];
		const node = graph[toModel];

		if (node.parent === null) {
			// No possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),

/***/ 11103:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(73887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 43459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 73887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43459);
} else {}


/***/ }),

/***/ 52170:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(68438);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52219:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) {} else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 81088:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(4000);
var _formatUrl = __webpack_require__(34588);
var _addLocale = __webpack_require__(37003);
var _routerContext = __webpack_require__(67858);
var _appRouterContext = __webpack_require__(77826);
var _useIntersection = __webpack_require__(8599);
var _getDomainLocale = __webpack_require__(52219);
var _addBasePath = __webpack_require__(92484);
const prefetched = new Set();
function prefetch(router, href, as, options) {
    if (false) {}
    if (!(0, _router).isLocalURL(href)) {
        return;
    }
    // We should only dedupe requests when experimental.optimisticClientCache is
    // disabled.
    if (!options.bypassPrefetchedCheck) {
        const locale = typeof options.locale !== "undefined" ? options.locale : "locale" in router ? router.locale : undefined;
        const prefetchedKey = href + "%" + as + "%" + locale;
        // If we've already fetched the key, then don't prefetch it again!
        if (prefetched.has(prefetchedKey)) {
            return;
        }
        // Mark this URL as prefetched.
        prefetched.add(prefetchedKey);
    }
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            router[replace ? "replace" : "push"](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
function formatStringOrUrl(urlObjOrString) {
    if (typeof urlObjOrString === "string") {
        return urlObjOrString;
    }
    return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter: onMouseEnterProp , onTouchStart: onTouchStartProp , legacyBehavior =true === false  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const prefetchEnabled = prefetchProp !== false;
    const pagesRouter = _react.default.useContext(_routerContext.RouterContext);
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    const router = pagesRouter != null ? pagesRouter : appRouter;
    // We're in the app directory if there is no pages router.
    const isAppRouter = !pagesRouter;
    if (false) {}
    const { href: href1 , as  } = _react.default.useMemo(()=>{
        if (!pagesRouter) {
            const resolvedHref = formatStringOrUrl(hrefProp);
            return {
                href: resolvedHref,
                as: asProp ? formatStringOrUrl(asProp) : resolvedHref
            };
        }
        const [resolvedHref1, resolvedAs] = (0, _router).resolveHref(pagesRouter, hrefProp, true);
        return {
            href: resolvedHref1,
            as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref1
        };
    }, [
        pagesRouter,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href1);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href1) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href1;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href1,
        resetVisible,
        setIntersectionRef
    ]);
    // Prefetch the URL if we haven't already and it's visible.
    _react.default.useEffect(()=>{
        if (!router) {
            return;
        }
        // If we don't need to prefetch the URL, don't do prefetch.
        if (!isVisible || !prefetchEnabled) {
            return;
        }
        // Prefetch the URL.
        prefetch(router, href1, as, {
            locale
        });
    }, [
        as,
        href1,
        isVisible,
        locale,
        prefetchEnabled,
        pagesRouter == null ? void 0 : pagesRouter.locale,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick (e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!router) {
                return;
            }
            if (e.defaultPrevented) {
                return;
            }
            linkClicked(e, router, href1, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
        },
        onMouseEnter (e) {
            if (!legacyBehavior && typeof onMouseEnterProp === "function") {
                onMouseEnterProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href1, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        },
        onTouchStart (e) {
            if (!legacyBehavior && typeof onTouchStartProp === "function") {
                onTouchStartProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href1, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : pagesRouter == null ? void 0 : pagesRouter.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 8599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(11424);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 68438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96656);
/* harmony import */ var _styles_globals_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _wazoe_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22976);



function MyApp(param) {
    let { Component , pageProps  } = param;
    var _pageProps_site, _pageProps_site_defaultLanguage, _pageProps_site1, _pageProps_site2, _pageProps_site3, _pageProps_site4, _pageProps_pageData, _pageProps_locale, _pageProps_locale1, _pageProps_pageData1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wazoe_elements__WEBPACK_IMPORTED_MODULE_2__/* .EditorProvider */ .KU, {
        initMode: "production",
        backendApi: pageProps.backendApiUrl,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wazoe_elements__WEBPACK_IMPORTED_MODULE_2__/* .SiteProvider */ .qJ, {
            initLocale: pageProps === null || pageProps === void 0 ? void 0 : pageProps.locale,
            defaultLocale: (_pageProps_site = pageProps.site) === null || _pageProps_site === void 0 ? void 0 : (_pageProps_site_defaultLanguage = _pageProps_site.defaultLanguage) === null || _pageProps_site_defaultLanguage === void 0 ? void 0 : _pageProps_site_defaultLanguage.code,
            pages: pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_site1 = pageProps.site) === null || _pageProps_site1 === void 0 ? void 0 : _pageProps_site1.pages,
            forms: pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_site2 = pageProps.site) === null || _pageProps_site2 === void 0 ? void 0 : _pageProps_site2.forms,
            menus: pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_site3 = pageProps.site) === null || _pageProps_site3 === void 0 ? void 0 : _pageProps_site3.menus,
            languages: pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_site4 = pageProps.site) === null || _pageProps_site4 === void 0 ? void 0 : _pageProps_site4.languages,
            activePage: (pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_pageData = pageProps.pageData) === null || _pageProps_pageData === void 0 ? void 0 : _pageProps_pageData.path) === "/" ? "/".concat(pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_locale = pageProps.locale) === null || _pageProps_locale === void 0 ? void 0 : _pageProps_locale.toLowerCase()) : "/".concat(pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_locale1 = pageProps.locale) === null || _pageProps_locale1 === void 0 ? void 0 : _pageProps_locale1.toLowerCase()).concat(pageProps === null || pageProps === void 0 ? void 0 : (_pageProps_pageData1 = pageProps.pageData) === null || _pageProps_pageData1 === void 0 ? void 0 : _pageProps_pageData1.path),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...pageProps
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (MyApp);


/***/ }),

/***/ 96656:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(81088)


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 58970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var react_1 = __webpack_require__(2784);
/**
 * Determines if the given param is an object. {}
 * @param obj
 */
__webpack_unused_export__ = function (obj) { return Object.prototype.toString.call(obj) === '[object Object]'; }; // eslint-disable-line
var useMounted = function () {
    var mounted = react_1.useRef(false);
    react_1.useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    return mounted;
};
function useRefState(initialState, blockIfUnmounted) {
    if (blockIfUnmounted === void 0) { blockIfUnmounted = true; }
    var mounted = useMounted();
    var _a = react_1.useState(initialState), reactState = _a[0], setReactState = _a[1];
    var state = react_1.useRef(reactState);
    var setState = react_1.useCallback(function (arg) {
        if (!mounted.current && blockIfUnmounted)
            return;
        state.current = (typeof arg === 'function') ? arg(state.current) : arg;
        setReactState(state.current);
    }, []);
    return [state, setState];
}
__webpack_unused_export__ = useRefState;
exports.ZP = useRefState;


/***/ }),

/***/ 31137:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Device;
(function (Device) {
    Device["Browser"] = "browser";
    Device["Server"] = "server";
    Device["Native"] = "native";
})(Device = exports.Device || (exports.Device = {}));
var Browser = Device.Browser, Server = Device.Server, Native = Device.Native;
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
var canUseNative = typeof navigator != 'undefined' && navigator.product == 'ReactNative';
var device = canUseNative ? Native : canUseDOM ? Browser : Server;
var SSRObject = {
    isBrowser: device === Browser,
    isServer: device === Server,
    isNative: device === Native,
    device: device,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: device === Browser && !!window.addEventListener,
    canUseViewport: device === Browser && !!window.screen,
};
// TODO: instead of this, do a polyfill for `Object.assign` https://www.npmjs.com/package/es6-object-assign
var assign = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.reduce(function (acc, obj) { return (__assign(__assign({}, acc), obj)); }, {});
};
var values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
var toArrayObject = function () { return assign((values(SSRObject), SSRObject)); };
var useSSRObject = toArrayObject();
exports.weAreServer = function () {
    SSRObject.isServer = true;
    useSSRObject = toArrayObject();
};
exports.useSSR = function () { return useSSRObject; };
exports["default"] = exports.useSSR;


/***/ }),

/***/ 22976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KU": function() { return /* reexport */ hooks_EditorProvider; },
  "wx": function() { return /* reexport */ html_NoContentFound; },
  "nV": function() { return /* reexport */ draggable_RenderDraggableElement; },
  "r5": function() { return /* reexport */ html_RenderHtmlElement; },
  "qJ": function() { return /* reexport */ hooks_SiteProvider; },
  "ZP": function() { return /* binding */ lib; },
  "W4": function() { return /* reexport */ useSite; }
});

// UNUSED EXPORTS: draggableCategories, draggableElements, htmlToDraggable, mergeDeep, removePTag, tailwindcssPaletteGenerator, useEditor

// NAMESPACE OBJECT: ../../node_modules/lucide-react/dist/esm/icons/index.js
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, {
  "Accessibility": function() { return Accessibility; },
  "Activity": function() { return Activity; },
  "ActivitySquare": function() { return ActivitySquare; },
  "AirVent": function() { return AirVent; },
  "Airplay": function() { return Airplay; },
  "AlarmCheck": function() { return AlarmCheck; },
  "AlarmClock": function() { return AlarmClock; },
  "AlarmClockOff": function() { return AlarmClockOff; },
  "AlarmMinus": function() { return AlarmMinus; },
  "AlarmPlus": function() { return AlarmPlus; },
  "Album": function() { return Album; },
  "AlertCircle": function() { return AlertCircle; },
  "AlertOctagon": function() { return AlertOctagon; },
  "AlertTriangle": function() { return AlertTriangle; },
  "AlignCenter": function() { return AlignCenter; },
  "AlignCenterHorizontal": function() { return AlignCenterHorizontal; },
  "AlignCenterVertical": function() { return AlignCenterVertical; },
  "AlignEndHorizontal": function() { return AlignEndHorizontal; },
  "AlignEndVertical": function() { return AlignEndVertical; },
  "AlignHorizontalDistributeCenter": function() { return AlignHorizontalDistributeCenter; },
  "AlignHorizontalDistributeEnd": function() { return AlignHorizontalDistributeEnd; },
  "AlignHorizontalDistributeStart": function() { return AlignHorizontalDistributeStart; },
  "AlignHorizontalJustifyCenter": function() { return AlignHorizontalJustifyCenter; },
  "AlignHorizontalJustifyEnd": function() { return AlignHorizontalJustifyEnd; },
  "AlignHorizontalJustifyStart": function() { return AlignHorizontalJustifyStart; },
  "AlignHorizontalSpaceAround": function() { return AlignHorizontalSpaceAround; },
  "AlignHorizontalSpaceBetween": function() { return AlignHorizontalSpaceBetween; },
  "AlignJustify": function() { return AlignJustify; },
  "AlignLeft": function() { return AlignLeft; },
  "AlignRight": function() { return AlignRight; },
  "AlignStartHorizontal": function() { return AlignStartHorizontal; },
  "AlignStartVertical": function() { return AlignStartVertical; },
  "AlignVerticalDistributeCenter": function() { return AlignVerticalDistributeCenter; },
  "AlignVerticalDistributeEnd": function() { return AlignVerticalDistributeEnd; },
  "AlignVerticalDistributeStart": function() { return AlignVerticalDistributeStart; },
  "AlignVerticalJustifyCenter": function() { return AlignVerticalJustifyCenter; },
  "AlignVerticalJustifyEnd": function() { return AlignVerticalJustifyEnd; },
  "AlignVerticalJustifyStart": function() { return AlignVerticalJustifyStart; },
  "AlignVerticalSpaceAround": function() { return AlignVerticalSpaceAround; },
  "AlignVerticalSpaceBetween": function() { return AlignVerticalSpaceBetween; },
  "Ampersand": function() { return Ampersand; },
  "Ampersands": function() { return Ampersands; },
  "Anchor": function() { return Anchor; },
  "Angry": function() { return Angry; },
  "Annoyed": function() { return Annoyed; },
  "Antenna": function() { return Antenna; },
  "Aperture": function() { return Aperture; },
  "AppWindow": function() { return AppWindow; },
  "Apple": function() { return Apple; },
  "Archive": function() { return Archive; },
  "ArchiveRestore": function() { return ArchiveRestore; },
  "ArchiveX": function() { return ArchiveX; },
  "AreaChart": function() { return AreaChart; },
  "Armchair": function() { return Armchair; },
  "ArrowBigDown": function() { return ArrowBigDown; },
  "ArrowBigDownDash": function() { return ArrowBigDownDash; },
  "ArrowBigLeft": function() { return ArrowBigLeft; },
  "ArrowBigLeftDash": function() { return ArrowBigLeftDash; },
  "ArrowBigRight": function() { return ArrowBigRight; },
  "ArrowBigRightDash": function() { return ArrowBigRightDash; },
  "ArrowBigUp": function() { return ArrowBigUp; },
  "ArrowBigUpDash": function() { return ArrowBigUpDash; },
  "ArrowDown": function() { return ArrowDown; },
  "ArrowDown01": function() { return ArrowDown01; },
  "ArrowDown10": function() { return ArrowDown10; },
  "ArrowDownAZ": function() { return ArrowDownAZ; },
  "ArrowDownCircle": function() { return ArrowDownCircle; },
  "ArrowDownFromLine": function() { return ArrowDownFromLine; },
  "ArrowDownLeft": function() { return ArrowDownLeft; },
  "ArrowDownLeftFromCircle": function() { return ArrowDownLeftFromCircle; },
  "ArrowDownLeftSquare": function() { return ArrowDownLeftSquare; },
  "ArrowDownNarrowWide": function() { return ArrowDownNarrowWide; },
  "ArrowDownRight": function() { return ArrowDownRight; },
  "ArrowDownRightFromCircle": function() { return ArrowDownRightFromCircle; },
  "ArrowDownRightSquare": function() { return ArrowDownRightSquare; },
  "ArrowDownSquare": function() { return ArrowDownSquare; },
  "ArrowDownToDot": function() { return ArrowDownToDot; },
  "ArrowDownToLine": function() { return ArrowDownToLine; },
  "ArrowDownUp": function() { return ArrowDownUp; },
  "ArrowDownWideNarrow": function() { return ArrowDownWideNarrow; },
  "ArrowDownZA": function() { return ArrowDownZA; },
  "ArrowLeft": function() { return ArrowLeft; },
  "ArrowLeftCircle": function() { return ArrowLeftCircle; },
  "ArrowLeftFromLine": function() { return ArrowLeftFromLine; },
  "ArrowLeftRight": function() { return ArrowLeftRight; },
  "ArrowLeftSquare": function() { return ArrowLeftSquare; },
  "ArrowLeftToLine": function() { return ArrowLeftToLine; },
  "ArrowRight": function() { return ArrowRight; },
  "ArrowRightCircle": function() { return ArrowRightCircle; },
  "ArrowRightFromLine": function() { return ArrowRightFromLine; },
  "ArrowRightLeft": function() { return ArrowRightLeft; },
  "ArrowRightSquare": function() { return ArrowRightSquare; },
  "ArrowRightToLine": function() { return ArrowRightToLine; },
  "ArrowUp": function() { return ArrowUp; },
  "ArrowUp01": function() { return ArrowUp01; },
  "ArrowUp10": function() { return ArrowUp10; },
  "ArrowUpAZ": function() { return ArrowUpAZ; },
  "ArrowUpCircle": function() { return ArrowUpCircle; },
  "ArrowUpDown": function() { return ArrowUpDown; },
  "ArrowUpFromDot": function() { return ArrowUpFromDot; },
  "ArrowUpFromLine": function() { return ArrowUpFromLine; },
  "ArrowUpLeft": function() { return ArrowUpLeft; },
  "ArrowUpLeftFromCircle": function() { return ArrowUpLeftFromCircle; },
  "ArrowUpLeftSquare": function() { return ArrowUpLeftSquare; },
  "ArrowUpNarrowWide": function() { return ArrowUpNarrowWide; },
  "ArrowUpRight": function() { return ArrowUpRight; },
  "ArrowUpRightFromCircle": function() { return ArrowUpRightFromCircle; },
  "ArrowUpRightSquare": function() { return ArrowUpRightSquare; },
  "ArrowUpSquare": function() { return ArrowUpSquare; },
  "ArrowUpToLine": function() { return ArrowUpToLine; },
  "ArrowUpWideNarrow": function() { return ArrowUpWideNarrow; },
  "ArrowUpZA": function() { return ArrowUpZA; },
  "ArrowsUpFromLine": function() { return ArrowsUpFromLine; },
  "Asterisk": function() { return Asterisk; },
  "AtSign": function() { return AtSign; },
  "Atom": function() { return Atom; },
  "Award": function() { return Award; },
  "Axe": function() { return Axe; },
  "Axis3d": function() { return Axis3d; },
  "Baby": function() { return Baby; },
  "Backpack": function() { return Backpack; },
  "Badge": function() { return Badge; },
  "BadgeAlert": function() { return BadgeAlert; },
  "BadgeCent": function() { return BadgeCent; },
  "BadgeCheck": function() { return BadgeCheck; },
  "BadgeDollarSign": function() { return BadgeDollarSign; },
  "BadgeEuro": function() { return BadgeEuro; },
  "BadgeHelp": function() { return BadgeHelp; },
  "BadgeIndianRupee": function() { return BadgeIndianRupee; },
  "BadgeInfo": function() { return BadgeInfo; },
  "BadgeJapaneseYen": function() { return BadgeJapaneseYen; },
  "BadgeMinus": function() { return BadgeMinus; },
  "BadgePercent": function() { return BadgePercent; },
  "BadgePlus": function() { return BadgePlus; },
  "BadgePoundSterling": function() { return BadgePoundSterling; },
  "BadgeRussianRuble": function() { return BadgeRussianRuble; },
  "BadgeSwissFranc": function() { return BadgeSwissFranc; },
  "BadgeX": function() { return BadgeX; },
  "BaggageClaim": function() { return BaggageClaim; },
  "Ban": function() { return Ban; },
  "Banana": function() { return Banana; },
  "Banknote": function() { return Banknote; },
  "BarChart": function() { return BarChart; },
  "BarChart2": function() { return BarChart2; },
  "BarChart3": function() { return BarChart3; },
  "BarChart4": function() { return BarChart4; },
  "BarChartBig": function() { return BarChartBig; },
  "BarChartHorizontal": function() { return BarChartHorizontal; },
  "BarChartHorizontalBig": function() { return BarChartHorizontalBig; },
  "Barcode": function() { return Barcode; },
  "Baseline": function() { return Baseline; },
  "Bath": function() { return Bath; },
  "Battery": function() { return Battery; },
  "BatteryCharging": function() { return BatteryCharging; },
  "BatteryFull": function() { return BatteryFull; },
  "BatteryLow": function() { return BatteryLow; },
  "BatteryMedium": function() { return BatteryMedium; },
  "BatteryWarning": function() { return BatteryWarning; },
  "Beaker": function() { return Beaker; },
  "Bean": function() { return Bean; },
  "BeanOff": function() { return BeanOff; },
  "Bed": function() { return Bed; },
  "BedDouble": function() { return BedDouble; },
  "BedSingle": function() { return BedSingle; },
  "Beef": function() { return Beef; },
  "Beer": function() { return Beer; },
  "Bell": function() { return Bell; },
  "BellDot": function() { return BellDot; },
  "BellMinus": function() { return BellMinus; },
  "BellOff": function() { return BellOff; },
  "BellPlus": function() { return BellPlus; },
  "BellRing": function() { return BellRing; },
  "Bike": function() { return Bike; },
  "Binary": function() { return Binary; },
  "Biohazard": function() { return Biohazard; },
  "Bird": function() { return Bird; },
  "Bitcoin": function() { return Bitcoin; },
  "Blinds": function() { return Blinds; },
  "Blocks": function() { return Blocks; },
  "Bluetooth": function() { return Bluetooth; },
  "BluetoothConnected": function() { return BluetoothConnected; },
  "BluetoothOff": function() { return BluetoothOff; },
  "BluetoothSearching": function() { return BluetoothSearching; },
  "Bold": function() { return Bold; },
  "Bomb": function() { return Bomb; },
  "Bone": function() { return Bone; },
  "Book": function() { return Book; },
  "BookCopy": function() { return BookCopy; },
  "BookDown": function() { return BookDown; },
  "BookKey": function() { return BookKey; },
  "BookLock": function() { return BookLock; },
  "BookMarked": function() { return BookMarked; },
  "BookMinus": function() { return BookMinus; },
  "BookOpen": function() { return BookOpen; },
  "BookOpenCheck": function() { return BookOpenCheck; },
  "BookPlus": function() { return BookPlus; },
  "BookTemplate": function() { return BookTemplate; },
  "BookUp": function() { return BookUp; },
  "BookUp2": function() { return BookUp2; },
  "BookX": function() { return BookX; },
  "Bookmark": function() { return Bookmark; },
  "BookmarkCheck": function() { return BookmarkCheck; },
  "BookmarkMinus": function() { return BookmarkMinus; },
  "BookmarkPlus": function() { return BookmarkPlus; },
  "BookmarkX": function() { return BookmarkX; },
  "BoomBox": function() { return BoomBox; },
  "Bot": function() { return Bot; },
  "Box": function() { return Box; },
  "BoxSelect": function() { return BoxSelect; },
  "Boxes": function() { return Boxes; },
  "Braces": function() { return Braces; },
  "Brackets": function() { return Brackets; },
  "Brain": function() { return Brain; },
  "BrainCircuit": function() { return BrainCircuit; },
  "BrainCog": function() { return BrainCog; },
  "Briefcase": function() { return Briefcase; },
  "BringToFront": function() { return BringToFront; },
  "Brush": function() { return Brush; },
  "Bug": function() { return Bug; },
  "BugOff": function() { return BugOff; },
  "BugPlay": function() { return BugPlay; },
  "Building": function() { return Building; },
  "Building2": function() { return Building2; },
  "Bus": function() { return Bus; },
  "BusFront": function() { return BusFront; },
  "Cable": function() { return Cable; },
  "CableCar": function() { return CableCar; },
  "Cake": function() { return Cake; },
  "CakeSlice": function() { return CakeSlice; },
  "Calculator": function() { return Calculator; },
  "Calendar": function() { return Calendar; },
  "CalendarCheck": function() { return CalendarCheck; },
  "CalendarCheck2": function() { return CalendarCheck2; },
  "CalendarClock": function() { return CalendarClock; },
  "CalendarDays": function() { return CalendarDays; },
  "CalendarHeart": function() { return CalendarHeart; },
  "CalendarMinus": function() { return CalendarMinus; },
  "CalendarOff": function() { return CalendarOff; },
  "CalendarPlus": function() { return CalendarPlus; },
  "CalendarRange": function() { return CalendarRange; },
  "CalendarSearch": function() { return CalendarSearch; },
  "CalendarX": function() { return CalendarX; },
  "CalendarX2": function() { return CalendarX2; },
  "Camera": function() { return Camera; },
  "CameraOff": function() { return CameraOff; },
  "CandlestickChart": function() { return CandlestickChart; },
  "Candy": function() { return Candy; },
  "CandyCane": function() { return CandyCane; },
  "CandyOff": function() { return CandyOff; },
  "Car": function() { return Car; },
  "CarFront": function() { return CarFront; },
  "CarTaxiFront": function() { return CarTaxiFront; },
  "Caravan": function() { return Caravan; },
  "Carrot": function() { return Carrot; },
  "CaseLower": function() { return CaseLower; },
  "CaseSensitive": function() { return CaseSensitive; },
  "CaseUpper": function() { return CaseUpper; },
  "CassetteTape": function() { return CassetteTape; },
  "Cast": function() { return Cast; },
  "Castle": function() { return Castle; },
  "Cat": function() { return Cat; },
  "Check": function() { return Check; },
  "CheckCheck": function() { return CheckCheck; },
  "CheckCircle": function() { return CheckCircle; },
  "CheckCircle2": function() { return CheckCircle2; },
  "CheckSquare": function() { return CheckSquare; },
  "ChefHat": function() { return ChefHat; },
  "Cherry": function() { return Cherry; },
  "ChevronDown": function() { return ChevronDown; },
  "ChevronDownCircle": function() { return ChevronDownCircle; },
  "ChevronDownSquare": function() { return ChevronDownSquare; },
  "ChevronFirst": function() { return ChevronFirst; },
  "ChevronLast": function() { return ChevronLast; },
  "ChevronLeft": function() { return ChevronLeft; },
  "ChevronLeftCircle": function() { return ChevronLeftCircle; },
  "ChevronLeftSquare": function() { return ChevronLeftSquare; },
  "ChevronRight": function() { return ChevronRight; },
  "ChevronRightCircle": function() { return ChevronRightCircle; },
  "ChevronRightSquare": function() { return ChevronRightSquare; },
  "ChevronUp": function() { return ChevronUp; },
  "ChevronUpCircle": function() { return ChevronUpCircle; },
  "ChevronUpSquare": function() { return ChevronUpSquare; },
  "ChevronsDown": function() { return ChevronsDown; },
  "ChevronsDownUp": function() { return ChevronsDownUp; },
  "ChevronsLeft": function() { return ChevronsLeft; },
  "ChevronsLeftRight": function() { return ChevronsLeftRight; },
  "ChevronsRight": function() { return ChevronsRight; },
  "ChevronsRightLeft": function() { return ChevronsRightLeft; },
  "ChevronsUp": function() { return ChevronsUp; },
  "ChevronsUpDown": function() { return ChevronsUpDown; },
  "Chrome": function() { return Chrome; },
  "Church": function() { return Church; },
  "Cigarette": function() { return Cigarette; },
  "CigaretteOff": function() { return CigaretteOff; },
  "Circle": function() { return Circle; },
  "CircleDashed": function() { return CircleDashed; },
  "CircleDollarSign": function() { return CircleDollarSign; },
  "CircleDot": function() { return CircleDot; },
  "CircleDotDashed": function() { return CircleDotDashed; },
  "CircleEllipsis": function() { return CircleEllipsis; },
  "CircleEqual": function() { return CircleEqual; },
  "CircleOff": function() { return CircleOff; },
  "CircleSlash": function() { return CircleSlash; },
  "CircleSlash2": function() { return CircleSlash2; },
  "CircuitBoard": function() { return CircuitBoard; },
  "Citrus": function() { return Citrus; },
  "Clapperboard": function() { return Clapperboard; },
  "Clipboard": function() { return Clipboard; },
  "ClipboardCheck": function() { return ClipboardCheck; },
  "ClipboardCopy": function() { return ClipboardCopy; },
  "ClipboardEdit": function() { return ClipboardEdit; },
  "ClipboardList": function() { return ClipboardList; },
  "ClipboardPaste": function() { return ClipboardPaste; },
  "ClipboardSignature": function() { return ClipboardSignature; },
  "ClipboardType": function() { return ClipboardType; },
  "ClipboardX": function() { return ClipboardX; },
  "Clock": function() { return Clock; },
  "Clock1": function() { return Clock1; },
  "Clock10": function() { return Clock10; },
  "Clock11": function() { return Clock11; },
  "Clock12": function() { return Clock12; },
  "Clock2": function() { return Clock2; },
  "Clock3": function() { return Clock3; },
  "Clock4": function() { return Clock4; },
  "Clock5": function() { return Clock5; },
  "Clock6": function() { return Clock6; },
  "Clock7": function() { return Clock7; },
  "Clock8": function() { return Clock8; },
  "Clock9": function() { return Clock9; },
  "Cloud": function() { return Cloud; },
  "CloudCog": function() { return CloudCog; },
  "CloudDrizzle": function() { return CloudDrizzle; },
  "CloudFog": function() { return CloudFog; },
  "CloudHail": function() { return CloudHail; },
  "CloudLightning": function() { return CloudLightning; },
  "CloudMoon": function() { return CloudMoon; },
  "CloudMoonRain": function() { return CloudMoonRain; },
  "CloudOff": function() { return CloudOff; },
  "CloudRain": function() { return CloudRain; },
  "CloudRainWind": function() { return CloudRainWind; },
  "CloudSnow": function() { return CloudSnow; },
  "CloudSun": function() { return CloudSun; },
  "CloudSunRain": function() { return CloudSunRain; },
  "Cloudy": function() { return Cloudy; },
  "Clover": function() { return Clover; },
  "Club": function() { return Club; },
  "Code": function() { return Code; },
  "Code2": function() { return Code2; },
  "Codepen": function() { return Codepen; },
  "Codesandbox": function() { return Codesandbox; },
  "Coffee": function() { return Coffee; },
  "Cog": function() { return Cog; },
  "Coins": function() { return Coins; },
  "Columns": function() { return Columns; },
  "Combine": function() { return Combine; },
  "Command": function() { return Command; },
  "Compass": function() { return Compass; },
  "Component": function() { return Component; },
  "Computer": function() { return Computer; },
  "ConciergeBell": function() { return ConciergeBell; },
  "Cone": function() { return Cone; },
  "Construction": function() { return Construction; },
  "Contact": function() { return Contact; },
  "Contact2": function() { return Contact2; },
  "Container": function() { return container_Container; },
  "Contrast": function() { return Contrast; },
  "Cookie": function() { return Cookie; },
  "Copy": function() { return Copy; },
  "CopyCheck": function() { return CopyCheck; },
  "CopyMinus": function() { return CopyMinus; },
  "CopyPlus": function() { return CopyPlus; },
  "CopySlash": function() { return CopySlash; },
  "CopyX": function() { return CopyX; },
  "Copyleft": function() { return Copyleft; },
  "Copyright": function() { return Copyright; },
  "CornerDownLeft": function() { return CornerDownLeft; },
  "CornerDownRight": function() { return CornerDownRight; },
  "CornerLeftDown": function() { return CornerLeftDown; },
  "CornerLeftUp": function() { return CornerLeftUp; },
  "CornerRightDown": function() { return CornerRightDown; },
  "CornerRightUp": function() { return CornerRightUp; },
  "CornerUpLeft": function() { return CornerUpLeft; },
  "CornerUpRight": function() { return CornerUpRight; },
  "Cpu": function() { return Cpu; },
  "CreativeCommons": function() { return CreativeCommons; },
  "CreditCard": function() { return CreditCard; },
  "Croissant": function() { return Croissant; },
  "Crop": function() { return Crop; },
  "Cross": function() { return Cross; },
  "Crosshair": function() { return Crosshair; },
  "Crown": function() { return Crown; },
  "Cuboid": function() { return Cuboid; },
  "CupSoda": function() { return CupSoda; },
  "Currency": function() { return Currency; },
  "Cylinder": function() { return Cylinder; },
  "Database": function() { return Database; },
  "DatabaseBackup": function() { return DatabaseBackup; },
  "DatabaseZap": function() { return DatabaseZap; },
  "Delete": function() { return Delete; },
  "Dessert": function() { return Dessert; },
  "Diameter": function() { return Diameter; },
  "Diamond": function() { return Diamond; },
  "Dice1": function() { return Dice1; },
  "Dice2": function() { return Dice2; },
  "Dice3": function() { return Dice3; },
  "Dice4": function() { return Dice4; },
  "Dice5": function() { return Dice5; },
  "Dice6": function() { return Dice6; },
  "Dices": function() { return Dices; },
  "Diff": function() { return Diff; },
  "Disc": function() { return Disc; },
  "Disc2": function() { return Disc2; },
  "Disc3": function() { return Disc3; },
  "Divide": function() { return Divide; },
  "DivideCircle": function() { return DivideCircle; },
  "DivideSquare": function() { return DivideSquare; },
  "Dna": function() { return Dna; },
  "DnaOff": function() { return DnaOff; },
  "Dog": function() { return Dog; },
  "DollarSign": function() { return DollarSign; },
  "Donut": function() { return Donut; },
  "DoorClosed": function() { return DoorClosed; },
  "DoorOpen": function() { return DoorOpen; },
  "Dot": function() { return Dot; },
  "Download": function() { return Download; },
  "DownloadCloud": function() { return DownloadCloud; },
  "DraftingCompass": function() { return DraftingCompass; },
  "Drama": function() { return Drama; },
  "Dribbble": function() { return Dribbble; },
  "Droplet": function() { return Droplet; },
  "Droplets": function() { return Droplets; },
  "Drumstick": function() { return Drumstick; },
  "Dumbbell": function() { return Dumbbell; },
  "Ear": function() { return Ear; },
  "EarOff": function() { return EarOff; },
  "Egg": function() { return Egg; },
  "EggFried": function() { return EggFried; },
  "EggOff": function() { return EggOff; },
  "Equal": function() { return Equal; },
  "EqualNot": function() { return EqualNot; },
  "Eraser": function() { return Eraser; },
  "Euro": function() { return Euro; },
  "Expand": function() { return Expand; },
  "ExternalLink": function() { return ExternalLink; },
  "Eye": function() { return Eye; },
  "EyeOff": function() { return EyeOff; },
  "Facebook": function() { return Facebook; },
  "Factory": function() { return Factory; },
  "Fan": function() { return Fan; },
  "FastForward": function() { return FastForward; },
  "Feather": function() { return Feather; },
  "FerrisWheel": function() { return FerrisWheel; },
  "Figma": function() { return Figma; },
  "File": function() { return File; },
  "FileArchive": function() { return FileArchive; },
  "FileAudio": function() { return FileAudio; },
  "FileAudio2": function() { return FileAudio2; },
  "FileAxis3d": function() { return FileAxis3d; },
  "FileBadge": function() { return FileBadge; },
  "FileBadge2": function() { return FileBadge2; },
  "FileBarChart": function() { return FileBarChart; },
  "FileBarChart2": function() { return FileBarChart2; },
  "FileBox": function() { return FileBox; },
  "FileCheck": function() { return FileCheck; },
  "FileCheck2": function() { return FileCheck2; },
  "FileClock": function() { return FileClock; },
  "FileCode": function() { return FileCode; },
  "FileCode2": function() { return FileCode2; },
  "FileCog": function() { return FileCog; },
  "FileDiff": function() { return FileDiff; },
  "FileDigit": function() { return FileDigit; },
  "FileDown": function() { return FileDown; },
  "FileEdit": function() { return FileEdit; },
  "FileHeart": function() { return FileHeart; },
  "FileImage": function() { return FileImage; },
  "FileInput": function() { return FileInput; },
  "FileJson": function() { return FileJson; },
  "FileJson2": function() { return FileJson2; },
  "FileKey": function() { return FileKey; },
  "FileKey2": function() { return FileKey2; },
  "FileLineChart": function() { return FileLineChart; },
  "FileLock": function() { return FileLock; },
  "FileLock2": function() { return FileLock2; },
  "FileMinus": function() { return FileMinus; },
  "FileMinus2": function() { return FileMinus2; },
  "FileOutput": function() { return FileOutput; },
  "FilePieChart": function() { return FilePieChart; },
  "FilePlus": function() { return FilePlus; },
  "FilePlus2": function() { return FilePlus2; },
  "FileQuestion": function() { return FileQuestion; },
  "FileScan": function() { return FileScan; },
  "FileSearch": function() { return FileSearch; },
  "FileSearch2": function() { return FileSearch2; },
  "FileSignature": function() { return FileSignature; },
  "FileSpreadsheet": function() { return FileSpreadsheet; },
  "FileStack": function() { return FileStack; },
  "FileSymlink": function() { return FileSymlink; },
  "FileTerminal": function() { return FileTerminal; },
  "FileText": function() { return FileText; },
  "FileType": function() { return FileType; },
  "FileType2": function() { return FileType2; },
  "FileUp": function() { return FileUp; },
  "FileVideo": function() { return FileVideo; },
  "FileVideo2": function() { return FileVideo2; },
  "FileVolume": function() { return FileVolume; },
  "FileVolume2": function() { return FileVolume2; },
  "FileWarning": function() { return FileWarning; },
  "FileX": function() { return FileX; },
  "FileX2": function() { return FileX2; },
  "Files": function() { return Files; },
  "Film": function() { return Film; },
  "Filter": function() { return Filter; },
  "FilterX": function() { return FilterX; },
  "Fingerprint": function() { return Fingerprint; },
  "Fish": function() { return Fish; },
  "FishOff": function() { return FishOff; },
  "FishSymbol": function() { return FishSymbol; },
  "Flag": function() { return Flag; },
  "FlagOff": function() { return FlagOff; },
  "FlagTriangleLeft": function() { return FlagTriangleLeft; },
  "FlagTriangleRight": function() { return FlagTriangleRight; },
  "Flame": function() { return Flame; },
  "FlameKindling": function() { return FlameKindling; },
  "Flashlight": function() { return Flashlight; },
  "FlashlightOff": function() { return FlashlightOff; },
  "FlaskConical": function() { return FlaskConical; },
  "FlaskConicalOff": function() { return FlaskConicalOff; },
  "FlaskRound": function() { return FlaskRound; },
  "FlipHorizontal": function() { return FlipHorizontal; },
  "FlipHorizontal2": function() { return FlipHorizontal2; },
  "FlipVertical": function() { return FlipVertical; },
  "FlipVertical2": function() { return FlipVertical2; },
  "Flower": function() { return Flower; },
  "Flower2": function() { return Flower2; },
  "Focus": function() { return Focus; },
  "FoldHorizontal": function() { return FoldHorizontal; },
  "FoldVertical": function() { return FoldVertical; },
  "Folder": function() { return Folder; },
  "FolderArchive": function() { return FolderArchive; },
  "FolderCheck": function() { return FolderCheck; },
  "FolderClock": function() { return FolderClock; },
  "FolderClosed": function() { return FolderClosed; },
  "FolderCog": function() { return FolderCog; },
  "FolderDot": function() { return FolderDot; },
  "FolderDown": function() { return FolderDown; },
  "FolderEdit": function() { return FolderEdit; },
  "FolderGit": function() { return FolderGit; },
  "FolderGit2": function() { return FolderGit2; },
  "FolderHeart": function() { return FolderHeart; },
  "FolderInput": function() { return FolderInput; },
  "FolderKanban": function() { return FolderKanban; },
  "FolderKey": function() { return FolderKey; },
  "FolderLock": function() { return FolderLock; },
  "FolderMinus": function() { return FolderMinus; },
  "FolderOpen": function() { return FolderOpen; },
  "FolderOpenDot": function() { return FolderOpenDot; },
  "FolderOutput": function() { return FolderOutput; },
  "FolderPlus": function() { return FolderPlus; },
  "FolderRoot": function() { return FolderRoot; },
  "FolderSearch": function() { return FolderSearch; },
  "FolderSearch2": function() { return FolderSearch2; },
  "FolderSymlink": function() { return FolderSymlink; },
  "FolderSync": function() { return FolderSync; },
  "FolderTree": function() { return FolderTree; },
  "FolderUp": function() { return FolderUp; },
  "FolderX": function() { return FolderX; },
  "Folders": function() { return Folders; },
  "Footprints": function() { return Footprints; },
  "Forklift": function() { return Forklift; },
  "FormInput": function() { return FormInput; },
  "Forward": function() { return Forward; },
  "Frame": function() { return Frame; },
  "Framer": function() { return Framer; },
  "Frown": function() { return Frown; },
  "Fuel": function() { return Fuel; },
  "Fullscreen": function() { return Fullscreen; },
  "FunctionSquare": function() { return FunctionSquare; },
  "GalleryHorizontal": function() { return GalleryHorizontal; },
  "GalleryHorizontalEnd": function() { return GalleryHorizontalEnd; },
  "GalleryThumbnails": function() { return GalleryThumbnails; },
  "GalleryVertical": function() { return GalleryVertical; },
  "GalleryVerticalEnd": function() { return GalleryVerticalEnd; },
  "Gamepad": function() { return Gamepad; },
  "Gamepad2": function() { return Gamepad2; },
  "GanttChart": function() { return GanttChart; },
  "GanttChartSquare": function() { return GanttChartSquare; },
  "Gauge": function() { return Gauge; },
  "GaugeCircle": function() { return GaugeCircle; },
  "Gavel": function() { return Gavel; },
  "Gem": function() { return Gem; },
  "Ghost": function() { return Ghost; },
  "Gift": function() { return Gift; },
  "GitBranch": function() { return GitBranch; },
  "GitBranchPlus": function() { return GitBranchPlus; },
  "GitCommit": function() { return GitCommit; },
  "GitCompare": function() { return GitCompare; },
  "GitFork": function() { return GitFork; },
  "GitMerge": function() { return GitMerge; },
  "GitPullRequest": function() { return GitPullRequest; },
  "GitPullRequestClosed": function() { return GitPullRequestClosed; },
  "GitPullRequestDraft": function() { return GitPullRequestDraft; },
  "Github": function() { return Github; },
  "Gitlab": function() { return Gitlab; },
  "GlassWater": function() { return GlassWater; },
  "Glasses": function() { return Glasses; },
  "Globe": function() { return Globe; },
  "Globe2": function() { return Globe2; },
  "Goal": function() { return Goal; },
  "Grab": function() { return Grab; },
  "GraduationCap": function() { return GraduationCap; },
  "Grape": function() { return Grape; },
  "Grid2x2": function() { return Grid2x2; },
  "Grid3x3": function() { return Grid3x3; },
  "Grip": function() { return Grip; },
  "GripHorizontal": function() { return GripHorizontal; },
  "GripVertical": function() { return GripVertical; },
  "Group": function() { return Group; },
  "Hammer": function() { return Hammer; },
  "Hand": function() { return Hand; },
  "HandMetal": function() { return HandMetal; },
  "HardDrive": function() { return HardDrive; },
  "HardDriveDownload": function() { return HardDriveDownload; },
  "HardDriveUpload": function() { return HardDriveUpload; },
  "HardHat": function() { return HardHat; },
  "Hash": function() { return Hash; },
  "Haze": function() { return Haze; },
  "HdmiPort": function() { return HdmiPort; },
  "Heading": function() { return Heading; },
  "Heading1": function() { return Heading1; },
  "Heading2": function() { return Heading2; },
  "Heading3": function() { return Heading3; },
  "Heading4": function() { return Heading4; },
  "Heading5": function() { return Heading5; },
  "Heading6": function() { return Heading6; },
  "Headphones": function() { return Headphones; },
  "Heart": function() { return Heart; },
  "HeartCrack": function() { return HeartCrack; },
  "HeartHandshake": function() { return HeartHandshake; },
  "HeartOff": function() { return HeartOff; },
  "HeartPulse": function() { return HeartPulse; },
  "HelpCircle": function() { return HelpCircle; },
  "HelpingHand": function() { return HelpingHand; },
  "Hexagon": function() { return Hexagon; },
  "Highlighter": function() { return Highlighter; },
  "History": function() { return History; },
  "Home": function() { return Home; },
  "Hop": function() { return Hop; },
  "HopOff": function() { return HopOff; },
  "Hotel": function() { return Hotel; },
  "Hourglass": function() { return Hourglass; },
  "IceCream": function() { return IceCream; },
  "IceCream2": function() { return IceCream2; },
  "Image": function() { return Image; },
  "ImageMinus": function() { return ImageMinus; },
  "ImageOff": function() { return ImageOff; },
  "ImagePlus": function() { return ImagePlus; },
  "Import": function() { return Import; },
  "Inbox": function() { return Inbox; },
  "Indent": function() { return Indent; },
  "IndianRupee": function() { return IndianRupee; },
  "Infinity": function() { return infinity_Infinity; },
  "Info": function() { return Info; },
  "Instagram": function() { return Instagram; },
  "Italic": function() { return Italic; },
  "IterationCcw": function() { return IterationCcw; },
  "IterationCw": function() { return IterationCw; },
  "JapaneseYen": function() { return JapaneseYen; },
  "Joystick": function() { return Joystick; },
  "Kanban": function() { return Kanban; },
  "KanbanSquare": function() { return KanbanSquare; },
  "KanbanSquareDashed": function() { return KanbanSquareDashed; },
  "Key": function() { return Key; },
  "KeyRound": function() { return KeyRound; },
  "KeySquare": function() { return KeySquare; },
  "Keyboard": function() { return Keyboard; },
  "Lamp": function() { return Lamp; },
  "LampCeiling": function() { return LampCeiling; },
  "LampDesk": function() { return LampDesk; },
  "LampFloor": function() { return LampFloor; },
  "LampWallDown": function() { return LampWallDown; },
  "LampWallUp": function() { return LampWallUp; },
  "LandPlot": function() { return LandPlot; },
  "Landmark": function() { return Landmark; },
  "Languages": function() { return Languages; },
  "Laptop": function() { return Laptop; },
  "Laptop2": function() { return Laptop2; },
  "Lasso": function() { return Lasso; },
  "LassoSelect": function() { return LassoSelect; },
  "Laugh": function() { return Laugh; },
  "Layers": function() { return Layers; },
  "Layers2": function() { return Layers2; },
  "Layers3": function() { return Layers3; },
  "Layout": function() { return Layout; },
  "LayoutDashboard": function() { return LayoutDashboard; },
  "LayoutGrid": function() { return LayoutGrid; },
  "LayoutList": function() { return LayoutList; },
  "LayoutPanelLeft": function() { return LayoutPanelLeft; },
  "LayoutPanelTop": function() { return LayoutPanelTop; },
  "LayoutTemplate": function() { return LayoutTemplate; },
  "Leaf": function() { return Leaf; },
  "LeafyGreen": function() { return LeafyGreen; },
  "Library": function() { return Library; },
  "LifeBuoy": function() { return LifeBuoy; },
  "Ligature": function() { return Ligature; },
  "Lightbulb": function() { return Lightbulb; },
  "LightbulbOff": function() { return LightbulbOff; },
  "LineChart": function() { return LineChart; },
  "Link": function() { return link_Link; },
  "Link2": function() { return Link2; },
  "Link2Off": function() { return Link2Off; },
  "Linkedin": function() { return Linkedin; },
  "List": function() { return List; },
  "ListChecks": function() { return ListChecks; },
  "ListEnd": function() { return ListEnd; },
  "ListFilter": function() { return ListFilter; },
  "ListMinus": function() { return ListMinus; },
  "ListMusic": function() { return ListMusic; },
  "ListOrdered": function() { return ListOrdered; },
  "ListPlus": function() { return ListPlus; },
  "ListRestart": function() { return ListRestart; },
  "ListStart": function() { return ListStart; },
  "ListTodo": function() { return ListTodo; },
  "ListTree": function() { return ListTree; },
  "ListVideo": function() { return ListVideo; },
  "ListX": function() { return ListX; },
  "Loader": function() { return Loader; },
  "Loader2": function() { return Loader2; },
  "Locate": function() { return Locate; },
  "LocateFixed": function() { return LocateFixed; },
  "LocateOff": function() { return LocateOff; },
  "Lock": function() { return Lock; },
  "LockKeyhole": function() { return LockKeyhole; },
  "LogIn": function() { return LogIn; },
  "LogOut": function() { return LogOut; },
  "Lollipop": function() { return Lollipop; },
  "Luggage": function() { return Luggage; },
  "MSquare": function() { return MSquare; },
  "Magnet": function() { return Magnet; },
  "Mail": function() { return Mail; },
  "MailCheck": function() { return MailCheck; },
  "MailMinus": function() { return MailMinus; },
  "MailOpen": function() { return MailOpen; },
  "MailPlus": function() { return MailPlus; },
  "MailQuestion": function() { return MailQuestion; },
  "MailSearch": function() { return MailSearch; },
  "MailWarning": function() { return MailWarning; },
  "MailX": function() { return MailX; },
  "Mailbox": function() { return Mailbox; },
  "Mails": function() { return Mails; },
  "Map": function() { return map_Map; },
  "MapPin": function() { return MapPin; },
  "MapPinOff": function() { return MapPinOff; },
  "Martini": function() { return Martini; },
  "Maximize": function() { return Maximize; },
  "Maximize2": function() { return Maximize2; },
  "Medal": function() { return Medal; },
  "Megaphone": function() { return Megaphone; },
  "MegaphoneOff": function() { return MegaphoneOff; },
  "Meh": function() { return Meh; },
  "MemoryStick": function() { return MemoryStick; },
  "Menu": function() { return Menu; },
  "MenuSquare": function() { return MenuSquare; },
  "Merge": function() { return Merge; },
  "MessageCircle": function() { return MessageCircle; },
  "MessageSquare": function() { return MessageSquare; },
  "MessageSquareDashed": function() { return MessageSquareDashed; },
  "MessageSquarePlus": function() { return MessageSquarePlus; },
  "MessagesSquare": function() { return MessagesSquare; },
  "Mic": function() { return Mic; },
  "Mic2": function() { return Mic2; },
  "MicOff": function() { return MicOff; },
  "Microscope": function() { return Microscope; },
  "Microwave": function() { return Microwave; },
  "Milestone": function() { return Milestone; },
  "Milk": function() { return Milk; },
  "MilkOff": function() { return MilkOff; },
  "Minimize": function() { return Minimize; },
  "Minimize2": function() { return Minimize2; },
  "Minus": function() { return Minus; },
  "MinusCircle": function() { return MinusCircle; },
  "MinusSquare": function() { return MinusSquare; },
  "Monitor": function() { return Monitor; },
  "MonitorCheck": function() { return MonitorCheck; },
  "MonitorDot": function() { return MonitorDot; },
  "MonitorDown": function() { return MonitorDown; },
  "MonitorOff": function() { return MonitorOff; },
  "MonitorPause": function() { return MonitorPause; },
  "MonitorPlay": function() { return MonitorPlay; },
  "MonitorSmartphone": function() { return MonitorSmartphone; },
  "MonitorSpeaker": function() { return MonitorSpeaker; },
  "MonitorStop": function() { return MonitorStop; },
  "MonitorUp": function() { return MonitorUp; },
  "MonitorX": function() { return MonitorX; },
  "Moon": function() { return Moon; },
  "MoonStar": function() { return MoonStar; },
  "MoreHorizontal": function() { return MoreHorizontal; },
  "MoreVertical": function() { return MoreVertical; },
  "Mountain": function() { return Mountain; },
  "MountainSnow": function() { return MountainSnow; },
  "Mouse": function() { return Mouse; },
  "MousePointer": function() { return MousePointer; },
  "MousePointer2": function() { return MousePointer2; },
  "MousePointerClick": function() { return MousePointerClick; },
  "MousePointerSquare": function() { return MousePointerSquare; },
  "MousePointerSquareDashed": function() { return MousePointerSquareDashed; },
  "Move": function() { return Move; },
  "Move3d": function() { return Move3d; },
  "MoveDiagonal": function() { return MoveDiagonal; },
  "MoveDiagonal2": function() { return MoveDiagonal2; },
  "MoveDown": function() { return MoveDown; },
  "MoveDownLeft": function() { return MoveDownLeft; },
  "MoveDownRight": function() { return MoveDownRight; },
  "MoveHorizontal": function() { return MoveHorizontal; },
  "MoveLeft": function() { return MoveLeft; },
  "MoveRight": function() { return MoveRight; },
  "MoveUp": function() { return MoveUp; },
  "MoveUpLeft": function() { return MoveUpLeft; },
  "MoveUpRight": function() { return MoveUpRight; },
  "MoveVertical": function() { return MoveVertical; },
  "Music": function() { return Music; },
  "Music2": function() { return Music2; },
  "Music3": function() { return Music3; },
  "Music4": function() { return Music4; },
  "Navigation": function() { return Navigation; },
  "Navigation2": function() { return Navigation2; },
  "Navigation2Off": function() { return Navigation2Off; },
  "NavigationOff": function() { return NavigationOff; },
  "Network": function() { return Network; },
  "Newspaper": function() { return Newspaper; },
  "Nfc": function() { return Nfc; },
  "Nut": function() { return Nut; },
  "NutOff": function() { return NutOff; },
  "Octagon": function() { return Octagon; },
  "Option": function() { return Option; },
  "Orbit": function() { return Orbit; },
  "Outdent": function() { return Outdent; },
  "Package": function() { return Package; },
  "Package2": function() { return Package2; },
  "PackageCheck": function() { return PackageCheck; },
  "PackageMinus": function() { return PackageMinus; },
  "PackageOpen": function() { return PackageOpen; },
  "PackagePlus": function() { return PackagePlus; },
  "PackageSearch": function() { return PackageSearch; },
  "PackageX": function() { return PackageX; },
  "PaintBucket": function() { return PaintBucket; },
  "Paintbrush": function() { return Paintbrush; },
  "Paintbrush2": function() { return Paintbrush2; },
  "Palette": function() { return Palette; },
  "Palmtree": function() { return Palmtree; },
  "PanelBottom": function() { return PanelBottom; },
  "PanelBottomClose": function() { return PanelBottomClose; },
  "PanelBottomInactive": function() { return PanelBottomInactive; },
  "PanelBottomOpen": function() { return PanelBottomOpen; },
  "PanelLeft": function() { return PanelLeft; },
  "PanelLeftClose": function() { return PanelLeftClose; },
  "PanelLeftInactive": function() { return PanelLeftInactive; },
  "PanelLeftOpen": function() { return PanelLeftOpen; },
  "PanelRight": function() { return PanelRight; },
  "PanelRightClose": function() { return PanelRightClose; },
  "PanelRightInactive": function() { return PanelRightInactive; },
  "PanelRightOpen": function() { return PanelRightOpen; },
  "PanelTop": function() { return PanelTop; },
  "PanelTopClose": function() { return PanelTopClose; },
  "PanelTopInactive": function() { return PanelTopInactive; },
  "PanelTopOpen": function() { return PanelTopOpen; },
  "Paperclip": function() { return Paperclip; },
  "Parentheses": function() { return Parentheses; },
  "ParkingCircle": function() { return ParkingCircle; },
  "ParkingCircleOff": function() { return ParkingCircleOff; },
  "ParkingMeter": function() { return ParkingMeter; },
  "ParkingSquare": function() { return ParkingSquare; },
  "ParkingSquareOff": function() { return ParkingSquareOff; },
  "PartyPopper": function() { return PartyPopper; },
  "Pause": function() { return Pause; },
  "PauseCircle": function() { return PauseCircle; },
  "PauseOctagon": function() { return PauseOctagon; },
  "PawPrint": function() { return PawPrint; },
  "PcCase": function() { return PcCase; },
  "Pen": function() { return Pen; },
  "PenLine": function() { return PenLine; },
  "PenSquare": function() { return PenSquare; },
  "PenTool": function() { return PenTool; },
  "Pencil": function() { return Pencil; },
  "PencilLine": function() { return PencilLine; },
  "PencilRuler": function() { return PencilRuler; },
  "Pentagon": function() { return Pentagon; },
  "Percent": function() { return Percent; },
  "PercentCircle": function() { return PercentCircle; },
  "PercentDiamond": function() { return PercentDiamond; },
  "PercentSquare": function() { return PercentSquare; },
  "PersonStanding": function() { return PersonStanding; },
  "Phone": function() { return Phone; },
  "PhoneCall": function() { return PhoneCall; },
  "PhoneForwarded": function() { return PhoneForwarded; },
  "PhoneIncoming": function() { return PhoneIncoming; },
  "PhoneMissed": function() { return PhoneMissed; },
  "PhoneOff": function() { return PhoneOff; },
  "PhoneOutgoing": function() { return PhoneOutgoing; },
  "Pi": function() { return Pi; },
  "PiSquare": function() { return PiSquare; },
  "PictureInPicture": function() { return PictureInPicture; },
  "PictureInPicture2": function() { return PictureInPicture2; },
  "PieChart": function() { return PieChart; },
  "PiggyBank": function() { return PiggyBank; },
  "Pilcrow": function() { return Pilcrow; },
  "PilcrowSquare": function() { return PilcrowSquare; },
  "Pill": function() { return Pill; },
  "Pin": function() { return Pin; },
  "PinOff": function() { return PinOff; },
  "Pipette": function() { return Pipette; },
  "Pizza": function() { return Pizza; },
  "Plane": function() { return Plane; },
  "PlaneLanding": function() { return PlaneLanding; },
  "PlaneTakeoff": function() { return PlaneTakeoff; },
  "Play": function() { return Play; },
  "PlayCircle": function() { return PlayCircle; },
  "PlaySquare": function() { return PlaySquare; },
  "Plug": function() { return Plug; },
  "Plug2": function() { return Plug2; },
  "PlugZap": function() { return PlugZap; },
  "PlugZap2": function() { return PlugZap2; },
  "Plus": function() { return Plus; },
  "PlusCircle": function() { return PlusCircle; },
  "PlusSquare": function() { return PlusSquare; },
  "Pocket": function() { return Pocket; },
  "PocketKnife": function() { return PocketKnife; },
  "Podcast": function() { return Podcast; },
  "Pointer": function() { return Pointer; },
  "Popcorn": function() { return Popcorn; },
  "Popsicle": function() { return Popsicle; },
  "PoundSterling": function() { return PoundSterling; },
  "Power": function() { return Power; },
  "PowerOff": function() { return PowerOff; },
  "Presentation": function() { return Presentation; },
  "Printer": function() { return Printer; },
  "Projector": function() { return Projector; },
  "Puzzle": function() { return Puzzle; },
  "Pyramid": function() { return Pyramid; },
  "QrCode": function() { return QrCode; },
  "Quote": function() { return Quote; },
  "Rabbit": function() { return Rabbit; },
  "Radar": function() { return Radar; },
  "Radiation": function() { return Radiation; },
  "Radio": function() { return Radio; },
  "RadioReceiver": function() { return RadioReceiver; },
  "RadioTower": function() { return RadioTower; },
  "Radius": function() { return Radius; },
  "RailSymbol": function() { return RailSymbol; },
  "Rainbow": function() { return Rainbow; },
  "Rat": function() { return Rat; },
  "Ratio": function() { return Ratio; },
  "Receipt": function() { return Receipt; },
  "RectangleHorizontal": function() { return RectangleHorizontal; },
  "RectangleVertical": function() { return RectangleVertical; },
  "Recycle": function() { return Recycle; },
  "Redo": function() { return Redo; },
  "Redo2": function() { return Redo2; },
  "RedoDot": function() { return RedoDot; },
  "RefreshCcw": function() { return RefreshCcw; },
  "RefreshCcwDot": function() { return RefreshCcwDot; },
  "RefreshCw": function() { return RefreshCw; },
  "RefreshCwOff": function() { return RefreshCwOff; },
  "Refrigerator": function() { return Refrigerator; },
  "Regex": function() { return Regex; },
  "RemoveFormatting": function() { return RemoveFormatting; },
  "Repeat": function() { return Repeat; },
  "Repeat1": function() { return Repeat1; },
  "Repeat2": function() { return Repeat2; },
  "Replace": function() { return Replace; },
  "ReplaceAll": function() { return ReplaceAll; },
  "Reply": function() { return Reply; },
  "ReplyAll": function() { return ReplyAll; },
  "Rewind": function() { return Rewind; },
  "Rocket": function() { return Rocket; },
  "RockingChair": function() { return RockingChair; },
  "RollerCoaster": function() { return RollerCoaster; },
  "Rotate3d": function() { return Rotate3d; },
  "RotateCcw": function() { return RotateCcw; },
  "RotateCw": function() { return RotateCw; },
  "Router": function() { return Router; },
  "Rows": function() { return Rows; },
  "Rss": function() { return Rss; },
  "Ruler": function() { return Ruler; },
  "RussianRuble": function() { return RussianRuble; },
  "Sailboat": function() { return Sailboat; },
  "Salad": function() { return Salad; },
  "Sandwich": function() { return Sandwich; },
  "Satellite": function() { return Satellite; },
  "SatelliteDish": function() { return SatelliteDish; },
  "Save": function() { return Save; },
  "SaveAll": function() { return SaveAll; },
  "Scale": function() { return Scale; },
  "Scale3d": function() { return Scale3d; },
  "Scaling": function() { return Scaling; },
  "Scan": function() { return Scan; },
  "ScanBarcode": function() { return ScanBarcode; },
  "ScanEye": function() { return ScanEye; },
  "ScanFace": function() { return ScanFace; },
  "ScanLine": function() { return ScanLine; },
  "ScanSearch": function() { return ScanSearch; },
  "ScanText": function() { return ScanText; },
  "ScatterChart": function() { return ScatterChart; },
  "School": function() { return School; },
  "School2": function() { return School2; },
  "Scissors": function() { return Scissors; },
  "ScissorsLineDashed": function() { return ScissorsLineDashed; },
  "ScissorsSquare": function() { return ScissorsSquare; },
  "ScissorsSquareDashedBottom": function() { return ScissorsSquareDashedBottom; },
  "ScreenShare": function() { return ScreenShare; },
  "ScreenShareOff": function() { return ScreenShareOff; },
  "Scroll": function() { return Scroll; },
  "ScrollText": function() { return ScrollText; },
  "Search": function() { return Search; },
  "SearchCheck": function() { return SearchCheck; },
  "SearchCode": function() { return SearchCode; },
  "SearchSlash": function() { return SearchSlash; },
  "SearchX": function() { return SearchX; },
  "Send": function() { return Send; },
  "SendHorizontal": function() { return SendHorizontal; },
  "SendToBack": function() { return SendToBack; },
  "SeparatorHorizontal": function() { return SeparatorHorizontal; },
  "SeparatorVertical": function() { return SeparatorVertical; },
  "Server": function() { return server_Server; },
  "ServerCog": function() { return ServerCog; },
  "ServerCrash": function() { return ServerCrash; },
  "ServerOff": function() { return ServerOff; },
  "Settings": function() { return Settings; },
  "Settings2": function() { return Settings2; },
  "Shapes": function() { return Shapes; },
  "Share": function() { return Share; },
  "Share2": function() { return Share2; },
  "Sheet": function() { return Sheet; },
  "Shell": function() { return Shell; },
  "Shield": function() { return Shield; },
  "ShieldAlert": function() { return ShieldAlert; },
  "ShieldBan": function() { return ShieldBan; },
  "ShieldCheck": function() { return ShieldCheck; },
  "ShieldEllipsis": function() { return ShieldEllipsis; },
  "ShieldHalf": function() { return ShieldHalf; },
  "ShieldMinus": function() { return ShieldMinus; },
  "ShieldOff": function() { return ShieldOff; },
  "ShieldPlus": function() { return ShieldPlus; },
  "ShieldQuestion": function() { return ShieldQuestion; },
  "ShieldX": function() { return ShieldX; },
  "Ship": function() { return Ship; },
  "ShipWheel": function() { return ShipWheel; },
  "Shirt": function() { return Shirt; },
  "ShoppingBag": function() { return ShoppingBag; },
  "ShoppingBasket": function() { return ShoppingBasket; },
  "ShoppingCart": function() { return ShoppingCart; },
  "Shovel": function() { return Shovel; },
  "ShowerHead": function() { return ShowerHead; },
  "Shrink": function() { return Shrink; },
  "Shrub": function() { return Shrub; },
  "Shuffle": function() { return Shuffle; },
  "Sigma": function() { return Sigma; },
  "SigmaSquare": function() { return SigmaSquare; },
  "Signal": function() { return Signal; },
  "SignalHigh": function() { return SignalHigh; },
  "SignalLow": function() { return SignalLow; },
  "SignalMedium": function() { return SignalMedium; },
  "SignalZero": function() { return SignalZero; },
  "Siren": function() { return Siren; },
  "SkipBack": function() { return SkipBack; },
  "SkipForward": function() { return SkipForward; },
  "Skull": function() { return Skull; },
  "Slack": function() { return Slack; },
  "Slash": function() { return Slash; },
  "Slice": function() { return Slice; },
  "Sliders": function() { return Sliders; },
  "SlidersHorizontal": function() { return SlidersHorizontal; },
  "Smartphone": function() { return Smartphone; },
  "SmartphoneCharging": function() { return SmartphoneCharging; },
  "SmartphoneNfc": function() { return SmartphoneNfc; },
  "Smile": function() { return Smile; },
  "SmilePlus": function() { return SmilePlus; },
  "Snail": function() { return Snail; },
  "Snowflake": function() { return Snowflake; },
  "Sofa": function() { return Sofa; },
  "Soup": function() { return Soup; },
  "Space": function() { return Space; },
  "Spade": function() { return Spade; },
  "Sparkle": function() { return Sparkle; },
  "Sparkles": function() { return Sparkles; },
  "Speaker": function() { return Speaker; },
  "Speech": function() { return Speech; },
  "SpellCheck": function() { return SpellCheck; },
  "SpellCheck2": function() { return SpellCheck2; },
  "Spline": function() { return Spline; },
  "Split": function() { return Split; },
  "SplitSquareHorizontal": function() { return SplitSquareHorizontal; },
  "SplitSquareVertical": function() { return SplitSquareVertical; },
  "SprayCan": function() { return SprayCan; },
  "Sprout": function() { return Sprout; },
  "Square": function() { return Square; },
  "SquareAsterisk": function() { return SquareAsterisk; },
  "SquareCode": function() { return SquareCode; },
  "SquareDashedBottom": function() { return SquareDashedBottom; },
  "SquareDashedBottomCode": function() { return SquareDashedBottomCode; },
  "SquareDot": function() { return SquareDot; },
  "SquareEqual": function() { return SquareEqual; },
  "SquareSlash": function() { return SquareSlash; },
  "SquareStack": function() { return SquareStack; },
  "Squirrel": function() { return Squirrel; },
  "Stamp": function() { return Stamp; },
  "Star": function() { return Star; },
  "StarHalf": function() { return StarHalf; },
  "StarOff": function() { return StarOff; },
  "StepBack": function() { return StepBack; },
  "StepForward": function() { return StepForward; },
  "Stethoscope": function() { return Stethoscope; },
  "Sticker": function() { return Sticker; },
  "StickyNote": function() { return StickyNote; },
  "StopCircle": function() { return StopCircle; },
  "Store": function() { return Store; },
  "StretchHorizontal": function() { return StretchHorizontal; },
  "StretchVertical": function() { return StretchVertical; },
  "Strikethrough": function() { return Strikethrough; },
  "Subscript": function() { return Subscript; },
  "Subtitles": function() { return Subtitles; },
  "Sun": function() { return Sun; },
  "SunDim": function() { return SunDim; },
  "SunMedium": function() { return SunMedium; },
  "SunMoon": function() { return SunMoon; },
  "SunSnow": function() { return SunSnow; },
  "Sunrise": function() { return Sunrise; },
  "Sunset": function() { return Sunset; },
  "Superscript": function() { return Superscript; },
  "SwissFranc": function() { return SwissFranc; },
  "SwitchCamera": function() { return SwitchCamera; },
  "Sword": function() { return Sword; },
  "Swords": function() { return Swords; },
  "Syringe": function() { return Syringe; },
  "Table": function() { return Table; },
  "Table2": function() { return Table2; },
  "TableProperties": function() { return TableProperties; },
  "Tablet": function() { return Tablet; },
  "TabletSmartphone": function() { return TabletSmartphone; },
  "Tablets": function() { return Tablets; },
  "Tag": function() { return Tag; },
  "Tags": function() { return Tags; },
  "Tally1": function() { return Tally1; },
  "Tally2": function() { return Tally2; },
  "Tally3": function() { return Tally3; },
  "Tally4": function() { return Tally4; },
  "Tally5": function() { return Tally5; },
  "Tangent": function() { return Tangent; },
  "Target": function() { return Target; },
  "Tent": function() { return Tent; },
  "TentTree": function() { return TentTree; },
  "Terminal": function() { return Terminal; },
  "TerminalSquare": function() { return TerminalSquare; },
  "TestTube": function() { return TestTube; },
  "TestTube2": function() { return TestTube2; },
  "TestTubes": function() { return TestTubes; },
  "Text": function() { return Text; },
  "TextCursor": function() { return TextCursor; },
  "TextCursorInput": function() { return TextCursorInput; },
  "TextQuote": function() { return TextQuote; },
  "TextSelect": function() { return TextSelect; },
  "Theater": function() { return Theater; },
  "Thermometer": function() { return Thermometer; },
  "ThermometerSnowflake": function() { return ThermometerSnowflake; },
  "ThermometerSun": function() { return ThermometerSun; },
  "ThumbsDown": function() { return ThumbsDown; },
  "ThumbsUp": function() { return ThumbsUp; },
  "Ticket": function() { return Ticket; },
  "Timer": function() { return Timer; },
  "TimerOff": function() { return TimerOff; },
  "TimerReset": function() { return TimerReset; },
  "ToggleLeft": function() { return ToggleLeft; },
  "ToggleRight": function() { return ToggleRight; },
  "Tornado": function() { return Tornado; },
  "Torus": function() { return Torus; },
  "Touchpad": function() { return Touchpad; },
  "TouchpadOff": function() { return TouchpadOff; },
  "TowerControl": function() { return TowerControl; },
  "ToyBrick": function() { return ToyBrick; },
  "Tractor": function() { return Tractor; },
  "TrafficCone": function() { return TrafficCone; },
  "TrainFront": function() { return TrainFront; },
  "TrainFrontTunnel": function() { return TrainFrontTunnel; },
  "TrainTrack": function() { return TrainTrack; },
  "TramFront": function() { return TramFront; },
  "Trash": function() { return Trash; },
  "Trash2": function() { return Trash2; },
  "TreeDeciduous": function() { return TreeDeciduous; },
  "TreePine": function() { return TreePine; },
  "Trees": function() { return Trees; },
  "Trello": function() { return Trello; },
  "TrendingDown": function() { return TrendingDown; },
  "TrendingUp": function() { return TrendingUp; },
  "Triangle": function() { return Triangle; },
  "TriangleRight": function() { return TriangleRight; },
  "Trophy": function() { return Trophy; },
  "Truck": function() { return Truck; },
  "Turtle": function() { return Turtle; },
  "Tv": function() { return Tv; },
  "Tv2": function() { return Tv2; },
  "Twitch": function() { return Twitch; },
  "Twitter": function() { return Twitter; },
  "Type": function() { return Type; },
  "Umbrella": function() { return Umbrella; },
  "Underline": function() { return Underline; },
  "Undo": function() { return Undo; },
  "Undo2": function() { return Undo2; },
  "UndoDot": function() { return UndoDot; },
  "UnfoldHorizontal": function() { return UnfoldHorizontal; },
  "UnfoldVertical": function() { return UnfoldVertical; },
  "Ungroup": function() { return Ungroup; },
  "Unlink": function() { return Unlink; },
  "Unlink2": function() { return Unlink2; },
  "Unlock": function() { return Unlock; },
  "UnlockKeyhole": function() { return UnlockKeyhole; },
  "Unplug": function() { return Unplug; },
  "Upload": function() { return Upload; },
  "UploadCloud": function() { return UploadCloud; },
  "Usb": function() { return Usb; },
  "User": function() { return User; },
  "User2": function() { return User2; },
  "UserCheck": function() { return UserCheck; },
  "UserCheck2": function() { return UserCheck2; },
  "UserCircle": function() { return UserCircle; },
  "UserCircle2": function() { return UserCircle2; },
  "UserCog": function() { return UserCog; },
  "UserCog2": function() { return UserCog2; },
  "UserMinus": function() { return UserMinus; },
  "UserMinus2": function() { return UserMinus2; },
  "UserPlus": function() { return UserPlus; },
  "UserPlus2": function() { return UserPlus2; },
  "UserSquare": function() { return UserSquare; },
  "UserSquare2": function() { return UserSquare2; },
  "UserX": function() { return UserX; },
  "UserX2": function() { return UserX2; },
  "Users": function() { return Users; },
  "Users2": function() { return Users2; },
  "Utensils": function() { return Utensils; },
  "UtensilsCrossed": function() { return UtensilsCrossed; },
  "UtilityPole": function() { return UtilityPole; },
  "Variable": function() { return Variable; },
  "Vegan": function() { return Vegan; },
  "VenetianMask": function() { return VenetianMask; },
  "Vibrate": function() { return Vibrate; },
  "VibrateOff": function() { return VibrateOff; },
  "Video": function() { return Video; },
  "VideoOff": function() { return VideoOff; },
  "Videotape": function() { return Videotape; },
  "View": function() { return View; },
  "Voicemail": function() { return Voicemail; },
  "Volume": function() { return Volume; },
  "Volume1": function() { return Volume1; },
  "Volume2": function() { return Volume2; },
  "VolumeX": function() { return VolumeX; },
  "Vote": function() { return Vote; },
  "Wallet": function() { return Wallet; },
  "Wallet2": function() { return Wallet2; },
  "WalletCards": function() { return WalletCards; },
  "Wallpaper": function() { return Wallpaper; },
  "Wand": function() { return Wand; },
  "Wand2": function() { return Wand2; },
  "Warehouse": function() { return Warehouse; },
  "Watch": function() { return Watch; },
  "Waves": function() { return Waves; },
  "Webcam": function() { return Webcam; },
  "Webhook": function() { return Webhook; },
  "Weight": function() { return Weight; },
  "Wheat": function() { return Wheat; },
  "WheatOff": function() { return WheatOff; },
  "WholeWord": function() { return WholeWord; },
  "Wifi": function() { return Wifi; },
  "WifiOff": function() { return WifiOff; },
  "Wind": function() { return Wind; },
  "Wine": function() { return Wine; },
  "WineOff": function() { return WineOff; },
  "Workflow": function() { return Workflow; },
  "WrapText": function() { return WrapText; },
  "Wrench": function() { return Wrench; },
  "X": function() { return x_X; },
  "XCircle": function() { return XCircle; },
  "XOctagon": function() { return XOctagon; },
  "XSquare": function() { return XSquare; },
  "Youtube": function() { return Youtube; },
  "Zap": function() { return Zap; },
  "ZapOff": function() { return ZapOff; },
  "ZoomIn": function() { return ZoomIn; },
  "ZoomOut": function() { return ZoomOut; }
});

// NAMESPACE OBJECT: ../../node_modules/lucide-react/dist/esm/lucide-react.js
var lucide_react_namespaceObject = {};
__webpack_require__.r(lucide_react_namespaceObject);
__webpack_require__.d(lucide_react_namespaceObject, {
  "Accessibility": function() { return Accessibility; },
  "AccessibilityIcon": function() { return Accessibility; },
  "Activity": function() { return Activity; },
  "ActivityIcon": function() { return Activity; },
  "ActivitySquare": function() { return ActivitySquare; },
  "ActivitySquareIcon": function() { return ActivitySquare; },
  "AirVent": function() { return AirVent; },
  "AirVentIcon": function() { return AirVent; },
  "Airplay": function() { return Airplay; },
  "AirplayIcon": function() { return Airplay; },
  "AlarmCheck": function() { return AlarmCheck; },
  "AlarmCheckIcon": function() { return AlarmCheck; },
  "AlarmClock": function() { return AlarmClock; },
  "AlarmClockIcon": function() { return AlarmClock; },
  "AlarmClockOff": function() { return AlarmClockOff; },
  "AlarmClockOffIcon": function() { return AlarmClockOff; },
  "AlarmMinus": function() { return AlarmMinus; },
  "AlarmMinusIcon": function() { return AlarmMinus; },
  "AlarmPlus": function() { return AlarmPlus; },
  "AlarmPlusIcon": function() { return AlarmPlus; },
  "Album": function() { return Album; },
  "AlbumIcon": function() { return Album; },
  "AlertCircle": function() { return AlertCircle; },
  "AlertCircleIcon": function() { return AlertCircle; },
  "AlertOctagon": function() { return AlertOctagon; },
  "AlertOctagonIcon": function() { return AlertOctagon; },
  "AlertTriangle": function() { return AlertTriangle; },
  "AlertTriangleIcon": function() { return AlertTriangle; },
  "AlignCenter": function() { return AlignCenter; },
  "AlignCenterHorizontal": function() { return AlignCenterHorizontal; },
  "AlignCenterHorizontalIcon": function() { return AlignCenterHorizontal; },
  "AlignCenterIcon": function() { return AlignCenter; },
  "AlignCenterVertical": function() { return AlignCenterVertical; },
  "AlignCenterVerticalIcon": function() { return AlignCenterVertical; },
  "AlignEndHorizontal": function() { return AlignEndHorizontal; },
  "AlignEndHorizontalIcon": function() { return AlignEndHorizontal; },
  "AlignEndVertical": function() { return AlignEndVertical; },
  "AlignEndVerticalIcon": function() { return AlignEndVertical; },
  "AlignHorizontalDistributeCenter": function() { return AlignHorizontalDistributeCenter; },
  "AlignHorizontalDistributeCenterIcon": function() { return AlignHorizontalDistributeCenter; },
  "AlignHorizontalDistributeEnd": function() { return AlignHorizontalDistributeEnd; },
  "AlignHorizontalDistributeEndIcon": function() { return AlignHorizontalDistributeEnd; },
  "AlignHorizontalDistributeStart": function() { return AlignHorizontalDistributeStart; },
  "AlignHorizontalDistributeStartIcon": function() { return AlignHorizontalDistributeStart; },
  "AlignHorizontalJustifyCenter": function() { return AlignHorizontalJustifyCenter; },
  "AlignHorizontalJustifyCenterIcon": function() { return AlignHorizontalJustifyCenter; },
  "AlignHorizontalJustifyEnd": function() { return AlignHorizontalJustifyEnd; },
  "AlignHorizontalJustifyEndIcon": function() { return AlignHorizontalJustifyEnd; },
  "AlignHorizontalJustifyStart": function() { return AlignHorizontalJustifyStart; },
  "AlignHorizontalJustifyStartIcon": function() { return AlignHorizontalJustifyStart; },
  "AlignHorizontalSpaceAround": function() { return AlignHorizontalSpaceAround; },
  "AlignHorizontalSpaceAroundIcon": function() { return AlignHorizontalSpaceAround; },
  "AlignHorizontalSpaceBetween": function() { return AlignHorizontalSpaceBetween; },
  "AlignHorizontalSpaceBetweenIcon": function() { return AlignHorizontalSpaceBetween; },
  "AlignJustify": function() { return AlignJustify; },
  "AlignJustifyIcon": function() { return AlignJustify; },
  "AlignLeft": function() { return AlignLeft; },
  "AlignLeftIcon": function() { return AlignLeft; },
  "AlignRight": function() { return AlignRight; },
  "AlignRightIcon": function() { return AlignRight; },
  "AlignStartHorizontal": function() { return AlignStartHorizontal; },
  "AlignStartHorizontalIcon": function() { return AlignStartHorizontal; },
  "AlignStartVertical": function() { return AlignStartVertical; },
  "AlignStartVerticalIcon": function() { return AlignStartVertical; },
  "AlignVerticalDistributeCenter": function() { return AlignVerticalDistributeCenter; },
  "AlignVerticalDistributeCenterIcon": function() { return AlignVerticalDistributeCenter; },
  "AlignVerticalDistributeEnd": function() { return AlignVerticalDistributeEnd; },
  "AlignVerticalDistributeEndIcon": function() { return AlignVerticalDistributeEnd; },
  "AlignVerticalDistributeStart": function() { return AlignVerticalDistributeStart; },
  "AlignVerticalDistributeStartIcon": function() { return AlignVerticalDistributeStart; },
  "AlignVerticalJustifyCenter": function() { return AlignVerticalJustifyCenter; },
  "AlignVerticalJustifyCenterIcon": function() { return AlignVerticalJustifyCenter; },
  "AlignVerticalJustifyEnd": function() { return AlignVerticalJustifyEnd; },
  "AlignVerticalJustifyEndIcon": function() { return AlignVerticalJustifyEnd; },
  "AlignVerticalJustifyStart": function() { return AlignVerticalJustifyStart; },
  "AlignVerticalJustifyStartIcon": function() { return AlignVerticalJustifyStart; },
  "AlignVerticalSpaceAround": function() { return AlignVerticalSpaceAround; },
  "AlignVerticalSpaceAroundIcon": function() { return AlignVerticalSpaceAround; },
  "AlignVerticalSpaceBetween": function() { return AlignVerticalSpaceBetween; },
  "AlignVerticalSpaceBetweenIcon": function() { return AlignVerticalSpaceBetween; },
  "Ampersand": function() { return Ampersand; },
  "AmpersandIcon": function() { return Ampersand; },
  "Ampersands": function() { return Ampersands; },
  "AmpersandsIcon": function() { return Ampersands; },
  "Anchor": function() { return Anchor; },
  "AnchorIcon": function() { return Anchor; },
  "Angry": function() { return Angry; },
  "AngryIcon": function() { return Angry; },
  "Annoyed": function() { return Annoyed; },
  "AnnoyedIcon": function() { return Annoyed; },
  "Antenna": function() { return Antenna; },
  "AntennaIcon": function() { return Antenna; },
  "Aperture": function() { return Aperture; },
  "ApertureIcon": function() { return Aperture; },
  "AppWindow": function() { return AppWindow; },
  "AppWindowIcon": function() { return AppWindow; },
  "Apple": function() { return Apple; },
  "AppleIcon": function() { return Apple; },
  "Archive": function() { return Archive; },
  "ArchiveIcon": function() { return Archive; },
  "ArchiveRestore": function() { return ArchiveRestore; },
  "ArchiveRestoreIcon": function() { return ArchiveRestore; },
  "ArchiveX": function() { return ArchiveX; },
  "ArchiveXIcon": function() { return ArchiveX; },
  "AreaChart": function() { return AreaChart; },
  "AreaChartIcon": function() { return AreaChart; },
  "Armchair": function() { return Armchair; },
  "ArmchairIcon": function() { return Armchair; },
  "ArrowBigDown": function() { return ArrowBigDown; },
  "ArrowBigDownDash": function() { return ArrowBigDownDash; },
  "ArrowBigDownDashIcon": function() { return ArrowBigDownDash; },
  "ArrowBigDownIcon": function() { return ArrowBigDown; },
  "ArrowBigLeft": function() { return ArrowBigLeft; },
  "ArrowBigLeftDash": function() { return ArrowBigLeftDash; },
  "ArrowBigLeftDashIcon": function() { return ArrowBigLeftDash; },
  "ArrowBigLeftIcon": function() { return ArrowBigLeft; },
  "ArrowBigRight": function() { return ArrowBigRight; },
  "ArrowBigRightDash": function() { return ArrowBigRightDash; },
  "ArrowBigRightDashIcon": function() { return ArrowBigRightDash; },
  "ArrowBigRightIcon": function() { return ArrowBigRight; },
  "ArrowBigUp": function() { return ArrowBigUp; },
  "ArrowBigUpDash": function() { return ArrowBigUpDash; },
  "ArrowBigUpDashIcon": function() { return ArrowBigUpDash; },
  "ArrowBigUpIcon": function() { return ArrowBigUp; },
  "ArrowDown": function() { return ArrowDown; },
  "ArrowDown01": function() { return ArrowDown01; },
  "ArrowDown01Icon": function() { return ArrowDown01; },
  "ArrowDown10": function() { return ArrowDown10; },
  "ArrowDown10Icon": function() { return ArrowDown10; },
  "ArrowDownAZ": function() { return ArrowDownAZ; },
  "ArrowDownAZIcon": function() { return ArrowDownAZ; },
  "ArrowDownAz": function() { return ArrowDownAZ; },
  "ArrowDownAzIcon": function() { return ArrowDownAZ; },
  "ArrowDownCircle": function() { return ArrowDownCircle; },
  "ArrowDownCircleIcon": function() { return ArrowDownCircle; },
  "ArrowDownFromLine": function() { return ArrowDownFromLine; },
  "ArrowDownFromLineIcon": function() { return ArrowDownFromLine; },
  "ArrowDownIcon": function() { return ArrowDown; },
  "ArrowDownLeft": function() { return ArrowDownLeft; },
  "ArrowDownLeftFromCircle": function() { return ArrowDownLeftFromCircle; },
  "ArrowDownLeftFromCircleIcon": function() { return ArrowDownLeftFromCircle; },
  "ArrowDownLeftIcon": function() { return ArrowDownLeft; },
  "ArrowDownLeftSquare": function() { return ArrowDownLeftSquare; },
  "ArrowDownLeftSquareIcon": function() { return ArrowDownLeftSquare; },
  "ArrowDownNarrowWide": function() { return ArrowDownNarrowWide; },
  "ArrowDownNarrowWideIcon": function() { return ArrowDownNarrowWide; },
  "ArrowDownRight": function() { return ArrowDownRight; },
  "ArrowDownRightFromCircle": function() { return ArrowDownRightFromCircle; },
  "ArrowDownRightFromCircleIcon": function() { return ArrowDownRightFromCircle; },
  "ArrowDownRightIcon": function() { return ArrowDownRight; },
  "ArrowDownRightSquare": function() { return ArrowDownRightSquare; },
  "ArrowDownRightSquareIcon": function() { return ArrowDownRightSquare; },
  "ArrowDownSquare": function() { return ArrowDownSquare; },
  "ArrowDownSquareIcon": function() { return ArrowDownSquare; },
  "ArrowDownToDot": function() { return ArrowDownToDot; },
  "ArrowDownToDotIcon": function() { return ArrowDownToDot; },
  "ArrowDownToLine": function() { return ArrowDownToLine; },
  "ArrowDownToLineIcon": function() { return ArrowDownToLine; },
  "ArrowDownUp": function() { return ArrowDownUp; },
  "ArrowDownUpIcon": function() { return ArrowDownUp; },
  "ArrowDownWideNarrow": function() { return ArrowDownWideNarrow; },
  "ArrowDownWideNarrowIcon": function() { return ArrowDownWideNarrow; },
  "ArrowDownZA": function() { return ArrowDownZA; },
  "ArrowDownZAIcon": function() { return ArrowDownZA; },
  "ArrowDownZa": function() { return ArrowDownZA; },
  "ArrowDownZaIcon": function() { return ArrowDownZA; },
  "ArrowLeft": function() { return ArrowLeft; },
  "ArrowLeftCircle": function() { return ArrowLeftCircle; },
  "ArrowLeftCircleIcon": function() { return ArrowLeftCircle; },
  "ArrowLeftFromLine": function() { return ArrowLeftFromLine; },
  "ArrowLeftFromLineIcon": function() { return ArrowLeftFromLine; },
  "ArrowLeftIcon": function() { return ArrowLeft; },
  "ArrowLeftRight": function() { return ArrowLeftRight; },
  "ArrowLeftRightIcon": function() { return ArrowLeftRight; },
  "ArrowLeftSquare": function() { return ArrowLeftSquare; },
  "ArrowLeftSquareIcon": function() { return ArrowLeftSquare; },
  "ArrowLeftToLine": function() { return ArrowLeftToLine; },
  "ArrowLeftToLineIcon": function() { return ArrowLeftToLine; },
  "ArrowRight": function() { return ArrowRight; },
  "ArrowRightCircle": function() { return ArrowRightCircle; },
  "ArrowRightCircleIcon": function() { return ArrowRightCircle; },
  "ArrowRightFromLine": function() { return ArrowRightFromLine; },
  "ArrowRightFromLineIcon": function() { return ArrowRightFromLine; },
  "ArrowRightIcon": function() { return ArrowRight; },
  "ArrowRightLeft": function() { return ArrowRightLeft; },
  "ArrowRightLeftIcon": function() { return ArrowRightLeft; },
  "ArrowRightSquare": function() { return ArrowRightSquare; },
  "ArrowRightSquareIcon": function() { return ArrowRightSquare; },
  "ArrowRightToLine": function() { return ArrowRightToLine; },
  "ArrowRightToLineIcon": function() { return ArrowRightToLine; },
  "ArrowUp": function() { return ArrowUp; },
  "ArrowUp01": function() { return ArrowUp01; },
  "ArrowUp01Icon": function() { return ArrowUp01; },
  "ArrowUp10": function() { return ArrowUp10; },
  "ArrowUp10Icon": function() { return ArrowUp10; },
  "ArrowUpAZ": function() { return ArrowUpAZ; },
  "ArrowUpAZIcon": function() { return ArrowUpAZ; },
  "ArrowUpAz": function() { return ArrowUpAZ; },
  "ArrowUpAzIcon": function() { return ArrowUpAZ; },
  "ArrowUpCircle": function() { return ArrowUpCircle; },
  "ArrowUpCircleIcon": function() { return ArrowUpCircle; },
  "ArrowUpDown": function() { return ArrowUpDown; },
  "ArrowUpDownIcon": function() { return ArrowUpDown; },
  "ArrowUpFromDot": function() { return ArrowUpFromDot; },
  "ArrowUpFromDotIcon": function() { return ArrowUpFromDot; },
  "ArrowUpFromLine": function() { return ArrowUpFromLine; },
  "ArrowUpFromLineIcon": function() { return ArrowUpFromLine; },
  "ArrowUpIcon": function() { return ArrowUp; },
  "ArrowUpLeft": function() { return ArrowUpLeft; },
  "ArrowUpLeftFromCircle": function() { return ArrowUpLeftFromCircle; },
  "ArrowUpLeftFromCircleIcon": function() { return ArrowUpLeftFromCircle; },
  "ArrowUpLeftIcon": function() { return ArrowUpLeft; },
  "ArrowUpLeftSquare": function() { return ArrowUpLeftSquare; },
  "ArrowUpLeftSquareIcon": function() { return ArrowUpLeftSquare; },
  "ArrowUpNarrowWide": function() { return ArrowUpNarrowWide; },
  "ArrowUpNarrowWideIcon": function() { return ArrowUpNarrowWide; },
  "ArrowUpRight": function() { return ArrowUpRight; },
  "ArrowUpRightFromCircle": function() { return ArrowUpRightFromCircle; },
  "ArrowUpRightFromCircleIcon": function() { return ArrowUpRightFromCircle; },
  "ArrowUpRightIcon": function() { return ArrowUpRight; },
  "ArrowUpRightSquare": function() { return ArrowUpRightSquare; },
  "ArrowUpRightSquareIcon": function() { return ArrowUpRightSquare; },
  "ArrowUpSquare": function() { return ArrowUpSquare; },
  "ArrowUpSquareIcon": function() { return ArrowUpSquare; },
  "ArrowUpToLine": function() { return ArrowUpToLine; },
  "ArrowUpToLineIcon": function() { return ArrowUpToLine; },
  "ArrowUpWideNarrow": function() { return ArrowUpWideNarrow; },
  "ArrowUpWideNarrowIcon": function() { return ArrowUpWideNarrow; },
  "ArrowUpZA": function() { return ArrowUpZA; },
  "ArrowUpZAIcon": function() { return ArrowUpZA; },
  "ArrowUpZa": function() { return ArrowUpZA; },
  "ArrowUpZaIcon": function() { return ArrowUpZA; },
  "ArrowsUpFromLine": function() { return ArrowsUpFromLine; },
  "ArrowsUpFromLineIcon": function() { return ArrowsUpFromLine; },
  "Asterisk": function() { return Asterisk; },
  "AsteriskIcon": function() { return Asterisk; },
  "AtSign": function() { return AtSign; },
  "AtSignIcon": function() { return AtSign; },
  "Atom": function() { return Atom; },
  "AtomIcon": function() { return Atom; },
  "Award": function() { return Award; },
  "AwardIcon": function() { return Award; },
  "Axe": function() { return Axe; },
  "AxeIcon": function() { return Axe; },
  "Axis3D": function() { return Axis3d; },
  "Axis3DIcon": function() { return Axis3d; },
  "Axis3d": function() { return Axis3d; },
  "Axis3dIcon": function() { return Axis3d; },
  "Baby": function() { return Baby; },
  "BabyIcon": function() { return Baby; },
  "Backpack": function() { return Backpack; },
  "BackpackIcon": function() { return Backpack; },
  "Badge": function() { return Badge; },
  "BadgeAlert": function() { return BadgeAlert; },
  "BadgeAlertIcon": function() { return BadgeAlert; },
  "BadgeCent": function() { return BadgeCent; },
  "BadgeCentIcon": function() { return BadgeCent; },
  "BadgeCheck": function() { return BadgeCheck; },
  "BadgeCheckIcon": function() { return BadgeCheck; },
  "BadgeDollarSign": function() { return BadgeDollarSign; },
  "BadgeDollarSignIcon": function() { return BadgeDollarSign; },
  "BadgeEuro": function() { return BadgeEuro; },
  "BadgeEuroIcon": function() { return BadgeEuro; },
  "BadgeHelp": function() { return BadgeHelp; },
  "BadgeHelpIcon": function() { return BadgeHelp; },
  "BadgeIcon": function() { return Badge; },
  "BadgeIndianRupee": function() { return BadgeIndianRupee; },
  "BadgeIndianRupeeIcon": function() { return BadgeIndianRupee; },
  "BadgeInfo": function() { return BadgeInfo; },
  "BadgeInfoIcon": function() { return BadgeInfo; },
  "BadgeJapaneseYen": function() { return BadgeJapaneseYen; },
  "BadgeJapaneseYenIcon": function() { return BadgeJapaneseYen; },
  "BadgeMinus": function() { return BadgeMinus; },
  "BadgeMinusIcon": function() { return BadgeMinus; },
  "BadgePercent": function() { return BadgePercent; },
  "BadgePercentIcon": function() { return BadgePercent; },
  "BadgePlus": function() { return BadgePlus; },
  "BadgePlusIcon": function() { return BadgePlus; },
  "BadgePoundSterling": function() { return BadgePoundSterling; },
  "BadgePoundSterlingIcon": function() { return BadgePoundSterling; },
  "BadgeRussianRuble": function() { return BadgeRussianRuble; },
  "BadgeRussianRubleIcon": function() { return BadgeRussianRuble; },
  "BadgeSwissFranc": function() { return BadgeSwissFranc; },
  "BadgeSwissFrancIcon": function() { return BadgeSwissFranc; },
  "BadgeX": function() { return BadgeX; },
  "BadgeXIcon": function() { return BadgeX; },
  "BaggageClaim": function() { return BaggageClaim; },
  "BaggageClaimIcon": function() { return BaggageClaim; },
  "Ban": function() { return Ban; },
  "BanIcon": function() { return Ban; },
  "Banana": function() { return Banana; },
  "BananaIcon": function() { return Banana; },
  "Banknote": function() { return Banknote; },
  "BanknoteIcon": function() { return Banknote; },
  "BarChart": function() { return BarChart; },
  "BarChart2": function() { return BarChart2; },
  "BarChart2Icon": function() { return BarChart2; },
  "BarChart3": function() { return BarChart3; },
  "BarChart3Icon": function() { return BarChart3; },
  "BarChart4": function() { return BarChart4; },
  "BarChart4Icon": function() { return BarChart4; },
  "BarChartBig": function() { return BarChartBig; },
  "BarChartBigIcon": function() { return BarChartBig; },
  "BarChartHorizontal": function() { return BarChartHorizontal; },
  "BarChartHorizontalBig": function() { return BarChartHorizontalBig; },
  "BarChartHorizontalBigIcon": function() { return BarChartHorizontalBig; },
  "BarChartHorizontalIcon": function() { return BarChartHorizontal; },
  "BarChartIcon": function() { return BarChart; },
  "Barcode": function() { return Barcode; },
  "BarcodeIcon": function() { return Barcode; },
  "Baseline": function() { return Baseline; },
  "BaselineIcon": function() { return Baseline; },
  "Bath": function() { return Bath; },
  "BathIcon": function() { return Bath; },
  "Battery": function() { return Battery; },
  "BatteryCharging": function() { return BatteryCharging; },
  "BatteryChargingIcon": function() { return BatteryCharging; },
  "BatteryFull": function() { return BatteryFull; },
  "BatteryFullIcon": function() { return BatteryFull; },
  "BatteryIcon": function() { return Battery; },
  "BatteryLow": function() { return BatteryLow; },
  "BatteryLowIcon": function() { return BatteryLow; },
  "BatteryMedium": function() { return BatteryMedium; },
  "BatteryMediumIcon": function() { return BatteryMedium; },
  "BatteryWarning": function() { return BatteryWarning; },
  "BatteryWarningIcon": function() { return BatteryWarning; },
  "Beaker": function() { return Beaker; },
  "BeakerIcon": function() { return Beaker; },
  "Bean": function() { return Bean; },
  "BeanIcon": function() { return Bean; },
  "BeanOff": function() { return BeanOff; },
  "BeanOffIcon": function() { return BeanOff; },
  "Bed": function() { return Bed; },
  "BedDouble": function() { return BedDouble; },
  "BedDoubleIcon": function() { return BedDouble; },
  "BedIcon": function() { return Bed; },
  "BedSingle": function() { return BedSingle; },
  "BedSingleIcon": function() { return BedSingle; },
  "Beef": function() { return Beef; },
  "BeefIcon": function() { return Beef; },
  "Beer": function() { return Beer; },
  "BeerIcon": function() { return Beer; },
  "Bell": function() { return Bell; },
  "BellDot": function() { return BellDot; },
  "BellDotIcon": function() { return BellDot; },
  "BellIcon": function() { return Bell; },
  "BellMinus": function() { return BellMinus; },
  "BellMinusIcon": function() { return BellMinus; },
  "BellOff": function() { return BellOff; },
  "BellOffIcon": function() { return BellOff; },
  "BellPlus": function() { return BellPlus; },
  "BellPlusIcon": function() { return BellPlus; },
  "BellRing": function() { return BellRing; },
  "BellRingIcon": function() { return BellRing; },
  "Bike": function() { return Bike; },
  "BikeIcon": function() { return Bike; },
  "Binary": function() { return Binary; },
  "BinaryIcon": function() { return Binary; },
  "Biohazard": function() { return Biohazard; },
  "BiohazardIcon": function() { return Biohazard; },
  "Bird": function() { return Bird; },
  "BirdIcon": function() { return Bird; },
  "Bitcoin": function() { return Bitcoin; },
  "BitcoinIcon": function() { return Bitcoin; },
  "Blinds": function() { return Blinds; },
  "BlindsIcon": function() { return Blinds; },
  "Blocks": function() { return Blocks; },
  "BlocksIcon": function() { return Blocks; },
  "Bluetooth": function() { return Bluetooth; },
  "BluetoothConnected": function() { return BluetoothConnected; },
  "BluetoothConnectedIcon": function() { return BluetoothConnected; },
  "BluetoothIcon": function() { return Bluetooth; },
  "BluetoothOff": function() { return BluetoothOff; },
  "BluetoothOffIcon": function() { return BluetoothOff; },
  "BluetoothSearching": function() { return BluetoothSearching; },
  "BluetoothSearchingIcon": function() { return BluetoothSearching; },
  "Bold": function() { return Bold; },
  "BoldIcon": function() { return Bold; },
  "Bomb": function() { return Bomb; },
  "BombIcon": function() { return Bomb; },
  "Bone": function() { return Bone; },
  "BoneIcon": function() { return Bone; },
  "Book": function() { return Book; },
  "BookCopy": function() { return BookCopy; },
  "BookCopyIcon": function() { return BookCopy; },
  "BookDown": function() { return BookDown; },
  "BookDownIcon": function() { return BookDown; },
  "BookIcon": function() { return Book; },
  "BookKey": function() { return BookKey; },
  "BookKeyIcon": function() { return BookKey; },
  "BookLock": function() { return BookLock; },
  "BookLockIcon": function() { return BookLock; },
  "BookMarked": function() { return BookMarked; },
  "BookMarkedIcon": function() { return BookMarked; },
  "BookMinus": function() { return BookMinus; },
  "BookMinusIcon": function() { return BookMinus; },
  "BookOpen": function() { return BookOpen; },
  "BookOpenCheck": function() { return BookOpenCheck; },
  "BookOpenCheckIcon": function() { return BookOpenCheck; },
  "BookOpenIcon": function() { return BookOpen; },
  "BookPlus": function() { return BookPlus; },
  "BookPlusIcon": function() { return BookPlus; },
  "BookTemplate": function() { return BookTemplate; },
  "BookTemplateIcon": function() { return BookTemplate; },
  "BookUp": function() { return BookUp; },
  "BookUp2": function() { return BookUp2; },
  "BookUp2Icon": function() { return BookUp2; },
  "BookUpIcon": function() { return BookUp; },
  "BookX": function() { return BookX; },
  "BookXIcon": function() { return BookX; },
  "Bookmark": function() { return Bookmark; },
  "BookmarkCheck": function() { return BookmarkCheck; },
  "BookmarkCheckIcon": function() { return BookmarkCheck; },
  "BookmarkIcon": function() { return Bookmark; },
  "BookmarkMinus": function() { return BookmarkMinus; },
  "BookmarkMinusIcon": function() { return BookmarkMinus; },
  "BookmarkPlus": function() { return BookmarkPlus; },
  "BookmarkPlusIcon": function() { return BookmarkPlus; },
  "BookmarkX": function() { return BookmarkX; },
  "BookmarkXIcon": function() { return BookmarkX; },
  "BoomBox": function() { return BoomBox; },
  "BoomBoxIcon": function() { return BoomBox; },
  "Bot": function() { return Bot; },
  "BotIcon": function() { return Bot; },
  "Box": function() { return Box; },
  "BoxIcon": function() { return Box; },
  "BoxSelect": function() { return BoxSelect; },
  "BoxSelectIcon": function() { return BoxSelect; },
  "Boxes": function() { return Boxes; },
  "BoxesIcon": function() { return Boxes; },
  "Braces": function() { return Braces; },
  "BracesIcon": function() { return Braces; },
  "Brackets": function() { return Brackets; },
  "BracketsIcon": function() { return Brackets; },
  "Brain": function() { return Brain; },
  "BrainCircuit": function() { return BrainCircuit; },
  "BrainCircuitIcon": function() { return BrainCircuit; },
  "BrainCog": function() { return BrainCog; },
  "BrainCogIcon": function() { return BrainCog; },
  "BrainIcon": function() { return Brain; },
  "Briefcase": function() { return Briefcase; },
  "BriefcaseIcon": function() { return Briefcase; },
  "BringToFront": function() { return BringToFront; },
  "BringToFrontIcon": function() { return BringToFront; },
  "Brush": function() { return Brush; },
  "BrushIcon": function() { return Brush; },
  "Bug": function() { return Bug; },
  "BugIcon": function() { return Bug; },
  "BugOff": function() { return BugOff; },
  "BugOffIcon": function() { return BugOff; },
  "BugPlay": function() { return BugPlay; },
  "BugPlayIcon": function() { return BugPlay; },
  "Building": function() { return Building; },
  "Building2": function() { return Building2; },
  "Building2Icon": function() { return Building2; },
  "BuildingIcon": function() { return Building; },
  "Bus": function() { return Bus; },
  "BusFront": function() { return BusFront; },
  "BusFrontIcon": function() { return BusFront; },
  "BusIcon": function() { return Bus; },
  "Cable": function() { return Cable; },
  "CableCar": function() { return CableCar; },
  "CableCarIcon": function() { return CableCar; },
  "CableIcon": function() { return Cable; },
  "Cake": function() { return Cake; },
  "CakeIcon": function() { return Cake; },
  "CakeSlice": function() { return CakeSlice; },
  "CakeSliceIcon": function() { return CakeSlice; },
  "Calculator": function() { return Calculator; },
  "CalculatorIcon": function() { return Calculator; },
  "Calendar": function() { return Calendar; },
  "CalendarCheck": function() { return CalendarCheck; },
  "CalendarCheck2": function() { return CalendarCheck2; },
  "CalendarCheck2Icon": function() { return CalendarCheck2; },
  "CalendarCheckIcon": function() { return CalendarCheck; },
  "CalendarClock": function() { return CalendarClock; },
  "CalendarClockIcon": function() { return CalendarClock; },
  "CalendarDays": function() { return CalendarDays; },
  "CalendarDaysIcon": function() { return CalendarDays; },
  "CalendarHeart": function() { return CalendarHeart; },
  "CalendarHeartIcon": function() { return CalendarHeart; },
  "CalendarIcon": function() { return Calendar; },
  "CalendarMinus": function() { return CalendarMinus; },
  "CalendarMinusIcon": function() { return CalendarMinus; },
  "CalendarOff": function() { return CalendarOff; },
  "CalendarOffIcon": function() { return CalendarOff; },
  "CalendarPlus": function() { return CalendarPlus; },
  "CalendarPlusIcon": function() { return CalendarPlus; },
  "CalendarRange": function() { return CalendarRange; },
  "CalendarRangeIcon": function() { return CalendarRange; },
  "CalendarSearch": function() { return CalendarSearch; },
  "CalendarSearchIcon": function() { return CalendarSearch; },
  "CalendarX": function() { return CalendarX; },
  "CalendarX2": function() { return CalendarX2; },
  "CalendarX2Icon": function() { return CalendarX2; },
  "CalendarXIcon": function() { return CalendarX; },
  "Camera": function() { return Camera; },
  "CameraIcon": function() { return Camera; },
  "CameraOff": function() { return CameraOff; },
  "CameraOffIcon": function() { return CameraOff; },
  "CandlestickChart": function() { return CandlestickChart; },
  "CandlestickChartIcon": function() { return CandlestickChart; },
  "Candy": function() { return Candy; },
  "CandyCane": function() { return CandyCane; },
  "CandyCaneIcon": function() { return CandyCane; },
  "CandyIcon": function() { return Candy; },
  "CandyOff": function() { return CandyOff; },
  "CandyOffIcon": function() { return CandyOff; },
  "Car": function() { return Car; },
  "CarFront": function() { return CarFront; },
  "CarFrontIcon": function() { return CarFront; },
  "CarIcon": function() { return Car; },
  "CarTaxiFront": function() { return CarTaxiFront; },
  "CarTaxiFrontIcon": function() { return CarTaxiFront; },
  "Caravan": function() { return Caravan; },
  "CaravanIcon": function() { return Caravan; },
  "Carrot": function() { return Carrot; },
  "CarrotIcon": function() { return Carrot; },
  "CaseLower": function() { return CaseLower; },
  "CaseLowerIcon": function() { return CaseLower; },
  "CaseSensitive": function() { return CaseSensitive; },
  "CaseSensitiveIcon": function() { return CaseSensitive; },
  "CaseUpper": function() { return CaseUpper; },
  "CaseUpperIcon": function() { return CaseUpper; },
  "CassetteTape": function() { return CassetteTape; },
  "CassetteTapeIcon": function() { return CassetteTape; },
  "Cast": function() { return Cast; },
  "CastIcon": function() { return Cast; },
  "Castle": function() { return Castle; },
  "CastleIcon": function() { return Castle; },
  "Cat": function() { return Cat; },
  "CatIcon": function() { return Cat; },
  "Check": function() { return Check; },
  "CheckCheck": function() { return CheckCheck; },
  "CheckCheckIcon": function() { return CheckCheck; },
  "CheckCircle": function() { return CheckCircle; },
  "CheckCircle2": function() { return CheckCircle2; },
  "CheckCircle2Icon": function() { return CheckCircle2; },
  "CheckCircleIcon": function() { return CheckCircle; },
  "CheckIcon": function() { return Check; },
  "CheckSquare": function() { return CheckSquare; },
  "CheckSquareIcon": function() { return CheckSquare; },
  "ChefHat": function() { return ChefHat; },
  "ChefHatIcon": function() { return ChefHat; },
  "Cherry": function() { return Cherry; },
  "CherryIcon": function() { return Cherry; },
  "ChevronDown": function() { return ChevronDown; },
  "ChevronDownCircle": function() { return ChevronDownCircle; },
  "ChevronDownCircleIcon": function() { return ChevronDownCircle; },
  "ChevronDownIcon": function() { return ChevronDown; },
  "ChevronDownSquare": function() { return ChevronDownSquare; },
  "ChevronDownSquareIcon": function() { return ChevronDownSquare; },
  "ChevronFirst": function() { return ChevronFirst; },
  "ChevronFirstIcon": function() { return ChevronFirst; },
  "ChevronLast": function() { return ChevronLast; },
  "ChevronLastIcon": function() { return ChevronLast; },
  "ChevronLeft": function() { return ChevronLeft; },
  "ChevronLeftCircle": function() { return ChevronLeftCircle; },
  "ChevronLeftCircleIcon": function() { return ChevronLeftCircle; },
  "ChevronLeftIcon": function() { return ChevronLeft; },
  "ChevronLeftSquare": function() { return ChevronLeftSquare; },
  "ChevronLeftSquareIcon": function() { return ChevronLeftSquare; },
  "ChevronRight": function() { return ChevronRight; },
  "ChevronRightCircle": function() { return ChevronRightCircle; },
  "ChevronRightCircleIcon": function() { return ChevronRightCircle; },
  "ChevronRightIcon": function() { return ChevronRight; },
  "ChevronRightSquare": function() { return ChevronRightSquare; },
  "ChevronRightSquareIcon": function() { return ChevronRightSquare; },
  "ChevronUp": function() { return ChevronUp; },
  "ChevronUpCircle": function() { return ChevronUpCircle; },
  "ChevronUpCircleIcon": function() { return ChevronUpCircle; },
  "ChevronUpIcon": function() { return ChevronUp; },
  "ChevronUpSquare": function() { return ChevronUpSquare; },
  "ChevronUpSquareIcon": function() { return ChevronUpSquare; },
  "ChevronsDown": function() { return ChevronsDown; },
  "ChevronsDownIcon": function() { return ChevronsDown; },
  "ChevronsDownUp": function() { return ChevronsDownUp; },
  "ChevronsDownUpIcon": function() { return ChevronsDownUp; },
  "ChevronsLeft": function() { return ChevronsLeft; },
  "ChevronsLeftIcon": function() { return ChevronsLeft; },
  "ChevronsLeftRight": function() { return ChevronsLeftRight; },
  "ChevronsLeftRightIcon": function() { return ChevronsLeftRight; },
  "ChevronsRight": function() { return ChevronsRight; },
  "ChevronsRightIcon": function() { return ChevronsRight; },
  "ChevronsRightLeft": function() { return ChevronsRightLeft; },
  "ChevronsRightLeftIcon": function() { return ChevronsRightLeft; },
  "ChevronsUp": function() { return ChevronsUp; },
  "ChevronsUpDown": function() { return ChevronsUpDown; },
  "ChevronsUpDownIcon": function() { return ChevronsUpDown; },
  "ChevronsUpIcon": function() { return ChevronsUp; },
  "Chrome": function() { return Chrome; },
  "ChromeIcon": function() { return Chrome; },
  "Church": function() { return Church; },
  "ChurchIcon": function() { return Church; },
  "Cigarette": function() { return Cigarette; },
  "CigaretteIcon": function() { return Cigarette; },
  "CigaretteOff": function() { return CigaretteOff; },
  "CigaretteOffIcon": function() { return CigaretteOff; },
  "Circle": function() { return Circle; },
  "CircleDashed": function() { return CircleDashed; },
  "CircleDashedIcon": function() { return CircleDashed; },
  "CircleDollarSign": function() { return CircleDollarSign; },
  "CircleDollarSignIcon": function() { return CircleDollarSign; },
  "CircleDot": function() { return CircleDot; },
  "CircleDotDashed": function() { return CircleDotDashed; },
  "CircleDotDashedIcon": function() { return CircleDotDashed; },
  "CircleDotIcon": function() { return CircleDot; },
  "CircleEllipsis": function() { return CircleEllipsis; },
  "CircleEllipsisIcon": function() { return CircleEllipsis; },
  "CircleEqual": function() { return CircleEqual; },
  "CircleEqualIcon": function() { return CircleEqual; },
  "CircleIcon": function() { return Circle; },
  "CircleOff": function() { return CircleOff; },
  "CircleOffIcon": function() { return CircleOff; },
  "CircleSlash": function() { return CircleSlash; },
  "CircleSlash2": function() { return CircleSlash2; },
  "CircleSlash2Icon": function() { return CircleSlash2; },
  "CircleSlashIcon": function() { return CircleSlash; },
  "CircleSlashed": function() { return CircleSlash2; },
  "CircleSlashedIcon": function() { return CircleSlash2; },
  "CircuitBoard": function() { return CircuitBoard; },
  "CircuitBoardIcon": function() { return CircuitBoard; },
  "Citrus": function() { return Citrus; },
  "CitrusIcon": function() { return Citrus; },
  "Clapperboard": function() { return Clapperboard; },
  "ClapperboardIcon": function() { return Clapperboard; },
  "Clipboard": function() { return Clipboard; },
  "ClipboardCheck": function() { return ClipboardCheck; },
  "ClipboardCheckIcon": function() { return ClipboardCheck; },
  "ClipboardCopy": function() { return ClipboardCopy; },
  "ClipboardCopyIcon": function() { return ClipboardCopy; },
  "ClipboardEdit": function() { return ClipboardEdit; },
  "ClipboardEditIcon": function() { return ClipboardEdit; },
  "ClipboardIcon": function() { return Clipboard; },
  "ClipboardList": function() { return ClipboardList; },
  "ClipboardListIcon": function() { return ClipboardList; },
  "ClipboardPaste": function() { return ClipboardPaste; },
  "ClipboardPasteIcon": function() { return ClipboardPaste; },
  "ClipboardSignature": function() { return ClipboardSignature; },
  "ClipboardSignatureIcon": function() { return ClipboardSignature; },
  "ClipboardType": function() { return ClipboardType; },
  "ClipboardTypeIcon": function() { return ClipboardType; },
  "ClipboardX": function() { return ClipboardX; },
  "ClipboardXIcon": function() { return ClipboardX; },
  "Clock": function() { return Clock; },
  "Clock1": function() { return Clock1; },
  "Clock10": function() { return Clock10; },
  "Clock10Icon": function() { return Clock10; },
  "Clock11": function() { return Clock11; },
  "Clock11Icon": function() { return Clock11; },
  "Clock12": function() { return Clock12; },
  "Clock12Icon": function() { return Clock12; },
  "Clock1Icon": function() { return Clock1; },
  "Clock2": function() { return Clock2; },
  "Clock2Icon": function() { return Clock2; },
  "Clock3": function() { return Clock3; },
  "Clock3Icon": function() { return Clock3; },
  "Clock4": function() { return Clock4; },
  "Clock4Icon": function() { return Clock4; },
  "Clock5": function() { return Clock5; },
  "Clock5Icon": function() { return Clock5; },
  "Clock6": function() { return Clock6; },
  "Clock6Icon": function() { return Clock6; },
  "Clock7": function() { return Clock7; },
  "Clock7Icon": function() { return Clock7; },
  "Clock8": function() { return Clock8; },
  "Clock8Icon": function() { return Clock8; },
  "Clock9": function() { return Clock9; },
  "Clock9Icon": function() { return Clock9; },
  "ClockIcon": function() { return Clock; },
  "Cloud": function() { return Cloud; },
  "CloudCog": function() { return CloudCog; },
  "CloudCogIcon": function() { return CloudCog; },
  "CloudDrizzle": function() { return CloudDrizzle; },
  "CloudDrizzleIcon": function() { return CloudDrizzle; },
  "CloudFog": function() { return CloudFog; },
  "CloudFogIcon": function() { return CloudFog; },
  "CloudHail": function() { return CloudHail; },
  "CloudHailIcon": function() { return CloudHail; },
  "CloudIcon": function() { return Cloud; },
  "CloudLightning": function() { return CloudLightning; },
  "CloudLightningIcon": function() { return CloudLightning; },
  "CloudMoon": function() { return CloudMoon; },
  "CloudMoonIcon": function() { return CloudMoon; },
  "CloudMoonRain": function() { return CloudMoonRain; },
  "CloudMoonRainIcon": function() { return CloudMoonRain; },
  "CloudOff": function() { return CloudOff; },
  "CloudOffIcon": function() { return CloudOff; },
  "CloudRain": function() { return CloudRain; },
  "CloudRainIcon": function() { return CloudRain; },
  "CloudRainWind": function() { return CloudRainWind; },
  "CloudRainWindIcon": function() { return CloudRainWind; },
  "CloudSnow": function() { return CloudSnow; },
  "CloudSnowIcon": function() { return CloudSnow; },
  "CloudSun": function() { return CloudSun; },
  "CloudSunIcon": function() { return CloudSun; },
  "CloudSunRain": function() { return CloudSunRain; },
  "CloudSunRainIcon": function() { return CloudSunRain; },
  "Cloudy": function() { return Cloudy; },
  "CloudyIcon": function() { return Cloudy; },
  "Clover": function() { return Clover; },
  "CloverIcon": function() { return Clover; },
  "Club": function() { return Club; },
  "ClubIcon": function() { return Club; },
  "Code": function() { return Code; },
  "Code2": function() { return Code2; },
  "Code2Icon": function() { return Code2; },
  "CodeIcon": function() { return Code; },
  "Codepen": function() { return Codepen; },
  "CodepenIcon": function() { return Codepen; },
  "Codesandbox": function() { return Codesandbox; },
  "CodesandboxIcon": function() { return Codesandbox; },
  "Coffee": function() { return Coffee; },
  "CoffeeIcon": function() { return Coffee; },
  "Cog": function() { return Cog; },
  "CogIcon": function() { return Cog; },
  "Coins": function() { return Coins; },
  "CoinsIcon": function() { return Coins; },
  "Columns": function() { return Columns; },
  "ColumnsIcon": function() { return Columns; },
  "Combine": function() { return Combine; },
  "CombineIcon": function() { return Combine; },
  "Command": function() { return Command; },
  "CommandIcon": function() { return Command; },
  "Compass": function() { return Compass; },
  "CompassIcon": function() { return Compass; },
  "Component": function() { return Component; },
  "ComponentIcon": function() { return Component; },
  "Computer": function() { return Computer; },
  "ComputerIcon": function() { return Computer; },
  "ConciergeBell": function() { return ConciergeBell; },
  "ConciergeBellIcon": function() { return ConciergeBell; },
  "Cone": function() { return Cone; },
  "ConeIcon": function() { return Cone; },
  "Construction": function() { return Construction; },
  "ConstructionIcon": function() { return Construction; },
  "Contact": function() { return Contact; },
  "Contact2": function() { return Contact2; },
  "Contact2Icon": function() { return Contact2; },
  "ContactIcon": function() { return Contact; },
  "Container": function() { return container_Container; },
  "ContainerIcon": function() { return container_Container; },
  "Contrast": function() { return Contrast; },
  "ContrastIcon": function() { return Contrast; },
  "Cookie": function() { return Cookie; },
  "CookieIcon": function() { return Cookie; },
  "Copy": function() { return Copy; },
  "CopyCheck": function() { return CopyCheck; },
  "CopyCheckIcon": function() { return CopyCheck; },
  "CopyIcon": function() { return Copy; },
  "CopyMinus": function() { return CopyMinus; },
  "CopyMinusIcon": function() { return CopyMinus; },
  "CopyPlus": function() { return CopyPlus; },
  "CopyPlusIcon": function() { return CopyPlus; },
  "CopySlash": function() { return CopySlash; },
  "CopySlashIcon": function() { return CopySlash; },
  "CopyX": function() { return CopyX; },
  "CopyXIcon": function() { return CopyX; },
  "Copyleft": function() { return Copyleft; },
  "CopyleftIcon": function() { return Copyleft; },
  "Copyright": function() { return Copyright; },
  "CopyrightIcon": function() { return Copyright; },
  "CornerDownLeft": function() { return CornerDownLeft; },
  "CornerDownLeftIcon": function() { return CornerDownLeft; },
  "CornerDownRight": function() { return CornerDownRight; },
  "CornerDownRightIcon": function() { return CornerDownRight; },
  "CornerLeftDown": function() { return CornerLeftDown; },
  "CornerLeftDownIcon": function() { return CornerLeftDown; },
  "CornerLeftUp": function() { return CornerLeftUp; },
  "CornerLeftUpIcon": function() { return CornerLeftUp; },
  "CornerRightDown": function() { return CornerRightDown; },
  "CornerRightDownIcon": function() { return CornerRightDown; },
  "CornerRightUp": function() { return CornerRightUp; },
  "CornerRightUpIcon": function() { return CornerRightUp; },
  "CornerUpLeft": function() { return CornerUpLeft; },
  "CornerUpLeftIcon": function() { return CornerUpLeft; },
  "CornerUpRight": function() { return CornerUpRight; },
  "CornerUpRightIcon": function() { return CornerUpRight; },
  "Cpu": function() { return Cpu; },
  "CpuIcon": function() { return Cpu; },
  "CreativeCommons": function() { return CreativeCommons; },
  "CreativeCommonsIcon": function() { return CreativeCommons; },
  "CreditCard": function() { return CreditCard; },
  "CreditCardIcon": function() { return CreditCard; },
  "Croissant": function() { return Croissant; },
  "CroissantIcon": function() { return Croissant; },
  "Crop": function() { return Crop; },
  "CropIcon": function() { return Crop; },
  "Cross": function() { return Cross; },
  "CrossIcon": function() { return Cross; },
  "Crosshair": function() { return Crosshair; },
  "CrosshairIcon": function() { return Crosshair; },
  "Crown": function() { return Crown; },
  "CrownIcon": function() { return Crown; },
  "Cuboid": function() { return Cuboid; },
  "CuboidIcon": function() { return Cuboid; },
  "CupSoda": function() { return CupSoda; },
  "CupSodaIcon": function() { return CupSoda; },
  "CurlyBraces": function() { return Braces; },
  "CurlyBracesIcon": function() { return Braces; },
  "Currency": function() { return Currency; },
  "CurrencyIcon": function() { return Currency; },
  "Cylinder": function() { return Cylinder; },
  "CylinderIcon": function() { return Cylinder; },
  "Database": function() { return Database; },
  "DatabaseBackup": function() { return DatabaseBackup; },
  "DatabaseBackupIcon": function() { return DatabaseBackup; },
  "DatabaseIcon": function() { return Database; },
  "DatabaseZap": function() { return DatabaseZap; },
  "DatabaseZapIcon": function() { return DatabaseZap; },
  "Delete": function() { return Delete; },
  "DeleteIcon": function() { return Delete; },
  "Dessert": function() { return Dessert; },
  "DessertIcon": function() { return Dessert; },
  "Diameter": function() { return Diameter; },
  "DiameterIcon": function() { return Diameter; },
  "Diamond": function() { return Diamond; },
  "DiamondIcon": function() { return Diamond; },
  "Dice1": function() { return Dice1; },
  "Dice1Icon": function() { return Dice1; },
  "Dice2": function() { return Dice2; },
  "Dice2Icon": function() { return Dice2; },
  "Dice3": function() { return Dice3; },
  "Dice3Icon": function() { return Dice3; },
  "Dice4": function() { return Dice4; },
  "Dice4Icon": function() { return Dice4; },
  "Dice5": function() { return Dice5; },
  "Dice5Icon": function() { return Dice5; },
  "Dice6": function() { return Dice6; },
  "Dice6Icon": function() { return Dice6; },
  "Dices": function() { return Dices; },
  "DicesIcon": function() { return Dices; },
  "Diff": function() { return Diff; },
  "DiffIcon": function() { return Diff; },
  "Disc": function() { return Disc; },
  "Disc2": function() { return Disc2; },
  "Disc2Icon": function() { return Disc2; },
  "Disc3": function() { return Disc3; },
  "Disc3Icon": function() { return Disc3; },
  "DiscIcon": function() { return Disc; },
  "Divide": function() { return Divide; },
  "DivideCircle": function() { return DivideCircle; },
  "DivideCircleIcon": function() { return DivideCircle; },
  "DivideIcon": function() { return Divide; },
  "DivideSquare": function() { return DivideSquare; },
  "DivideSquareIcon": function() { return DivideSquare; },
  "Dna": function() { return Dna; },
  "DnaIcon": function() { return Dna; },
  "DnaOff": function() { return DnaOff; },
  "DnaOffIcon": function() { return DnaOff; },
  "Dog": function() { return Dog; },
  "DogIcon": function() { return Dog; },
  "DollarSign": function() { return DollarSign; },
  "DollarSignIcon": function() { return DollarSign; },
  "Donut": function() { return Donut; },
  "DonutIcon": function() { return Donut; },
  "DoorClosed": function() { return DoorClosed; },
  "DoorClosedIcon": function() { return DoorClosed; },
  "DoorOpen": function() { return DoorOpen; },
  "DoorOpenIcon": function() { return DoorOpen; },
  "Dot": function() { return Dot; },
  "DotIcon": function() { return Dot; },
  "Download": function() { return Download; },
  "DownloadCloud": function() { return DownloadCloud; },
  "DownloadCloudIcon": function() { return DownloadCloud; },
  "DownloadIcon": function() { return Download; },
  "DraftingCompass": function() { return DraftingCompass; },
  "DraftingCompassIcon": function() { return DraftingCompass; },
  "Drama": function() { return Drama; },
  "DramaIcon": function() { return Drama; },
  "Dribbble": function() { return Dribbble; },
  "DribbbleIcon": function() { return Dribbble; },
  "Droplet": function() { return Droplet; },
  "DropletIcon": function() { return Droplet; },
  "Droplets": function() { return Droplets; },
  "DropletsIcon": function() { return Droplets; },
  "Drumstick": function() { return Drumstick; },
  "DrumstickIcon": function() { return Drumstick; },
  "Dumbbell": function() { return Dumbbell; },
  "DumbbellIcon": function() { return Dumbbell; },
  "Ear": function() { return Ear; },
  "EarIcon": function() { return Ear; },
  "EarOff": function() { return EarOff; },
  "EarOffIcon": function() { return EarOff; },
  "Edit": function() { return PenSquare; },
  "Edit2": function() { return Pen; },
  "Edit2Icon": function() { return Pen; },
  "Edit3": function() { return PenLine; },
  "Edit3Icon": function() { return PenLine; },
  "EditIcon": function() { return PenSquare; },
  "Egg": function() { return Egg; },
  "EggFried": function() { return EggFried; },
  "EggFriedIcon": function() { return EggFried; },
  "EggIcon": function() { return Egg; },
  "EggOff": function() { return EggOff; },
  "EggOffIcon": function() { return EggOff; },
  "Equal": function() { return Equal; },
  "EqualIcon": function() { return Equal; },
  "EqualNot": function() { return EqualNot; },
  "EqualNotIcon": function() { return EqualNot; },
  "Eraser": function() { return Eraser; },
  "EraserIcon": function() { return Eraser; },
  "Euro": function() { return Euro; },
  "EuroIcon": function() { return Euro; },
  "Expand": function() { return Expand; },
  "ExpandIcon": function() { return Expand; },
  "ExternalLink": function() { return ExternalLink; },
  "ExternalLinkIcon": function() { return ExternalLink; },
  "Eye": function() { return Eye; },
  "EyeIcon": function() { return Eye; },
  "EyeOff": function() { return EyeOff; },
  "EyeOffIcon": function() { return EyeOff; },
  "Facebook": function() { return Facebook; },
  "FacebookIcon": function() { return Facebook; },
  "Factory": function() { return Factory; },
  "FactoryIcon": function() { return Factory; },
  "Fan": function() { return Fan; },
  "FanIcon": function() { return Fan; },
  "FastForward": function() { return FastForward; },
  "FastForwardIcon": function() { return FastForward; },
  "Feather": function() { return Feather; },
  "FeatherIcon": function() { return Feather; },
  "FerrisWheel": function() { return FerrisWheel; },
  "FerrisWheelIcon": function() { return FerrisWheel; },
  "Figma": function() { return Figma; },
  "FigmaIcon": function() { return Figma; },
  "File": function() { return File; },
  "FileArchive": function() { return FileArchive; },
  "FileArchiveIcon": function() { return FileArchive; },
  "FileAudio": function() { return FileAudio; },
  "FileAudio2": function() { return FileAudio2; },
  "FileAudio2Icon": function() { return FileAudio2; },
  "FileAudioIcon": function() { return FileAudio; },
  "FileAxis3D": function() { return FileAxis3d; },
  "FileAxis3DIcon": function() { return FileAxis3d; },
  "FileAxis3d": function() { return FileAxis3d; },
  "FileAxis3dIcon": function() { return FileAxis3d; },
  "FileBadge": function() { return FileBadge; },
  "FileBadge2": function() { return FileBadge2; },
  "FileBadge2Icon": function() { return FileBadge2; },
  "FileBadgeIcon": function() { return FileBadge; },
  "FileBarChart": function() { return FileBarChart; },
  "FileBarChart2": function() { return FileBarChart2; },
  "FileBarChart2Icon": function() { return FileBarChart2; },
  "FileBarChartIcon": function() { return FileBarChart; },
  "FileBox": function() { return FileBox; },
  "FileBoxIcon": function() { return FileBox; },
  "FileCheck": function() { return FileCheck; },
  "FileCheck2": function() { return FileCheck2; },
  "FileCheck2Icon": function() { return FileCheck2; },
  "FileCheckIcon": function() { return FileCheck; },
  "FileClock": function() { return FileClock; },
  "FileClockIcon": function() { return FileClock; },
  "FileCode": function() { return FileCode; },
  "FileCode2": function() { return FileCode2; },
  "FileCode2Icon": function() { return FileCode2; },
  "FileCodeIcon": function() { return FileCode; },
  "FileCog": function() { return FileCog; },
  "FileCog2": function() { return FileCog; },
  "FileCog2Icon": function() { return FileCog; },
  "FileCogIcon": function() { return FileCog; },
  "FileDiff": function() { return FileDiff; },
  "FileDiffIcon": function() { return FileDiff; },
  "FileDigit": function() { return FileDigit; },
  "FileDigitIcon": function() { return FileDigit; },
  "FileDown": function() { return FileDown; },
  "FileDownIcon": function() { return FileDown; },
  "FileEdit": function() { return FileEdit; },
  "FileEditIcon": function() { return FileEdit; },
  "FileHeart": function() { return FileHeart; },
  "FileHeartIcon": function() { return FileHeart; },
  "FileIcon": function() { return File; },
  "FileImage": function() { return FileImage; },
  "FileImageIcon": function() { return FileImage; },
  "FileInput": function() { return FileInput; },
  "FileInputIcon": function() { return FileInput; },
  "FileJson": function() { return FileJson; },
  "FileJson2": function() { return FileJson2; },
  "FileJson2Icon": function() { return FileJson2; },
  "FileJsonIcon": function() { return FileJson; },
  "FileKey": function() { return FileKey; },
  "FileKey2": function() { return FileKey2; },
  "FileKey2Icon": function() { return FileKey2; },
  "FileKeyIcon": function() { return FileKey; },
  "FileLineChart": function() { return FileLineChart; },
  "FileLineChartIcon": function() { return FileLineChart; },
  "FileLock": function() { return FileLock; },
  "FileLock2": function() { return FileLock2; },
  "FileLock2Icon": function() { return FileLock2; },
  "FileLockIcon": function() { return FileLock; },
  "FileMinus": function() { return FileMinus; },
  "FileMinus2": function() { return FileMinus2; },
  "FileMinus2Icon": function() { return FileMinus2; },
  "FileMinusIcon": function() { return FileMinus; },
  "FileOutput": function() { return FileOutput; },
  "FileOutputIcon": function() { return FileOutput; },
  "FilePieChart": function() { return FilePieChart; },
  "FilePieChartIcon": function() { return FilePieChart; },
  "FilePlus": function() { return FilePlus; },
  "FilePlus2": function() { return FilePlus2; },
  "FilePlus2Icon": function() { return FilePlus2; },
  "FilePlusIcon": function() { return FilePlus; },
  "FileQuestion": function() { return FileQuestion; },
  "FileQuestionIcon": function() { return FileQuestion; },
  "FileScan": function() { return FileScan; },
  "FileScanIcon": function() { return FileScan; },
  "FileSearch": function() { return FileSearch; },
  "FileSearch2": function() { return FileSearch2; },
  "FileSearch2Icon": function() { return FileSearch2; },
  "FileSearchIcon": function() { return FileSearch; },
  "FileSignature": function() { return FileSignature; },
  "FileSignatureIcon": function() { return FileSignature; },
  "FileSpreadsheet": function() { return FileSpreadsheet; },
  "FileSpreadsheetIcon": function() { return FileSpreadsheet; },
  "FileStack": function() { return FileStack; },
  "FileStackIcon": function() { return FileStack; },
  "FileSymlink": function() { return FileSymlink; },
  "FileSymlinkIcon": function() { return FileSymlink; },
  "FileTerminal": function() { return FileTerminal; },
  "FileTerminalIcon": function() { return FileTerminal; },
  "FileText": function() { return FileText; },
  "FileTextIcon": function() { return FileText; },
  "FileType": function() { return FileType; },
  "FileType2": function() { return FileType2; },
  "FileType2Icon": function() { return FileType2; },
  "FileTypeIcon": function() { return FileType; },
  "FileUp": function() { return FileUp; },
  "FileUpIcon": function() { return FileUp; },
  "FileVideo": function() { return FileVideo; },
  "FileVideo2": function() { return FileVideo2; },
  "FileVideo2Icon": function() { return FileVideo2; },
  "FileVideoIcon": function() { return FileVideo; },
  "FileVolume": function() { return FileVolume; },
  "FileVolume2": function() { return FileVolume2; },
  "FileVolume2Icon": function() { return FileVolume2; },
  "FileVolumeIcon": function() { return FileVolume; },
  "FileWarning": function() { return FileWarning; },
  "FileWarningIcon": function() { return FileWarning; },
  "FileX": function() { return FileX; },
  "FileX2": function() { return FileX2; },
  "FileX2Icon": function() { return FileX2; },
  "FileXIcon": function() { return FileX; },
  "Files": function() { return Files; },
  "FilesIcon": function() { return Files; },
  "Film": function() { return Film; },
  "FilmIcon": function() { return Film; },
  "Filter": function() { return Filter; },
  "FilterIcon": function() { return Filter; },
  "FilterX": function() { return FilterX; },
  "FilterXIcon": function() { return FilterX; },
  "Fingerprint": function() { return Fingerprint; },
  "FingerprintIcon": function() { return Fingerprint; },
  "Fish": function() { return Fish; },
  "FishIcon": function() { return Fish; },
  "FishOff": function() { return FishOff; },
  "FishOffIcon": function() { return FishOff; },
  "FishSymbol": function() { return FishSymbol; },
  "FishSymbolIcon": function() { return FishSymbol; },
  "Flag": function() { return Flag; },
  "FlagIcon": function() { return Flag; },
  "FlagOff": function() { return FlagOff; },
  "FlagOffIcon": function() { return FlagOff; },
  "FlagTriangleLeft": function() { return FlagTriangleLeft; },
  "FlagTriangleLeftIcon": function() { return FlagTriangleLeft; },
  "FlagTriangleRight": function() { return FlagTriangleRight; },
  "FlagTriangleRightIcon": function() { return FlagTriangleRight; },
  "Flame": function() { return Flame; },
  "FlameIcon": function() { return Flame; },
  "FlameKindling": function() { return FlameKindling; },
  "FlameKindlingIcon": function() { return FlameKindling; },
  "Flashlight": function() { return Flashlight; },
  "FlashlightIcon": function() { return Flashlight; },
  "FlashlightOff": function() { return FlashlightOff; },
  "FlashlightOffIcon": function() { return FlashlightOff; },
  "FlaskConical": function() { return FlaskConical; },
  "FlaskConicalIcon": function() { return FlaskConical; },
  "FlaskConicalOff": function() { return FlaskConicalOff; },
  "FlaskConicalOffIcon": function() { return FlaskConicalOff; },
  "FlaskRound": function() { return FlaskRound; },
  "FlaskRoundIcon": function() { return FlaskRound; },
  "FlipHorizontal": function() { return FlipHorizontal; },
  "FlipHorizontal2": function() { return FlipHorizontal2; },
  "FlipHorizontal2Icon": function() { return FlipHorizontal2; },
  "FlipHorizontalIcon": function() { return FlipHorizontal; },
  "FlipVertical": function() { return FlipVertical; },
  "FlipVertical2": function() { return FlipVertical2; },
  "FlipVertical2Icon": function() { return FlipVertical2; },
  "FlipVerticalIcon": function() { return FlipVertical; },
  "Flower": function() { return Flower; },
  "Flower2": function() { return Flower2; },
  "Flower2Icon": function() { return Flower2; },
  "FlowerIcon": function() { return Flower; },
  "Focus": function() { return Focus; },
  "FocusIcon": function() { return Focus; },
  "FoldHorizontal": function() { return FoldHorizontal; },
  "FoldHorizontalIcon": function() { return FoldHorizontal; },
  "FoldVertical": function() { return FoldVertical; },
  "FoldVerticalIcon": function() { return FoldVertical; },
  "Folder": function() { return Folder; },
  "FolderArchive": function() { return FolderArchive; },
  "FolderArchiveIcon": function() { return FolderArchive; },
  "FolderCheck": function() { return FolderCheck; },
  "FolderCheckIcon": function() { return FolderCheck; },
  "FolderClock": function() { return FolderClock; },
  "FolderClockIcon": function() { return FolderClock; },
  "FolderClosed": function() { return FolderClosed; },
  "FolderClosedIcon": function() { return FolderClosed; },
  "FolderCog": function() { return FolderCog; },
  "FolderCog2": function() { return FolderCog; },
  "FolderCog2Icon": function() { return FolderCog; },
  "FolderCogIcon": function() { return FolderCog; },
  "FolderDot": function() { return FolderDot; },
  "FolderDotIcon": function() { return FolderDot; },
  "FolderDown": function() { return FolderDown; },
  "FolderDownIcon": function() { return FolderDown; },
  "FolderEdit": function() { return FolderEdit; },
  "FolderEditIcon": function() { return FolderEdit; },
  "FolderGit": function() { return FolderGit; },
  "FolderGit2": function() { return FolderGit2; },
  "FolderGit2Icon": function() { return FolderGit2; },
  "FolderGitIcon": function() { return FolderGit; },
  "FolderHeart": function() { return FolderHeart; },
  "FolderHeartIcon": function() { return FolderHeart; },
  "FolderIcon": function() { return Folder; },
  "FolderInput": function() { return FolderInput; },
  "FolderInputIcon": function() { return FolderInput; },
  "FolderKanban": function() { return FolderKanban; },
  "FolderKanbanIcon": function() { return FolderKanban; },
  "FolderKey": function() { return FolderKey; },
  "FolderKeyIcon": function() { return FolderKey; },
  "FolderLock": function() { return FolderLock; },
  "FolderLockIcon": function() { return FolderLock; },
  "FolderMinus": function() { return FolderMinus; },
  "FolderMinusIcon": function() { return FolderMinus; },
  "FolderOpen": function() { return FolderOpen; },
  "FolderOpenDot": function() { return FolderOpenDot; },
  "FolderOpenDotIcon": function() { return FolderOpenDot; },
  "FolderOpenIcon": function() { return FolderOpen; },
  "FolderOutput": function() { return FolderOutput; },
  "FolderOutputIcon": function() { return FolderOutput; },
  "FolderPlus": function() { return FolderPlus; },
  "FolderPlusIcon": function() { return FolderPlus; },
  "FolderRoot": function() { return FolderRoot; },
  "FolderRootIcon": function() { return FolderRoot; },
  "FolderSearch": function() { return FolderSearch; },
  "FolderSearch2": function() { return FolderSearch2; },
  "FolderSearch2Icon": function() { return FolderSearch2; },
  "FolderSearchIcon": function() { return FolderSearch; },
  "FolderSymlink": function() { return FolderSymlink; },
  "FolderSymlinkIcon": function() { return FolderSymlink; },
  "FolderSync": function() { return FolderSync; },
  "FolderSyncIcon": function() { return FolderSync; },
  "FolderTree": function() { return FolderTree; },
  "FolderTreeIcon": function() { return FolderTree; },
  "FolderUp": function() { return FolderUp; },
  "FolderUpIcon": function() { return FolderUp; },
  "FolderX": function() { return FolderX; },
  "FolderXIcon": function() { return FolderX; },
  "Folders": function() { return Folders; },
  "FoldersIcon": function() { return Folders; },
  "Footprints": function() { return Footprints; },
  "FootprintsIcon": function() { return Footprints; },
  "Forklift": function() { return Forklift; },
  "ForkliftIcon": function() { return Forklift; },
  "FormInput": function() { return FormInput; },
  "FormInputIcon": function() { return FormInput; },
  "Forward": function() { return Forward; },
  "ForwardIcon": function() { return Forward; },
  "Frame": function() { return Frame; },
  "FrameIcon": function() { return Frame; },
  "Framer": function() { return Framer; },
  "FramerIcon": function() { return Framer; },
  "Frown": function() { return Frown; },
  "FrownIcon": function() { return Frown; },
  "Fuel": function() { return Fuel; },
  "FuelIcon": function() { return Fuel; },
  "Fullscreen": function() { return Fullscreen; },
  "FullscreenIcon": function() { return Fullscreen; },
  "FunctionSquare": function() { return FunctionSquare; },
  "FunctionSquareIcon": function() { return FunctionSquare; },
  "GalleryHorizontal": function() { return GalleryHorizontal; },
  "GalleryHorizontalEnd": function() { return GalleryHorizontalEnd; },
  "GalleryHorizontalEndIcon": function() { return GalleryHorizontalEnd; },
  "GalleryHorizontalIcon": function() { return GalleryHorizontal; },
  "GalleryThumbnails": function() { return GalleryThumbnails; },
  "GalleryThumbnailsIcon": function() { return GalleryThumbnails; },
  "GalleryVertical": function() { return GalleryVertical; },
  "GalleryVerticalEnd": function() { return GalleryVerticalEnd; },
  "GalleryVerticalEndIcon": function() { return GalleryVerticalEnd; },
  "GalleryVerticalIcon": function() { return GalleryVertical; },
  "Gamepad": function() { return Gamepad; },
  "Gamepad2": function() { return Gamepad2; },
  "Gamepad2Icon": function() { return Gamepad2; },
  "GamepadIcon": function() { return Gamepad; },
  "GanttChart": function() { return GanttChart; },
  "GanttChartIcon": function() { return GanttChart; },
  "GanttChartSquare": function() { return GanttChartSquare; },
  "GanttChartSquareIcon": function() { return GanttChartSquare; },
  "Gauge": function() { return Gauge; },
  "GaugeCircle": function() { return GaugeCircle; },
  "GaugeCircleIcon": function() { return GaugeCircle; },
  "GaugeIcon": function() { return Gauge; },
  "Gavel": function() { return Gavel; },
  "GavelIcon": function() { return Gavel; },
  "Gem": function() { return Gem; },
  "GemIcon": function() { return Gem; },
  "Ghost": function() { return Ghost; },
  "GhostIcon": function() { return Ghost; },
  "Gift": function() { return Gift; },
  "GiftIcon": function() { return Gift; },
  "GitBranch": function() { return GitBranch; },
  "GitBranchIcon": function() { return GitBranch; },
  "GitBranchPlus": function() { return GitBranchPlus; },
  "GitBranchPlusIcon": function() { return GitBranchPlus; },
  "GitCommit": function() { return GitCommit; },
  "GitCommitIcon": function() { return GitCommit; },
  "GitCompare": function() { return GitCompare; },
  "GitCompareIcon": function() { return GitCompare; },
  "GitFork": function() { return GitFork; },
  "GitForkIcon": function() { return GitFork; },
  "GitMerge": function() { return GitMerge; },
  "GitMergeIcon": function() { return GitMerge; },
  "GitPullRequest": function() { return GitPullRequest; },
  "GitPullRequestClosed": function() { return GitPullRequestClosed; },
  "GitPullRequestClosedIcon": function() { return GitPullRequestClosed; },
  "GitPullRequestDraft": function() { return GitPullRequestDraft; },
  "GitPullRequestDraftIcon": function() { return GitPullRequestDraft; },
  "GitPullRequestIcon": function() { return GitPullRequest; },
  "Github": function() { return Github; },
  "GithubIcon": function() { return Github; },
  "Gitlab": function() { return Gitlab; },
  "GitlabIcon": function() { return Gitlab; },
  "GlassWater": function() { return GlassWater; },
  "GlassWaterIcon": function() { return GlassWater; },
  "Glasses": function() { return Glasses; },
  "GlassesIcon": function() { return Glasses; },
  "Globe": function() { return Globe; },
  "Globe2": function() { return Globe2; },
  "Globe2Icon": function() { return Globe2; },
  "GlobeIcon": function() { return Globe; },
  "Goal": function() { return Goal; },
  "GoalIcon": function() { return Goal; },
  "Grab": function() { return Grab; },
  "GrabIcon": function() { return Grab; },
  "GraduationCap": function() { return GraduationCap; },
  "GraduationCapIcon": function() { return GraduationCap; },
  "Grape": function() { return Grape; },
  "GrapeIcon": function() { return Grape; },
  "Grid": function() { return Grid3x3; },
  "Grid2X2": function() { return Grid2x2; },
  "Grid2X2Icon": function() { return Grid2x2; },
  "Grid2x2": function() { return Grid2x2; },
  "Grid2x2Icon": function() { return Grid2x2; },
  "Grid3X3": function() { return Grid3x3; },
  "Grid3X3Icon": function() { return Grid3x3; },
  "Grid3x3": function() { return Grid3x3; },
  "Grid3x3Icon": function() { return Grid3x3; },
  "GridIcon": function() { return Grid3x3; },
  "Grip": function() { return Grip; },
  "GripHorizontal": function() { return GripHorizontal; },
  "GripHorizontalIcon": function() { return GripHorizontal; },
  "GripIcon": function() { return Grip; },
  "GripVertical": function() { return GripVertical; },
  "GripVerticalIcon": function() { return GripVertical; },
  "Group": function() { return Group; },
  "GroupIcon": function() { return Group; },
  "Hammer": function() { return Hammer; },
  "HammerIcon": function() { return Hammer; },
  "Hand": function() { return Hand; },
  "HandIcon": function() { return Hand; },
  "HandMetal": function() { return HandMetal; },
  "HandMetalIcon": function() { return HandMetal; },
  "HardDrive": function() { return HardDrive; },
  "HardDriveDownload": function() { return HardDriveDownload; },
  "HardDriveDownloadIcon": function() { return HardDriveDownload; },
  "HardDriveIcon": function() { return HardDrive; },
  "HardDriveUpload": function() { return HardDriveUpload; },
  "HardDriveUploadIcon": function() { return HardDriveUpload; },
  "HardHat": function() { return HardHat; },
  "HardHatIcon": function() { return HardHat; },
  "Hash": function() { return Hash; },
  "HashIcon": function() { return Hash; },
  "Haze": function() { return Haze; },
  "HazeIcon": function() { return Haze; },
  "HdmiPort": function() { return HdmiPort; },
  "HdmiPortIcon": function() { return HdmiPort; },
  "Heading": function() { return Heading; },
  "Heading1": function() { return Heading1; },
  "Heading1Icon": function() { return Heading1; },
  "Heading2": function() { return Heading2; },
  "Heading2Icon": function() { return Heading2; },
  "Heading3": function() { return Heading3; },
  "Heading3Icon": function() { return Heading3; },
  "Heading4": function() { return Heading4; },
  "Heading4Icon": function() { return Heading4; },
  "Heading5": function() { return Heading5; },
  "Heading5Icon": function() { return Heading5; },
  "Heading6": function() { return Heading6; },
  "Heading6Icon": function() { return Heading6; },
  "HeadingIcon": function() { return Heading; },
  "Headphones": function() { return Headphones; },
  "HeadphonesIcon": function() { return Headphones; },
  "Heart": function() { return Heart; },
  "HeartCrack": function() { return HeartCrack; },
  "HeartCrackIcon": function() { return HeartCrack; },
  "HeartHandshake": function() { return HeartHandshake; },
  "HeartHandshakeIcon": function() { return HeartHandshake; },
  "HeartIcon": function() { return Heart; },
  "HeartOff": function() { return HeartOff; },
  "HeartOffIcon": function() { return HeartOff; },
  "HeartPulse": function() { return HeartPulse; },
  "HeartPulseIcon": function() { return HeartPulse; },
  "HelpCircle": function() { return HelpCircle; },
  "HelpCircleIcon": function() { return HelpCircle; },
  "HelpingHand": function() { return HelpingHand; },
  "HelpingHandIcon": function() { return HelpingHand; },
  "Hexagon": function() { return Hexagon; },
  "HexagonIcon": function() { return Hexagon; },
  "Highlighter": function() { return Highlighter; },
  "HighlighterIcon": function() { return Highlighter; },
  "History": function() { return History; },
  "HistoryIcon": function() { return History; },
  "Home": function() { return Home; },
  "HomeIcon": function() { return Home; },
  "Hop": function() { return Hop; },
  "HopIcon": function() { return Hop; },
  "HopOff": function() { return HopOff; },
  "HopOffIcon": function() { return HopOff; },
  "Hotel": function() { return Hotel; },
  "HotelIcon": function() { return Hotel; },
  "Hourglass": function() { return Hourglass; },
  "HourglassIcon": function() { return Hourglass; },
  "IceCream": function() { return IceCream; },
  "IceCream2": function() { return IceCream2; },
  "IceCream2Icon": function() { return IceCream2; },
  "IceCreamIcon": function() { return IceCream; },
  "Image": function() { return Image; },
  "ImageIcon": function() { return Image; },
  "ImageMinus": function() { return ImageMinus; },
  "ImageMinusIcon": function() { return ImageMinus; },
  "ImageOff": function() { return ImageOff; },
  "ImageOffIcon": function() { return ImageOff; },
  "ImagePlus": function() { return ImagePlus; },
  "ImagePlusIcon": function() { return ImagePlus; },
  "Import": function() { return Import; },
  "ImportIcon": function() { return Import; },
  "Inbox": function() { return Inbox; },
  "InboxIcon": function() { return Inbox; },
  "Indent": function() { return Indent; },
  "IndentIcon": function() { return Indent; },
  "IndianRupee": function() { return IndianRupee; },
  "IndianRupeeIcon": function() { return IndianRupee; },
  "Infinity": function() { return infinity_Infinity; },
  "InfinityIcon": function() { return infinity_Infinity; },
  "Info": function() { return Info; },
  "InfoIcon": function() { return Info; },
  "Inspect": function() { return MousePointerSquare; },
  "InspectIcon": function() { return MousePointerSquare; },
  "Instagram": function() { return Instagram; },
  "InstagramIcon": function() { return Instagram; },
  "Italic": function() { return Italic; },
  "ItalicIcon": function() { return Italic; },
  "IterationCcw": function() { return IterationCcw; },
  "IterationCcwIcon": function() { return IterationCcw; },
  "IterationCw": function() { return IterationCw; },
  "IterationCwIcon": function() { return IterationCw; },
  "JapaneseYen": function() { return JapaneseYen; },
  "JapaneseYenIcon": function() { return JapaneseYen; },
  "Joystick": function() { return Joystick; },
  "JoystickIcon": function() { return Joystick; },
  "Kanban": function() { return Kanban; },
  "KanbanIcon": function() { return Kanban; },
  "KanbanSquare": function() { return KanbanSquare; },
  "KanbanSquareDashed": function() { return KanbanSquareDashed; },
  "KanbanSquareDashedIcon": function() { return KanbanSquareDashed; },
  "KanbanSquareIcon": function() { return KanbanSquare; },
  "Key": function() { return Key; },
  "KeyIcon": function() { return Key; },
  "KeyRound": function() { return KeyRound; },
  "KeyRoundIcon": function() { return KeyRound; },
  "KeySquare": function() { return KeySquare; },
  "KeySquareIcon": function() { return KeySquare; },
  "Keyboard": function() { return Keyboard; },
  "KeyboardIcon": function() { return Keyboard; },
  "Lamp": function() { return Lamp; },
  "LampCeiling": function() { return LampCeiling; },
  "LampCeilingIcon": function() { return LampCeiling; },
  "LampDesk": function() { return LampDesk; },
  "LampDeskIcon": function() { return LampDesk; },
  "LampFloor": function() { return LampFloor; },
  "LampFloorIcon": function() { return LampFloor; },
  "LampIcon": function() { return Lamp; },
  "LampWallDown": function() { return LampWallDown; },
  "LampWallDownIcon": function() { return LampWallDown; },
  "LampWallUp": function() { return LampWallUp; },
  "LampWallUpIcon": function() { return LampWallUp; },
  "LandPlot": function() { return LandPlot; },
  "LandPlotIcon": function() { return LandPlot; },
  "Landmark": function() { return Landmark; },
  "LandmarkIcon": function() { return Landmark; },
  "Languages": function() { return Languages; },
  "LanguagesIcon": function() { return Languages; },
  "Laptop": function() { return Laptop; },
  "Laptop2": function() { return Laptop2; },
  "Laptop2Icon": function() { return Laptop2; },
  "LaptopIcon": function() { return Laptop; },
  "Lasso": function() { return Lasso; },
  "LassoIcon": function() { return Lasso; },
  "LassoSelect": function() { return LassoSelect; },
  "LassoSelectIcon": function() { return LassoSelect; },
  "Laugh": function() { return Laugh; },
  "LaughIcon": function() { return Laugh; },
  "Layers": function() { return Layers; },
  "Layers2": function() { return Layers2; },
  "Layers2Icon": function() { return Layers2; },
  "Layers3": function() { return Layers3; },
  "Layers3Icon": function() { return Layers3; },
  "LayersIcon": function() { return Layers; },
  "Layout": function() { return Layout; },
  "LayoutDashboard": function() { return LayoutDashboard; },
  "LayoutDashboardIcon": function() { return LayoutDashboard; },
  "LayoutGrid": function() { return LayoutGrid; },
  "LayoutGridIcon": function() { return LayoutGrid; },
  "LayoutIcon": function() { return Layout; },
  "LayoutList": function() { return LayoutList; },
  "LayoutListIcon": function() { return LayoutList; },
  "LayoutPanelLeft": function() { return LayoutPanelLeft; },
  "LayoutPanelLeftIcon": function() { return LayoutPanelLeft; },
  "LayoutPanelTop": function() { return LayoutPanelTop; },
  "LayoutPanelTopIcon": function() { return LayoutPanelTop; },
  "LayoutTemplate": function() { return LayoutTemplate; },
  "LayoutTemplateIcon": function() { return LayoutTemplate; },
  "Leaf": function() { return Leaf; },
  "LeafIcon": function() { return Leaf; },
  "LeafyGreen": function() { return LeafyGreen; },
  "LeafyGreenIcon": function() { return LeafyGreen; },
  "Library": function() { return Library; },
  "LibraryIcon": function() { return Library; },
  "LifeBuoy": function() { return LifeBuoy; },
  "LifeBuoyIcon": function() { return LifeBuoy; },
  "Ligature": function() { return Ligature; },
  "LigatureIcon": function() { return Ligature; },
  "Lightbulb": function() { return Lightbulb; },
  "LightbulbIcon": function() { return Lightbulb; },
  "LightbulbOff": function() { return LightbulbOff; },
  "LightbulbOffIcon": function() { return LightbulbOff; },
  "LineChart": function() { return LineChart; },
  "LineChartIcon": function() { return LineChart; },
  "Link": function() { return link_Link; },
  "Link2": function() { return Link2; },
  "Link2Icon": function() { return Link2; },
  "Link2Off": function() { return Link2Off; },
  "Link2OffIcon": function() { return Link2Off; },
  "LinkIcon": function() { return link_Link; },
  "Linkedin": function() { return Linkedin; },
  "LinkedinIcon": function() { return Linkedin; },
  "List": function() { return List; },
  "ListChecks": function() { return ListChecks; },
  "ListChecksIcon": function() { return ListChecks; },
  "ListEnd": function() { return ListEnd; },
  "ListEndIcon": function() { return ListEnd; },
  "ListFilter": function() { return ListFilter; },
  "ListFilterIcon": function() { return ListFilter; },
  "ListIcon": function() { return List; },
  "ListMinus": function() { return ListMinus; },
  "ListMinusIcon": function() { return ListMinus; },
  "ListMusic": function() { return ListMusic; },
  "ListMusicIcon": function() { return ListMusic; },
  "ListOrdered": function() { return ListOrdered; },
  "ListOrderedIcon": function() { return ListOrdered; },
  "ListPlus": function() { return ListPlus; },
  "ListPlusIcon": function() { return ListPlus; },
  "ListRestart": function() { return ListRestart; },
  "ListRestartIcon": function() { return ListRestart; },
  "ListStart": function() { return ListStart; },
  "ListStartIcon": function() { return ListStart; },
  "ListTodo": function() { return ListTodo; },
  "ListTodoIcon": function() { return ListTodo; },
  "ListTree": function() { return ListTree; },
  "ListTreeIcon": function() { return ListTree; },
  "ListVideo": function() { return ListVideo; },
  "ListVideoIcon": function() { return ListVideo; },
  "ListX": function() { return ListX; },
  "ListXIcon": function() { return ListX; },
  "Loader": function() { return Loader; },
  "Loader2": function() { return Loader2; },
  "Loader2Icon": function() { return Loader2; },
  "LoaderIcon": function() { return Loader; },
  "Locate": function() { return Locate; },
  "LocateFixed": function() { return LocateFixed; },
  "LocateFixedIcon": function() { return LocateFixed; },
  "LocateIcon": function() { return Locate; },
  "LocateOff": function() { return LocateOff; },
  "LocateOffIcon": function() { return LocateOff; },
  "Lock": function() { return Lock; },
  "LockIcon": function() { return Lock; },
  "LockKeyhole": function() { return LockKeyhole; },
  "LockKeyholeIcon": function() { return LockKeyhole; },
  "LogIn": function() { return LogIn; },
  "LogInIcon": function() { return LogIn; },
  "LogOut": function() { return LogOut; },
  "LogOutIcon": function() { return LogOut; },
  "Lollipop": function() { return Lollipop; },
  "LollipopIcon": function() { return Lollipop; },
  "LucideAccessibility": function() { return Accessibility; },
  "LucideActivity": function() { return Activity; },
  "LucideActivitySquare": function() { return ActivitySquare; },
  "LucideAirVent": function() { return AirVent; },
  "LucideAirplay": function() { return Airplay; },
  "LucideAlarmCheck": function() { return AlarmCheck; },
  "LucideAlarmClock": function() { return AlarmClock; },
  "LucideAlarmClockOff": function() { return AlarmClockOff; },
  "LucideAlarmMinus": function() { return AlarmMinus; },
  "LucideAlarmPlus": function() { return AlarmPlus; },
  "LucideAlbum": function() { return Album; },
  "LucideAlertCircle": function() { return AlertCircle; },
  "LucideAlertOctagon": function() { return AlertOctagon; },
  "LucideAlertTriangle": function() { return AlertTriangle; },
  "LucideAlignCenter": function() { return AlignCenter; },
  "LucideAlignCenterHorizontal": function() { return AlignCenterHorizontal; },
  "LucideAlignCenterVertical": function() { return AlignCenterVertical; },
  "LucideAlignEndHorizontal": function() { return AlignEndHorizontal; },
  "LucideAlignEndVertical": function() { return AlignEndVertical; },
  "LucideAlignHorizontalDistributeCenter": function() { return AlignHorizontalDistributeCenter; },
  "LucideAlignHorizontalDistributeEnd": function() { return AlignHorizontalDistributeEnd; },
  "LucideAlignHorizontalDistributeStart": function() { return AlignHorizontalDistributeStart; },
  "LucideAlignHorizontalJustifyCenter": function() { return AlignHorizontalJustifyCenter; },
  "LucideAlignHorizontalJustifyEnd": function() { return AlignHorizontalJustifyEnd; },
  "LucideAlignHorizontalJustifyStart": function() { return AlignHorizontalJustifyStart; },
  "LucideAlignHorizontalSpaceAround": function() { return AlignHorizontalSpaceAround; },
  "LucideAlignHorizontalSpaceBetween": function() { return AlignHorizontalSpaceBetween; },
  "LucideAlignJustify": function() { return AlignJustify; },
  "LucideAlignLeft": function() { return AlignLeft; },
  "LucideAlignRight": function() { return AlignRight; },
  "LucideAlignStartHorizontal": function() { return AlignStartHorizontal; },
  "LucideAlignStartVertical": function() { return AlignStartVertical; },
  "LucideAlignVerticalDistributeCenter": function() { return AlignVerticalDistributeCenter; },
  "LucideAlignVerticalDistributeEnd": function() { return AlignVerticalDistributeEnd; },
  "LucideAlignVerticalDistributeStart": function() { return AlignVerticalDistributeStart; },
  "LucideAlignVerticalJustifyCenter": function() { return AlignVerticalJustifyCenter; },
  "LucideAlignVerticalJustifyEnd": function() { return AlignVerticalJustifyEnd; },
  "LucideAlignVerticalJustifyStart": function() { return AlignVerticalJustifyStart; },
  "LucideAlignVerticalSpaceAround": function() { return AlignVerticalSpaceAround; },
  "LucideAlignVerticalSpaceBetween": function() { return AlignVerticalSpaceBetween; },
  "LucideAmpersand": function() { return Ampersand; },
  "LucideAmpersands": function() { return Ampersands; },
  "LucideAnchor": function() { return Anchor; },
  "LucideAngry": function() { return Angry; },
  "LucideAnnoyed": function() { return Annoyed; },
  "LucideAntenna": function() { return Antenna; },
  "LucideAperture": function() { return Aperture; },
  "LucideAppWindow": function() { return AppWindow; },
  "LucideApple": function() { return Apple; },
  "LucideArchive": function() { return Archive; },
  "LucideArchiveRestore": function() { return ArchiveRestore; },
  "LucideArchiveX": function() { return ArchiveX; },
  "LucideAreaChart": function() { return AreaChart; },
  "LucideArmchair": function() { return Armchair; },
  "LucideArrowBigDown": function() { return ArrowBigDown; },
  "LucideArrowBigDownDash": function() { return ArrowBigDownDash; },
  "LucideArrowBigLeft": function() { return ArrowBigLeft; },
  "LucideArrowBigLeftDash": function() { return ArrowBigLeftDash; },
  "LucideArrowBigRight": function() { return ArrowBigRight; },
  "LucideArrowBigRightDash": function() { return ArrowBigRightDash; },
  "LucideArrowBigUp": function() { return ArrowBigUp; },
  "LucideArrowBigUpDash": function() { return ArrowBigUpDash; },
  "LucideArrowDown": function() { return ArrowDown; },
  "LucideArrowDown01": function() { return ArrowDown01; },
  "LucideArrowDown10": function() { return ArrowDown10; },
  "LucideArrowDownAZ": function() { return ArrowDownAZ; },
  "LucideArrowDownAz": function() { return ArrowDownAZ; },
  "LucideArrowDownCircle": function() { return ArrowDownCircle; },
  "LucideArrowDownFromLine": function() { return ArrowDownFromLine; },
  "LucideArrowDownLeft": function() { return ArrowDownLeft; },
  "LucideArrowDownLeftFromCircle": function() { return ArrowDownLeftFromCircle; },
  "LucideArrowDownLeftSquare": function() { return ArrowDownLeftSquare; },
  "LucideArrowDownNarrowWide": function() { return ArrowDownNarrowWide; },
  "LucideArrowDownRight": function() { return ArrowDownRight; },
  "LucideArrowDownRightFromCircle": function() { return ArrowDownRightFromCircle; },
  "LucideArrowDownRightSquare": function() { return ArrowDownRightSquare; },
  "LucideArrowDownSquare": function() { return ArrowDownSquare; },
  "LucideArrowDownToDot": function() { return ArrowDownToDot; },
  "LucideArrowDownToLine": function() { return ArrowDownToLine; },
  "LucideArrowDownUp": function() { return ArrowDownUp; },
  "LucideArrowDownWideNarrow": function() { return ArrowDownWideNarrow; },
  "LucideArrowDownZA": function() { return ArrowDownZA; },
  "LucideArrowDownZa": function() { return ArrowDownZA; },
  "LucideArrowLeft": function() { return ArrowLeft; },
  "LucideArrowLeftCircle": function() { return ArrowLeftCircle; },
  "LucideArrowLeftFromLine": function() { return ArrowLeftFromLine; },
  "LucideArrowLeftRight": function() { return ArrowLeftRight; },
  "LucideArrowLeftSquare": function() { return ArrowLeftSquare; },
  "LucideArrowLeftToLine": function() { return ArrowLeftToLine; },
  "LucideArrowRight": function() { return ArrowRight; },
  "LucideArrowRightCircle": function() { return ArrowRightCircle; },
  "LucideArrowRightFromLine": function() { return ArrowRightFromLine; },
  "LucideArrowRightLeft": function() { return ArrowRightLeft; },
  "LucideArrowRightSquare": function() { return ArrowRightSquare; },
  "LucideArrowRightToLine": function() { return ArrowRightToLine; },
  "LucideArrowUp": function() { return ArrowUp; },
  "LucideArrowUp01": function() { return ArrowUp01; },
  "LucideArrowUp10": function() { return ArrowUp10; },
  "LucideArrowUpAZ": function() { return ArrowUpAZ; },
  "LucideArrowUpAz": function() { return ArrowUpAZ; },
  "LucideArrowUpCircle": function() { return ArrowUpCircle; },
  "LucideArrowUpDown": function() { return ArrowUpDown; },
  "LucideArrowUpFromDot": function() { return ArrowUpFromDot; },
  "LucideArrowUpFromLine": function() { return ArrowUpFromLine; },
  "LucideArrowUpLeft": function() { return ArrowUpLeft; },
  "LucideArrowUpLeftFromCircle": function() { return ArrowUpLeftFromCircle; },
  "LucideArrowUpLeftSquare": function() { return ArrowUpLeftSquare; },
  "LucideArrowUpNarrowWide": function() { return ArrowUpNarrowWide; },
  "LucideArrowUpRight": function() { return ArrowUpRight; },
  "LucideArrowUpRightFromCircle": function() { return ArrowUpRightFromCircle; },
  "LucideArrowUpRightSquare": function() { return ArrowUpRightSquare; },
  "LucideArrowUpSquare": function() { return ArrowUpSquare; },
  "LucideArrowUpToLine": function() { return ArrowUpToLine; },
  "LucideArrowUpWideNarrow": function() { return ArrowUpWideNarrow; },
  "LucideArrowUpZA": function() { return ArrowUpZA; },
  "LucideArrowUpZa": function() { return ArrowUpZA; },
  "LucideArrowsUpFromLine": function() { return ArrowsUpFromLine; },
  "LucideAsterisk": function() { return Asterisk; },
  "LucideAtSign": function() { return AtSign; },
  "LucideAtom": function() { return Atom; },
  "LucideAward": function() { return Award; },
  "LucideAxe": function() { return Axe; },
  "LucideAxis3D": function() { return Axis3d; },
  "LucideAxis3d": function() { return Axis3d; },
  "LucideBaby": function() { return Baby; },
  "LucideBackpack": function() { return Backpack; },
  "LucideBadge": function() { return Badge; },
  "LucideBadgeAlert": function() { return BadgeAlert; },
  "LucideBadgeCent": function() { return BadgeCent; },
  "LucideBadgeCheck": function() { return BadgeCheck; },
  "LucideBadgeDollarSign": function() { return BadgeDollarSign; },
  "LucideBadgeEuro": function() { return BadgeEuro; },
  "LucideBadgeHelp": function() { return BadgeHelp; },
  "LucideBadgeIndianRupee": function() { return BadgeIndianRupee; },
  "LucideBadgeInfo": function() { return BadgeInfo; },
  "LucideBadgeJapaneseYen": function() { return BadgeJapaneseYen; },
  "LucideBadgeMinus": function() { return BadgeMinus; },
  "LucideBadgePercent": function() { return BadgePercent; },
  "LucideBadgePlus": function() { return BadgePlus; },
  "LucideBadgePoundSterling": function() { return BadgePoundSterling; },
  "LucideBadgeRussianRuble": function() { return BadgeRussianRuble; },
  "LucideBadgeSwissFranc": function() { return BadgeSwissFranc; },
  "LucideBadgeX": function() { return BadgeX; },
  "LucideBaggageClaim": function() { return BaggageClaim; },
  "LucideBan": function() { return Ban; },
  "LucideBanana": function() { return Banana; },
  "LucideBanknote": function() { return Banknote; },
  "LucideBarChart": function() { return BarChart; },
  "LucideBarChart2": function() { return BarChart2; },
  "LucideBarChart3": function() { return BarChart3; },
  "LucideBarChart4": function() { return BarChart4; },
  "LucideBarChartBig": function() { return BarChartBig; },
  "LucideBarChartHorizontal": function() { return BarChartHorizontal; },
  "LucideBarChartHorizontalBig": function() { return BarChartHorizontalBig; },
  "LucideBarcode": function() { return Barcode; },
  "LucideBaseline": function() { return Baseline; },
  "LucideBath": function() { return Bath; },
  "LucideBattery": function() { return Battery; },
  "LucideBatteryCharging": function() { return BatteryCharging; },
  "LucideBatteryFull": function() { return BatteryFull; },
  "LucideBatteryLow": function() { return BatteryLow; },
  "LucideBatteryMedium": function() { return BatteryMedium; },
  "LucideBatteryWarning": function() { return BatteryWarning; },
  "LucideBeaker": function() { return Beaker; },
  "LucideBean": function() { return Bean; },
  "LucideBeanOff": function() { return BeanOff; },
  "LucideBed": function() { return Bed; },
  "LucideBedDouble": function() { return BedDouble; },
  "LucideBedSingle": function() { return BedSingle; },
  "LucideBeef": function() { return Beef; },
  "LucideBeer": function() { return Beer; },
  "LucideBell": function() { return Bell; },
  "LucideBellDot": function() { return BellDot; },
  "LucideBellMinus": function() { return BellMinus; },
  "LucideBellOff": function() { return BellOff; },
  "LucideBellPlus": function() { return BellPlus; },
  "LucideBellRing": function() { return BellRing; },
  "LucideBike": function() { return Bike; },
  "LucideBinary": function() { return Binary; },
  "LucideBiohazard": function() { return Biohazard; },
  "LucideBird": function() { return Bird; },
  "LucideBitcoin": function() { return Bitcoin; },
  "LucideBlinds": function() { return Blinds; },
  "LucideBlocks": function() { return Blocks; },
  "LucideBluetooth": function() { return Bluetooth; },
  "LucideBluetoothConnected": function() { return BluetoothConnected; },
  "LucideBluetoothOff": function() { return BluetoothOff; },
  "LucideBluetoothSearching": function() { return BluetoothSearching; },
  "LucideBold": function() { return Bold; },
  "LucideBomb": function() { return Bomb; },
  "LucideBone": function() { return Bone; },
  "LucideBook": function() { return Book; },
  "LucideBookCopy": function() { return BookCopy; },
  "LucideBookDown": function() { return BookDown; },
  "LucideBookKey": function() { return BookKey; },
  "LucideBookLock": function() { return BookLock; },
  "LucideBookMarked": function() { return BookMarked; },
  "LucideBookMinus": function() { return BookMinus; },
  "LucideBookOpen": function() { return BookOpen; },
  "LucideBookOpenCheck": function() { return BookOpenCheck; },
  "LucideBookPlus": function() { return BookPlus; },
  "LucideBookTemplate": function() { return BookTemplate; },
  "LucideBookUp": function() { return BookUp; },
  "LucideBookUp2": function() { return BookUp2; },
  "LucideBookX": function() { return BookX; },
  "LucideBookmark": function() { return Bookmark; },
  "LucideBookmarkCheck": function() { return BookmarkCheck; },
  "LucideBookmarkMinus": function() { return BookmarkMinus; },
  "LucideBookmarkPlus": function() { return BookmarkPlus; },
  "LucideBookmarkX": function() { return BookmarkX; },
  "LucideBoomBox": function() { return BoomBox; },
  "LucideBot": function() { return Bot; },
  "LucideBox": function() { return Box; },
  "LucideBoxSelect": function() { return BoxSelect; },
  "LucideBoxes": function() { return Boxes; },
  "LucideBraces": function() { return Braces; },
  "LucideBrackets": function() { return Brackets; },
  "LucideBrain": function() { return Brain; },
  "LucideBrainCircuit": function() { return BrainCircuit; },
  "LucideBrainCog": function() { return BrainCog; },
  "LucideBriefcase": function() { return Briefcase; },
  "LucideBringToFront": function() { return BringToFront; },
  "LucideBrush": function() { return Brush; },
  "LucideBug": function() { return Bug; },
  "LucideBugOff": function() { return BugOff; },
  "LucideBugPlay": function() { return BugPlay; },
  "LucideBuilding": function() { return Building; },
  "LucideBuilding2": function() { return Building2; },
  "LucideBus": function() { return Bus; },
  "LucideBusFront": function() { return BusFront; },
  "LucideCable": function() { return Cable; },
  "LucideCableCar": function() { return CableCar; },
  "LucideCake": function() { return Cake; },
  "LucideCakeSlice": function() { return CakeSlice; },
  "LucideCalculator": function() { return Calculator; },
  "LucideCalendar": function() { return Calendar; },
  "LucideCalendarCheck": function() { return CalendarCheck; },
  "LucideCalendarCheck2": function() { return CalendarCheck2; },
  "LucideCalendarClock": function() { return CalendarClock; },
  "LucideCalendarDays": function() { return CalendarDays; },
  "LucideCalendarHeart": function() { return CalendarHeart; },
  "LucideCalendarMinus": function() { return CalendarMinus; },
  "LucideCalendarOff": function() { return CalendarOff; },
  "LucideCalendarPlus": function() { return CalendarPlus; },
  "LucideCalendarRange": function() { return CalendarRange; },
  "LucideCalendarSearch": function() { return CalendarSearch; },
  "LucideCalendarX": function() { return CalendarX; },
  "LucideCalendarX2": function() { return CalendarX2; },
  "LucideCamera": function() { return Camera; },
  "LucideCameraOff": function() { return CameraOff; },
  "LucideCandlestickChart": function() { return CandlestickChart; },
  "LucideCandy": function() { return Candy; },
  "LucideCandyCane": function() { return CandyCane; },
  "LucideCandyOff": function() { return CandyOff; },
  "LucideCar": function() { return Car; },
  "LucideCarFront": function() { return CarFront; },
  "LucideCarTaxiFront": function() { return CarTaxiFront; },
  "LucideCaravan": function() { return Caravan; },
  "LucideCarrot": function() { return Carrot; },
  "LucideCaseLower": function() { return CaseLower; },
  "LucideCaseSensitive": function() { return CaseSensitive; },
  "LucideCaseUpper": function() { return CaseUpper; },
  "LucideCassetteTape": function() { return CassetteTape; },
  "LucideCast": function() { return Cast; },
  "LucideCastle": function() { return Castle; },
  "LucideCat": function() { return Cat; },
  "LucideCheck": function() { return Check; },
  "LucideCheckCheck": function() { return CheckCheck; },
  "LucideCheckCircle": function() { return CheckCircle; },
  "LucideCheckCircle2": function() { return CheckCircle2; },
  "LucideCheckSquare": function() { return CheckSquare; },
  "LucideChefHat": function() { return ChefHat; },
  "LucideCherry": function() { return Cherry; },
  "LucideChevronDown": function() { return ChevronDown; },
  "LucideChevronDownCircle": function() { return ChevronDownCircle; },
  "LucideChevronDownSquare": function() { return ChevronDownSquare; },
  "LucideChevronFirst": function() { return ChevronFirst; },
  "LucideChevronLast": function() { return ChevronLast; },
  "LucideChevronLeft": function() { return ChevronLeft; },
  "LucideChevronLeftCircle": function() { return ChevronLeftCircle; },
  "LucideChevronLeftSquare": function() { return ChevronLeftSquare; },
  "LucideChevronRight": function() { return ChevronRight; },
  "LucideChevronRightCircle": function() { return ChevronRightCircle; },
  "LucideChevronRightSquare": function() { return ChevronRightSquare; },
  "LucideChevronUp": function() { return ChevronUp; },
  "LucideChevronUpCircle": function() { return ChevronUpCircle; },
  "LucideChevronUpSquare": function() { return ChevronUpSquare; },
  "LucideChevronsDown": function() { return ChevronsDown; },
  "LucideChevronsDownUp": function() { return ChevronsDownUp; },
  "LucideChevronsLeft": function() { return ChevronsLeft; },
  "LucideChevronsLeftRight": function() { return ChevronsLeftRight; },
  "LucideChevronsRight": function() { return ChevronsRight; },
  "LucideChevronsRightLeft": function() { return ChevronsRightLeft; },
  "LucideChevronsUp": function() { return ChevronsUp; },
  "LucideChevronsUpDown": function() { return ChevronsUpDown; },
  "LucideChrome": function() { return Chrome; },
  "LucideChurch": function() { return Church; },
  "LucideCigarette": function() { return Cigarette; },
  "LucideCigaretteOff": function() { return CigaretteOff; },
  "LucideCircle": function() { return Circle; },
  "LucideCircleDashed": function() { return CircleDashed; },
  "LucideCircleDollarSign": function() { return CircleDollarSign; },
  "LucideCircleDot": function() { return CircleDot; },
  "LucideCircleDotDashed": function() { return CircleDotDashed; },
  "LucideCircleEllipsis": function() { return CircleEllipsis; },
  "LucideCircleEqual": function() { return CircleEqual; },
  "LucideCircleOff": function() { return CircleOff; },
  "LucideCircleSlash": function() { return CircleSlash; },
  "LucideCircleSlash2": function() { return CircleSlash2; },
  "LucideCircleSlashed": function() { return CircleSlash2; },
  "LucideCircuitBoard": function() { return CircuitBoard; },
  "LucideCitrus": function() { return Citrus; },
  "LucideClapperboard": function() { return Clapperboard; },
  "LucideClipboard": function() { return Clipboard; },
  "LucideClipboardCheck": function() { return ClipboardCheck; },
  "LucideClipboardCopy": function() { return ClipboardCopy; },
  "LucideClipboardEdit": function() { return ClipboardEdit; },
  "LucideClipboardList": function() { return ClipboardList; },
  "LucideClipboardPaste": function() { return ClipboardPaste; },
  "LucideClipboardSignature": function() { return ClipboardSignature; },
  "LucideClipboardType": function() { return ClipboardType; },
  "LucideClipboardX": function() { return ClipboardX; },
  "LucideClock": function() { return Clock; },
  "LucideClock1": function() { return Clock1; },
  "LucideClock10": function() { return Clock10; },
  "LucideClock11": function() { return Clock11; },
  "LucideClock12": function() { return Clock12; },
  "LucideClock2": function() { return Clock2; },
  "LucideClock3": function() { return Clock3; },
  "LucideClock4": function() { return Clock4; },
  "LucideClock5": function() { return Clock5; },
  "LucideClock6": function() { return Clock6; },
  "LucideClock7": function() { return Clock7; },
  "LucideClock8": function() { return Clock8; },
  "LucideClock9": function() { return Clock9; },
  "LucideCloud": function() { return Cloud; },
  "LucideCloudCog": function() { return CloudCog; },
  "LucideCloudDrizzle": function() { return CloudDrizzle; },
  "LucideCloudFog": function() { return CloudFog; },
  "LucideCloudHail": function() { return CloudHail; },
  "LucideCloudLightning": function() { return CloudLightning; },
  "LucideCloudMoon": function() { return CloudMoon; },
  "LucideCloudMoonRain": function() { return CloudMoonRain; },
  "LucideCloudOff": function() { return CloudOff; },
  "LucideCloudRain": function() { return CloudRain; },
  "LucideCloudRainWind": function() { return CloudRainWind; },
  "LucideCloudSnow": function() { return CloudSnow; },
  "LucideCloudSun": function() { return CloudSun; },
  "LucideCloudSunRain": function() { return CloudSunRain; },
  "LucideCloudy": function() { return Cloudy; },
  "LucideClover": function() { return Clover; },
  "LucideClub": function() { return Club; },
  "LucideCode": function() { return Code; },
  "LucideCode2": function() { return Code2; },
  "LucideCodepen": function() { return Codepen; },
  "LucideCodesandbox": function() { return Codesandbox; },
  "LucideCoffee": function() { return Coffee; },
  "LucideCog": function() { return Cog; },
  "LucideCoins": function() { return Coins; },
  "LucideColumns": function() { return Columns; },
  "LucideCombine": function() { return Combine; },
  "LucideCommand": function() { return Command; },
  "LucideCompass": function() { return Compass; },
  "LucideComponent": function() { return Component; },
  "LucideComputer": function() { return Computer; },
  "LucideConciergeBell": function() { return ConciergeBell; },
  "LucideCone": function() { return Cone; },
  "LucideConstruction": function() { return Construction; },
  "LucideContact": function() { return Contact; },
  "LucideContact2": function() { return Contact2; },
  "LucideContainer": function() { return container_Container; },
  "LucideContrast": function() { return Contrast; },
  "LucideCookie": function() { return Cookie; },
  "LucideCopy": function() { return Copy; },
  "LucideCopyCheck": function() { return CopyCheck; },
  "LucideCopyMinus": function() { return CopyMinus; },
  "LucideCopyPlus": function() { return CopyPlus; },
  "LucideCopySlash": function() { return CopySlash; },
  "LucideCopyX": function() { return CopyX; },
  "LucideCopyleft": function() { return Copyleft; },
  "LucideCopyright": function() { return Copyright; },
  "LucideCornerDownLeft": function() { return CornerDownLeft; },
  "LucideCornerDownRight": function() { return CornerDownRight; },
  "LucideCornerLeftDown": function() { return CornerLeftDown; },
  "LucideCornerLeftUp": function() { return CornerLeftUp; },
  "LucideCornerRightDown": function() { return CornerRightDown; },
  "LucideCornerRightUp": function() { return CornerRightUp; },
  "LucideCornerUpLeft": function() { return CornerUpLeft; },
  "LucideCornerUpRight": function() { return CornerUpRight; },
  "LucideCpu": function() { return Cpu; },
  "LucideCreativeCommons": function() { return CreativeCommons; },
  "LucideCreditCard": function() { return CreditCard; },
  "LucideCroissant": function() { return Croissant; },
  "LucideCrop": function() { return Crop; },
  "LucideCross": function() { return Cross; },
  "LucideCrosshair": function() { return Crosshair; },
  "LucideCrown": function() { return Crown; },
  "LucideCuboid": function() { return Cuboid; },
  "LucideCupSoda": function() { return CupSoda; },
  "LucideCurlyBraces": function() { return Braces; },
  "LucideCurrency": function() { return Currency; },
  "LucideCylinder": function() { return Cylinder; },
  "LucideDatabase": function() { return Database; },
  "LucideDatabaseBackup": function() { return DatabaseBackup; },
  "LucideDatabaseZap": function() { return DatabaseZap; },
  "LucideDelete": function() { return Delete; },
  "LucideDessert": function() { return Dessert; },
  "LucideDiameter": function() { return Diameter; },
  "LucideDiamond": function() { return Diamond; },
  "LucideDice1": function() { return Dice1; },
  "LucideDice2": function() { return Dice2; },
  "LucideDice3": function() { return Dice3; },
  "LucideDice4": function() { return Dice4; },
  "LucideDice5": function() { return Dice5; },
  "LucideDice6": function() { return Dice6; },
  "LucideDices": function() { return Dices; },
  "LucideDiff": function() { return Diff; },
  "LucideDisc": function() { return Disc; },
  "LucideDisc2": function() { return Disc2; },
  "LucideDisc3": function() { return Disc3; },
  "LucideDivide": function() { return Divide; },
  "LucideDivideCircle": function() { return DivideCircle; },
  "LucideDivideSquare": function() { return DivideSquare; },
  "LucideDna": function() { return Dna; },
  "LucideDnaOff": function() { return DnaOff; },
  "LucideDog": function() { return Dog; },
  "LucideDollarSign": function() { return DollarSign; },
  "LucideDonut": function() { return Donut; },
  "LucideDoorClosed": function() { return DoorClosed; },
  "LucideDoorOpen": function() { return DoorOpen; },
  "LucideDot": function() { return Dot; },
  "LucideDownload": function() { return Download; },
  "LucideDownloadCloud": function() { return DownloadCloud; },
  "LucideDraftingCompass": function() { return DraftingCompass; },
  "LucideDrama": function() { return Drama; },
  "LucideDribbble": function() { return Dribbble; },
  "LucideDroplet": function() { return Droplet; },
  "LucideDroplets": function() { return Droplets; },
  "LucideDrumstick": function() { return Drumstick; },
  "LucideDumbbell": function() { return Dumbbell; },
  "LucideEar": function() { return Ear; },
  "LucideEarOff": function() { return EarOff; },
  "LucideEdit": function() { return PenSquare; },
  "LucideEdit2": function() { return Pen; },
  "LucideEdit3": function() { return PenLine; },
  "LucideEgg": function() { return Egg; },
  "LucideEggFried": function() { return EggFried; },
  "LucideEggOff": function() { return EggOff; },
  "LucideEqual": function() { return Equal; },
  "LucideEqualNot": function() { return EqualNot; },
  "LucideEraser": function() { return Eraser; },
  "LucideEuro": function() { return Euro; },
  "LucideExpand": function() { return Expand; },
  "LucideExternalLink": function() { return ExternalLink; },
  "LucideEye": function() { return Eye; },
  "LucideEyeOff": function() { return EyeOff; },
  "LucideFacebook": function() { return Facebook; },
  "LucideFactory": function() { return Factory; },
  "LucideFan": function() { return Fan; },
  "LucideFastForward": function() { return FastForward; },
  "LucideFeather": function() { return Feather; },
  "LucideFerrisWheel": function() { return FerrisWheel; },
  "LucideFigma": function() { return Figma; },
  "LucideFile": function() { return File; },
  "LucideFileArchive": function() { return FileArchive; },
  "LucideFileAudio": function() { return FileAudio; },
  "LucideFileAudio2": function() { return FileAudio2; },
  "LucideFileAxis3D": function() { return FileAxis3d; },
  "LucideFileAxis3d": function() { return FileAxis3d; },
  "LucideFileBadge": function() { return FileBadge; },
  "LucideFileBadge2": function() { return FileBadge2; },
  "LucideFileBarChart": function() { return FileBarChart; },
  "LucideFileBarChart2": function() { return FileBarChart2; },
  "LucideFileBox": function() { return FileBox; },
  "LucideFileCheck": function() { return FileCheck; },
  "LucideFileCheck2": function() { return FileCheck2; },
  "LucideFileClock": function() { return FileClock; },
  "LucideFileCode": function() { return FileCode; },
  "LucideFileCode2": function() { return FileCode2; },
  "LucideFileCog": function() { return FileCog; },
  "LucideFileCog2": function() { return FileCog; },
  "LucideFileDiff": function() { return FileDiff; },
  "LucideFileDigit": function() { return FileDigit; },
  "LucideFileDown": function() { return FileDown; },
  "LucideFileEdit": function() { return FileEdit; },
  "LucideFileHeart": function() { return FileHeart; },
  "LucideFileImage": function() { return FileImage; },
  "LucideFileInput": function() { return FileInput; },
  "LucideFileJson": function() { return FileJson; },
  "LucideFileJson2": function() { return FileJson2; },
  "LucideFileKey": function() { return FileKey; },
  "LucideFileKey2": function() { return FileKey2; },
  "LucideFileLineChart": function() { return FileLineChart; },
  "LucideFileLock": function() { return FileLock; },
  "LucideFileLock2": function() { return FileLock2; },
  "LucideFileMinus": function() { return FileMinus; },
  "LucideFileMinus2": function() { return FileMinus2; },
  "LucideFileOutput": function() { return FileOutput; },
  "LucideFilePieChart": function() { return FilePieChart; },
  "LucideFilePlus": function() { return FilePlus; },
  "LucideFilePlus2": function() { return FilePlus2; },
  "LucideFileQuestion": function() { return FileQuestion; },
  "LucideFileScan": function() { return FileScan; },
  "LucideFileSearch": function() { return FileSearch; },
  "LucideFileSearch2": function() { return FileSearch2; },
  "LucideFileSignature": function() { return FileSignature; },
  "LucideFileSpreadsheet": function() { return FileSpreadsheet; },
  "LucideFileStack": function() { return FileStack; },
  "LucideFileSymlink": function() { return FileSymlink; },
  "LucideFileTerminal": function() { return FileTerminal; },
  "LucideFileText": function() { return FileText; },
  "LucideFileType": function() { return FileType; },
  "LucideFileType2": function() { return FileType2; },
  "LucideFileUp": function() { return FileUp; },
  "LucideFileVideo": function() { return FileVideo; },
  "LucideFileVideo2": function() { return FileVideo2; },
  "LucideFileVolume": function() { return FileVolume; },
  "LucideFileVolume2": function() { return FileVolume2; },
  "LucideFileWarning": function() { return FileWarning; },
  "LucideFileX": function() { return FileX; },
  "LucideFileX2": function() { return FileX2; },
  "LucideFiles": function() { return Files; },
  "LucideFilm": function() { return Film; },
  "LucideFilter": function() { return Filter; },
  "LucideFilterX": function() { return FilterX; },
  "LucideFingerprint": function() { return Fingerprint; },
  "LucideFish": function() { return Fish; },
  "LucideFishOff": function() { return FishOff; },
  "LucideFishSymbol": function() { return FishSymbol; },
  "LucideFlag": function() { return Flag; },
  "LucideFlagOff": function() { return FlagOff; },
  "LucideFlagTriangleLeft": function() { return FlagTriangleLeft; },
  "LucideFlagTriangleRight": function() { return FlagTriangleRight; },
  "LucideFlame": function() { return Flame; },
  "LucideFlameKindling": function() { return FlameKindling; },
  "LucideFlashlight": function() { return Flashlight; },
  "LucideFlashlightOff": function() { return FlashlightOff; },
  "LucideFlaskConical": function() { return FlaskConical; },
  "LucideFlaskConicalOff": function() { return FlaskConicalOff; },
  "LucideFlaskRound": function() { return FlaskRound; },
  "LucideFlipHorizontal": function() { return FlipHorizontal; },
  "LucideFlipHorizontal2": function() { return FlipHorizontal2; },
  "LucideFlipVertical": function() { return FlipVertical; },
  "LucideFlipVertical2": function() { return FlipVertical2; },
  "LucideFlower": function() { return Flower; },
  "LucideFlower2": function() { return Flower2; },
  "LucideFocus": function() { return Focus; },
  "LucideFoldHorizontal": function() { return FoldHorizontal; },
  "LucideFoldVertical": function() { return FoldVertical; },
  "LucideFolder": function() { return Folder; },
  "LucideFolderArchive": function() { return FolderArchive; },
  "LucideFolderCheck": function() { return FolderCheck; },
  "LucideFolderClock": function() { return FolderClock; },
  "LucideFolderClosed": function() { return FolderClosed; },
  "LucideFolderCog": function() { return FolderCog; },
  "LucideFolderCog2": function() { return FolderCog; },
  "LucideFolderDot": function() { return FolderDot; },
  "LucideFolderDown": function() { return FolderDown; },
  "LucideFolderEdit": function() { return FolderEdit; },
  "LucideFolderGit": function() { return FolderGit; },
  "LucideFolderGit2": function() { return FolderGit2; },
  "LucideFolderHeart": function() { return FolderHeart; },
  "LucideFolderInput": function() { return FolderInput; },
  "LucideFolderKanban": function() { return FolderKanban; },
  "LucideFolderKey": function() { return FolderKey; },
  "LucideFolderLock": function() { return FolderLock; },
  "LucideFolderMinus": function() { return FolderMinus; },
  "LucideFolderOpen": function() { return FolderOpen; },
  "LucideFolderOpenDot": function() { return FolderOpenDot; },
  "LucideFolderOutput": function() { return FolderOutput; },
  "LucideFolderPlus": function() { return FolderPlus; },
  "LucideFolderRoot": function() { return FolderRoot; },
  "LucideFolderSearch": function() { return FolderSearch; },
  "LucideFolderSearch2": function() { return FolderSearch2; },
  "LucideFolderSymlink": function() { return FolderSymlink; },
  "LucideFolderSync": function() { return FolderSync; },
  "LucideFolderTree": function() { return FolderTree; },
  "LucideFolderUp": function() { return FolderUp; },
  "LucideFolderX": function() { return FolderX; },
  "LucideFolders": function() { return Folders; },
  "LucideFootprints": function() { return Footprints; },
  "LucideForklift": function() { return Forklift; },
  "LucideFormInput": function() { return FormInput; },
  "LucideForward": function() { return Forward; },
  "LucideFrame": function() { return Frame; },
  "LucideFramer": function() { return Framer; },
  "LucideFrown": function() { return Frown; },
  "LucideFuel": function() { return Fuel; },
  "LucideFullscreen": function() { return Fullscreen; },
  "LucideFunctionSquare": function() { return FunctionSquare; },
  "LucideGalleryHorizontal": function() { return GalleryHorizontal; },
  "LucideGalleryHorizontalEnd": function() { return GalleryHorizontalEnd; },
  "LucideGalleryThumbnails": function() { return GalleryThumbnails; },
  "LucideGalleryVertical": function() { return GalleryVertical; },
  "LucideGalleryVerticalEnd": function() { return GalleryVerticalEnd; },
  "LucideGamepad": function() { return Gamepad; },
  "LucideGamepad2": function() { return Gamepad2; },
  "LucideGanttChart": function() { return GanttChart; },
  "LucideGanttChartSquare": function() { return GanttChartSquare; },
  "LucideGauge": function() { return Gauge; },
  "LucideGaugeCircle": function() { return GaugeCircle; },
  "LucideGavel": function() { return Gavel; },
  "LucideGem": function() { return Gem; },
  "LucideGhost": function() { return Ghost; },
  "LucideGift": function() { return Gift; },
  "LucideGitBranch": function() { return GitBranch; },
  "LucideGitBranchPlus": function() { return GitBranchPlus; },
  "LucideGitCommit": function() { return GitCommit; },
  "LucideGitCompare": function() { return GitCompare; },
  "LucideGitFork": function() { return GitFork; },
  "LucideGitMerge": function() { return GitMerge; },
  "LucideGitPullRequest": function() { return GitPullRequest; },
  "LucideGitPullRequestClosed": function() { return GitPullRequestClosed; },
  "LucideGitPullRequestDraft": function() { return GitPullRequestDraft; },
  "LucideGithub": function() { return Github; },
  "LucideGitlab": function() { return Gitlab; },
  "LucideGlassWater": function() { return GlassWater; },
  "LucideGlasses": function() { return Glasses; },
  "LucideGlobe": function() { return Globe; },
  "LucideGlobe2": function() { return Globe2; },
  "LucideGoal": function() { return Goal; },
  "LucideGrab": function() { return Grab; },
  "LucideGraduationCap": function() { return GraduationCap; },
  "LucideGrape": function() { return Grape; },
  "LucideGrid": function() { return Grid3x3; },
  "LucideGrid2X2": function() { return Grid2x2; },
  "LucideGrid2x2": function() { return Grid2x2; },
  "LucideGrid3X3": function() { return Grid3x3; },
  "LucideGrid3x3": function() { return Grid3x3; },
  "LucideGrip": function() { return Grip; },
  "LucideGripHorizontal": function() { return GripHorizontal; },
  "LucideGripVertical": function() { return GripVertical; },
  "LucideGroup": function() { return Group; },
  "LucideHammer": function() { return Hammer; },
  "LucideHand": function() { return Hand; },
  "LucideHandMetal": function() { return HandMetal; },
  "LucideHardDrive": function() { return HardDrive; },
  "LucideHardDriveDownload": function() { return HardDriveDownload; },
  "LucideHardDriveUpload": function() { return HardDriveUpload; },
  "LucideHardHat": function() { return HardHat; },
  "LucideHash": function() { return Hash; },
  "LucideHaze": function() { return Haze; },
  "LucideHdmiPort": function() { return HdmiPort; },
  "LucideHeading": function() { return Heading; },
  "LucideHeading1": function() { return Heading1; },
  "LucideHeading2": function() { return Heading2; },
  "LucideHeading3": function() { return Heading3; },
  "LucideHeading4": function() { return Heading4; },
  "LucideHeading5": function() { return Heading5; },
  "LucideHeading6": function() { return Heading6; },
  "LucideHeadphones": function() { return Headphones; },
  "LucideHeart": function() { return Heart; },
  "LucideHeartCrack": function() { return HeartCrack; },
  "LucideHeartHandshake": function() { return HeartHandshake; },
  "LucideHeartOff": function() { return HeartOff; },
  "LucideHeartPulse": function() { return HeartPulse; },
  "LucideHelpCircle": function() { return HelpCircle; },
  "LucideHelpingHand": function() { return HelpingHand; },
  "LucideHexagon": function() { return Hexagon; },
  "LucideHighlighter": function() { return Highlighter; },
  "LucideHistory": function() { return History; },
  "LucideHome": function() { return Home; },
  "LucideHop": function() { return Hop; },
  "LucideHopOff": function() { return HopOff; },
  "LucideHotel": function() { return Hotel; },
  "LucideHourglass": function() { return Hourglass; },
  "LucideIceCream": function() { return IceCream; },
  "LucideIceCream2": function() { return IceCream2; },
  "LucideImage": function() { return Image; },
  "LucideImageMinus": function() { return ImageMinus; },
  "LucideImageOff": function() { return ImageOff; },
  "LucideImagePlus": function() { return ImagePlus; },
  "LucideImport": function() { return Import; },
  "LucideInbox": function() { return Inbox; },
  "LucideIndent": function() { return Indent; },
  "LucideIndianRupee": function() { return IndianRupee; },
  "LucideInfinity": function() { return infinity_Infinity; },
  "LucideInfo": function() { return Info; },
  "LucideInspect": function() { return MousePointerSquare; },
  "LucideInstagram": function() { return Instagram; },
  "LucideItalic": function() { return Italic; },
  "LucideIterationCcw": function() { return IterationCcw; },
  "LucideIterationCw": function() { return IterationCw; },
  "LucideJapaneseYen": function() { return JapaneseYen; },
  "LucideJoystick": function() { return Joystick; },
  "LucideKanban": function() { return Kanban; },
  "LucideKanbanSquare": function() { return KanbanSquare; },
  "LucideKanbanSquareDashed": function() { return KanbanSquareDashed; },
  "LucideKey": function() { return Key; },
  "LucideKeyRound": function() { return KeyRound; },
  "LucideKeySquare": function() { return KeySquare; },
  "LucideKeyboard": function() { return Keyboard; },
  "LucideLamp": function() { return Lamp; },
  "LucideLampCeiling": function() { return LampCeiling; },
  "LucideLampDesk": function() { return LampDesk; },
  "LucideLampFloor": function() { return LampFloor; },
  "LucideLampWallDown": function() { return LampWallDown; },
  "LucideLampWallUp": function() { return LampWallUp; },
  "LucideLandPlot": function() { return LandPlot; },
  "LucideLandmark": function() { return Landmark; },
  "LucideLanguages": function() { return Languages; },
  "LucideLaptop": function() { return Laptop; },
  "LucideLaptop2": function() { return Laptop2; },
  "LucideLasso": function() { return Lasso; },
  "LucideLassoSelect": function() { return LassoSelect; },
  "LucideLaugh": function() { return Laugh; },
  "LucideLayers": function() { return Layers; },
  "LucideLayers2": function() { return Layers2; },
  "LucideLayers3": function() { return Layers3; },
  "LucideLayout": function() { return Layout; },
  "LucideLayoutDashboard": function() { return LayoutDashboard; },
  "LucideLayoutGrid": function() { return LayoutGrid; },
  "LucideLayoutList": function() { return LayoutList; },
  "LucideLayoutPanelLeft": function() { return LayoutPanelLeft; },
  "LucideLayoutPanelTop": function() { return LayoutPanelTop; },
  "LucideLayoutTemplate": function() { return LayoutTemplate; },
  "LucideLeaf": function() { return Leaf; },
  "LucideLeafyGreen": function() { return LeafyGreen; },
  "LucideLibrary": function() { return Library; },
  "LucideLifeBuoy": function() { return LifeBuoy; },
  "LucideLigature": function() { return Ligature; },
  "LucideLightbulb": function() { return Lightbulb; },
  "LucideLightbulbOff": function() { return LightbulbOff; },
  "LucideLineChart": function() { return LineChart; },
  "LucideLink": function() { return link_Link; },
  "LucideLink2": function() { return Link2; },
  "LucideLink2Off": function() { return Link2Off; },
  "LucideLinkedin": function() { return Linkedin; },
  "LucideList": function() { return List; },
  "LucideListChecks": function() { return ListChecks; },
  "LucideListEnd": function() { return ListEnd; },
  "LucideListFilter": function() { return ListFilter; },
  "LucideListMinus": function() { return ListMinus; },
  "LucideListMusic": function() { return ListMusic; },
  "LucideListOrdered": function() { return ListOrdered; },
  "LucideListPlus": function() { return ListPlus; },
  "LucideListRestart": function() { return ListRestart; },
  "LucideListStart": function() { return ListStart; },
  "LucideListTodo": function() { return ListTodo; },
  "LucideListTree": function() { return ListTree; },
  "LucideListVideo": function() { return ListVideo; },
  "LucideListX": function() { return ListX; },
  "LucideLoader": function() { return Loader; },
  "LucideLoader2": function() { return Loader2; },
  "LucideLocate": function() { return Locate; },
  "LucideLocateFixed": function() { return LocateFixed; },
  "LucideLocateOff": function() { return LocateOff; },
  "LucideLock": function() { return Lock; },
  "LucideLockKeyhole": function() { return LockKeyhole; },
  "LucideLogIn": function() { return LogIn; },
  "LucideLogOut": function() { return LogOut; },
  "LucideLollipop": function() { return Lollipop; },
  "LucideLuggage": function() { return Luggage; },
  "LucideMSquare": function() { return MSquare; },
  "LucideMagnet": function() { return Magnet; },
  "LucideMail": function() { return Mail; },
  "LucideMailCheck": function() { return MailCheck; },
  "LucideMailMinus": function() { return MailMinus; },
  "LucideMailOpen": function() { return MailOpen; },
  "LucideMailPlus": function() { return MailPlus; },
  "LucideMailQuestion": function() { return MailQuestion; },
  "LucideMailSearch": function() { return MailSearch; },
  "LucideMailWarning": function() { return MailWarning; },
  "LucideMailX": function() { return MailX; },
  "LucideMailbox": function() { return Mailbox; },
  "LucideMails": function() { return Mails; },
  "LucideMap": function() { return map_Map; },
  "LucideMapPin": function() { return MapPin; },
  "LucideMapPinOff": function() { return MapPinOff; },
  "LucideMartini": function() { return Martini; },
  "LucideMaximize": function() { return Maximize; },
  "LucideMaximize2": function() { return Maximize2; },
  "LucideMedal": function() { return Medal; },
  "LucideMegaphone": function() { return Megaphone; },
  "LucideMegaphoneOff": function() { return MegaphoneOff; },
  "LucideMeh": function() { return Meh; },
  "LucideMemoryStick": function() { return MemoryStick; },
  "LucideMenu": function() { return Menu; },
  "LucideMenuSquare": function() { return MenuSquare; },
  "LucideMerge": function() { return Merge; },
  "LucideMessageCircle": function() { return MessageCircle; },
  "LucideMessageSquare": function() { return MessageSquare; },
  "LucideMessageSquareDashed": function() { return MessageSquareDashed; },
  "LucideMessageSquarePlus": function() { return MessageSquarePlus; },
  "LucideMessagesSquare": function() { return MessagesSquare; },
  "LucideMic": function() { return Mic; },
  "LucideMic2": function() { return Mic2; },
  "LucideMicOff": function() { return MicOff; },
  "LucideMicroscope": function() { return Microscope; },
  "LucideMicrowave": function() { return Microwave; },
  "LucideMilestone": function() { return Milestone; },
  "LucideMilk": function() { return Milk; },
  "LucideMilkOff": function() { return MilkOff; },
  "LucideMinimize": function() { return Minimize; },
  "LucideMinimize2": function() { return Minimize2; },
  "LucideMinus": function() { return Minus; },
  "LucideMinusCircle": function() { return MinusCircle; },
  "LucideMinusSquare": function() { return MinusSquare; },
  "LucideMonitor": function() { return Monitor; },
  "LucideMonitorCheck": function() { return MonitorCheck; },
  "LucideMonitorDot": function() { return MonitorDot; },
  "LucideMonitorDown": function() { return MonitorDown; },
  "LucideMonitorOff": function() { return MonitorOff; },
  "LucideMonitorPause": function() { return MonitorPause; },
  "LucideMonitorPlay": function() { return MonitorPlay; },
  "LucideMonitorSmartphone": function() { return MonitorSmartphone; },
  "LucideMonitorSpeaker": function() { return MonitorSpeaker; },
  "LucideMonitorStop": function() { return MonitorStop; },
  "LucideMonitorUp": function() { return MonitorUp; },
  "LucideMonitorX": function() { return MonitorX; },
  "LucideMoon": function() { return Moon; },
  "LucideMoonStar": function() { return MoonStar; },
  "LucideMoreHorizontal": function() { return MoreHorizontal; },
  "LucideMoreVertical": function() { return MoreVertical; },
  "LucideMountain": function() { return Mountain; },
  "LucideMountainSnow": function() { return MountainSnow; },
  "LucideMouse": function() { return Mouse; },
  "LucideMousePointer": function() { return MousePointer; },
  "LucideMousePointer2": function() { return MousePointer2; },
  "LucideMousePointerClick": function() { return MousePointerClick; },
  "LucideMousePointerSquare": function() { return MousePointerSquare; },
  "LucideMousePointerSquareDashed": function() { return MousePointerSquareDashed; },
  "LucideMove": function() { return Move; },
  "LucideMove3D": function() { return Move3d; },
  "LucideMove3d": function() { return Move3d; },
  "LucideMoveDiagonal": function() { return MoveDiagonal; },
  "LucideMoveDiagonal2": function() { return MoveDiagonal2; },
  "LucideMoveDown": function() { return MoveDown; },
  "LucideMoveDownLeft": function() { return MoveDownLeft; },
  "LucideMoveDownRight": function() { return MoveDownRight; },
  "LucideMoveHorizontal": function() { return MoveHorizontal; },
  "LucideMoveLeft": function() { return MoveLeft; },
  "LucideMoveRight": function() { return MoveRight; },
  "LucideMoveUp": function() { return MoveUp; },
  "LucideMoveUpLeft": function() { return MoveUpLeft; },
  "LucideMoveUpRight": function() { return MoveUpRight; },
  "LucideMoveVertical": function() { return MoveVertical; },
  "LucideMusic": function() { return Music; },
  "LucideMusic2": function() { return Music2; },
  "LucideMusic3": function() { return Music3; },
  "LucideMusic4": function() { return Music4; },
  "LucideNavigation": function() { return Navigation; },
  "LucideNavigation2": function() { return Navigation2; },
  "LucideNavigation2Off": function() { return Navigation2Off; },
  "LucideNavigationOff": function() { return NavigationOff; },
  "LucideNetwork": function() { return Network; },
  "LucideNewspaper": function() { return Newspaper; },
  "LucideNfc": function() { return Nfc; },
  "LucideNut": function() { return Nut; },
  "LucideNutOff": function() { return NutOff; },
  "LucideOctagon": function() { return Octagon; },
  "LucideOption": function() { return Option; },
  "LucideOrbit": function() { return Orbit; },
  "LucideOutdent": function() { return Outdent; },
  "LucidePackage": function() { return Package; },
  "LucidePackage2": function() { return Package2; },
  "LucidePackageCheck": function() { return PackageCheck; },
  "LucidePackageMinus": function() { return PackageMinus; },
  "LucidePackageOpen": function() { return PackageOpen; },
  "LucidePackagePlus": function() { return PackagePlus; },
  "LucidePackageSearch": function() { return PackageSearch; },
  "LucidePackageX": function() { return PackageX; },
  "LucidePaintBucket": function() { return PaintBucket; },
  "LucidePaintbrush": function() { return Paintbrush; },
  "LucidePaintbrush2": function() { return Paintbrush2; },
  "LucidePalette": function() { return Palette; },
  "LucidePalmtree": function() { return Palmtree; },
  "LucidePanelBottom": function() { return PanelBottom; },
  "LucidePanelBottomClose": function() { return PanelBottomClose; },
  "LucidePanelBottomInactive": function() { return PanelBottomInactive; },
  "LucidePanelBottomOpen": function() { return PanelBottomOpen; },
  "LucidePanelLeft": function() { return PanelLeft; },
  "LucidePanelLeftClose": function() { return PanelLeftClose; },
  "LucidePanelLeftInactive": function() { return PanelLeftInactive; },
  "LucidePanelLeftOpen": function() { return PanelLeftOpen; },
  "LucidePanelRight": function() { return PanelRight; },
  "LucidePanelRightClose": function() { return PanelRightClose; },
  "LucidePanelRightInactive": function() { return PanelRightInactive; },
  "LucidePanelRightOpen": function() { return PanelRightOpen; },
  "LucidePanelTop": function() { return PanelTop; },
  "LucidePanelTopClose": function() { return PanelTopClose; },
  "LucidePanelTopInactive": function() { return PanelTopInactive; },
  "LucidePanelTopOpen": function() { return PanelTopOpen; },
  "LucidePaperclip": function() { return Paperclip; },
  "LucideParentheses": function() { return Parentheses; },
  "LucideParkingCircle": function() { return ParkingCircle; },
  "LucideParkingCircleOff": function() { return ParkingCircleOff; },
  "LucideParkingMeter": function() { return ParkingMeter; },
  "LucideParkingSquare": function() { return ParkingSquare; },
  "LucideParkingSquareOff": function() { return ParkingSquareOff; },
  "LucidePartyPopper": function() { return PartyPopper; },
  "LucidePause": function() { return Pause; },
  "LucidePauseCircle": function() { return PauseCircle; },
  "LucidePauseOctagon": function() { return PauseOctagon; },
  "LucidePawPrint": function() { return PawPrint; },
  "LucidePcCase": function() { return PcCase; },
  "LucidePen": function() { return Pen; },
  "LucidePenBox": function() { return PenSquare; },
  "LucidePenLine": function() { return PenLine; },
  "LucidePenSquare": function() { return PenSquare; },
  "LucidePenTool": function() { return PenTool; },
  "LucidePencil": function() { return Pencil; },
  "LucidePencilLine": function() { return PencilLine; },
  "LucidePencilRuler": function() { return PencilRuler; },
  "LucidePentagon": function() { return Pentagon; },
  "LucidePercent": function() { return Percent; },
  "LucidePercentCircle": function() { return PercentCircle; },
  "LucidePercentDiamond": function() { return PercentDiamond; },
  "LucidePercentSquare": function() { return PercentSquare; },
  "LucidePersonStanding": function() { return PersonStanding; },
  "LucidePhone": function() { return Phone; },
  "LucidePhoneCall": function() { return PhoneCall; },
  "LucidePhoneForwarded": function() { return PhoneForwarded; },
  "LucidePhoneIncoming": function() { return PhoneIncoming; },
  "LucidePhoneMissed": function() { return PhoneMissed; },
  "LucidePhoneOff": function() { return PhoneOff; },
  "LucidePhoneOutgoing": function() { return PhoneOutgoing; },
  "LucidePi": function() { return Pi; },
  "LucidePiSquare": function() { return PiSquare; },
  "LucidePictureInPicture": function() { return PictureInPicture; },
  "LucidePictureInPicture2": function() { return PictureInPicture2; },
  "LucidePieChart": function() { return PieChart; },
  "LucidePiggyBank": function() { return PiggyBank; },
  "LucidePilcrow": function() { return Pilcrow; },
  "LucidePilcrowSquare": function() { return PilcrowSquare; },
  "LucidePill": function() { return Pill; },
  "LucidePin": function() { return Pin; },
  "LucidePinOff": function() { return PinOff; },
  "LucidePipette": function() { return Pipette; },
  "LucidePizza": function() { return Pizza; },
  "LucidePlane": function() { return Plane; },
  "LucidePlaneLanding": function() { return PlaneLanding; },
  "LucidePlaneTakeoff": function() { return PlaneTakeoff; },
  "LucidePlay": function() { return Play; },
  "LucidePlayCircle": function() { return PlayCircle; },
  "LucidePlaySquare": function() { return PlaySquare; },
  "LucidePlug": function() { return Plug; },
  "LucidePlug2": function() { return Plug2; },
  "LucidePlugZap": function() { return PlugZap; },
  "LucidePlugZap2": function() { return PlugZap2; },
  "LucidePlus": function() { return Plus; },
  "LucidePlusCircle": function() { return PlusCircle; },
  "LucidePlusSquare": function() { return PlusSquare; },
  "LucidePocket": function() { return Pocket; },
  "LucidePocketKnife": function() { return PocketKnife; },
  "LucidePodcast": function() { return Podcast; },
  "LucidePointer": function() { return Pointer; },
  "LucidePopcorn": function() { return Popcorn; },
  "LucidePopsicle": function() { return Popsicle; },
  "LucidePoundSterling": function() { return PoundSterling; },
  "LucidePower": function() { return Power; },
  "LucidePowerOff": function() { return PowerOff; },
  "LucidePresentation": function() { return Presentation; },
  "LucidePrinter": function() { return Printer; },
  "LucideProjector": function() { return Projector; },
  "LucidePuzzle": function() { return Puzzle; },
  "LucidePyramid": function() { return Pyramid; },
  "LucideQrCode": function() { return QrCode; },
  "LucideQuote": function() { return Quote; },
  "LucideRabbit": function() { return Rabbit; },
  "LucideRadar": function() { return Radar; },
  "LucideRadiation": function() { return Radiation; },
  "LucideRadio": function() { return Radio; },
  "LucideRadioReceiver": function() { return RadioReceiver; },
  "LucideRadioTower": function() { return RadioTower; },
  "LucideRadius": function() { return Radius; },
  "LucideRailSymbol": function() { return RailSymbol; },
  "LucideRainbow": function() { return Rainbow; },
  "LucideRat": function() { return Rat; },
  "LucideRatio": function() { return Ratio; },
  "LucideReceipt": function() { return Receipt; },
  "LucideRectangleHorizontal": function() { return RectangleHorizontal; },
  "LucideRectangleVertical": function() { return RectangleVertical; },
  "LucideRecycle": function() { return Recycle; },
  "LucideRedo": function() { return Redo; },
  "LucideRedo2": function() { return Redo2; },
  "LucideRedoDot": function() { return RedoDot; },
  "LucideRefreshCcw": function() { return RefreshCcw; },
  "LucideRefreshCcwDot": function() { return RefreshCcwDot; },
  "LucideRefreshCw": function() { return RefreshCw; },
  "LucideRefreshCwOff": function() { return RefreshCwOff; },
  "LucideRefrigerator": function() { return Refrigerator; },
  "LucideRegex": function() { return Regex; },
  "LucideRemoveFormatting": function() { return RemoveFormatting; },
  "LucideRepeat": function() { return Repeat; },
  "LucideRepeat1": function() { return Repeat1; },
  "LucideRepeat2": function() { return Repeat2; },
  "LucideReplace": function() { return Replace; },
  "LucideReplaceAll": function() { return ReplaceAll; },
  "LucideReply": function() { return Reply; },
  "LucideReplyAll": function() { return ReplyAll; },
  "LucideRewind": function() { return Rewind; },
  "LucideRocket": function() { return Rocket; },
  "LucideRockingChair": function() { return RockingChair; },
  "LucideRollerCoaster": function() { return RollerCoaster; },
  "LucideRotate3D": function() { return Rotate3d; },
  "LucideRotate3d": function() { return Rotate3d; },
  "LucideRotateCcw": function() { return RotateCcw; },
  "LucideRotateCw": function() { return RotateCw; },
  "LucideRouter": function() { return Router; },
  "LucideRows": function() { return Rows; },
  "LucideRss": function() { return Rss; },
  "LucideRuler": function() { return Ruler; },
  "LucideRussianRuble": function() { return RussianRuble; },
  "LucideSailboat": function() { return Sailboat; },
  "LucideSalad": function() { return Salad; },
  "LucideSandwich": function() { return Sandwich; },
  "LucideSatellite": function() { return Satellite; },
  "LucideSatelliteDish": function() { return SatelliteDish; },
  "LucideSave": function() { return Save; },
  "LucideSaveAll": function() { return SaveAll; },
  "LucideScale": function() { return Scale; },
  "LucideScale3D": function() { return Scale3d; },
  "LucideScale3d": function() { return Scale3d; },
  "LucideScaling": function() { return Scaling; },
  "LucideScan": function() { return Scan; },
  "LucideScanBarcode": function() { return ScanBarcode; },
  "LucideScanEye": function() { return ScanEye; },
  "LucideScanFace": function() { return ScanFace; },
  "LucideScanLine": function() { return ScanLine; },
  "LucideScanSearch": function() { return ScanSearch; },
  "LucideScanText": function() { return ScanText; },
  "LucideScatterChart": function() { return ScatterChart; },
  "LucideSchool": function() { return School; },
  "LucideSchool2": function() { return School2; },
  "LucideScissors": function() { return Scissors; },
  "LucideScissorsLineDashed": function() { return ScissorsLineDashed; },
  "LucideScissorsSquare": function() { return ScissorsSquare; },
  "LucideScissorsSquareDashedBottom": function() { return ScissorsSquareDashedBottom; },
  "LucideScreenShare": function() { return ScreenShare; },
  "LucideScreenShareOff": function() { return ScreenShareOff; },
  "LucideScroll": function() { return Scroll; },
  "LucideScrollText": function() { return ScrollText; },
  "LucideSearch": function() { return Search; },
  "LucideSearchCheck": function() { return SearchCheck; },
  "LucideSearchCode": function() { return SearchCode; },
  "LucideSearchSlash": function() { return SearchSlash; },
  "LucideSearchX": function() { return SearchX; },
  "LucideSend": function() { return Send; },
  "LucideSendHorizonal": function() { return SendHorizontal; },
  "LucideSendHorizontal": function() { return SendHorizontal; },
  "LucideSendToBack": function() { return SendToBack; },
  "LucideSeparatorHorizontal": function() { return SeparatorHorizontal; },
  "LucideSeparatorVertical": function() { return SeparatorVertical; },
  "LucideServer": function() { return server_Server; },
  "LucideServerCog": function() { return ServerCog; },
  "LucideServerCrash": function() { return ServerCrash; },
  "LucideServerOff": function() { return ServerOff; },
  "LucideSettings": function() { return Settings; },
  "LucideSettings2": function() { return Settings2; },
  "LucideShapes": function() { return Shapes; },
  "LucideShare": function() { return Share; },
  "LucideShare2": function() { return Share2; },
  "LucideSheet": function() { return Sheet; },
  "LucideShell": function() { return Shell; },
  "LucideShield": function() { return Shield; },
  "LucideShieldAlert": function() { return ShieldAlert; },
  "LucideShieldBan": function() { return ShieldBan; },
  "LucideShieldCheck": function() { return ShieldCheck; },
  "LucideShieldClose": function() { return ShieldX; },
  "LucideShieldEllipsis": function() { return ShieldEllipsis; },
  "LucideShieldHalf": function() { return ShieldHalf; },
  "LucideShieldMinus": function() { return ShieldMinus; },
  "LucideShieldOff": function() { return ShieldOff; },
  "LucideShieldPlus": function() { return ShieldPlus; },
  "LucideShieldQuestion": function() { return ShieldQuestion; },
  "LucideShieldX": function() { return ShieldX; },
  "LucideShip": function() { return Ship; },
  "LucideShipWheel": function() { return ShipWheel; },
  "LucideShirt": function() { return Shirt; },
  "LucideShoppingBag": function() { return ShoppingBag; },
  "LucideShoppingBasket": function() { return ShoppingBasket; },
  "LucideShoppingCart": function() { return ShoppingCart; },
  "LucideShovel": function() { return Shovel; },
  "LucideShowerHead": function() { return ShowerHead; },
  "LucideShrink": function() { return Shrink; },
  "LucideShrub": function() { return Shrub; },
  "LucideShuffle": function() { return Shuffle; },
  "LucideSidebar": function() { return PanelLeft; },
  "LucideSidebarClose": function() { return PanelLeftClose; },
  "LucideSidebarOpen": function() { return PanelLeftOpen; },
  "LucideSigma": function() { return Sigma; },
  "LucideSigmaSquare": function() { return SigmaSquare; },
  "LucideSignal": function() { return Signal; },
  "LucideSignalHigh": function() { return SignalHigh; },
  "LucideSignalLow": function() { return SignalLow; },
  "LucideSignalMedium": function() { return SignalMedium; },
  "LucideSignalZero": function() { return SignalZero; },
  "LucideSiren": function() { return Siren; },
  "LucideSkipBack": function() { return SkipBack; },
  "LucideSkipForward": function() { return SkipForward; },
  "LucideSkull": function() { return Skull; },
  "LucideSlack": function() { return Slack; },
  "LucideSlash": function() { return Slash; },
  "LucideSlice": function() { return Slice; },
  "LucideSliders": function() { return Sliders; },
  "LucideSlidersHorizontal": function() { return SlidersHorizontal; },
  "LucideSmartphone": function() { return Smartphone; },
  "LucideSmartphoneCharging": function() { return SmartphoneCharging; },
  "LucideSmartphoneNfc": function() { return SmartphoneNfc; },
  "LucideSmile": function() { return Smile; },
  "LucideSmilePlus": function() { return SmilePlus; },
  "LucideSnail": function() { return Snail; },
  "LucideSnowflake": function() { return Snowflake; },
  "LucideSofa": function() { return Sofa; },
  "LucideSortAsc": function() { return ArrowUpNarrowWide; },
  "LucideSortDesc": function() { return ArrowDownWideNarrow; },
  "LucideSoup": function() { return Soup; },
  "LucideSpace": function() { return Space; },
  "LucideSpade": function() { return Spade; },
  "LucideSparkle": function() { return Sparkle; },
  "LucideSparkles": function() { return Sparkles; },
  "LucideSpeaker": function() { return Speaker; },
  "LucideSpeech": function() { return Speech; },
  "LucideSpellCheck": function() { return SpellCheck; },
  "LucideSpellCheck2": function() { return SpellCheck2; },
  "LucideSpline": function() { return Spline; },
  "LucideSplit": function() { return Split; },
  "LucideSplitSquareHorizontal": function() { return SplitSquareHorizontal; },
  "LucideSplitSquareVertical": function() { return SplitSquareVertical; },
  "LucideSprayCan": function() { return SprayCan; },
  "LucideSprout": function() { return Sprout; },
  "LucideSquare": function() { return Square; },
  "LucideSquareAsterisk": function() { return SquareAsterisk; },
  "LucideSquareCode": function() { return SquareCode; },
  "LucideSquareDashedBottom": function() { return SquareDashedBottom; },
  "LucideSquareDashedBottomCode": function() { return SquareDashedBottomCode; },
  "LucideSquareDot": function() { return SquareDot; },
  "LucideSquareEqual": function() { return SquareEqual; },
  "LucideSquareGantt": function() { return GanttChartSquare; },
  "LucideSquareKanban": function() { return KanbanSquare; },
  "LucideSquareKanbanDashed": function() { return KanbanSquareDashed; },
  "LucideSquareSlash": function() { return SquareSlash; },
  "LucideSquareStack": function() { return SquareStack; },
  "LucideSquirrel": function() { return Squirrel; },
  "LucideStamp": function() { return Stamp; },
  "LucideStar": function() { return Star; },
  "LucideStarHalf": function() { return StarHalf; },
  "LucideStarOff": function() { return StarOff; },
  "LucideStars": function() { return Sparkles; },
  "LucideStepBack": function() { return StepBack; },
  "LucideStepForward": function() { return StepForward; },
  "LucideStethoscope": function() { return Stethoscope; },
  "LucideSticker": function() { return Sticker; },
  "LucideStickyNote": function() { return StickyNote; },
  "LucideStopCircle": function() { return StopCircle; },
  "LucideStore": function() { return Store; },
  "LucideStretchHorizontal": function() { return StretchHorizontal; },
  "LucideStretchVertical": function() { return StretchVertical; },
  "LucideStrikethrough": function() { return Strikethrough; },
  "LucideSubscript": function() { return Subscript; },
  "LucideSubtitles": function() { return Subtitles; },
  "LucideSun": function() { return Sun; },
  "LucideSunDim": function() { return SunDim; },
  "LucideSunMedium": function() { return SunMedium; },
  "LucideSunMoon": function() { return SunMoon; },
  "LucideSunSnow": function() { return SunSnow; },
  "LucideSunrise": function() { return Sunrise; },
  "LucideSunset": function() { return Sunset; },
  "LucideSuperscript": function() { return Superscript; },
  "LucideSwissFranc": function() { return SwissFranc; },
  "LucideSwitchCamera": function() { return SwitchCamera; },
  "LucideSword": function() { return Sword; },
  "LucideSwords": function() { return Swords; },
  "LucideSyringe": function() { return Syringe; },
  "LucideTable": function() { return Table; },
  "LucideTable2": function() { return Table2; },
  "LucideTableProperties": function() { return TableProperties; },
  "LucideTablet": function() { return Tablet; },
  "LucideTabletSmartphone": function() { return TabletSmartphone; },
  "LucideTablets": function() { return Tablets; },
  "LucideTag": function() { return Tag; },
  "LucideTags": function() { return Tags; },
  "LucideTally1": function() { return Tally1; },
  "LucideTally2": function() { return Tally2; },
  "LucideTally3": function() { return Tally3; },
  "LucideTally4": function() { return Tally4; },
  "LucideTally5": function() { return Tally5; },
  "LucideTangent": function() { return Tangent; },
  "LucideTarget": function() { return Target; },
  "LucideTent": function() { return Tent; },
  "LucideTentTree": function() { return TentTree; },
  "LucideTerminal": function() { return Terminal; },
  "LucideTerminalSquare": function() { return TerminalSquare; },
  "LucideTestTube": function() { return TestTube; },
  "LucideTestTube2": function() { return TestTube2; },
  "LucideTestTubes": function() { return TestTubes; },
  "LucideText": function() { return Text; },
  "LucideTextCursor": function() { return TextCursor; },
  "LucideTextCursorInput": function() { return TextCursorInput; },
  "LucideTextQuote": function() { return TextQuote; },
  "LucideTextSelect": function() { return TextSelect; },
  "LucideTextSelection": function() { return TextSelect; },
  "LucideTheater": function() { return Theater; },
  "LucideThermometer": function() { return Thermometer; },
  "LucideThermometerSnowflake": function() { return ThermometerSnowflake; },
  "LucideThermometerSun": function() { return ThermometerSun; },
  "LucideThumbsDown": function() { return ThumbsDown; },
  "LucideThumbsUp": function() { return ThumbsUp; },
  "LucideTicket": function() { return Ticket; },
  "LucideTimer": function() { return Timer; },
  "LucideTimerOff": function() { return TimerOff; },
  "LucideTimerReset": function() { return TimerReset; },
  "LucideToggleLeft": function() { return ToggleLeft; },
  "LucideToggleRight": function() { return ToggleRight; },
  "LucideTornado": function() { return Tornado; },
  "LucideTorus": function() { return Torus; },
  "LucideTouchpad": function() { return Touchpad; },
  "LucideTouchpadOff": function() { return TouchpadOff; },
  "LucideTowerControl": function() { return TowerControl; },
  "LucideToyBrick": function() { return ToyBrick; },
  "LucideTractor": function() { return Tractor; },
  "LucideTrafficCone": function() { return TrafficCone; },
  "LucideTrain": function() { return TramFront; },
  "LucideTrainFront": function() { return TrainFront; },
  "LucideTrainFrontTunnel": function() { return TrainFrontTunnel; },
  "LucideTrainTrack": function() { return TrainTrack; },
  "LucideTramFront": function() { return TramFront; },
  "LucideTrash": function() { return Trash; },
  "LucideTrash2": function() { return Trash2; },
  "LucideTreeDeciduous": function() { return TreeDeciduous; },
  "LucideTreePine": function() { return TreePine; },
  "LucideTrees": function() { return Trees; },
  "LucideTrello": function() { return Trello; },
  "LucideTrendingDown": function() { return TrendingDown; },
  "LucideTrendingUp": function() { return TrendingUp; },
  "LucideTriangle": function() { return Triangle; },
  "LucideTriangleRight": function() { return TriangleRight; },
  "LucideTrophy": function() { return Trophy; },
  "LucideTruck": function() { return Truck; },
  "LucideTurtle": function() { return Turtle; },
  "LucideTv": function() { return Tv; },
  "LucideTv2": function() { return Tv2; },
  "LucideTwitch": function() { return Twitch; },
  "LucideTwitter": function() { return Twitter; },
  "LucideType": function() { return Type; },
  "LucideUmbrella": function() { return Umbrella; },
  "LucideUnderline": function() { return Underline; },
  "LucideUndo": function() { return Undo; },
  "LucideUndo2": function() { return Undo2; },
  "LucideUndoDot": function() { return UndoDot; },
  "LucideUnfoldHorizontal": function() { return UnfoldHorizontal; },
  "LucideUnfoldVertical": function() { return UnfoldVertical; },
  "LucideUngroup": function() { return Ungroup; },
  "LucideUnlink": function() { return Unlink; },
  "LucideUnlink2": function() { return Unlink2; },
  "LucideUnlock": function() { return Unlock; },
  "LucideUnlockKeyhole": function() { return UnlockKeyhole; },
  "LucideUnplug": function() { return Unplug; },
  "LucideUpload": function() { return Upload; },
  "LucideUploadCloud": function() { return UploadCloud; },
  "LucideUsb": function() { return Usb; },
  "LucideUser": function() { return User; },
  "LucideUser2": function() { return User2; },
  "LucideUserCheck": function() { return UserCheck; },
  "LucideUserCheck2": function() { return UserCheck2; },
  "LucideUserCircle": function() { return UserCircle; },
  "LucideUserCircle2": function() { return UserCircle2; },
  "LucideUserCog": function() { return UserCog; },
  "LucideUserCog2": function() { return UserCog2; },
  "LucideUserMinus": function() { return UserMinus; },
  "LucideUserMinus2": function() { return UserMinus2; },
  "LucideUserPlus": function() { return UserPlus; },
  "LucideUserPlus2": function() { return UserPlus2; },
  "LucideUserSquare": function() { return UserSquare; },
  "LucideUserSquare2": function() { return UserSquare2; },
  "LucideUserX": function() { return UserX; },
  "LucideUserX2": function() { return UserX2; },
  "LucideUsers": function() { return Users; },
  "LucideUsers2": function() { return Users2; },
  "LucideUtensils": function() { return Utensils; },
  "LucideUtensilsCrossed": function() { return UtensilsCrossed; },
  "LucideUtilityPole": function() { return UtilityPole; },
  "LucideVariable": function() { return Variable; },
  "LucideVegan": function() { return Vegan; },
  "LucideVenetianMask": function() { return VenetianMask; },
  "LucideVerified": function() { return BadgeCheck; },
  "LucideVibrate": function() { return Vibrate; },
  "LucideVibrateOff": function() { return VibrateOff; },
  "LucideVideo": function() { return Video; },
  "LucideVideoOff": function() { return VideoOff; },
  "LucideVideotape": function() { return Videotape; },
  "LucideView": function() { return View; },
  "LucideVoicemail": function() { return Voicemail; },
  "LucideVolume": function() { return Volume; },
  "LucideVolume1": function() { return Volume1; },
  "LucideVolume2": function() { return Volume2; },
  "LucideVolumeX": function() { return VolumeX; },
  "LucideVote": function() { return Vote; },
  "LucideWallet": function() { return Wallet; },
  "LucideWallet2": function() { return Wallet2; },
  "LucideWalletCards": function() { return WalletCards; },
  "LucideWallpaper": function() { return Wallpaper; },
  "LucideWand": function() { return Wand; },
  "LucideWand2": function() { return Wand2; },
  "LucideWarehouse": function() { return Warehouse; },
  "LucideWatch": function() { return Watch; },
  "LucideWaves": function() { return Waves; },
  "LucideWebcam": function() { return Webcam; },
  "LucideWebhook": function() { return Webhook; },
  "LucideWeight": function() { return Weight; },
  "LucideWheat": function() { return Wheat; },
  "LucideWheatOff": function() { return WheatOff; },
  "LucideWholeWord": function() { return WholeWord; },
  "LucideWifi": function() { return Wifi; },
  "LucideWifiOff": function() { return WifiOff; },
  "LucideWind": function() { return Wind; },
  "LucideWine": function() { return Wine; },
  "LucideWineOff": function() { return WineOff; },
  "LucideWorkflow": function() { return Workflow; },
  "LucideWrapText": function() { return WrapText; },
  "LucideWrench": function() { return Wrench; },
  "LucideX": function() { return x_X; },
  "LucideXCircle": function() { return XCircle; },
  "LucideXOctagon": function() { return XOctagon; },
  "LucideXSquare": function() { return XSquare; },
  "LucideYoutube": function() { return Youtube; },
  "LucideZap": function() { return Zap; },
  "LucideZapOff": function() { return ZapOff; },
  "LucideZoomIn": function() { return ZoomIn; },
  "LucideZoomOut": function() { return ZoomOut; },
  "Luggage": function() { return Luggage; },
  "LuggageIcon": function() { return Luggage; },
  "MSquare": function() { return MSquare; },
  "MSquareIcon": function() { return MSquare; },
  "Magnet": function() { return Magnet; },
  "MagnetIcon": function() { return Magnet; },
  "Mail": function() { return Mail; },
  "MailCheck": function() { return MailCheck; },
  "MailCheckIcon": function() { return MailCheck; },
  "MailIcon": function() { return Mail; },
  "MailMinus": function() { return MailMinus; },
  "MailMinusIcon": function() { return MailMinus; },
  "MailOpen": function() { return MailOpen; },
  "MailOpenIcon": function() { return MailOpen; },
  "MailPlus": function() { return MailPlus; },
  "MailPlusIcon": function() { return MailPlus; },
  "MailQuestion": function() { return MailQuestion; },
  "MailQuestionIcon": function() { return MailQuestion; },
  "MailSearch": function() { return MailSearch; },
  "MailSearchIcon": function() { return MailSearch; },
  "MailWarning": function() { return MailWarning; },
  "MailWarningIcon": function() { return MailWarning; },
  "MailX": function() { return MailX; },
  "MailXIcon": function() { return MailX; },
  "Mailbox": function() { return Mailbox; },
  "MailboxIcon": function() { return Mailbox; },
  "Mails": function() { return Mails; },
  "MailsIcon": function() { return Mails; },
  "Map": function() { return map_Map; },
  "MapIcon": function() { return map_Map; },
  "MapPin": function() { return MapPin; },
  "MapPinIcon": function() { return MapPin; },
  "MapPinOff": function() { return MapPinOff; },
  "MapPinOffIcon": function() { return MapPinOff; },
  "Martini": function() { return Martini; },
  "MartiniIcon": function() { return Martini; },
  "Maximize": function() { return Maximize; },
  "Maximize2": function() { return Maximize2; },
  "Maximize2Icon": function() { return Maximize2; },
  "MaximizeIcon": function() { return Maximize; },
  "Medal": function() { return Medal; },
  "MedalIcon": function() { return Medal; },
  "Megaphone": function() { return Megaphone; },
  "MegaphoneIcon": function() { return Megaphone; },
  "MegaphoneOff": function() { return MegaphoneOff; },
  "MegaphoneOffIcon": function() { return MegaphoneOff; },
  "Meh": function() { return Meh; },
  "MehIcon": function() { return Meh; },
  "MemoryStick": function() { return MemoryStick; },
  "MemoryStickIcon": function() { return MemoryStick; },
  "Menu": function() { return Menu; },
  "MenuIcon": function() { return Menu; },
  "MenuSquare": function() { return MenuSquare; },
  "MenuSquareIcon": function() { return MenuSquare; },
  "Merge": function() { return Merge; },
  "MergeIcon": function() { return Merge; },
  "MessageCircle": function() { return MessageCircle; },
  "MessageCircleIcon": function() { return MessageCircle; },
  "MessageSquare": function() { return MessageSquare; },
  "MessageSquareDashed": function() { return MessageSquareDashed; },
  "MessageSquareDashedIcon": function() { return MessageSquareDashed; },
  "MessageSquareIcon": function() { return MessageSquare; },
  "MessageSquarePlus": function() { return MessageSquarePlus; },
  "MessageSquarePlusIcon": function() { return MessageSquarePlus; },
  "MessagesSquare": function() { return MessagesSquare; },
  "MessagesSquareIcon": function() { return MessagesSquare; },
  "Mic": function() { return Mic; },
  "Mic2": function() { return Mic2; },
  "Mic2Icon": function() { return Mic2; },
  "MicIcon": function() { return Mic; },
  "MicOff": function() { return MicOff; },
  "MicOffIcon": function() { return MicOff; },
  "Microscope": function() { return Microscope; },
  "MicroscopeIcon": function() { return Microscope; },
  "Microwave": function() { return Microwave; },
  "MicrowaveIcon": function() { return Microwave; },
  "Milestone": function() { return Milestone; },
  "MilestoneIcon": function() { return Milestone; },
  "Milk": function() { return Milk; },
  "MilkIcon": function() { return Milk; },
  "MilkOff": function() { return MilkOff; },
  "MilkOffIcon": function() { return MilkOff; },
  "Minimize": function() { return Minimize; },
  "Minimize2": function() { return Minimize2; },
  "Minimize2Icon": function() { return Minimize2; },
  "MinimizeIcon": function() { return Minimize; },
  "Minus": function() { return Minus; },
  "MinusCircle": function() { return MinusCircle; },
  "MinusCircleIcon": function() { return MinusCircle; },
  "MinusIcon": function() { return Minus; },
  "MinusSquare": function() { return MinusSquare; },
  "MinusSquareIcon": function() { return MinusSquare; },
  "Monitor": function() { return Monitor; },
  "MonitorCheck": function() { return MonitorCheck; },
  "MonitorCheckIcon": function() { return MonitorCheck; },
  "MonitorDot": function() { return MonitorDot; },
  "MonitorDotIcon": function() { return MonitorDot; },
  "MonitorDown": function() { return MonitorDown; },
  "MonitorDownIcon": function() { return MonitorDown; },
  "MonitorIcon": function() { return Monitor; },
  "MonitorOff": function() { return MonitorOff; },
  "MonitorOffIcon": function() { return MonitorOff; },
  "MonitorPause": function() { return MonitorPause; },
  "MonitorPauseIcon": function() { return MonitorPause; },
  "MonitorPlay": function() { return MonitorPlay; },
  "MonitorPlayIcon": function() { return MonitorPlay; },
  "MonitorSmartphone": function() { return MonitorSmartphone; },
  "MonitorSmartphoneIcon": function() { return MonitorSmartphone; },
  "MonitorSpeaker": function() { return MonitorSpeaker; },
  "MonitorSpeakerIcon": function() { return MonitorSpeaker; },
  "MonitorStop": function() { return MonitorStop; },
  "MonitorStopIcon": function() { return MonitorStop; },
  "MonitorUp": function() { return MonitorUp; },
  "MonitorUpIcon": function() { return MonitorUp; },
  "MonitorX": function() { return MonitorX; },
  "MonitorXIcon": function() { return MonitorX; },
  "Moon": function() { return Moon; },
  "MoonIcon": function() { return Moon; },
  "MoonStar": function() { return MoonStar; },
  "MoonStarIcon": function() { return MoonStar; },
  "MoreHorizontal": function() { return MoreHorizontal; },
  "MoreHorizontalIcon": function() { return MoreHorizontal; },
  "MoreVertical": function() { return MoreVertical; },
  "MoreVerticalIcon": function() { return MoreVertical; },
  "Mountain": function() { return Mountain; },
  "MountainIcon": function() { return Mountain; },
  "MountainSnow": function() { return MountainSnow; },
  "MountainSnowIcon": function() { return MountainSnow; },
  "Mouse": function() { return Mouse; },
  "MouseIcon": function() { return Mouse; },
  "MousePointer": function() { return MousePointer; },
  "MousePointer2": function() { return MousePointer2; },
  "MousePointer2Icon": function() { return MousePointer2; },
  "MousePointerClick": function() { return MousePointerClick; },
  "MousePointerClickIcon": function() { return MousePointerClick; },
  "MousePointerIcon": function() { return MousePointer; },
  "MousePointerSquare": function() { return MousePointerSquare; },
  "MousePointerSquareDashed": function() { return MousePointerSquareDashed; },
  "MousePointerSquareDashedIcon": function() { return MousePointerSquareDashed; },
  "MousePointerSquareIcon": function() { return MousePointerSquare; },
  "Move": function() { return Move; },
  "Move3D": function() { return Move3d; },
  "Move3DIcon": function() { return Move3d; },
  "Move3d": function() { return Move3d; },
  "Move3dIcon": function() { return Move3d; },
  "MoveDiagonal": function() { return MoveDiagonal; },
  "MoveDiagonal2": function() { return MoveDiagonal2; },
  "MoveDiagonal2Icon": function() { return MoveDiagonal2; },
  "MoveDiagonalIcon": function() { return MoveDiagonal; },
  "MoveDown": function() { return MoveDown; },
  "MoveDownIcon": function() { return MoveDown; },
  "MoveDownLeft": function() { return MoveDownLeft; },
  "MoveDownLeftIcon": function() { return MoveDownLeft; },
  "MoveDownRight": function() { return MoveDownRight; },
  "MoveDownRightIcon": function() { return MoveDownRight; },
  "MoveHorizontal": function() { return MoveHorizontal; },
  "MoveHorizontalIcon": function() { return MoveHorizontal; },
  "MoveIcon": function() { return Move; },
  "MoveLeft": function() { return MoveLeft; },
  "MoveLeftIcon": function() { return MoveLeft; },
  "MoveRight": function() { return MoveRight; },
  "MoveRightIcon": function() { return MoveRight; },
  "MoveUp": function() { return MoveUp; },
  "MoveUpIcon": function() { return MoveUp; },
  "MoveUpLeft": function() { return MoveUpLeft; },
  "MoveUpLeftIcon": function() { return MoveUpLeft; },
  "MoveUpRight": function() { return MoveUpRight; },
  "MoveUpRightIcon": function() { return MoveUpRight; },
  "MoveVertical": function() { return MoveVertical; },
  "MoveVerticalIcon": function() { return MoveVertical; },
  "Music": function() { return Music; },
  "Music2": function() { return Music2; },
  "Music2Icon": function() { return Music2; },
  "Music3": function() { return Music3; },
  "Music3Icon": function() { return Music3; },
  "Music4": function() { return Music4; },
  "Music4Icon": function() { return Music4; },
  "MusicIcon": function() { return Music; },
  "Navigation": function() { return Navigation; },
  "Navigation2": function() { return Navigation2; },
  "Navigation2Icon": function() { return Navigation2; },
  "Navigation2Off": function() { return Navigation2Off; },
  "Navigation2OffIcon": function() { return Navigation2Off; },
  "NavigationIcon": function() { return Navigation; },
  "NavigationOff": function() { return NavigationOff; },
  "NavigationOffIcon": function() { return NavigationOff; },
  "Network": function() { return Network; },
  "NetworkIcon": function() { return Network; },
  "Newspaper": function() { return Newspaper; },
  "NewspaperIcon": function() { return Newspaper; },
  "Nfc": function() { return Nfc; },
  "NfcIcon": function() { return Nfc; },
  "Nut": function() { return Nut; },
  "NutIcon": function() { return Nut; },
  "NutOff": function() { return NutOff; },
  "NutOffIcon": function() { return NutOff; },
  "Octagon": function() { return Octagon; },
  "OctagonIcon": function() { return Octagon; },
  "Option": function() { return Option; },
  "OptionIcon": function() { return Option; },
  "Orbit": function() { return Orbit; },
  "OrbitIcon": function() { return Orbit; },
  "Outdent": function() { return Outdent; },
  "OutdentIcon": function() { return Outdent; },
  "Package": function() { return Package; },
  "Package2": function() { return Package2; },
  "Package2Icon": function() { return Package2; },
  "PackageCheck": function() { return PackageCheck; },
  "PackageCheckIcon": function() { return PackageCheck; },
  "PackageIcon": function() { return Package; },
  "PackageMinus": function() { return PackageMinus; },
  "PackageMinusIcon": function() { return PackageMinus; },
  "PackageOpen": function() { return PackageOpen; },
  "PackageOpenIcon": function() { return PackageOpen; },
  "PackagePlus": function() { return PackagePlus; },
  "PackagePlusIcon": function() { return PackagePlus; },
  "PackageSearch": function() { return PackageSearch; },
  "PackageSearchIcon": function() { return PackageSearch; },
  "PackageX": function() { return PackageX; },
  "PackageXIcon": function() { return PackageX; },
  "PaintBucket": function() { return PaintBucket; },
  "PaintBucketIcon": function() { return PaintBucket; },
  "Paintbrush": function() { return Paintbrush; },
  "Paintbrush2": function() { return Paintbrush2; },
  "Paintbrush2Icon": function() { return Paintbrush2; },
  "PaintbrushIcon": function() { return Paintbrush; },
  "Palette": function() { return Palette; },
  "PaletteIcon": function() { return Palette; },
  "Palmtree": function() { return Palmtree; },
  "PalmtreeIcon": function() { return Palmtree; },
  "PanelBottom": function() { return PanelBottom; },
  "PanelBottomClose": function() { return PanelBottomClose; },
  "PanelBottomCloseIcon": function() { return PanelBottomClose; },
  "PanelBottomIcon": function() { return PanelBottom; },
  "PanelBottomInactive": function() { return PanelBottomInactive; },
  "PanelBottomInactiveIcon": function() { return PanelBottomInactive; },
  "PanelBottomOpen": function() { return PanelBottomOpen; },
  "PanelBottomOpenIcon": function() { return PanelBottomOpen; },
  "PanelLeft": function() { return PanelLeft; },
  "PanelLeftClose": function() { return PanelLeftClose; },
  "PanelLeftCloseIcon": function() { return PanelLeftClose; },
  "PanelLeftIcon": function() { return PanelLeft; },
  "PanelLeftInactive": function() { return PanelLeftInactive; },
  "PanelLeftInactiveIcon": function() { return PanelLeftInactive; },
  "PanelLeftOpen": function() { return PanelLeftOpen; },
  "PanelLeftOpenIcon": function() { return PanelLeftOpen; },
  "PanelRight": function() { return PanelRight; },
  "PanelRightClose": function() { return PanelRightClose; },
  "PanelRightCloseIcon": function() { return PanelRightClose; },
  "PanelRightIcon": function() { return PanelRight; },
  "PanelRightInactive": function() { return PanelRightInactive; },
  "PanelRightInactiveIcon": function() { return PanelRightInactive; },
  "PanelRightOpen": function() { return PanelRightOpen; },
  "PanelRightOpenIcon": function() { return PanelRightOpen; },
  "PanelTop": function() { return PanelTop; },
  "PanelTopClose": function() { return PanelTopClose; },
  "PanelTopCloseIcon": function() { return PanelTopClose; },
  "PanelTopIcon": function() { return PanelTop; },
  "PanelTopInactive": function() { return PanelTopInactive; },
  "PanelTopInactiveIcon": function() { return PanelTopInactive; },
  "PanelTopOpen": function() { return PanelTopOpen; },
  "PanelTopOpenIcon": function() { return PanelTopOpen; },
  "Paperclip": function() { return Paperclip; },
  "PaperclipIcon": function() { return Paperclip; },
  "Parentheses": function() { return Parentheses; },
  "ParenthesesIcon": function() { return Parentheses; },
  "ParkingCircle": function() { return ParkingCircle; },
  "ParkingCircleIcon": function() { return ParkingCircle; },
  "ParkingCircleOff": function() { return ParkingCircleOff; },
  "ParkingCircleOffIcon": function() { return ParkingCircleOff; },
  "ParkingMeter": function() { return ParkingMeter; },
  "ParkingMeterIcon": function() { return ParkingMeter; },
  "ParkingSquare": function() { return ParkingSquare; },
  "ParkingSquareIcon": function() { return ParkingSquare; },
  "ParkingSquareOff": function() { return ParkingSquareOff; },
  "ParkingSquareOffIcon": function() { return ParkingSquareOff; },
  "PartyPopper": function() { return PartyPopper; },
  "PartyPopperIcon": function() { return PartyPopper; },
  "Pause": function() { return Pause; },
  "PauseCircle": function() { return PauseCircle; },
  "PauseCircleIcon": function() { return PauseCircle; },
  "PauseIcon": function() { return Pause; },
  "PauseOctagon": function() { return PauseOctagon; },
  "PauseOctagonIcon": function() { return PauseOctagon; },
  "PawPrint": function() { return PawPrint; },
  "PawPrintIcon": function() { return PawPrint; },
  "PcCase": function() { return PcCase; },
  "PcCaseIcon": function() { return PcCase; },
  "Pen": function() { return Pen; },
  "PenBox": function() { return PenSquare; },
  "PenBoxIcon": function() { return PenSquare; },
  "PenIcon": function() { return Pen; },
  "PenLine": function() { return PenLine; },
  "PenLineIcon": function() { return PenLine; },
  "PenSquare": function() { return PenSquare; },
  "PenSquareIcon": function() { return PenSquare; },
  "PenTool": function() { return PenTool; },
  "PenToolIcon": function() { return PenTool; },
  "Pencil": function() { return Pencil; },
  "PencilIcon": function() { return Pencil; },
  "PencilLine": function() { return PencilLine; },
  "PencilLineIcon": function() { return PencilLine; },
  "PencilRuler": function() { return PencilRuler; },
  "PencilRulerIcon": function() { return PencilRuler; },
  "Pentagon": function() { return Pentagon; },
  "PentagonIcon": function() { return Pentagon; },
  "Percent": function() { return Percent; },
  "PercentCircle": function() { return PercentCircle; },
  "PercentCircleIcon": function() { return PercentCircle; },
  "PercentDiamond": function() { return PercentDiamond; },
  "PercentDiamondIcon": function() { return PercentDiamond; },
  "PercentIcon": function() { return Percent; },
  "PercentSquare": function() { return PercentSquare; },
  "PercentSquareIcon": function() { return PercentSquare; },
  "PersonStanding": function() { return PersonStanding; },
  "PersonStandingIcon": function() { return PersonStanding; },
  "Phone": function() { return Phone; },
  "PhoneCall": function() { return PhoneCall; },
  "PhoneCallIcon": function() { return PhoneCall; },
  "PhoneForwarded": function() { return PhoneForwarded; },
  "PhoneForwardedIcon": function() { return PhoneForwarded; },
  "PhoneIcon": function() { return Phone; },
  "PhoneIncoming": function() { return PhoneIncoming; },
  "PhoneIncomingIcon": function() { return PhoneIncoming; },
  "PhoneMissed": function() { return PhoneMissed; },
  "PhoneMissedIcon": function() { return PhoneMissed; },
  "PhoneOff": function() { return PhoneOff; },
  "PhoneOffIcon": function() { return PhoneOff; },
  "PhoneOutgoing": function() { return PhoneOutgoing; },
  "PhoneOutgoingIcon": function() { return PhoneOutgoing; },
  "Pi": function() { return Pi; },
  "PiIcon": function() { return Pi; },
  "PiSquare": function() { return PiSquare; },
  "PiSquareIcon": function() { return PiSquare; },
  "PictureInPicture": function() { return PictureInPicture; },
  "PictureInPicture2": function() { return PictureInPicture2; },
  "PictureInPicture2Icon": function() { return PictureInPicture2; },
  "PictureInPictureIcon": function() { return PictureInPicture; },
  "PieChart": function() { return PieChart; },
  "PieChartIcon": function() { return PieChart; },
  "PiggyBank": function() { return PiggyBank; },
  "PiggyBankIcon": function() { return PiggyBank; },
  "Pilcrow": function() { return Pilcrow; },
  "PilcrowIcon": function() { return Pilcrow; },
  "PilcrowSquare": function() { return PilcrowSquare; },
  "PilcrowSquareIcon": function() { return PilcrowSquare; },
  "Pill": function() { return Pill; },
  "PillIcon": function() { return Pill; },
  "Pin": function() { return Pin; },
  "PinIcon": function() { return Pin; },
  "PinOff": function() { return PinOff; },
  "PinOffIcon": function() { return PinOff; },
  "Pipette": function() { return Pipette; },
  "PipetteIcon": function() { return Pipette; },
  "Pizza": function() { return Pizza; },
  "PizzaIcon": function() { return Pizza; },
  "Plane": function() { return Plane; },
  "PlaneIcon": function() { return Plane; },
  "PlaneLanding": function() { return PlaneLanding; },
  "PlaneLandingIcon": function() { return PlaneLanding; },
  "PlaneTakeoff": function() { return PlaneTakeoff; },
  "PlaneTakeoffIcon": function() { return PlaneTakeoff; },
  "Play": function() { return Play; },
  "PlayCircle": function() { return PlayCircle; },
  "PlayCircleIcon": function() { return PlayCircle; },
  "PlayIcon": function() { return Play; },
  "PlaySquare": function() { return PlaySquare; },
  "PlaySquareIcon": function() { return PlaySquare; },
  "Plug": function() { return Plug; },
  "Plug2": function() { return Plug2; },
  "Plug2Icon": function() { return Plug2; },
  "PlugIcon": function() { return Plug; },
  "PlugZap": function() { return PlugZap; },
  "PlugZap2": function() { return PlugZap2; },
  "PlugZap2Icon": function() { return PlugZap2; },
  "PlugZapIcon": function() { return PlugZap; },
  "Plus": function() { return Plus; },
  "PlusCircle": function() { return PlusCircle; },
  "PlusCircleIcon": function() { return PlusCircle; },
  "PlusIcon": function() { return Plus; },
  "PlusSquare": function() { return PlusSquare; },
  "PlusSquareIcon": function() { return PlusSquare; },
  "Pocket": function() { return Pocket; },
  "PocketIcon": function() { return Pocket; },
  "PocketKnife": function() { return PocketKnife; },
  "PocketKnifeIcon": function() { return PocketKnife; },
  "Podcast": function() { return Podcast; },
  "PodcastIcon": function() { return Podcast; },
  "Pointer": function() { return Pointer; },
  "PointerIcon": function() { return Pointer; },
  "Popcorn": function() { return Popcorn; },
  "PopcornIcon": function() { return Popcorn; },
  "Popsicle": function() { return Popsicle; },
  "PopsicleIcon": function() { return Popsicle; },
  "PoundSterling": function() { return PoundSterling; },
  "PoundSterlingIcon": function() { return PoundSterling; },
  "Power": function() { return Power; },
  "PowerIcon": function() { return Power; },
  "PowerOff": function() { return PowerOff; },
  "PowerOffIcon": function() { return PowerOff; },
  "Presentation": function() { return Presentation; },
  "PresentationIcon": function() { return Presentation; },
  "Printer": function() { return Printer; },
  "PrinterIcon": function() { return Printer; },
  "Projector": function() { return Projector; },
  "ProjectorIcon": function() { return Projector; },
  "Puzzle": function() { return Puzzle; },
  "PuzzleIcon": function() { return Puzzle; },
  "Pyramid": function() { return Pyramid; },
  "PyramidIcon": function() { return Pyramid; },
  "QrCode": function() { return QrCode; },
  "QrCodeIcon": function() { return QrCode; },
  "Quote": function() { return Quote; },
  "QuoteIcon": function() { return Quote; },
  "Rabbit": function() { return Rabbit; },
  "RabbitIcon": function() { return Rabbit; },
  "Radar": function() { return Radar; },
  "RadarIcon": function() { return Radar; },
  "Radiation": function() { return Radiation; },
  "RadiationIcon": function() { return Radiation; },
  "Radio": function() { return Radio; },
  "RadioIcon": function() { return Radio; },
  "RadioReceiver": function() { return RadioReceiver; },
  "RadioReceiverIcon": function() { return RadioReceiver; },
  "RadioTower": function() { return RadioTower; },
  "RadioTowerIcon": function() { return RadioTower; },
  "Radius": function() { return Radius; },
  "RadiusIcon": function() { return Radius; },
  "RailSymbol": function() { return RailSymbol; },
  "RailSymbolIcon": function() { return RailSymbol; },
  "Rainbow": function() { return Rainbow; },
  "RainbowIcon": function() { return Rainbow; },
  "Rat": function() { return Rat; },
  "RatIcon": function() { return Rat; },
  "Ratio": function() { return Ratio; },
  "RatioIcon": function() { return Ratio; },
  "Receipt": function() { return Receipt; },
  "ReceiptIcon": function() { return Receipt; },
  "RectangleHorizontal": function() { return RectangleHorizontal; },
  "RectangleHorizontalIcon": function() { return RectangleHorizontal; },
  "RectangleVertical": function() { return RectangleVertical; },
  "RectangleVerticalIcon": function() { return RectangleVertical; },
  "Recycle": function() { return Recycle; },
  "RecycleIcon": function() { return Recycle; },
  "Redo": function() { return Redo; },
  "Redo2": function() { return Redo2; },
  "Redo2Icon": function() { return Redo2; },
  "RedoDot": function() { return RedoDot; },
  "RedoDotIcon": function() { return RedoDot; },
  "RedoIcon": function() { return Redo; },
  "RefreshCcw": function() { return RefreshCcw; },
  "RefreshCcwDot": function() { return RefreshCcwDot; },
  "RefreshCcwDotIcon": function() { return RefreshCcwDot; },
  "RefreshCcwIcon": function() { return RefreshCcw; },
  "RefreshCw": function() { return RefreshCw; },
  "RefreshCwIcon": function() { return RefreshCw; },
  "RefreshCwOff": function() { return RefreshCwOff; },
  "RefreshCwOffIcon": function() { return RefreshCwOff; },
  "Refrigerator": function() { return Refrigerator; },
  "RefrigeratorIcon": function() { return Refrigerator; },
  "Regex": function() { return Regex; },
  "RegexIcon": function() { return Regex; },
  "RemoveFormatting": function() { return RemoveFormatting; },
  "RemoveFormattingIcon": function() { return RemoveFormatting; },
  "Repeat": function() { return Repeat; },
  "Repeat1": function() { return Repeat1; },
  "Repeat1Icon": function() { return Repeat1; },
  "Repeat2": function() { return Repeat2; },
  "Repeat2Icon": function() { return Repeat2; },
  "RepeatIcon": function() { return Repeat; },
  "Replace": function() { return Replace; },
  "ReplaceAll": function() { return ReplaceAll; },
  "ReplaceAllIcon": function() { return ReplaceAll; },
  "ReplaceIcon": function() { return Replace; },
  "Reply": function() { return Reply; },
  "ReplyAll": function() { return ReplyAll; },
  "ReplyAllIcon": function() { return ReplyAll; },
  "ReplyIcon": function() { return Reply; },
  "Rewind": function() { return Rewind; },
  "RewindIcon": function() { return Rewind; },
  "Rocket": function() { return Rocket; },
  "RocketIcon": function() { return Rocket; },
  "RockingChair": function() { return RockingChair; },
  "RockingChairIcon": function() { return RockingChair; },
  "RollerCoaster": function() { return RollerCoaster; },
  "RollerCoasterIcon": function() { return RollerCoaster; },
  "Rotate3D": function() { return Rotate3d; },
  "Rotate3DIcon": function() { return Rotate3d; },
  "Rotate3d": function() { return Rotate3d; },
  "Rotate3dIcon": function() { return Rotate3d; },
  "RotateCcw": function() { return RotateCcw; },
  "RotateCcwIcon": function() { return RotateCcw; },
  "RotateCw": function() { return RotateCw; },
  "RotateCwIcon": function() { return RotateCw; },
  "Router": function() { return Router; },
  "RouterIcon": function() { return Router; },
  "Rows": function() { return Rows; },
  "RowsIcon": function() { return Rows; },
  "Rss": function() { return Rss; },
  "RssIcon": function() { return Rss; },
  "Ruler": function() { return Ruler; },
  "RulerIcon": function() { return Ruler; },
  "RussianRuble": function() { return RussianRuble; },
  "RussianRubleIcon": function() { return RussianRuble; },
  "Sailboat": function() { return Sailboat; },
  "SailboatIcon": function() { return Sailboat; },
  "Salad": function() { return Salad; },
  "SaladIcon": function() { return Salad; },
  "Sandwich": function() { return Sandwich; },
  "SandwichIcon": function() { return Sandwich; },
  "Satellite": function() { return Satellite; },
  "SatelliteDish": function() { return SatelliteDish; },
  "SatelliteDishIcon": function() { return SatelliteDish; },
  "SatelliteIcon": function() { return Satellite; },
  "Save": function() { return Save; },
  "SaveAll": function() { return SaveAll; },
  "SaveAllIcon": function() { return SaveAll; },
  "SaveIcon": function() { return Save; },
  "Scale": function() { return Scale; },
  "Scale3D": function() { return Scale3d; },
  "Scale3DIcon": function() { return Scale3d; },
  "Scale3d": function() { return Scale3d; },
  "Scale3dIcon": function() { return Scale3d; },
  "ScaleIcon": function() { return Scale; },
  "Scaling": function() { return Scaling; },
  "ScalingIcon": function() { return Scaling; },
  "Scan": function() { return Scan; },
  "ScanBarcode": function() { return ScanBarcode; },
  "ScanBarcodeIcon": function() { return ScanBarcode; },
  "ScanEye": function() { return ScanEye; },
  "ScanEyeIcon": function() { return ScanEye; },
  "ScanFace": function() { return ScanFace; },
  "ScanFaceIcon": function() { return ScanFace; },
  "ScanIcon": function() { return Scan; },
  "ScanLine": function() { return ScanLine; },
  "ScanLineIcon": function() { return ScanLine; },
  "ScanSearch": function() { return ScanSearch; },
  "ScanSearchIcon": function() { return ScanSearch; },
  "ScanText": function() { return ScanText; },
  "ScanTextIcon": function() { return ScanText; },
  "ScatterChart": function() { return ScatterChart; },
  "ScatterChartIcon": function() { return ScatterChart; },
  "School": function() { return School; },
  "School2": function() { return School2; },
  "School2Icon": function() { return School2; },
  "SchoolIcon": function() { return School; },
  "Scissors": function() { return Scissors; },
  "ScissorsIcon": function() { return Scissors; },
  "ScissorsLineDashed": function() { return ScissorsLineDashed; },
  "ScissorsLineDashedIcon": function() { return ScissorsLineDashed; },
  "ScissorsSquare": function() { return ScissorsSquare; },
  "ScissorsSquareDashedBottom": function() { return ScissorsSquareDashedBottom; },
  "ScissorsSquareDashedBottomIcon": function() { return ScissorsSquareDashedBottom; },
  "ScissorsSquareIcon": function() { return ScissorsSquare; },
  "ScreenShare": function() { return ScreenShare; },
  "ScreenShareIcon": function() { return ScreenShare; },
  "ScreenShareOff": function() { return ScreenShareOff; },
  "ScreenShareOffIcon": function() { return ScreenShareOff; },
  "Scroll": function() { return Scroll; },
  "ScrollIcon": function() { return Scroll; },
  "ScrollText": function() { return ScrollText; },
  "ScrollTextIcon": function() { return ScrollText; },
  "Search": function() { return Search; },
  "SearchCheck": function() { return SearchCheck; },
  "SearchCheckIcon": function() { return SearchCheck; },
  "SearchCode": function() { return SearchCode; },
  "SearchCodeIcon": function() { return SearchCode; },
  "SearchIcon": function() { return Search; },
  "SearchSlash": function() { return SearchSlash; },
  "SearchSlashIcon": function() { return SearchSlash; },
  "SearchX": function() { return SearchX; },
  "SearchXIcon": function() { return SearchX; },
  "Send": function() { return Send; },
  "SendHorizonal": function() { return SendHorizontal; },
  "SendHorizonalIcon": function() { return SendHorizontal; },
  "SendHorizontal": function() { return SendHorizontal; },
  "SendHorizontalIcon": function() { return SendHorizontal; },
  "SendIcon": function() { return Send; },
  "SendToBack": function() { return SendToBack; },
  "SendToBackIcon": function() { return SendToBack; },
  "SeparatorHorizontal": function() { return SeparatorHorizontal; },
  "SeparatorHorizontalIcon": function() { return SeparatorHorizontal; },
  "SeparatorVertical": function() { return SeparatorVertical; },
  "SeparatorVerticalIcon": function() { return SeparatorVertical; },
  "Server": function() { return server_Server; },
  "ServerCog": function() { return ServerCog; },
  "ServerCogIcon": function() { return ServerCog; },
  "ServerCrash": function() { return ServerCrash; },
  "ServerCrashIcon": function() { return ServerCrash; },
  "ServerIcon": function() { return server_Server; },
  "ServerOff": function() { return ServerOff; },
  "ServerOffIcon": function() { return ServerOff; },
  "Settings": function() { return Settings; },
  "Settings2": function() { return Settings2; },
  "Settings2Icon": function() { return Settings2; },
  "SettingsIcon": function() { return Settings; },
  "Shapes": function() { return Shapes; },
  "ShapesIcon": function() { return Shapes; },
  "Share": function() { return Share; },
  "Share2": function() { return Share2; },
  "Share2Icon": function() { return Share2; },
  "ShareIcon": function() { return Share; },
  "Sheet": function() { return Sheet; },
  "SheetIcon": function() { return Sheet; },
  "Shell": function() { return Shell; },
  "ShellIcon": function() { return Shell; },
  "Shield": function() { return Shield; },
  "ShieldAlert": function() { return ShieldAlert; },
  "ShieldAlertIcon": function() { return ShieldAlert; },
  "ShieldBan": function() { return ShieldBan; },
  "ShieldBanIcon": function() { return ShieldBan; },
  "ShieldCheck": function() { return ShieldCheck; },
  "ShieldCheckIcon": function() { return ShieldCheck; },
  "ShieldClose": function() { return ShieldX; },
  "ShieldCloseIcon": function() { return ShieldX; },
  "ShieldEllipsis": function() { return ShieldEllipsis; },
  "ShieldEllipsisIcon": function() { return ShieldEllipsis; },
  "ShieldHalf": function() { return ShieldHalf; },
  "ShieldHalfIcon": function() { return ShieldHalf; },
  "ShieldIcon": function() { return Shield; },
  "ShieldMinus": function() { return ShieldMinus; },
  "ShieldMinusIcon": function() { return ShieldMinus; },
  "ShieldOff": function() { return ShieldOff; },
  "ShieldOffIcon": function() { return ShieldOff; },
  "ShieldPlus": function() { return ShieldPlus; },
  "ShieldPlusIcon": function() { return ShieldPlus; },
  "ShieldQuestion": function() { return ShieldQuestion; },
  "ShieldQuestionIcon": function() { return ShieldQuestion; },
  "ShieldX": function() { return ShieldX; },
  "ShieldXIcon": function() { return ShieldX; },
  "Ship": function() { return Ship; },
  "ShipIcon": function() { return Ship; },
  "ShipWheel": function() { return ShipWheel; },
  "ShipWheelIcon": function() { return ShipWheel; },
  "Shirt": function() { return Shirt; },
  "ShirtIcon": function() { return Shirt; },
  "ShoppingBag": function() { return ShoppingBag; },
  "ShoppingBagIcon": function() { return ShoppingBag; },
  "ShoppingBasket": function() { return ShoppingBasket; },
  "ShoppingBasketIcon": function() { return ShoppingBasket; },
  "ShoppingCart": function() { return ShoppingCart; },
  "ShoppingCartIcon": function() { return ShoppingCart; },
  "Shovel": function() { return Shovel; },
  "ShovelIcon": function() { return Shovel; },
  "ShowerHead": function() { return ShowerHead; },
  "ShowerHeadIcon": function() { return ShowerHead; },
  "Shrink": function() { return Shrink; },
  "ShrinkIcon": function() { return Shrink; },
  "Shrub": function() { return Shrub; },
  "ShrubIcon": function() { return Shrub; },
  "Shuffle": function() { return Shuffle; },
  "ShuffleIcon": function() { return Shuffle; },
  "Sidebar": function() { return PanelLeft; },
  "SidebarClose": function() { return PanelLeftClose; },
  "SidebarCloseIcon": function() { return PanelLeftClose; },
  "SidebarIcon": function() { return PanelLeft; },
  "SidebarOpen": function() { return PanelLeftOpen; },
  "SidebarOpenIcon": function() { return PanelLeftOpen; },
  "Sigma": function() { return Sigma; },
  "SigmaIcon": function() { return Sigma; },
  "SigmaSquare": function() { return SigmaSquare; },
  "SigmaSquareIcon": function() { return SigmaSquare; },
  "Signal": function() { return Signal; },
  "SignalHigh": function() { return SignalHigh; },
  "SignalHighIcon": function() { return SignalHigh; },
  "SignalIcon": function() { return Signal; },
  "SignalLow": function() { return SignalLow; },
  "SignalLowIcon": function() { return SignalLow; },
  "SignalMedium": function() { return SignalMedium; },
  "SignalMediumIcon": function() { return SignalMedium; },
  "SignalZero": function() { return SignalZero; },
  "SignalZeroIcon": function() { return SignalZero; },
  "Siren": function() { return Siren; },
  "SirenIcon": function() { return Siren; },
  "SkipBack": function() { return SkipBack; },
  "SkipBackIcon": function() { return SkipBack; },
  "SkipForward": function() { return SkipForward; },
  "SkipForwardIcon": function() { return SkipForward; },
  "Skull": function() { return Skull; },
  "SkullIcon": function() { return Skull; },
  "Slack": function() { return Slack; },
  "SlackIcon": function() { return Slack; },
  "Slash": function() { return Slash; },
  "SlashIcon": function() { return Slash; },
  "Slice": function() { return Slice; },
  "SliceIcon": function() { return Slice; },
  "Sliders": function() { return Sliders; },
  "SlidersHorizontal": function() { return SlidersHorizontal; },
  "SlidersHorizontalIcon": function() { return SlidersHorizontal; },
  "SlidersIcon": function() { return Sliders; },
  "Smartphone": function() { return Smartphone; },
  "SmartphoneCharging": function() { return SmartphoneCharging; },
  "SmartphoneChargingIcon": function() { return SmartphoneCharging; },
  "SmartphoneIcon": function() { return Smartphone; },
  "SmartphoneNfc": function() { return SmartphoneNfc; },
  "SmartphoneNfcIcon": function() { return SmartphoneNfc; },
  "Smile": function() { return Smile; },
  "SmileIcon": function() { return Smile; },
  "SmilePlus": function() { return SmilePlus; },
  "SmilePlusIcon": function() { return SmilePlus; },
  "Snail": function() { return Snail; },
  "SnailIcon": function() { return Snail; },
  "Snowflake": function() { return Snowflake; },
  "SnowflakeIcon": function() { return Snowflake; },
  "Sofa": function() { return Sofa; },
  "SofaIcon": function() { return Sofa; },
  "SortAsc": function() { return ArrowUpNarrowWide; },
  "SortAscIcon": function() { return ArrowUpNarrowWide; },
  "SortDesc": function() { return ArrowDownWideNarrow; },
  "SortDescIcon": function() { return ArrowDownWideNarrow; },
  "Soup": function() { return Soup; },
  "SoupIcon": function() { return Soup; },
  "Space": function() { return Space; },
  "SpaceIcon": function() { return Space; },
  "Spade": function() { return Spade; },
  "SpadeIcon": function() { return Spade; },
  "Sparkle": function() { return Sparkle; },
  "SparkleIcon": function() { return Sparkle; },
  "Sparkles": function() { return Sparkles; },
  "SparklesIcon": function() { return Sparkles; },
  "Speaker": function() { return Speaker; },
  "SpeakerIcon": function() { return Speaker; },
  "Speech": function() { return Speech; },
  "SpeechIcon": function() { return Speech; },
  "SpellCheck": function() { return SpellCheck; },
  "SpellCheck2": function() { return SpellCheck2; },
  "SpellCheck2Icon": function() { return SpellCheck2; },
  "SpellCheckIcon": function() { return SpellCheck; },
  "Spline": function() { return Spline; },
  "SplineIcon": function() { return Spline; },
  "Split": function() { return Split; },
  "SplitIcon": function() { return Split; },
  "SplitSquareHorizontal": function() { return SplitSquareHorizontal; },
  "SplitSquareHorizontalIcon": function() { return SplitSquareHorizontal; },
  "SplitSquareVertical": function() { return SplitSquareVertical; },
  "SplitSquareVerticalIcon": function() { return SplitSquareVertical; },
  "SprayCan": function() { return SprayCan; },
  "SprayCanIcon": function() { return SprayCan; },
  "Sprout": function() { return Sprout; },
  "SproutIcon": function() { return Sprout; },
  "Square": function() { return Square; },
  "SquareAsterisk": function() { return SquareAsterisk; },
  "SquareAsteriskIcon": function() { return SquareAsterisk; },
  "SquareCode": function() { return SquareCode; },
  "SquareCodeIcon": function() { return SquareCode; },
  "SquareDashedBottom": function() { return SquareDashedBottom; },
  "SquareDashedBottomCode": function() { return SquareDashedBottomCode; },
  "SquareDashedBottomCodeIcon": function() { return SquareDashedBottomCode; },
  "SquareDashedBottomIcon": function() { return SquareDashedBottom; },
  "SquareDot": function() { return SquareDot; },
  "SquareDotIcon": function() { return SquareDot; },
  "SquareEqual": function() { return SquareEqual; },
  "SquareEqualIcon": function() { return SquareEqual; },
  "SquareGantt": function() { return GanttChartSquare; },
  "SquareGanttIcon": function() { return GanttChartSquare; },
  "SquareIcon": function() { return Square; },
  "SquareKanban": function() { return KanbanSquare; },
  "SquareKanbanDashed": function() { return KanbanSquareDashed; },
  "SquareKanbanDashedIcon": function() { return KanbanSquareDashed; },
  "SquareKanbanIcon": function() { return KanbanSquare; },
  "SquareSlash": function() { return SquareSlash; },
  "SquareSlashIcon": function() { return SquareSlash; },
  "SquareStack": function() { return SquareStack; },
  "SquareStackIcon": function() { return SquareStack; },
  "Squirrel": function() { return Squirrel; },
  "SquirrelIcon": function() { return Squirrel; },
  "Stamp": function() { return Stamp; },
  "StampIcon": function() { return Stamp; },
  "Star": function() { return Star; },
  "StarHalf": function() { return StarHalf; },
  "StarHalfIcon": function() { return StarHalf; },
  "StarIcon": function() { return Star; },
  "StarOff": function() { return StarOff; },
  "StarOffIcon": function() { return StarOff; },
  "Stars": function() { return Sparkles; },
  "StarsIcon": function() { return Sparkles; },
  "StepBack": function() { return StepBack; },
  "StepBackIcon": function() { return StepBack; },
  "StepForward": function() { return StepForward; },
  "StepForwardIcon": function() { return StepForward; },
  "Stethoscope": function() { return Stethoscope; },
  "StethoscopeIcon": function() { return Stethoscope; },
  "Sticker": function() { return Sticker; },
  "StickerIcon": function() { return Sticker; },
  "StickyNote": function() { return StickyNote; },
  "StickyNoteIcon": function() { return StickyNote; },
  "StopCircle": function() { return StopCircle; },
  "StopCircleIcon": function() { return StopCircle; },
  "Store": function() { return Store; },
  "StoreIcon": function() { return Store; },
  "StretchHorizontal": function() { return StretchHorizontal; },
  "StretchHorizontalIcon": function() { return StretchHorizontal; },
  "StretchVertical": function() { return StretchVertical; },
  "StretchVerticalIcon": function() { return StretchVertical; },
  "Strikethrough": function() { return Strikethrough; },
  "StrikethroughIcon": function() { return Strikethrough; },
  "Subscript": function() { return Subscript; },
  "SubscriptIcon": function() { return Subscript; },
  "Subtitles": function() { return Subtitles; },
  "SubtitlesIcon": function() { return Subtitles; },
  "Sun": function() { return Sun; },
  "SunDim": function() { return SunDim; },
  "SunDimIcon": function() { return SunDim; },
  "SunIcon": function() { return Sun; },
  "SunMedium": function() { return SunMedium; },
  "SunMediumIcon": function() { return SunMedium; },
  "SunMoon": function() { return SunMoon; },
  "SunMoonIcon": function() { return SunMoon; },
  "SunSnow": function() { return SunSnow; },
  "SunSnowIcon": function() { return SunSnow; },
  "Sunrise": function() { return Sunrise; },
  "SunriseIcon": function() { return Sunrise; },
  "Sunset": function() { return Sunset; },
  "SunsetIcon": function() { return Sunset; },
  "Superscript": function() { return Superscript; },
  "SuperscriptIcon": function() { return Superscript; },
  "SwissFranc": function() { return SwissFranc; },
  "SwissFrancIcon": function() { return SwissFranc; },
  "SwitchCamera": function() { return SwitchCamera; },
  "SwitchCameraIcon": function() { return SwitchCamera; },
  "Sword": function() { return Sword; },
  "SwordIcon": function() { return Sword; },
  "Swords": function() { return Swords; },
  "SwordsIcon": function() { return Swords; },
  "Syringe": function() { return Syringe; },
  "SyringeIcon": function() { return Syringe; },
  "Table": function() { return Table; },
  "Table2": function() { return Table2; },
  "Table2Icon": function() { return Table2; },
  "TableIcon": function() { return Table; },
  "TableProperties": function() { return TableProperties; },
  "TablePropertiesIcon": function() { return TableProperties; },
  "Tablet": function() { return Tablet; },
  "TabletIcon": function() { return Tablet; },
  "TabletSmartphone": function() { return TabletSmartphone; },
  "TabletSmartphoneIcon": function() { return TabletSmartphone; },
  "Tablets": function() { return Tablets; },
  "TabletsIcon": function() { return Tablets; },
  "Tag": function() { return Tag; },
  "TagIcon": function() { return Tag; },
  "Tags": function() { return Tags; },
  "TagsIcon": function() { return Tags; },
  "Tally1": function() { return Tally1; },
  "Tally1Icon": function() { return Tally1; },
  "Tally2": function() { return Tally2; },
  "Tally2Icon": function() { return Tally2; },
  "Tally3": function() { return Tally3; },
  "Tally3Icon": function() { return Tally3; },
  "Tally4": function() { return Tally4; },
  "Tally4Icon": function() { return Tally4; },
  "Tally5": function() { return Tally5; },
  "Tally5Icon": function() { return Tally5; },
  "Tangent": function() { return Tangent; },
  "TangentIcon": function() { return Tangent; },
  "Target": function() { return Target; },
  "TargetIcon": function() { return Target; },
  "Tent": function() { return Tent; },
  "TentIcon": function() { return Tent; },
  "TentTree": function() { return TentTree; },
  "TentTreeIcon": function() { return TentTree; },
  "Terminal": function() { return Terminal; },
  "TerminalIcon": function() { return Terminal; },
  "TerminalSquare": function() { return TerminalSquare; },
  "TerminalSquareIcon": function() { return TerminalSquare; },
  "TestTube": function() { return TestTube; },
  "TestTube2": function() { return TestTube2; },
  "TestTube2Icon": function() { return TestTube2; },
  "TestTubeIcon": function() { return TestTube; },
  "TestTubes": function() { return TestTubes; },
  "TestTubesIcon": function() { return TestTubes; },
  "Text": function() { return Text; },
  "TextCursor": function() { return TextCursor; },
  "TextCursorIcon": function() { return TextCursor; },
  "TextCursorInput": function() { return TextCursorInput; },
  "TextCursorInputIcon": function() { return TextCursorInput; },
  "TextIcon": function() { return Text; },
  "TextQuote": function() { return TextQuote; },
  "TextQuoteIcon": function() { return TextQuote; },
  "TextSelect": function() { return TextSelect; },
  "TextSelectIcon": function() { return TextSelect; },
  "TextSelection": function() { return TextSelect; },
  "TextSelectionIcon": function() { return TextSelect; },
  "Theater": function() { return Theater; },
  "TheaterIcon": function() { return Theater; },
  "Thermometer": function() { return Thermometer; },
  "ThermometerIcon": function() { return Thermometer; },
  "ThermometerSnowflake": function() { return ThermometerSnowflake; },
  "ThermometerSnowflakeIcon": function() { return ThermometerSnowflake; },
  "ThermometerSun": function() { return ThermometerSun; },
  "ThermometerSunIcon": function() { return ThermometerSun; },
  "ThumbsDown": function() { return ThumbsDown; },
  "ThumbsDownIcon": function() { return ThumbsDown; },
  "ThumbsUp": function() { return ThumbsUp; },
  "ThumbsUpIcon": function() { return ThumbsUp; },
  "Ticket": function() { return Ticket; },
  "TicketIcon": function() { return Ticket; },
  "Timer": function() { return Timer; },
  "TimerIcon": function() { return Timer; },
  "TimerOff": function() { return TimerOff; },
  "TimerOffIcon": function() { return TimerOff; },
  "TimerReset": function() { return TimerReset; },
  "TimerResetIcon": function() { return TimerReset; },
  "ToggleLeft": function() { return ToggleLeft; },
  "ToggleLeftIcon": function() { return ToggleLeft; },
  "ToggleRight": function() { return ToggleRight; },
  "ToggleRightIcon": function() { return ToggleRight; },
  "Tornado": function() { return Tornado; },
  "TornadoIcon": function() { return Tornado; },
  "Torus": function() { return Torus; },
  "TorusIcon": function() { return Torus; },
  "Touchpad": function() { return Touchpad; },
  "TouchpadIcon": function() { return Touchpad; },
  "TouchpadOff": function() { return TouchpadOff; },
  "TouchpadOffIcon": function() { return TouchpadOff; },
  "TowerControl": function() { return TowerControl; },
  "TowerControlIcon": function() { return TowerControl; },
  "ToyBrick": function() { return ToyBrick; },
  "ToyBrickIcon": function() { return ToyBrick; },
  "Tractor": function() { return Tractor; },
  "TractorIcon": function() { return Tractor; },
  "TrafficCone": function() { return TrafficCone; },
  "TrafficConeIcon": function() { return TrafficCone; },
  "Train": function() { return TramFront; },
  "TrainFront": function() { return TrainFront; },
  "TrainFrontIcon": function() { return TrainFront; },
  "TrainFrontTunnel": function() { return TrainFrontTunnel; },
  "TrainFrontTunnelIcon": function() { return TrainFrontTunnel; },
  "TrainIcon": function() { return TramFront; },
  "TrainTrack": function() { return TrainTrack; },
  "TrainTrackIcon": function() { return TrainTrack; },
  "TramFront": function() { return TramFront; },
  "TramFrontIcon": function() { return TramFront; },
  "Trash": function() { return Trash; },
  "Trash2": function() { return Trash2; },
  "Trash2Icon": function() { return Trash2; },
  "TrashIcon": function() { return Trash; },
  "TreeDeciduous": function() { return TreeDeciduous; },
  "TreeDeciduousIcon": function() { return TreeDeciduous; },
  "TreePine": function() { return TreePine; },
  "TreePineIcon": function() { return TreePine; },
  "Trees": function() { return Trees; },
  "TreesIcon": function() { return Trees; },
  "Trello": function() { return Trello; },
  "TrelloIcon": function() { return Trello; },
  "TrendingDown": function() { return TrendingDown; },
  "TrendingDownIcon": function() { return TrendingDown; },
  "TrendingUp": function() { return TrendingUp; },
  "TrendingUpIcon": function() { return TrendingUp; },
  "Triangle": function() { return Triangle; },
  "TriangleIcon": function() { return Triangle; },
  "TriangleRight": function() { return TriangleRight; },
  "TriangleRightIcon": function() { return TriangleRight; },
  "Trophy": function() { return Trophy; },
  "TrophyIcon": function() { return Trophy; },
  "Truck": function() { return Truck; },
  "TruckIcon": function() { return Truck; },
  "Turtle": function() { return Turtle; },
  "TurtleIcon": function() { return Turtle; },
  "Tv": function() { return Tv; },
  "Tv2": function() { return Tv2; },
  "Tv2Icon": function() { return Tv2; },
  "TvIcon": function() { return Tv; },
  "Twitch": function() { return Twitch; },
  "TwitchIcon": function() { return Twitch; },
  "Twitter": function() { return Twitter; },
  "TwitterIcon": function() { return Twitter; },
  "Type": function() { return Type; },
  "TypeIcon": function() { return Type; },
  "Umbrella": function() { return Umbrella; },
  "UmbrellaIcon": function() { return Umbrella; },
  "Underline": function() { return Underline; },
  "UnderlineIcon": function() { return Underline; },
  "Undo": function() { return Undo; },
  "Undo2": function() { return Undo2; },
  "Undo2Icon": function() { return Undo2; },
  "UndoDot": function() { return UndoDot; },
  "UndoDotIcon": function() { return UndoDot; },
  "UndoIcon": function() { return Undo; },
  "UnfoldHorizontal": function() { return UnfoldHorizontal; },
  "UnfoldHorizontalIcon": function() { return UnfoldHorizontal; },
  "UnfoldVertical": function() { return UnfoldVertical; },
  "UnfoldVerticalIcon": function() { return UnfoldVertical; },
  "Ungroup": function() { return Ungroup; },
  "UngroupIcon": function() { return Ungroup; },
  "Unlink": function() { return Unlink; },
  "Unlink2": function() { return Unlink2; },
  "Unlink2Icon": function() { return Unlink2; },
  "UnlinkIcon": function() { return Unlink; },
  "Unlock": function() { return Unlock; },
  "UnlockIcon": function() { return Unlock; },
  "UnlockKeyhole": function() { return UnlockKeyhole; },
  "UnlockKeyholeIcon": function() { return UnlockKeyhole; },
  "Unplug": function() { return Unplug; },
  "UnplugIcon": function() { return Unplug; },
  "Upload": function() { return Upload; },
  "UploadCloud": function() { return UploadCloud; },
  "UploadCloudIcon": function() { return UploadCloud; },
  "UploadIcon": function() { return Upload; },
  "Usb": function() { return Usb; },
  "UsbIcon": function() { return Usb; },
  "User": function() { return User; },
  "User2": function() { return User2; },
  "User2Icon": function() { return User2; },
  "UserCheck": function() { return UserCheck; },
  "UserCheck2": function() { return UserCheck2; },
  "UserCheck2Icon": function() { return UserCheck2; },
  "UserCheckIcon": function() { return UserCheck; },
  "UserCircle": function() { return UserCircle; },
  "UserCircle2": function() { return UserCircle2; },
  "UserCircle2Icon": function() { return UserCircle2; },
  "UserCircleIcon": function() { return UserCircle; },
  "UserCog": function() { return UserCog; },
  "UserCog2": function() { return UserCog2; },
  "UserCog2Icon": function() { return UserCog2; },
  "UserCogIcon": function() { return UserCog; },
  "UserIcon": function() { return User; },
  "UserMinus": function() { return UserMinus; },
  "UserMinus2": function() { return UserMinus2; },
  "UserMinus2Icon": function() { return UserMinus2; },
  "UserMinusIcon": function() { return UserMinus; },
  "UserPlus": function() { return UserPlus; },
  "UserPlus2": function() { return UserPlus2; },
  "UserPlus2Icon": function() { return UserPlus2; },
  "UserPlusIcon": function() { return UserPlus; },
  "UserSquare": function() { return UserSquare; },
  "UserSquare2": function() { return UserSquare2; },
  "UserSquare2Icon": function() { return UserSquare2; },
  "UserSquareIcon": function() { return UserSquare; },
  "UserX": function() { return UserX; },
  "UserX2": function() { return UserX2; },
  "UserX2Icon": function() { return UserX2; },
  "UserXIcon": function() { return UserX; },
  "Users": function() { return Users; },
  "Users2": function() { return Users2; },
  "Users2Icon": function() { return Users2; },
  "UsersIcon": function() { return Users; },
  "Utensils": function() { return Utensils; },
  "UtensilsCrossed": function() { return UtensilsCrossed; },
  "UtensilsCrossedIcon": function() { return UtensilsCrossed; },
  "UtensilsIcon": function() { return Utensils; },
  "UtilityPole": function() { return UtilityPole; },
  "UtilityPoleIcon": function() { return UtilityPole; },
  "Variable": function() { return Variable; },
  "VariableIcon": function() { return Variable; },
  "Vegan": function() { return Vegan; },
  "VeganIcon": function() { return Vegan; },
  "VenetianMask": function() { return VenetianMask; },
  "VenetianMaskIcon": function() { return VenetianMask; },
  "Verified": function() { return BadgeCheck; },
  "VerifiedIcon": function() { return BadgeCheck; },
  "Vibrate": function() { return Vibrate; },
  "VibrateIcon": function() { return Vibrate; },
  "VibrateOff": function() { return VibrateOff; },
  "VibrateOffIcon": function() { return VibrateOff; },
  "Video": function() { return Video; },
  "VideoIcon": function() { return Video; },
  "VideoOff": function() { return VideoOff; },
  "VideoOffIcon": function() { return VideoOff; },
  "Videotape": function() { return Videotape; },
  "VideotapeIcon": function() { return Videotape; },
  "View": function() { return View; },
  "ViewIcon": function() { return View; },
  "Voicemail": function() { return Voicemail; },
  "VoicemailIcon": function() { return Voicemail; },
  "Volume": function() { return Volume; },
  "Volume1": function() { return Volume1; },
  "Volume1Icon": function() { return Volume1; },
  "Volume2": function() { return Volume2; },
  "Volume2Icon": function() { return Volume2; },
  "VolumeIcon": function() { return Volume; },
  "VolumeX": function() { return VolumeX; },
  "VolumeXIcon": function() { return VolumeX; },
  "Vote": function() { return Vote; },
  "VoteIcon": function() { return Vote; },
  "Wallet": function() { return Wallet; },
  "Wallet2": function() { return Wallet2; },
  "Wallet2Icon": function() { return Wallet2; },
  "WalletCards": function() { return WalletCards; },
  "WalletCardsIcon": function() { return WalletCards; },
  "WalletIcon": function() { return Wallet; },
  "Wallpaper": function() { return Wallpaper; },
  "WallpaperIcon": function() { return Wallpaper; },
  "Wand": function() { return Wand; },
  "Wand2": function() { return Wand2; },
  "Wand2Icon": function() { return Wand2; },
  "WandIcon": function() { return Wand; },
  "Warehouse": function() { return Warehouse; },
  "WarehouseIcon": function() { return Warehouse; },
  "Watch": function() { return Watch; },
  "WatchIcon": function() { return Watch; },
  "Waves": function() { return Waves; },
  "WavesIcon": function() { return Waves; },
  "Webcam": function() { return Webcam; },
  "WebcamIcon": function() { return Webcam; },
  "Webhook": function() { return Webhook; },
  "WebhookIcon": function() { return Webhook; },
  "Weight": function() { return Weight; },
  "WeightIcon": function() { return Weight; },
  "Wheat": function() { return Wheat; },
  "WheatIcon": function() { return Wheat; },
  "WheatOff": function() { return WheatOff; },
  "WheatOffIcon": function() { return WheatOff; },
  "WholeWord": function() { return WholeWord; },
  "WholeWordIcon": function() { return WholeWord; },
  "Wifi": function() { return Wifi; },
  "WifiIcon": function() { return Wifi; },
  "WifiOff": function() { return WifiOff; },
  "WifiOffIcon": function() { return WifiOff; },
  "Wind": function() { return Wind; },
  "WindIcon": function() { return Wind; },
  "Wine": function() { return Wine; },
  "WineIcon": function() { return Wine; },
  "WineOff": function() { return WineOff; },
  "WineOffIcon": function() { return WineOff; },
  "Workflow": function() { return Workflow; },
  "WorkflowIcon": function() { return Workflow; },
  "WrapText": function() { return WrapText; },
  "WrapTextIcon": function() { return WrapText; },
  "Wrench": function() { return Wrench; },
  "WrenchIcon": function() { return Wrench; },
  "X": function() { return x_X; },
  "XCircle": function() { return XCircle; },
  "XCircleIcon": function() { return XCircle; },
  "XIcon": function() { return x_X; },
  "XOctagon": function() { return XOctagon; },
  "XOctagonIcon": function() { return XOctagon; },
  "XSquare": function() { return XSquare; },
  "XSquareIcon": function() { return XSquare; },
  "Youtube": function() { return Youtube; },
  "YoutubeIcon": function() { return Youtube; },
  "Zap": function() { return Zap; },
  "ZapIcon": function() { return Zap; },
  "ZapOff": function() { return ZapOff; },
  "ZapOffIcon": function() { return ZapOff; },
  "ZoomIn": function() { return ZoomIn; },
  "ZoomInIcon": function() { return ZoomIn; },
  "ZoomOut": function() { return ZoomOut; },
  "ZoomOutIcon": function() { return ZoomOut; },
  "createLucideIcon": function() { return createLucideIcon; },
  "icons": function() { return icons_namespaceObject; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ../elements/lib/helpers/placeholders.js
const titleSmallPlaceholder = {
    value: "Lorem ipsum",
    color: "text-site-500",
};
const titlePlaceholder = {
    value: "Lorem ipsum",
    color: "text-gray-900",
};
const textPlaceHolder = {
    value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    color: "text-gray-900",
};
const placeholders_imagePlaceholder = {
    file: "placeholder.png",
    src: "https://placehold.co/400",
    placeholder: true,
    alt: "Afbeelding",
};
const renderHtmlImageProps = {
    "editor-img-file": placeholders_imagePlaceholder.file,
    "editor-img-placeholder": placeholders_imagePlaceholder.placeholder.toString(),
};
const bgPlaceholder = {
    color: "bg-white",
};
const renderHtmlLinkProps = {
    href: "#",
    target: "_self",
    "editor-link-type": "link",
};
//# sourceMappingURL=placeholders.js.map
;// CONCATENATED MODULE: ../elements/lib/helpers/RenderElement.js

class RenderElement {
    props = null;
    editor = false;
    setProps = (props) => {
        this.props = props;
        return this;
    };
    setEditor = (value) => {
        this.editor = value;
    };
    returnProps = (props) => {
        const rProps = props;
        if (!this.editor) {
            Object.keys(rProps)
                .filter((key) => {
                if (["editor-link-label"].includes(key))
                    return false;
                return key.startsWith(`editor-`);
            })
                .forEach((key) => {
                delete rProps[key];
            });
        }
        return rProps;
    };
    renderClassName = (key, fallback = "", options = null, additional = "") => {
        let classNames = (this.props?.[key]?.className || fallback) + ` ${additional}`;
        let animation = this.props?.[key]?.animation;
        const editorOptions = {};
        if (options?.backgroundColor) {
            if (this.props?.[key]?.backgroundColor) {
                classNames += ` ${this.props?.[key]?.backgroundColor} `;
                editorOptions["editor-backgroundcolor"] =
                    this.props?.[key]?.backgroundColor;
            }
            else {
                classNames += ` ${options?.backgroundColor}`;
                editorOptions["editor-backgroundcolor"] = options?.backgroundColor;
            }
        }
        if (options?.textSize) {
            if (this.props?.[key]?.textSize) {
                classNames += ` ${this.props?.[key]?.textSize}`;
                editorOptions["editor-textsize"] = this.props?.[key]?.textSize;
            }
            else {
                classNames += ` ${options?.textSize}`;
                editorOptions["editor-textsize"] = options?.textSize;
            }
        }
        if (animation && animation.selected !== "disabled") {
            editorOptions["editor-animation-selected"] = animation.selected;
            editorOptions["data-aos"] = `animate__${animation.selected}`;
            if (this.editor) {
                classNames += ` animate__animated animate__${animation.selected}`;
            }
        }
        return this.returnProps({
            className: classNames,
            ...editorOptions,
        });
    };
    renderText = (key, fallback = textPlaceHolder.value) => {
        const propsResult = this.props?.[key]?.text;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps(fallback);
    };
    renderImage = (key, fallback = {}) => {
        const propsResult = this.props?.[key]?.image;
        if (propsResult) {
            return this.returnProps({
                src: propsResult.src,
                alt: propsResult.alt,
                "editor-img-placeholder": propsResult.placeholder.toString(),
                "editor-img-file": propsResult.file,
            });
        }
        return this.returnProps({
            src: placeholders_imagePlaceholder.src,
            alt: placeholders_imagePlaceholder.alt,
            "editor-img-placeholder": placeholders_imagePlaceholder.placeholder.toString(),
            "editor-img-file": placeholders_imagePlaceholder.file,
            ...fallback,
        });
    };
    renderLink = (key, fallback = null) => {
        const propsResult = this.props?.[key]?.link;
        if (propsResult) {
            return this.returnProps({
                href: propsResult.href,
                target: propsResult.target,
                page: propsResult.page,
                "editor-link-label": propsResult.label,
                "editor-link-type": propsResult.type,
                "editor-link-page": propsResult.page,
            });
        }
        return this.returnProps({
            href: "#",
            "editor-link-label": "Link tekst",
            "editor-link-type": "link",
        });
    };
    renderMenu = (key) => {
        const propsResult = this.props?.[key]?.menu;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps({
            selected: null,
        });
    };
    renderForm = (key) => {
        const propsResult = this.props?.[key]?.form;
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return this.returnProps({
            selected: null,
            button: "Verstuur",
        });
    };
    renderBackgroundImage = (key, prop) => {
        const propsResult = this.props?.[key]?.[prop];
        if (propsResult) {
            return this.returnProps({
                src: propsResult.src,
                "editor-background-image-src": propsResult.src,
                "editor-background-image-alt": propsResult.alt,
                "editor-background-image-placeholder": propsResult.placeholder.toString(),
                "editor-background-image-file": propsResult.file,
            });
        }
        return this.returnProps({
            src: placeholders_imagePlaceholder.src,
            "editor-background-image-src": placeholders_imagePlaceholder.src,
            "editor-background-image-placeholder": placeholders_imagePlaceholder.placeholder.toString(),
            "editor-background-image-file": placeholders_imagePlaceholder.file,
        });
    };
    renderIcon = (key, fallback = { name: "", variant: "outline" }) => {
        const propsResult = this.props?.[key];
        if (propsResult) {
            return this.returnProps({
                name: propsResult.iconName,
                variant: propsResult.iconVariant,
            });
        }
        return this.returnProps({
            name: fallback.name,
            variant: fallback.variant,
        });
    };
    renderProp = (key, prop) => {
        const propsResult = this.props?.[key]?.[prop];
        if (propsResult) {
            return this.returnProps(propsResult);
        }
        return null;
    };
    renderAttributeOptions = (options = [], parentKey = null) => {
        const dataProps = {};
        options.forEach((option) => {
            if (option.config && option.config.key && parentKey) {
                const value = this.renderProp(parentKey, option.config.key)?.[option.config.valueKey || "value"] || option.config.defaultValue;
                dataProps[`editor-${option.config.key}`] = value;
                if (option.config?.repeatableOptions) {
                    option.config?.repeatableOptions.forEach((o) => {
                        dataProps[`repeatable-${o.key}`] = this.renderProp(parentKey, `repeatable-${o.key}`);
                    });
                }
            }
        });
        return this.returnProps({
            "editor-options": JSON.stringify(options),
            ...dataProps,
        });
    };
    renderRepeatDeleteKey = (element, group, index) => {
        return this.returnProps({
            "editor-deletekey": `${element}|${group}|${index}`,
        });
    };
}
/* harmony default export */ var helpers_RenderElement = (new RenderElement());
//# sourceMappingURL=RenderElement.js.map
;// CONCATENATED MODULE: ../elements/lib/helpers/findElementByIdDraggable.js
function findElementByIdDraggable(id, obj) {
    const idString = id?.toString();
    if (obj?.id?.toString() === idString) {
        return obj;
    }
    if (obj.children) {
        for (let i = 0; i < obj.children.length; i++) {
            const result = findElementByIdDraggable(idString, obj.children[i]);
            if (result) {
                return result;
            }
        }
    }
    return null;
}
/* harmony default export */ var helpers_findElementByIdDraggable = (findElementByIdDraggable);
//# sourceMappingURL=findElementByIdDraggable.js.map
;// CONCATENATED MODULE: ../elements/lib/types/draggable.js
var draggable_DraggableComponentTypes;
(function (DraggableComponentTypes) {
    DraggableComponentTypes["Text"] = "text";
    DraggableComponentTypes["Title"] = "title";
    DraggableComponentTypes["Div"] = "div";
    DraggableComponentTypes["Grid"] = "grid";
    DraggableComponentTypes["GridItem"] = "gridItem";
    DraggableComponentTypes["Container"] = "container";
    DraggableComponentTypes["Image"] = "image";
    DraggableComponentTypes["Link"] = "link";
    DraggableComponentTypes["Button"] = "button";
    DraggableComponentTypes["Form"] = "form";
    DraggableComponentTypes["Svg"] = "svg";
    DraggableComponentTypes["List"] = "list";
    DraggableComponentTypes["ListItem"] = "listItem";
    DraggableComponentTypes["Icon"] = "icon";
    DraggableComponentTypes["Navbar"] = "navbar";
    DraggableComponentTypes["NavbarVertical"] = "navbarVertical";
    DraggableComponentTypes["Html"] = "html";
})(draggable_DraggableComponentTypes || (draggable_DraggableComponentTypes = {}));
//# sourceMappingURL=draggable.js.map
;// CONCATENATED MODULE: ../elements/lib/hooks/EditorProvider.js






const EditorContext = (0,react.createContext)();
const useEditor = () => (0,react.useContext)(EditorContext);
function EditorProvider({ children, page, initMode = "editor", backendApi = "", elements = [], }) {
    const [content, setContent] = (0,react.useState)(page?.data?.content ? JSON.parse(page?.data?.content.content) : []);
    const [mode, setMode] = (0,react.useState)(initMode);
    const [editorDevice, setEditorDevice] = (0,react.useState)("desktop");
    const [editorScale, setEditorScale] = (0,react.useState)(1);
    const [editorStylingDevice, setEditorStylingDevice] = (0,react.useState)("all");
    const [selectedElement, setSelectedElement] = (0,react.useState)(null);
    const [elementModalOpen, setElementModalOpen] = (0,react.useState)(false);
    const [elementAddDragActive, setElementAddDragActive] = (0,react.useState)(false);
    const [elementOverviewOpen, setElementOverviewOpen] = (0,react.useState)(false);
    const [elementType, setElementType] = (0,react.useState)(null);
    const [editableItem, setEditableItem] = (0,react.useState)(null);
    const [hasUpdate, setHasUpdate] = (0,react.useState)(false);
    const [iframeMount, setIframeMount] = (0,react.useState)(null);
    const [lastSelectedEditableTime, setLastSelectedEditableTime] = (0,react.useState)(0);
    const [dragActive, setDragActive] = (0,react.useState)(false);
    const dragOverComponent = (0,react.useRef)(null);
    const [dragContextMenu, setDragContextMenu] = (0,react.useState)(null);
    const [draggableHtmlEditor, setDraggableHtmlEditor] = (0,react.useState)(null);
    const [dragElementMenu, setDragElementMenu] = (0,react.useState)(null);
    const addElement = (element, index) => {
        if (index >= -1) {
            const contentArray = [...content];
            contentArray.splice(index === -1 ? 0 : index, 0, element);
            setContent(contentArray);
        }
        else {
            setContent([...content, element]);
        }
        setElementAddDragActive(false);
        setHasUpdate(true);
        setElementModalOpen(false);
    };
    const changeElementPostion = (elementId, action) => {
        const contentArray = [...content];
        const element = content.find((c) => c.id === elementId);
        const elementIndex = content.findIndex((c) => c.id === elementId);
        contentArray.splice(elementIndex, 1);
        if (action === "up")
            contentArray.splice(elementIndex - 1, 0, element);
        if (action === "down")
            contentArray.splice(elementIndex + 1, 0, element);
        setContent(contentArray);
        setHasUpdate(true);
    };
    const duplicateElement = (elementId) => {
        const contentArray = [...content];
        const element = content.find((c) => c.id === elementId);
        const elementIndex = content.findIndex((c) => c.id === elementId);
        const duplatedElement = {
            ...element,
            id: esm_browser_v4(),
        };
        contentArray.splice(elementIndex + 1, 0, duplatedElement);
        setContent(contentArray);
        setHasUpdate(true);
    };
    const removeElement = (elementId) => {
        const contentArray = [...content];
        const elementIndex = content.findIndex((c) => c.id === elementId);
        contentArray.splice(elementIndex, 1);
        setContent(contentArray);
        setHasUpdate(true);
    };
    const updateElementProp = (value, key = null, elementId = null) => {
        const contentArray = [...content];
        const selectedElementId = elementId ? elementId : selectedElement;
        const elementIndex = content.findIndex((c) => c.id === selectedElementId);
        if (elementIndex === -1)
            return;
        const editableItemKey = key || editableItem.getAttribute("editor-key");
        if (!contentArray[elementIndex].props) {
            contentArray[elementIndex] = {
                ...contentArray[elementIndex],
                props: {},
            };
        }
        if (!contentArray[elementIndex].props?.[editableItemKey]) {
            contentArray[elementIndex].props = {
                ...contentArray[elementIndex].props,
                [editableItemKey]: {},
            };
        }
        contentArray[elementIndex].props = {
            ...contentArray[elementIndex].props,
            [editableItemKey]: {
                ...contentArray[elementIndex].props?.[editableItemKey],
                ...value,
            },
        };
        setContent(contentArray);
        setHasUpdate(true);
    };
    const deleteRepeatElementProp = (elementId, groupInput, indexInput) => {
        const itemData = groupInput && indexInput
            ? []
            : editableItem?.getAttribute("editor-deletekey").split("|");
        const group = groupInput || itemData[1];
        const index = indexInput || itemData[2];
        const contentArray = [...content];
        const elementIndex = content.findIndex((c) => c.id === elementId || itemData[0]);
        if (elementIndex === -1)
            return;
        setEditableItem(null);
        Object.keys(contentArray[elementIndex].props).forEach((itemKey) => {
            if (itemKey.startsWith(`${group}-${index}`)) {
                delete contentArray[elementIndex].props[itemKey];
            }
        });
        const repeatItemIndex = contentArray[elementIndex].props[group]?.items?.indexOf(index);
        if (repeatItemIndex > -1) {
            contentArray[elementIndex].props[group]?.items.splice(repeatItemIndex, 1);
        }
        setContent(contentArray);
        setHasUpdate(true);
    };
    (0,react.useEffect)(() => {
        if (mode === "editor") {
            helpers_RenderElement.setEditor(true);
        }
        else {
            helpers_RenderElement.setEditor(false);
        }
    }, [mode]);
    const draggableAddComponent = (draggableBoxId, componentType, elementId, data = null) => {
        const contentArray = [...content];
        const elementIndex = content.findIndex((c) => c.id === elementId);
        if (elementIndex === -1)
            return;
        const currentParentElement = helpers_findElementByIdDraggable(data?.id.split("/").slice(0, -1).join("/"), contentArray[elementIndex]?.props);
        const indexOfCurrentElement = currentParentElement?.children?.findIndex((c) => c.id === data?.id);
        if (indexOfCurrentElement &&
            dragOverComponent.current &&
            data.id.split("/").slice(0, -1).join("/") ===
                dragOverComponent.current.split("/").slice(0, -1).join("/")) {
            const currentChilds = [...currentParentElement.children];
            const indexOfDragOverElement = currentParentElement.children.findIndex((c) => c.id === dragOverComponent.current);
            let elementToMove = currentChilds.splice(indexOfCurrentElement, 1)[0];
            currentChilds.splice(indexOfDragOverElement, 0, elementToMove);
            currentParentElement.children = currentChilds;
            dragOverComponent.current = null;
        }
        else {
            if (!contentArray[elementIndex].props) {
                contentArray[elementIndex] = {
                    ...contentArray[elementIndex],
                    props: {},
                };
            }
            if (!contentArray[elementIndex].props?.children) {
                contentArray[elementIndex].props = {
                    ...contentArray[elementIndex].props,
                    id: 1,
                    children: [],
                };
            }
            if (draggableBoxId.includes("/") &&
                draggableBoxId.split("/").length > 1) {
                const parentElement = helpers_findElementByIdDraggable(draggableBoxId, contentArray[elementIndex]?.props);
                const newDraggableBoxId = `${draggableBoxId}/${esm_browser_v4()}`;
                parentElement.children = [
                    ...(parentElement.children || []),
                    {
                        id: newDraggableBoxId,
                        type: componentType,
                        ...(data && data.props && { props: data.props }),
                        ...(componentType === "grid" && {
                            props: {
                                gridMobile: "grid-cols-2",
                                gridTablet: "md:grid-cols-2",
                                gridDesktop: "lg:grid-cols-2",
                            },
                            children: [
                                {
                                    id: `${newDraggableBoxId}/${esm_browser_v4()}`,
                                    type: draggable_DraggableComponentTypes.GridItem,
                                },
                                {
                                    id: `${newDraggableBoxId}/${esm_browser_v4()}`,
                                    type: draggable_DraggableComponentTypes.GridItem,
                                },
                            ],
                        }),
                    },
                ];
            }
            else {
                const newDraggableBoxId = `${draggableBoxId}/${esm_browser_v4()}`;
                contentArray[elementIndex].props = {
                    ...contentArray[elementIndex].props,
                    children: [
                        ...contentArray[elementIndex].props?.children,
                        {
                            id: newDraggableBoxId,
                            type: componentType,
                            ...(data && data.props && { props: data.props }),
                            ...(componentType === "grid" && {
                                props: {
                                    gridMobile: "grid-cols-2",
                                    gridTablet: "md:grid-cols-2",
                                    gridDesktop: "lg:grid-cols-2",
                                },
                                children: [
                                    {
                                        id: `${newDraggableBoxId}/${esm_browser_v4()}`,
                                        type: draggable_DraggableComponentTypes.GridItem,
                                    },
                                    {
                                        id: `${newDraggableBoxId}/${esm_browser_v4()}`,
                                        type: draggable_DraggableComponentTypes.GridItem,
                                    },
                                ],
                            }),
                        },
                    ],
                };
            }
            if (data) {
                const elementParentId = data.id.split("/").slice(0, -1).join("/");
                let currentParentElement = elementParentId === "1"
                    ? contentArray[elementIndex]?.props
                    : helpers_findElementByIdDraggable(elementParentId, contentArray[elementIndex]?.props);
                const indexOfCurrentElement = currentParentElement?.children.findIndex((c) => c.id === data.id);
                currentParentElement?.children?.splice(indexOfCurrentElement, 1);
            }
        }
        setContent(contentArray);
        setHasUpdate(true);
        setDragActive(false);
    };
    const draggableUpdateElementProp = (value, id = null) => {
        const contentArray = [...content];
        const elementIndex = content.findIndex((c) => c.id === selectedElement);
        if (elementIndex === -1)
            return;
        const editableItemKey = id || editableItem?.getAttribute("editor-key");
        const editableElement = helpers_findElementByIdDraggable(editableItemKey, contentArray[elementIndex]?.props);
        if (!editableElement?.props) {
            editableElement.props = {};
        }
        editableElement.props = {
            ...editableElement?.props,
            ...value,
        };
        setContent(contentArray);
        setHasUpdate(true);
    };
    const draggableFindElement = (editableItemKey, data) => {
        const contentObj = data || content;
        const elementIndex = contentObj.findIndex((c) => c.id === selectedElement);
        if (elementIndex === -1)
            return;
        return helpers_findElementByIdDraggable(editableItemKey, contentObj[elementIndex]?.props);
    };
    const draggableItemUpdate = (editableItemKey, action, elementId) => {
        const contentArray = [...content];
        const elementIndex = content.findIndex((c) => c.id === elementId);
        if (elementIndex === -1)
            return;
        const currentParentElement = helpers_findElementByIdDraggable(editableItemKey.split("/").slice(0, -1).join("/"), contentArray[elementIndex]?.props);
        if (!currentParentElement)
            return;
        const indexOfCurrentElement = currentParentElement?.children.findIndex((c) => c.id === editableItemKey);
        const currentChilds = currentParentElement?.children
            ? [...currentParentElement?.children]
            : [];
        if (action === "remove") {
            if (editableItem?.getAttribute("editor-key") === editableItemKey) {
                setEditableItem(null);
            }
            currentChilds.splice(indexOfCurrentElement, 1);
        }
        if (action === "duplicate") {
            const duplicatedElement = {
                ...currentParentElement?.children[indexOfCurrentElement],
                id: `${currentParentElement.id}/${esm_browser_v4()}`,
            };
            currentChilds.push(JSON.parse(JSON.stringify(duplicatedElement).replaceAll(currentParentElement?.children[indexOfCurrentElement].id, duplicatedElement.id)));
        }
        if (["up", "down"].includes(action)) {
            let elementToMove = currentChilds.splice(indexOfCurrentElement, 1)[0];
            currentChilds.splice(action === "up" ? indexOfCurrentElement - 1 : indexOfCurrentElement + 1, 0, elementToMove);
        }
        if (action === "changeToIcon") {
            const updatedElement = {
                ...currentParentElement?.children[indexOfCurrentElement],
                type: draggable_DraggableComponentTypes.Icon,
            };
            currentChilds[indexOfCurrentElement] = updatedElement;
        }
        currentParentElement.children = currentChilds;
        setContent(contentArray);
        setHasUpdate(true);
    };
    const draggableGridModify = (editableItemKey, action, actionValue = {}) => {
        const contentArray = [...content];
        const gridItem = draggableFindElement(editableItemKey, contentArray);
        if (action === "add") {
            gridItem.children = [
                ...gridItem.children,
                {
                    id: `${editableItemKey}/${esm_browser_v4()}`,
                    type: draggable_DraggableComponentTypes.GridItem,
                },
            ];
        }
        if (action === "remove") {
            gridItem.children = gridItem.children.filter((c) => c.id !== actionValue.id);
        }
        if (action === "update") {
            gridItem.props = {
                ...gridItem.props,
                ...actionValue,
            };
        }
        if (action === "copy") {
            const element = gridItem.children.find((c) => c.id === actionValue.id);
            let newElement = {
                ...element,
                id: `${editableItemKey}/${esm_browser_v4()}`,
                type: draggable_DraggableComponentTypes.GridItem,
            };
            newElement = JSON.parse(JSON.stringify(element).replaceAll(element.id, `${editableItemKey}/${esm_browser_v4()}`));
            gridItem.children = [...gridItem.children, newElement];
        }
        setContent(contentArray);
        setHasUpdate(true);
    };
    return ((0,jsx_runtime.jsx)(EditorContext.Provider, { value: {
            elements,
            content,
            addElement,
            selectedElement,
            setSelectedElement,
            changeElementPostion,
            duplicateElement,
            removeElement,
            elementModalOpen,
            setElementModalOpen,
            elementAddDragActive,
            setElementAddDragActive,
            updateElementProp,
            deleteRepeatElementProp,
            mode,
            setMode,
            editorDevice,
            setEditorDevice,
            editorScale,
            setEditorScale,
            editorStylingDevice,
            setEditorStylingDevice,
            editableItem,
            setEditableItem,
            backendApi,
            hasUpdate,
            page,
            setHasUpdate,
            elementType,
            setElementType,
            iframeMount,
            setIframeMount,
            lastSelectedEditableTime,
            setLastSelectedEditableTime,
            draggableAddComponent,
            dragActive,
            setDragActive,
            draggableUpdateElementProp,
            draggableFindElement,
            draggableItemUpdate,
            draggableGridModify,
            dragOverComponent,
            dragContextMenu,
            setDragContextMenu,
            dragElementMenu,
            setDragElementMenu,
            elementOverviewOpen,
            setElementOverviewOpen,
            draggableHtmlEditor,
            setDraggableHtmlEditor,
            setContent,
        }, children: children }));
}
/* harmony default export */ var hooks_EditorProvider = (EditorProvider);
//# sourceMappingURL=EditorProvider.js.map
;// CONCATENATED MODULE: ../elements/lib/hooks/SiteProvider.js


const SiteContext = (0,react.createContext)();
const useSite = () => (0,react.useContext)(SiteContext);
const SiteProvider = ({ children, initLocale = "NL", defaultLocale = "NL", pages = [], forms = [], menus = [], activePage, languages = [], }) => {
    const [locale, setLocale] = (0,react.useState)(initLocale);
    return ((0,jsx_runtime.jsx)(SiteContext.Provider, { value: {
            children,
            locale,
            setLocale,
            pages,
            forms,
            menus,
            activePage,
            languages,
            defaultLocale,
        }, children: children }));
};
/* harmony default export */ var hooks_SiteProvider = (SiteProvider);
//# sourceMappingURL=SiteProvider.js.map
// EXTERNAL MODULE: ../../node_modules/color-convert/index.js
var color_convert = __webpack_require__(50841);
;// CONCATENATED MODULE: ../elements/lib/helpers/paletteGenerator.js

const CMY_HUES = (/* unused pure expression or super */ null && ([180, 300, 60]));
const RGB_HUES = (/* unused pure expression or super */ null && ([360, 240, 120, 0]));
function hueShift(hues, hue, intensity) {
    const closestHue = hues.sort((a, b) => Math.abs(a - hue) - Math.abs(b - hue))[0], hueShift = closestHue - hue;
    return Math.round(intensity * hueShift * 0.5);
}
function lighten(hex, intensity) {
    if (!hex) {
        return "";
    }
    const [h, s, v] = convert.hex.hsv(hex);
    const hue = h + hueShift(CMY_HUES, h, intensity);
    const saturation = s - Math.round(s * intensity);
    const value = v + Math.round((100 - v) * intensity);
    return `#${convert.hsv.hex([hue, saturation, value])}`;
}
function darken(hex, intensity) {
    if (!hex) {
        return "";
    }
    const inverseIntensity = 1 - intensity;
    const [h, s, v] = convert.hex.hsv(hex);
    const hue = h + hueShift(RGB_HUES, h, inverseIntensity);
    const saturation = s + Math.round((100 - s) * inverseIntensity);
    const value = v - Math.round(v * inverseIntensity);
    return `#${convert.hsv.hex([hue, saturation, value])}`;
}
function sixDigitsColorHex(hexColor) {
    const hexValue = hexColor.replace("#", "");
    return `#${hexValue.length === 3
        ? hexValue.replace(/(.)/g, "$1$1")
        : hexValue.padEnd(6, "0")}`;
}
/* harmony default export */ var paletteGenerator = ((baseColor) => {
    if (!baseColor) {
        return;
    }
    const fullColorCode = sixDigitsColorHex(baseColor);
    const response = {
        500: fullColorCode,
    };
    const intensityMap = {
        50: 0.95,
        100: 0.9,
        200: 0.75,
        300: 0.6,
        400: 0.3,
        600: 0.9,
        700: 0.75,
        800: 0.6,
        900: 0.45,
        950: 0.29,
    };
    [50, 100, 200, 300, 400].forEach((level) => {
        response[level] = lighten(fullColorCode, intensityMap[level]);
    });
    [600, 700, 800, 900, 950].forEach((level) => {
        response[level] = darken(fullColorCode, intensityMap[level]);
    });
    return response;
});
//# sourceMappingURL=paletteGenerator.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/RenderHtmlElement.js


const RenderHtmlElement = ({ element, elementProps, elementId }) => {
    const Element = lib[element];
    if (elementProps?.elementHtml?.content) {
        return ((0,jsx_runtime.jsx)("div", { "editor-html": "true", "editor-elementid": elementId, dangerouslySetInnerHTML: {
                __html: elementProps?.elementHtml?.content,
            } }));
    }
    return ((0,jsx_runtime.jsx)("div", { "editor-html": "true", "editor-elementid": elementId, children: (0,jsx_runtime.jsx)(Element, {}) }));
};
/* harmony default export */ var html_RenderHtmlElement = (RenderHtmlElement);
//# sourceMappingURL=RenderHtmlElement.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/NoContentFound.js

const NoContentFound = () => {
    return ((0,jsx_runtime.jsx)("div", { className: "mt-8 flex justify-center", children: (0,jsx_runtime.jsx)("span", { className: "text-2xl font-medium text-gray-700", children: "Pagina heeft momenteel nog geen content" }) }));
};
/* harmony default export */ var html_NoContentFound = (NoContentFound);
//# sourceMappingURL=NoContentFound.js.map
;// CONCATENATED MODULE: ../elements/lib/types/elements.js
var SideEditOptions;
(function (SideEditOptions) {
    SideEditOptions["Text"] = "text";
    SideEditOptions["Select"] = "select";
    SideEditOptions["Image"] = "image";
    SideEditOptions["BackgroundImage"] = "backgroundImage";
    SideEditOptions["TextColor"] = "textColor";
    SideEditOptions["BackgroundColor"] = "backgroundColor";
    SideEditOptions["Menu"] = "menu";
    SideEditOptions["Class"] = "class";
    SideEditOptions["Repeat"] = "repeat";
    SideEditOptions["Multiple"] = "multiple";
    SideEditOptions["Link"] = "link";
    SideEditOptions["Form"] = "form";
    SideEditOptions["Repeatable"] = "repeatable";
})(SideEditOptions || (SideEditOptions = {}));
var SideEditPropType;
(function (SideEditPropType) {
    SideEditPropType["Text"] = "text";
    SideEditPropType["Select"] = "select";
    SideEditPropType["Image"] = "image";
    SideEditPropType["Color"] = "color";
    SideEditPropType["Menu"] = "menu";
    SideEditPropType["Class"] = "class";
    SideEditPropType["Repeat"] = "repeat";
    SideEditPropType["Multiple"] = "multiple";
    SideEditPropType["Link"] = "link";
    SideEditPropType["Form"] = "form";
})(SideEditPropType || (SideEditPropType = {}));
//# sourceMappingURL=elements.js.map
;// CONCATENATED MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react.useRef(props);
    _props.current = props;
    react.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react.useState(control._formState);
    const _mounted = react.useRef(true);
    const _localProxyFormState = react.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        callback: react.useCallback((value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current) &&
            updateFormState({
                ...control._formState,
                ...value,
            }), [control, exact]),
        subject: control._subjects.state,
    });
    react.useEffect(() => {
        _mounted.current = true;
        const isDirty = control._proxyFormState.isDirty && control._getDirty();
        if (isDirty !== control._formState.isDirty) {
            control._subjects.state.next({
                isDirty,
            });
        }
        control._updateValid();
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var index_esm_isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    if (index_esm_isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
                updateValue(isUndefined(fieldValues) ? defaultValue : cloneObject(fieldValues));
            }
        },
    });
    const [value, updateValue] = react.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    react.useEffect(() => control._removeUnmounted());
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    react.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: react.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: react.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isMessage = (value) => index_esm_isString(value) || react.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (index_esm_isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (index_esm_isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (index_esm_isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && index_esm_isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) && isEmptyArray(objectRef)))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    const callback = React.useCallback(({ values, name: fieldArrayName, }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current);
            if (Array.isArray(fieldValues)) {
                setFields(fieldValues);
                ids.current = fieldValues.map(generateId);
            }
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, get(control._formValues, name), control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => !!key && key.startsWith(control._names.focus || ''));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                deepEqual(data[key], formValues[key])
                    ? delete dirtyFieldsFromValues[key]
                    : (dirtyFieldsFromValues[key] = true);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && index_esm_isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async () => {
        if (_proxyFormState.isValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        value !== _formState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            if (_proxyFormState.dirtyFields) {
                isPreviousDirty = get(_formState.dirtyFields, name);
                const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
                isCurrentFieldPristine
                    ? unset(_formState.dirtyFields, name)
                    : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField =
                    shouldUpdateField || isPreviousDirty !== !isCurrentFieldPristine;
            }
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_stateFlags.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : index_esm_isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal);
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                if (error) {
                    isValid = false;
                }
                else if (_proxyFormState.isValid) {
                    isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (!isPrimitive(fieldValue) || getCurrentFieldValue() === fieldValue) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
            else {
                _updateIsValidating(false);
            }
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!index_esm_isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : index_esm_isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuiltInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _focusError();
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _focusError,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react.useRef();
    const [formState, updateFormState] = react.useState({
        isDirty: false,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        callback: react.useCallback((value) => {
            if (shouldRenderFormState(value, control._proxyFormState, true)) {
                control._formState = {
                    ...control._formState,
                    ...value,
                };
                updateFormState({ ...control._formState });
            }
        }, [control]),
    });
    react.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    react.useEffect(() => {
        formState.submitCount && control._focusError();
    }, [control, formState.submitCount]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/class-names.js
function class_names_e(...n){return n.filter(Boolean).join(" ")}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/match.js
function match_u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,match_u),t}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/render.js
var S=(a=>(a[a.None=0]="None",a[a.RenderStrategy=1]="RenderStrategy",a[a.Static=2]="Static",a))(S||{}),render_j=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(render_j||{});function render_X({ourProps:r,theirProps:t,slot:e,defaultTag:a,features:s,visible:n=!0,name:f}){let o=N(t,r);if(n)return c(o,e,a,f);let u=s!=null?s:0;if(u&2){let{static:l=!1,...p}=o;if(l)return c(p,e,a,f)}if(u&1){let{unmount:l=!0,...p}=o;return match_u(l?0:1,{[0](){return null},[1](){return c({...p,hidden:!0,style:{display:"none"}},e,a,f)}})}return c(o,e,a,f)}function c(r,t={},e,a){let{as:s=e,children:n,refName:f="ref",...o}=g(r,["unmount","static"]),u=r.ref!==void 0?{[f]:r.ref}:{},l=typeof n=="function"?n(t):n;"className"in o&&o.className&&typeof o.className=="function"&&(o.className=o.className(t));let p={};if(t){let i=!1,m=[];for(let[y,d]of Object.entries(t))typeof d=="boolean"&&(i=!0),d===!0&&m.push(y);i&&(p["data-headlessui-state"]=m.join(" "))}if(s===react.Fragment&&Object.keys(render_R(o)).length>0){if(!(0,react.isValidElement)(l)||Array.isArray(l)&&l.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${a} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(o).map(d=>`  - ${d}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(d=>`  - ${d}`).join(`
`)].join(`
`));let i=l.props,m=typeof(i==null?void 0:i.className)=="function"?(...d)=>class_names_e(i==null?void 0:i.className(...d),o.className):class_names_e(i==null?void 0:i.className,o.className),y=m?{className:m}:{};return (0,react.cloneElement)(l,Object.assign({},N(l.props,render_R(g(o,["ref"]))),p,u,w(l.ref,u.ref),y))}return (0,react.createElement)(s,Object.assign({},g(o,["ref"]),s!==react.Fragment&&u,s!==react.Fragment&&p),l)}function w(...r){return{ref:r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t)}}}function N(...r){var a;if(r.length===0)return{};if(r.length===1)return r[0];let t={},e={};for(let s of r)for(let n in s)n.startsWith("on")&&typeof s[n]=="function"?((a=e[n])!=null||(e[n]=[]),e[n].push(s[n])):t[n]=s[n];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(s=>[s,void 0])));for(let s in e)Object.assign(t,{[s](n,...f){let o=e[s];for(let u of o){if((n instanceof Event||(n==null?void 0:n.nativeEvent)instanceof Event)&&n.defaultPrevented)return;u(n,...f)}}});return t}function D(r){var t;return Object.assign((0,react.forwardRef)(r),{displayName:(t=r.displayName)!=null?t:r.name})}function render_R(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function g(r,t=[]){let e=Object.assign({},r);for(let a of t)a in e&&delete e[a];return e}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/env.js
var env_i=Object.defineProperty;var d=(t,e,n)=>e in t?env_i(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r=(t,e,n)=>(d(t,typeof e!="symbol"?e+"":e,n),n);class o{constructor(){r(this,"current",this.detect());r(this,"handoffState","pending");r(this,"currentId",0)}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e)}reset(){this.set(this.detect())}nextId(){return++this.currentId}get isServer(){return this.current==="server"}get isClient(){return this.current==="client"}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client"}handoff(){this.handoffState==="pending"&&(this.handoffState="complete")}get isHandoffComplete(){return this.handoffState==="complete"}}let s=new o;

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
let use_iso_morphic_effect_l=(e,f)=>{s.isServer?(0,react.useEffect)(e,f):(0,react.useLayoutEffect)(e,f)};

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
function use_server_handoff_complete_l(){let[e,f]=(0,react.useState)(s.isHandoffComplete);return e&&s.isHandoffComplete===!1&&f(!1),(0,react.useEffect)(()=>{e!==!0&&f(!0)},[e]),(0,react.useEffect)(()=>s.handoff(),[]),e}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id_o;let use_id_I=(use_id_o=react.useId)!=null?use_id_o:function(){let n=use_server_handoff_complete_l(),[e,u]=react.useState(n?()=>s.nextId():null);return use_iso_morphic_effect_l(()=>{e===null&&u(s.nextId())},[e]),e!=null?""+e:void 0};

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard_o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(keyboard_o||{});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/bugs.js
function bugs_r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&bugs_i(l)?!1:t}function bugs_i(n){if(!n)return!1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return!1;e=e.previousElementSibling}return!0}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-latest-value.js
function use_latest_value_s(e){let r=(0,react.useRef)(e);return use_iso_morphic_effect_l(()=>{r.current=e},[e]),r}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event.js
let use_event_o=function(t){let e=use_latest_value_s(t);return react.useCallback((...r)=>e.current(...r),[e])};

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
let u=Symbol();function use_sync_refs_T(t,n=!0){return Object.assign(t,{[u]:n})}function use_sync_refs_y(...t){let n=(0,react.useRef)(t);(0,react.useEffect)(()=>{n.current=t},[t]);let c=use_event_o(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e)});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/label/label.js
let label_d=(0,react.createContext)(null);function label_u(){let o=(0,react.useContext)(label_d);if(o===null){let t=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,label_u),t}return o}function H(){let[o,t]=(0,react.useState)([]);return[o.length>0?o.join(" "):void 0,(0,react.useMemo)(()=>function(e){let s=use_event_o(r=>(t(l=>[...l,r]),()=>t(l=>{let n=l.slice(),p=n.indexOf(r);return p!==-1&&n.splice(p,1),n}))),a=(0,react.useMemo)(()=>({register:s,slot:e.slot,name:e.name,props:e.props}),[s,e.slot,e.name,e.props]);return react.createElement(label_d.Provider,{value:a},e.children)},[t])]}let A="label";function h(o,t){let i=use_id_I(),{id:e=`headlessui-label-${i}`,passive:s=!1,...a}=o,r=label_u(),l=use_sync_refs_y(t);use_iso_morphic_effect_l(()=>r.register(e),[e,r.register]);let n={ref:l,...r.props,id:e};return s&&("onClick"in n&&(delete n.htmlFor,delete n.onClick),"onClick"in a&&delete a.onClick),render_X({ourProps:n,theirProps:a,slot:r.slot||{},defaultTag:A,name:r.name||"Label"})}let v=D(h),M=Object.assign(v,{});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/description/description.js
let description_d=(0,react.createContext)(null);function f(){let r=(0,react.useContext)(description_d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,f),t}return r}function description_M(){let[r,t]=(0,react.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react.useMemo)(()=>function(e){let i=use_event_o(s=>(t(o=>[...o,s]),()=>t(o=>{let p=o.slice(),c=p.indexOf(s);return c!==-1&&p.splice(c,1),p}))),n=(0,react.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react.createElement(description_d.Provider,{value:n},e.children)},[t])]}let description_S="p";function description_h(r,t){let a=use_id_I(),{id:e=`headlessui-description-${a}`,...i}=r,n=f(),s=use_sync_refs_y(t);use_iso_morphic_effect_l(()=>n.register(e),[e,n.register]);let o={ref:s,...n.props,id:e};return render_X({ourProps:o,theirProps:i,slot:n.slot||{},defaultTag:description_S,name:n.name||"Description"})}let y=D(description_h),b=Object.assign(y,{});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
function use_resolve_button_type_i(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return"button"}function use_resolve_button_type_s(t,e){let[n,u]=(0,react.useState)(()=>use_resolve_button_type_i(t));return use_iso_morphic_effect_l(()=>{u(use_resolve_button_type_i(t))},[t.type,t.as]),use_iso_morphic_effect_l(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button")},[n,e]),n}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/internal/hidden.js
let a="div";var hidden_p=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(hidden_p||{});function hidden_s(t,o){let{features:n=1,...e}=t,d={ref:o,"aria-hidden":(n&2)===2?!0:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(n&4)===4&&(n&2)!==2&&{display:"none"}}};return render_X({ourProps:d,theirProps:e,slot:{},defaultTag:a,name:"Hidden"})}let hidden_c=D(hidden_s);

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/form.js
function e(n={},r=null,t=[]){for(let[i,o]of Object.entries(n))form_f(t,form_s(r,i),o);return t}function form_s(n,r){return n?n+"["+r+"]":r}function form_f(n,r,t){if(Array.isArray(t))for(let[i,o]of t.entries())form_f(n,form_s(r,i.toString()),o);else t instanceof Date?n.push([r,t.toISOString()]):typeof t=="boolean"?n.push([r,t?"1":"0"]):typeof t=="string"?n.push([r,t]):typeof t=="number"?n.push([r,`${t}`]):t==null?n.push([r,""]):e(t,r,n)}function form_p(n){var t;let r=(t=n==null?void 0:n.form)!=null?t:n.closest("form");if(r){for(let i of r.elements)if(i.tagName==="INPUT"&&i.type==="submit"||i.tagName==="BUTTON"&&i.type==="submit"||i.nodeName==="INPUT"&&i.type==="image"){i.click();return}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-controllable.js
function use_controllable_T(l,r,c){let[i,s]=(0,react.useState)(c),e=l!==void 0,t=(0,react.useRef)(e),u=(0,react.useRef)(!1),d=(0,react.useRef)(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,use_event_o(n=>(e||s(n),r==null?void 0:r(n)))]}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/micro-task.js
function micro_task_t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/disposables.js
function disposables_o(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return micro_task_t(()=>{t.current&&e[0]()}),r.add(()=>{t.current=!1})},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a})})},group(e){let t=disposables_o();return e(t),this.add(()=>t.dispose())},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s()}},dispose(){for(let e of n.splice(0))e()}};return r}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-disposables.js
function use_disposables_p(){let[e]=(0,react.useState)(disposables_o);return (0,react.useEffect)(()=>()=>e.dispose(),[e]),e}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/switch/switch.js
let switch_y=(0,react.createContext)(null);switch_y.displayName="GroupContext";let Y=react.Fragment;function Z(s){var d;let[n,p]=(0,react.useState)(null),[c,f]=H(),[r,h]=description_M(),l=(0,react.useMemo)(()=>({switch:n,setSwitch:p,labelledby:c,describedby:r}),[n,p,c,r]),T={},b=s;return react.createElement(h,{name:"Switch.Description"},react.createElement(f,{name:"Switch.Label",props:{htmlFor:(d=l.switch)==null?void 0:d.id,onClick(t){n&&(t.currentTarget.tagName==="LABEL"&&t.preventDefault(),n.click(),n.focus({preventScroll:!0}))}}},react.createElement(switch_y.Provider,{value:l},render_X({ourProps:T,theirProps:b,defaultTag:Y,name:"Switch.Group"}))))}let ee="button";function te(s,n){let p=use_id_I(),{id:c=`headlessui-switch-${p}`,checked:f,defaultChecked:r=!1,onChange:h,name:l,value:T,form:b,...d}=s,t=(0,react.useContext)(switch_y),u=(0,react.useRef)(null),D=use_sync_refs_y(u,n,t===null?null:t.setSwitch),[o,a]=use_controllable_T(f,h,r),S=use_event_o(()=>a==null?void 0:a(!o)),C=use_event_o(e=>{if(bugs_r(e.currentTarget))return e.preventDefault();e.preventDefault(),S()}),L=use_event_o(e=>{e.key===keyboard_o.Space?(e.preventDefault(),S()):e.key===keyboard_o.Enter&&form_p(e.currentTarget)}),v=use_event_o(e=>e.preventDefault()),G=(0,react.useMemo)(()=>({checked:o}),[o]),R={id:c,ref:D,role:"switch",type:use_resolve_button_type_s(s,u),tabIndex:0,"aria-checked":o,"aria-labelledby":t==null?void 0:t.labelledby,"aria-describedby":t==null?void 0:t.describedby,onClick:C,onKeyUp:L,onKeyPress:v},k=use_disposables_p();return (0,react.useEffect)(()=>{var w;let e=(w=u.current)==null?void 0:w.closest("form");e&&r!==void 0&&k.addEventListener(e,"reset",()=>{a(r)})},[u,a]),react.createElement(react.Fragment,null,l!=null&&o&&react.createElement(hidden_c,{features:hidden_p.Hidden,...render_R({as:"input",type:"checkbox",hidden:!0,readOnly:!0,form:b,checked:o,name:l,value:T})}),render_X({ourProps:R,theirProps:d,slot:G,defaultTag:ee,name:"Switch"}))}let ne=D(te),re=Z,Ge=Object.assign(ne,{Group:re,Label:M,Description:b});

;// CONCATENATED MODULE: ../elements/lib/helpers/classNames.js
/* harmony default export */ function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
//# sourceMappingURL=classNames.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Form/Checkbox.js




const Checkbox = react.forwardRef(({ className, label, name, onChange, value, error }, ref) => {
    return ((0,jsx_runtime.jsxs)("div", { className: className, children: [(0,jsx_runtime.jsxs)("div", { className: "flex items-start", children: [(0,jsx_runtime.jsx)("div", { className: "flex-shrink-0", children: (0,jsx_runtime.jsx)(Ge, { ref: ref, checked: value, onChange: onChange, className: classNames(value ? "bg-site-500" : "bg-gray-200", "focus:ring-app-500 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"), children: (0,jsx_runtime.jsx)("span", { "aria-hidden": "true", className: classNames(value ? "translate-x-5" : "translate-x-0", "inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out") }) }) }), (0,jsx_runtime.jsx)("div", { className: "ml-3", children: (0,jsx_runtime.jsx)("p", { className: "font-text text-base text-gray-500", children: label }) })] }), error && ((0,jsx_runtime.jsx)("p", { className: "text-sm text-red-600", id: `${name}-error`, children: error.message }))] }));
});
/* harmony default export */ var Form_Checkbox = (Checkbox);
//# sourceMappingURL=Checkbox.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Form/Input.js


const Input = react.forwardRef(({ className, label, name, type = "text", error, ...props }, ref) => {
    return ((0,jsx_runtime.jsxs)("div", { className: className, children: [(0,jsx_runtime.jsx)("label", { htmlFor: name, className: `font-text block text-sm font-medium ${error ? "text-red-600" : "text-gray-700"}`, children: label }), (0,jsx_runtime.jsxs)("div", { className: "mt-1", children: [(0,jsx_runtime.jsx)("input", { ref: ref, type: type, name: name, id: name, className: "focus:border-site-500 focus:ring-site-500 block w-full rounded-md border-gray-300 px-4 py-3 shadow-sm", ...props }), error && ((0,jsx_runtime.jsx)("p", { className: "text-sm text-red-600", id: `${name}-error`, children: error.message }))] })] }));
});
/* harmony default export */ var Form_Input = (Input);
//# sourceMappingURL=Input.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Form/Textarea.js


const Textarea = react.forwardRef(({ className, label, name, error, ...props }, ref) => {
    return ((0,jsx_runtime.jsxs)("div", { className: className, "editor-disabled": "true", children: [(0,jsx_runtime.jsx)("label", { "editor-disabled": "true", htmlFor: name, className: `font-text block text-sm font-medium ${error ? "text-red-600" : "text-gray-700"}`, children: label }), (0,jsx_runtime.jsxs)("div", { className: "mt-1", children: [(0,jsx_runtime.jsx)("textarea", { ref: ref, id: name, name: name, rows: 4, className: "focus:border-site-500 focus:ring-site-500 block w-full rounded-md border-gray-300 px-4 py-3 shadow-sm", defaultValue: "", ...props }), error && ((0,jsx_runtime.jsx)("p", { className: "text-sm text-red-600", id: `${name}-error`, children: error.message }))] })] }));
});
/* harmony default export */ var Form_Textarea = (Textarea);
//# sourceMappingURL=Textarea.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/20/solid/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(64785);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/20/solid/XMarkIcon.js
var XMarkIcon = __webpack_require__(88305);
// EXTERNAL MODULE: ../../node_modules/use-ssr/dist/useSSR.js
var dist_useSSR = __webpack_require__(31137);
var useSSR_default = /*#__PURE__*/__webpack_require__.n(dist_useSSR);
// EXTERNAL MODULE: ../../node_modules/urs/dist/useRefState.js
var useRefState = __webpack_require__(58970);
;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/types.js
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["GET"] = "GET";
    HTTPMethod["HEAD"] = "HEAD";
    HTTPMethod["OPTIONS"] = "OPTIONS";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["CONNECT"] = "CONNECT";
    HTTPMethod["TRACE"] = "TRACE";
})(HTTPMethod || (HTTPMethod = {}));
// https://www.apollographql.com/docs/react/api/react/hoc/#optionsfetchpolicy
var CachePolicies;
(function (CachePolicies) {
    /**
     * This is the default value where we always try reading data
     * from your cache first. If all the data needed to fulfill
     * your query is in the cache then that data will be returned.
     * useFetch will only fetch from the network if a cached result
     * is not available. This fetch policy aims to minimize the number
     * of network requests sent when rendering your component.
     */
    CachePolicies["CACHE_FIRST"] = "cache-first";
    /**
     * This fetch policy will have useFetch first trying to read data
     * from your cache. If all the data needed to fulfill your query
     * is in the cache then that data will be returned. However,
     * regardless of whether or not the full data is in your cache
     * this fetchPolicy will always execute query with the network
     * interface unlike cache-first which will only execute your query
     * if the query data is not in your cache. This fetch policy optimizes
     * for users getting a quick response while also trying to keep
     * cached data consistent with your server data at the cost of extra
     * network requests.
     */
    CachePolicies["CACHE_AND_NETWORK"] = "cache-and-network";
    /**
     * This fetch policy will never return your initial data from the
     * cache. Instead it will always make a request using your network
     * interface to the server. This fetch policy optimizes for data
     * consistency with the server, but at the cost of an instant response
     * to the user when one is available.
     */
    CachePolicies["NETWORK_ONLY"] = "network-only";
    /**
     * This fetch policy will never execute a query using your network
     * interface. Instead it will always try reading from the cache. If the
     * data for your query does not exist in the cache then an error will be
     * thrown. This fetch policy allows you to only interact with data in
     * your local client cache without making any network requests which
     * keeps your component fast, but means your local data might not be
     * consistent with what is on the server.
     */
    CachePolicies["CACHE_ONLY"] = "cache-only";
    /**
     * This fetch policy will never return your initial data from the cache.
     * Instead it will always make a request using your network interface to
     * the server. Unlike the network-only policy, it also will not write
     * any data to the cache after the query completes.
     */
    CachePolicies["NO_CACHE"] = "no-cache";
    CachePolicies["EXACT_CACHE_AND_NETWORK"] = "exact-cache-and-network";
})(CachePolicies || (CachePolicies = {}));

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/utils.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


/**
 * Used for error checking. If the condition is false, throw an error
 */
function utils_invariant(condition, format, a, b, c, d, e, f) {
    if (a === void 0) { a = ''; }
    if (b === void 0) { b = ''; }
    if (c === void 0) { c = ''; }
    if (d === void 0) { d = ''; }
    if (e === void 0) { e = ''; }
    if (f === void 0) { f = ''; }
    if (false) {}
    if (!condition) {
        var error = void 0;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' +
                'for the full error message and additional helpful warnings.');
        }
        else {
            var args_1 = [a, b, c, d, e, f];
            var argIndex_1 = 0;
            error = new Error(format.replace(/%s/g, function () { return args_1[argIndex_1++]; }));
            error.name = 'Invariant Violation';
        }
        throw error;
    }
}
var useExampleURL = function () {
    var isBrowser = useSSR().isBrowser;
    return useMemo(function () {
        return isBrowser ? window.location.origin : 'https://example.com';
    }, [isBrowser]);
};
function utils_useURLRequiredInvariant(condition, method, optionalMessage) {
    var exampleURL = useExampleURL();
    useEffect(function () {
        utils_invariant(condition, method + " requires a URL to be set as the 1st argument,\n\n      unless you wrap your app like:\n\n      <Provider url=\"" + exampleURL + "\"><App /></Provider>\n\n      " + optionalMessage);
    }, [condition, exampleURL, method, optionalMessage]);
}
var utils_isString = function (x) { return typeof x === 'string'; }; // eslint-disable-line
/**
 * Determines if the given param is an object. {}
 * @param obj
 */
var utils_isObject = function (obj) { return Object.prototype.toString.call(obj) === '[object Object]'; }; // eslint-disable-line
/**
 * Determines if the given param is an object that can be used as a request body.
 * Returns true for native objects or arrays.
 * @param obj
 */
var isBodyObject = function (obj) { return utils_isObject(obj) || Array.isArray(obj); };
var utils_isFunction = function (v) { return typeof v === 'function'; };
var isNumber = function (v) { return Object.prototype.toString.call(v) === '[object Number]'; };
// const requestFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Request('')))
// const responseFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Response()))
// export const customResponseFields = [...responseFields, 'data']
// TODO: come back and fix the "anys" in this http://bit.ly/2Lm3OLi
/**
 * Makes an object that will match the standards of a normal fetch's options
 * aka: pulls out all useFetch's special options like "onMount"
 */
var pullOutRequestInit = function (options) {
    if (!options)
        return {};
    var requestInitFields = [
        'body',
        'cache',
        'credentials',
        'headers',
        'integrity',
        'keepalive',
        'method',
        'mode',
        'redirect',
        'referrer',
        'referrerPolicy',
        'signal',
        'window'
    ];
    return requestInitFields.reduce(function (acc, key) {
        if (key in options)
            acc[key] = options[key];
        return acc;
    }, {});
};
var isEmpty = function (x) { return x === undefined || x === null; };
var Device;
(function (Device) {
    Device["Browser"] = "browser";
    Device["Server"] = "server";
    Device["Native"] = "native";
})(Device || (Device = {}));
var Browser = Device.Browser, Server = Device.Server, Native = Device.Native;
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
var canUseNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
var device = canUseNative ? Native : canUseDOM ? Browser : Server;
var isBrowser = device === Browser;
var isServer = device === Server;
var isNative = device === Native;
var tryGetData = function (res, defaultData, responseType) { return __awaiter(void 0, void 0, void 0, function () {
    var types, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof res === 'undefined')
                    throw Error('Response cannot be undefined... 😵');
                if (typeof responseType === 'undefined')
                    throw Error('responseType cannot be undefined... 😵');
                types = (Array.isArray(responseType) ? responseType : [responseType]);
                if (types[0] == null)
                    throw Error('could not parse data from response 😵');
                return [4 /*yield*/, tryRetry(res, types)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, !isEmpty(defaultData) && isEmpty(data) ? defaultData : data];
        }
    });
}); };
var tryRetry = function (res, types, i) {
    if (i === void 0) { i = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, res.clone()[types[i]]()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    if (types.length - 1 === i)
                        throw error_1;
                    return [2 /*return*/, tryRetry(res.clone(), types, ++i)];
                case 3: return [2 /*return*/];
            }
        });
    });
};
var responseFields = ['headers', 'ok', 'redirected', 'trailer', 'status', 'statusText', 'type', 'url', 'body', 'bodyUsed', 'data'];
var responseMethods = ['clone', 'arrayBuffer', 'blob', 'formData', 'json', 'text'];
var responseKeys = __spreadArrays(responseFields, responseMethods);
var toResponseObject = function (res, data) { return Object.defineProperties({}, responseKeys.reduce(function (acc, field) {
    if (responseFields.includes(field)) {
        acc[field] = {
            get: function () {
                var response = res instanceof Response ? res : res && res.current;
                if (!response)
                    return;
                if (field === 'data')
                    return data.current;
                var clonedResponse = ('clone' in response ? response.clone() : {});
                return clonedResponse[field];
            },
            enumerable: true
        };
    }
    else if (responseMethods.includes(field)) {
        acc[field] = {
            value: function () {
                var response = res instanceof Response ? res : res && res.current;
                if (!response)
                    return;
                var clonedResponse = ('clone' in response ? response.clone() : {});
                return clonedResponse[field]();
            },
            enumerable: true
        };
    }
    return acc;
}, {})); };
var emptyCustomResponse = toResponseObject();
// TODO: switch this to .reduce()
var headersAsObject = function (headers) {
    var obj = {};
    headers.forEach(function (value, key) {
        obj[key] = value;
    });
    return obj;
};
var serializeResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var body, status, statusText, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, response.text()];
            case 1:
                body = _a.sent();
                status = response.status, statusText = response.statusText;
                headers = headersAsObject(response.headers);
                return [2 /*return*/, {
                        body: body,
                        status: status,
                        statusText: statusText,
                        headers: headers
                    }];
        }
    });
}); };
function useDeepCompareMemoize(value) {
    var ref = (0,react.useRef)();
    if (JSON.stringify(value) !== JSON.stringify(ref.current))
        ref.current = value;
    return ref.current;
}
var useDeepCallback = function (cb, deps) { return (0,react.useCallback)(cb, useDeepCompareMemoize(deps)); };
var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var isPositiveNumber = function (n) { return Number.isInteger(n) && n > 0; };
var makeError = function (name, message) {
    var error = new Error(message);
    error.name = name + '';
    return error;
};
/**
 * Determines if we need to add a slash to front
 * of a path, and adds it if we do.
 * Cases:
 * (path = '', url = '' || null | undefined) => ''
 * (path = '?foo=bar', url = 'a.com')        => '?foo=bar'
 * (path = '?foo=bar', url = 'a.com/')       => '?foo=bar'
 * (path = 'bar', url = 'a.com/?foo=')       => 'bar'
 * (path = 'foo', url = 'a.com')             => '/foo'
 * (path = 'foo', url = 'a.com/')            => 'foo'
 * (path = '/foo', url = 'a.com')            => '/foo'
 * (path = '/foo', url = 'a.com/')           => 'foo'
 * (path = '?foo=bar')                       => '?foo=bar'
 * (path = 'foo')                            => '/foo'
 * (path = '/foo')                           => '/foo'
 * (path = '&foo=bar', url = 'a.com?b=k')    => '&foo=bar'
 * (path = '&foo=bar')                       => '&foo=bar'
 */
var addSlash = function (input, url) {
    if (!input)
        return '';
    if (!url) {
        if (input.startsWith('?') || input.startsWith('&') || input.startsWith('/'))
            return input;
        return "/" + input;
    }
    if (url.endsWith('/') && input.startsWith('/'))
        return input.substr(1);
    if (!url.endsWith('/') && !input.startsWith('/') && !input.startsWith('?') && !input.startsWith('&') && !url.includes('?'))
        return "/" + input;
    return input;
};

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/FetchContext.js

var FetchContext_FetchContext = (0,react.createContext)({
    url: '',
    options: {},
    graphql: false // TODO: this will make it so useFetch(QUERY || MUTATION) will work
});
/* harmony default export */ var esm_FetchContext = (FetchContext_FetchContext);

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/defaults.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var useFetchArgsDefaults = {
    host: '',
    path: undefined,
    customOptions: {
        cacheLife: 0,
        cachePolicy: CachePolicies.CACHE_FIRST,
        interceptors: {},
        onAbort: function () { },
        onError: function () { },
        onNewData: function (currData, newData) { return newData; },
        onTimeout: function () { },
        perPage: 0,
        persist: false,
        responseType: ['json', 'text', 'blob', 'arrayBuffer'],
        retries: 0,
        retryDelay: 1000,
        retryOn: [],
        suspense: false,
        timeout: 0,
        // defaults
        data: undefined,
        loading: false
    },
    requestInit: {
        headers: {
            Accept: 'application/json, text/plain, */*'
        }
    },
    dependencies: undefined
};
/* harmony default export */ var defaults = (Object.entries(useFetchArgsDefaults).reduce(function (acc, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    if (utils_isObject(value))
        return __assign(__assign({}, acc), value);
    return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
}, {}));

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/useFetchArgs.js
var useFetchArgs_assign = (undefined && undefined.__assign) || function () {
    useFetchArgs_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useFetchArgs_assign.apply(this, arguments);
};




function useFetchArgs(urlOrPathOrOptionsOrOverwriteGlobalOptions, optionsOrOverwriteGlobalOrDeps, deps) {
    utils_invariant(!(utils_isObject(urlOrPathOrOptionsOrOverwriteGlobalOptions) && utils_isObject(optionsOrOverwriteGlobalOrDeps)), 'You cannot have a 2nd parameter of useFetch as object when your first argument is an object.');
    var context = (0,react.useContext)(esm_FetchContext);
    var host = (0,react.useMemo)(function () {
        var maybeHost = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if (utils_isString(maybeHost) && maybeHost.includes('://'))
            return maybeHost;
        if (context.url)
            return context.url;
        return defaults.host;
    }, [context.url, urlOrPathOrOptionsOrOverwriteGlobalOptions]);
    var path = (0,react.useMemo)(function () {
        var maybePath = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if (utils_isString(maybePath) && !maybePath.includes('://'))
            return maybePath;
    }, [urlOrPathOrOptionsOrOverwriteGlobalOptions]);
    var overwriteGlobalOptions = (0,react.useMemo)(function () {
        if (utils_isFunction(urlOrPathOrOptionsOrOverwriteGlobalOptions))
            return urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if (utils_isFunction(optionsOrOverwriteGlobalOrDeps))
            return optionsOrOverwriteGlobalOrDeps;
    }, []);
    var options = (0,react.useMemo)(function () {
        var localOptions = { headers: {} };
        if (utils_isObject(urlOrPathOrOptionsOrOverwriteGlobalOptions)) {
            localOptions = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        }
        else if (utils_isObject(optionsOrOverwriteGlobalOrDeps)) {
            localOptions = optionsOrOverwriteGlobalOrDeps;
        }
        var globalOptions = context.options;
        var finalOptions = useFetchArgs_assign(useFetchArgs_assign(useFetchArgs_assign(useFetchArgs_assign({}, defaults), globalOptions), localOptions), { headers: useFetchArgs_assign(useFetchArgs_assign(useFetchArgs_assign({}, defaults.headers), globalOptions.headers), localOptions.headers), interceptors: useFetchArgs_assign(useFetchArgs_assign(useFetchArgs_assign({}, defaults.interceptors), globalOptions.interceptors), localOptions.interceptors) });
        if (overwriteGlobalOptions)
            return overwriteGlobalOptions(finalOptions);
        return finalOptions;
    }, [urlOrPathOrOptionsOrOverwriteGlobalOptions, overwriteGlobalOptions, context.options]);
    var requestInit = (0,react.useMemo)(function () { return pullOutRequestInit(options); }, [options]);
    var dependencies = (0,react.useMemo)(function () {
        if (Array.isArray(optionsOrOverwriteGlobalOrDeps))
            return optionsOrOverwriteGlobalOrDeps;
        if (Array.isArray(deps))
            return deps;
        return defaults.dependencies;
    }, [optionsOrOverwriteGlobalOrDeps, deps]);
    var cacheLife = options.cacheLife, retries = options.retries, retryDelay = options.retryDelay, retryOn = options.retryOn;
    utils_invariant(Number.isInteger(cacheLife) && cacheLife >= 0, '`cacheLife` must be a number >= 0');
    utils_invariant(Number.isInteger(retries) && retries >= 0, '`retries` must be a number >= 0');
    utils_invariant(utils_isFunction(retryDelay) || Number.isInteger(retryDelay) && retryDelay >= 0, '`retryDelay` must be a positive number or a function returning a positive number.');
    var isValidRetryOn = utils_isFunction(retryOn) || (Array.isArray(retryOn) && retryOn.every(isPositiveNumber));
    utils_invariant(isValidRetryOn, '`retryOn` must be an array of positive numbers or a function returning a boolean.');
    var loading = options.loading || Array.isArray(dependencies);
    var interceptors = (0,react.useMemo)(function () {
        var final = {};
        if ('request' in options.interceptors)
            final.request = options.interceptors.request;
        if ('response' in options.interceptors)
            final.response = options.interceptors.response;
        return final;
    }, [options]);
    var customOptions = (0,react.useMemo)(function () {
        var customOptionKeys = Object.keys(useFetchArgsDefaults.customOptions); // Array<keyof CustomOptions>
        var customOptions = customOptionKeys.reduce(function (opts, key) {
            opts[key] = options[key];
            return opts;
        }, {});
        return useFetchArgs_assign(useFetchArgs_assign({}, customOptions), { interceptors: interceptors, loading: loading });
    }, [interceptors, loading]);
    return {
        host: host,
        path: path,
        customOptions: customOptions,
        requestInit: requestInit,
        dependencies: dependencies
    };
}

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/doFetchArgs.js
var doFetchArgs_assign = (undefined && undefined.__assign) || function () {
    doFetchArgs_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return doFetchArgs_assign.apply(this, arguments);
};
var doFetchArgs_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var doFetchArgs_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var GET = HTTPMethod.GET;
function doFetchArgs(initialOptions, method, controller, cacheLife, cache, host, path, routeOrBody, bodyAs2ndParam, requestInterceptor) {
    return doFetchArgs_awaiter(this, void 0, void 0, function () {
        var route, url, body, headers, options, responseID, _a, _b;
        var _this = this;
        return doFetchArgs_generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    utils_invariant(!(isBodyObject(routeOrBody) && isBodyObject(bodyAs2ndParam)), "If first argument of " + method.toLowerCase() + "() is an object, you cannot have a 2nd argument. \uD83D\uDE1C");
                    utils_invariant(!(method === GET && isBodyObject(routeOrBody)), 'You can only have query params as 1st argument of request.get()');
                    utils_invariant(!(method === GET && bodyAs2ndParam !== undefined), 'You can only have query params as 1st argument of request.get()');
                    route = (function () {
                        if (!isServer && routeOrBody instanceof URLSearchParams)
                            return "?" + routeOrBody;
                        if (utils_isString(routeOrBody))
                            return routeOrBody;
                        return '';
                    })();
                    url = "" + host + addSlash(path, host) + addSlash(route);
                    body = (function () {
                        // FormData instanceof check should go first, because React Native's FormData implementation
                        // is indistinguishable from plain object when using isBodyObject check
                        if (routeOrBody instanceof FormData)
                            return routeOrBody;
                        if (isBodyObject(routeOrBody))
                            return JSON.stringify(routeOrBody);
                        if (!isServer &&
                            (bodyAs2ndParam instanceof FormData ||
                                bodyAs2ndParam instanceof URLSearchParams))
                            return bodyAs2ndParam;
                        if (isBodyObject(bodyAs2ndParam) || utils_isString(bodyAs2ndParam))
                            return JSON.stringify(bodyAs2ndParam);
                        if (isBodyObject(initialOptions.body) || utils_isString(bodyAs2ndParam))
                            return JSON.stringify(initialOptions.body);
                        return null;
                    })();
                    headers = (function () {
                        var contentType = (initialOptions.headers || {})['Content-Type'];
                        var shouldAddContentType = !!contentType || [HTTPMethod.POST, HTTPMethod.PUT, HTTPMethod.PATCH].includes(method) && !(body instanceof FormData);
                        var headers = doFetchArgs_assign({}, initialOptions.headers);
                        if (shouldAddContentType) {
                            // default content types http://bit.ly/2N2ovOZ
                            // Accept: 'application/json',
                            // roughly, should only add for POST and PUT http://bit.ly/2NJNt3N
                            // unless specified by the user
                            headers['Content-Type'] = contentType || 'application/json';
                        }
                        else if (Object.keys(headers).length === 0) {
                            return null;
                        }
                        return headers;
                    })();
                    return [4 /*yield*/, (function () { return doFetchArgs_awaiter(_this, void 0, void 0, function () {
                            var opts, interceptor;
                            return doFetchArgs_generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        opts = doFetchArgs_assign(doFetchArgs_assign({}, initialOptions), { method: method, signal: controller.signal });
                                        if (headers !== null) {
                                            opts.headers = headers;
                                        }
                                        else {
                                            delete opts.headers;
                                        }
                                        if (body !== null)
                                            opts.body = body;
                                        if (!requestInterceptor) return [3 /*break*/, 2];
                                        return [4 /*yield*/, requestInterceptor({ options: opts, url: host, path: path, route: route })];
                                    case 1:
                                        interceptor = _a.sent();
                                        return [2 /*return*/, interceptor];
                                    case 2: return [2 /*return*/, opts];
                                }
                            });
                        }); })()
                        // TODO: if the body is a file, and this is a large file, it might exceed the size
                        // limit of the key size. Potential solution: base64 the body
                        // used to tell if a request has already been made
                    ];
                case 1:
                    options = _c.sent();
                    responseID = Object.entries({ url: url, method: method, body: options.body || '' })
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return key + ":" + value;
                    }).join('||');
                    _a = {
                        url: url,
                        options: options
                    };
                    _b = {};
                    return [4 /*yield*/, cache.has(responseID)];
                case 2:
                    _b.isCached = _c.sent(),
                        _b.id = responseID;
                    return [4 /*yield*/, cache.get(responseID)];
                case 3: return [2 /*return*/, (_a.response = (_b.cached = (_c.sent()),
                        _b),
                        _a)];
            }
        });
    });
}

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/storage/localStorage.js
var localStorage_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var localStorage_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var cacheName = 'useHTTPcache';
var getCache = function () {
    try {
        return JSON.parse(localStorage.getItem(cacheName) || '{}');
    }
    catch (err) {
        localStorage.removeItem(cacheName);
        return {};
    }
};
var getLocalStorage = function (_a) {
    var cacheLife = _a.cacheLife;
    var remove = function () {
        var responseIDs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            responseIDs[_i] = arguments[_i];
        }
        return localStorage_awaiter(void 0, void 0, void 0, function () {
            var cache;
            return localStorage_generator(this, function (_a) {
                cache = getCache();
                responseIDs.forEach(function (id) { return delete cache[id]; });
                localStorage.setItem(cacheName, JSON.stringify(cache));
                return [2 /*return*/];
            });
        });
    };
    var isExpired = function (responseID) {
        var cache = getCache();
        var _a = (cache[responseID] || {}), expiration = _a.expiration, response = _a.response;
        var expired = expiration > 0 && expiration < Date.now();
        if (expired)
            remove(responseID);
        return expired || !response;
    };
    var has = function (responseID) { return localStorage_awaiter(void 0, void 0, void 0, function () { return localStorage_generator(this, function (_a) {
        return [2 /*return*/, !isExpired(responseID)];
    }); }); };
    var get = function (responseID) { return localStorage_awaiter(void 0, void 0, void 0, function () {
        var cache, _a, body, headers, status, statusText;
        return localStorage_generator(this, function (_b) {
            if (isExpired(responseID))
                return [2 /*return*/];
            cache = getCache();
            _a = cache[responseID].response, body = _a.body, headers = _a.headers, status = _a.status, statusText = _a.statusText;
            return [2 /*return*/, new Response(body, {
                    status: status,
                    statusText: statusText,
                    headers: new Headers(headers || {})
                })];
        });
    }); };
    var set = function (responseID, response) { return localStorage_awaiter(void 0, void 0, void 0, function () {
        var cache, _a, _b, _c;
        return localStorage_generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    cache = getCache();
                    _a = cache;
                    _b = responseID;
                    _c = {};
                    return [4 /*yield*/, serializeResponse(response)];
                case 1:
                    _a[_b] = (_c.response = _d.sent(),
                        _c.expiration = Date.now() + cacheLife,
                        _c);
                    localStorage.setItem(cacheName, JSON.stringify(cache));
                    return [2 /*return*/];
            }
        });
    }); };
    var clear = function () { return localStorage_awaiter(void 0, void 0, void 0, function () {
        return localStorage_generator(this, function (_a) {
            localStorage.setItem(cacheName, JSON.stringify({}));
            return [2 /*return*/];
        });
    }); };
    return Object.defineProperties(getCache(), {
        get: { value: get, writable: false },
        set: { value: set, writable: false },
        has: { value: has, writable: false },
        delete: { value: remove, writable: false },
        clear: { value: clear, writable: false }
    });
};
/* harmony default export */ var storage_localStorage = (getLocalStorage);

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/storage/memoryStorage.js
var memoryStorage_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var memoryStorage_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var inMemoryStorage = {};
var getMemoryStorage = function (_a) {
    var cacheLife = _a.cacheLife;
    var remove = function () {
        var responseIDs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            responseIDs[_i] = arguments[_i];
        }
        return memoryStorage_awaiter(void 0, void 0, void 0, function () {
            var _a, responseIDs_1, responseID;
            return memoryStorage_generator(this, function (_b) {
                for (_a = 0, responseIDs_1 = responseIDs; _a < responseIDs_1.length; _a++) {
                    responseID = responseIDs_1[_a];
                    delete inMemoryStorage[responseID];
                    delete inMemoryStorage[responseID + ":ts"];
                }
                return [2 /*return*/];
            });
        });
    };
    var isExpired = function (responseID) {
        var expiration = inMemoryStorage[responseID + ":ts"];
        var expired = expiration > 0 && expiration < Date.now();
        if (expired)
            remove(responseID);
        return expired || !inMemoryStorage[responseID];
    };
    var get = function (responseID) { return memoryStorage_awaiter(void 0, void 0, void 0, function () {
        return memoryStorage_generator(this, function (_a) {
            if (isExpired(responseID))
                return [2 /*return*/];
            return [2 /*return*/, inMemoryStorage[responseID]];
        });
    }); };
    var set = function (responseID, res) { return memoryStorage_awaiter(void 0, void 0, void 0, function () {
        return memoryStorage_generator(this, function (_a) {
            inMemoryStorage[responseID] = res;
            inMemoryStorage[responseID + ":ts"] = cacheLife > 0 ? Date.now() + cacheLife : 0;
            return [2 /*return*/];
        });
    }); };
    var has = function (responseID) { return memoryStorage_awaiter(void 0, void 0, void 0, function () { return memoryStorage_generator(this, function (_a) {
        return [2 /*return*/, !isExpired(responseID)];
    }); }); };
    var clear = function () { return memoryStorage_awaiter(void 0, void 0, void 0, function () {
        return memoryStorage_generator(this, function (_a) {
            inMemoryStorage = {};
            return [2 /*return*/];
        });
    }); };
    return Object.defineProperties(inMemoryStorage, {
        get: { value: get, writable: false, configurable: true },
        set: { value: set, writable: false, configurable: true },
        has: { value: has, writable: false, configurable: true },
        delete: { value: remove, writable: false, configurable: true },
        clear: { value: clear, writable: false, configurable: true }
    });
};
/* harmony default export */ var memoryStorage = (getMemoryStorage);

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/useCache.js





var NETWORK_ONLY = CachePolicies.NETWORK_ONLY, NO_CACHE = CachePolicies.NO_CACHE;
var useCache = function (_a) {
    var persist = _a.persist, cacheLife = _a.cacheLife, cachePolicy = _a.cachePolicy;
    var _b = useSSR_default()(), isNative = _b.isNative, isServer = _b.isServer;
    utils_invariant(!(isServer && persist), 'There is no persistent storage on the Server currently! 🙅‍♂️');
    utils_invariant(!(isNative && persist), 'React Native support for persistent cache is not yet implemented. 🙅‍♂️');
    utils_invariant(!(persist && [NO_CACHE, NETWORK_ONLY].includes(cachePolicy)), "You cannot use option 'persist' with cachePolicy: " + cachePolicy + " \uD83D\uDE45\u200D\u2642\uFE0F");
    // right now we're not worrying about react-native
    if (persist)
        return storage_localStorage({ cacheLife: cacheLife || (24 * 3600000) });
    return memoryStorage({ cacheLife: cacheLife });
};
/* harmony default export */ var esm_useCache = (useCache);

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/useFetch.js
var useFetch_assign = (undefined && undefined.__assign) || function () {
    useFetch_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useFetch_assign.apply(this, arguments);
};
var useFetch_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useFetch_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








var CACHE_FIRST = CachePolicies.CACHE_FIRST;
function useFetch_useFetch() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = useFetchArgs.apply(void 0, args), host = _a.host, path = _a.path, customOptions = _a.customOptions, requestInit = _a.requestInit, dependencies = _a.dependencies;
    var cacheLife = customOptions.cacheLife, cachePolicy = customOptions.cachePolicy, // 'cache-first' by default
    interceptors = customOptions.interceptors, onAbort = customOptions.onAbort, onError = customOptions.onError, onNewData = customOptions.onNewData, onTimeout = customOptions.onTimeout, perPage = customOptions.perPage, persist = customOptions.persist, responseType = customOptions.responseType, retries = customOptions.retries, retryDelay = customOptions.retryDelay, retryOn = customOptions.retryOn, suspense = customOptions.suspense, timeout = customOptions.timeout, defaults = __rest(customOptions, ["cacheLife", "cachePolicy", "interceptors", "onAbort", "onError", "onNewData", "onTimeout", "perPage", "persist", "responseType", "retries", "retryDelay", "retryOn", "suspense", "timeout"]);
    var cache = esm_useCache({ persist: persist, cacheLife: cacheLife, cachePolicy: cachePolicy });
    var isServer = useSSR_default()().isServer;
    var controller = (0,react.useRef)();
    var res = (0,react.useRef)({});
    var data = (0,react.useRef)(defaults.data);
    var timedout = (0,react.useRef)(false);
    var attempt = (0,react.useRef)(0);
    var error = (0,react.useRef)();
    var hasMore = (0,react.useRef)(true);
    var suspenseStatus = (0,react.useRef)('pending');
    var suspender = (0,react.useRef)();
    var mounted = (0,react.useRef)(false);
    var _b = (0,useRefState/* default */.ZP)(defaults.loading), loading = _b[0], setLoading = _b[1];
    var forceUpdate = (0,react.useReducer)(function () { return ({}); }, [])[1];
    var makeFetch = useDeepCallback(function (method) {
        var doFetch = function (routeOrBody, body) { return useFetch_awaiter(_this, void 0, void 0, function () {
            var theController, _a, url, options, response, timer, newData, newRes, _b, _c, opts, shouldRetry, _d, _e, theData, err_1, opts, shouldRetry, _f, _g, theData;
            return useFetch_generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (isServer)
                            return [2 /*return*/]; // for now, we don't do anything on the server
                        controller.current = new AbortController();
                        controller.current.signal.onabort = onAbort;
                        theController = controller.current;
                        return [4 /*yield*/, doFetchArgs(requestInit, method, theController, cacheLife, cache, host, path, routeOrBody, body, interceptors.request)];
                    case 1:
                        _a = _h.sent(), url = _a.url, options = _a.options, response = _a.response;
                        error.current = undefined;
                        // don't perform the request if there is no more data to fetch (pagination)
                        if (perPage > 0 && !hasMore.current && !error.current)
                            return [2 /*return*/, data.current];
                        if (!suspense)
                            setLoading(true);
                        timer = timeout && setTimeout(function () {
                            timedout.current = true;
                            theController.abort();
                            if (onTimeout)
                                onTimeout();
                        }, timeout);
                        _h.label = 2;
                    case 2:
                        _h.trys.push([2, 17, 23, 24]);
                        if (!(response.isCached && cachePolicy === CACHE_FIRST)) return [3 /*break*/, 3];
                        newRes = response.cached;
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, fetch(url, options)];
                    case 4:
                        newRes = (_h.sent()).clone();
                        _h.label = 5;
                    case 5:
                        res.current = newRes.clone();
                        return [4 /*yield*/, tryGetData(newRes, defaults.data, responseType)];
                    case 6:
                        newData = _h.sent();
                        res.current.data = onNewData(data.current, newData);
                        _b = res;
                        if (!interceptors.response) return [3 /*break*/, 8];
                        return [4 /*yield*/, interceptors.response({ response: res.current, request: requestInit })];
                    case 7:
                        _c = _h.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        _c = res.current;
                        _h.label = 9;
                    case 9:
                        _b.current = _c;
                        utils_invariant('data' in res.current, 'You must have `data` field on the Response returned from your `interceptors.response`');
                        data.current = res.current.data;
                        opts = { attempt: attempt.current, response: newRes };
                        // if we just have `retries` set with NO `retryOn` then
                        // automatically retry on fail until attempts run out
                        _d = !utils_isFunction(retryOn) && Array.isArray(retryOn) && retryOn.length < 1 && (newRes === null || newRes === void 0 ? void 0 : newRes.ok) === false
                            // otherwise only retry when is specified
                            || Array.isArray(retryOn) && retryOn.includes(newRes.status);
                        if (_d) 
                        // if we just have `retries` set with NO `retryOn` then
                        // automatically retry on fail until attempts run out
                        return [3 /*break*/, 12];
                        _e = utils_isFunction(retryOn);
                        if (!_e) return [3 /*break*/, 11];
                        return [4 /*yield*/, retryOn(opts)];
                    case 10:
                        _e = (_h.sent());
                        _h.label = 11;
                    case 11:
                        _d = _e;
                        _h.label = 12;
                    case 12:
                        shouldRetry = (_d) && retries > 0 && retries > attempt.current;
                        if (!shouldRetry) return [3 /*break*/, 14];
                        return [4 /*yield*/, retry(opts, routeOrBody, body)];
                    case 13:
                        theData = _h.sent();
                        return [2 /*return*/, theData];
                    case 14:
                        if (!(cachePolicy === CACHE_FIRST && !response.isCached)) return [3 /*break*/, 16];
                        return [4 /*yield*/, cache.set(response.id, newRes.clone())];
                    case 15:
                        _h.sent();
                        _h.label = 16;
                    case 16:
                        if (Array.isArray(data.current) && !!(data.current.length % perPage))
                            hasMore.current = false;
                        return [3 /*break*/, 24];
                    case 17:
                        err_1 = _h.sent();
                        if (attempt.current >= retries && timedout.current)
                            error.current = makeError('AbortError', 'Timeout Error');
                        opts = { attempt: attempt.current, error: err_1 };
                        // if we just have `retries` set with NO `retryOn` then
                        // automatically retry on fail until attempts run out
                        _f = !utils_isFunction(retryOn) && Array.isArray(retryOn) && retryOn.length < 1;
                        if (_f) 
                        // if we just have `retries` set with NO `retryOn` then
                        // automatically retry on fail until attempts run out
                        return [3 /*break*/, 20];
                        _g = utils_isFunction(retryOn);
                        if (!_g) return [3 /*break*/, 19];
                        return [4 /*yield*/, retryOn(opts)];
                    case 18:
                        _g = (_h.sent());
                        _h.label = 19;
                    case 19:
                        _f = _g;
                        _h.label = 20;
                    case 20:
                        shouldRetry = (_f) && retries > 0 && retries > attempt.current;
                        if (!shouldRetry) return [3 /*break*/, 22];
                        return [4 /*yield*/, retry(opts, routeOrBody, body)];
                    case 21:
                        theData = _h.sent();
                        return [2 /*return*/, theData];
                    case 22:
                        if (err_1.name !== 'AbortError') {
                            error.current = err_1;
                        }
                        return [3 /*break*/, 24];
                    case 23:
                        timedout.current = false;
                        if (timer)
                            clearTimeout(timer);
                        controller.current = undefined;
                        return [7 /*endfinally*/];
                    case 24:
                        if (newRes && !newRes.ok && !error.current)
                            error.current = makeError(newRes.status, newRes.statusText);
                        if (!suspense)
                            setLoading(false);
                        if (attempt.current === retries)
                            attempt.current = 0;
                        if (error.current)
                            onError({ error: error.current });
                        return [2 /*return*/, data.current];
                }
            });
        }); }; // end of doFetch()
        var retry = function (opts, routeOrBody, body) { return useFetch_awaiter(_this, void 0, void 0, function () {
            var delay, d;
            return useFetch_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delay = (utils_isFunction(retryDelay) ? retryDelay(opts) : retryDelay);
                        if (!(Number.isInteger(delay) && delay >= 0)) {
                            console.error('retryDelay must be a number >= 0! If you\'re using it as a function, it must also return a number >= 0.');
                        }
                        attempt.current++;
                        if (!delay) return [3 /*break*/, 2];
                        return [4 /*yield*/, sleep(delay)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, doFetch(routeOrBody, body)];
                    case 3:
                        d = _a.sent();
                        return [2 /*return*/, d];
                }
            });
        }); };
        if (suspense) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return useFetch_awaiter(_this, void 0, void 0, function () {
                    var newData;
                    return useFetch_generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                suspender.current = doFetch.apply(void 0, args).then(function (newData) {
                                    suspenseStatus.current = 'success';
                                    return newData;
                                }, function () {
                                    suspenseStatus.current = 'error';
                                });
                                forceUpdate();
                                return [4 /*yield*/, suspender.current];
                            case 1:
                                newData = _a.sent();
                                return [2 /*return*/, newData];
                        }
                    });
                });
            };
        }
        return doFetch;
    }, [isServer, onAbort, requestInit, host, path, interceptors, cachePolicy, perPage, timeout, persist, cacheLife, onTimeout, defaults.data, onNewData, forceUpdate, suspense]);
    var post = (0,react.useCallback)(makeFetch(HTTPMethod.POST), [makeFetch]);
    var del = (0,react.useCallback)(makeFetch(HTTPMethod.DELETE), [makeFetch]);
    var request = (0,react.useMemo)(function () { return Object.defineProperties({
        get: makeFetch(HTTPMethod.GET),
        post: post,
        patch: makeFetch(HTTPMethod.PATCH),
        put: makeFetch(HTTPMethod.PUT),
        options: makeFetch(HTTPMethod.OPTIONS),
        head: makeFetch(HTTPMethod.HEAD),
        connect: makeFetch(HTTPMethod.CONNECT),
        trace: makeFetch(HTTPMethod.TRACE),
        del: del,
        delete: del,
        abort: function () { return controller.current && controller.current.abort(); },
        query: function (query, variables) { return post({ query: query, variables: variables }); },
        mutate: function (mutation, variables) { return post({ mutation: mutation, variables: variables }); },
        cache: cache
    }, {
        loading: { get: function () { return loading.current; } },
        error: { get: function () { return error.current; } },
        data: { get: function () { return data.current; } },
    }); }, [makeFetch]);
    var response = (0,react.useMemo)(function () { return toResponseObject(res, data); }, []);
    // onMount/onUpdate
    (0,react.useEffect)(function () {
        mounted.current = true;
        if (Array.isArray(dependencies)) {
            var methodName = requestInit.method || HTTPMethod.GET;
            var methodLower = methodName.toLowerCase();
            var req = request[methodLower];
            req();
        }
        return function () { return mounted.current = false; };
    }, dependencies);
    // Cancel any running request when unmounting to avoid updating state after component has unmounted
    // This can happen if a request's promise resolves after component unmounts
    (0,react.useEffect)(function () { return request.abort; }, []);
    if (suspense && suspender.current) {
        if (isServer)
            throw new Error('Suspense on server side is not yet supported! 🙅‍♂️');
        switch (suspenseStatus.current) {
            case 'pending':
                throw suspender.current;
            case 'error':
                throw error.current;
        }
    }
    return Object.assign([request, response, loading.current, error.current], useFetch_assign(useFetch_assign({ request: request, response: response }, request), { loading: loading.current, data: data.current, error: error.current }));
}

/* harmony default export */ var esm_useFetch = (useFetch_useFetch);

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/useMutation.js
var useMutation_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var useMutation = function (urlOrMutation, mutationArg) {
    var context = useContext(FetchContext);
    useURLRequiredInvariant(!!context.url && Array.isArray(urlOrMutation), 'useMutation');
    useURLRequiredInvariant(!!context.url || (isString(urlOrMutation) && !mutationArg), 'useMutation', 'OR you need to do useMutation("https://example.com", `your graphql mutation`)');
    // regular no context: useMutation('https://example.com', `graphql MUTATION`)
    var url = urlOrMutation;
    var MUTATION = mutationArg;
    // tagged template literal with context: useMutation`graphql MUTATION`
    if (Array.isArray(urlOrMutation) && context.url) {
        invariant(!mutationArg, 'You cannot have a 2nd argument when using tagged template literal syntax with useMutation.');
        url = context.url;
        MUTATION = urlOrMutation[0];
        // regular with context: useMutation(`graphql MUTATION`)
    }
    else if (urlOrMutation && !mutationArg && context.url) {
        url = context.url;
        MUTATION = urlOrMutation;
    }
    var _a = useFetch(url), loading = _a.loading, error = _a.error, cache = _a.cache, request = useMutation_rest(_a, ["loading", "error", "cache"]);
    var mutate = useCallback(function (inputs) { return request.mutate(MUTATION, inputs); }, [MUTATION, request]);
    var data = (request.data || { data: undefined }).data;
    return Object.assign([data, loading, error, mutate], { data: data, loading: loading, error: error, mutate: mutate, cache: cache });
};

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/useQuery.js
var useQuery_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var useQuery = function (urlOrQuery, queryArg) {
    var context = useContext(FetchContext);
    useURLRequiredInvariant(!!context.url && Array.isArray(urlOrQuery), 'useQuery');
    useURLRequiredInvariant(!!context.url || (isString(urlOrQuery) && !queryArg), 'useQuery', 'OR you need to do useQuery("https://example.com", `your graphql query`)');
    // regular no context: useQuery('https://example.com', `graphql QUERY`)
    var url = urlOrQuery;
    var QUERY = queryArg;
    // tagged template literal with context: useQuery`graphql QUERY`
    if (Array.isArray(urlOrQuery) && context.url) {
        invariant(!queryArg, 'You cannot have a 2nd argument when using tagged template literal syntax with useQuery.');
        url = context.url;
        QUERY = urlOrQuery[0];
        // regular with context: useQuery(`graphql QUERY`)
    }
    else if (urlOrQuery && !queryArg && context.url) {
        url = context.url;
        QUERY = urlOrQuery;
    }
    var _a = useFetch(url), loading = _a.loading, error = _a.error, cache = _a.cache, request = useQuery_rest(_a, ["loading", "error", "cache"]);
    var query = useCallback(function (variables) { return request.query(QUERY, variables); }, [QUERY, request]);
    var data = (request.data || { data: undefined }).data;
    return Object.assign([data, loading, error, query], { data: data, loading: loading, error: error, query: query, cache: cache });
};

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/Provider.js



var Provider = function (_a) {
    var url = _a.url, options = _a.options, _b = _a.graphql, graphql = _b === void 0 ? false : _b, children = _a.children;
    var isBrowser = useSSR().isBrowser;
    var defaults = useMemo(function () { return ({
        url: url || (isBrowser ? window.location.origin : ''),
        options: options || {},
        graphql: graphql // TODO: this will make it so useFetch(QUERY || MUTATION) will work
    }); }, [options, graphql, isBrowser, url]);
    return (React.createElement(FetchContext.Provider, { value: defaults }, children));
};

;// CONCATENATED MODULE: ../../node_modules/use-http/dist/esm/index.js









// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha.js
var _excluded = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);
  function ReCAPTCHA() {
    var _this;
    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ReCAPTCHA.prototype;
  _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
    if (this.props.grecaptcha) {
      if (this.props.grecaptcha.enterprise) {
        return this.props.grecaptcha.enterprise[fnName];
      }
      return this.props.grecaptcha[fnName];
    }
    return null;
  };
  _proto.getValue = function getValue() {
    var getResponse = this.getCaptchaFunction("getResponse");
    if (getResponse && this._widgetId !== undefined) {
      return getResponse(this._widgetId);
    }
    return null;
  };
  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }
    return null;
  };
  _proto.execute = function execute() {
    var execute = this.getCaptchaFunction("execute");
    if (execute && this._widgetId !== undefined) {
      return execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };
  _proto.executeAsync = function executeAsync() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;
      _this2.execute();
    });
  };
  _proto.reset = function reset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter && this._widgetId !== undefined) {
      resetter(this._widgetId);
    }
  };
  _proto.forceReset = function forceReset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter) {
      resetter();
    }
  };
  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };
  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }
    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };
  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }
    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };
  _proto.explicitRender = function explicitRender() {
    var render = this.getCaptchaFunction("render");
    if (render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      });
      this.captcha.appendChild(wrapper);
    }
    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };
  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };
  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
      sitekey = _this$props.sitekey,
      onChange = _this$props.onChange,
      theme = _this$props.theme,
      type = _this$props.type,
      tabindex = _this$props.tabindex,
      onExpired = _this$props.onExpired,
      onErrored = _this$props.onErrored,
      size = _this$props.size,
      stoken = _this$props.stoken,
      grecaptcha = _this$props.grecaptcha,
      badge = _this$props.badge,
      hl = _this$props.hl,
      isolated = _this$props.isolated,
      childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    /* eslint-enable no-unused-vars */
    return /*#__PURE__*/react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };
  return ReCAPTCHA;
}(react.Component);

ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: (prop_types_default()).bool
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  if (dynamicOptions.enterprise) {
    return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
  }
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName,
  attributes: getOptions().nonce ? {
    nonce: getOptions().nonce
  } : {}
})(ReCAPTCHA));
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Form/index.js











const Form = ({ id, name, recaptchaPublicKey, className, buttonText, fields, focusKey, }) => {
    const { register, handleSubmit, formState: { errors }, control, setError, reset, setValue, } = useForm();
    const { mode, backendApi } = useEditor();
    const { locale } = useSite();
    const [success, setSucces] = (0,react.useState)(false);
    const { post, response } = esm_useFetch(`${backendApi}/form`);
    const onSubmit = async (data) => {
        if (mode === "editor")
            return;
        setSucces(false);
        const formPost = await post("/", {
            formId: id,
            locale,
            ...data,
        });
        if (formPost?.errors) {
            const errors = formPost.errors;
            Object.keys(errors).forEach((errorKey) => {
                setError(errorKey, {
                    type: "custom",
                    message: errors[errorKey],
                });
            });
        }
        if (response.ok) {
            reset();
            setSucces(response.data);
        }
    };
    return ((0,jsx_runtime.jsxs)("form", { onSubmit: handleSubmit(onSubmit), className: className, "editor-focuskey": focusKey, children: [success && ((0,jsx_runtime.jsx)("div", { className: "rounded-md bg-green-50 p-4 sm:col-span-2", children: (0,jsx_runtime.jsxs)("div", { className: "flex", children: [(0,jsx_runtime.jsx)("div", { className: "flex-shrink-0", children: (0,jsx_runtime.jsx)(CheckCircleIcon, { className: "h-5 w-5 text-green-400", "aria-hidden": "true" }) }), (0,jsx_runtime.jsx)("div", { className: "ml-3", children: (0,jsx_runtime.jsx)("p", { className: "text-sm font-medium text-green-800", children: success }) }), (0,jsx_runtime.jsx)("div", { className: "ml-auto pl-3", children: (0,jsx_runtime.jsx)("div", { className: "-mx-1.5 -my-1.5", children: (0,jsx_runtime.jsxs)("button", { type: "button", className: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50", children: [(0,jsx_runtime.jsx)("span", { className: "sr-only", children: "Dismiss" }), (0,jsx_runtime.jsx)(XMarkIcon, { className: "h-5 w-5", "aria-hidden": "true" })] }) }) })] }) })), fields.map((field) => {
                if (field.type === "textarea") {
                    return ((0,jsx_runtime.jsx)(Form_Textarea, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, error: errors[field.name] || null, ...register(field.name) }, field.name));
                }
                if (field.type === "checkbox") {
                    return ((0,jsx_runtime.jsx)(Controller, { name: field.name, control: control, render: ({ field: propField }) => ((0,jsx_runtime.jsx)(Form_Checkbox, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, error: errors[field.name] || null, ...propField }, field.name)) }, field.name));
                }
                if (field.type === "recaptcha") {
                    if (mode === "editor")
                        return;
                    if (!recaptchaPublicKey)
                        return;
                    return ((0,jsx_runtime.jsxs)("div", { className: "space-y-2", children: [(0,jsx_runtime.jsx)(esm, { sitekey: recaptchaPublicKey, onChange: (value) => setValue(field.name, value) }), errors && errors[field.name] && ((0,jsx_runtime.jsx)("p", { className: "text-sm text-red-600", id: `${name}-error`, children: errors[field.name]?.message }))] }));
                }
                return ((0,jsx_runtime.jsx)(Form_Input, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, type: field.type === "email" ? "email" : "text", error: errors[field.name] || null, ...register(field.name) }, field.name));
            }), (0,jsx_runtime.jsx)("div", { className: "sm:col-span-2", children: (0,jsx_runtime.jsx)("button", { type: "submit", className: "font-text bg-site-600 hover:bg-site-700 focus:ring-site-500 inline-flex w-full items-center justify-center rounded-md border border-transparent px-6 py-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2", children: buttonText }) })] }));
};
/* harmony default export */ var Common_Form = (Form);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Typography.js



const Typography = ({ component: Component, color, className, children, fontType = "text", ...props }) => {
    const { mode } = useEditor();
    const fontClasses = fontType === "heading" ? "font-heading" : "";
    if (children === '"<br>"' && mode !== "editor")
        return null;
    return ((0,jsx_runtime.jsx)(Component, { ...props, className: classNames(className, color, fontClasses), dangerouslySetInnerHTML: {
            __html: children,
        } }));
};
/* harmony default export */ var Common_Typography = (Typography);
//# sourceMappingURL=Typography.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/ContactCentered.js








const ContactCentered = ({ elementId, elementProps }) => {
    const { mode } = useEditor();
    const { forms } = useSite();
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const form = forms && renderElement.renderForm("form-1").selected
        ? forms.find((f) => f.id === renderElement.renderForm("form-1").selected)
        : null;
    return ((0,jsx_runtime.jsx)("div", { "editor-elementid": elementId, "editor-key": "container-1", ...renderElement.renderClassName("container-1", "overflow-hidden py-16 px-4 sm:px-6 lg:px-8 lg:py-24", {
            backgroundColor: "bg-white",
        }), children: (0,jsx_runtime.jsxs)("div", { className: "relative mx-auto max-w-xl", children: [(0,jsx_runtime.jsxs)("div", { className: "text-center", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", "mt-4 text-lg leading-6 text-gray-500 prose"), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }), (0,jsx_runtime.jsxs)("div", { "editor-key": "form-1", ...renderElement.renderClassName("form-1", "mt-12", {
                        backgroundColor: "",
                    }), "editor-form-button": renderElement.renderForm("form-1").button, "editor-form-selected": renderElement.renderForm("form-1").selected, ...renderElement.renderAttributeOptions([{ type: SideEditOptions.Form }], "form-1"), children: [!form && mode === "editor" && ((0,jsx_runtime.jsx)("div", { "editor-focuskey": "form-1", className: "focus:ring-site-500 relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2", children: (0,jsx_runtime.jsx)("span", { className: "mt-2 block text-sm font-medium text-gray-900", children: "Selecteer een formulier" }) })), form && ((0,jsx_runtime.jsx)(Common_Form, { focusKey: "form-1", id: form.id, name: form.name, className: "grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8", fields: form.fields, buttonText: renderElement.renderForm("form-1").button || "Verstuur" }))] })] }) }));
};
/* harmony default export */ var element_ContactCentered = (ContactCentered);
//# sourceMappingURL=ContactCentered.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Container.js


const Container = ({ children, className, focusKey, }) => {
    return ((0,jsx_runtime.jsx)("div", { className: classNames("mx-auto max-w-7xl sm:px-6 lg:px-8", className), "editor-focuskey": focusKey, children: children }));
};
/* harmony default export */ var Common_Container = (Container);
//# sourceMappingURL=Container.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/ElementColorImage.js



const ElementColorImage = ({ editorKey, renderElement, elementId, children, className = "", ...props }) => {
    const containerBgRender = renderElement.renderBackgroundImage(editorKey, "backgroundImage");
    const backgroundType = renderElement.renderProp(editorKey, "background-type")?.value;
    return ((0,jsx_runtime.jsxs)("div", { "editor-elementid": elementId, "editor-key": editorKey, ...containerBgRender, ...renderElement.renderClassName("container-1", classNames("relative", className)), ...renderElement.renderAttributeOptions([
            {
                type: SideEditOptions.Select,
                config: {
                    key: "background-type",
                    label: "Achtergrond type",
                    defaultValue: "color",
                    open: true,
                    selectOptions: [
                        {
                            value: "color",
                            label: "Kleur",
                        },
                        {
                            value: "image",
                            label: "Afbeelding",
                        },
                    ],
                },
            },
            {
                type: SideEditOptions.BackgroundImage,
                config: { key: "backgroundimage", open: false },
            },
        ], "container-1"), children: [backgroundType === "image" && ((0,jsx_runtime.jsx)("div", { className: "absolute inset-0", children: (0,jsx_runtime.jsx)("img", { "editor-focuskey": editorKey, className: "h-full w-full object-cover opacity-60", src: containerBgRender["src"] || "" }) })), children] }));
};
/* harmony default export */ var Common_ElementColorImage = (ElementColorImage);
//# sourceMappingURL=ElementColorImage.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/index.js
var outline = __webpack_require__(77270);
var outline_namespaceObject = /*#__PURE__*/__webpack_require__.t(outline, 2);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/QuestionMarkCircleIcon.js
var QuestionMarkCircleIcon = __webpack_require__(40100);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/solid/index.js
var solid = __webpack_require__(53752);
var solid_namespaceObject = /*#__PURE__*/__webpack_require__.t(solid, 2);
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Icon.js



const Icon = ({ variant, name = "QuestionMarkCircleIcon", ...props }) => {
    const variantIcon = variant === "outline" ? outline_namespaceObject : solid_namespaceObject;
    const Icon = name ? variantIcon[name] : QuestionMarkCircleIcon;
    if (!Icon) {
        const DefaultIcon = QuestionMarkCircleIcon;
        return (0,jsx_runtime.jsx)(DefaultIcon, { "editor-icon": "true", ...props });
    }
    return (0,jsx_runtime.jsx)(Icon, { "editor-icon": "true", ...props });
};
/* harmony default export */ var Common_Icon = (Icon);
//# sourceMappingURL=Icon.js.map
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/Link.js




const Link = ({ href, className, children, target = "_self", page, handleLinkClick, ...props }) => {
    const { mode } = useEditor();
    const { pages, locale, defaultLocale } = useSite();
    const handleClick = (event) => {
        if (mode !== "production") {
            event.preventDefault();
        }
        if (handleLinkClick) {
            handleLinkClick();
        }
    };
    let linkHref = href;
    if (page && mode === "production") {
        const pageObject = pages.find((p) => p.uuid === page);
        const pageData = pageObject?.data.find((d) => d.language.code === locale.toUpperCase());
        if (pageData) {
            if (locale !== defaultLocale) {
                linkHref = `/${locale}${pageData?.path}`;
            }
            else {
                linkHref = pageData?.path;
            }
        }
    }
    return ((0,jsx_runtime.jsx)((link_default()), { href: mode === "production" && linkHref ? linkHref : "#", target: target, onClick: handleClick, className: className, ...props, children: children }));
};
/* harmony default export */ var Common_Link = (Link);
//# sourceMappingURL=Link.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/TrashIcon.js
var TrashIcon = __webpack_require__(84703);
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/RepeatGroup.js




const RepeatGroup = ({ children, group, index, editable, elementId, }) => {
    const { deleteRepeatElementProp } = useEditor();
    const deleteItem = () => {
        deleteRepeatElementProp(elementId, group, index);
    };
    if (editable) {
        return ((0,jsx_runtime.jsxs)("div", { className: classNames("hover:border-app-500 relative w-full border border-dashed p-1"), children: [index && !index.includes("default") && ((0,jsx_runtime.jsx)("button", { onClick: deleteItem, type: "button", className: "bg-app-600 hover:bg-app-700 absolute -top-3 right-1 z-50 inline-flex items-center rounded-lg border border-transparent p-1 text-white shadow-sm focus:outline-none focus:ring-0", children: (0,jsx_runtime.jsx)(TrashIcon, { className: "h-4 w-4", "aria-hidden": "true" }) })), children || null] }));
    }
    return children || null;
};
/* harmony default export */ var Common_RepeatGroup = (RepeatGroup);
//# sourceMappingURL=RepeatGroup.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/PlusIcon.js
var PlusIcon = __webpack_require__(16084);
;// CONCATENATED MODULE: ../elements/lib/components/element/Common/RepeatItem.js





const RepeatItem = ({ children, repeatId, elementProps, elementId, create, className, editable, component: Component = "div", ...props }) => {
    const { updateElementProp } = useEditor();
    const handleCreate = () => {
        const propData = elementProps?.[repeatId]?.items || [];
        propData.push(esm_browser_v4());
        updateElementProp({ items: propData }, repeatId, elementId);
    };
    if (editable) {
        return ((0,jsx_runtime.jsxs)(Component, { className: classNames("relative border border-dashed p-1", className), "editor-repeatid": repeatId, ...props, children: [children || null, create && ((0,jsx_runtime.jsx)("div", { className: "group relative mt-2 flex cursor-pointer items-center justify-center border border-dashed p-2", onClick: handleCreate, children: (0,jsx_runtime.jsx)("div", { className: "bg-app-600 hover:bg-app-700 flex h-6 w-6 items-center justify-center rounded-lg p-1 text-white", children: (0,jsx_runtime.jsx)(PlusIcon, { className: "h-4 w-4" }) }) }))] }));
    }
    return (0,jsx_runtime.jsx)(Component, { className: className, children: children || null });
};
/* harmony default export */ var Common_RepeatItem = (RepeatItem);
//# sourceMappingURL=RepeatItem.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Content/ContentFeatureBox.js











const repeatConfig = [
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-desktop",
            label: "Aantal items op desktop",
            defaultValue: "lg:grid-cols-3",
            open: false,
            selectOptions: [
                {
                    value: "lg:grid-cols-1",
                    label: "1",
                },
                {
                    value: "lg:grid-cols-2",
                    label: "2",
                },
                {
                    value: "lg:grid-cols-3",
                    label: "3",
                },
                {
                    value: "lg:grid-cols-4",
                    label: "4",
                },
                {
                    value: "lg:grid-cols-5",
                    label: "5",
                },
                {
                    value: "lg:grid-cols-6",
                    label: "6",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-tablet",
            label: "Aantal items op tablet",
            defaultValue: "md:grid-cols-2",
            open: false,
            selectOptions: [
                {
                    value: "md:grid-cols-1",
                    label: "1",
                },
                {
                    value: "md:grid-cols-2",
                    label: "2",
                },
                {
                    value: "md:grid-cols-3",
                    label: "3",
                },
                {
                    value: "md:grid-cols-4",
                    label: "4",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-mobile",
            label: "Aantal items op mobiel",
            defaultValue: "grid-cols-1",
            open: false,
            selectOptions: [
                {
                    value: "grid-cols-1",
                    label: "1",
                },
                {
                    value: "grid-cols-2",
                    label: "2",
                },
                {
                    value: "grid-cols-3",
                    label: "3",
                },
            ],
        },
    },
];
const ContentFeatureBox = ({ elementId, elementProps, editable }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "p-8", children: (0,jsx_runtime.jsxs)(Common_Container, { children: [(0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-2xl lg:text-center", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "text-site-500 mt-2 text-3xl font-bold tracking-tight sm:text-4xl"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", "mt-6 text-lg leading-8 prose text-gray-600"), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }), (0,jsx_runtime.jsx)(Common_RepeatItem, { className: `mt-4 grid gap-[50px] ${renderElement.renderProp("feature-repeat", "items-mobile")?.value ||
                        "grid-cols-1"} ${renderElement.renderProp("feature-repeat", "items-tablet")?.value ||
                        "md:grid-cols-2"} ${renderElement.renderProp("feature-repeat", "items-desktop")
                        ?.value || "lg:grid-cols-3"}`, repeatId: "feature-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, "editor-key": "feature-repeat", ...renderElement.renderAttributeOptions(repeatConfig, "feature-repeat"), children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: [
                            "default",
                            ...(elementProps?.["feature-repeat"]?.items || []),
                        ].map((repeatKey) => ((0,jsx_runtime.jsx)(Common_RepeatGroup, { index: repeatKey, group: "feature-repeat", editable: editable, elementId: elementId, children: (0,jsx_runtime.jsxs)("div", { className: "text-center", children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsx)("span", { className: "relative", children: (0,jsx_runtime.jsx)(Common_Icon, { "editor-key": `feature-repeat-${repeatKey}-icon-1`, ...renderElement.renderIcon(`feature-repeat-${repeatKey}-icon-1`), ...renderElement.renderClassName(`feature-repeat-${repeatKey}-icon-1`, `mx-auto h-[60px] w-[60px] md:h-[90px] md:w-[90px] text-gray-900`) }) }) }), (0,jsx_runtime.jsxs)("div", { className: "mt-[30px]", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h3", "editor-key": `feature-repeat-${repeatKey}-title`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-title`, "text-2xl font-medium text-gray-900"), children: renderElement.renderText(`feature-repeat-${repeatKey}-title`, titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": `feature-repeat-${repeatKey}-text`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-text`, "mx-auto mt-5 leading-[30px] prose text-gray-900"), children: renderElement.renderText(`feature-repeat-${repeatKey}-text`, textPlaceHolder.value) }), (0,jsx_runtime.jsx)(Common_Link, { "editor-key": `feature-repeat-${repeatKey}-link`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-link`, "text-base text-site-500 hover:text-site-600 mt-4 block"), ...renderElement.renderLink(`feature-repeat-${repeatKey}-link`), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": `feature-repeat-${repeatKey}-link`, children: renderElement.renderLink(`feature-repeat-${repeatKey}-link`)["editor-link-label"] }) })] })] }, repeatKey) }))) }) })] }) }));
};
/* harmony default export */ var Content_ContentFeatureBox = (ContentFeatureBox);
//# sourceMappingURL=ContentFeatureBox.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Content/ContentFeatureList.js








const ContentFeatureList = ({ elementId, elementProps, editable }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "p-8", children: (0,jsx_runtime.jsxs)(Common_Container, { className: "mx-auto max-w-7xl lg:grid lg:grid-cols-3 lg:gap-x-12", children: [(0,jsx_runtime.jsxs)("div", { children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "top-1", ...renderElement.renderClassName("top-1", "text-lg font-semibold leading-8 tracking-tight text-site-500"), children: renderElement.renderText("top-1", titleSmallPlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "mt-2 text-4xl font-bold tracking-tight text-gray-900"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", "mt-6 text-base leading-7 prose text-gray-600"), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }), (0,jsx_runtime.jsx)("div", { className: "mt-20 lg:col-span-2 lg:mt-0", children: (0,jsx_runtime.jsx)(Common_RepeatItem, { className: "grid grid-cols-1 gap-4 sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-4", repeatId: "feature-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: [
                                "default",
                                ...(elementProps?.["feature-repeat"]?.items || []),
                            ].map((repeatKey) => ((0,jsx_runtime.jsx)("div", { className: "relative", children: (0,jsx_runtime.jsxs)("dt", { children: [(0,jsx_runtime.jsx)(Common_Icon, { "editor-key": `feature-repeat-${repeatKey}-icon`, ...renderElement.renderIcon(`feature-repeat-${repeatKey}-icon`, {
                                                variant: "outline",
                                                name: "CheckIcon",
                                            }), ...renderElement.renderClassName(`feature-repeat-${repeatKey}-icon`, "absolute mt-1 h-6 w-6 text-site-600") }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": `feature-repeat-${repeatKey}-text`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-text`, "ml-10 text-lg font-semibold leading-8 prose text-gray-900"), children: renderElement.renderText(`feature-repeat-${repeatKey}-text`, titleSmallPlaceholder.value) })] }) }, repeatKey))) }) }) })] }) }));
};
/* harmony default export */ var Content_ContentFeatureList = (ContentFeatureList);
//# sourceMappingURL=ContentFeatureList.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Content/ContentText.js








const ContentText = ({ elementId, elementProps, editable }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const items = ["default", ...(elementProps?.["text-repeat"]?.items || [])];
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "py-16", children: (0,jsx_runtime.jsxs)(Common_Container, { children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h1", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "block text-center font-bold leading-8 tracking-tight text-gray-900", {
                        textSize: "text-3xl",
                    }), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_RepeatItem, { className: classNames(`mt-4 text-center lg:grid lg:gap-6 lg:text-left`, items.length === 1 && "text-center lg:grid-cols-1", items.length === 2 && "lg:grid-cols-2", items.length >= 3 && "lg:grid-cols-3"), repeatId: "text-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: items.map((repeatKey) => ((0,jsx_runtime.jsxs)("div", { children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": `text-repeat-${repeatKey}-title`, ...renderElement.renderClassName(`text-repeat-${repeatKey}-title`, "font-semibold leading-6 tracking-wide text-site-500", {
                                        textSize: "text-base",
                                    }), children: renderElement.renderText(`text-repeat-${repeatKey}-title`, titleSmallPlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": `text-repeat-${repeatKey}-text`, ...renderElement.renderClassName(`text-repeat-${repeatKey}-text`, "mb-4 prose text-gray-900", {
                                        textSize: "text-base",
                                    }), children: renderElement.renderText(`text-repeat-${repeatKey}-text`, textPlaceHolder.value) })] }, repeatKey))) }) })] }) }));
};
/* harmony default export */ var Content_ContentText = (ContentText);
//# sourceMappingURL=ContentText.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Content/LogosSimple.js






const LogosSimple = ({ elementId, elementProps, editable }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const repeatConfig = [
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-desktop",
                label: "Aantal items op desktop",
                defaultValue: "lg:grid-cols-3",
                open: false,
                selectOptions: [
                    {
                        value: "lg:grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "lg:grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "lg:grid-cols-3",
                        label: "3",
                    },
                    {
                        value: "lg:grid-cols-4",
                        label: "4",
                    },
                    {
                        value: "lg:grid-cols-5",
                        label: "5",
                    },
                    {
                        value: "lg:grid-cols-6",
                        label: "6",
                    },
                ],
            },
        },
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-tablet",
                label: "Aantal items op tablet",
                defaultValue: "md:grid-cols-2",
                open: false,
                selectOptions: [
                    {
                        value: "md:grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "md:grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "md:grid-cols-3",
                        label: "3",
                    },
                    {
                        value: "md:grid-cols-4",
                        label: "4",
                    },
                ],
            },
        },
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-mobile",
                label: "Aantal items op mobiel",
                defaultValue: "grid-cols-1",
                open: false,
                selectOptions: [
                    {
                        value: "grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "grid-cols-3",
                        label: "3",
                    },
                ],
            },
        },
    ];
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "p-8", children: (0,jsx_runtime.jsx)("div", { className: "mx-auto max-w-7xl px-6 py-12 lg:px-8", children: (0,jsx_runtime.jsx)(Common_RepeatItem, { className: `grid gap-8 ${renderElement.renderProp("logos-repeat", "items-mobile")?.value ||
                    "grid-cols-2"} ${renderElement.renderProp("logos-repeat", "items-tablet")?.value ||
                    "md:grid-cols-2"} ${renderElement.renderProp("logos-repeat", "items-desktop")?.value ||
                    "lg:grid-cols-3"}`, repeatId: "logos-repeat", "editor-key": "logos-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, ...renderElement.renderAttributeOptions(repeatConfig, "logos-repeat"), children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: ["default", ...(elementProps?.["logos-repeat"]?.items || [])].map((repeatKey) => ((0,jsx_runtime.jsx)(Common_RepeatGroup, { index: repeatKey, group: "logos-repeat", editable: editable, elementId: elementId, children: (0,jsx_runtime.jsx)("div", { className: "col-span-1 flex justify-center md:col-span-2 lg:col-span-1", children: (0,jsx_runtime.jsx)("img", { "editor-key": `logos-repeat-${repeatKey}-logo`, ...renderElement.renderClassName(`logos-repeat-${repeatKey}-logo`, "h-12"), ...renderElement.renderImage(`logos-repeat-${repeatKey}-logo`, {
                                    src: "https://tailwindui.com/img/logos/tuple-logo-gray-400.svg",
                                }) }) }, repeatKey) }))) }) }) }) }));
};
/* harmony default export */ var Content_LogosSimple = (LogosSimple);
//# sourceMappingURL=LogosSimple.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Footer/FooterDefault.js






const FooterDefault = ({ elementId, elementProps, editable }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    return ((0,jsx_runtime.jsxs)("div", { "editor-elementid": elementId, "editor-key": "container-1", "aria-labelledby": "footer-heading", ...renderElement.renderClassName("container-1", "", {
            backgroundColor: "bg-white",
        }), children: [(0,jsx_runtime.jsx)("h2", { id: "footer-heading", className: "sr-only", children: "Footer" }), (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16", "editor-focuskey": "container-1", children: [(0,jsx_runtime.jsxs)("div", { className: "xl:grid xl:grid-cols-3 xl:gap-8", children: [(0,jsx_runtime.jsx)("div", { className: "mt-2 space-y-8 xl:col-span-1", children: (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-logo", ...renderElement.renderClassName("text-logo", "text-base prose text-gray-500"), children: renderElement.renderText("text-logo") }) }), (0,jsx_runtime.jsx)(Common_RepeatItem, { className: "mt-12 grid grid-cols-2 gap-8 lg:grid-cols-3 xl:col-span-2 xl:mt-0", repeatId: "footer-links-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: [
                                        "default",
                                        ...(elementProps?.["footer-links-repeat"]?.items || []),
                                    ].map((repeatKey) => ((0,jsx_runtime.jsx)("div", { className: "md:grid md:grid-cols-2 md:gap-8", children: (0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsx)(Common_RepeatGroup, { index: repeatKey, group: "footer-links-repeat", editable: editable, elementId: elementId, children: (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Common_Typography, { component: "h3", "editor-key": `footer-links-repeat-${repeatKey}-title`, ...renderElement.renderClassName(`footer-links-repeat-${repeatKey}-title`, "mb-4 text-site-500"), children: renderElement.renderText(`footer-links-repeat-${repeatKey}-title`, "Header") }), (0,jsx_runtime.jsx)(Common_RepeatItem, { repeatId: `footer-links-repeat-${repeatKey}-links`, elementProps: elementProps, elementId: elementId, create: true, editable: editable, className: "mt-4 space-y-4", component: "ul", children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: [
                                                                    "default",
                                                                    ...(elementProps?.[`footer-links-repeat-${repeatKey}-links`]?.items || []),
                                                                ].map((repeatLinkKey) => ((0,jsx_runtime.jsx)("li", { children: (0,jsx_runtime.jsx)(Common_Link, { ...renderElement.renderRepeatDeleteKey(elementId, `footer-links-repeat-${repeatKey}-links`, repeatLinkKey), "editor-key": `footer-links-repeat-${repeatKey}-links-${repeatLinkKey}-link`, ...renderElement.renderClassName(`footer-links-repeat-${repeatKey}-links-${repeatLinkKey}-link`, "text-base text-gray-500 hover:text-gray-900"), ...renderElement.renderLink(`footer-links-repeat-${repeatKey}-links-${repeatLinkKey}-link`), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": `footer-links-repeat-${repeatKey}-links-${repeatLinkKey}-link`, children: renderElement.renderLink(`footer-links-repeat-${repeatKey}-links-${repeatLinkKey}-link`)["editor-link-label"] }) }) }, repeatLinkKey))) }) })] }) }) }) }, repeatKey))) }) })] }), (0,jsx_runtime.jsx)("div", { className: "mt-12 w-full border-t border-gray-200 pt-8 text-center", children: (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-copyright", ...renderElement.renderClassName("text-copyright", "text-base text-gray-400"), children: renderElement.renderText("text-copyright", "2023 Your Company, Inc. All rights reserved.") }) })] })] }));
};
/* harmony default export */ var Footer_FooterDefault = (FooterDefault);
//# sourceMappingURL=FooterDefault.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Header/CardWithBackgroundImage.js







const CardWithBackgroundImage = ({ elementId, elementProps, editable, }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    return ((0,jsx_runtime.jsx)("div", { className: "relative my-4", "editor-elementid": elementId, children: (0,jsx_runtime.jsx)("div", { className: "mx-auto max-w-7xl sm:px-6 lg:px-8", children: (0,jsx_runtime.jsxs)("div", { className: "relative sm:overflow-hidden sm:rounded-2xl", children: [(0,jsx_runtime.jsxs)("div", { className: "absolute inset-0", children: [(0,jsx_runtime.jsx)("img", { "editor-key": "img-1", ...renderElement.renderClassName("img-1", "h-full w-full object-cover"), ...renderElement.renderImage("img-1", {
                                    src: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2830&q=80&sat=-100",
                                }), ...renderElement.renderAttributeOptions([
                                    {
                                        type: SideEditOptions.BackgroundColor,
                                        config: {
                                            key: "bg-cover",
                                            valueKey: "backgroundColor",
                                            defaultValue: "bg-site-400",
                                            label: "Afbeelding overlay kleur",
                                        },
                                    },
                                ], "img-1") }), (0,jsx_runtime.jsx)("div", { className: `absolute inset-0 ${renderElement.renderProp("img-1", "bg-cover")
                                    ?.backgroundColor || "bg-site-400"} mix-blend-multiply` })] }), (0,jsx_runtime.jsxs)("div", { className: `relative px-6 py-16 sm:py-24 lg:px-8 lg:py-32 ${editable ? "cursor-pointer" : ""}`, "editor-focuskey": "img-1", children: [(0,jsx_runtime.jsxs)("h1", { className: "text-center text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "span", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "block text-white"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "span", "editor-key": "title-2", ...renderElement.renderClassName("title-2", "block text-site-200"), children: renderElement.renderText("title-2", titlePlaceholder.value) })] }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("title-2", "mx-auto mt-6 max-w-lg text-center text-xl sm:max-w-3xl prose text-site-200"), children: renderElement.renderText("text-1", textPlaceHolder.value) }), (0,jsx_runtime.jsx)(Common_RepeatItem, { repeatId: "link-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, className: "mx-auto mt-10 flex max-w-sm justify-center sm:max-w-none", children: (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: [
                                        "default",
                                        ...(elementProps?.["link-repeat"]?.items || []),
                                    ].map((repeatKey) => ((0,jsx_runtime.jsx)(Common_Link, { "editor-key": `link-repeat-${repeatKey}-link`, ...renderElement.renderRepeatDeleteKey(elementId, "link-repeat", repeatKey), ...renderElement.renderClassName(`link-repeat-${repeatKey}-link`, "flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-indigo-700 shadow-sm hover:bg-indigo-50 sm:px-8"), ...renderElement.renderLink(`link-repeat-${repeatKey}-link`), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": `link-repeat-${repeatKey}-link`, children: renderElement.renderLink(`link-repeat-${repeatKey}-link`)["editor-link-label"] }) }, repeatKey))) }) })] })] }) }) }));
};
/* harmony default export */ var Header_CardWithBackgroundImage = (CardWithBackgroundImage);
//# sourceMappingURL=CardWithBackgroundImage.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Header/HeroHeaderBackground.js







const HeroHeaderBackground = ({ elementId, elementProps }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const containerBgRender = renderElement.renderBackgroundImage("container-1", "backgroundImage");
    const imageLocation = renderElement.renderProp("container-1", "img-location")?.value;
    return ((0,jsx_runtime.jsx)("div", { "editor-elementid": elementId, "editor-key": "container-1", ...containerBgRender, ...renderElement.renderAttributeOptions([
            {
                type: SideEditOptions.BackgroundImage,
                config: { key: "backgroundimage" },
            },
            {
                type: SideEditOptions.BackgroundColor,
                config: {
                    key: "bg-cover",
                    valueKey: "backgroundColor",
                    defaultValue: "bg-site-400",
                    label: "Afbeelding overlay kleur",
                },
            },
            {
                type: SideEditOptions.Select,
                config: {
                    key: "img-location",
                    label: "Afbeelding locatie",
                    defaultValue: "object-center",
                    open: false,
                    selectOptions: [
                        {
                            value: "object-left",
                            label: "Links",
                        },
                        {
                            value: "object-right",
                            label: "Rechts",
                        },
                        {
                            value: "object-top",
                            label: "Boven",
                        },
                        {
                            value: "object-bottom",
                            label: "Beneden",
                        },
                        {
                            value: "object-center",
                            label: "Center",
                        },
                    ],
                },
            },
        ], "container-1"), ...renderElement.renderClassName("container-1", ""), children: (0,jsx_runtime.jsxs)("div", { "editor-focuskey": "container-1", className: `relative flex h-96 w-full items-center justify-center ${renderElement.renderProp("container-1", "bg-cover")
                ?.backgroundColor || "bg-site-400"}`, children: [(0,jsx_runtime.jsx)("div", { className: "absolute inset-0", children: (0,jsx_runtime.jsx)("img", { "editor-focuskey": "container-1", className: classNames("h-full w-full object-cover opacity-60", imageLocation || "object-center"), src: containerBgRender["src"] || placeholders_imagePlaceholder.src, alt: "container image" }) }), (0,jsx_runtime.jsxs)(Common_Container, { className: "z-[1] text-center", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h1", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "text-white text-4xl font-bold tracking-tight sm:text-center sm:text-6xl sm:leading-tight prose"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "title-2", ...renderElement.renderClassName("title-2", "text-white text-2xl font-bold tracking-tight sm:text-center sm:text-4xl sm:leading-tight prose"), children: renderElement.renderText("title-2", titlePlaceholder.value) })] })] }) }));
};
/* harmony default export */ var Header_HeroHeaderBackground = (HeroHeaderBackground);
//# sourceMappingURL=HeroHeaderBackground.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/HeroHeader.js






const HeroHeader = ({ elementId, elementProps }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, children: (0,jsx_runtime.jsx)("div", { "editor-focuskey": "container-1", className: "relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8", children: (0,jsx_runtime.jsx)(Common_Container, { children: (0,jsx_runtime.jsxs)("div", { className: "z-10 text-center", children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h3", "editor-key": "top-1", ...renderElement.renderClassName("top-1", "text-base uppercase tracking-wide text-site-500"), children: renderElement.renderText("top-1", titleSmallPlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "mt-1 text-4xl font-extrabold sm:text-5xl sm:tracking-tight lg:text-6xl text-gray-900"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", "mx-auto mt-5 max-w-xl text-xl prose text-gray-500"), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }) }) }) }));
};
/* harmony default export */ var element_HeroHeader = (HeroHeader);
//# sourceMappingURL=HeroHeader.js.map
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/internal/open-closed.js
let n=(0,react.createContext)(null);n.displayName="OpenClosedContext";var open_closed_d=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(open_closed_d||{});function C(){return (0,react.useContext)(n)}function open_closed_c({value:o,children:r}){return react.createElement(n.Provider,{value:o},r)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/owner.js
function owner_e(r){return s.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/start-transition.js
var t;let start_transition_a=(t=react.startTransition)!=null?t:function(i){i()};

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var q=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(q||{}),z=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(z||{});let Q={[0]:e=>({...e,disclosureState:match_u(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},k=(0,react.createContext)(null);k.displayName="DisclosureContext";function disclosure_M(e){let n=(0,react.useContext)(k);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,disclosure_M),o}return n}let disclosure_v=(0,react.createContext)(null);disclosure_v.displayName="DisclosureAPIContext";function disclosure_w(e){let n=(0,react.useContext)(disclosure_v);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,disclosure_w),o}return n}let disclosure_H=(0,react.createContext)(null);disclosure_H.displayName="DisclosurePanelContext";function V(){return (0,react.useContext)(disclosure_H)}function disclosure_Y(e,n){return match_u(n.type,Q,e,n)}let disclosure_Z=react.Fragment;function disclosure_ee(e,n){let{defaultOpen:o=!1,...u}=e,T=(0,react.useRef)(null),l=use_sync_refs_y(n,use_sync_refs_T(a=>{T.current=a},e.as===void 0||e.as===react.Fragment)),t=(0,react.useRef)(null),f=(0,react.useRef)(null),s=(0,react.useReducer)(disclosure_Y,{disclosureState:o?0:1,linkedPanel:!1,buttonRef:f,panelRef:t,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:c},D]=s,d=use_event_o(a=>{D({type:1});let r=owner_e(T);if(!r||!c)return;let p=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(c):r.getElementById(c))();p==null||p.focus()}),P=(0,react.useMemo)(()=>({close:d}),[d]),b=(0,react.useMemo)(()=>({open:i===0,close:d}),[i,d]),y={ref:l};return react.createElement(k.Provider,{value:s},react.createElement(disclosure_v.Provider,{value:P},react.createElement(open_closed_c,{value:match_u(i,{[0]:open_closed_d.Open,[1]:open_closed_d.Closed})},render_X({ourProps:y,theirProps:u,slot:b,defaultTag:disclosure_Z,name:"Disclosure"}))))}let disclosure_te="button";function disclosure_ne(e,n){let o=use_id_I(),{id:u=`headlessui-disclosure-button-${o}`,...T}=e,[l,t]=disclosure_M("Disclosure.Button"),f=V(),s=f===null?!1:f===l.panelId,i=(0,react.useRef)(null),c=use_sync_refs_y(i,n,s?null:l.buttonRef);(0,react.useEffect)(()=>{if(!s)return t({type:2,buttonId:u}),()=>{t({type:2,buttonId:null})}},[u,t,s]);let D=use_event_o(r=>{var p;if(s){if(l.disclosureState===1)return;switch(r.key){case keyboard_o.Space:case keyboard_o.Enter:r.preventDefault(),r.stopPropagation(),t({type:0}),(p=l.buttonRef.current)==null||p.focus();break}}else switch(r.key){case keyboard_o.Space:case keyboard_o.Enter:r.preventDefault(),r.stopPropagation(),t({type:0});break}}),d=use_event_o(r=>{switch(r.key){case keyboard_o.Space:r.preventDefault();break}}),P=use_event_o(r=>{var p;bugs_r(r.currentTarget)||e.disabled||(s?(t({type:0}),(p=l.buttonRef.current)==null||p.focus()):t({type:0}))}),b=(0,react.useMemo)(()=>({open:l.disclosureState===0}),[l]),y=use_resolve_button_type_s(e,i),a=s?{ref:c,type:y,onKeyDown:D,onClick:P}:{ref:c,id:u,type:y,"aria-expanded":e.disabled?void 0:l.disclosureState===0,"aria-controls":l.linkedPanel?l.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return render_X({ourProps:a,theirProps:T,slot:b,defaultTag:disclosure_te,name:"Disclosure.Button"})}let le="div",oe=S.RenderStrategy|S.Static;function disclosure_re(e,n){let o=use_id_I(),{id:u=`headlessui-disclosure-panel-${o}`,...T}=e,[l,t]=disclosure_M("Disclosure.Panel"),{close:f}=disclosure_w("Disclosure.Panel"),s=use_sync_refs_y(n,l.panelRef,P=>{start_transition_a(()=>t({type:P?4:5}))});(0,react.useEffect)(()=>(t({type:3,panelId:u}),()=>{t({type:3,panelId:null})}),[u,t]);let i=C(),c=(()=>i!==null?(i&open_closed_d.Open)===open_closed_d.Open:l.disclosureState===0)(),D=(0,react.useMemo)(()=>({open:l.disclosureState===0,close:f}),[l,f]),d={ref:s,id:u};return react.createElement(disclosure_H.Provider,{value:l.panelId},render_X({ourProps:d,theirProps:T,slot:D,defaultTag:le,features:oe,visible:c,name:"Disclosure.Panel"}))}let se=D(disclosure_ee),ue=D(disclosure_ne),ie=D(disclosure_re),ve=Object.assign(se,{Button:ue,Panel:ie});

// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/XMarkIcon.js
var outline_XMarkIcon = __webpack_require__(75993);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/Bars3Icon.js
var Bars3Icon = __webpack_require__(23630);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/calculate-active-index.js
function calculate_active_index_f(r){throw new Error("Unexpected object: "+r)}var calculate_active_index_a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(calculate_active_index_a||{});function x(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:calculate_active_index_f(r)}})();return d===-1?l:d}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/focus-management.js
let focus_management_c=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var focus_management_M=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(focus_management_M||{}),focus_management_N=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(focus_management_N||{}),F=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(F||{});function focus_management_f(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(focus_management_c)).sort((r,t)=>Math.sign((r.tabIndex||Number.MAX_SAFE_INTEGER)-(t.tabIndex||Number.MAX_SAFE_INTEGER)))}var T=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T||{});function focus_management_h(e,r=0){var t;return e===((t=owner_e(e))==null?void 0:t.body)?!1:match_u(r,{[0](){return e.matches(focus_management_c)},[1](){let l=e;for(;l!==null;){if(l.matches(focus_management_c))return!0;l=l.parentElement}return!1}})}function focus_management_D(e){let r=owner_e(e);disposables_o().nextFrame(()=>{r&&!focus_management_h(r.activeElement,0)&&focus_management_y(e)})}var focus_management_w=(t=>(t[t.Keyboard=0]="Keyboard",t[t.Mouse=1]="Mouse",t))(focus_management_w||{});typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("keydown",e=>{e.metaKey||e.altKey||e.ctrlKey||(document.documentElement.dataset.headlessuiFocusVisible="")},!0),document.addEventListener("click",e=>{e.detail===1?delete document.documentElement.dataset.headlessuiFocusVisible:e.detail===0&&(document.documentElement.dataset.headlessuiFocusVisible="")},!0));function focus_management_y(e){e==null||e.focus({preventScroll:!0})}let focus_management_S=["textarea","input"].join(",");function focus_management_H(e){var r,t;return(t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,focus_management_S))!=null?t:!1}function I(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),i=r(l);if(o===null||i===null)return 0;let n=o.compareDocumentPosition(i);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function _(e,r){return O(focus_management_f(),r,{relativeTo:e})}function O(e,r,{sorted:t=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?I(e):e:focus_management_f(e);o.length>0&&n.length>1&&(n=n.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let E=(()=>{if(r&5)return 1;if(r&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(l))-1;if(r&4)return Math.max(0,n.indexOf(l))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),p=r&32?{preventScroll:!0}:{},d=0,a=n.length,u;do{if(d>=a||d+a<=0)return 0;let s=x+d;if(r&16)s=(s+a)%a;else{if(s<0)return 3;if(s>=a)return 1}u=n[s],u==null||u.focus(p),d+=E}while(u!==i.activeElement);return r&6&&focus_management_H(u)&&u.select(),2}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-document-event.js
function use_document_event_d(e,r,n){let o=use_latest_value_s(r);(0,react.useEffect)(()=>{function t(u){o.current(u)}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-window-event.js
function use_window_event_s(e,r,n){let o=use_latest_value_s(r);(0,react.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function use_outside_click_H(s,m,i=!0){let l=(0,react.useRef)(!1);(0,react.useEffect)(()=>{requestAnimationFrame(()=>{l.current=i})},[i]);function a(e,o){if(!l.current||e.defaultPrevented)return;let n=o(e);if(n===null||!n.getRootNode().contains(n))return;let E=function r(t){return typeof t=="function"?r(t()):Array.isArray(t)||t instanceof Set?t:[t]}(s);for(let r of E){if(r===null)continue;let t=r instanceof HTMLElement?r:r.current;if(t!=null&&t.contains(n)||e.composed&&e.composedPath().includes(t))return}return!focus_management_h(n,T.Loose)&&n.tabIndex!==-1&&e.preventDefault(),m(e,n)}let u=(0,react.useRef)(null);use_document_event_d("mousedown",e=>{var o,n;l.current&&(u.current=((n=(o=e.composedPath)==null?void 0:o.call(e))==null?void 0:n[0])||e.target)},!0),use_document_event_d("click",e=>{u.current&&(a(e,()=>u.current),u.current=null)},!0),use_window_event_s("blur",e=>a(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-tree-walker.js
function use_tree_walker_F({container:e,accept:t,walk:r,enabled:c=!0}){let o=(0,react.useRef)(t),l=(0,react.useRef)(r);(0,react.useEffect)(()=>{o.current=t,l.current=r},[t,r]),use_iso_morphic_effect_l(()=>{if(!e||!c)return;let n=owner_e(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode)},[e,c,o,l])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-owner.js
function use_owner_n(...e){return (0,react.useMemo)(()=>owner_e(...e),[...e])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-tracked-pointer.js
function use_tracked_pointer_t(e){return[e.screenX,e.screenY]}function use_tracked_pointer_u(){let e=(0,react.useRef)([-1,-1]);return{wasMoved(r){let n=use_tracked_pointer_t(r);return e.current[0]===n[0]&&e.current[1]===n[1]?!1:(e.current=n,!0)},update(r){e.current=use_tracked_pointer_t(r)}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/get-text-value.js
let get_text_value_a=/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;function get_text_value_o(e){var r,i;let n=(r=e.innerText)!=null?r:"",t=e.cloneNode(!0);if(!(t instanceof HTMLElement))return n;let u=!1;for(let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(),u=!0;let l=u?(i=t.innerText)!=null?i:"":n;return get_text_value_a.test(l)&&(l=l.replace(get_text_value_a,"")),l}function get_text_value_g(e){let n=e.getAttribute("aria-label");if(typeof n=="string")return n.trim();let t=e.getAttribute("aria-labelledby");if(t){let u=t.split(" ").map(l=>{let r=document.getElementById(l);if(r){let i=r.getAttribute("aria-label");return typeof i=="string"?i.trim():get_text_value_o(r).trim()}return null}).filter(Boolean);if(u.length>0)return u.join(", ")}return get_text_value_o(e).trim()}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-text-value.js
function use_text_value_b(c){let t=(0,react.useRef)(""),r=(0,react.useRef)("");return use_event_o(()=>{let e=c.current;if(!e)return"";let u=e.innerText;if(t.current===u)return r.current;let n=get_text_value_g(e).trim().toLowerCase();return t.current=u,r.current=n,n})}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/menu/menu.js
var me=(r=>(r[r.Open=0]="Open",r[r.Closed=1]="Closed",r))(me||{}),de=(r=>(r[r.Pointer=0]="Pointer",r[r.Other=1]="Other",r))(de||{}),fe=(a=>(a[a.OpenMenu=0]="OpenMenu",a[a.CloseMenu=1]="CloseMenu",a[a.GoToItem=2]="GoToItem",a[a.Search=3]="Search",a[a.ClearSearch=4]="ClearSearch",a[a.RegisterItem=5]="RegisterItem",a[a.UnregisterItem=6]="UnregisterItem",a))(fe||{});function menu_w(e,u=r=>r){let r=e.activeItemIndex!==null?e.items[e.activeItemIndex]:null,i=I(u(e.items.slice()),t=>t.dataRef.current.domRef.current),s=r?i.indexOf(r):null;return s===-1&&(s=null),{items:i,activeItemIndex:s}}let Te={[1](e){return e.menuState===1?e:{...e,activeItemIndex:null,menuState:1}},[0](e){return e.menuState===0?e:{...e,__demoMode:!1,menuState:0}},[2]:(e,u)=>{var s;let r=menu_w(e),i=x(u,{resolveItems:()=>r.items,resolveActiveIndex:()=>r.activeItemIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return{...e,...r,searchQuery:"",activeItemIndex:i,activationTrigger:(s=u.trigger)!=null?s:1}},[3]:(e,u)=>{let i=e.searchQuery!==""?0:1,s=e.searchQuery+u.value.toLowerCase(),o=(e.activeItemIndex!==null?e.items.slice(e.activeItemIndex+i).concat(e.items.slice(0,e.activeItemIndex+i)):e.items).find(l=>{var m;return((m=l.dataRef.current.textValue)==null?void 0:m.startsWith(s))&&!l.dataRef.current.disabled}),a=o?e.items.indexOf(o):-1;return a===-1||a===e.activeItemIndex?{...e,searchQuery:s}:{...e,searchQuery:s,activeItemIndex:a,activationTrigger:1}},[4](e){return e.searchQuery===""?e:{...e,searchQuery:"",searchActiveItemIndex:null}},[5]:(e,u)=>{let r=menu_w(e,i=>[...i,{id:u.id,dataRef:u.dataRef}]);return{...e,...r}},[6]:(e,u)=>{let r=menu_w(e,i=>{let s=i.findIndex(t=>t.id===u.id);return s!==-1&&i.splice(s,1),i});return{...e,...r,activationTrigger:1}}},U=(0,react.createContext)(null);U.displayName="MenuContext";function menu_O(e){let u=(0,react.useContext)(U);if(u===null){let r=new Error(`<${e} /> is missing a parent <Menu /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,menu_O),r}return u}function ye(e,u){return match_u(u.type,Te,e,u)}let Ie=react.Fragment;function Me(e,u){let{__demoMode:r=!1,...i}=e,s=(0,react.useReducer)(ye,{__demoMode:r,menuState:r?0:1,buttonRef:(0,react.createRef)(),itemsRef:(0,react.createRef)(),items:[],searchQuery:"",activeItemIndex:null,activationTrigger:1}),[{menuState:t,itemsRef:o,buttonRef:a},l]=s,m=use_sync_refs_y(u);use_outside_click_H([a,o],(g,R)=>{var p;l({type:1}),focus_management_h(R,T.Loose)||(g.preventDefault(),(p=a.current)==null||p.focus())},t===0);let I=use_event_o(()=>{l({type:1})}),A=(0,react.useMemo)(()=>({open:t===0,close:I}),[t,I]),f={ref:m};return react.createElement(U.Provider,{value:s},react.createElement(open_closed_c,{value:match_u(t,{[0]:open_closed_d.Open,[1]:open_closed_d.Closed})},render_X({ourProps:f,theirProps:i,slot:A,defaultTag:Ie,name:"Menu"})))}let ge="button";function Re(e,u){var R;let r=use_id_I(),{id:i=`headlessui-menu-button-${r}`,...s}=e,[t,o]=menu_O("Menu.Button"),a=use_sync_refs_y(t.buttonRef,u),l=use_disposables_p(),m=use_event_o(p=>{switch(p.key){case keyboard_o.Space:case keyboard_o.Enter:case keyboard_o.ArrowDown:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:calculate_active_index_a.First}));break;case keyboard_o.ArrowUp:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:calculate_active_index_a.Last}));break}}),I=use_event_o(p=>{switch(p.key){case keyboard_o.Space:p.preventDefault();break}}),A=use_event_o(p=>{if(bugs_r(p.currentTarget))return p.preventDefault();e.disabled||(t.menuState===0?(o({type:1}),l.nextFrame(()=>{var M;return(M=t.buttonRef.current)==null?void 0:M.focus({preventScroll:!0})})):(p.preventDefault(),o({type:0})))}),f=(0,react.useMemo)(()=>({open:t.menuState===0}),[t]),g={ref:a,id:i,type:use_resolve_button_type_s(e,t.buttonRef),"aria-haspopup":"menu","aria-controls":(R=t.itemsRef.current)==null?void 0:R.id,"aria-expanded":e.disabled?void 0:t.menuState===0,onKeyDown:m,onKeyUp:I,onClick:A};return render_X({ourProps:g,theirProps:s,slot:f,defaultTag:ge,name:"Menu.Button"})}let Ae="div",be=S.RenderStrategy|S.Static;function Ee(e,u){var M,b;let r=use_id_I(),{id:i=`headlessui-menu-items-${r}`,...s}=e,[t,o]=menu_O("Menu.Items"),a=use_sync_refs_y(t.itemsRef,u),l=use_owner_n(t.itemsRef),m=use_disposables_p(),I=C(),A=(()=>I!==null?(I&open_closed_d.Open)===open_closed_d.Open:t.menuState===0)();(0,react.useEffect)(()=>{let n=t.itemsRef.current;n&&t.menuState===0&&n!==(l==null?void 0:l.activeElement)&&n.focus({preventScroll:!0})},[t.menuState,t.itemsRef,l]),use_tree_walker_F({container:t.itemsRef.current,enabled:t.menuState===0,accept(n){return n.getAttribute("role")==="menuitem"?NodeFilter.FILTER_REJECT:n.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(n){n.setAttribute("role","none")}});let f=use_event_o(n=>{var E,P;switch(m.dispose(),n.key){case keyboard_o.Space:if(t.searchQuery!=="")return n.preventDefault(),n.stopPropagation(),o({type:3,value:n.key});case keyboard_o.Enter:if(n.preventDefault(),n.stopPropagation(),o({type:1}),t.activeItemIndex!==null){let{dataRef:S}=t.items[t.activeItemIndex];(P=(E=S.current)==null?void 0:E.domRef.current)==null||P.click()}focus_management_D(t.buttonRef.current);break;case keyboard_o.ArrowDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:calculate_active_index_a.Next});case keyboard_o.ArrowUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:calculate_active_index_a.Previous});case keyboard_o.Home:case keyboard_o.PageUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:calculate_active_index_a.First});case keyboard_o.End:case keyboard_o.PageDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:calculate_active_index_a.Last});case keyboard_o.Escape:n.preventDefault(),n.stopPropagation(),o({type:1}),disposables_o().nextFrame(()=>{var S;return(S=t.buttonRef.current)==null?void 0:S.focus({preventScroll:!0})});break;case keyboard_o.Tab:n.preventDefault(),n.stopPropagation(),o({type:1}),disposables_o().nextFrame(()=>{_(t.buttonRef.current,n.shiftKey?focus_management_M.Previous:focus_management_M.Next)});break;default:n.key.length===1&&(o({type:3,value:n.key}),m.setTimeout(()=>o({type:4}),350));break}}),g=use_event_o(n=>{switch(n.key){case keyboard_o.Space:n.preventDefault();break}}),R=(0,react.useMemo)(()=>({open:t.menuState===0}),[t]),p={"aria-activedescendant":t.activeItemIndex===null||(M=t.items[t.activeItemIndex])==null?void 0:M.id,"aria-labelledby":(b=t.buttonRef.current)==null?void 0:b.id,id:i,onKeyDown:f,onKeyUp:g,role:"menu",tabIndex:0,ref:a};return render_X({ourProps:p,theirProps:s,slot:R,defaultTag:Ae,features:be,visible:A,name:"Menu.Items"})}let Se=react.Fragment;function Pe(e,u){let r=use_id_I(),{id:i=`headlessui-menu-item-${r}`,disabled:s=!1,...t}=e,[o,a]=menu_O("Menu.Item"),l=o.activeItemIndex!==null?o.items[o.activeItemIndex].id===i:!1,m=(0,react.useRef)(null),I=use_sync_refs_y(u,m);use_iso_morphic_effect_l(()=>{if(o.__demoMode||o.menuState!==0||!l||o.activationTrigger===0)return;let T=disposables_o();return T.requestAnimationFrame(()=>{var v,B;(B=(v=m.current)==null?void 0:v.scrollIntoView)==null||B.call(v,{block:"nearest"})}),T.dispose},[o.__demoMode,m,l,o.menuState,o.activationTrigger,o.activeItemIndex]);let A=use_text_value_b(m),f=(0,react.useRef)({disabled:s,domRef:m,get textValue(){return A()}});use_iso_morphic_effect_l(()=>{f.current.disabled=s},[f,s]),use_iso_morphic_effect_l(()=>(a({type:5,id:i,dataRef:f}),()=>a({type:6,id:i})),[f,i]);let g=use_event_o(()=>{a({type:1})}),R=use_event_o(T=>{if(s)return T.preventDefault();a({type:1}),focus_management_D(o.buttonRef.current)}),p=use_event_o(()=>{if(s)return a({type:2,focus:calculate_active_index_a.Nothing});a({type:2,focus:calculate_active_index_a.Specific,id:i})}),M=use_tracked_pointer_u(),b=use_event_o(T=>M.update(T)),n=use_event_o(T=>{M.wasMoved(T)&&(s||l||a({type:2,focus:calculate_active_index_a.Specific,id:i,trigger:0}))}),E=use_event_o(T=>{M.wasMoved(T)&&(s||l&&a({type:2,focus:calculate_active_index_a.Nothing}))}),P=(0,react.useMemo)(()=>({active:l,disabled:s,close:g}),[l,s,g]);return render_X({ourProps:{id:i,ref:I,role:"menuitem",tabIndex:s===!0?void 0:-1,"aria-disabled":s===!0?!0:void 0,disabled:void 0,onClick:R,onFocus:p,onPointerEnter:b,onMouseEnter:b,onPointerMove:n,onMouseMove:n,onPointerLeave:E,onMouseLeave:E},theirProps:t,slot:P,defaultTag:Se,name:"Menu.Item"})}let menu_ve=D(Me),xe=D(Re),he=D(Ee),De=D(Pe),it=Object.assign(menu_ve,{Button:xe,Items:he,Item:De});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
function use_is_mounted_f(){let e=(0,react.useRef)(!1);return use_iso_morphic_effect_l(()=>(e.current=!0,()=>{e.current=!1}),[]),e}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/once.js
function once_l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function transition_d(t,...e){t&&e.length>0&&t.classList.add(...e)}function transition_v(t,...e){t&&e.length>0&&t.classList.remove(...e)}function transition_F(t,e){let n=disposables_o();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:o}=getComputedStyle(t),[u,p]=[m,o].map(a=>{let[r=0]=a.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,f)=>f-i);return r}),l=u+p;if(l!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose()},l),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose()})});let a=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),a())})}else e();return n.add(()=>e()),n.dispose}function transition_y(t,e,n,m){let o=n?"enter":"leave",u=disposables_o(),p=m!==void 0?once_l(m):()=>{};o==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let l=match_u(o,{enter:()=>e.enter,leave:()=>e.leave}),a=match_u(o,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=match_u(o,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return transition_v(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),transition_d(t,...l,...r),u.nextFrame(()=>{transition_v(t,...r),transition_d(t,...a),transition_F(t,()=>(transition_v(t,...l),transition_d(t,...e.entered),p()))}),u.dispose}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-transition.js
function use_transition_D({container:i,direction:t,classes:o,onStart:s,onStop:u}){let a=use_is_mounted_f(),c=use_disposables_p(),r=use_latest_value_s(t);use_iso_morphic_effect_l(()=>{let e=disposables_o();c.add(e.dispose);let n=i.current;if(n&&r.current!=="idle"&&a.current)return e.dispose(),s.current(r.current),e.add(transition_y(n,o.current,r.current==="enter",()=>{e.dispose(),u.current(r.current)})),e.dispose},[t])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-flags.js
function use_flags_c(a=0){let[l,r]=(0,react.useState)(a),t=use_is_mounted_f(),o=(0,react.useCallback)(e=>{t.current&&r(u=>u|e)},[l,t]),m=(0,react.useCallback)(e=>Boolean(l&e),[l]),s=(0,react.useCallback)(e=>{t.current&&r(u=>u&~e)},[r,t]),g=(0,react.useCallback)(e=>{t.current&&r(u=>u^e)},[r]);return{flags:l,addFlag:o,hasFlag:m,removeFlag:s,toggleFlag:g}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/transitions/transition.js
function transition_x(t=""){return t.split(" ").filter(n=>n.trim().length>1)}let transition_I=(0,react.createContext)(null);transition_I.displayName="TransitionContext";var Ce=(r=>(r.Visible="visible",r.Hidden="hidden",r))(Ce||{});function transition_Ee(){let t=(0,react.useContext)(transition_I);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}function transition_be(){let t=(0,react.useContext)(transition_);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}let transition_=(0,react.createContext)(null);transition_.displayName="NestingContext";function transition_M(t){return"children"in t?transition_M(t.children):t.current.filter(({el:n})=>n.current!==null).filter(({state:n})=>n==="visible").length>0}function transition_re(t,n){let r=use_latest_value_s(t),o=(0,react.useRef)([]),N=use_is_mounted_f(),H=use_disposables_p(),p=use_event_o((s,e=render_j.Hidden)=>{let a=o.current.findIndex(({el:i})=>i===s);a!==-1&&(match_u(e,{[render_j.Unmount](){o.current.splice(a,1)},[render_j.Hidden](){o.current[a].state="hidden"}}),H.microTask(()=>{var i;!transition_M(o)&&N.current&&((i=r.current)==null||i.call(r))}))}),P=use_event_o(s=>{let e=o.current.find(({el:a})=>a===s);return e?e.state!=="visible"&&(e.state="visible"):o.current.push({el:s,state:"visible"}),()=>p(s,render_j.Unmount)}),h=(0,react.useRef)([]),v=(0,react.useRef)(Promise.resolve()),T=(0,react.useRef)({enter:[],leave:[],idle:[]}),g=use_event_o((s,e,a)=>{h.current.splice(0),n&&(n.chains.current[e]=n.chains.current[e].filter(([i])=>i!==s)),n==null||n.chains.current[e].push([s,new Promise(i=>{h.current.push(i)})]),n==null||n.chains.current[e].push([s,new Promise(i=>{Promise.all(T.current[e].map(([l,R])=>R)).then(()=>i())})]),e==="enter"?v.current=v.current.then(()=>n==null?void 0:n.wait.current).then(()=>a(e)):a(e)}),f=use_event_o((s,e,a)=>{Promise.all(T.current[e].splice(0).map(([i,l])=>l)).then(()=>{var i;(i=h.current.shift())==null||i()}).then(()=>a(e))});return (0,react.useMemo)(()=>({children:o,register:P,unregister:p,onStart:g,onStop:f,wait:v,chains:T}),[P,p,o,g,f,T,v])}function transition_Se(){}let transition_xe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function transition_ie(t){var r;let n={};for(let o of transition_xe)n[o]=(r=t[o])!=null?r:transition_Se;return n}function transition_Pe(t){let n=(0,react.useRef)(transition_ie(t));return (0,react.useEffect)(()=>{n.current=transition_ie(t)},[t]),n}let transition_Re="div",transition_oe=S.RenderStrategy;function transition_ye(t,n){let{beforeEnter:r,afterEnter:o,beforeLeave:N,afterLeave:H,enter:p,enterFrom:P,enterTo:h,entered:v,leave:T,leaveFrom:g,leaveTo:f,...s}=t,e=(0,react.useRef)(null),a=use_sync_refs_y(e,n),i=s.unmount?render_j.Unmount:render_j.Hidden,{show:l,appear:R,initial:d}=transition_Ee(),[u,U]=(0,react.useState)(l?"visible":"hidden"),K=transition_be(),{register:L,unregister:w}=K,j=(0,react.useRef)(null);(0,react.useEffect)(()=>L(e),[L,e]),(0,react.useEffect)(()=>{if(i===render_j.Hidden&&e.current){if(l&&u!=="visible"){U("visible");return}return match_u(u,{["hidden"]:()=>w(e),["visible"]:()=>L(e)})}},[u,e,L,w,l,i]);let k=use_latest_value_s({enter:transition_x(p),enterFrom:transition_x(P),enterTo:transition_x(h),entered:transition_x(v),leave:transition_x(T),leaveFrom:transition_x(g),leaveTo:transition_x(f)}),O=transition_Pe({beforeEnter:r,afterEnter:o,beforeLeave:N,afterLeave:H}),G=use_server_handoff_complete_l();(0,react.useEffect)(()=>{if(G&&u==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[e,u,G]);let B=d&&!R,ae=(()=>!G||B||j.current===l?"idle":l?"enter":"leave")(),D=use_flags_c(0),le=use_event_o(C=>match_u(C,{enter:()=>{D.addFlag(open_closed_d.Opening),O.current.beforeEnter()},leave:()=>{D.addFlag(open_closed_d.Closing),O.current.beforeLeave()},idle:()=>{}})),ue=use_event_o(C=>match_u(C,{enter:()=>{D.removeFlag(open_closed_d.Opening),O.current.afterEnter()},leave:()=>{D.removeFlag(open_closed_d.Closing),O.current.afterLeave()},idle:()=>{}})),V=transition_re(()=>{U("hidden"),w(e)},K);use_transition_D({container:e,classes:k,direction:ae,onStart:use_latest_value_s(C=>{V.onStart(e,C,le)}),onStop:use_latest_value_s(C=>{V.onStop(e,C,ue),C==="leave"&&!transition_M(V)&&(U("hidden"),w(e))})}),(0,react.useEffect)(()=>{B&&(i===render_j.Hidden?j.current=null:j.current=l)},[l,B,u]);let J=s,Te={ref:a};return R&&l&&d&&(J={...J,className:class_names_e(s.className,...k.current.enter,...k.current.enterFrom)}),react.createElement(transition_.Provider,{value:V},react.createElement(open_closed_c,{value:match_u(u,{["visible"]:open_closed_d.Open,["hidden"]:open_closed_d.Closed})|D.flags},render_X({ourProps:Te,theirProps:J,defaultTag:transition_Re,features:transition_oe,visible:u==="visible",name:"Transition.Child"})))}function Ne(t,n){let{show:r,appear:o=!1,unmount:N,...H}=t,p=(0,react.useRef)(null),P=use_sync_refs_y(p,n);use_server_handoff_complete_l();let h=C();if(r===void 0&&h!==null&&(r=(h&open_closed_d.Open)===open_closed_d.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[v,T]=(0,react.useState)(r?"visible":"hidden"),g=transition_re(()=>{T("hidden")}),[f,s]=(0,react.useState)(!0),e=(0,react.useRef)([r]);use_iso_morphic_effect_l(()=>{f!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),s(!1))},[e,r]);let a=(0,react.useMemo)(()=>({show:r,appear:o,initial:f}),[r,o,f]);(0,react.useEffect)(()=>{if(r)T("visible");else if(!transition_M(g))T("hidden");else{let d=p.current;if(!d)return;let u=d.getBoundingClientRect();u.x===0&&u.y===0&&u.width===0&&u.height===0&&T("hidden")}},[r,g]);let i={unmount:N},l=use_event_o(()=>{var d;f&&s(!1),(d=t.beforeEnter)==null||d.call(t)}),R=use_event_o(()=>{var d;f&&s(!1),(d=t.beforeLeave)==null||d.call(t)});return react.createElement(transition_.Provider,{value:g},react.createElement(transition_I.Provider,{value:a},render_X({ourProps:{...i,as:react.Fragment,children:react.createElement(transition_se,{ref:P,...i,...H,beforeEnter:l,beforeLeave:R})},theirProps:{},defaultTag:react.Fragment,features:transition_oe,visible:v==="visible",name:"Transition"})))}function He(t,n){let r=(0,react.useContext)(transition_I)!==null,o=C()!==null;return react.createElement(react.Fragment,null,!r&&o?react.createElement(transition_z,{ref:n,...t}):react.createElement(transition_se,{ref:n,...t}))}let transition_z=D(Ne),transition_se=D(transition_ye),transition_De=D(He),$e=Object.assign(transition_z,{Child:transition_De,Root:transition_z});

// EXTERNAL MODULE: ../../node_modules/@heroicons/react/20/solid/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(72211);
;// CONCATENATED MODULE: ../../node_modules/react-country-flag/dist/react-country-flag.esm.js


function react_country_flag_esm_extends() {
  react_country_flag_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return react_country_flag_esm_extends.apply(this, arguments);
}
function react_country_flag_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var react_country_flag_esm_excluded = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"];
var DEFAULT_CDN_URL = 'https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/';
var DEFAULT_CDN_SUFFIX = 'svg';
// offset between uppercase ascii and regional indicator symbols
var OFFSET = 127397;
var ReactCountryFlag = function ReactCountryFlag(_ref) {
  var _ref$cdnSuffix = _ref.cdnSuffix,
    cdnSuffix = _ref$cdnSuffix === void 0 ? DEFAULT_CDN_SUFFIX : _ref$cdnSuffix,
    _ref$cdnUrl = _ref.cdnUrl,
    cdnUrl = _ref$cdnUrl === void 0 ? DEFAULT_CDN_URL : _ref$cdnUrl,
    countryCode = _ref.countryCode,
    style = _ref.style,
    _ref$svg = _ref.svg,
    svg = _ref$svg === void 0 ? false : _ref$svg,
    props = react_country_flag_esm_objectWithoutPropertiesLoose(_ref, react_country_flag_esm_excluded);
  if (typeof countryCode !== 'string') {
    return null;
  }
  if (svg) {
    var flagUrl = "" + cdnUrl + countryCode.toLowerCase() + "." + cdnSuffix;
    return (0,react.createElement)("img", Object.assign({}, props, {
      src: flagUrl,
      style: react_country_flag_esm_extends({
        display: 'inline-block',
        width: '1em',
        height: '1em',
        verticalAlign: 'middle'
      }, style)
    }));
  }
  var emoji = countryCode.toUpperCase().replace(/./g, function (_char) {
    return String.fromCodePoint(_char.charCodeAt(0) + OFFSET);
  });
  return (0,react.createElement)("span", Object.assign({
    role: "img"
  }, props, {
    style: react_country_flag_esm_extends({
      display: 'inline-block',
      fontSize: '1em',
      lineHeight: '1em',
      verticalAlign: 'middle'
    }, style)
  }), emoji);
};

/* harmony default export */ var react_country_flag_esm = (ReactCountryFlag);

//# sourceMappingURL=react-country-flag.esm.js.map

;// CONCATENATED MODULE: ../elements/lib/helpers/navbarItemsRender.js
const formatItem = (item, pages) => {
    const page = pages?.find((p) => p.id === item.page);
    const pageData = page?.data.find((d) => d.id === item.pageDataId);
    if (!pageData && item.type === "page")
        return;
    return {
        id: item.id,
        name: item.type === "page" ? pageData?.name : item.text,
        ...(item.type === "page" && {
            href: pageData?.path === "/"
                ? `/${pageData.language.code.toLowerCase()}`
                : `/${pageData.language.code.toLowerCase()}${pageData.path}`,
            type: "link",
        }),
    };
};
const navbarItemsRender = (items, pages) => {
    return items
        .filter((i) => i.parent === 0)
        .map((i) => {
        return {
            ...formatItem(i, pages),
            items: items
                .filter((childItem) => childItem.parent === i.id)
                .map((childItem) => formatItem(childItem, pages)),
        };
    });
};
/* harmony default export */ var helpers_navbarItemsRender = (navbarItemsRender);
//# sourceMappingURL=navbarItemsRender.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Navbar/NavbarDefault.js















const navbarConfig = [
    { type: SideEditOptions.Menu },
    {
        type: SideEditOptions.Select,
        config: {
            key: "navbar-location",
            label: "Navbar locatie",
            defaultValue: "top",
            open: false,
            selectOptions: [
                {
                    value: "top",
                    label: "Altijd boven",
                },
                {
                    value: "sticky",
                    label: "Meebewegen met scrollen",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "menu-location",
            label: "Menu locatie",
            defaultValue: "justify-start",
            open: false,
            selectOptions: [
                {
                    value: "justify-start",
                    label: "Links",
                },
                {
                    value: "justify-center",
                    label: "Midden",
                },
                {
                    value: "justify-end",
                    label: "Rechts",
                },
            ],
        },
    },
    {
        type: SideEditOptions.TextColor,
        config: {
            key: "text-color",
            valueKey: "textColor",
            defaultValue: "text-white",
            label: "Tekst kleur",
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "bg-active-item",
            valueKey: "backgroundColor",
            defaultValue: "bg-site-400",
            label: "Kleur active item",
        },
    },
    {
        type: SideEditOptions.TextColor,
        config: {
            key: "text-active-color",
            valueKey: "textColor",
            defaultValue: "text-white",
            label: "Tekst active item kleur",
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "language-bg-color",
            valueKey: "backgroundColor",
            defaultValue: "bg-site-400",
            label: "Kleur taal button",
        },
    },
];
const LanguagePicker = ({ renderElement }) => {
    const { languages, locale } = useSite();
    const localeMapper = {
        EN: "GB",
    };
    if (languages.length === 0)
        return null;
    return ((0,jsx_runtime.jsxs)(it, { as: "div", className: "relative inline-block text-left", children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsx)(it.Button, { as: "div", "editor-focuskey": "language-1", className: classNames("ml-4 flex h-[36px] cursor-pointer items-center justify-center  rounded-md px-3 py-2 ", renderElement.renderProp("menu-1", "language-bg-color")
                        ?.backgroundColor || "bg-site-400"), children: (0,jsx_runtime.jsx)(react_country_flag_esm, { countryCode: localeMapper[locale?.toUpperCase()] || locale?.toUpperCase(), style: { width: 24 }, svg: true }) }) }), (0,jsx_runtime.jsx)($e, { as: react.Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95", children: (0,jsx_runtime.jsx)(it.Items, { className: "absolute right-0 z-10 mt-2 flex origin-top-right rounded-md bg-white p-2 pl-3 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: (0,jsx_runtime.jsx)("div", { className: "py-1", children: languages
                            .filter((l) => l.code.toLowerCase() !== locale)
                            .map((language) => ((0,jsx_runtime.jsx)(it.Item, { children: ({ active }) => ((0,jsx_runtime.jsx)(Common_Link, { href: `/${language.code.toLowerCase()}`, className: classNames(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "-2 block rounded-md p-2"), children: (0,jsx_runtime.jsx)(react_country_flag_esm, { countryCode: localeMapper[language.code] || language.code, style: { width: 14 }, svg: true, alt: localeMapper[language.code] || language.code }) })) }, language.id))) }) }) })] }));
};
const NavbarItemDesktop = ({ item, activePage, renderElement }) => {
    if (item.items.length > 0) {
        return ((0,jsx_runtime.jsxs)(it, { as: "div", className: "relative inline-block text-left", children: [(0,jsx_runtime.jsx)("div", { children: (0,jsx_runtime.jsxs)(it.Button, { className: classNames(item.href === activePage
                            ? `${renderElement.renderProp("menu-1", "bg-active-item")
                                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                                ?.textColor || "text-white"}`
                            : `${renderElement.renderProp("menu-1", "text-color")
                                ?.textColor || "text-black"} opacity-80 hover:opacity-100`, "flex justify-center rounded-md px-3 py-2 "), children: [(0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }), (0,jsx_runtime.jsx)(ChevronDownIcon, { className: "-mr-1 ml-2 h-5 w-5", "aria-hidden": "true" })] }) }), (0,jsx_runtime.jsx)($e, { as: react.Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95", children: (0,jsx_runtime.jsx)(it.Items, { className: "absolute right-0 z-10  mt-2 w-56 origin-top-right rounded-md bg-white p-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: (0,jsx_runtime.jsx)("div", { className: "py-1", children: item.items.map((subItem) => ((0,jsx_runtime.jsx)(it.Item, { children: ({ active }) => ((0,jsx_runtime.jsx)(Common_Link, { href: subItem.href, className: classNames(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "block rounded-md px-4 py-2"), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", children: subItem.name }) })) }))) }) }) })] }));
    }
    return ((0,jsx_runtime.jsx)(Common_Link, { href: item.href, className: classNames(item.href === activePage
            ? `${renderElement.renderProp("menu-1", "bg-active-item")
                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                ?.textColor || "text-white"}`
            : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                "text-black"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2"), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }) }, item.id));
};
const NavbarItemMobile = ({ item, activePage, elementProps }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const [activeSub, setActiveSub] = (0,react.useState)(false);
    if (item.items?.length > 0) {
        return ((0,jsx_runtime.jsxs)("div", { className: "relative inline-block text-left", children: [(0,jsx_runtime.jsxs)("div", { onClick: () => setActiveSub(!activeSub), className: classNames(item.href === activePage
                        ? `${renderElement.renderProp("menu-1", "bg-active-item")
                            ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                            ?.textColor || "text-white"}`
                        : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                            "text-black"} opacity-80 hover:opacity-100`, "flex rounded-md px-3 py-2 "), children: [(0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }), (0,jsx_runtime.jsx)(ChevronDownIcon, { className: "-mr-1 ml-2 h-5 w-5", "aria-hidden": "true" })] }), activeSub && ((0,jsx_runtime.jsx)("div", { className: "flex flex-col py-1", children: item.items.map((subItem) => ((0,jsx_runtime.jsx)(ve.Button, { as: Common_Link, href: subItem.href, className: classNames(item.href === activePage
                            ? `${renderElement.renderProp("menu-1", "text-active-item")
                                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                                ?.textColor || "text-white"}`
                            : `${renderElement.renderProp("menu-1", "text-color")
                                ?.textColor || "text-black"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2 "), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", children: subItem.name }) }, subItem.id))) }))] }));
    }
    return ((0,jsx_runtime.jsx)(ve.Button, { as: Common_Link, href: item.href, className: classNames(item.href === activePage
            ? `${renderElement.renderProp("menu-1", "text-active-item")
                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                ?.textColor || "text-white"}`
            : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                "text-white"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2 "), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", children: item.name }) }, item.id));
};
const NavbarDefault = ({ menus, pages, activePage, elementId, elementProps, }) => {
    const { mode } = useEditor();
    const { locale } = useSite();
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const menu = menus?.find((m) => m.id === renderElement.renderMenu("menu-1")?.selected);
    const items = menu ? JSON.parse(menu.items) : [];
    const navbarItems = helpers_navbarItemsRender(items, pages);
    renderElement.renderProp("menu-1", "menu-location")?.value;
    return ((0,jsx_runtime.jsx)(ve, { as: "div", "editor-key": "container-1", ...renderElement.renderClassName("container-1", "", {
            backgroundColor: "bg-site-500",
        }, renderElement.renderProp("menu-1", "navbar-location")?.value ===
            "sticky"
            ? "sticky z-10 w-full border-b top-0"
            : ""), "editor-elementid": elementId, children: ({ open }) => ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)("div", { className: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8", children: (0,jsx_runtime.jsxs)("div", { className: "relative flex h-16 items-center justify-between", "editor-focuskey": "container-1", children: [(0,jsx_runtime.jsx)("div", { className: "absolute inset-y-0 left-0 flex items-center sm:hidden", children: (0,jsx_runtime.jsxs)(ve.Button, { className: `text-white-100/80 inline-flex items-center justify-center rounded-md p-2  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`, children: [(0,jsx_runtime.jsx)("span", { className: "sr-only", children: "Open main menu" }), open ? ((0,jsx_runtime.jsx)(outline_XMarkIcon, { className: `block h-6 w-6 ${renderElement.renderProp("menu-1", "text-color")
                                                ?.textColor || "text-white"}`, "aria-hidden": "true" })) : ((0,jsx_runtime.jsx)(Bars3Icon, { className: `block h-6 w-6 ${renderElement.renderProp("menu-1", "text-color")
                                                ?.textColor || "text-black"}`, "aria-hidden": "true" }))] }) }), (0,jsx_runtime.jsxs)("div", { className: "flex flex-1 items-center justify-center sm:items-stretch sm:justify-start", children: [(0,jsx_runtime.jsx)("div", { className: `flex flex-shrink-0 items-center`, children: (0,jsx_runtime.jsx)("div", { className: "md:w-24", children: (0,jsx_runtime.jsx)(Common_Link, { href: `/${locale}`, children: (0,jsx_runtime.jsx)("img", { "editor-key": "logo-1", ...renderElement.renderClassName("logo-1", "block h-8 w-auto"), ...renderElement.renderImage("logo-1", {
                                                        src: "https://tailwindui.com/img/logos/mark.svg?color=white",
                                                    }) }) }) }) }), (0,jsx_runtime.jsx)("div", { className: `hidden w-full items-center ${renderElement.renderProp("menu-1", "menu-location")
                                            ?.value || "justify-center"} sm:ml-6 sm:flex`, children: (0,jsx_runtime.jsxs)("div", { className: `flex  space-x-4`, "editor-key": "menu-1", "editor-menu-selected": renderElement.renderMenu("menu-1").selected, ...renderElement.renderAttributeOptions(navbarConfig, "menu-1"), children: [navbarItems.length === 0 && mode === "editor" && ((0,jsx_runtime.jsx)("div", { className: "rounded-md bg-black/40 p-2 text-white", children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": "menu-1", children: "Selecteer een menu" }) })), navbarItems?.map((item) => ((0,jsx_runtime.jsx)(NavbarItemDesktop, { item: item, activePage: activePage, renderElement: renderElement }, item.id)))] }) }), (0,jsx_runtime.jsx)("div", { className: "hidden items-center md:flex", children: (0,jsx_runtime.jsx)(LanguagePicker, { renderElement: renderElement }) })] })] }) }), (0,jsx_runtime.jsxs)(ve.Panel, { className: "sm:hidden", children: [(0,jsx_runtime.jsx)("div", { className: "flex flex-col space-y-1 px-2 pb-3 pt-2", children: navbarItems?.map((item) => ((0,jsx_runtime.jsx)(NavbarItemMobile, { item: item, activePage: activePage, elementProps: elementProps }, item.name))) }), (0,jsx_runtime.jsx)("div", { className: "block py-4 md:hidden", children: (0,jsx_runtime.jsx)(LanguagePicker, { renderElement: renderElement }) })] })] })) }));
};
/* harmony default export */ var Navbar_NavbarDefault = (NavbarDefault);
//# sourceMappingURL=NavbarDefault.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/PlusSmallIcon.js
var PlusSmallIcon = __webpack_require__(88519);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/MinusSmallIcon.js
var MinusSmallIcon = __webpack_require__(58946);
;// CONCATENATED MODULE: ../elements/lib/helpers/removePTag.js
/* harmony default export */ var removePTag = ((text) => text?.replace(/<[\/]{0,1}(p)[^><]*>/g, ""));
//# sourceMappingURL=removePTag.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/Repeatable/RepeatableCenteredAccordion.js










const elementConfig = [
    {
        type: SideEditOptions.Repeatable,
        config: {
            key: "repeatable",
            label: "Repeatable instellen",
            valueKey: "id",
            open: true,
            repeatableOptions: [
                { key: "title", label: "Titel" },
                { key: "description", label: "Beschrijving" },
            ],
        },
    },
];
const RepeatableCenteredAccordion = ({ elementId, elementProps, editable, repeatables }) => {
    const { locale } = useSite();
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const repeatableId = renderElement.renderProp("content-1", "repeatable")?.id;
    const [items, setItems] = (0,react.useState)(null);
    (0,react.useEffect)(() => {
        const renderElementHook = helpers_RenderElement.setProps(elementProps);
        const repeatable = repeatables.find((r) => r.id === repeatableId) || [];
        setItems(repeatable?.items?.map((item, key) => ({
            id: key,
            title: item.values.find((v) => v.field_id ===
                renderElementHook.renderProp("content-1", "repeatable-title") &&
                v.language.code.toLowerCase() === locale)?.value,
            description: item.values.find((v) => v.field_id ===
                renderElementHook.renderProp("content-1", "repeatable-description") && v.language.code.toLowerCase() === locale)?.value,
        })) || []);
    }, [elementProps, repeatables, repeatableId]);
    return ((0,jsx_runtime.jsx)(Common_ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, children: (0,jsx_runtime.jsx)(Common_Container, { focusKey: "container-1", children: (0,jsx_runtime.jsx)("div", { className: "mx-auto max-w-3xl divide-y divide-gray-900/10", children: (0,jsx_runtime.jsxs)("dl", { className: "space-y-6 divide-y divide-gray-900/10 pb-6", "editor-key": "content-1", ...renderElement.renderAttributeOptions(elementConfig, "content-1"), children: [!repeatableId && editable && ((0,jsx_runtime.jsx)("div", { "editor-focuskey": "content-1", className: "focus:ring-site-500 relative mt-6 block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2", children: (0,jsx_runtime.jsx)("span", { className: "mt-2 block text-sm font-medium text-gray-900", children: "Selecteer een repeatable" }) })), items &&
                            [...items].map((item) => ((0,jsx_runtime.jsx)(ve, { as: "div", className: "pt-6", children: ({ open }) => ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)("dt", { "editor-focuskey": "content-1", children: (0,jsx_runtime.jsxs)(ve.Button, { className: "flex w-full items-start justify-between text-left text-gray-900", children: [(0,jsx_runtime.jsx)("span", { className: "text-base font-semibold leading-7", "editor-focuskey": "content-1", children: removePTag(item?.title) }), (0,jsx_runtime.jsx)("span", { className: "ml-6 flex h-7 items-center", children: open ? ((0,jsx_runtime.jsx)(PlusSmallIcon, { className: "h-6 w-6", "aria-hidden": "true" })) : ((0,jsx_runtime.jsx)(MinusSmallIcon, { className: "h-6 w-6", "aria-hidden": "true" })) })] }) }), (0,jsx_runtime.jsx)(ve.Panel, { as: "dd", className: "mt-2 pr-12", "editor-focuskey": "content-1", children: (0,jsx_runtime.jsx)("div", { className: "text-base leading-7 text-gray-600", dangerouslySetInnerHTML: {
                                                    __html: removePTag(item?.description),
                                                } }) })] })) }, item?.id)))] }) }) }) }));
};
/* harmony default export */ var Repeatable_RepeatableCenteredAccordion = (RepeatableCenteredAccordion);
//# sourceMappingURL=RepeatableCenteredAccordion.js.map
;// CONCATENATED MODULE: ../elements/lib/types/propOptions.js
var PropImageLocation;
(function (PropImageLocation) {
    PropImageLocation["Left"] = "left";
    PropImageLocation["Right"] = "right";
})(PropImageLocation || (PropImageLocation = {}));
var PropImagePosition;
(function (PropImagePosition) {
    PropImagePosition["Left"] = "left";
    PropImagePosition["Right"] = "right";
    PropImagePosition["Top"] = "top";
    PropImagePosition["Bottom"] = "bottom";
    PropImagePosition["Center"] = "center";
})(PropImagePosition || (PropImagePosition = {}));
var NavbarItemType;
(function (NavbarItemType) {
    NavbarItemType["Link"] = "link";
})(NavbarItemType || (NavbarItemType = {}));
//# sourceMappingURL=propOptions.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/TextImage.js






const imgConfig = [
    {
        type: SideEditOptions.Select,
        config: {
            key: "img-location",
            label: "Afbeelding locatie",
            defaultValue: "object-center",
            open: false,
            selectOptions: [
                {
                    value: "object-left",
                    label: "Links",
                },
                {
                    value: "object-right",
                    label: "Rechts",
                },
                {
                    value: "object-top",
                    label: "Boven",
                },
                {
                    value: "object-bottom",
                    label: "Beneden",
                },
                {
                    value: "object-center",
                    label: "Center",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "img-position",
            label: "Afbeelding positie",
            defaultValue: PropImagePosition.Left,
            open: false,
            selectOptions: [
                {
                    value: PropImagePosition.Left,
                    label: "Links",
                },
                {
                    value: PropImagePosition.Right,
                    label: "Rechts",
                },
            ],
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "backgroundcolor",
            valueKey: "backgroundColor",
            defaultValue: "bg-white",
            label: "Achtergrond kleur",
        },
    },
];
const TextImage = ({ elementId, elementProps }) => {
    const renderElement = helpers_RenderElement.setProps(elementProps);
    const imageLocation = renderElement.renderProp("img-1", "img-location")?.value;
    const imagePosition = renderElement.renderProp("img-1", "img-position")?.value;
    const containerBgRender = renderElement.renderProp("img-1", "backgroundcolor");
    return ((0,jsx_runtime.jsxs)("div", { "editor-elementid": elementId, "editor-key": "container-1", ...renderElement.renderClassName("container-1", "relative", {
            backgroundColor: containerBgRender?.backgroundColor || "bg-white",
        }), children: [(0,jsx_runtime.jsx)("div", { className: "lg:absolute lg:inset-0", children: (0,jsx_runtime.jsx)("div", { className: `lg:absolute lg:inset-y-0 ${imagePosition === "right" ? "right-0" : "left-0"} lg:w-1/2`, children: (0,jsx_runtime.jsx)("img", { "editor-key": "img-1", ...renderElement.renderClassName("img-1", `h-56 w-full object-cover ${imageLocation || "object-center"} lg:absolute lg:h-full`), ...renderElement.renderImage("img-1"), ...renderElement.renderAttributeOptions(imgConfig, "img-1") }) }) }), (0,jsx_runtime.jsx)("div", { className: "relative px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8", "editor-focuskey": "img-1", children: (0,jsx_runtime.jsx)("div", { className: `${imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2"} ${imagePosition === "right" ? "lg:pr-8" : "lg:pl-8"} `, children: (0,jsx_runtime.jsxs)("div", { className: `mx-auto max-w-prose text-base lg:max-w-lg lg:m${imagePosition === "right" ? "lg:ml-auto" : "lg:ml-auto"}-auto ${imagePosition === "right" ? "lg:ml-0" : "lg:m-0"}`, children: [(0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h2", "editor-key": "titleSmall-1", ...renderElement.renderClassName("titleSmall-1", `font-semibold uppercase leading-6 tracking-wide ${titleSmallPlaceholder.color}`), children: renderElement.renderText("titleSmall-1", titleSmallPlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { fontType: "heading", component: "h3", "editor-key": "title-1", ...renderElement.renderClassName("title-1", `mt-2 text-3xl font-extrabold leading-8 tracking-tight sm:text-4xl ${titlePlaceholder.color}`), children: renderElement.renderText("title-1", titlePlaceholder.value) }), (0,jsx_runtime.jsx)(Common_Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", `mt-8 text-lg prose ${textPlaceHolder.color}`), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }) }) })] }));
};
/* harmony default export */ var element_TextImage = (TextImage);
//# sourceMappingURL=TextImage.js.map
;// CONCATENATED MODULE: ../elements/lib/components/element/index.js












const element_elements = {
    "hero-header": element_HeroHeader,
    "text-image": element_TextImage,
    "navbar-default": Navbar_NavbarDefault,
    "footer-default": Footer_FooterDefault,
    "contact-centered": element_ContactCentered,
    "header-card-with-background-image": Header_CardWithBackgroundImage,
    "content-feature-list": Content_ContentFeatureList,
    "content-feature-box": Content_ContentFeatureBox,
    "content-text": Content_ContentText,
    "content-logos-simple": Content_LogosSimple,
    "header-heroheader-background": Header_HeroHeaderBackground,
    "repeatable-repeatable-centered-accordion": Repeatable_RepeatableCenteredAccordion,
};
/* harmony default export */ var components_element = (element_elements);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/CallToAction/HtmlCallToActionOne.js


const HtmlCallToActionOne = () => ((0,jsx_runtime.jsx)("section", { children: (0,jsx_runtime.jsx)("div", { className: "mx-auto max-w-7xl px-4 py-8 lg:px-6 lg:py-16", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-2xl text-center", children: [(0,jsx_runtime.jsx)("h2", { className: "poppins mb-3 text-left text-2xl font-extrabold leading-tight tracking-tight text-gray-900 sm:text-center sm:text-3xl md:text-4xl", children: "Start your free trial today" }), (0,jsx_runtime.jsx)("p", { className: "poppins mb-3 text-left text-sm font-normal text-gray-500 sm:mb-8 sm:text-center sm:text-base md:text-lg", children: "Start crafting the landing page of your dreams. No credit card required." }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, className: "poppins bg-site-700 hover:bg-site-800 focus:ring-site-300 mb-2 mr-2 block w-full rounded px-5 py-3 text-sm font-bold text-white focus:outline-none focus:ring-4 sm:inline-block sm:w-auto", children: "Get Started Today" })] }) }) }));
/* harmony default export */ var CallToAction_HtmlCallToActionOne = (HtmlCallToActionOne);
//# sourceMappingURL=HtmlCallToActionOne.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/ContentTwoColumns.js


function ContentTwoColumns() {
    return ((0,jsx_runtime.jsx)("div", { className: "overflow-hidden bg-white px-6 py-16 lg:px-8 xl:py-36", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-max lg:max-w-7xl", children: [(0,jsx_runtime.jsx)("div", { className: "relative z-10 mb-8 md:mb-2 md:px-6", children: (0,jsx_runtime.jsxs)("div", { className: "max-w-prose text-base lg:max-w-none", children: [(0,jsx_runtime.jsx)("h2", { className: "text-site-600 font-semibold leading-6", children: titlePlaceholder.value }), (0,jsx_runtime.jsx)("p", { className: "mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl", children: titleSmallPlaceholder.value })] }) }), (0,jsx_runtime.jsx)("div", { className: "relative", children: (0,jsx_runtime.jsx)("div", { className: "relative md:p-6", children: (0,jsx_runtime.jsxs)("div", { className: "lg:grid lg:grid-cols-2 lg:gap-6", children: [(0,jsx_runtime.jsx)("article", { className: "prose prose-lg prose-indigo text-gray-500 lg:max-w-none", children: (0,jsx_runtime.jsx)("p", { children: textPlaceHolder.value }) }), (0,jsx_runtime.jsx)("article", { className: "prose prose-lg prose-indigo mt-6 text-gray-500 lg:mt-0", children: (0,jsx_runtime.jsx)("p", { children: textPlaceHolder.value }) })] }) }) })] }) }));
}
//# sourceMappingURL=ContentTwoColumns.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentFive.js


const HtmlContentFive = () => {
    return ((0,jsx_runtime.jsx)("section", { className: "flex items-center justify-center bg-white py-10 text-white sm:py-16 md:py-24 lg:py-32", children: (0,jsx_runtime.jsxs)("div", { className: "auto relative max-w-3xl px-10 text-center text-white lg:px-0", children: [(0,jsx_runtime.jsxs)("div", { className: "flex w-full flex-col md:flex-row", children: [(0,jsx_runtime.jsx)("div", { className: "flex justify-between", children: (0,jsx_runtime.jsx)("h1", { className: "relative flex flex-col text-left text-6xl font-extrabold text-black", children: "Crafting" }) }), (0,jsx_runtime.jsx)("div", { className: "relative right-0 top-0 mt-12 h-64 md:absolute md:-mt-16 md:h-96", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/december2020/designs3d.png", className: "mr-5 mt-3 h-80 object-cover lg:h-96", ...renderHtmlImageProps }) })] }), (0,jsx_runtime.jsx)("div", { className: "my-16 border-b border-gray-300 lg:my-24" }), (0,jsx_runtime.jsx)("h2", { className: "text-left text-gray-500 xl:text-xl", children: "Building beautiful designs for your next project. We've unlocked the secret to converting visitors into customers. Download our re-usable and extandable components today." })] }) }));
};
/* harmony default export */ var Content_HtmlContentFive = (HtmlContentFive);
//# sourceMappingURL=HtmlContentFive.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentFour.js


const HtmlContentFour = () => {
    return ((0,jsx_runtime.jsx)("section", { className: "relative bg-white", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-2xl px-12 lg:max-w-7xl", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center py-12 sm:py-12 lg:flex-row xl:py-16", children: [(0,jsx_runtime.jsx)("div", { className: "mb-16 w-full sm:px-7 lg:mb-0 lg:w-1/2 lg:px-0 lg:pl-0 xl:pl-10", children: (0,jsx_runtime.jsxs)("div", { className: "relative", children: [(0,jsx_runtime.jsx)("h2", { className: "mb-5 text-3xl font-bold leading-tight text-gray-800 md:text-4xl md:leading-tight lg:leading-tight xl:mb-12 xl:text-5xl", children: "Expertly Crafted" }), (0,jsx_runtime.jsxs)("div", { className: "mb-6 flex lg:pr-12 xl:pr-0", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-indigo-500 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Latest version of TailwindCSS" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "Our components are coded with the latest version of Tailwind, giving you the latest and greatest." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "mb-6 flex lg:pr-12 xl:pr-0", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-indigo-500 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Formatted HTML Code" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "Each of our templates have been formatted and structured with the best possible organization." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "flex lg:pr-12 xl:pr-0", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-indigo-500 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Easy to Integrate in Your App" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "You can easily integrate our components and themes into any of your applications or websites." })] })] })] }) }), (0,jsx_runtime.jsx)("div", { className: "h-full w-full lg:w-1/2", children: (0,jsx_runtime.jsx)("div", { className: "h-full w-full rounded-2xl border-b-4 border-r-4 border-blue-200 bg-gradient-to-br from-blue-100 to-indigo-200 p-20 shadow-sm", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/february2022/computers-3d.png", className: "", ...renderHtmlImageProps }) }) })] }), (0,jsx_runtime.jsxs)("div", { className: "flex flex-col-reverse items-center justify-center pb-12 lg:flex-row xl:pb-16", children: [(0,jsx_runtime.jsx)("div", { className: "mb-16 w-full lg:mb-0 lg:w-1/2 lg:px-0", children: (0,jsx_runtime.jsx)("div", { className: "h-full w-full rounded-2xl border-b-4 border-r-4 border-pink-200 bg-gradient-to-br from-red-100 to-pink-200 p-20 pb-0 shadow-sm", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/february2022/phone-3d.png", className: "", ...renderHtmlImageProps }) }) }), (0,jsx_runtime.jsx)("div", { className: "mb-16 ml-0 w-full sm:px-5 sm:pl-8 lg:mb-0 lg:w-1/2 xl:pl-20", children: (0,jsx_runtime.jsxs)("div", { className: "relative", children: [(0,jsx_runtime.jsx)("h2", { className: "mb-5 text-3xl font-bold leading-tight md:text-4xl md:leading-tight lg:leading-tight xl:mb-12 xl:text-5xl", children: "Clean Designs" }), (0,jsx_runtime.jsxs)("div", { className: "mb-6 flex", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-pink-400 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Mobile Optimized Templates" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "All templates will look good on any device. Every break point has been designed to look nice." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "mb-6 flex", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-pink-400 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Easily Configurable and Editable" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "You can configure any section of the template to make it fit the needs of your application." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "flex", children: [(0,jsx_runtime.jsx)("svg", { className: "-mt-0.5 mr-3 h-8 w-8 flex-shrink-0 text-pink-400 xl:mr-5", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "fill-rule": "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", "clip-rule": "evenodd" }) }), (0,jsx_runtime.jsxs)("div", { className: "max-w-md lg:max-w-sm", children: [(0,jsx_runtime.jsx)("h3", { className: "-mt-1 mb-2 text-xl font-semibold text-gray-700 md:text-xl", children: "Fast and SEO Friendly" }), (0,jsx_runtime.jsx)("p", { className: "leading-loose text-gray-400", children: "All the images and formats have been optimized efficiently, making it fast and SEO friendly." })] })] })] }) })] })] }) }));
};
/* harmony default export */ var Content_HtmlContentFour = (HtmlContentFour);
//# sourceMappingURL=HtmlContentFour.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentOne.js


const HtmlContentOne = () => ((0,jsx_runtime.jsxs)("div", { className: "w-full bg-white pb-7 pt-7 md:pb-24 md:pt-20", children: [(0,jsx_runtime.jsxs)("div", { className: "mx-auto box-border flex max-w-7xl flex-col content-center items-center border-0 border-solid border-gray-300 px-8 leading-6 text-black md:flex-row lg:px-16", children: [(0,jsx_runtime.jsx)("div", { className: "relative -ml-5 mb-4 mt-5 box-border w-full max-w-md border-solid bg-contain bg-no-repeat px-4 text-center md:ml-0 md:mt-0 md:w-1/2 md:max-w-none lg:mb-0 xl:pl-10", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/december2020/productivity.png", className: "p-2 pl-6 pr-5 xl:pl-16 xl:pr-20", ...renderHtmlImageProps }) }), (0,jsx_runtime.jsxs)("div", { className: "order-first box-border w-full border-solid text-black md:order-none md:w-1/2 md:pl-10", children: [(0,jsx_runtime.jsxs)("article", { className: "prose", children: [(0,jsx_runtime.jsx)("h2", { className: "m-0 border-0 border-gray-300 text-xl font-semibold leading-tight md:text-2xl lg:text-3xl", children: "Boost Productivity" }), (0,jsx_runtime.jsx)("p", { className: "m-0 border-0 border-gray-300 pb-8 pt-4 leading-7 text-gray-700 sm:pr-12 lg:text-lg xl:pr-32", children: "Build an atmosphere that creates productivity in your organization and your company culture." })] }), (0,jsx_runtime.jsxs)("ul", { className: "m-0 border-0 border-gray-300 p-0 leading-6", children: [(0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Maximize productivity and growth"] }), (0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Speed past your competition"] }), (0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Learn the top techniques"] })] })] })] }), (0,jsx_runtime.jsxs)("div", { className: "mx-auto mt-2 box-border flex max-w-7xl flex-col content-center items-center border-0 border-solid border-gray-300 px-8 leading-6 text-black md:mt-20 md:flex-row lg:px-16 xl:mt-0", children: [(0,jsx_runtime.jsxs)("div", { className: "box-border w-full border-solid text-black md:w-1/2 md:pl-6 xl:pl-32", children: [(0,jsx_runtime.jsxs)("article", { className: "prose", children: [(0,jsx_runtime.jsx)("h2", { className: "m-0 border-0 border-gray-300 text-xl font-semibold leading-tight md:text-2xl lg:text-3xl", children: "Boost Productivity" }), (0,jsx_runtime.jsx)("p", { className: "m-0 border-0 border-gray-300 pb-8 pt-4 leading-7 text-gray-700 sm:pr-12 lg:text-lg xl:pr-32", children: "Build an atmosphere that creates productivity in your organization and your company culture." })] }), (0,jsx_runtime.jsxs)("ul", { className: "m-0 border-0 border-gray-300 p-0 leading-6", children: [(0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Automated task management workflow"] }), (0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Detailed analytics for your data"] }), (0,jsx_runtime.jsxs)("li", { className: "relative box-border border-solid py-1 pl-0 text-left text-gray-500", children: [(0,jsx_runtime.jsx)("span", { className: "mr-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-yellow-300 text-white", children: (0,jsx_runtime.jsx)("span", { className: "text-sm font-bold", children: "\u2713" }) }), "Some awesome integrations"] })] })] }), (0,jsx_runtime.jsx)("div", { className: "relative mb-4 mt-10 box-border w-full max-w-md border-solid bg-contain bg-no-repeat px-4 text-center md:mt-0 md:w-1/2 md:max-w-none lg:mb-0", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/december2020/settings.png", className: "pl-4 sm:pr-10 lg:pr-32 xl:pl-10", ...renderHtmlImageProps }) })] })] }));
/* harmony default export */ var Content_HtmlContentOne = (HtmlContentOne);
//# sourceMappingURL=HtmlContentOne.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentThree.js


const HtmlContentThree = () => {
    return ((0,jsx_runtime.jsx)("section", { className: "w-full bg-white", children: (0,jsx_runtime.jsx)("div", { className: "ml-auto mr-auto max-w-7xl px-10 pb-16 pt-16 md:px-24 lg:px-12 lg:py-20", children: (0,jsx_runtime.jsxs)("div", { className: "grid gap-5 lg:grid-cols-2", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col justify-center md:pr-8 lg:max-w-lg xl:pr-0", children: [(0,jsx_runtime.jsx)("div", { className: "mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-500", children: (0,jsx_runtime.jsx)("svg", { className: "h-10 w-10 text-white", fill: "currentColor", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z", className: "" }) }) }), (0,jsx_runtime.jsxs)("div", { className: "mb-6 max-w-xl", children: [(0,jsx_runtime.jsxs)("div", { className: "mb-6", children: [(0,jsx_runtime.jsxs)("p", { className: "inline font-sans text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl sm:leading-none", children: ["Beautiful designs", " "] }), (0,jsx_runtime.jsx)("p", { className: "block font-sans text-5xl font-bold tracking-tight text-purple-700 sm:text-6xl sm:leading-none", children: "to help you shine." })] }), (0,jsx_runtime.jsx)("p", { className: "text-base text-gray-700 md:text-lg", children: "We have hand-crafted beautiful designs that will help your product or service shine. Drag'n drop templates that allow you to build amazing landing pages in seconds!" })] })] }), (0,jsx_runtime.jsxs)("div", { className: "flex w-full justify-center lg:items-center", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-end pr-3", children: [(0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/july2021/content-19-1.jpg", className: "mb-6 h-full w-full rounded object-cover shadow-lg lg:h-48 lg:w-48 xl:h-56 xl:w-56", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/july2021/content-19-2.jpg", className: "h-full w-full rounded object-cover shadow-lg lg:h-32 lg:w-32 xl:h-40 xl:w-40", ...renderHtmlImageProps })] }), (0,jsx_runtime.jsx)("div", { className: "pl-3", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/july2021/content-19-3.jpg", className: "h-full w-full rounded object-cover shadow-lg lg:h-64 lg:w-64 xl:h-80 xl:w-80", ...renderHtmlImageProps }) })] })] }) }) }));
};
/* harmony default export */ var Content_HtmlContentThree = (HtmlContentThree);
//# sourceMappingURL=HtmlContentThree.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentTitleText.js


const HtmlContentTitleText = () => {
    return ((0,jsx_runtime.jsx)("div", { className: "bg-white px-6 py-32 lg:px-8", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-3xl text-base leading-7 text-gray-700", children: [(0,jsx_runtime.jsx)("p", { className: "text-site-600 text-base font-semibold leading-7", children: titleSmallPlaceholder.value }), (0,jsx_runtime.jsx)("h1", { className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: titlePlaceholder.value }), (0,jsx_runtime.jsx)("article", { className: "prose mt-4 max-w-2xl", children: (0,jsx_runtime.jsx)("p", { children: "Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor praesent donec est. Odio penatibus risus viverra tellus varius sit neque erat velit. Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae sed turpis id." }) })] }) }));
};
/* harmony default export */ var Content_HtmlContentTitleText = (HtmlContentTitleText);
//# sourceMappingURL=HtmlContentTitleText.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlContentTwo.js


const HtmlContentTwo = () => {
    return ((0,jsx_runtime.jsxs)("section", { className: "flex w-full flex-col bg-black md:flex-row", children: [(0,jsx_runtime.jsxs)("div", { className: "flex w-full flex-col items-center justify-center p-10 md:w-1/2 lg:p-16 xl:p-24", children: [(0,jsx_runtime.jsx)("h2", { className: "max-w-lg text-4xl font-light leading-tight text-white md:text-3xl lg:text-4xl xl:text-5xl", children: "We have the tools you need to succeed" }), (0,jsx_runtime.jsx)("p", { className: "mt-5 max-w-lg text-xl text-gray-500 md:text-base lg:text-xl", children: "Our powerful and revolutionary tools are designed to help your business thrive." })] }), (0,jsx_runtime.jsx)("div", { className: "w-full md:w-1/2", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/november2020/tools-bg.jpeg?q=75&auto=format", className: "inset-0 object-cover", ...renderHtmlImageProps }) })] }));
};
/* harmony default export */ var Content_HtmlContentTwo = (HtmlContentTwo);
//# sourceMappingURL=HtmlContentTwo.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Content/HtmlTitleSimple.js


const HtmlTitleSimple = () => {
    return ((0,jsx_runtime.jsx)("div", { className: "bg-white py-16", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto box-border w-full px-10 text-black sm:text-center", children: [(0,jsx_runtime.jsx)("h3", { className: "mb-1 text-xl font-black uppercase text-gray-500", children: titleSmallPlaceholder.value }), (0,jsx_runtime.jsx)("h2", { className: "font-heading text-5xl font-black text-black sm:text-6xl", children: titlePlaceholder.value })] }) }));
};
/* harmony default export */ var Content_HtmlTitleSimple = (HtmlTitleSimple);
//# sourceMappingURL=HtmlTitleSimple.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Feature/HtmlFeatureOne.js

const HtmlFeatureOne = () => ((0,jsx_runtime.jsx)("div", { className: "bg-white py-20", children: (0,jsx_runtime.jsxs)("div", { className: "container mx-auto max-w-6xl", children: [(0,jsx_runtime.jsx)("h2", { className: "text-center text-4xl font-bold tracking-tight", children: "Our Features" }), (0,jsx_runtime.jsx)("p", { className: "mt-2 text-center text-lg text-gray-600", children: "Check out our list of awesome features below." }), (0,jsx_runtime.jsxs)("div", { className: "mt-10 grid grid-cols-4 gap-8 sm:grid-cols-8 sm:px-8 lg:grid-cols-12 xl:px-0", children: [(0,jsx_runtime.jsxs)("div", { className: "relative col-span-4 flex flex-col items-center justify-between space-y-4 overflow-hidden bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }), (0,jsx_runtime.jsx)("path", { d: "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5" }), (0,jsx_runtime.jsx)("circle", { cx: "6", cy: "14", r: "3" }), (0,jsx_runtime.jsx)("path", { d: "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Certifications" }), (0,jsx_runtime.jsx)("p", { className: "text-center text-base text-gray-500", children: "Each of our plan will provide you and your team with certifications." })] }), (0,jsx_runtime.jsxs)("div", { className: "col-span-4 flex flex-col items-center justify-between space-y-4 bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("path", { d: "M18 8a3 3 0 0 1 0 6" }), (0,jsx_runtime.jsx)("path", { d: "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5" }), (0,jsx_runtime.jsx)("path", { d: "M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Notifications" }), (0,jsx_runtime.jsx)("p", { className: "prose text-center text-base text-gray-500", children: "Send out notifications to all your customers to keep them engaged." })] }), (0,jsx_runtime.jsxs)("div", { className: "col-span-4 flex flex-col items-center justify-between space-y-4 bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("polyline", { points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" }), (0,jsx_runtime.jsx)("line", { x1: "12", y1: "12", x2: "20", y2: "7.5" }), (0,jsx_runtime.jsx)("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), (0,jsx_runtime.jsx)("line", { x1: "12", y1: "12", x2: "4", y2: "7.5" }), (0,jsx_runtime.jsx)("line", { x1: "16", y1: "5.25", x2: "8", y2: "9.75" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Bundles" }), (0,jsx_runtime.jsx)("p", { className: "text-center text-base text-gray-500", children: "High-quality bundles of awesome tools to help you out." })] }), (0,jsx_runtime.jsxs)("div", { className: "col-span-4 flex flex-col items-center justify-between space-y-4 bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("path", { d: "M8 9l3 3l-3 3" }), (0,jsx_runtime.jsx)("line", { x1: "13", y1: "15", x2: "16", y2: "15" }), (0,jsx_runtime.jsx)("rect", { x: "3", y: "4", width: "18", height: "16", rx: "2" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Developer Tools" }), (0,jsx_runtime.jsx)("p", { className: "text-center text-base text-gray-500", children: "Developer tools to help grow your application and keep it up-to-date." })] }), (0,jsx_runtime.jsxs)("div", { className: "col-span-4 flex flex-col items-center justify-between space-y-4 bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("line", { x1: "9.5", y1: "11", x2: "9.51", y2: "11" }), (0,jsx_runtime.jsx)("line", { x1: "14.5", y1: "11", x2: "14.51", y2: "11" }), (0,jsx_runtime.jsx)("path", { d: "M9.5 15a3.5 3.5 0 0 0 5 0" }), (0,jsx_runtime.jsx)("path", { d: "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Building Blocks" }), (0,jsx_runtime.jsx)("p", { className: "text-center text-base text-gray-500", children: "The right kind of building blocks to take your company to the next level." })] }), (0,jsx_runtime.jsxs)("div", { className: "col-span-4 flex flex-col items-center justify-between space-y-4 bg-gray-100 px-8 py-12 sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: [(0,jsx_runtime.jsx)("div", { className: "bg-site-500 rounded-full p-3 text-white", "data-primary": "site-500", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-8 w-8 ", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", fill: "none", "stroke-linecap": "round", "stroke-linejoin": "round", "editor-icon": "true", children: [(0,jsx_runtime.jsx)("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), (0,jsx_runtime.jsx)("line", { x1: "15", y1: "5", x2: "15", y2: "7" }), (0,jsx_runtime.jsx)("line", { x1: "15", y1: "11", x2: "15", y2: "13" }), (0,jsx_runtime.jsx)("line", { x1: "15", y1: "17", x2: "15", y2: "19" }), (0,jsx_runtime.jsx)("path", { d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2" })] }) }), (0,jsx_runtime.jsx)("h4", { className: "text-xl font-medium text-gray-700", children: "Coupons" }), (0,jsx_runtime.jsx)("p", { className: "text-center text-base text-gray-500", children: "Coupons system to provide special offers and discounts for your app." })] })] })] }) }));
/* harmony default export */ var Feature_HtmlFeatureOne = (HtmlFeatureOne);
//# sourceMappingURL=HtmlFeatureOne.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Feature/HtmlFeatureTwo.js


const HtmlFeatureTwo = () => {
    return ((0,jsx_runtime.jsx)("section", { className: "relative border-solid bg-white leading-7 text-gray-900", children: (0,jsx_runtime.jsx)("div", { className: "mx-auto box-border max-w-7xl border-solid lg:pl-8", children: (0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center border-0 border-gray-200 leading-7 text-gray-900 lg:flex-row", children: [(0,jsx_runtime.jsxs)("div", { className: "box-border flex h-full w-full flex-col justify-center border-solid p-8 text-gray-900 md:p-16 lg:w-1/2 lg:p-0 lg:pl-10 lg:pr-20", children: [(0,jsx_runtime.jsx)("h2", { className: "m-0 text-left text-3xl font-medium leading-tight tracking-tight text-black sm:text-4xl md:text-5xl", children: "Why Choose Us" }), (0,jsx_runtime.jsx)("p", { className: "mt-2 border-0 border-gray-200 text-left text-xl sm:text-2xl", children: "We offer the best features in the industry." }), (0,jsx_runtime.jsxs)("div", { className: "mt-8 grid gap-4 border-0 border-gray-200 leading-7 sm:mt-10 sm:gap-6 lg:mt-12 lg:gap-8", children: [(0,jsx_runtime.jsxs)("div", { className: "box-border flex items-start border-solid text-gray-900", children: [(0,jsx_runtime.jsx)("div", { className: "flex h-12 w-12 items-center justify-center rounded-full border-0 border-gray-200 bg-blue-600 leading-7", "data-primary": "blue-600", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsx)("p", { className: "m-0 box-border border-solid text-xl text-white", children: (0,jsx_runtime.jsx)("svg", { className: "h-6 w-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" }) }) }) }), (0,jsx_runtime.jsxs)("div", { className: "ml-6 flex-1 border-0 border-gray-200 leading-7", children: [(0,jsx_runtime.jsx)("h3", { className: "m-0 box-border border-solid text-lg font-semibold leading-tight tracking-tight text-black sm:text-xl md:text-2xl", children: "Automated Tasks" }), (0,jsx_runtime.jsx)("p", { className: "mt-2 box-border border-solid text-base leading-normal text-gray-900", children: "No more wasting time on manual tasks, you can leverage our automated tasks to make your life easier." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "box-border flex items-start border-solid text-gray-900", children: [(0,jsx_runtime.jsx)("div", { className: "flex h-12 w-12 items-center justify-center rounded-full border-0 border-gray-200 bg-blue-600 leading-7", "data-primary": "blue-600", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsx)("p", { className: "m-0 box-border border-solid text-xl text-white", children: (0,jsx_runtime.jsx)("svg", { className: "h-6 w-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" }) }) }) }), (0,jsx_runtime.jsxs)("div", { className: "ml-6 flex-1 border-0 border-gray-200 leading-7", children: [(0,jsx_runtime.jsx)("h3", { className: "m-0 box-border border-solid text-lg font-semibold leading-tight tracking-tight text-black sm:text-xl md:text-2xl", children: "Email Campaigns" }), (0,jsx_runtime.jsx)("p", { className: "mt-2 box-border border-solid text-base leading-normal text-gray-900", children: "Utilize our email campaigns to send your users up-to-date information about your product and services." })] })] }), (0,jsx_runtime.jsxs)("div", { className: "box-border flex items-start border-solid text-gray-900", children: [(0,jsx_runtime.jsx)("div", { className: "flex h-12 w-12 items-center justify-center rounded-full border-0 border-gray-200 bg-blue-600 leading-7", "data-primary": "blue-600", "data-rounded": "rounded-full", children: (0,jsx_runtime.jsx)("p", { className: "m-0 box-border border-solid text-xl text-white", children: (0,jsx_runtime.jsx)("svg", { className: "h-6 w-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: (0,jsx_runtime.jsx)("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" }) }) }) }), (0,jsx_runtime.jsxs)("div", { className: "ml-6 flex-1 border-0 border-gray-200 leading-7", children: [(0,jsx_runtime.jsx)("h3", { className: "m-0 box-border border-solid text-lg font-semibold leading-tight tracking-tight text-black sm:text-xl md:text-2xl", children: "Great Support" }), (0,jsx_runtime.jsx)("p", { className: "mt-2 box-border border-solid text-base leading-normal text-gray-900", children: "We offer some of the best support available. Contact us anytime of the day and we'll help you out ASAP." })] })] })] })] }), (0,jsx_runtime.jsx)("div", { className: "h-full w-full overflow-hidden border-0 border-gray-200 leading-7 text-gray-900 lg:w-1/2", children: (0,jsx_runtime.jsx)("img", { src: "https://images.unsplash.com/photo-1553484771-047a44eee27a?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1234&h=1600&q=80", className: "h-full w-full object-cover", ...renderHtmlImageProps }) })] }) }) }));
};
/* harmony default export */ var Feature_HtmlFeatureTwo = (HtmlFeatureTwo);
//# sourceMappingURL=HtmlFeatureTwo.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Hero/HtmlHeroOne.js


const HtmlHeroOne = () => ((0,jsx_runtime.jsx)("div", { className: "bg-white px-2 py-32 md:px-0", children: (0,jsx_runtime.jsx)("div", { className: "container mx-auto max-w-6xl items-center px-8 xl:px-5", children: (0,jsx_runtime.jsxs)("div", { className: "flex flex-wrap items-center sm:-mx-3", children: [(0,jsx_runtime.jsx)("div", { className: "w-full md:w-1/2 md:px-3", children: (0,jsx_runtime.jsxs)("div", { className: "w-full space-y-6 pb-6 sm:max-w-md sm:pr-5 md:space-y-4 md:pb-0 lg:max-w-lg lg:space-y-8 lg:pr-0 xl:space-y-9", children: [(0,jsx_runtime.jsxs)("h1", { className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-4xl lg:text-5xl xl:text-6xl", children: [(0,jsx_runtime.jsx)("span", { className: "block xl:inline", children: "Beautiful Pages to" }), (0,jsx_runtime.jsx)("span", { className: "text-site-600 block xl:inline", "data-primary": "site-600", children: "Tell Your Story!" })] }), (0,jsx_runtime.jsx)("p", { className: "prose mx-auto text-base text-gray-500 sm:max-w-md md:max-w-3xl lg:text-xl", children: "It's never been easier to build beautiful websites that convey your message and tell your story." }), (0,jsx_runtime.jsxs)("div", { className: "relative flex flex-col sm:flex-row sm:space-x-4", children: [(0,jsx_runtime.jsxs)("a", { href: "#_", className: "bg-site-600 hover:bg-site-700 mb-3 flex w-full items-center rounded-md px-6 py-3 text-lg text-white sm:mb-0 sm:w-auto", "data-primary": "site-600", "data-rounded": "rounded-md", children: ["Try It Free", (0,jsx_runtime.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "ml-1 h-5 w-5", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", children: [(0,jsx_runtime.jsx)("line", { x1: "5", y1: "12", x2: "19", y2: "12", className: "" }), (0,jsx_runtime.jsx)("polyline", { points: "12 5 19 12 12 19" })] })] }), (0,jsx_runtime.jsx)("a", { href: "#_", className: "flex items-center rounded-md bg-gray-100 px-6 py-3 text-gray-500 hover:bg-gray-200 hover:text-gray-600", "data-rounded": "rounded-md", children: "Learn More" })] })] }) }), (0,jsx_runtime.jsx)("div", { className: "w-full md:w-1/2", children: (0,jsx_runtime.jsx)("div", { className: "h-auto w-full overflow-hidden rounded-md shadow-xl sm:rounded-xl", "data-rounded": "rounded-xl", "data-rounded-max": "rounded-full", children: (0,jsx_runtime.jsx)("img", { src: "https://cdn.devdojo.com/images/november2020/hero-image.jpeg", className: "", ...renderHtmlImageProps }) }) })] }) }) }));
/* harmony default export */ var Hero_HtmlHeroOne = (HtmlHeroOne);
//# sourceMappingURL=HtmlHeroOne.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/Team/HtmlTeamOne.js


const HtmlTeamOne = () => {
    return ((0,jsx_runtime.jsx)("section", { className: "w-full bg-white py-12 lg:py-24", children: (0,jsx_runtime.jsxs)("div", { className: "mx-auto max-w-6xl px-12 text-center", children: [(0,jsx_runtime.jsx)("div", { className: "space-y-12 md:text-center", children: (0,jsx_runtime.jsxs)("div", { className: "mb-20 max-w-3xl space-y-5 sm:mx-auto sm:space-y-4", children: [(0,jsx_runtime.jsx)("h2", { className: "relative text-4xl font-extrabold tracking-tight sm:text-5xl", children: "Our Awesome Team" }), (0,jsx_runtime.jsx)("p", { className: "prose text-xl text-gray-500", children: "We take pride in the people we work with. This is because we all collectively help each other become more awesome every day." })] }) }), (0,jsx_runtime.jsxs)("div", { className: "grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3", children: [(0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/headshot2.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "prose text-lg font-medium", children: "John Doe" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "CEO and Founder" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2015" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z", className: "" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/headshotguy.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "text-lg font-medium", children: "Mike Smith" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "CTO and Co-Founder" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2015" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/headshot-n.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "text-lg font-medium", children: "Fred Clemens" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "Marketing Manager" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2016" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/female-headshot-2.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "text-lg font-medium", children: "Sandra Mitchell" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "Lead Designer" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2017" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/headshot-female.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "text-lg font-medium", children: "Kelly Rogers" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "Designer" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2018" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] }), (0,jsx_runtime.jsxs)("div", { className: "w-full rounded-lg border border-gray-200 shadow-sm", children: [(0,jsx_runtime.jsxs)("div", { className: "flex flex-col items-center justify-center p-10", children: [(0,jsx_runtime.jsx)("img", { className: "mb-6 h-32 w-32 rounded-full", src: "https://cdn.devdojo.com/images/june2021/headshotf2.jpg", ...renderHtmlImageProps }), (0,jsx_runtime.jsx)("h2", { className: "text-lg font-medium", children: "Sarah Neilson" }), (0,jsx_runtime.jsx)("p", { className: "prose font-medium text-blue-500", children: "Designer" }), (0,jsx_runtime.jsx)("p", { className: "prose text-gray-400", children: "Team member as of 2018" })] }), (0,jsx_runtime.jsxs)("div", { className: "flex divide-x divide-gray-200 border-t border-gray-200", children: [(0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" }) }) }), (0,jsx_runtime.jsx)("a", { ...renderHtmlLinkProps, href: "#", className: "block flex-1 p-5 text-center text-gray-300 transition duration-200 ease-out hover:bg-gray-100 hover:text-gray-500", children: (0,jsx_runtime.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", className: "mx-auto h-6 w-6 fill-current", viewBox: "0 0 24 24", children: (0,jsx_runtime.jsx)("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" }) }) })] })] })] })] }) }));
};
/* harmony default export */ var Team_HtmlTeamOne = (HtmlTeamOne);
//# sourceMappingURL=HtmlTeamOne.js.map
;// CONCATENATED MODULE: ../elements/lib/components/html/index.js













const html_elements = {
    "html-content-two-columns": ContentTwoColumns,
    "html-hero-hero-one": Hero_HtmlHeroOne,
    "html-content-content-one": Content_HtmlContentOne,
    "html-feature-feature-one": Feature_HtmlFeatureOne,
    "html-team-one": Team_HtmlTeamOne,
    "html-context-title-text": Content_HtmlContentTitleText,
    "html-content-title-simple": Content_HtmlTitleSimple,
    "html-content-content-two": Content_HtmlContentTwo,
    "html-content-content-three": Content_HtmlContentThree,
    "html-feature-feature-two": Feature_HtmlFeatureTwo,
    "html-content-content-four": Content_HtmlContentFour,
    "html-content-content-five": Content_HtmlContentFive,
    "html-call-to-action-one": CallToAction_HtmlCallToActionOne,
};
/* harmony default export */ var html = (html_elements);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableButton.js


const DraggableButton = ({ item: { props, id }, ...rest }) => {
    const linkProps = {
        href: props?.link?.href,
        target: props?.link?.target,
        page: props?.link?.page,
        "editor-link-label": props?.link?.label,
        "editor-link-type": props?.link?.type,
        "editor-link-page": props?.link?.page,
    };
    return ((0,jsx_runtime.jsx)(Common_Link, { "editor-key": id, className: props?.className ||
            "font-text bg-site-600 hover:bg-site-500 focus-visible:outline-site-600 rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2", ...linkProps, ...rest, children: props?.link?.label || "Button tekst" }));
};
/* harmony default export */ var draggableComponents_DraggableButton = (DraggableButton);
//# sourceMappingURL=DraggableButton.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableContainer.js


const DraggableContainer = ({ id, props, children, elementId, ...rest }) => {
    return ((0,jsx_runtime.jsx)("div", { className: props?.className || "mx-auto max-w-7xl bg-white px-6 py-16 lg:px-8", "editor-background-image-src": props?.backgroundImage?.src, "editor-background-image-file": props?.backgroundImage?.file, style: {
            ...(props?.backgroundImage && {
                backgroundImage: `url(${props?.backgroundImage?.src})`,
            }),
        }, "editor-key": id, children: (0,jsx_runtime.jsx)(draggable_DraggableBox, { className: "p-1", draggableId: id, focusKey: id, elementId: elementId, childs: children, ...rest }) }));
};
/* harmony default export */ var draggableComponents_DraggableContainer = (DraggableContainer);
//# sourceMappingURL=DraggableContainer.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableDiv.js


const DraggableDiv = ({ id, props, children, elementId, ...rest }) => {
    return ((0,jsx_runtime.jsx)(draggable_DraggableBox, { className: props?.className, "editor-key": id, draggableId: id, focusKey: id, elementId: elementId, childs: children, component: props?.component || "div", "editor-background-image-src": props?.backgroundImage?.src, "editor-background-image-file": props?.backgroundImage?.file, style: {
            ...(props?.backgroundImage && {
                backgroundImage: `url(${props?.backgroundImage?.src})`,
            }),
        }, ...props, ...rest }));
};
/* harmony default export */ var draggableComponents_DraggableDiv = (DraggableDiv);
//# sourceMappingURL=DraggableDiv.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableForm.js




const DraggableForm = ({ item: { props, id }, ...rest }) => {
    const { mode } = useEditor();
    const { forms } = useSite();
    const form = forms && props?.form?.selected
        ? forms.find((f) => f.id === props?.form?.selected)
        : null;
    return ((0,jsx_runtime.jsxs)("div", { "editor-key": id, className: props?.className || "mt-4", "editor-form-button": props?.form?.button || "Verstuur", "editor-form-selected": props?.form?.selected || null, "editor-options": JSON.stringify([{ type: "form" }]), ...rest, children: [!form && mode === "editor" && ((0,jsx_runtime.jsx)("div", { "editor-focuskey": id, className: "focus:ring-site-500 relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2", children: (0,jsx_runtime.jsx)("span", { className: "mt-2 block text-sm font-medium text-gray-900", "editor-disabled": "true", children: "Selecteer een formulier" }) })), form && ((0,jsx_runtime.jsx)(Common_Form, { focusKey: id, id: form.id, name: form.name, recaptchaPublicKey: form?.recaptchaPublicKey, className: "grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8", fields: form.fields, buttonText: props?.form.button || "Verstuur" }))] }));
};
/* harmony default export */ var draggableComponents_DraggableForm = (DraggableForm);
//# sourceMappingURL=DraggableForm.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableGrid.js




const DraggableGrid = ({ id, children, elementId, props, }) => {
    return ((0,jsx_runtime.jsx)(draggable_DraggableBox, { className: classNames("grid", props.className, props?.gridMobile, props?.gridTablet, props?.gridDesktop, !props.className?.includes("gap") && "gap-4"), draggableId: id, elementId: elementId, childs: children.filter((i) => true), editorKey: id, type: draggable_DraggableComponentTypes.Grid, "editor-type": "grid" }));
};
/* harmony default export */ var draggableComponents_DraggableGrid = (DraggableGrid);
//# sourceMappingURL=DraggableGrid.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableGridItem.js



const DraggableGridItem = ({ id, children, elementId, props, }) => {
    return ((0,jsx_runtime.jsx)(draggable_DraggableBox, { editorKey: id, draggableId: id, elementId: elementId, childs: children, className: props?.className, type: draggable_DraggableComponentTypes.GridItem }));
};
/* harmony default export */ var draggableComponents_DraggableGridItem = (DraggableGridItem);
//# sourceMappingURL=DraggableGridItem.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableImage.js



const tailwindToPx = (value) => {
    if (!value)
        return null;
    return {
        "1": "4",
        "2": "8",
        "3": "12",
        "4": "16",
        "5": "20",
        "6": "24",
        "7": "28",
        "8": "32",
        "9": "36",
        "10": "40",
        "11": "44",
        "12": "48",
        "14": "56",
        "16": "64",
        "20": "80",
        "24": "96",
        "28": "112",
        "32": "128",
        "36": "144",
        "40": "160",
        "44": "176",
        "48": "192",
        "52": "208",
        "56": "224",
        "60": "240",
        "64": "256",
        "72": "288",
        "80": "320",
        "96": "384",
    }[value];
};
const DraggableImage = ({ item: { props, id }, ...rest }) => {
    const { mode } = useEditor();
    const className = props?.className || "h-44 w-44";
    const src = props?.image?.src || placeholders_imagePlaceholder.src;
    const srcLoader = () => {
        if (!src.includes("cloudfront"))
            return src;
        const findStylingWidth = className.split(" ").find((c) => c.includes("w-"));
        const stylingWidth = findStylingWidth?.split("-")[1] || null;
        const imageWidth = tailwindToPx(stylingWidth);
        if (imageWidth && mode === "production")
            return `${src}?format=webp&width=${parseFloat(imageWidth) * 2}`;
        return `${src}?format=webp`;
    };
    return ((0,jsx_runtime.jsx)("img", { src: srcLoader(), className: className, alt: props?.image?.src || placeholders_imagePlaceholder.alt, "editor-img-file": props?.image?.file || placeholders_imagePlaceholder.file, "editor-key": id, ...rest }));
};
/* harmony default export */ var draggableComponents_DraggableImage = (DraggableImage);
//# sourceMappingURL=DraggableImage.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableLink.js


const DraggableLink = ({ item: { props, id }, ...rest }) => {
    const linkProps = {
        href: props?.link?.href || "#",
        target: props?.link?.target || "_self",
        page: props?.link?.page,
        "editor-link-label": props?.link?.label,
        "editor-link-type": props?.link?.type,
        "editor-link-page": props?.link?.page,
    };
    return ((0,jsx_runtime.jsx)(Common_Link, { "editor-key": id, className: props?.className || "text-site-500 hover:text-site-600 text-base", ...linkProps, ...rest, children: props?.link?.label || "Link tekst" }));
};
/* harmony default export */ var draggableComponents_DraggableLink = (DraggableLink);
//# sourceMappingURL=DraggableLink.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableList.js


const DraggableList = ({ item: { props, id, children }, elementId, ...rest }) => {
    return ((0,jsx_runtime.jsx)("ul", { className: props?.className, "editor-key": id, "editor-type": "list", ...rest, children: children.map((c) => ((0,jsx_runtime.jsx)(draggable_DraggableComponent, { item: c, elementId: elementId }, c.id))) }));
};
/* harmony default export */ var draggableComponents_DraggableList = (DraggableList);
//# sourceMappingURL=DraggableList.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableSvg.js


const DraggableSvg = ({ item: { props: { className, svgContent, ...restProps }, id, }, ...rest }) => {
    return ((0,jsx_runtime.jsx)("svg", { className: classNames(className), "editor-key": id, ...restProps, ...rest, dangerouslySetInnerHTML: {
            __html: svgContent,
        } }));
};
/* harmony default export */ var draggableComponents_DraggableSvg = (DraggableSvg);
//# sourceMappingURL=DraggableSvg.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableText.js



const DraggableText = ({ item: { props, id }, ...rest }) => {
    const articleRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        const articleElement = articleRef.current;
        if (articleElement) {
            const pElements = articleElement.querySelectorAll("p");
            pElements.forEach((pElement) => {
                pElement.setAttribute("editor-key", id);
            });
        }
    }, []);
    return ((0,jsx_runtime.jsx)("article", { className: props?.className || "prose", "editor-key": id, ...rest, ref: articleRef, dangerouslySetInnerHTML: {
            __html: props?.text || textPlaceHolder.value,
        } }));
};
/* harmony default export */ var draggableComponents_DraggableText = (DraggableText);
//# sourceMappingURL=DraggableText.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableTitle.js


const DraggableTitle = ({ item: { props, id }, ...rest }) => {
    const Component = props?.component || "h1";
    return ((0,jsx_runtime.jsx)(Component, { className: props?.className ||
            "font-heading text-4xl font-bold text-gray-900 sm:tracking-tight", "editor-key": id, ...rest, children: props?.text || titlePlaceholder.value }));
};
/* harmony default export */ var draggableComponents_DraggableTitle = (DraggableTitle);
//# sourceMappingURL=DraggableTitle.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableListItem.js




const DraggableListItem = ({ item: { props, id, children }, elementId, ...rest }) => {
    const iconChild = children?.find((c) => c.type === draggable_DraggableComponentTypes.Icon);
    return ((0,jsx_runtime.jsx)("li", { className: props?.className, "editor-key": id, "editor-has-childs": (children?.length > 0).toString(), ...rest, children: children && children.length > 0 ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: children?.map((item) => ((0,jsx_runtime.jsx)(draggable_DraggableComponent, { item: item, elementId: elementId }, item.id))) })) : (props?.text || textPlaceHolder.value) }));
};
/* harmony default export */ var draggableComponents_DraggableListItem = (DraggableListItem);
//# sourceMappingURL=DraggableListItem.js.map
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction_s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(use_tab_direction_s||{});function use_tab_direction_n(){let e=(0,react.useRef)(0);return use_window_event_s("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function E(n,e,a,t){let i=use_latest_value_s(a);(0,react.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-watch.js
function m(u,t){let e=(0,react.useRef)([]),r=use_event_o(u);(0,react.useEffect)(()=>{let o=[...e.current];for(let[n,a]of t.entries())if(e.current[n]!==a){let l=r(t,o);return e.current=t,l}},[r,...t])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/document-ready.js
function document_ready_t(n){function e(){document.readyState!=="loading"&&(n(),document.removeEventListener("DOMContentLoaded",e))}typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("DOMContentLoaded",e),e())}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-on-unmount.js
function use_on_unmount_c(t){let r=use_event_o(t),e=(0,react.useRef)(!1);(0,react.useEffect)(()=>(e.current=!1,()=>{e.current=!0,micro_task_t(()=>{e.current&&r()})}),[r])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
function P(t){if(!t)return new Set;if(typeof t=="function")return new Set(t());let r=new Set;for(let e of t.current)e.current instanceof HTMLElement&&r.add(e.current);return r}let J="div";var focus_trap_h=(n=>(n[n.None=1]="None",n[n.InitialFocus=2]="InitialFocus",n[n.TabLock=4]="TabLock",n[n.FocusLock=8]="FocusLock",n[n.RestoreFocus=16]="RestoreFocus",n[n.All=30]="All",n))(focus_trap_h||{});function X(t,r){let e=(0,react.useRef)(null),o=use_sync_refs_y(e,r),{initialFocus:u,containers:i,features:n=30,...l}=t;use_server_handoff_complete_l()||(n=1);let m=use_owner_n(e);focus_trap_Y({ownerDocument:m},Boolean(n&16));let c=focus_trap_Z({ownerDocument:m,container:e,initialFocus:u},Boolean(n&2));$({ownerDocument:m,container:e,containers:i,previousActiveElement:c},Boolean(n&8));let v=use_tab_direction_n(),y=use_event_o(s=>{let T=e.current;if(!T)return;(B=>B())(()=>{match_u(v.current,{[use_tab_direction_s.Forwards]:()=>{O(T,focus_management_M.First,{skipElements:[s.relatedTarget]})},[use_tab_direction_s.Backwards]:()=>{O(T,focus_management_M.Last,{skipElements:[s.relatedTarget]})}})})}),_=use_disposables_p(),b=(0,react.useRef)(!1),j={ref:o,onKeyDown(s){s.key=="Tab"&&(b.current=!0,_.requestAnimationFrame(()=>{b.current=!1}))},onBlur(s){let T=P(i);e.current instanceof HTMLElement&&T.add(e.current);let d=s.relatedTarget;d instanceof HTMLElement&&d.dataset.headlessuiFocusGuard!=="true"&&(focus_trap_S(T,d)||(b.current?O(e.current,match_u(v.current,{[use_tab_direction_s.Forwards]:()=>focus_management_M.Next,[use_tab_direction_s.Backwards]:()=>focus_management_M.Previous})|focus_management_M.WrapAround,{relativeTo:s.target}):s.target instanceof HTMLElement&&focus_management_y(s.target)))}};return react.createElement(react.Fragment,null,Boolean(n&4)&&react.createElement(hidden_c,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:y,features:hidden_p.Focusable}),render_X({ourProps:j,theirProps:l,defaultTag:J,name:"FocusTrap"}),Boolean(n&4)&&react.createElement(hidden_c,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:y,features:hidden_p.Focusable}))}let focus_trap_z=D(X),focus_trap_ge=Object.assign(focus_trap_z,{features:focus_trap_h}),focus_trap_a=[];document_ready_t(()=>{function t(r){r.target instanceof HTMLElement&&r.target!==document.body&&focus_trap_a[0]!==r.target&&(focus_trap_a.unshift(r.target),focus_trap_a=focus_trap_a.filter(e=>e!=null&&e.isConnected),focus_trap_a.splice(10))}window.addEventListener("click",t,{capture:!0}),window.addEventListener("mousedown",t,{capture:!0}),window.addEventListener("focus",t,{capture:!0}),document.body.addEventListener("click",t,{capture:!0}),document.body.addEventListener("mousedown",t,{capture:!0}),document.body.addEventListener("focus",t,{capture:!0})});function focus_trap_Q(t=!0){let r=(0,react.useRef)(focus_trap_a.slice());return m(([e],[o])=>{o===!0&&e===!1&&micro_task_t(()=>{r.current.splice(0)}),o===!1&&e===!0&&(r.current=focus_trap_a.slice())},[t,focus_trap_a,r]),use_event_o(()=>{var e;return(e=r.current.find(o=>o!=null&&o.isConnected))!=null?e:null})}function focus_trap_Y({ownerDocument:t},r){let e=focus_trap_Q(r);m(()=>{r||(t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&focus_management_y(e())},[r]),use_on_unmount_c(()=>{r&&focus_management_y(e())})}function focus_trap_Z({ownerDocument:t,container:r,initialFocus:e},o){let u=(0,react.useRef)(null),i=use_is_mounted_f();return m(()=>{if(!o)return;let n=r.current;n&&micro_task_t(()=>{if(!i.current)return;let l=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===l){u.current=l;return}}else if(n.contains(l)){u.current=l;return}e!=null&&e.current?focus_management_y(e.current):O(n,focus_management_M.First)===focus_management_N.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),u.current=t==null?void 0:t.activeElement})},[o]),u}function $({ownerDocument:t,container:r,containers:e,previousActiveElement:o},u){let i=use_is_mounted_f();E(t==null?void 0:t.defaultView,"focus",n=>{if(!u||!i.current)return;let l=P(e);r.current instanceof HTMLElement&&l.add(r.current);let m=o.current;if(!m)return;let c=n.target;c&&c instanceof HTMLElement?focus_trap_S(l,c)?(o.current=c,focus_management_y(c)):(n.preventDefault(),n.stopPropagation(),focus_management_y(m)):focus_management_y(o.current)},!0)}function focus_trap_S(t,r){for(let e of t)if(e.contains(r))return!0;return!1}

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/internal/portal-force-root.js
let portal_force_root_e=(0,react.createContext)(!1);function portal_force_root_l(){return (0,react.useContext)(portal_force_root_e)}function portal_force_root_P(o){return react.createElement(portal_force_root_e.Provider,{value:o.force},o.children)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/portal/portal.js
function portal_F(p){let l=portal_force_root_l(),n=(0,react.useContext)(portal_v),e=use_owner_n(p),[a,o]=(0,react.useState)(()=>{if(!l&&n!==null||s.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return (0,react.useEffect)(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a))},[a,e]),(0,react.useEffect)(()=>{l||n!==null&&o(n.current)},[n,o,l]),a}let portal_U=react.Fragment;function portal_N(p,l){let n=p,e=(0,react.useRef)(null),a=use_sync_refs_y(use_sync_refs_T(u=>{e.current=u}),l),o=use_owner_n(e),t=portal_F(e),[r]=(0,react.useState)(()=>{var u;return s.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null}),i=(0,react.useContext)(portal_f),C=use_server_handoff_complete_l();return use_iso_morphic_effect_l(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r))},[t,r]),use_iso_morphic_effect_l(()=>{if(r&&i)return i.register(r)},[i,r]),use_on_unmount_c(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)))}),C?!t||!r?null:(0,react_dom.createPortal)(render_X({ourProps:{ref:a},theirProps:n,defaultTag:portal_U,name:"Portal"}),r):null}let portal_S=react.Fragment,portal_v=(0,react.createContext)(null);function j(p,l){let{target:n,...e}=p,o={ref:use_sync_refs_y(l)};return react.createElement(portal_v.Provider,{value:n},render_X({ourProps:o,theirProps:e,defaultTag:portal_S,name:"Popover.Group"}))}let portal_f=(0,react.createContext)(null);function portal_ae(){let p=(0,react.useContext)(portal_f),l=(0,react.useRef)([]),n=use_event_o(o=>(l.current.push(o),p&&p.register(o),()=>e(o))),e=use_event_o(o=>{let t=l.current.indexOf(o);t!==-1&&l.current.splice(t,1),p&&p.unregister(o)}),a=(0,react.useMemo)(()=>({register:n,unregister:e,portals:l}),[n,e,l]);return[l,(0,react.useMemo)(()=>function({children:t}){return react.createElement(portal_f.Provider,{value:a},t)},[a])]}let portal_D=D(portal_N),portal_I=D(j),portal_pe=Object.assign(portal_D,{Group:portal_I});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/internal/stack-context.js
let stack_context_a=(0,react.createContext)(()=>{});stack_context_a.displayName="StackContext";var stack_context_s=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(stack_context_s||{});function stack_context_x(){return (0,react.useContext)(stack_context_a)}function stack_context_M({children:i,onUpdate:r,type:e,element:n,enabled:u}){let l=stack_context_x(),o=use_event_o((...t)=>{r==null||r(...t),l(...t)});return use_iso_morphic_effect_l(()=>{let t=u===void 0||u===!0;return t&&o(0,e,n),()=>{t&&o(1,e,n)}},[o,e,n,u]),react.createElement(stack_context_a.Provider,{value:o},i)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimClient.js
function useSyncExternalStoreShimClient_i(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t}const useSyncExternalStoreShimClient_d=typeof Object.is=="function"?Object.is:useSyncExternalStoreShimClient_i,{useState:useSyncExternalStoreShimClient_u,useEffect:useSyncExternalStoreShimClient_h,useLayoutEffect:useSyncExternalStoreShimClient_f,useDebugValue:p}=react_namespaceObject;let useSyncExternalStoreShimClient_S=(/* unused pure expression or super */ null && (!1)),useSyncExternalStoreShimClient_=(/* unused pure expression or super */ null && (!1));function useSyncExternalStoreShimClient_y(e,t,c){const a=t(),[{inst:n},o]=useSyncExternalStoreShimClient_u({inst:{value:a,getSnapshot:t}});return useSyncExternalStoreShimClient_f(()=>{n.value=a,n.getSnapshot=t,useSyncExternalStoreShimClient_r(n)&&o({inst:n})},[e,a,t]),useSyncExternalStoreShimClient_h(()=>(useSyncExternalStoreShimClient_r(n)&&o({inst:n}),e(()=>{useSyncExternalStoreShimClient_r(n)&&o({inst:n})})),[e]),p(a),a}function useSyncExternalStoreShimClient_r(e){const t=e.getSnapshot,c=e.value;try{const a=t();return!useSyncExternalStoreShimClient_d(c,a)}catch{return!0}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimServer.js
function useSyncExternalStoreShimServer_t(r,e,n){return e()}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/index.js
const use_sync_external_store_shim_r=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined",use_sync_external_store_shim_s=!use_sync_external_store_shim_r,use_sync_external_store_shim_c=use_sync_external_store_shim_s?useSyncExternalStoreShimServer_t:useSyncExternalStoreShimClient_y,use_sync_external_store_shim_a= true?(n=>n.useSyncExternalStore)(react_namespaceObject):use_sync_external_store_shim_c;

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-store.js
function use_store_S(t){return use_sync_external_store_shim_a(t.subscribe,t.getSnapshot,t.getSnapshot)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/store.js
function store_a(o,r){let t=o(),n=new Set;return{getSnapshot(){return t},subscribe(e){return n.add(e),()=>n.delete(e)},dispatch(e,...s){let i=r[e].call(t,...s);i&&(t=i,n.forEach(c=>c()))}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/adjust-scrollbar-padding.js
function adjust_scrollbar_padding_c(){let o;return{before({doc:e}){var l;let n=e.documentElement;o=((l=e.defaultView)!=null?l:window).innerWidth-n.clientWidth},after({doc:e,d:n}){let t=e.documentElement,l=t.clientWidth-t.offsetWidth,r=o-l;n.style(t,"paddingRight",`${r}px`)}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/platform.js
function platform_t(){return/iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0}function platform_i(){return/Android/gi.test(window.navigator.userAgent)}function platform_n(){return platform_t()||platform_i()}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/handle-ios-locking.js
function handle_ios_locking_p(){if(!platform_t())return{};let o;return{before(){o=window.pageYOffset},after({doc:r,d:l,meta:s}){function i(e){return s.containers.flatMap(t=>t()).some(t=>t.contains(e))}l.style(r.body,"marginTop",`-${o}px`),window.scrollTo(0,0);let n=null;l.addEventListener(r,"click",e=>{if(e.target instanceof HTMLElement)try{let t=e.target.closest("a");if(!t)return;let{hash:c}=new URL(t.href),a=r.querySelector(c);a&&!i(a)&&(n=a)}catch{}},!0),l.addEventListener(r,"touchmove",e=>{e.target instanceof HTMLElement&&!i(e.target)&&e.preventDefault()},{passive:!1}),l.add(()=>{window.scrollTo(0,window.pageYOffset+o),n&&n.isConnected&&(n.scrollIntoView({block:"nearest"}),n=null)})}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/prevent-scroll.js
function l(){return{before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden")}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/overflow-store.js
function overflow_store_m(e){let n={};for(let t of e)Object.assign(n,t(n));return n}let overflow_store_a=store_a(()=>new Map,{PUSH(e,n){var o;let t=(o=this.get(e))!=null?o:{doc:e,count:0,d:disposables_o(),meta:new Set};return t.count++,t.meta.add(n),this.set(e,t),this},POP(e,n){let t=this.get(e);return t&&(t.count--,t.meta.delete(n)),this},SCROLL_PREVENT({doc:e,d:n,meta:t}){let o={doc:e,d:n,meta:overflow_store_m(t)},c=[handle_ios_locking_p(),adjust_scrollbar_padding_c(),l()];c.forEach(({before:r})=>r==null?void 0:r(o)),c.forEach(({after:r})=>r==null?void 0:r(o))},SCROLL_ALLOW({d:e}){e.dispose()},TEARDOWN({doc:e}){this.delete(e)}});overflow_store_a.subscribe(()=>{let e=overflow_store_a.getSnapshot(),n=new Map;for(let[t]of e)n.set(t,t.documentElement.style.overflow);for(let t of e.values()){let o=n.get(t.doc)==="hidden",c=t.count!==0;(c&&!o||!c&&o)&&overflow_store_a.dispatch(t.count>0?"SCROLL_PREVENT":"SCROLL_ALLOW",t),t.count===0&&overflow_store_a.dispatch("TEARDOWN",t)}});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/use-document-overflow.js
function use_document_overflow_p(e,r,n){let f=use_store_S(overflow_store_a),o=e?f.get(e):void 0,i=o?o.count>0:!1;return use_iso_morphic_effect_l(()=>{if(!(!e||!r))return overflow_store_a.dispatch("PUSH",e,n),()=>overflow_store_a.dispatch("POP",e,n)},[r,e]),i}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-inert.js
let use_inert_u=new Map,use_inert_t=new Map;function use_inert_h(r,l=!0){use_iso_morphic_effect_l(()=>{var o;if(!l)return;let e=typeof r=="function"?r():r.current;if(!e)return;function a(){var d;if(!e)return;let i=(d=use_inert_t.get(e))!=null?d:1;if(i===1?use_inert_t.delete(e):use_inert_t.set(e,i-1),i!==1)return;let n=use_inert_u.get(e);n&&(n["aria-hidden"]===null?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",n["aria-hidden"]),e.inert=n.inert,use_inert_u.delete(e))}let f=(o=use_inert_t.get(e))!=null?o:0;return use_inert_t.set(e,f+1),f!==0||(use_inert_u.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),e.setAttribute("aria-hidden","true"),e.inert=!0),a},[r,l])}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-root-containers.js
function use_root_containers_p({defaultContainers:f=[],portals:o}={}){let t=(0,react.useRef)(null),i=use_owner_n(t),u=use_event_o(()=>{var r;let n=[];for(let e of f)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(o!=null&&o.current)for(let e of o.current)n.push(e);for(let e of(r=i==null?void 0:i.querySelectorAll("html > *, body > *"))!=null?r:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(t.current)||n.some(c=>e.contains(c))||n.push(e));return n});return{resolveContainers:u,contains:use_event_o(n=>u().some(r=>r.contains(n))),mainTreeNodeRef:t,MainTreeNode:(0,react.useMemo)(()=>function(){return react.createElement(hidden_c,{features:hidden_p.Hidden,ref:t})},[t])}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/dialog/dialog.js
var _e=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(_e||{}),dialog_Ie=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(dialog_Ie||{});let dialog_Me={[0](t,e){return t.titleId===e.id?t:{...t,titleId:e.id}}},dialog_I=(0,react.createContext)(null);dialog_I.displayName="DialogContext";function dialog_b(t){let e=(0,react.useContext)(dialog_I);if(e===null){let o=new Error(`<${t} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,dialog_b),o}return e}function we(t,e,o=()=>[document.body]){use_document_overflow_p(t,e,i=>{var n;return{containers:[...(n=i.containers)!=null?n:[],o]}})}function Be(t,e){return match_u(e.type,dialog_Me,t,e)}let dialog_He="div",dialog_Ge=S.RenderStrategy|S.Static;function dialog_Ne(t,e){var X;let o=use_id_I(),{id:i=`headlessui-dialog-${o}`,open:n,onClose:l,initialFocus:s,__demoMode:g=!1,...T}=t,[m,h]=(0,react.useState)(0),a=C();n===void 0&&a!==null&&(n=(a&open_closed_d.Open)===open_closed_d.Open);let D=(0,react.useRef)(null),Q=use_sync_refs_y(D,e),f=use_owner_n(D),N=t.hasOwnProperty("open")||a!==null,U=t.hasOwnProperty("onClose");if(!N&&!U)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!N)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!U)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof n!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);if(typeof l!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);let p=n?0:1,[S,Z]=(0,react.useReducer)(Be,{titleId:null,descriptionId:null,panelRef:(0,react.createRef)()}),P=use_event_o(()=>l(!1)),W=use_event_o(r=>Z({type:0,id:r})),L=use_server_handoff_complete_l()?g?!1:p===0:!1,F=m>1,Y=(0,react.useContext)(dialog_I)!==null,[ee,te]=portal_ae(),{resolveContainers:M,mainTreeNodeRef:k,MainTreeNode:oe}=use_root_containers_p({portals:ee,defaultContainers:[(X=S.panelRef.current)!=null?X:D.current]}),re=F?"parent":"leaf",$=a!==null?(a&open_closed_d.Closing)===open_closed_d.Closing:!1,ne=(()=>Y||$?!1:L)(),le=(0,react.useCallback)(()=>{var r,c;return(c=Array.from((r=f==null?void 0:f.querySelectorAll("body > *"))!=null?r:[]).find(d=>d.id==="headlessui-portal-root"?!1:d.contains(k.current)&&d instanceof HTMLElement))!=null?c:null},[k]);use_inert_h(le,ne);let ae=(()=>F?!0:L)(),ie=(0,react.useCallback)(()=>{var r,c;return(c=Array.from((r=f==null?void 0:f.querySelectorAll("[data-headlessui-portal]"))!=null?r:[]).find(d=>d.contains(k.current)&&d instanceof HTMLElement))!=null?c:null},[k]);use_inert_h(ie,ae);let se=(()=>!(!L||F))();use_outside_click_H(M,P,se);let pe=(()=>!(F||p!==0))();E(f==null?void 0:f.defaultView,"keydown",r=>{pe&&(r.defaultPrevented||r.key===keyboard_o.Escape&&(r.preventDefault(),r.stopPropagation(),P()))});let de=(()=>!($||p!==0||Y))();we(f,de,M),(0,react.useEffect)(()=>{if(p!==0||!D.current)return;let r=new ResizeObserver(c=>{for(let d of c){let x=d.target.getBoundingClientRect();x.x===0&&x.y===0&&x.width===0&&x.height===0&&P()}});return r.observe(D.current),()=>r.disconnect()},[p,D,P]);let[ue,fe]=description_M(),ge=(0,react.useMemo)(()=>[{dialogState:p,close:P,setTitleId:W},S],[p,S,P,W]),J=(0,react.useMemo)(()=>({open:p===0}),[p]),Te={ref:Q,id:i,role:"dialog","aria-modal":p===0?!0:void 0,"aria-labelledby":S.titleId,"aria-describedby":ue};return react.createElement(stack_context_M,{type:"Dialog",enabled:p===0,element:D,onUpdate:use_event_o((r,c)=>{c==="Dialog"&&match_u(r,{[stack_context_s.Add]:()=>h(d=>d+1),[stack_context_s.Remove]:()=>h(d=>d-1)})})},react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_pe,null,react.createElement(dialog_I.Provider,{value:ge},react.createElement(portal_pe.Group,{target:D},react.createElement(portal_force_root_P,{force:!1},react.createElement(fe,{slot:J,name:"Dialog.Description"},react.createElement(focus_trap_ge,{initialFocus:s,containers:M,features:L?match_u(re,{parent:focus_trap_ge.features.RestoreFocus,leaf:focus_trap_ge.features.All&~focus_trap_ge.features.FocusLock}):focus_trap_ge.features.None},react.createElement(te,null,render_X({ourProps:Te,theirProps:T,slot:J,defaultTag:dialog_He,features:dialog_Ge,visible:p===0,name:"Dialog"}))))))))),react.createElement(oe,null))}let Ue="div";function We(t,e){let o=use_id_I(),{id:i=`headlessui-dialog-overlay-${o}`,...n}=t,[{dialogState:l,close:s}]=dialog_b("Dialog.Overlay"),g=use_sync_refs_y(e),T=use_event_o(a=>{if(a.target===a.currentTarget){if(bugs_r(a.currentTarget))return a.preventDefault();a.preventDefault(),a.stopPropagation(),s()}}),m=(0,react.useMemo)(()=>({open:l===0}),[l]);return render_X({ourProps:{ref:g,id:i,"aria-hidden":!0,onClick:T},theirProps:n,slot:m,defaultTag:Ue,name:"Dialog.Overlay"})}let Ye="div";function dialog_$e(t,e){let o=use_id_I(),{id:i=`headlessui-dialog-backdrop-${o}`,...n}=t,[{dialogState:l},s]=dialog_b("Dialog.Backdrop"),g=use_sync_refs_y(e);(0,react.useEffect)(()=>{if(s.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.")},[s.panelRef]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_pe,null,render_X({ourProps:{ref:g,id:i,"aria-hidden":!0},theirProps:n,slot:T,defaultTag:Ye,name:"Dialog.Backdrop"})))}let Je="div";function Xe(t,e){let o=use_id_I(),{id:i=`headlessui-dialog-panel-${o}`,...n}=t,[{dialogState:l},s]=dialog_b("Dialog.Panel"),g=use_sync_refs_y(e,s.panelRef),T=(0,react.useMemo)(()=>({open:l===0}),[l]),m=use_event_o(a=>{a.stopPropagation()});return render_X({ourProps:{ref:g,id:i,onClick:m},theirProps:n,slot:T,defaultTag:Je,name:"Dialog.Panel"})}let je="h2";function Ke(t,e){let o=use_id_I(),{id:i=`headlessui-dialog-title-${o}`,...n}=t,[{dialogState:l,setTitleId:s}]=dialog_b("Dialog.Title"),g=use_sync_refs_y(e);(0,react.useEffect)(()=>(s(i),()=>s(null)),[i,s]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return render_X({ourProps:{ref:g,id:i},theirProps:n,slot:T,defaultTag:je,name:"Dialog.Title"})}let Ve=D(dialog_Ne),qe=D(dialog_$e),ze=D(Xe),Qe=D(We),Ze=D(Ke),_t=Object.assign(Ve,{Backdrop:qe,Panel:ze,Overlay:Qe,Title:Ze,Description:b});

// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/ChevronDownIcon.js
var outline_ChevronDownIcon = __webpack_require__(4836);
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableNavbarHorizontal.js












const NavbarDesktop = ({ id, textColor, bgActive, textActiveColor, navbarItems, }) => {
    const { activePage } = useSite();
    return ((0,jsx_runtime.jsx)("div", { className: "hidden md:block", children: (0,jsx_runtime.jsx)("div", { className: "flex space-x-4", "editor-focuskey": id, children: navbarItems.map((item) => ((0,jsx_runtime.jsx)(react.Fragment, { children: item?.items?.length > 0 ? ((0,jsx_runtime.jsxs)(it, { as: "div", className: "relative inline-block text-left", "editor-focuskey": item.id, children: [(0,jsx_runtime.jsxs)(it.Button, { "editor-focuskey": item.id, className: classNames(item.href === activePage
                                ? `${bgActive} ${textActiveColor}`
                                : `${textColor} opacity-80  hover:opacity-100`, "flex items-center rounded-md px-3 py-2 font-medium"), children: [(0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": id, children: item.name }), item?.items?.length > 0 && ((0,jsx_runtime.jsx)(outline_ChevronDownIcon, { className: "-mr-1 ml-2 h-4 w-4", "aria-hidden": "true" }))] }), item?.items?.length > 0 && ((0,jsx_runtime.jsx)($e, { as: react.Fragment, enter: "transition ease-out duration-200", enterFrom: "opacity-0 translate-y-1", enterTo: "opacity-100 translate-y-0", leave: "transition ease-in duration-150", leaveFrom: "opacity-100 translate-y-0", leaveTo: "opacity-0 translate-y-1", children: (0,jsx_runtime.jsx)(it.Items, { className: "absolute right-0 z-50 w-64 origin-top-right rounded-md bg-white py-2", style: { boxShadow: "4px 4px 40px rgba(16,24,40,.1)" }, children: (0,jsx_runtime.jsx)("div", { className: "py-1", children: item.items.map((subItem) => ((0,jsx_runtime.jsx)(it.Item, { children: ({ active }) => ((0,jsx_runtime.jsx)(Common_Link, { href: subItem.href, className: classNames(active
                                                ? `${bgActive} ${textActiveColor}`
                                                : `text-black opacity-80  hover:opacity-100`, "block rounded-md px-4 py-2 transition-all duration-200"), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", children: subItem.name }) })) }, subItem.id))) }) }) }))] }, item.id)) : ((0,jsx_runtime.jsx)(Common_Link, { href: item.href, "editor-focuskey": id, className: classNames(item.href === activePage
                        ? `${bgActive} ${textActiveColor}`
                        : `${textColor} opacity-80  hover:opacity-100`, "block rounded-md px-4 py-2"), children: (0,jsx_runtime.jsx)(Common_Typography, { component: "span", "editor-focuskey": id, children: item.name }) }, item.id)) }, item.id))) }) }));
};
const NavbarMobileItem = ({ item, bgActive, textActiveColor, textColor, setOpen, }) => {
    const [subMenuOpen, setSubMenuOpen] = (0,react.useState)(false);
    const { activePage } = useSite();
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Common_Link, { href: item?.items?.length > 0 ? "#" : item.href, className: classNames(item.href === activePage
                    ? `${bgActive} ${textActiveColor}`
                    : `${textColor}`, "flex w-full items-center justify-between rounded-md py-2 text-base font-medium"), "aria-current": item.current ? "page" : undefined, handleLinkClick: () => {
                    item.items.length > 0 && setSubMenuOpen(!subMenuOpen);
                    item.items.length === 0 && setOpen(false);
                }, children: (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Common_Typography, { component: "span", children: item.name }), item?.items?.length > 0 && ((0,jsx_runtime.jsx)(outline_ChevronDownIcon, { className: "-mr-1 ml-2 h-4 w-4", "aria-hidden": "true" }))] }) }, item.name), subMenuOpen && ((0,jsx_runtime.jsx)("div", { className: "pl-4", children: item?.items?.map((subItem) => ((0,jsx_runtime.jsx)(NavbarMobileItem, { item: subItem, bgActive: bgActive, textActiveColor: textActiveColor, textColor: textColor, setOpen: setOpen }, subItem.id))) }))] }));
};
const NavbarMobile = ({ textColor, bgActive, textActiveColor, navbarItems, }) => {
    const { mode } = useEditor();
    const [open, setOpen] = (0,react.useState)(false);
    return ((0,jsx_runtime.jsx)("div", { className: "block md:hidden", children: (0,jsx_runtime.jsx)("nav", { children: (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsxs)("div", { className: `inline-flex items-center justify-center rounded-md p-2 ${textColor} hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`, children: [(0,jsx_runtime.jsx)("span", { className: "sr-only", children: "Open main menu" }), (0,jsx_runtime.jsx)(Bars3Icon, { className: "block h-6 w-6", "aria-hidden": "true", onClick: () => mode === "production" && setOpen(true) })] }), (0,jsx_runtime.jsx)($e.Root, { show: open, as: react.Fragment, children: (0,jsx_runtime.jsxs)(_t, { as: "div", className: "relative z-[100]", onClose: () => setOpen(false), children: [(0,jsx_runtime.jsx)("div", { className: "fixed inset-0" }), (0,jsx_runtime.jsx)("div", { className: "fixed inset-0 overflow-hidden", children: (0,jsx_runtime.jsx)("div", { className: "absolute inset-0 overflow-hidden", children: (0,jsx_runtime.jsx)("div", { className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10", children: (0,jsx_runtime.jsx)($e.Child, { as: react.Fragment, enter: "transform transition ease-in-out duration-500 sm:duration-700", enterFrom: "translate-x-full", enterTo: "translate-x-0", leave: "transform transition ease-in-out duration-500 sm:duration-700", leaveFrom: "translate-x-0", leaveTo: "translate-x-full", children: (0,jsx_runtime.jsx)(_t.Panel, { className: "pointer-events-auto w-screen max-w-md", children: (0,jsx_runtime.jsxs)("div", { className: "flex h-full flex-col overflow-y-scroll bg-white  shadow-xl", children: [(0,jsx_runtime.jsx)("div", { className: "bg-gray-50 px-4 py-4 sm:px-6", children: (0,jsx_runtime.jsxs)("div", { className: "flex items-center justify-between", children: [(0,jsx_runtime.jsx)(_t.Title, { className: "text-base font-semibold leading-6 text-gray-900", children: "Menu" }), (0,jsx_runtime.jsx)("div", { className: "ml-3 flex h-7 items-center", children: (0,jsx_runtime.jsxs)("button", { type: "button", className: "rounded-md text-gray-400 hover:text-gray-500 focus:outline-none", onClick: () => setOpen(false), children: [(0,jsx_runtime.jsx)("span", { className: "sr-only", children: "Close panel" }), (0,jsx_runtime.jsx)(outline_XMarkIcon, { className: "h-6 w-6", "aria-hidden": "true" })] }) })] }) }), (0,jsx_runtime.jsx)("div", { className: "relative flex-1 border-t px-4 pt-2", children: navbarItems.map((item) => ((0,jsx_runtime.jsx)(NavbarMobileItem, { item: item, bgActive: bgActive, textActiveColor: textActiveColor, textColor: textColor, setOpen: setOpen }, item.id))) })] }) }) }) }) }) })] }) })] }) }) }));
};
const DraggableNavbarHorizontal = ({ item: { props, id }, ...rest }) => {
    const { menus, pages } = useSite();
    const { mode } = useEditor();
    const menu = menus?.find((m) => m.id === props?.["menu"]?.selected);
    const navbarItems = menu
        ? helpers_navbarItemsRender(JSON.parse(menu?.items), pages)
        : null;
    const fallbackItems = [
        {
            href: "#",
            name: mode === "production" ? "Home" : "Geen menu items gevonden",
            id: 1,
            type: NavbarItemType.Link,
        },
    ];
    return ((0,jsx_runtime.jsxs)("div", { className: props?.className || "w-full", "editor-key": id, "editor-type": "Navigatie", "editor-options": JSON.stringify([
            {
                type: "menu",
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst kleur",
                },
            },
            {
                type: SideEditOptions.BackgroundColor,
                config: {
                    key: "bg-active-item",
                    valueKey: "backgroundColor",
                    defaultValue: "bg-site-400",
                    label: "Kleur active item",
                },
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-active-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst active item kleur",
                },
            },
        ]), "editor-text-color": props?.["text-color"] || "text-black", "editor-bg-active-item": props?.["bg-active-item"] || "bg-site-500", "editor-text-active-color": props?.["text-active-color"] || "text-white", "editor-menu-selected": props?.["menu"]?.selected || null, children: [(0,jsx_runtime.jsx)(NavbarDesktop, { id: id, textColor: props?.["text-color"] || "text-black", bgActive: props?.["bg-active-item"] || "bg-site-500", textActiveColor: props?.["text-active-color"] || "text-white", navbarItems: navbarItems || fallbackItems }), (0,jsx_runtime.jsx)(NavbarMobile, { textColor: props?.["text-color"] || "text-black", bgActive: props?.["bg-active-item"] || "bg-site-500", textActiveColor: props?.["text-active-color"] || "text-white", navbarItems: navbarItems || fallbackItems })] }));
};
/* harmony default export */ var draggableComponents_DraggableNavbarHorizontal = (DraggableNavbarHorizontal);
//# sourceMappingURL=DraggableNavbarHorizontal.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/24/outline/CodeBracketIcon.js
var CodeBracketIcon = __webpack_require__(87381);
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableHtml.js



const DraggableHtml = ({ item: { props, id }, elementId, ...rest }) => {
    const { mode, setDraggableHtmlEditor, setSelectedElement } = useEditor();
    const handelClick = () => {
        setSelectedElement(elementId);
        setDraggableHtmlEditor({
            id,
            elementId,
            html: props?.html || "<div>Html content</div>",
        });
    };
    if (props?.html) {
        if (mode === "editor") {
            return ((0,jsx_runtime.jsxs)("div", { className: "relative", children: [(0,jsx_runtime.jsx)("div", { className: props?.className, dangerouslySetInnerHTML: {
                            __html: props?.html,
                        } }), (0,jsx_runtime.jsx)("div", { className: "bg-app-500/50 absolute inset-0 flex h-full w-full cursor-pointer items-center justify-center text-white opacity-0 hover:opacity-100", onClick: handelClick, children: (0,jsx_runtime.jsxs)("div", { className: "text-app-900 inline-flex items-center rounded-lg border border-transparent p-1 text-xs font-semibold uppercase tracking-wider", children: [(0,jsx_runtime.jsx)(CodeBracketIcon, { className: "mr-2 h-4 w-4", "aria-hidden": "true" }), (0,jsx_runtime.jsx)("span", { children: "Code bewerken" })] }) })] }));
        }
        return ((0,jsx_runtime.jsx)("div", { className: props?.className, dangerouslySetInnerHTML: {
                __html: props?.html,
            } }));
    }
    if (mode === "production")
        return null;
    return ((0,jsx_runtime.jsxs)("div", { className: "hover:border-app-500 relative block w-full cursor-pointer rounded-lg border-2 border-dashed border-gray-300 p-12 text-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2", onClick: handelClick, children: [(0,jsx_runtime.jsx)(CodeBracketIcon, { className: "mx-auto h-8 w-8 text-gray-400" }), (0,jsx_runtime.jsx)("span", { className: "mt-2 block text-sm font-semibold text-gray-900", children: "Klik hier om het HTML blok te bewerken" }), (0,jsx_runtime.jsx)("div", { className: "bg-app-500/50 absolute inset-0 flex h-full w-full cursor-pointer items-center justify-center text-white opacity-0 hover:opacity-100", onClick: handelClick, children: (0,jsx_runtime.jsxs)("div", { className: "text-app-900 inline-flex items-center rounded-lg border border-transparent p-1 text-xs font-semibold uppercase tracking-wider", children: [(0,jsx_runtime.jsx)(CodeBracketIcon, { className: "mr-2 h-4 w-4", "aria-hidden": "true" }), (0,jsx_runtime.jsx)("span", { children: "Code bewerken" })] }) })] }));
};
/* harmony default export */ var draggableComponents_DraggableHtml = (DraggableHtml);
//# sourceMappingURL=DraggableHtml.js.map
;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * lucide-react v0.284.0 - ISC
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * lucide-react v0.284.0 - ISC
 */




const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, children, ...rest }, ref) => (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: `lucide lucide-${toKebabCase(iconName)}`,
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...(Array.isArray(children) ? children : [children]) || []
      ]
    )
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/accessibility.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Accessibility = createLucideIcon("Accessibility", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);


//# sourceMappingURL=accessibility.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/activity-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ActivitySquare = createLucideIcon("ActivitySquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);


//# sourceMappingURL=activity-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/activity.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Activity = createLucideIcon("Activity", [
  ["path", { d: "M22 12h-4l-3 9L9 3l-3 9H2", key: "d5dnw9" }]
]);


//# sourceMappingURL=activity.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/air-vent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AirVent = createLucideIcon("AirVent", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  [
    "path",
    {
      d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12",
      key: "1bo8pg"
    }
  ],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);


//# sourceMappingURL=air-vent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/airplay.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Airplay = createLucideIcon("Airplay", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["polygon", { points: "12 15 17 21 7 21 12 15", key: "1sy95i" }]
]);


//# sourceMappingURL=airplay.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alarm-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlarmCheck = createLucideIcon("AlarmCheck", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);


//# sourceMappingURL=alarm-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alarm-clock-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlarmClockOff = createLucideIcon("AlarmClockOff", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);


//# sourceMappingURL=alarm-clock-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alarm-clock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlarmClock = createLucideIcon("AlarmClock", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);


//# sourceMappingURL=alarm-clock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alarm-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlarmMinus = createLucideIcon("AlarmMinus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);


//# sourceMappingURL=alarm-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alarm-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlarmPlus = createLucideIcon("AlarmPlus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);


//# sourceMappingURL=alarm-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/album.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Album = createLucideIcon("Album", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);


//# sourceMappingURL=album.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alert-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlertCircle = createLucideIcon("AlertCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);


//# sourceMappingURL=alert-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alert-octagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlertOctagon = createLucideIcon("AlertOctagon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);


//# sourceMappingURL=alert-octagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/alert-triangle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlertTriangle = createLucideIcon("AlertTriangle", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
      key: "c3ski4"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);


//# sourceMappingURL=alert-triangle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-center-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignCenterHorizontal = createLucideIcon("AlignCenterHorizontal", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);


//# sourceMappingURL=align-center-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-center-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignCenterVertical = createLucideIcon("AlignCenterVertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);


//# sourceMappingURL=align-center-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-center.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignCenter = createLucideIcon("AlignCenter", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "17", x2: "7", y1: "12", y2: "12", key: "rsh8ii" }],
  ["line", { x1: "19", x2: "5", y1: "18", y2: "18", key: "1t0tuv" }]
]);


//# sourceMappingURL=align-center.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-end-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignEndHorizontal = createLucideIcon("AlignEndHorizontal", [
  [
    "rect",
    { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }
  ],
  [
    "rect",
    { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }
  ],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);


//# sourceMappingURL=align-end-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-end-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignEndVertical = createLucideIcon("AlignEndVertical", [
  [
    "rect",
    { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }
  ],
  [
    "rect",
    { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }
  ],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);


//# sourceMappingURL=align-end-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-distribute-center.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalDistributeCenter = createLucideIcon(
  "AlignHorizontalDistributeCenter",
  [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }
    ],
    ["path", { d: "M17 22v-5", key: "4b6g73" }],
    ["path", { d: "M17 7V2", key: "hnrr36" }],
    ["path", { d: "M7 22v-3", key: "1r4jpn" }],
    ["path", { d: "M7 5V2", key: "liy1u9" }]
  ]
);


//# sourceMappingURL=align-horizontal-distribute-center.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-distribute-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalDistributeEnd = createLucideIcon(
  "AlignHorizontalDistributeEnd",
  [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }
    ],
    ["path", { d: "M10 2v20", key: "uyc634" }],
    ["path", { d: "M20 2v20", key: "1tx262" }]
  ]
);


//# sourceMappingURL=align-horizontal-distribute-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-distribute-start.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalDistributeStart = createLucideIcon(
  "AlignHorizontalDistributeStart",
  [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }
    ],
    ["path", { d: "M4 2v20", key: "gtpd5x" }],
    ["path", { d: "M14 2v20", key: "tg6bpw" }]
  ]
);


//# sourceMappingURL=align-horizontal-distribute-start.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-justify-center.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalJustifyCenter = createLucideIcon(
  "AlignHorizontalJustifyCenter",
  [
    [
      "rect",
      { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }
    ],
    ["path", { d: "M12 2v20", key: "t6zp3m" }]
  ]
);


//# sourceMappingURL=align-horizontal-justify-center.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-justify-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalJustifyEnd = createLucideIcon(
  "AlignHorizontalJustifyEnd",
  [
    [
      "rect",
      { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }
    ],
    ["path", { d: "M22 2v20", key: "40qfg1" }]
  ]
);


//# sourceMappingURL=align-horizontal-justify-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-justify-start.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalJustifyStart = createLucideIcon(
  "AlignHorizontalJustifyStart",
  [
    [
      "rect",
      { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }
    ],
    ["path", { d: "M2 2v20", key: "1ivd8o" }]
  ]
);


//# sourceMappingURL=align-horizontal-justify-start.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-space-around.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalSpaceAround = createLucideIcon(
  "AlignHorizontalSpaceAround",
  [
    [
      "rect",
      { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }
    ],
    ["path", { d: "M4 22V2", key: "tsjzd3" }],
    ["path", { d: "M20 22V2", key: "1bnhr8" }]
  ]
);


//# sourceMappingURL=align-horizontal-space-around.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-horizontal-space-between.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignHorizontalSpaceBetween = createLucideIcon(
  "AlignHorizontalSpaceBetween",
  [
    [
      "rect",
      { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }
    ],
    [
      "rect",
      { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }
    ],
    ["path", { d: "M3 2v20", key: "1d2pfg" }],
    ["path", { d: "M21 2v20", key: "p059bm" }]
  ]
);


//# sourceMappingURL=align-horizontal-space-between.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-justify.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignJustify = createLucideIcon("AlignJustify", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["line", { x1: "3", x2: "21", y1: "18", y2: "18", key: "kwyyxn" }]
]);


//# sourceMappingURL=align-justify.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignLeft = createLucideIcon("AlignLeft", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
  ["line", { x1: "17", x2: "3", y1: "18", y2: "18", key: "1awlsn" }]
]);


//# sourceMappingURL=align-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignRight = createLucideIcon("AlignRight", [
  ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
  ["line", { x1: "21", x2: "7", y1: "18", y2: "18", key: "1g9eri" }]
]);


//# sourceMappingURL=align-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-start-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignStartHorizontal = createLucideIcon("AlignStartHorizontal", [
  [
    "rect",
    { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }
  ],
  [
    "rect",
    { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }
  ],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);


//# sourceMappingURL=align-start-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-start-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignStartVertical = createLucideIcon("AlignStartVertical", [
  [
    "rect",
    { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }
  ],
  [
    "rect",
    { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }
  ],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);


//# sourceMappingURL=align-start-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-distribute-center.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalDistributeCenter = createLucideIcon(
  "AlignVerticalDistributeCenter",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }
    ],
    ["path", { d: "M22 7h-5", key: "o2endc" }],
    ["path", { d: "M7 7H1", key: "105l6j" }],
    ["path", { d: "M22 17h-3", key: "1lwga1" }],
    ["path", { d: "M5 17H2", key: "1gx9xc" }]
  ]
);


//# sourceMappingURL=align-vertical-distribute-center.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-distribute-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalDistributeEnd = createLucideIcon(
  "AlignVerticalDistributeEnd",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }
    ],
    ["path", { d: "M2 20h20", key: "owomy5" }],
    ["path", { d: "M2 10h20", key: "1ir3d8" }]
  ]
);


//# sourceMappingURL=align-vertical-distribute-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-distribute-start.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalDistributeStart = createLucideIcon(
  "AlignVerticalDistributeStart",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }
    ],
    ["path", { d: "M2 14h20", key: "myj16y" }],
    ["path", { d: "M2 4h20", key: "mda7wb" }]
  ]
);


//# sourceMappingURL=align-vertical-distribute-start.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-justify-center.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalJustifyCenter = createLucideIcon(
  "AlignVerticalJustifyCenter",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }
    ],
    ["path", { d: "M2 12h20", key: "9i4pu4" }]
  ]
);


//# sourceMappingURL=align-vertical-justify-center.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-justify-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalJustifyEnd = createLucideIcon("AlignVerticalJustifyEnd", [
  [
    "rect",
    { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }
  ],
  [
    "rect",
    { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }
  ],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);


//# sourceMappingURL=align-vertical-justify-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-justify-start.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalJustifyStart = createLucideIcon(
  "AlignVerticalJustifyStart",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }
    ],
    ["path", { d: "M2 2h20", key: "1ennik" }]
  ]
);


//# sourceMappingURL=align-vertical-justify-start.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-space-around.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalSpaceAround = createLucideIcon("AlignVerticalSpaceAround", [
  [
    "rect",
    { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }
  ],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);


//# sourceMappingURL=align-vertical-space-around.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/align-vertical-space-between.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AlignVerticalSpaceBetween = createLucideIcon(
  "AlignVerticalSpaceBetween",
  [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }
    ],
    ["path", { d: "M2 21h20", key: "1nyx9w" }],
    ["path", { d: "M2 3h20", key: "91anmk" }]
  ]
);


//# sourceMappingURL=align-vertical-space-between.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ampersand.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ampersand = createLucideIcon("Ampersand", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);


//# sourceMappingURL=ampersand.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ampersands.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ampersands = createLucideIcon("Ampersands", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);


//# sourceMappingURL=ampersands.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/anchor.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Anchor = createLucideIcon("Anchor", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "8", key: "abakz7" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }]
]);


//# sourceMappingURL=anchor.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/angry.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Angry = createLucideIcon("Angry", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h0", key: "1vxvly" }],
  ["path", { d: "M15 10h0", key: "1j6oav" }]
]);


//# sourceMappingURL=angry.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/annoyed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Annoyed = createLucideIcon("Annoyed", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);


//# sourceMappingURL=annoyed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/antenna.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Antenna = createLucideIcon("Antenna", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);


//# sourceMappingURL=antenna.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/aperture.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Aperture = createLucideIcon("Aperture", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "14.31", x2: "20.05", y1: "8", y2: "17.94", key: "jdes2e" }],
  ["line", { x1: "9.69", x2: "21.17", y1: "8", y2: "8", key: "1gubuk" }],
  ["line", { x1: "7.38", x2: "13.12", y1: "12", y2: "2.06", key: "1m4d1n" }],
  ["line", { x1: "9.69", x2: "3.95", y1: "16", y2: "6.06", key: "1wye2p" }],
  ["line", { x1: "14.31", x2: "2.83", y1: "16", y2: "16", key: "1l9f4x" }],
  ["line", { x1: "16.62", x2: "10.88", y1: "12", y2: "21.94", key: "1jjvfs" }]
]);


//# sourceMappingURL=aperture.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/app-window.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AppWindow = createLucideIcon("AppWindow", [
  [
    "rect",
    { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }
  ],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);


//# sourceMappingURL=app-window.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/apple.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Apple = createLucideIcon("Apple", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);


//# sourceMappingURL=apple.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/archive-restore.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArchiveRestore = createLucideIcon("ArchiveRestore", [
  [
    "rect",
    { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }
  ],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);


//# sourceMappingURL=archive-restore.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/archive-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArchiveX = createLucideIcon("ArchiveX", [
  [
    "rect",
    { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }
  ],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);


//# sourceMappingURL=archive-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/archive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Archive = createLucideIcon("Archive", [
  [
    "rect",
    { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }
  ],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);


//# sourceMappingURL=archive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/area-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AreaChart = createLucideIcon("AreaChart", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 12v5h12V8l-5 5-4-4Z", key: "zxz28u" }]
]);


//# sourceMappingURL=area-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/armchair.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Armchair = createLucideIcon("Armchair", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 11v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z",
      key: "1ed1m0"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);


//# sourceMappingURL=armchair.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-down-dash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigDownDash = createLucideIcon("ArrowBigDownDash", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9h6z", key: "oscb9h" }]
]);


//# sourceMappingURL=arrow-big-down-dash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigDown = createLucideIcon("ArrowBigDown", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);


//# sourceMappingURL=arrow-big-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-left-dash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigLeftDash = createLucideIcon("ArrowBigLeftDash", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);


//# sourceMappingURL=arrow-big-left-dash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigLeft = createLucideIcon("ArrowBigLeft", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);


//# sourceMappingURL=arrow-big-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-right-dash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigRightDash = createLucideIcon("ArrowBigRightDash", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);


//# sourceMappingURL=arrow-big-right-dash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigRight = createLucideIcon("ArrowBigRight", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);


//# sourceMappingURL=arrow-big-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-up-dash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigUpDash = createLucideIcon("ArrowBigUpDash", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);


//# sourceMappingURL=arrow-big-up-dash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-big-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowBigUp = createLucideIcon("ArrowBigUp", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);


//# sourceMappingURL=arrow-big-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-0-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDown01 = createLucideIcon("ArrowDown01", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  [
    "rect",
    { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }
  ],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);


//# sourceMappingURL=arrow-down-0-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-1-0.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDown10 = createLucideIcon("ArrowDown10", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  [
    "rect",
    { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }
  ]
]);


//# sourceMappingURL=arrow-down-1-0.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-a-z.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownAZ = createLucideIcon("ArrowDownAZ", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);


//# sourceMappingURL=arrow-down-a-z.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownCircle = createLucideIcon("ArrowDownCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);


//# sourceMappingURL=arrow-down-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-from-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownFromLine = createLucideIcon("ArrowDownFromLine", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);


//# sourceMappingURL=arrow-down-from-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-left-from-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownLeftFromCircle = createLucideIcon("ArrowDownLeftFromCircle", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);


//# sourceMappingURL=arrow-down-left-from-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-left-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownLeftSquare = createLucideIcon("ArrowDownLeftSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);


//# sourceMappingURL=arrow-down-left-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownLeft = createLucideIcon("ArrowDownLeft", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);


//# sourceMappingURL=arrow-down-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-narrow-wide.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownNarrowWide = createLucideIcon("ArrowDownNarrowWide", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);


//# sourceMappingURL=arrow-down-narrow-wide.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-right-from-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownRightFromCircle = createLucideIcon("ArrowDownRightFromCircle", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);


//# sourceMappingURL=arrow-down-right-from-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-right-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownRightSquare = createLucideIcon("ArrowDownRightSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);


//# sourceMappingURL=arrow-down-right-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownRight = createLucideIcon("ArrowDownRight", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);


//# sourceMappingURL=arrow-down-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownSquare = createLucideIcon("ArrowDownSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);


//# sourceMappingURL=arrow-down-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-to-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownToDot = createLucideIcon("ArrowDownToDot", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);


//# sourceMappingURL=arrow-down-to-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-to-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownToLine = createLucideIcon("ArrowDownToLine", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);


//# sourceMappingURL=arrow-down-to-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownUp = createLucideIcon("ArrowDownUp", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);


//# sourceMappingURL=arrow-down-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-wide-narrow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownWideNarrow = createLucideIcon("ArrowDownWideNarrow", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);


//# sourceMappingURL=arrow-down-wide-narrow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down-z-a.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDownZA = createLucideIcon("ArrowDownZA", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);


//# sourceMappingURL=arrow-down-z-a.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowDown = createLucideIcon("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);


//# sourceMappingURL=arrow-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeftCircle = createLucideIcon("ArrowLeftCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);


//# sourceMappingURL=arrow-left-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left-from-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeftFromLine = createLucideIcon("ArrowLeftFromLine", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);


//# sourceMappingURL=arrow-left-from-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeftRight = createLucideIcon("ArrowLeftRight", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);


//# sourceMappingURL=arrow-left-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeftSquare = createLucideIcon("ArrowLeftSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);


//# sourceMappingURL=arrow-left-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left-to-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeftToLine = createLucideIcon("ArrowLeftToLine", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);


//# sourceMappingURL=arrow-left-to-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowLeft = createLucideIcon("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);


//# sourceMappingURL=arrow-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRightCircle = createLucideIcon("ArrowRightCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);


//# sourceMappingURL=arrow-right-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right-from-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRightFromLine = createLucideIcon("ArrowRightFromLine", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);


//# sourceMappingURL=arrow-right-from-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRightLeft = createLucideIcon("ArrowRightLeft", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);


//# sourceMappingURL=arrow-right-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRightSquare = createLucideIcon("ArrowRightSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);


//# sourceMappingURL=arrow-right-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right-to-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRightToLine = createLucideIcon("ArrowRightToLine", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);


//# sourceMappingURL=arrow-right-to-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowRight = createLucideIcon("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);


//# sourceMappingURL=arrow-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-0-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUp01 = createLucideIcon("ArrowUp01", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  [
    "rect",
    { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }
  ],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);


//# sourceMappingURL=arrow-up-0-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-1-0.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUp10 = createLucideIcon("ArrowUp10", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  [
    "rect",
    { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }
  ]
]);


//# sourceMappingURL=arrow-up-1-0.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-a-z.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpAZ = createLucideIcon("ArrowUpAZ", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);


//# sourceMappingURL=arrow-up-a-z.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpCircle = createLucideIcon("ArrowUpCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);


//# sourceMappingURL=arrow-up-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpDown = createLucideIcon("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);


//# sourceMappingURL=arrow-up-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-from-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpFromDot = createLucideIcon("ArrowUpFromDot", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);


//# sourceMappingURL=arrow-up-from-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-from-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpFromLine = createLucideIcon("ArrowUpFromLine", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);


//# sourceMappingURL=arrow-up-from-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-left-from-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpLeftFromCircle = createLucideIcon("ArrowUpLeftFromCircle", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);


//# sourceMappingURL=arrow-up-left-from-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-left-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpLeftSquare = createLucideIcon("ArrowUpLeftSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);


//# sourceMappingURL=arrow-up-left-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpLeft = createLucideIcon("ArrowUpLeft", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);


//# sourceMappingURL=arrow-up-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-narrow-wide.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpNarrowWide = createLucideIcon("ArrowUpNarrowWide", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);


//# sourceMappingURL=arrow-up-narrow-wide.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-right-from-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpRightFromCircle = createLucideIcon("ArrowUpRightFromCircle", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);


//# sourceMappingURL=arrow-up-right-from-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-right-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpRightSquare = createLucideIcon("ArrowUpRightSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);


//# sourceMappingURL=arrow-up-right-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpRight = createLucideIcon("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);


//# sourceMappingURL=arrow-up-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpSquare = createLucideIcon("ArrowUpSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);


//# sourceMappingURL=arrow-up-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-to-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpToLine = createLucideIcon("ArrowUpToLine", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);


//# sourceMappingURL=arrow-up-to-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-wide-narrow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpWideNarrow = createLucideIcon("ArrowUpWideNarrow", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);


//# sourceMappingURL=arrow-up-wide-narrow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up-z-a.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUpZA = createLucideIcon("ArrowUpZA", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);


//# sourceMappingURL=arrow-up-z-a.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrow-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowUp = createLucideIcon("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);


//# sourceMappingURL=arrow-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/arrows-up-from-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ArrowsUpFromLine = createLucideIcon("ArrowsUpFromLine", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);


//# sourceMappingURL=arrows-up-from-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/asterisk.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Asterisk = createLucideIcon("Asterisk", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);


//# sourceMappingURL=asterisk.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/at-sign.js
/**
 * lucide-react v0.284.0 - ISC
 */



const AtSign = createLucideIcon("AtSign", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);


//# sourceMappingURL=at-sign.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/atom.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Atom = createLucideIcon("Atom", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);


//# sourceMappingURL=atom.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/award.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Award = createLucideIcon("Award", [
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }],
  ["path", { d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11", key: "em7aur" }]
]);


//# sourceMappingURL=award.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/axe.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Axe = createLucideIcon("Axe", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);


//# sourceMappingURL=axe.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/axis-3d.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Axis3d = createLucideIcon("Axis3d", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);


//# sourceMappingURL=axis-3d.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/baby.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Baby = createLucideIcon("Baby", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);


//# sourceMappingURL=baby.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/backpack.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Backpack = createLucideIcon("Backpack", [
  [
    "path",
    {
      d: "M4 20V10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z",
      key: "tunmdx"
    }
  ],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }],
  ["path", { d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5", key: "xk3gvk" }],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }]
]);


//# sourceMappingURL=backpack.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-alert.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeAlert = createLucideIcon("BadgeAlert", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);


//# sourceMappingURL=badge-alert.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-cent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeCent = createLucideIcon("BadgeCent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);


//# sourceMappingURL=badge-cent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeCheck = createLucideIcon("BadgeCheck", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);


//# sourceMappingURL=badge-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-dollar-sign.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeDollarSign = createLucideIcon("BadgeDollarSign", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);


//# sourceMappingURL=badge-dollar-sign.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-euro.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeEuro = createLucideIcon("BadgeEuro", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);


//# sourceMappingURL=badge-euro.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-help.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeHelp = createLucideIcon("BadgeHelp", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);


//# sourceMappingURL=badge-help.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-indian-rupee.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeIndianRupee = createLucideIcon("BadgeIndianRupee", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);


//# sourceMappingURL=badge-indian-rupee.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-info.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeInfo = createLucideIcon("BadgeInfo", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);


//# sourceMappingURL=badge-info.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-japanese-yen.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeJapaneseYen = createLucideIcon("BadgeJapaneseYen", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);


//# sourceMappingURL=badge-japanese-yen.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeMinus = createLucideIcon("BadgeMinus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);


//# sourceMappingURL=badge-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-percent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgePercent = createLucideIcon("BadgePercent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);


//# sourceMappingURL=badge-percent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgePlus = createLucideIcon("BadgePlus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);


//# sourceMappingURL=badge-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-pound-sterling.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgePoundSterling = createLucideIcon("BadgePoundSterling", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);


//# sourceMappingURL=badge-pound-sterling.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-russian-ruble.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeRussianRuble = createLucideIcon("BadgeRussianRuble", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);


//# sourceMappingURL=badge-russian-ruble.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-swiss-franc.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeSwissFranc = createLucideIcon("BadgeSwissFranc", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);


//# sourceMappingURL=badge-swiss-franc.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BadgeX = createLucideIcon("BadgeX", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);


//# sourceMappingURL=badge-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/badge.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Badge = createLucideIcon("Badge", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);


//# sourceMappingURL=badge.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/baggage-claim.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BaggageClaim = createLucideIcon("BaggageClaim", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  [
    "rect",
    { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }
  ],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);


//# sourceMappingURL=baggage-claim.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ban.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ban = createLucideIcon("Ban", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);


//# sourceMappingURL=ban.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/banana.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Banana = createLucideIcon("Banana", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);


//# sourceMappingURL=banana.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/banknote.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Banknote = createLucideIcon("Banknote", [
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }
  ],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);


//# sourceMappingURL=banknote.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChart2 = createLucideIcon("BarChart2", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);


//# sourceMappingURL=bar-chart-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChart3 = createLucideIcon("BarChart3", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);


//# sourceMappingURL=bar-chart-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChart4 = createLucideIcon("BarChart4", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);


//# sourceMappingURL=bar-chart-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-big.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChartBig = createLucideIcon("BarChartBig", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  [
    "rect",
    { width: "4", height: "7", x: "7", y: "10", rx: "1", key: "14u6mf" }
  ],
  [
    "rect",
    { width: "4", height: "12", x: "15", y: "5", rx: "1", key: "b3pek6" }
  ]
]);


//# sourceMappingURL=bar-chart-big.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-horizontal-big.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChartHorizontalBig = createLucideIcon("BarChartHorizontalBig", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  [
    "rect",
    { width: "12", height: "4", x: "7", y: "5", rx: "1", key: "936jl1" }
  ],
  [
    "rect",
    { width: "7", height: "4", x: "7", y: "13", rx: "1", key: "jqfkpy" }
  ]
]);


//# sourceMappingURL=bar-chart-horizontal-big.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChartHorizontal = createLucideIcon("BarChartHorizontal", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);


//# sourceMappingURL=bar-chart-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bar-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BarChart = createLucideIcon("BarChart", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);


//# sourceMappingURL=bar-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/barcode.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Barcode = createLucideIcon("Barcode", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);


//# sourceMappingURL=barcode.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/baseline.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Baseline = createLucideIcon("Baseline", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);


//# sourceMappingURL=baseline.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bath.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bath = createLucideIcon("Bath", [
  [
    "path",
    {
      d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "1r8yf5"
    }
  ],
  ["line", { x1: "10", x2: "8", y1: "5", y2: "7", key: "h5g8z4" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "7", x2: "7", y1: "19", y2: "21", key: "16jp00" }],
  ["line", { x1: "17", x2: "17", y1: "19", y2: "21", key: "1pxrnk" }]
]);


//# sourceMappingURL=bath.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery-charging.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BatteryCharging = createLucideIcon("BatteryCharging", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);


//# sourceMappingURL=battery-charging.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery-full.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BatteryFull = createLucideIcon("BatteryFull", [
  [
    "rect",
    {
      width: "16",
      height: "10",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "1w10f2"
    }
  ],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);


//# sourceMappingURL=battery-full.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery-low.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BatteryLow = createLucideIcon("BatteryLow", [
  [
    "rect",
    {
      width: "16",
      height: "10",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "1w10f2"
    }
  ],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);


//# sourceMappingURL=battery-low.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery-medium.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BatteryMedium = createLucideIcon("BatteryMedium", [
  [
    "rect",
    {
      width: "16",
      height: "10",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "1w10f2"
    }
  ],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);


//# sourceMappingURL=battery-medium.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery-warning.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BatteryWarning = createLucideIcon("BatteryWarning", [
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2", key: "1if82c" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2", key: "2pdlyl" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "10", x2: "10", y1: "7", y2: "13", key: "1uzyus" }],
  ["line", { x1: "10", x2: "10", y1: "17", y2: "17.01", key: "1y8k4g" }]
]);


//# sourceMappingURL=battery-warning.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/battery.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Battery = createLucideIcon("Battery", [
  [
    "rect",
    {
      width: "16",
      height: "10",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "1w10f2"
    }
  ],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);


//# sourceMappingURL=battery.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/beaker.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Beaker = createLucideIcon("Beaker", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);


//# sourceMappingURL=beaker.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bean-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BeanOff = createLucideIcon("BeanOff", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  [
    "path",
    {
      d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66",
      key: "17ccse"
    }
  ],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=bean-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bean.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bean = createLucideIcon("Bean", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);


//# sourceMappingURL=bean.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bed-double.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BedDouble = createLucideIcon("BedDouble", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);


//# sourceMappingURL=bed-double.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bed-single.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BedSingle = createLucideIcon("BedSingle", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);


//# sourceMappingURL=bed-single.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bed = createLucideIcon("Bed", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);


//# sourceMappingURL=bed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/beef.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Beef = createLucideIcon("Beef", [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
]);


//# sourceMappingURL=beef.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/beer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Beer = createLucideIcon("Beer", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);


//# sourceMappingURL=beer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BellDot = createLucideIcon("BellDot", [
  [
    "path",
    {
      d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3",
      key: "xcehk"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);


//# sourceMappingURL=bell-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BellMinus = createLucideIcon("BellMinus", [
  [
    "path",
    {
      d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2",
      key: "eck70s"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }]
]);


//# sourceMappingURL=bell-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BellOff = createLucideIcon("BellOff", [
  ["path", { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5", key: "o7mx20" }],
  ["path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", key: "16f1lm" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);


//# sourceMappingURL=bell-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BellPlus = createLucideIcon("BellPlus", [
  [
    "path",
    {
      d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
      key: "guizqy"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }]
]);


//# sourceMappingURL=bell-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell-ring.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BellRing = createLucideIcon("BellRing", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }]
]);


//# sourceMappingURL=bell-ring.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bell.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bell = createLucideIcon("Bell", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }]
]);


//# sourceMappingURL=bell.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bike.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bike = createLucideIcon("Bike", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);


//# sourceMappingURL=bike.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/binary.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Binary = createLucideIcon("Binary", [
  [
    "rect",
    { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }
  ],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);


//# sourceMappingURL=binary.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/biohazard.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Biohazard = createLucideIcon("Biohazard", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  [
    "path",
    { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }
  ],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  [
    "path",
    {
      d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5",
      key: "wtwa5u"
    }
  ],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  [
    "path",
    {
      d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2",
      key: "m7qszh"
    }
  ],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);


//# sourceMappingURL=biohazard.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bird.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bird = createLucideIcon("Bird", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  [
    "path",
    { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }
  ],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);


//# sourceMappingURL=bird.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bitcoin.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bitcoin = createLucideIcon("Bitcoin", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);


//# sourceMappingURL=bitcoin.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/blinds.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Blinds = createLucideIcon("Blinds", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);


//# sourceMappingURL=blinds.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/blocks.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Blocks = createLucideIcon("Blocks", [
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }
  ],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);


//# sourceMappingURL=blocks.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bluetooth-connected.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BluetoothConnected = createLucideIcon("BluetoothConnected", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);


//# sourceMappingURL=bluetooth-connected.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bluetooth-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BluetoothOff = createLucideIcon("BluetoothOff", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);


//# sourceMappingURL=bluetooth-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bluetooth-searching.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BluetoothSearching = createLucideIcon("BluetoothSearching", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);


//# sourceMappingURL=bluetooth-searching.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bluetooth.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bluetooth = createLucideIcon("Bluetooth", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);


//# sourceMappingURL=bluetooth.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bold.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bold = createLucideIcon("Bold", [
  ["path", { d: "M14 12a4 4 0 0 0 0-8H6v8", key: "v2sylx" }],
  ["path", { d: "M15 20a4 4 0 0 0 0-8H6v8Z", key: "1ef5ya" }]
]);


//# sourceMappingURL=bold.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bomb.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bomb = createLucideIcon("Bomb", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "m19.5 9.5 1.8-1.8a2.4 2.4 0 0 0 0-3.4l-1.6-1.6a2.4 2.4 0 0 0-3.4 0l-1.8 1.8",
      key: "h0vzly"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);


//# sourceMappingURL=bomb.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bone = createLucideIcon("Bone", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);


//# sourceMappingURL=bone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-copy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookCopy = createLucideIcon("BookCopy", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }],
  [
    "path",
    { d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12", key: "1owzki" }
  ]
]);


//# sourceMappingURL=book-copy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookDown = createLucideIcon("BookDown", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);


//# sourceMappingURL=book-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-key.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookKey = createLucideIcon("BookKey", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["path", { d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20", key: "zb0ngp" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "m19 3 1 1", key: "ze14oc" }]
]);


//# sourceMappingURL=book-key.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-lock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookLock = createLucideIcon("BookLock", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["path", { d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20", key: "dpch1j" }],
  [
    "rect",
    { width: "8", height: "5", x: "12", y: "6", rx: "1", key: "9nqwug" }
  ],
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }]
]);


//# sourceMappingURL=book-lock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-marked.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookMarked = createLucideIcon("BookMarked", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["polyline", { points: "10 2 10 10 13 7 16 10 16 2", key: "13o6vz" }]
]);


//# sourceMappingURL=book-marked.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookMinus = createLucideIcon("BookMinus", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);


//# sourceMappingURL=book-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-open-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookOpenCheck = createLucideIcon("BookOpenCheck", [
  [
    "path",
    { d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z", key: "1i8u0n" }
  ],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3",
      key: "jb5l51"
    }
  ]
]);


//# sourceMappingURL=book-open-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookOpen = createLucideIcon("BookOpen", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }]
]);


//# sourceMappingURL=book-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookPlus = createLucideIcon("BookPlus", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }]
]);


//# sourceMappingURL=book-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-template.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookTemplate = createLucideIcon("BookTemplate", [
  ["path", { d: "M20 22h-2", key: "1rpnb6" }],
  ["path", { d: "M20 15v2h-2", key: "fph276" }],
  ["path", { d: "M4 19.5V15", key: "6gr39e" }],
  ["path", { d: "M20 8v3", key: "deu0bs" }],
  ["path", { d: "M18 2h2v2", key: "180o53" }],
  ["path", { d: "M4 11V9", key: "v3xsx8" }],
  ["path", { d: "M12 2h2", key: "cvn524" }],
  ["path", { d: "M12 22h2", key: "kn7ki6" }],
  ["path", { d: "M12 17h2", key: "13u4lk" }],
  ["path", { d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8", key: "fiseg2" }],
  ["path", { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", key: "wywhs9" }]
]);


//# sourceMappingURL=book-template.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-up-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookUp2 = createLucideIcon("BookUp2", [
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "1nfm9i" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);


//# sourceMappingURL=book-up-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookUp = createLucideIcon("BookUp", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);


//# sourceMappingURL=book-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookX = createLucideIcon("BookX", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ],
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);


//# sourceMappingURL=book-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/book.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Book = createLucideIcon("Book", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
      key: "t4utmx"
    }
  ]
]);


//# sourceMappingURL=book.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bookmark-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookmarkCheck = createLucideIcon("BookmarkCheck", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);


//# sourceMappingURL=bookmark-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bookmark-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookmarkMinus = createLucideIcon("BookmarkMinus", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }
  ],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);


//# sourceMappingURL=bookmark-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bookmark-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookmarkPlus = createLucideIcon("BookmarkPlus", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }
  ],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);


//# sourceMappingURL=bookmark-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bookmark-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BookmarkX = createLucideIcon("BookmarkX", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);


//# sourceMappingURL=bookmark-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bookmark.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bookmark = createLucideIcon("Bookmark", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }
  ]
]);


//# sourceMappingURL=bookmark.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/boom-box.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BoomBox = createLucideIcon("BoomBox", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }
  ],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);


//# sourceMappingURL=boom-box.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bot = createLucideIcon("Bot", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  [
    "rect",
    { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }
  ],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);


//# sourceMappingURL=bot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/box-select.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BoxSelect = createLucideIcon("BoxSelect", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);


//# sourceMappingURL=box-select.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/box.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Box = createLucideIcon("Box", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);


//# sourceMappingURL=box.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/boxes.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Boxes = createLucideIcon("Boxes", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);


//# sourceMappingURL=boxes.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/braces.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Braces = createLucideIcon("Braces", [
  [
    "path",
    {
      d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1",
      key: "ezmyqa"
    }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);


//# sourceMappingURL=braces.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/brackets.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Brackets = createLucideIcon("Brackets", [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
]);


//# sourceMappingURL=brackets.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/brain-circuit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BrainCircuit = createLucideIcon("BrainCircuit", [
  [
    "path",
    {
      d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08 2.5 2.5 0 0 0 4.91.05L12 20V4.5Z",
      key: "ixwj2a"
    }
  ],
  ["path", { d: "M16 8V5c0-1.1.9-2 2-2", key: "13dx7u" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M20.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", key: "1s25gz" }],
  ["path", { d: "M16.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", key: "127460" }],
  ["path", { d: "M20.5 21a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", key: "fys062" }],
  ["path", { d: "M18.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z", key: "1vib61" }]
]);


//# sourceMappingURL=brain-circuit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/brain-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BrainCog = createLucideIcon("BrainCog", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08A2.5 2.5 0 0 0 12 19.5a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 12 4.5",
      key: "1f4le0"
    }
  ],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);


//# sourceMappingURL=brain-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/brain.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Brain = createLucideIcon("Brain", [
  [
    "path",
    {
      d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z",
      key: "1mhkh5"
    }
  ],
  [
    "path",
    {
      d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z",
      key: "1d6s00"
    }
  ]
]);


//# sourceMappingURL=brain.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/briefcase.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Briefcase = createLucideIcon("Briefcase", [
  [
    "rect",
    {
      width: "20",
      height: "14",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "eto64e"
    }
  ],
  ["path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "zwj3tp" }]
]);


//# sourceMappingURL=briefcase.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bring-to-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BringToFront = createLucideIcon("BringToFront", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  [
    "path",
    { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }
  ],
  [
    "path",
    {
      d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2",
      key: "1q24h9"
    }
  ]
]);


//# sourceMappingURL=bring-to-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/brush.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Brush = createLucideIcon("Brush", [
  [
    "path",
    {
      d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08",
      key: "1styjt"
    }
  ],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);


//# sourceMappingURL=brush.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bug-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BugOff = createLucideIcon("BugOff", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }
  ],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);


//# sourceMappingURL=bug-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bug-play.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BugPlay = createLucideIcon("BugPlay", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5",
      key: "1tjixy"
    }
  ],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m12 12 8 5-8 5Z", key: "1ydf81" }]
]);


//# sourceMappingURL=bug-play.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bug.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bug = createLucideIcon("Bug", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);


//# sourceMappingURL=bug.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/building-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Building2 = createLucideIcon("Building2", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);


//# sourceMappingURL=building-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/building.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Building = createLucideIcon("Building", [
  [
    "rect",
    {
      width: "16",
      height: "20",
      x: "4",
      y: "2",
      rx: "2",
      ry: "2",
      key: "76otgf"
    }
  ],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);


//# sourceMappingURL=building.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bus-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const BusFront = createLucideIcon("BusFront", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  [
    "rect",
    { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }
  ],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);


//# sourceMappingURL=bus-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/bus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Bus = createLucideIcon("Bus", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);


//# sourceMappingURL=bus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cable-car.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CableCar = createLucideIcon("CableCar", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  [
    "rect",
    { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);


//# sourceMappingURL=cable-car.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cable.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cable = createLucideIcon("Cable", [
  ["path", { d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z", key: "1s6oa5" }],
  ["path", { d: "M3 5V3", key: "1k5hjh" }],
  ["path", { d: "M7 5V3", key: "1t1388" }],
  [
    "path",
    { d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9", key: "1ytv72" }
  ],
  ["path", { d: "M17 21v-2", key: "ds4u3f" }],
  ["path", { d: "M21 21v-2", key: "eo0ou" }],
  ["path", { d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z", key: "sdz6o8" }]
]);


//# sourceMappingURL=cable.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cake-slice.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CakeSlice = createLucideIcon("CakeSlice", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    {
      d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6",
      key: "xle13f"
    }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);


//# sourceMappingURL=cake-slice.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cake.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cake = createLucideIcon("Cake", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  [
    "path",
    {
      d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1",
      key: "n2jgmb"
    }
  ],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v2", key: "kqglng" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M17 8v2", key: "teptal" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
]);


//# sourceMappingURL=cake.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calculator.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Calculator = createLucideIcon("Calculator", [
  [
    "rect",
    { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }
  ],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);


//# sourceMappingURL=calculator.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-check-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarCheck2 = createLucideIcon("CalendarCheck2", [
  [
    "path",
    {
      d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
      key: "bce9hv"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);


//# sourceMappingURL=calendar-check-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarCheck = createLucideIcon("CalendarCheck", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "eu3xkr"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);


//# sourceMappingURL=calendar-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-clock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarClock = createLucideIcon("CalendarClock", [
  [
    "path",
    {
      d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
      key: "1osxxc"
    }
  ],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.25V14", key: "re2vv1" }],
  ["path", { d: "M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z", key: "ame013" }]
]);


//# sourceMappingURL=calendar-clock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-days.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarDays = createLucideIcon("CalendarDays", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "eu3xkr"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);


//# sourceMappingURL=calendar-days.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-heart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarHeart = createLucideIcon("CalendarHeart", [
  [
    "path",
    {
      d: "M21 10V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h7",
      key: "1sfrvf"
    }
  ],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);


//# sourceMappingURL=calendar-heart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarMinus = createLucideIcon("CalendarMinus", [
  [
    "path",
    {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
      key: "3spt84"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["line", { x1: "16", x2: "22", y1: "19", y2: "19", key: "1g9955" }]
]);


//# sourceMappingURL=calendar-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarOff = createLucideIcon("CalendarOff", [
  [
    "path",
    {
      d: "M4.18 4.18A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18",
      key: "1feomx"
    }
  ],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=calendar-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarPlus = createLucideIcon("CalendarPlus", [
  [
    "path",
    {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
      key: "3spt84"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["line", { x1: "19", x2: "19", y1: "16", y2: "22", key: "1ttwzi" }],
  ["line", { x1: "16", x2: "22", y1: "19", y2: "19", key: "1g9955" }]
]);


//# sourceMappingURL=calendar-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-range.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarRange = createLucideIcon("CalendarRange", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "eu3xkr"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);


//# sourceMappingURL=calendar-range.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarSearch = createLucideIcon("CalendarSearch", [
  [
    "path",
    {
      d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h7.5",
      key: "18ncp8"
    }
  ],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", key: "mgbru4" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);


//# sourceMappingURL=calendar-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-x-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarX2 = createLucideIcon("CalendarX2", [
  [
    "path",
    {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
      key: "3spt84"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["line", { x1: "17", x2: "22", y1: "17", y2: "22", key: "xa9o8b" }],
  ["line", { x1: "17", x2: "22", y1: "22", y2: "17", key: "18nitg" }]
]);


//# sourceMappingURL=calendar-x-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CalendarX = createLucideIcon("CalendarX", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "eu3xkr"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }],
  ["line", { x1: "10", x2: "14", y1: "14", y2: "18", key: "1g3qc0" }],
  ["line", { x1: "14", x2: "10", y1: "14", y2: "18", key: "1az83m" }]
]);


//# sourceMappingURL=calendar-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/calendar.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Calendar = createLucideIcon("Calendar", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "eu3xkr"
    }
  ],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "6", key: "m3sa8f" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "6", key: "18kwsl" }],
  ["line", { x1: "3", x2: "21", y1: "10", y2: "10", key: "xt86sb" }]
]);


//# sourceMappingURL=calendar.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/camera-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CameraOff = createLucideIcon("CameraOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);


//# sourceMappingURL=camera-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/camera.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Camera = createLucideIcon("Camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);


//# sourceMappingURL=camera.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/candlestick-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CandlestickChart = createLucideIcon("CandlestickChart", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  [
    "rect",
    { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }
  ],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);


//# sourceMappingURL=candlestick-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/candy-cane.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CandyCane = createLucideIcon("CandyCane", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);


//# sourceMappingURL=candy-cane.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/candy-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CandyOff = createLucideIcon("CandyOff", [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    {
      d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657",
      key: "1sbrv4"
    }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=candy-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/candy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Candy = createLucideIcon("Candy", [
  [
    "path",
    {
      d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z",
      key: "ue6khb"
    }
  ],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1",
      key: "b9cp6k"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1",
      key: "5lney8"
    }
  ]
]);


//# sourceMappingURL=candy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/car-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CarFront = createLucideIcon("CarFront", [
  [
    "path",
    {
      d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
      key: "1imjwt"
    }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "rect",
    { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);


//# sourceMappingURL=car-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/car-taxi-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CarTaxiFront = createLucideIcon("CarTaxiFront", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    {
      d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
      key: "1imjwt"
    }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "rect",
    { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);


//# sourceMappingURL=car-taxi-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/car.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Car = createLucideIcon("Car", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);


//# sourceMappingURL=car.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/caravan.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Caravan = createLucideIcon("Caravan", [
  ["rect", { width: "4", height: "4", x: "2", y: "9", key: "1vcvhd" }],
  ["rect", { width: "4", height: "10", x: "10", y: "9", key: "1b7ev2" }],
  [
    "path",
    {
      d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2",
      key: "19jm3t"
    }
  ],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }],
  ["path", { d: "M10 19h12v-2", key: "1yu2qx" }]
]);


//# sourceMappingURL=caravan.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/carrot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Carrot = createLucideIcon("Carrot", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  [
    "path",
    {
      d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z",
      key: "6b25w4"
    }
  ],
  [
    "path",
    {
      d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z",
      key: "fn65lo"
    }
  ]
]);


//# sourceMappingURL=carrot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/case-lower.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CaseLower = createLucideIcon("CaseLower", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);


//# sourceMappingURL=case-lower.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/case-sensitive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CaseSensitive = createLucideIcon("CaseSensitive", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);


//# sourceMappingURL=case-sensitive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/case-upper.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CaseUpper = createLucideIcon("CaseUpper", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  [
    "path",
    { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }
  ]
]);


//# sourceMappingURL=case-upper.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cassette-tape.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CassetteTape = createLucideIcon("CassetteTape", [
  [
    "rect",
    { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }
  ],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  [
    "path",
    {
      d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3",
      key: "l01ucn"
    }
  ]
]);


//# sourceMappingURL=cassette-tape.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cast.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cast = createLucideIcon("Cast", [
  [
    "path",
    {
      d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6",
      key: "3zrzxg"
    }
  ],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);


//# sourceMappingURL=cast.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/castle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Castle = createLucideIcon("Castle", [
  [
    "path",
    { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }
  ],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4", key: "jdggr9" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);


//# sourceMappingURL=castle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cat = createLucideIcon("Cat", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);


//# sourceMappingURL=cat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/check-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CheckCheck = createLucideIcon("CheckCheck", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);


//# sourceMappingURL=check-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/check-circle-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CheckCircle2 = createLucideIcon("CheckCircle2", [
  [
    "path",
    {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
      key: "14v8dr"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);


//# sourceMappingURL=check-circle-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/check-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CheckCircle = createLucideIcon("CheckCircle", [
  ["path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14", key: "g774vq" }],
  ["polyline", { points: "22 4 12 14.01 9 11.01", key: "6xbx8j" }]
]);


//# sourceMappingURL=check-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/check-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CheckSquare = createLucideIcon("CheckSquare", [
  ["polyline", { points: "9 11 12 14 22 4", key: "19ybtz" }],
  [
    "path",
    {
      d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
      key: "1jnkn4"
    }
  ]
]);


//# sourceMappingURL=check-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Check = createLucideIcon("Check", [
  ["polyline", { points: "20 6 9 17 4 12", key: "10jjfj" }]
]);


//# sourceMappingURL=check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chef-hat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChefHat = createLucideIcon("ChefHat", [
  [
    "path",
    {
      d: "M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z",
      key: "z3ra2g"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "17", y2: "17", key: "12q60k" }]
]);


//# sourceMappingURL=chef-hat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cherry.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cherry = createLucideIcon("Cherry", [
  [
    "path",
    {
      d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
      key: "cvxqlc"
    }
  ],
  [
    "path",
    {
      d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
      key: "1ostrc"
    }
  ],
  [
    "path",
    {
      d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12",
      key: "hqx58h"
    }
  ],
  [
    "path",
    { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }
  ]
]);


//# sourceMappingURL=cherry.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-down-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronDownCircle = createLucideIcon("ChevronDownCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);


//# sourceMappingURL=chevron-down-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-down-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronDownSquare = createLucideIcon("ChevronDownSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);


//# sourceMappingURL=chevron-down-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronDown = createLucideIcon("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);


//# sourceMappingURL=chevron-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-first.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronFirst = createLucideIcon("ChevronFirst", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);


//# sourceMappingURL=chevron-first.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-last.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronLast = createLucideIcon("ChevronLast", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);


//# sourceMappingURL=chevron-last.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-left-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronLeftCircle = createLucideIcon("ChevronLeftCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);


//# sourceMappingURL=chevron-left-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-left-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronLeftSquare = createLucideIcon("ChevronLeftSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);


//# sourceMappingURL=chevron-left-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronLeft = createLucideIcon("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);


//# sourceMappingURL=chevron-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-right-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronRightCircle = createLucideIcon("ChevronRightCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);


//# sourceMappingURL=chevron-right-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-right-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronRightSquare = createLucideIcon("ChevronRightSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);


//# sourceMappingURL=chevron-right-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronRight = createLucideIcon("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);


//# sourceMappingURL=chevron-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-up-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronUpCircle = createLucideIcon("ChevronUpCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);


//# sourceMappingURL=chevron-up-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-up-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronUpSquare = createLucideIcon("ChevronUpSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);


//# sourceMappingURL=chevron-up-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevron-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronUp = createLucideIcon("ChevronUp", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);


//# sourceMappingURL=chevron-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-down-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsDownUp = createLucideIcon("ChevronsDownUp", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);


//# sourceMappingURL=chevrons-down-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsDown = createLucideIcon("ChevronsDown", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);


//# sourceMappingURL=chevrons-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-left-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsLeftRight = createLucideIcon("ChevronsLeftRight", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);


//# sourceMappingURL=chevrons-left-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsLeft = createLucideIcon("ChevronsLeft", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);


//# sourceMappingURL=chevrons-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-right-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsRightLeft = createLucideIcon("ChevronsRightLeft", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);


//# sourceMappingURL=chevrons-right-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsRight = createLucideIcon("ChevronsRight", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);


//# sourceMappingURL=chevrons-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-up-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsUpDown = createLucideIcon("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);


//# sourceMappingURL=chevrons-up-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chevrons-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ChevronsUp = createLucideIcon("ChevronsUp", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);


//# sourceMappingURL=chevrons-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/chrome.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Chrome = createLucideIcon("Chrome", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);


//# sourceMappingURL=chrome.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/church.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Church = createLucideIcon("Church", [
  [
    "path",
    { d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2", key: "gy5gyo" }
  ],
  ["path", { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4", key: "cpkuc4" }],
  ["path", { d: "M18 22V5l-6-3-6 3v17", key: "1hsnhq" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M10 9h4", key: "u4k05v" }]
]);


//# sourceMappingURL=church.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cigarette-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CigaretteOff = createLucideIcon("CigaretteOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M12 12H2v4h14", key: "91gsaq" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M18 12h-.5", key: "12ymji" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);


//# sourceMappingURL=cigarette-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cigarette.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cigarette = createLucideIcon("Cigarette", [
  ["path", { d: "M18 12H2v4h16", key: "2rt1hm" }],
  ["path", { d: "M22 12v4", key: "142cbu" }],
  ["path", { d: "M7 12v4", key: "jqww69" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }]
]);


//# sourceMappingURL=cigarette.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleDashed = createLucideIcon("CircleDashed", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }]
]);


//# sourceMappingURL=circle-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-dollar-sign.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleDollarSign = createLucideIcon("CircleDollarSign", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);


//# sourceMappingURL=circle-dollar-sign.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-dot-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleDotDashed = createLucideIcon("CircleDotDashed", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);


//# sourceMappingURL=circle-dot-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleDot = createLucideIcon("CircleDot", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);


//# sourceMappingURL=circle-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-ellipsis.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleEllipsis = createLucideIcon("CircleEllipsis", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);


//# sourceMappingURL=circle-ellipsis.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-equal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleEqual = createLucideIcon("CircleEqual", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=circle-equal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleOff = createLucideIcon("CircleOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);


//# sourceMappingURL=circle-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-slash-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleSlash2 = createLucideIcon("CircleSlash2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);


//# sourceMappingURL=circle-slash-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle-slash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircleSlash = createLucideIcon("CircleSlash", [
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=circle-slash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Circle = createLucideIcon("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/circuit-board.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CircuitBoard = createLucideIcon("CircuitBoard", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);


//# sourceMappingURL=circuit-board.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/citrus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Citrus = createLucideIcon("Citrus", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);


//# sourceMappingURL=citrus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clapperboard.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clapperboard = createLucideIcon("Clapperboard", [
  [
    "path",
    {
      d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z",
      key: "1tn4o7"
    }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);


//# sourceMappingURL=clapperboard.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardCheck = createLucideIcon("ClipboardCheck", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);


//# sourceMappingURL=clipboard-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-copy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardCopy = createLucideIcon("ClipboardCopy", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
      key: "4jdomd"
    }
  ],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);


//# sourceMappingURL=clipboard-copy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-edit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardEdit = createLucideIcon("ClipboardEdit", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z",
      key: "1rgxu8"
    }
  ],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }]
]);


//# sourceMappingURL=clipboard-edit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-list.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardList = createLucideIcon("ClipboardList", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);


//# sourceMappingURL=clipboard-list.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-paste.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardPaste = createLucideIcon("ClipboardPaste", [
  [
    "path",
    {
      d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z",
      key: "1pp7kr"
    }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);


//# sourceMappingURL=clipboard-paste.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-signature.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardSignature = createLucideIcon("ClipboardSignature", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5",
      key: "1but9f"
    }
  ],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  [
    "path",
    {
      d: "M18.42 9.61a2.1 2.1 0 1 1 2.97 2.97L16.95 17 13 18l.99-3.95 4.43-4.44Z",
      key: "johvi5"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
]);


//# sourceMappingURL=clipboard-signature.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-type.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardType = createLucideIcon("ClipboardType", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);


//# sourceMappingURL=clipboard-type.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ClipboardX = createLucideIcon("ClipboardX", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);


//# sourceMappingURL=clipboard-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clipboard.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clipboard = createLucideIcon("Clipboard", [
  [
    "rect",
    {
      width: "8",
      height: "4",
      x: "8",
      y: "2",
      rx: "1",
      ry: "1",
      key: "tgr4d6"
    }
  ],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);


//# sourceMappingURL=clipboard.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock1 = createLucideIcon("Clock1", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);


//# sourceMappingURL=clock-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-10.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock10 = createLucideIcon("Clock10", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);


//# sourceMappingURL=clock-10.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-11.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock11 = createLucideIcon("Clock11", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);


//# sourceMappingURL=clock-11.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-12.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock12 = createLucideIcon("Clock12", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);


//# sourceMappingURL=clock-12.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock2 = createLucideIcon("Clock2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);


//# sourceMappingURL=clock-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock3 = createLucideIcon("Clock3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);


//# sourceMappingURL=clock-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock4 = createLucideIcon("Clock4", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);


//# sourceMappingURL=clock-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-5.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock5 = createLucideIcon("Clock5", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);


//# sourceMappingURL=clock-5.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-6.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock6 = createLucideIcon("Clock6", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);


//# sourceMappingURL=clock-6.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-7.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock7 = createLucideIcon("Clock7", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);


//# sourceMappingURL=clock-7.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-8.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock8 = createLucideIcon("Clock8", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);


//# sourceMappingURL=clock-8.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock-9.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock9 = createLucideIcon("Clock9", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);


//# sourceMappingURL=clock-9.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clock = createLucideIcon("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);


//# sourceMappingURL=clock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudCog = createLucideIcon("CloudCog", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  [
    "path",
    {
      d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2",
      key: "zaobp"
    }
  ],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);


//# sourceMappingURL=cloud-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-drizzle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudDrizzle = createLucideIcon("CloudDrizzle", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);


//# sourceMappingURL=cloud-drizzle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-fog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudFog = createLucideIcon("CloudFog", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);


//# sourceMappingURL=cloud-fog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-hail.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudHail = createLucideIcon("CloudHail", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);


//# sourceMappingURL=cloud-hail.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-lightning.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudLightning = createLucideIcon("CloudLightning", [
  [
    "path",
    {
      d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973",
      key: "1cez44"
    }
  ],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);


//# sourceMappingURL=cloud-lightning.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-moon-rain.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudMoonRain = createLucideIcon("CloudMoonRain", [
  [
    "path",
    {
      d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197",
      key: "u82z8m"
    }
  ],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);


//# sourceMappingURL=cloud-moon-rain.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-moon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudMoon = createLucideIcon("CloudMoon", [
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }],
  [
    "path",
    {
      d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197",
      key: "16nha0"
    }
  ]
]);


//# sourceMappingURL=cloud-moon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudOff = createLucideIcon("CloudOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193",
      key: "yfwify"
    }
  ],
  [
    "path",
    {
      d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07",
      key: "jlfiyv"
    }
  ]
]);


//# sourceMappingURL=cloud-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-rain-wind.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudRainWind = createLucideIcon("CloudRainWind", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);


//# sourceMappingURL=cloud-rain-wind.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-rain.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudRain = createLucideIcon("CloudRain", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);


//# sourceMappingURL=cloud-rain.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-snow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudSnow = createLucideIcon("CloudSnow", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);


//# sourceMappingURL=cloud-snow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-sun-rain.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudSunRain = createLucideIcon("CloudSunRain", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);


//# sourceMappingURL=cloud-sun-rain.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud-sun.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CloudSun = createLucideIcon("CloudSun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);


//# sourceMappingURL=cloud-sun.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloud.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cloud = createLucideIcon("Cloud", [
  [
    "path",
    { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }
  ]
]);


//# sourceMappingURL=cloud.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cloudy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cloudy = createLucideIcon("Cloudy", [
  [
    "path",
    { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }
  ],
  [
    "path",
    {
      d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5",
      key: "1p2s76"
    }
  ]
]);


//# sourceMappingURL=cloudy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/clover.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Clover = createLucideIcon("Clover", [
  [
    "path",
    {
      d: "M16.2 3.8a2.7 2.7 0 0 0-3.81 0l-.4.38-.4-.4a2.7 2.7 0 0 0-3.82 0C6.73 4.85 6.67 6.64 8 8l4 4 4-4c1.33-1.36 1.27-3.15.2-4.2z",
      key: "1gxwox"
    }
  ],
  [
    "path",
    {
      d: "M8 8c-1.36-1.33-3.15-1.27-4.2-.2a2.7 2.7 0 0 0 0 3.81l.38.4-.4.4a2.7 2.7 0 0 0 0 3.82C4.85 17.27 6.64 17.33 8 16",
      key: "il7z7z"
    }
  ],
  [
    "path",
    {
      d: "M16 16c1.36 1.33 3.15 1.27 4.2.2a2.7 2.7 0 0 0 0-3.81l-.38-.4.4-.4a2.7 2.7 0 0 0 0-3.82C19.15 6.73 17.36 6.67 16 8",
      key: "15bpx2"
    }
  ],
  [
    "path",
    {
      d: "M7.8 20.2a2.7 2.7 0 0 0 3.81 0l.4-.38.4.4a2.7 2.7 0 0 0 3.82 0c1.06-1.06 1.12-2.85-.21-4.21l-4-4-4 4c-1.33 1.36-1.27 3.15-.2 4.2z",
      key: "v9mug8"
    }
  ],
  ["path", { d: "m7 17-5 5", key: "1py3mz" }]
]);


//# sourceMappingURL=clover.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/club.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Club = createLucideIcon("Club", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);


//# sourceMappingURL=club.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/code-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Code2 = createLucideIcon("Code2", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);


//# sourceMappingURL=code-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Code = createLucideIcon("Code", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);


//# sourceMappingURL=code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/codepen.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Codepen = createLucideIcon("Codepen", [
  [
    "polygon",
    { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }
  ],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);


//# sourceMappingURL=codepen.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/codesandbox.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Codesandbox = createLucideIcon("Codesandbox", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);


//# sourceMappingURL=codesandbox.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/coffee.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Coffee = createLucideIcon("Coffee", [
  ["path", { d: "M17 8h1a4 4 0 1 1 0 8h-1", key: "jx4kbh" }],
  ["path", { d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z", key: "1bxrl0" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "4", key: "1cr9l3" }],
  ["line", { x1: "10", x2: "10", y1: "2", y2: "4", key: "170wym" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "4", key: "1c5f70" }]
]);


//# sourceMappingURL=coffee.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cog = createLucideIcon("Cog", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);


//# sourceMappingURL=cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/coins.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Coins = createLucideIcon("Coins", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);


//# sourceMappingURL=coins.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/columns.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Columns = createLucideIcon("Columns", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }]
]);


//# sourceMappingURL=columns.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/combine.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Combine = createLucideIcon("Combine", [
  ["rect", { width: "8", height: "8", x: "2", y: "2", rx: "2", key: "z1hh3n" }],
  ["path", { d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "83orz6" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "k86dmt" }],
  ["path", { d: "M10 18H5c-1.7 0-3-1.3-3-3v-1", key: "6vokjl" }],
  ["polyline", { points: "7 21 10 18 7 15", key: "1k02g0" }],
  [
    "rect",
    { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }
  ]
]);


//# sourceMappingURL=combine.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/command.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Command = createLucideIcon("Command", [
  [
    "path",
    {
      d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3",
      key: "11bfej"
    }
  ]
]);


//# sourceMappingURL=command.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/compass.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Compass = createLucideIcon("Compass", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "polygon",
    {
      points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
      key: "m9r19z"
    }
  ]
]);


//# sourceMappingURL=compass.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/component.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Component = createLucideIcon("Component", [
  ["path", { d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z", key: "1kciei" }],
  ["path", { d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z", key: "1ome0g" }],
  ["path", { d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z", key: "vbupec" }],
  ["path", { d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z", key: "16csic" }]
]);


//# sourceMappingURL=component.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/computer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Computer = createLucideIcon("Computer", [
  [
    "rect",
    { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }
  ],
  [
    "rect",
    { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }
  ],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);


//# sourceMappingURL=computer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/concierge-bell.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ConciergeBell = createLucideIcon("ConciergeBell", [
  [
    "path",
    { d: "M2 18a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2v-2Z", key: "1co3i8" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);


//# sourceMappingURL=concierge-bell.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cone = createLucideIcon("Cone", [
  [
    "path",
    { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }
  ],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);


//# sourceMappingURL=cone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/construction.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Construction = createLucideIcon("Construction", [
  [
    "rect",
    { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }
  ],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);


//# sourceMappingURL=construction.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/contact-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Contact2 = createLucideIcon("Contact2", [
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);


//# sourceMappingURL=contact-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/contact.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Contact = createLucideIcon("Contact", [
  ["path", { d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2", key: "1mghuy" }],
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }
  ],
  ["circle", { cx: "12", cy: "10", r: "2", key: "1yojzk" }],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
  ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }]
]);


//# sourceMappingURL=contact.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/container.js
/**
 * lucide-react v0.284.0 - ISC
 */



const container_Container = createLucideIcon("Container", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);


//# sourceMappingURL=container.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/contrast.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Contrast = createLucideIcon("Contrast", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);


//# sourceMappingURL=contrast.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cookie.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cookie = createLucideIcon("Cookie", [
  [
    "path",
    { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }
  ],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);


//# sourceMappingURL=cookie.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CopyCheck = createLucideIcon("CopyCheck", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CopyMinus = createLucideIcon("CopyMinus", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CopyPlus = createLucideIcon("CopyPlus", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy-slash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CopySlash = createLucideIcon("CopySlash", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy-slash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CopyX = createLucideIcon("CopyX", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Copy = createLucideIcon("Copy", [
  [
    "rect",
    {
      width: "14",
      height: "14",
      x: "8",
      y: "8",
      rx: "2",
      ry: "2",
      key: "17jyea"
    }
  ],
  [
    "path",
    {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
      key: "zix9uf"
    }
  ]
]);


//# sourceMappingURL=copy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copyleft.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Copyleft = createLucideIcon("Copyleft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 9.4a4 4 0 1 1 0 5.25", key: "cap0i8" }]
]);


//# sourceMappingURL=copyleft.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/copyright.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Copyright = createLucideIcon("Copyright", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.246", key: "wtyj23" }]
]);


//# sourceMappingURL=copyright.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-down-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerDownLeft = createLucideIcon("CornerDownLeft", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);


//# sourceMappingURL=corner-down-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-down-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerDownRight = createLucideIcon("CornerDownRight", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);


//# sourceMappingURL=corner-down-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-left-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerLeftDown = createLucideIcon("CornerLeftDown", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);


//# sourceMappingURL=corner-left-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-left-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerLeftUp = createLucideIcon("CornerLeftUp", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);


//# sourceMappingURL=corner-left-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-right-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerRightDown = createLucideIcon("CornerRightDown", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);


//# sourceMappingURL=corner-right-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-right-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerRightUp = createLucideIcon("CornerRightUp", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);


//# sourceMappingURL=corner-right-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-up-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerUpLeft = createLucideIcon("CornerUpLeft", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);


//# sourceMappingURL=corner-up-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/corner-up-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CornerUpRight = createLucideIcon("CornerUpRight", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);


//# sourceMappingURL=corner-up-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cpu.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cpu = createLucideIcon("Cpu", [
  [
    "rect",
    { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "1vbyd7" }
  ],
  ["rect", { x: "9", y: "9", width: "6", height: "6", key: "o3kz5p" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);


//# sourceMappingURL=cpu.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/creative-commons.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CreativeCommons = createLucideIcon("CreativeCommons", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    {
      d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
      key: "1ss3eq"
    }
  ],
  [
    "path",
    {
      d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
      key: "1od56t"
    }
  ]
]);


//# sourceMappingURL=creative-commons.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/credit-card.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CreditCard = createLucideIcon("CreditCard", [
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }
  ],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);


//# sourceMappingURL=credit-card.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/croissant.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Croissant = createLucideIcon("Croissant", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);


//# sourceMappingURL=croissant.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/crop.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Crop = createLucideIcon("Crop", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);


//# sourceMappingURL=crop.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cross.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cross = createLucideIcon("Cross", [
  [
    "path",
    {
      d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z",
      key: "1t5g7j"
    }
  ]
]);


//# sourceMappingURL=cross.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/crosshair.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Crosshair = createLucideIcon("Crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);


//# sourceMappingURL=crosshair.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/crown.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Crown = createLucideIcon("Crown", [
  ["path", { d: "m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14", key: "zkxr6b" }]
]);


//# sourceMappingURL=crown.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cuboid.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cuboid = createLucideIcon("Cuboid", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);


//# sourceMappingURL=cuboid.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cup-soda.js
/**
 * lucide-react v0.284.0 - ISC
 */



const CupSoda = createLucideIcon("CupSoda", [
  [
    "path",
    {
      d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8",
      key: "8166m8"
    }
  ],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  [
    "path",
    { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }
  ],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);


//# sourceMappingURL=cup-soda.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/currency.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Currency = createLucideIcon("Currency", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);


//# sourceMappingURL=currency.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/cylinder.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Cylinder = createLucideIcon("Cylinder", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);


//# sourceMappingURL=cylinder.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/database-backup.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DatabaseBackup = createLucideIcon("DatabaseBackup", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);


//# sourceMappingURL=database-backup.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/database-zap.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DatabaseZap = createLucideIcon("DatabaseZap", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);


//# sourceMappingURL=database-zap.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/database.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Database = createLucideIcon("Database", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);


//# sourceMappingURL=database.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/delete.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Delete = createLucideIcon("Delete", [
  [
    "path",
    { d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z", key: "1oy587" }
  ],
  ["line", { x1: "18", x2: "12", y1: "9", y2: "15", key: "1olkx5" }],
  ["line", { x1: "12", x2: "18", y1: "9", y2: "15", key: "1n50pc" }]
]);


//# sourceMappingURL=delete.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dessert.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dessert = createLucideIcon("Dessert", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);


//# sourceMappingURL=dessert.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/diameter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Diameter = createLucideIcon("Diameter", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);


//# sourceMappingURL=diameter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/diamond.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Diamond = createLucideIcon("Diamond", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);


//# sourceMappingURL=diamond.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice1 = createLucideIcon("Dice1", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);


//# sourceMappingURL=dice-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice2 = createLucideIcon("Dice2", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);


//# sourceMappingURL=dice-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice3 = createLucideIcon("Dice3", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);


//# sourceMappingURL=dice-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice4 = createLucideIcon("Dice4", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);


//# sourceMappingURL=dice-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-5.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice5 = createLucideIcon("Dice5", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);


//# sourceMappingURL=dice-5.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dice-6.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dice6 = createLucideIcon("Dice6", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);


//# sourceMappingURL=dice-6.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dices.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dices = createLucideIcon("Dices", [
  [
    "rect",
    {
      width: "12",
      height: "12",
      x: "2",
      y: "10",
      rx: "2",
      ry: "2",
      key: "6agr2n"
    }
  ],
  [
    "path",
    {
      d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
      key: "1o487t"
    }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);


//# sourceMappingURL=dices.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/diff.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Diff = createLucideIcon("Diff", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);


//# sourceMappingURL=diff.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/disc-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Disc2 = createLucideIcon("Disc2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);


//# sourceMappingURL=disc-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/disc-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Disc3 = createLucideIcon("Disc3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);


//# sourceMappingURL=disc-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/disc.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Disc = createLucideIcon("Disc", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);


//# sourceMappingURL=disc.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/divide-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DivideCircle = createLucideIcon("DivideCircle", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=divide-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/divide-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DivideSquare = createLucideIcon("DivideSquare", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);


//# sourceMappingURL=divide-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/divide.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Divide = createLucideIcon("Divide", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);


//# sourceMappingURL=divide.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dna-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DnaOff = createLucideIcon("DnaOff", [
  [
    "path",
    {
      d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5",
      key: "sxiaad"
    }
  ],
  [
    "path",
    {
      d: "M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5",
      key: "yn4bs1"
    }
  ],
  ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
  ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
  ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=dna-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dna.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dna = createLucideIcon("Dna", [
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
  ["path", { d: "m14 8-1-1", key: "15nbz5" }],
  ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
  ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
  ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }]
]);


//# sourceMappingURL=dna.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dog = createLucideIcon("Dog", [
  [
    "path",
    {
      d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5",
      key: "19br0u"
    }
  ],
  [
    "path",
    {
      d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "11n1an"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306",
      key: "wsu29d"
    }
  ]
]);


//# sourceMappingURL=dog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dollar-sign.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DollarSign = createLucideIcon("DollarSign", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  [
    "path",
    { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }
  ]
]);


//# sourceMappingURL=dollar-sign.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/donut.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Donut = createLucideIcon("Donut", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=donut.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/door-closed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DoorClosed = createLucideIcon("DoorClosed", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);


//# sourceMappingURL=door-closed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/door-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DoorOpen = createLucideIcon("DoorOpen", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);


//# sourceMappingURL=door-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dot = createLucideIcon("Dot", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);


//# sourceMappingURL=dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/download-cloud.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DownloadCloud = createLucideIcon("DownloadCloud", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m8 17 4 4 4-4", key: "1ul180" }]
]);


//# sourceMappingURL=download-cloud.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/download.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Download = createLucideIcon("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);


//# sourceMappingURL=download.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/drafting-compass.js
/**
 * lucide-react v0.284.0 - ISC
 */



const DraftingCompass = createLucideIcon("DraftingCompass", [
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19 12c-3.87 4-10.13 4-14 0", key: "1tsu18" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }]
]);


//# sourceMappingURL=drafting-compass.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/drama.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Drama = createLucideIcon("Drama", [
  ["path", { d: "M 10 11h.01", key: "1lksi6" }],
  ["path", { d: "M 14 6h.01", key: "1kxpxo" }],
  ["path", { d: "M 18 6h.01", key: "1goweo" }],
  ["path", { d: "M 6.5 13.1h.01", key: "1i19cj" }],
  [
    "path",
    { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }
  ],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);


//# sourceMappingURL=drama.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dribbble.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dribbble = createLucideIcon("Dribbble", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);


//# sourceMappingURL=dribbble.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/droplet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Droplet = createLucideIcon("Droplet", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);


//# sourceMappingURL=droplet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/droplets.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Droplets = createLucideIcon("Droplets", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);


//# sourceMappingURL=droplets.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/drumstick.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Drumstick = createLucideIcon("Drumstick", [
  [
    "path",
    {
      d: "M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z",
      key: "1o96s0"
    }
  ],
  [
    "path",
    {
      d: "m11.25 15.6-2.16 2.16a2.5 2.5 0 1 1-4.56 1.73 2.49 2.49 0 0 1-1.41-4.24 2.5 2.5 0 0 1 3.14-.32l2.16-2.16",
      key: "14vv5h"
    }
  ]
]);


//# sourceMappingURL=drumstick.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/dumbbell.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Dumbbell = createLucideIcon("Dumbbell", [
  ["path", { d: "m6.5 6.5 11 11", key: "f7oqzb" }],
  ["path", { d: "m21 21-1-1", key: "cpc6if" }],
  ["path", { d: "m3 3 1 1", key: "d3rpuf" }],
  ["path", { d: "m18 22 4-4", key: "1e32o6" }],
  ["path", { d: "m2 6 4-4", key: "189tqz" }],
  ["path", { d: "m3 10 7-7", key: "1bxui2" }],
  ["path", { d: "m14 21 7-7", key: "16x78n" }]
]);


//# sourceMappingURL=dumbbell.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ear-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const EarOff = createLucideIcon("EarOff", [
  [
    "path",
    { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }
  ],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  [
    "path",
    {
      d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76",
      key: "g10hsz"
    }
  ],
  [
    "path",
    {
      d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18",
      key: "ygzou7"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=ear-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ear.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ear = createLucideIcon("Ear", [
  [
    "path",
    {
      d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0",
      key: "1dfaln"
    }
  ],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);


//# sourceMappingURL=ear.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/egg-fried.js
/**
 * lucide-react v0.284.0 - ISC
 */



const EggFried = createLucideIcon("EggFried", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);


//# sourceMappingURL=egg-fried.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/egg-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const EggOff = createLucideIcon("EggOff", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=egg-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/egg.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Egg = createLucideIcon("Egg", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);


//# sourceMappingURL=egg.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/equal-not.js
/**
 * lucide-react v0.284.0 - ISC
 */



const EqualNot = createLucideIcon("EqualNot", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);


//# sourceMappingURL=equal-not.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/equal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Equal = createLucideIcon("Equal", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);


//# sourceMappingURL=equal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/eraser.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Eraser = createLucideIcon("Eraser", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);


//# sourceMappingURL=eraser.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/euro.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Euro = createLucideIcon("Euro", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);


//# sourceMappingURL=euro.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/expand.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Expand = createLucideIcon("Expand", [
  ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
  ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
  ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
  ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }]
]);


//# sourceMappingURL=expand.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/external-link.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ExternalLink = createLucideIcon("ExternalLink", [
  [
    "path",
    {
      d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
      key: "a6xqqp"
    }
  ],
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["line", { x1: "10", x2: "21", y1: "14", y2: "3", key: "18c3s4" }]
]);


//# sourceMappingURL=external-link.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/eye-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const EyeOff = createLucideIcon("EyeOff", [
  ["path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24", key: "1jxqfv" }],
  [
    "path",
    {
      d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
      key: "9wicm4"
    }
  ],
  [
    "path",
    {
      d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61",
      key: "1jreej"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=eye-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/eye.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Eye = createLucideIcon("Eye", [
  [
    "path",
    { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z", key: "rwhkz3" }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=eye.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/facebook.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Facebook = createLucideIcon("Facebook", [
  [
    "path",
    {
      d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z",
      key: "1jg4f8"
    }
  ]
]);


//# sourceMappingURL=facebook.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/factory.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Factory = createLucideIcon("Factory", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);


//# sourceMappingURL=factory.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fan.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Fan = createLucideIcon("Fan", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);


//# sourceMappingURL=fan.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fast-forward.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FastForward = createLucideIcon("FastForward", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);


//# sourceMappingURL=fast-forward.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/feather.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Feather = createLucideIcon("Feather", [
  [
    "path",
    { d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z", key: "u4sw5n" }
  ],
  ["line", { x1: "16", x2: "2", y1: "8", y2: "22", key: "1c47m2" }],
  ["line", { x1: "17.5", x2: "9", y1: "15", y2: "15", key: "2fj3pr" }]
]);


//# sourceMappingURL=feather.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ferris-wheel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FerrisWheel = createLucideIcon("FerrisWheel", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);


//# sourceMappingURL=ferris-wheel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/figma.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Figma = createLucideIcon("Figma", [
  [
    "path",
    {
      d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z",
      key: "1340ok"
    }
  ],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  [
    "path",
    { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }
  ],
  [
    "path",
    {
      d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z",
      key: "1ff65i"
    }
  ],
  [
    "path",
    {
      d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z",
      key: "pdip6e"
    }
  ]
]);


//# sourceMappingURL=figma.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-archive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileArchive = createLucideIcon("FileArchive", [
  [
    "path",
    {
      d: "M4 22V4c0-.5.2-1 .6-1.4C5 2.2 5.5 2 6 2h8.5L20 7.5V20c0 .5-.2 1-.6 1.4-.4.4-.9.6-1.4.6h-2",
      key: "1u864v"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }]
]);


//# sourceMappingURL=file-archive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-audio-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileAudio2 = createLucideIcon("FileAudio2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v2", key: "fkyf72" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }]
]);


//# sourceMappingURL=file-audio-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-audio.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileAudio = createLucideIcon("FileAudio", [
  [
    "path",
    {
      d: "M17.5 22h.5c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V7.5L14.5 2H6c-.5 0-1 .2-1.4.6C4.2 3 4 3.5 4 4v3",
      key: "1013sb"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M10 20v-1a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0Z", key: "gqt63y" }],
  ["path", { d: "M6 20v-1a2 2 0 1 0-4 0v1a2 2 0 1 0 4 0Z", key: "cf7lqx" }],
  ["path", { d: "M2 19v-3a6 6 0 0 1 12 0v3", key: "1acxgf" }]
]);


//# sourceMappingURL=file-audio.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-axis-3d.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileAxis3d = createLucideIcon("FileAxis3d", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }]
]);


//# sourceMappingURL=file-axis-3d.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-badge-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileBadge2 = createLucideIcon("FileBadge2", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["path", { d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "13rien" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);


//# sourceMappingURL=file-badge-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-badge.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileBadge = createLucideIcon("FileBadge", [
  [
    "path",
    { d: "M4 7V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-6", key: "qtddq0" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);


//# sourceMappingURL=file-badge.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-bar-chart-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileBarChart2 = createLucideIcon("FileBarChart2", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);


//# sourceMappingURL=file-bar-chart-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-bar-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileBarChart = createLucideIcon("FileBarChart", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);


//# sourceMappingURL=file-bar-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-box.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileBox = createLucideIcon("FileBox", [
  [
    "path",
    {
      d: "M14.5 22H18a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4",
      key: "h7jej2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "path",
    {
      d: "M2.97 13.12c-.6.36-.97 1.02-.97 1.74v3.28c0 .72.37 1.38.97 1.74l3 1.83c.63.39 1.43.39 2.06 0l3-1.83c.6-.36.97-1.02.97-1.74v-3.28c0-.72-.37-1.38-.97-1.74l-3-1.83a1.97 1.97 0 0 0-2.06 0l-3 1.83Z",
      key: "f4a3oc"
    }
  ],
  ["path", { d: "m7 17-4.74-2.85", key: "etm6su" }],
  ["path", { d: "m7 17 4.74-2.85", key: "5xuooz" }],
  ["path", { d: "M7 17v5", key: "1yj1jh" }]
]);


//# sourceMappingURL=file-box.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-check-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileCheck2 = createLucideIcon("FileCheck2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);


//# sourceMappingURL=file-check-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileCheck = createLucideIcon("FileCheck", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);


//# sourceMappingURL=file-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-clock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileClock = createLucideIcon("FileClock", [
  [
    "path",
    {
      d: "M16 22h2c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V7.5L14.5 2H6c-.5 0-1 .2-1.4.6C4.2 3 4 3.5 4 4v3",
      key: "9lo3o3"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);


//# sourceMappingURL=file-clock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-code-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileCode2 = createLucideIcon("FileCode2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }]
]);


//# sourceMappingURL=file-code-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileCode = createLucideIcon("FileCode", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m10 13-2 2 2 2", key: "17smn8" }],
  ["path", { d: "m14 17 2-2-2-2", key: "14mezr" }]
]);


//# sourceMappingURL=file-code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileCog = createLucideIcon("FileCog", [
  ["circle", { cx: "6", cy: "13", r: "3", key: "1z65bp" }],
  ["path", { d: "m9.7 14.4-.9-.3", key: "o1luaq" }],
  ["path", { d: "m3.2 11.9-.9-.3", key: "qm3zk5" }],
  ["path", { d: "m4.6 16.7.3-.9", key: "1o0ect" }],
  ["path", { d: "m7.6 16.7-.4-1", key: "1ym8d1" }],
  ["path", { d: "m4.8 10.3-.4-1", key: "18q26g" }],
  ["path", { d: "m2.3 14.6 1-.4", key: "121m88" }],
  ["path", { d: "m8.7 11.8 1-.4", key: "9meqp2" }],
  ["path", { d: "m7.4 9.3-.3.9", key: "136qqn" }],
  ["path", { d: "M14 2v6h6", key: "1kof46" }],
  [
    "path",
    {
      d: "M4 5.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-1.5",
      key: "xwe04"
    }
  ]
]);


//# sourceMappingURL=file-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-diff.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileDiff = createLucideIcon("FileDiff", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);


//# sourceMappingURL=file-diff.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-digit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileDigit = createLucideIcon("FileDigit", [
  [
    "rect",
    { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }
  ],
  ["path", { d: "M14 2v6h6", key: "1kof46" }],
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);


//# sourceMappingURL=file-digit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileDown = createLucideIcon("FileDown", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);


//# sourceMappingURL=file-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-edit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileEdit = createLucideIcon("FileEdit", [
  [
    "path",
    {
      d: "M4 13.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-5.5",
      key: "1bg6eb"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "path",
    {
      d: "M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z",
      key: "1rgxu8"
    }
  ]
]);


//# sourceMappingURL=file-edit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-heart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileHeart = createLucideIcon("FileHeart", [
  [
    "path",
    { d: "M4 6V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4", key: "dba9qu" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);


//# sourceMappingURL=file-heart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-image.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileImage = createLucideIcon("FileImage", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["circle", { cx: "10", cy: "13", r: "2", key: "6v46hv" }],
  ["path", { d: "m20 17-1.09-1.09a2 2 0 0 0-2.82 0L10 22", key: "17vly1" }]
]);


//# sourceMappingURL=file-image.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-input.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileInput = createLucideIcon("FileInput", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);


//# sourceMappingURL=file-input.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-json-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileJson2 = createLucideIcon("FileJson2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "path",
    {
      d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
      key: "fq0c9t"
    }
  ],
  [
    "path",
    {
      d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
      key: "4gibmv"
    }
  ]
]);


//# sourceMappingURL=file-json-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-json.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileJson = createLucideIcon("FileJson", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "path",
    {
      d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
      key: "1oajmo"
    }
  ],
  [
    "path",
    {
      d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
      key: "mpwhp6"
    }
  ]
]);


//# sourceMappingURL=file-json.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-key-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileKey2 = createLucideIcon("FileKey2", [
  [
    "path",
    { d: "M4 10V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4", key: "1nw5t3" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);


//# sourceMappingURL=file-key-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-key.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileKey = createLucideIcon("FileKey", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);


//# sourceMappingURL=file-key.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-line-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileLineChart = createLucideIcon("FileLineChart", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);


//# sourceMappingURL=file-line-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-lock-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileLock2 = createLucideIcon("FileLock2", [
  [
    "path",
    { d: "M4 5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4", key: "gwd2r9" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  [
    "rect",
    { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }
  ],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);


//# sourceMappingURL=file-lock-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-lock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileLock = createLucideIcon("FileLock", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  [
    "rect",
    { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }
  ],
  ["path", { d: "M15 12v-2a3 3 0 1 0-6 0v2", key: "1nqnhw" }]
]);


//# sourceMappingURL=file-lock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-minus-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileMinus2 = createLucideIcon("FileMinus2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);


//# sourceMappingURL=file-minus-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileMinus = createLucideIcon("FileMinus", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "15", key: "110plj" }]
]);


//# sourceMappingURL=file-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-output.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileOutput = createLucideIcon("FileOutput", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }]
]);


//# sourceMappingURL=file-output.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-pie-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FilePieChart = createLucideIcon("FilePieChart", [
  [
    "path",
    { d: "M16 22h2a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3", key: "zhyrez" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M4.04 11.71a5.84 5.84 0 1 0 8.2 8.29", key: "f1t5jc" }],
  ["path", { d: "M13.83 16A5.83 5.83 0 0 0 8 10.17V16h5.83Z", key: "7q54ec" }]
]);


//# sourceMappingURL=file-pie-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-plus-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FilePlus2 = createLucideIcon("FilePlus2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);


//# sourceMappingURL=file-plus-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FilePlus = createLucideIcon("FilePlus", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["line", { x1: "12", x2: "12", y1: "18", y2: "12", key: "1tsf04" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "15", key: "110plj" }]
]);


//# sourceMappingURL=file-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-question.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileQuestion = createLucideIcon("FileQuestion", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  [
    "path",
    {
      d: "M10 10.3c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "1umxtm"
    }
  ],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);


//# sourceMappingURL=file-question.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-scan.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileScan = createLucideIcon("FileScan", [
  [
    "path",
    {
      d: "M20 10V7.5L14.5 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h4.5",
      key: "uvikde"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }]
]);


//# sourceMappingURL=file-scan.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-search-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileSearch2 = createLucideIcon("FileSearch2", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.25 16.25 15 18", key: "9eh8bj" }]
]);


//# sourceMappingURL=file-search-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileSearch = createLucideIcon("FileSearch", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3", key: "am10z3" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "ychnub" }],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }]
]);


//# sourceMappingURL=file-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-signature.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileSignature = createLucideIcon("FileSignature", [
  [
    "path",
    {
      d: "M20 19.5v.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8.5L18 5.5",
      key: "kd5d3"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M18.42 9.61a2.1 2.1 0 1 1 2.97 2.97L16.95 17 13 18l.99-3.95 4.43-4.44Z",
      key: "johvi5"
    }
  ]
]);


//# sourceMappingURL=file-signature.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-spreadsheet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileSpreadsheet = createLucideIcon("FileSpreadsheet", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);


//# sourceMappingURL=file-spreadsheet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-stack.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileStack = createLucideIcon("FileStack", [
  ["path", { d: "M16 2v5h5", key: "kt2in0" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17l4 4z",
      key: "1km23n"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);


//# sourceMappingURL=file-stack.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-symlink.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileSymlink = createLucideIcon("FileSymlink", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v7", key: "138uzh" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M4 18v-1a2 2 0 0 1 2-2h6", key: "5uz2rn" }]
]);


//# sourceMappingURL=file-symlink.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-terminal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileTerminal = createLucideIcon("FileTerminal", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);


//# sourceMappingURL=file-terminal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-text.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileText = createLucideIcon("FileText", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["line", { x1: "16", x2: "8", y1: "13", y2: "13", key: "14keom" }],
  ["line", { x1: "16", x2: "8", y1: "17", y2: "17", key: "17nazh" }],
  ["line", { x1: "10", x2: "8", y1: "9", y2: "9", key: "1a5vjj" }]
]);


//# sourceMappingURL=file-text.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-type-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileType2 = createLucideIcon("FileType2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }]
]);


//# sourceMappingURL=file-type-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-type.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileType = createLucideIcon("FileType", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);


//# sourceMappingURL=file-type.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileUp = createLucideIcon("FileUp", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);


//# sourceMappingURL=file-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-video-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileVideo2 = createLucideIcon("FileVideo2", [
  [
    "path",
    { d: "M4 8V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4", key: "1nti49" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }],
  [
    "rect",
    { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }
  ]
]);


//# sourceMappingURL=file-video-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-video.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileVideo = createLucideIcon("FileVideo", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);


//# sourceMappingURL=file-video.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-volume-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileVolume2 = createLucideIcon("FileVolume2", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "M11.5 13.5c.32.4.5.94.5 1.5s-.18 1.1-.5 1.5", key: "joawwx" }],
  ["path", { d: "M15 12c.64.8 1 1.87 1 3s-.36 2.2-1 3", key: "1f2wyw" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }]
]);


//# sourceMappingURL=file-volume-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-volume.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileVolume = createLucideIcon("FileVolume", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3", key: "am10z3" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["path", { d: "m7 10-3 2H2v4h2l3 2v-8Z", key: "tazg57" }],
  ["path", { d: "M11 11c.64.8 1 1.87 1 3s-.36 2.2-1 3", key: "1yej3m" }]
]);


//# sourceMappingURL=file-volume.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-warning.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileWarning = createLucideIcon("FileWarning", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);


//# sourceMappingURL=file-warning.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-x-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileX2 = createLucideIcon("FileX2", [
  [
    "path",
    { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4", key: "702lig" }
  ],
  ["path", { d: "M14 2v6h6", key: "1kof46" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }]
]);


//# sourceMappingURL=file-x-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FileX = createLucideIcon("FileX", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["line", { x1: "9.5", x2: "14.5", y1: "12.5", y2: "17.5", key: "izs6du" }],
  ["line", { x1: "14.5", x2: "9.5", y1: "12.5", y2: "17.5", key: "1lehlj" }]
]);


//# sourceMappingURL=file-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/file.js
/**
 * lucide-react v0.284.0 - ISC
 */



const File = createLucideIcon("File", [
  [
    "path",
    {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
      key: "1nnpy2"
    }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }]
]);


//# sourceMappingURL=file.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/files.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Files = createLucideIcon("Files", [
  [
    "path",
    {
      d: "M15.5 2H8.6c-.4 0-.8.2-1.1.5-.3.3-.5.7-.5 1.1v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8c.4 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1V6.5L15.5 2z",
      key: "cennsq"
    }
  ],
  [
    "path",
    { d: "M3 7.6v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8", key: "ms809a" }
  ],
  ["path", { d: "M15 2v5h5", key: "qq6kwv" }]
]);


//# sourceMappingURL=files.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/film.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Film = createLucideIcon("Film", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);


//# sourceMappingURL=film.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/filter-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FilterX = createLucideIcon("FilterX", [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);


//# sourceMappingURL=filter-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/filter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Filter = createLucideIcon("Filter", [
  [
    "polygon",
    { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }
  ]
]);


//# sourceMappingURL=filter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fingerprint.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Fingerprint = createLucideIcon("Fingerprint", [
  ["path", { d: "M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4", key: "1jc9o5" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2", key: "1mxgy1" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2", key: "1fgabc" }]
]);


//# sourceMappingURL=fingerprint.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fish-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FishOff = createLucideIcon("FishOff", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);


//# sourceMappingURL=fish-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fish-symbol.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FishSymbol = createLucideIcon("FishSymbol", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);


//# sourceMappingURL=fish-symbol.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fish.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Fish = createLucideIcon("Fish", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    {
      d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4",
      key: "1kjonw"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98",
      key: "1zlm23"
    }
  ]
]);


//# sourceMappingURL=fish.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flag-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlagOff = createLucideIcon("FlagOff", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=flag-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flag-triangle-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlagTriangleLeft = createLucideIcon("FlagTriangleLeft", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);


//# sourceMappingURL=flag-triangle-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flag-triangle-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlagTriangleRight = createLucideIcon("FlagTriangleRight", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);


//# sourceMappingURL=flag-triangle-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flag.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Flag = createLucideIcon("Flag", [
  [
    "path",
    {
      d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z",
      key: "i9b6wo"
    }
  ],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);


//# sourceMappingURL=flag.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flame-kindling.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlameKindling = createLucideIcon("FlameKindling", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);


//# sourceMappingURL=flame-kindling.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flame.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Flame = createLucideIcon("Flame", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);


//# sourceMappingURL=flame.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flashlight-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlashlightOff = createLucideIcon("FlashlightOff", [
  [
    "path",
    {
      d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4",
      key: "1r120k"
    }
  ],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=flashlight-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flashlight.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Flashlight = createLucideIcon("Flashlight", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);


//# sourceMappingURL=flashlight.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flask-conical-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlaskConicalOff = createLucideIcon("FlaskConicalOff", [
  [
    "path",
    {
      d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
      key: "59ek9y"
    }
  ],
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h9", key: "t5njau" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=flask-conical-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flask-conical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlaskConical = createLucideIcon("FlaskConical", [
  [
    "path",
    {
      d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
      key: "pzvekw"
    }
  ],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);


//# sourceMappingURL=flask-conical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flask-round.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlaskRound = createLucideIcon("FlaskRound", [
  ["path", { d: "M10 2v7.31", key: "5d1hyh" }],
  ["path", { d: "M14 9.3V1.99", key: "14k4l0" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0", key: "1r8fvy" }],
  ["path", { d: "M5.52 16h12.96", key: "46hh1i" }]
]);


//# sourceMappingURL=flask-round.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flip-horizontal-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlipHorizontal2 = createLucideIcon("FlipHorizontal2", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);


//# sourceMappingURL=flip-horizontal-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flip-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlipHorizontal = createLucideIcon("FlipHorizontal", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);


//# sourceMappingURL=flip-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flip-vertical-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlipVertical2 = createLucideIcon("FlipVertical2", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);


//# sourceMappingURL=flip-vertical-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flip-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FlipVertical = createLucideIcon("FlipVertical", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);


//# sourceMappingURL=flip-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flower-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Flower2 = createLucideIcon("Flower2", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  [
    "path",
    { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }
  ]
]);


//# sourceMappingURL=flower-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/flower.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Flower = createLucideIcon("Flower", [
  [
    "path",
    {
      d: "M12 7.5a4.5 4.5 0 1 1 4.5 4.5M12 7.5A4.5 4.5 0 1 0 7.5 12M12 7.5V9m-4.5 3a4.5 4.5 0 1 0 4.5 4.5M7.5 12H9m7.5 0a4.5 4.5 0 1 1-4.5 4.5m4.5-4.5H15m-3 4.5V15",
      key: "51z86h"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m8 16 1.5-1.5", key: "ce6zph" }],
  ["path", { d: "M14.5 9.5 16 8", key: "1kzrzb" }],
  ["path", { d: "m8 8 1.5 1.5", key: "1yv88w" }],
  ["path", { d: "M14.5 14.5 16 16", key: "12xhjh" }]
]);


//# sourceMappingURL=flower.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/focus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Focus = createLucideIcon("Focus", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);


//# sourceMappingURL=focus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fold-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FoldHorizontal = createLucideIcon("FoldHorizontal", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);


//# sourceMappingURL=fold-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fold-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FoldVertical = createLucideIcon("FoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);


//# sourceMappingURL=fold-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-archive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderArchive = createLucideIcon("FolderArchive", [
  [
    "path",
    {
      d: "M22 20V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h6",
      key: "1l0vpk"
    }
  ],
  ["circle", { cx: "16", cy: "19", r: "2", key: "1uwppb" }],
  ["path", { d: "M16 11v-1", key: "eoyjtm" }],
  ["path", { d: "M16 17v-2", key: "1xp69b" }]
]);


//# sourceMappingURL=folder-archive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderCheck = createLucideIcon("FolderCheck", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);


//# sourceMappingURL=folder-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-clock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderClock = createLucideIcon("FolderClock", [
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2",
      key: "1p0xo9"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);


//# sourceMappingURL=folder-clock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-closed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderClosed = createLucideIcon("FolderClosed", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);


//# sourceMappingURL=folder-closed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderCog = createLucideIcon("FolderCog", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.5 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.5",
      key: "j83l98"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);


//# sourceMappingURL=folder-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderDot = createLucideIcon("FolderDot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);


//# sourceMappingURL=folder-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderDown = createLucideIcon("FolderDown", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);


//# sourceMappingURL=folder-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-edit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderEdit = createLucideIcon("FolderEdit", [
  [
    "path",
    {
      d: "M8.42 10.61a2.1 2.1 0 1 1 2.97 2.97L5.95 19 2 20l.99-3.95 5.43-5.44Z",
      key: "o1ah0z"
    }
  ],
  [
    "path",
    {
      d: "M2 11.5V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "bim890"
    }
  ]
]);


//# sourceMappingURL=folder-edit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-git-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderGit2 = createLucideIcon("FolderGit2", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);


//# sourceMappingURL=folder-git-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-git.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderGit = createLucideIcon("FolderGit", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);


//# sourceMappingURL=folder-git.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-heart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderHeart = createLucideIcon("FolderHeart", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v1.5",
      key: "zoglpu"
    }
  ],
  [
    "path",
    {
      d: "M21.29 13.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 21l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "2tfff6"
    }
  ]
]);


//# sourceMappingURL=folder-heart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-input.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderInput = createLucideIcon("FolderInput", [
  [
    "path",
    {
      d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "1gu97c"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);


//# sourceMappingURL=folder-input.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-kanban.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderKanban = createLucideIcon("FolderKanban", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);


//# sourceMappingURL=folder-kanban.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-key.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderKey = createLucideIcon("FolderKey", [
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2",
      key: "203odn"
    }
  ],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);


//# sourceMappingURL=folder-key.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-lock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderLock = createLucideIcon("FolderLock", [
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2.5",
      key: "1ivsx8"
    }
  ],
  [
    "rect",
    { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);


//# sourceMappingURL=folder-lock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderMinus = createLucideIcon("FolderMinus", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["line", { x1: "9", x2: "15", y1: "13", y2: "13", key: "10hoct" }]
]);


//# sourceMappingURL=folder-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-open-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderOpenDot = createLucideIcon("FolderOpenDot", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);


//# sourceMappingURL=folder-open-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderOpen = createLucideIcon("FolderOpen", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ]
]);


//# sourceMappingURL=folder-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-output.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderOutput = createLucideIcon("FolderOutput", [
  [
    "path",
    {
      d: "M2 7.5V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2",
      key: "jm8npq"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);


//# sourceMappingURL=folder-output.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderPlus = createLucideIcon("FolderPlus", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "10", y2: "16", key: "3c25pp" }],
  ["line", { x1: "9", x2: "15", y1: "13", y2: "13", key: "10hoct" }]
]);


//# sourceMappingURL=folder-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-root.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderRoot = createLucideIcon("FolderRoot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);


//# sourceMappingURL=folder-root.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-search-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderSearch2 = createLucideIcon("FolderSearch2", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  ["path", { d: "M13.27 14.27 15 16", key: "5hsvtf" }]
]);


//# sourceMappingURL=folder-search-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderSearch = createLucideIcon("FolderSearch", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v4",
      key: "1moo03"
    }
  ],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.5-1.5", key: "3sg1j" }]
]);


//# sourceMappingURL=folder-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-symlink.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderSymlink = createLucideIcon("FolderSymlink", [
  [
    "path",
    {
      d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2",
      key: "1or2t8"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }],
  ["path", { d: "M2 16v-1a2 2 0 0 1 2-2h6", key: "pgw8ln" }]
]);


//# sourceMappingURL=folder-symlink.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-sync.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderSync = createLucideIcon("FolderSync", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1",
      key: "1rkwto"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  [
    "path",
    {
      d: "m12 14 1.5-1.5c.9-.9 2.2-1.5 3.5-1.5s2.6.6 3.5 1.5c.4.4.8 1 1 1.5",
      key: "25wejs"
    }
  ],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  [
    "path",
    {
      d: "m22 18-1.5 1.5c-.9.9-2.1 1.5-3.5 1.5s-2.6-.6-3.5-1.5c-.4-.4-.8-1-1-1.5",
      key: "vlp1j8"
    }
  ]
]);


//# sourceMappingURL=folder-sync.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-tree.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderTree = createLucideIcon("FolderTree", [
  [
    "path",
    {
      d: "M13 10h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "10jzg2"
    }
  ],
  [
    "path",
    {
      d: "M13 21h7a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.88a1 1 0 0 1-.9-.55l-.44-.9a1 1 0 0 0-.9-.55H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "1b9nqm"
    }
  ],
  ["path", { d: "M3 3v2c0 1.1.9 2 2 2h3", key: "1wqwis" }],
  ["path", { d: "M3 3v13c0 1.1.9 2 2 2h3", key: "1bqeom" }]
]);


//# sourceMappingURL=folder-tree.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderUp = createLucideIcon("FolderUp", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);


//# sourceMappingURL=folder-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FolderX = createLucideIcon("FolderX", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);


//# sourceMappingURL=folder-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folder.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Folder = createLucideIcon("Folder", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ]
]);


//# sourceMappingURL=folder.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/folders.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Folders = createLucideIcon("Folders", [
  [
    "path",
    {
      d: "M8 17h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.93a2 2 0 0 1-1.66-.9l-.82-1.2a2 2 0 0 0-1.66-.9H8a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2Z",
      key: "1aska4"
    }
  ],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);


//# sourceMappingURL=folders.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/footprints.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Footprints = createLucideIcon("Footprints", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);


//# sourceMappingURL=footprints.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/forklift.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Forklift = createLucideIcon("Forklift", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  [
    "path",
    { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }
  ]
]);


//# sourceMappingURL=forklift.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/form-input.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FormInput = createLucideIcon("FormInput", [
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }
  ],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);


//# sourceMappingURL=form-input.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/forward.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Forward = createLucideIcon("Forward", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);


//# sourceMappingURL=forward.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/frame.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Frame = createLucideIcon("Frame", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);


//# sourceMappingURL=frame.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/framer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Framer = createLucideIcon("Framer", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);


//# sourceMappingURL=framer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/frown.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Frown = createLucideIcon("Frown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);


//# sourceMappingURL=frown.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fuel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Fuel = createLucideIcon("Fuel", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "8ur5zv"
    }
  ]
]);


//# sourceMappingURL=fuel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/fullscreen.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Fullscreen = createLucideIcon("Fullscreen", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  [
    "rect",
    { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }
  ]
]);


//# sourceMappingURL=fullscreen.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/function-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const FunctionSquare = createLucideIcon("FunctionSquare", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);


//# sourceMappingURL=function-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gallery-horizontal-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GalleryHorizontalEnd = createLucideIcon("GalleryHorizontalEnd", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  [
    "rect",
    { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }
  ]
]);


//# sourceMappingURL=gallery-horizontal-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gallery-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GalleryHorizontal = createLucideIcon("GalleryHorizontal", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  [
    "rect",
    { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }
  ],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);


//# sourceMappingURL=gallery-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gallery-thumbnails.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GalleryThumbnails = createLucideIcon("GalleryThumbnails", [
  [
    "rect",
    { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }
  ],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);


//# sourceMappingURL=gallery-thumbnails.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gallery-vertical-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GalleryVerticalEnd = createLucideIcon("GalleryVerticalEnd", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  [
    "rect",
    { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }
  ]
]);


//# sourceMappingURL=gallery-vertical-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gallery-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GalleryVertical = createLucideIcon("GalleryVertical", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  [
    "rect",
    { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }
  ],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);


//# sourceMappingURL=gallery-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gamepad-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gamepad2 = createLucideIcon("Gamepad2", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);


//# sourceMappingURL=gamepad-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gamepad.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gamepad = createLucideIcon("Gamepad", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }
  ]
]);


//# sourceMappingURL=gamepad.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gantt-chart-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GanttChartSquare = createLucideIcon("GanttChartSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);


//# sourceMappingURL=gantt-chart-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gantt-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GanttChart = createLucideIcon("GanttChart", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);


//# sourceMappingURL=gantt-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gauge-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GaugeCircle = createLucideIcon("GaugeCircle", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);


//# sourceMappingURL=gauge-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gauge.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gauge = createLucideIcon("Gauge", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);


//# sourceMappingURL=gauge.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gavel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gavel = createLucideIcon("Gavel", [
  [
    "path",
    {
      d: "m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10",
      key: "c9cbz0"
    }
  ],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);


//# sourceMappingURL=gavel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gem.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gem = createLucideIcon("Gem", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);


//# sourceMappingURL=gem.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ghost.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ghost = createLucideIcon("Ghost", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);


//# sourceMappingURL=ghost.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gift.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gift = createLucideIcon("Gift", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);


//# sourceMappingURL=gift.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-branch-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitBranchPlus = createLucideIcon("GitBranchPlus", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);


//# sourceMappingURL=git-branch-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-branch.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitBranch = createLucideIcon("GitBranch", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);


//# sourceMappingURL=git-branch.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-commit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitCommit = createLucideIcon("GitCommit", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);


//# sourceMappingURL=git-commit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-compare.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitCompare = createLucideIcon("GitCompare", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);


//# sourceMappingURL=git-compare.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-fork.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitFork = createLucideIcon("GitFork", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9", key: "c89w8i" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);


//# sourceMappingURL=git-fork.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-merge.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitMerge = createLucideIcon("GitMerge", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);


//# sourceMappingURL=git-merge.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-pull-request-closed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitPullRequestClosed = createLucideIcon("GitPullRequestClosed", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);


//# sourceMappingURL=git-pull-request-closed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-pull-request-draft.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitPullRequestDraft = createLucideIcon("GitPullRequestDraft", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);


//# sourceMappingURL=git-pull-request-draft.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/git-pull-request.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GitPullRequest = createLucideIcon("GitPullRequest", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);


//# sourceMappingURL=git-pull-request.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/github.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Github = createLucideIcon("Github", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);


//# sourceMappingURL=github.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/gitlab.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Gitlab = createLucideIcon("Gitlab", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);


//# sourceMappingURL=gitlab.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/glass-water.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GlassWater = createLucideIcon("GlassWater", [
  [
    "path",
    {
      d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z",
      key: "48rfw3"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);


//# sourceMappingURL=glass-water.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/glasses.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Glasses = createLucideIcon("Glasses", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);


//# sourceMappingURL=glasses.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/globe-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Globe2 = createLucideIcon("Globe2", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17",
      key: "1fi5u6"
    }
  ],
  [
    "path",
    {
      d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
      key: "xsiumc"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=globe-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/globe.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Globe = createLucideIcon("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  [
    "path",
    {
      d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z",
      key: "nb9nel"
    }
  ]
]);


//# sourceMappingURL=globe.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/goal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Goal = createLucideIcon("Goal", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.55 10.23A9 9 0 1 1 8 4.94", key: "5988i3" }],
  ["path", { d: "M8 10a5 5 0 1 0 8.9 2.02", key: "1hq7ot" }]
]);


//# sourceMappingURL=goal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grab.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Grab = createLucideIcon("Grab", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "n5nng" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "185i9d" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "11pz95" }],
  ["path", { d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "16yk7l" }],
  [
    "path",
    {
      d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0",
      key: "nzvb1c"
    }
  ]
]);


//# sourceMappingURL=grab.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/graduation-cap.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GraduationCap = createLucideIcon("GraduationCap", [
  ["path", { d: "M22 10v6M2 10l10-5 10 5-10 5z", key: "1ef52a" }],
  ["path", { d: "M6 12v5c3 3 9 3 12 0v-5", key: "1f75yj" }]
]);


//# sourceMappingURL=graduation-cap.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grape.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Grape = createLucideIcon("Grape", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);


//# sourceMappingURL=grape.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grid-2x2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Grid2x2 = createLucideIcon("Grid2x2", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);


//# sourceMappingURL=grid-2x2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grid-3x3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Grid3x3 = createLucideIcon("Grid3x3", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);


//# sourceMappingURL=grid-3x3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grip-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GripHorizontal = createLucideIcon("GripHorizontal", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);


//# sourceMappingURL=grip-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grip-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const GripVertical = createLucideIcon("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);


//# sourceMappingURL=grip-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/grip.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Grip = createLucideIcon("Grip", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);


//# sourceMappingURL=grip.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/group.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Group = createLucideIcon("Group", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  [
    "rect",
    { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }
  ]
]);


//# sourceMappingURL=group.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hammer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hammer = createLucideIcon("Hammer", [
  [
    "path",
    {
      d: "m15 12-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L12 9",
      key: "1afvon"
    }
  ],
  ["path", { d: "M17.64 15 22 10.64", key: "zsji6s" }],
  [
    "path",
    {
      d: "m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91",
      key: "lehyy1"
    }
  ]
]);


//# sourceMappingURL=hammer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hand-metal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HandMetal = createLucideIcon("HandMetal", [
  [
    "path",
    { d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "7eki13" }
  ],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);


//# sourceMappingURL=hand-metal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hand.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hand = createLucideIcon("Hand", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "aigmz7" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "1n6bmn" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8", key: "a9iiix" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);


//# sourceMappingURL=hand.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hard-drive-download.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HardDriveDownload = createLucideIcon("HardDriveDownload", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  [
    "rect",
    { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);


//# sourceMappingURL=hard-drive-download.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hard-drive-upload.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HardDriveUpload = createLucideIcon("HardDriveUpload", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  [
    "rect",
    { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);


//# sourceMappingURL=hard-drive-upload.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hard-drive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HardDrive = createLucideIcon("HardDrive", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);


//# sourceMappingURL=hard-drive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hard-hat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HardHat = createLucideIcon("HardHat", [
  [
    "path",
    {
      d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
      key: "1dej2m"
    }
  ],
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6h0", key: "1uc279" }],
  ["path", { d: "M14 6h0a6 6 0 0 1 6 6v3", key: "1j9mnm" }]
]);


//# sourceMappingURL=hard-hat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hash = createLucideIcon("Hash", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);


//# sourceMappingURL=hash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/haze.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Haze = createLucideIcon("Haze", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);


//# sourceMappingURL=haze.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hdmi-port.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HdmiPort = createLucideIcon("HdmiPort", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);


//# sourceMappingURL=hdmi-port.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading1 = createLucideIcon("Heading1", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);


//# sourceMappingURL=heading-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading2 = createLucideIcon("Heading2", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);


//# sourceMappingURL=heading-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading3 = createLucideIcon("Heading3", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  [
    "path",
    { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }
  ],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);


//# sourceMappingURL=heading-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading4 = createLucideIcon("Heading4", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v4h4", key: "13sv97" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }]
]);


//# sourceMappingURL=heading-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-5.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading5 = createLucideIcon("Heading5", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    {
      d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17",
      key: "2nebdn"
    }
  ]
]);


//# sourceMappingURL=heading-5.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading-6.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading6 = createLucideIcon("Heading6", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);


//# sourceMappingURL=heading-6.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heading.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heading = createLucideIcon("Heading", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);


//# sourceMappingURL=heading.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/headphones.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Headphones = createLucideIcon("Headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);


//# sourceMappingURL=headphones.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heart-crack.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HeartCrack = createLucideIcon("HeartCrack", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);


//# sourceMappingURL=heart-crack.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heart-handshake.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HeartHandshake = createLucideIcon("HeartHandshake", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "12sd6o"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);


//# sourceMappingURL=heart-handshake.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heart-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HeartOff = createLucideIcon("HeartOff", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    {
      d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35",
      key: "3mpagl"
    }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);


//# sourceMappingURL=heart-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heart-pulse.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HeartPulse = createLucideIcon("HeartPulse", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);


//# sourceMappingURL=heart-pulse.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/heart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Heart = createLucideIcon("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);


//# sourceMappingURL=heart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/help-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HelpCircle = createLucideIcon("HelpCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);


//# sourceMappingURL=help-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/helping-hand.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HelpingHand = createLucideIcon("HelpingHand", [
  [
    "path",
    {
      d: "m3 15 5.12-5.12A3 3 0 0 1 10.24 9H13a2 2 0 1 1 0 4h-2.5m4-.68 4.17-4.89a1.88 1.88 0 0 1 2.92 2.36l-4.2 5.94A3 3 0 0 1 14.96 17H9.83a2 2 0 0 0-1.42.59L7 19",
      key: "nitrv7"
    }
  ],
  ["path", { d: "m2 14 6 6", key: "g6j1uo" }]
]);


//# sourceMappingURL=helping-hand.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hexagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hexagon = createLucideIcon("Hexagon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);


//# sourceMappingURL=hexagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/highlighter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Highlighter = createLucideIcon("Highlighter", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  [
    "path",
    {
      d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4",
      key: "14a9rk"
    }
  ]
]);


//# sourceMappingURL=highlighter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/history.js
/**
 * lucide-react v0.284.0 - ISC
 */



const History = createLucideIcon("History", [
  [
    "path",
    { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }
  ],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);


//# sourceMappingURL=history.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/home.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Home = createLucideIcon("Home", [
  [
    "path",
    { d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "y5dka4" }
  ],
  ["polyline", { points: "9 22 9 12 15 12 15 22", key: "e2us08" }]
]);


//# sourceMappingURL=home.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hop-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const HopOff = createLucideIcon("HopOff", [
  [
    "path",
    {
      d: "M17.5 5.5C19 7 20.5 9 21 11c-1.323.265-2.646.39-4.118.226",
      key: "10j95a"
    }
  ],
  [
    "path",
    { d: "M5.5 17.5C7 19 9 20.5 11 21c.5-2.5.5-5-1-8.5", key: "1mqyjd" }
  ],
  ["path", { d: "M17.5 17.5c-2.5 0-4 0-6-1", key: "11elt5" }],
  ["path", { d: "M20 11.5c1 1.5 2 3.5 2 4.5", key: "13ezvz" }],
  [
    "path",
    { d: "M11.5 20c1.5 1 3.5 2 4.5 2 .5-1.5 0-3-.5-4.5", key: "1ufrz1" }
  ],
  ["path", { d: "M22 22c-2 0-3.5-.5-5.5-1.5", key: "1n8vbj" }],
  [
    "path",
    {
      d: "M4.783 4.782C1.073 8.492 1 14.5 5 18c1-1 2-4.5 1.5-6.5 1.5 1 4 1 5.5.5M8.227 2.57C11.578 1.335 15.453 2.089 18 5c-.88.88-3.7 1.761-5.726 1.618",
      key: "1h85u8"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=hop-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hop.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hop = createLucideIcon("Hop", [
  [
    "path",
    { d: "M17.5 5.5C19 7 20.5 9 21 11c-2.5.5-5 .5-8.5-1", key: "l0z2za" }
  ],
  [
    "path",
    { d: "M5.5 17.5C7 19 9 20.5 11 21c.5-2.5.5-5-1-8.5", key: "1mqyjd" }
  ],
  ["path", { d: "M16.5 11.5c1 2 1 3.5 1 6-2.5 0-4 0-6-1", key: "10xoad" }],
  ["path", { d: "M20 11.5c1 1.5 2 3.5 2 4.5-1.5.5-3 0-4.5-.5", key: "1a4gpx" }],
  [
    "path",
    { d: "M11.5 20c1.5 1 3.5 2 4.5 2 .5-1.5 0-3-.5-4.5", key: "1ufrz1" }
  ],
  [
    "path",
    { d: "M20.5 16.5c1 2 1.5 3.5 1.5 5.5-2 0-3.5-.5-5.5-1.5", key: "1ok5d2" }
  ],
  [
    "path",
    {
      d: "M4.783 4.782C8.493 1.072 14.5 1 18 5c-1 1-4.5 2-6.5 1.5 1 1.5 1 4 .5 5.5-1.5.5-4 .5-5.5-.5C7 13.5 6 17 5 18c-4-3.5-3.927-9.508-.217-13.218Z",
      key: "8hlroy"
    }
  ],
  ["path", { d: "M4.5 4.5 3 3c-.184-.185-.184-.816 0-1", key: "q3aj97" }]
]);


//# sourceMappingURL=hop.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hotel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hotel = createLucideIcon("Hotel", [
  [
    "path",
    {
      d: "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z",
      key: "p9z69c"
    }
  ],
  [
    "path",
    { d: "m9 16 .348-.24c1.465-1.013 3.84-1.013 5.304 0L15 16", key: "1bvcvh" }
  ],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M10 22v-6.5m4 0V22", key: "16gs4s" }]
]);


//# sourceMappingURL=hotel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/hourglass.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Hourglass = createLucideIcon("Hourglass", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    {
      d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
      key: "1vvvr6"
    }
  ]
]);


//# sourceMappingURL=hourglass.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ice-cream-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const IceCream2 = createLucideIcon("IceCream2", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6Zm-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "g86ewz"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);


//# sourceMappingURL=ice-cream-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ice-cream.js
/**
 * lucide-react v0.284.0 - ISC
 */



const IceCream = createLucideIcon("IceCream", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);


//# sourceMappingURL=ice-cream.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/image-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ImageMinus = createLucideIcon("ImageMinus", [
  [
    "path",
    {
      d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7",
      key: "m87ecr"
    }
  ],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);


//# sourceMappingURL=image-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/image-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ImageOff = createLucideIcon("ImageOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);


//# sourceMappingURL=image-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/image-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ImagePlus = createLucideIcon("ImagePlus", [
  [
    "path",
    {
      d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7",
      key: "31hg93"
    }
  ],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["line", { x1: "19", x2: "19", y1: "2", y2: "8", key: "1gkr8c" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);


//# sourceMappingURL=image-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/image.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Image = createLucideIcon("Image", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);


//# sourceMappingURL=image.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/import.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Import = createLucideIcon("Import", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);


//# sourceMappingURL=import.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/inbox.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Inbox = createLucideIcon("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);


//# sourceMappingURL=inbox.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/indent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Indent = createLucideIcon("Indent", [
  ["polyline", { points: "3 8 7 12 3 16", key: "f3rxhf" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);


//# sourceMappingURL=indent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/indian-rupee.js
/**
 * lucide-react v0.284.0 - ISC
 */



const IndianRupee = createLucideIcon("IndianRupee", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);


//# sourceMappingURL=indian-rupee.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/infinity.js
/**
 * lucide-react v0.284.0 - ISC
 */



const infinity_Infinity = createLucideIcon("Infinity", [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
]);


//# sourceMappingURL=infinity.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/info.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Info = createLucideIcon("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);


//# sourceMappingURL=info.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/instagram.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Instagram = createLucideIcon("Instagram", [
  [
    "rect",
    {
      width: "20",
      height: "20",
      x: "2",
      y: "2",
      rx: "5",
      ry: "5",
      key: "2e1cvw"
    }
  ],
  [
    "path",
    { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }
  ],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);


//# sourceMappingURL=instagram.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/italic.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Italic = createLucideIcon("Italic", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);


//# sourceMappingURL=italic.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/iteration-ccw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const IterationCcw = createLucideIcon("IterationCcw", [
  [
    "path",
    { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }
  ],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);


//# sourceMappingURL=iteration-ccw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/iteration-cw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const IterationCw = createLucideIcon("IterationCw", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);


//# sourceMappingURL=iteration-cw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/japanese-yen.js
/**
 * lucide-react v0.284.0 - ISC
 */



const JapaneseYen = createLucideIcon("JapaneseYen", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);


//# sourceMappingURL=japanese-yen.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/joystick.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Joystick = createLucideIcon("Joystick", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);


//# sourceMappingURL=joystick.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/kanban-square-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const KanbanSquareDashed = createLucideIcon("KanbanSquareDashed", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);


//# sourceMappingURL=kanban-square-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/kanban-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const KanbanSquare = createLucideIcon("KanbanSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);


//# sourceMappingURL=kanban-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/kanban.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Kanban = createLucideIcon("Kanban", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);


//# sourceMappingURL=kanban.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/key-round.js
/**
 * lucide-react v0.284.0 - ISC
 */



const KeyRound = createLucideIcon("KeyRound", [
  [
    "path",
    {
      d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z",
      key: "167ctg"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", key: "1kog09" }]
]);


//# sourceMappingURL=key-round.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/key-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const KeySquare = createLucideIcon("KeySquare", [
  [
    "path",
    {
      d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z",
      key: "9li5bk"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    { d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4", key: "1ym3zm" }
  ]
]);


//# sourceMappingURL=key-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/key.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Key = createLucideIcon("Key", [
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["path", { d: "m15.5 7.5 3 3L22 7l-3-3", key: "1rn1fs" }]
]);


//# sourceMappingURL=key.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/keyboard.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Keyboard = createLucideIcon("Keyboard", [
  [
    "rect",
    {
      width: "20",
      height: "16",
      x: "2",
      y: "4",
      rx: "2",
      ry: "2",
      key: "15u882"
    }
  ],
  ["path", { d: "M6 8h.001", key: "1ej0i3" }],
  ["path", { d: "M10 8h.001", key: "1x2st2" }],
  ["path", { d: "M14 8h.001", key: "1vkmyp" }],
  ["path", { d: "M18 8h.001", key: "kfsenl" }],
  ["path", { d: "M8 12h.001", key: "1sjpby" }],
  ["path", { d: "M12 12h.001", key: "al75ts" }],
  ["path", { d: "M16 12h.001", key: "931bgk" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);


//# sourceMappingURL=keyboard.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp-ceiling.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LampCeiling = createLucideIcon("LampCeiling", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);


//# sourceMappingURL=lamp-ceiling.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp-desk.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LampDesk = createLucideIcon("LampDesk", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);


//# sourceMappingURL=lamp-desk.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp-floor.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LampFloor = createLucideIcon("LampFloor", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);


//# sourceMappingURL=lamp-floor.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp-wall-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LampWallDown = createLucideIcon("LampWallDown", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);


//# sourceMappingURL=lamp-wall-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp-wall-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LampWallUp = createLucideIcon("LampWallUp", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);


//# sourceMappingURL=lamp-wall-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lamp.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Lamp = createLucideIcon("Lamp", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);


//# sourceMappingURL=lamp.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/land-plot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LandPlot = createLucideIcon("LandPlot", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);


//# sourceMappingURL=land-plot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/landmark.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Landmark = createLucideIcon("Landmark", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);


//# sourceMappingURL=landmark.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/languages.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Languages = createLucideIcon("Languages", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);


//# sourceMappingURL=languages.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/laptop-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Laptop2 = createLucideIcon("Laptop2", [
  [
    "rect",
    {
      width: "18",
      height: "12",
      x: "3",
      y: "4",
      rx: "2",
      ry: "2",
      key: "1qhy41"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);


//# sourceMappingURL=laptop-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/laptop.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Laptop = createLucideIcon("Laptop", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);


//# sourceMappingURL=laptop.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lasso-select.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LassoSelect = createLucideIcon("LassoSelect", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z",
      key: "1bawls"
    }
  ]
]);


//# sourceMappingURL=lasso-select.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lasso.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Lasso = createLucideIcon("Lasso", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);


//# sourceMappingURL=lasso.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/laugh.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Laugh = createLucideIcon("Laugh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);


//# sourceMappingURL=laugh.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layers-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Layers2 = createLucideIcon("Layers2", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);


//# sourceMappingURL=layers-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layers-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Layers3 = createLucideIcon("Layers3", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  [
    "path",
    {
      d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1e5n1m"
    }
  ],
  [
    "path",
    {
      d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1iwflc"
    }
  ]
]);


//# sourceMappingURL=layers-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layers.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Layers = createLucideIcon("Layers", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  [
    "path",
    { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }
  ],
  [
    "path",
    { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }
  ]
]);


//# sourceMappingURL=layers.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-dashboard.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutDashboard = createLucideIcon("LayoutDashboard", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  [
    "rect",
    { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }
  ],
  [
    "rect",
    { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }
  ],
  [
    "rect",
    { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }
  ]
]);


//# sourceMappingURL=layout-dashboard.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-grid.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutGrid = createLucideIcon("LayoutGrid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }
  ],
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }
  ],
  [
    "rect",
    { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }
  ]
]);


//# sourceMappingURL=layout-grid.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-list.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutList = createLucideIcon("LayoutList", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  [
    "rect",
    { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }
  ],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);


//# sourceMappingURL=layout-list.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-panel-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutPanelLeft = createLucideIcon("LayoutPanelLeft", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }
  ],
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }
  ]
]);


//# sourceMappingURL=layout-panel-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-panel-top.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutPanelTop = createLucideIcon("LayoutPanelTop", [
  [
    "rect",
    { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }
  ],
  [
    "rect",
    { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }
  ],
  [
    "rect",
    { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }
  ]
]);


//# sourceMappingURL=layout-panel-top.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout-template.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LayoutTemplate = createLucideIcon("LayoutTemplate", [
  [
    "rect",
    { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }
  ],
  [
    "rect",
    { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }
  ],
  [
    "rect",
    { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }
  ]
]);


//# sourceMappingURL=layout-template.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/layout.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Layout = createLucideIcon("Layout", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "9", x2: "9", y1: "21", y2: "9", key: "wpwpyp" }]
]);


//# sourceMappingURL=layout.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/leaf.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Leaf = createLucideIcon("Leaf", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  [
    "path",
    { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }
  ]
]);


//# sourceMappingURL=leaf.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/leafy-green.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LeafyGreen = createLucideIcon("LeafyGreen", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);


//# sourceMappingURL=leafy-green.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/library.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Library = createLucideIcon("Library", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);


//# sourceMappingURL=library.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/life-buoy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LifeBuoy = createLucideIcon("LifeBuoy", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);


//# sourceMappingURL=life-buoy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ligature.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ligature = createLucideIcon("Ligature", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);


//# sourceMappingURL=ligature.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lightbulb-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LightbulbOff = createLucideIcon("LightbulbOff", [
  [
    "path",
    { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5",
      key: "10m8kw"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);


//# sourceMappingURL=lightbulb-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lightbulb.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Lightbulb = createLucideIcon("Lightbulb", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);


//# sourceMappingURL=lightbulb.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/line-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LineChart = createLucideIcon("LineChart", [
  ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);


//# sourceMappingURL=line-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/link-2-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Link2Off = createLucideIcon("Link2Off", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=link-2-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/link-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Link2 = createLucideIcon("Link2", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);


//# sourceMappingURL=link-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/link.js
/**
 * lucide-react v0.284.0 - ISC
 */



const link_Link = createLucideIcon("Link", [
  [
    "path",
    {
      d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
      key: "1cjeqo"
    }
  ],
  [
    "path",
    {
      d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
      key: "19qd67"
    }
  ]
]);


//# sourceMappingURL=link.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/linkedin.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Linkedin = createLucideIcon("Linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);


//# sourceMappingURL=linkedin.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-checks.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListChecks = createLucideIcon("ListChecks", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);


//# sourceMappingURL=list-checks.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-end.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListEnd = createLucideIcon("ListEnd", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);


//# sourceMappingURL=list-end.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-filter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListFilter = createLucideIcon("ListFilter", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);


//# sourceMappingURL=list-filter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListMinus = createLucideIcon("ListMinus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);


//# sourceMappingURL=list-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-music.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListMusic = createLucideIcon("ListMusic", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  [
    "path",
    { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }
  ],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);


//# sourceMappingURL=list-music.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-ordered.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListOrdered = createLucideIcon("ListOrdered", [
  ["line", { x1: "10", x2: "21", y1: "6", y2: "6", key: "76qw6h" }],
  ["line", { x1: "10", x2: "21", y1: "12", y2: "12", key: "16nom4" }],
  ["line", { x1: "10", x2: "21", y1: "18", y2: "18", key: "u3jurt" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);


//# sourceMappingURL=list-ordered.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListPlus = createLucideIcon("ListPlus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);


//# sourceMappingURL=list-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-restart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListRestart = createLucideIcon("ListRestart", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);


//# sourceMappingURL=list-restart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-start.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListStart = createLucideIcon("ListStart", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);


//# sourceMappingURL=list-start.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-todo.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListTodo = createLucideIcon("ListTodo", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);


//# sourceMappingURL=list-todo.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-tree.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListTree = createLucideIcon("ListTree", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);


//# sourceMappingURL=list-tree.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-video.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListVideo = createLucideIcon("ListVideo", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);


//# sourceMappingURL=list-video.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ListX = createLucideIcon("ListX", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);


//# sourceMappingURL=list-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/list.js
/**
 * lucide-react v0.284.0 - ISC
 */



const List = createLucideIcon("List", [
  ["line", { x1: "8", x2: "21", y1: "6", y2: "6", key: "7ey8pc" }],
  ["line", { x1: "8", x2: "21", y1: "12", y2: "12", key: "rjfblc" }],
  ["line", { x1: "8", x2: "21", y1: "18", y2: "18", key: "c3b1m8" }],
  ["line", { x1: "3", x2: "3.01", y1: "6", y2: "6", key: "1g7gq3" }],
  ["line", { x1: "3", x2: "3.01", y1: "12", y2: "12", key: "1pjlvk" }],
  ["line", { x1: "3", x2: "3.01", y1: "18", y2: "18", key: "28t2mc" }]
]);


//# sourceMappingURL=list.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/loader-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Loader2 = createLucideIcon("Loader2", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);


//# sourceMappingURL=loader-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/loader.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Loader = createLucideIcon("Loader", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "6", key: "gza1u7" }],
  ["line", { x1: "12", x2: "12", y1: "18", y2: "22", key: "1qhbu9" }],
  ["line", { x1: "4.93", x2: "7.76", y1: "4.93", y2: "7.76", key: "xae44r" }],
  [
    "line",
    { x1: "16.24", x2: "19.07", y1: "16.24", y2: "19.07", key: "bxnmvf" }
  ],
  ["line", { x1: "2", x2: "6", y1: "12", y2: "12", key: "89khin" }],
  ["line", { x1: "18", x2: "22", y1: "12", y2: "12", key: "pb8tfm" }],
  ["line", { x1: "4.93", x2: "7.76", y1: "19.07", y2: "16.24", key: "1uxjnu" }],
  ["line", { x1: "16.24", x2: "19.07", y1: "7.76", y2: "4.93", key: "6duxfx" }]
]);


//# sourceMappingURL=loader.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/locate-fixed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LocateFixed = createLucideIcon("LocateFixed", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=locate-fixed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/locate-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LocateOff = createLucideIcon("LocateOff", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=locate-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/locate.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Locate = createLucideIcon("Locate", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);


//# sourceMappingURL=locate.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lock-keyhole.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LockKeyhole = createLucideIcon("LockKeyhole", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  [
    "rect",
    { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }
  ],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);


//# sourceMappingURL=lock-keyhole.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Lock = createLucideIcon("Lock", [
  [
    "rect",
    {
      width: "18",
      height: "11",
      x: "3",
      y: "11",
      rx: "2",
      ry: "2",
      key: "1w4ew1"
    }
  ],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);


//# sourceMappingURL=lock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/log-in.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LogIn = createLucideIcon("LogIn", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);


//# sourceMappingURL=log-in.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/log-out.js
/**
 * lucide-react v0.284.0 - ISC
 */



const LogOut = createLucideIcon("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);


//# sourceMappingURL=log-out.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/lollipop.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Lollipop = createLucideIcon("Lollipop", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  [
    "path",
    { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }
  ]
]);


//# sourceMappingURL=lollipop.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/luggage.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Luggage = createLucideIcon("Luggage", [
  [
    "path",
    {
      d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0",
      key: "1h5fkc"
    }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);


//# sourceMappingURL=luggage.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/m-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MSquare = createLucideIcon("MSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);


//# sourceMappingURL=m-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/magnet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Magnet = createLucideIcon("Magnet", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);


//# sourceMappingURL=magnet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailCheck = createLucideIcon("MailCheck", [
  [
    "path",
    {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
      key: "12jkf8"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);


//# sourceMappingURL=mail-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailMinus = createLucideIcon("MailMinus", [
  [
    "path",
    {
      d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
      key: "fuxbkv"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);


//# sourceMappingURL=mail-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailOpen = createLucideIcon("MailOpen", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);


//# sourceMappingURL=mail-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailPlus = createLucideIcon("MailPlus", [
  [
    "path",
    {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
      key: "12jkf8"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);


//# sourceMappingURL=mail-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-question.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailQuestion = createLucideIcon("MailQuestion", [
  [
    "path",
    {
      d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5",
      key: "e61zoh"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);


//# sourceMappingURL=mail-question.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailSearch = createLucideIcon("MailSearch", [
  [
    "path",
    {
      d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5",
      key: "w80f2v"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", key: "mgbru4" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);


//# sourceMappingURL=mail-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-warning.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailWarning = createLucideIcon("MailWarning", [
  [
    "path",
    {
      d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5",
      key: "e61zoh"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);


//# sourceMappingURL=mail-warning.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MailX = createLucideIcon("MailX", [
  [
    "path",
    {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9",
      key: "1j9vog"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);


//# sourceMappingURL=mail-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mail.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mail = createLucideIcon("Mail", [
  [
    "rect",
    { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);


//# sourceMappingURL=mail.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mailbox.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mailbox = createLucideIcon("Mailbox", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0", key: "n6nfvi" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);


//# sourceMappingURL=mailbox.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mails.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mails = createLucideIcon("Mails", [
  [
    "rect",
    { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }
  ],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);


//# sourceMappingURL=mails.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/map-pin-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MapPinOff = createLucideIcon("MapPinOff", [
  [
    "path",
    {
      d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5",
      key: "12a8pk"
    }
  ],
  [
    "path",
    {
      d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82",
      key: "1r9f6y"
    }
  ],
  [
    "path",
    {
      d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13",
      key: "erynq7"
    }
  ],
  ["path", { d: "M14.9 9.25a3 3 0 0 0-2.15-2.16", key: "1hwwmx" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=map-pin-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/map-pin.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MapPin = createLucideIcon("MapPin", [
  [
    "path",
    { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z", key: "2oe9fu" }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);


//# sourceMappingURL=map-pin.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/map.js
/**
 * lucide-react v0.284.0 - ISC
 */



const map_Map = createLucideIcon("Map", [
  [
    "polygon",
    { points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21", key: "ok2ie8" }
  ],
  ["line", { x1: "9", x2: "9", y1: "3", y2: "18", key: "w34qz5" }],
  ["line", { x1: "15", x2: "15", y1: "6", y2: "21", key: "volv9a" }]
]);


//# sourceMappingURL=map.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/martini.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Martini = createLucideIcon("Martini", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);


//# sourceMappingURL=martini.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/maximize-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Maximize2 = createLucideIcon("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);


//# sourceMappingURL=maximize-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/maximize.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Maximize = createLucideIcon("Maximize", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);


//# sourceMappingURL=maximize.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/medal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Medal = createLucideIcon("Medal", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);


//# sourceMappingURL=medal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/megaphone-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MegaphoneOff = createLucideIcon("MegaphoneOff", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=megaphone-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/megaphone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Megaphone = createLucideIcon("Megaphone", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);


//# sourceMappingURL=megaphone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/meh.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Meh = createLucideIcon("Meh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);


//# sourceMappingURL=meh.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/memory-stick.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MemoryStick = createLucideIcon("MemoryStick", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);


//# sourceMappingURL=memory-stick.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/menu-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MenuSquare = createLucideIcon("MenuSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);


//# sourceMappingURL=menu-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/menu.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Menu = createLucideIcon("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);


//# sourceMappingURL=menu.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/merge.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Merge = createLucideIcon("Merge", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);


//# sourceMappingURL=merge.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/message-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MessageCircle = createLucideIcon("MessageCircle", [
  ["path", { d: "m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z", key: "v2veuj" }]
]);


//# sourceMappingURL=message-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/message-square-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MessageSquareDashed = createLucideIcon("MessageSquareDashed", [
  ["path", { d: "M3 6V5c0-1.1.9-2 2-2h2", key: "9usibi" }],
  ["path", { d: "M11 3h3", key: "1c3ji7" }],
  ["path", { d: "M18 3h1c1.1 0 2 .9 2 2", key: "19esxn" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M21 15c0 1.1-.9 2-2 2h-1", key: "1fo1j8" }],
  ["path", { d: "M14 17h-3", key: "1w4p2m" }],
  ["path", { d: "m7 17-4 4v-5", key: "ph9x1h" }],
  ["path", { d: "M3 12v-2", key: "856n1q" }]
]);


//# sourceMappingURL=message-square-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/message-square-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MessageSquarePlus = createLucideIcon("MessageSquarePlus", [
  [
    "path",
    {
      d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
      key: "1lielz"
    }
  ],
  ["line", { x1: "9", x2: "15", y1: "10", y2: "10", key: "1lj1wd" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }]
]);


//# sourceMappingURL=message-square-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/message-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MessageSquare = createLucideIcon("MessageSquare", [
  [
    "path",
    {
      d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
      key: "1lielz"
    }
  ]
]);


//# sourceMappingURL=message-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/messages-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MessagesSquare = createLucideIcon("MessagesSquare", [
  [
    "path",
    {
      d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z",
      key: "16vlm8"
    }
  ],
  [
    "path",
    { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }
  ]
]);


//# sourceMappingURL=messages-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mic-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mic2 = createLucideIcon("Mic2", [
  [
    "path",
    { d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12", key: "zoua8r" }
  ],
  ["circle", { cx: "17", cy: "7", r: "5", key: "1fomce" }]
]);


//# sourceMappingURL=mic-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mic-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MicOff = createLucideIcon("MicOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);


//# sourceMappingURL=mic-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mic.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mic = createLucideIcon("Mic", [
  [
    "path",
    {
      d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z",
      key: "131961"
    }
  ],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);


//# sourceMappingURL=mic.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/microscope.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Microscope = createLucideIcon("Microscope", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);


//# sourceMappingURL=microscope.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/microwave.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Microwave = createLucideIcon("Microwave", [
  [
    "rect",
    { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }
  ],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);


//# sourceMappingURL=microwave.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/milestone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Milestone = createLucideIcon("Milestone", [
  [
    "path",
    {
      d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z",
      key: "1mp5s7"
    }
  ],
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }]
]);


//# sourceMappingURL=milestone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/milk-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MilkOff = createLucideIcon("MilkOff", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  [
    "path",
    {
      d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435",
      key: "iaxqsy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=milk-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/milk.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Milk = createLucideIcon("Milk", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  [
    "path",
    { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }
  ]
]);


//# sourceMappingURL=milk.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/minimize-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Minimize2 = createLucideIcon("Minimize2", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);


//# sourceMappingURL=minimize-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/minimize.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Minimize = createLucideIcon("Minimize", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);


//# sourceMappingURL=minimize.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/minus-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MinusCircle = createLucideIcon("MinusCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);


//# sourceMappingURL=minus-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/minus-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MinusSquare = createLucideIcon("MinusSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);


//# sourceMappingURL=minus-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Minus = createLucideIcon("Minus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }]
]);


//# sourceMappingURL=minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorCheck = createLucideIcon("MonitorCheck", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorDot = createLucideIcon("MonitorDot", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  [
    "path",
    {
      d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9",
      key: "1fet9y"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorDown = createLucideIcon("MonitorDown", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorOff = createLucideIcon("MonitorOff", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);


//# sourceMappingURL=monitor-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-pause.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorPause = createLucideIcon("MonitorPause", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-pause.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-play.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorPlay = createLucideIcon("MonitorPlay", [
  ["path", { d: "m10 7 5 3-5 3Z", key: "29ljg6" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-play.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-smartphone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorSmartphone = createLucideIcon("MonitorSmartphone", [
  [
    "path",
    {
      d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8",
      key: "10dyio"
    }
  ],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  [
    "rect",
    { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }
  ]
]);


//# sourceMappingURL=monitor-smartphone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-speaker.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorSpeaker = createLucideIcon("MonitorSpeaker", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  [
    "rect",
    { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }
  ],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);


//# sourceMappingURL=monitor-speaker.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-stop.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorStop = createLucideIcon("MonitorStop", [
  ["rect", { x: "9", y: "7", width: "6", height: "6", key: "4xvc6r" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-stop.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorUp = createLucideIcon("MonitorUp", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MonitorX = createLucideIcon("MonitorX", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);


//# sourceMappingURL=monitor-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/monitor.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Monitor = createLucideIcon("Monitor", [
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);


//# sourceMappingURL=monitor.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/moon-star.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoonStar = createLucideIcon("MoonStar", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }],
  ["path", { d: "M19 3v4", key: "vgv24u" }],
  ["path", { d: "M21 5h-4", key: "1wcg1f" }]
]);


//# sourceMappingURL=moon-star.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/moon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Moon = createLucideIcon("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);


//# sourceMappingURL=moon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/more-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoreHorizontal = createLucideIcon("MoreHorizontal", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);


//# sourceMappingURL=more-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/more-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoreVertical = createLucideIcon("MoreVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);


//# sourceMappingURL=more-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mountain-snow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MountainSnow = createLucideIcon("MountainSnow", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    {
      d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19",
      key: "1pvmmp"
    }
  ]
]);


//# sourceMappingURL=mountain-snow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mountain.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mountain = createLucideIcon("Mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);


//# sourceMappingURL=mountain.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse-pointer-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MousePointer2 = createLucideIcon("MousePointer2", [
  ["path", { d: "m4 4 7.07 17 2.51-7.39L21 11.07z", key: "1vqm48" }]
]);


//# sourceMappingURL=mouse-pointer-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse-pointer-click.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MousePointerClick = createLucideIcon("MousePointerClick", [
  ["path", { d: "m9 9 5 12 1.8-5.2L21 14Z", key: "1b76lo" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }]
]);


//# sourceMappingURL=mouse-pointer-click.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse-pointer-square-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MousePointerSquareDashed = createLucideIcon("MousePointerSquareDashed", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);


//# sourceMappingURL=mouse-pointer-square-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse-pointer-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MousePointerSquare = createLucideIcon("MousePointerSquare", [
  [
    "path",
    {
      d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6",
      key: "14rsvq"
    }
  ],
  ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }]
]);


//# sourceMappingURL=mouse-pointer-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse-pointer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MousePointer = createLucideIcon("MousePointer", [
  ["path", { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z", key: "y2ucgo" }],
  ["path", { d: "m13 13 6 6", key: "1nhxnf" }]
]);


//# sourceMappingURL=mouse-pointer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/mouse.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Mouse = createLucideIcon("Mouse", [
  [
    "rect",
    { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }
  ],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);


//# sourceMappingURL=mouse.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-3d.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Move3d = createLucideIcon("Move3d", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);


//# sourceMappingURL=move-3d.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-diagonal-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveDiagonal2 = createLucideIcon("MoveDiagonal2", [
  ["polyline", { points: "5 11 5 5 11 5", key: "ncfzxk" }],
  ["polyline", { points: "19 13 19 19 13 19", key: "1mk7hk" }],
  ["line", { x1: "5", x2: "19", y1: "5", y2: "19", key: "mcyte3" }]
]);


//# sourceMappingURL=move-diagonal-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-diagonal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveDiagonal = createLucideIcon("MoveDiagonal", [
  ["polyline", { points: "13 5 19 5 19 11", key: "11219e" }],
  ["polyline", { points: "11 19 5 19 5 13", key: "sfq3wq" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);


//# sourceMappingURL=move-diagonal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-down-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveDownLeft = createLucideIcon("MoveDownLeft", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);


//# sourceMappingURL=move-down-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-down-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveDownRight = createLucideIcon("MoveDownRight", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);


//# sourceMappingURL=move-down-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveDown = createLucideIcon("MoveDown", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);


//# sourceMappingURL=move-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveHorizontal = createLucideIcon("MoveHorizontal", [
  ["polyline", { points: "18 8 22 12 18 16", key: "1hqrds" }],
  ["polyline", { points: "6 8 2 12 6 16", key: "f0ernq" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }]
]);


//# sourceMappingURL=move-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveLeft = createLucideIcon("MoveLeft", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);


//# sourceMappingURL=move-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveRight = createLucideIcon("MoveRight", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);


//# sourceMappingURL=move-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-up-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveUpLeft = createLucideIcon("MoveUpLeft", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);


//# sourceMappingURL=move-up-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-up-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveUpRight = createLucideIcon("MoveUpRight", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);


//# sourceMappingURL=move-up-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveUp = createLucideIcon("MoveUp", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);


//# sourceMappingURL=move-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const MoveVertical = createLucideIcon("MoveVertical", [
  ["polyline", { points: "8 18 12 22 16 18", key: "1uutw3" }],
  ["polyline", { points: "8 6 12 2 16 6", key: "d60sxy" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);


//# sourceMappingURL=move-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/move.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Move = createLucideIcon("Move", [
  ["polyline", { points: "5 9 2 12 5 15", key: "1r5uj5" }],
  ["polyline", { points: "9 5 12 2 15 5", key: "5v383o" }],
  ["polyline", { points: "15 19 12 22 9 19", key: "g7qi8m" }],
  ["polyline", { points: "19 9 22 12 19 15", key: "tpp73q" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }]
]);


//# sourceMappingURL=move.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/music-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Music2 = createLucideIcon("Music2", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);


//# sourceMappingURL=music-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/music-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Music3 = createLucideIcon("Music3", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);


//# sourceMappingURL=music-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/music-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Music4 = createLucideIcon("Music4", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);


//# sourceMappingURL=music-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/music.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Music = createLucideIcon("Music", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);


//# sourceMappingURL=music.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/navigation-2-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Navigation2Off = createLucideIcon("Navigation2Off", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=navigation-2-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/navigation-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Navigation2 = createLucideIcon("Navigation2", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);


//# sourceMappingURL=navigation-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/navigation-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const NavigationOff = createLucideIcon("NavigationOff", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=navigation-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/navigation.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Navigation = createLucideIcon("Navigation", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);


//# sourceMappingURL=navigation.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/network.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Network = createLucideIcon("Network", [
  [
    "rect",
    { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }
  ],
  [
    "rect",
    { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }
  ],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);


//# sourceMappingURL=network.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/newspaper.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Newspaper = createLucideIcon("Newspaper", [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
]);


//# sourceMappingURL=newspaper.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/nfc.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Nfc = createLucideIcon("Nfc", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);


//# sourceMappingURL=nfc.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/nut-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const NutOff = createLucideIcon("NutOff", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=nut-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/nut.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Nut = createLucideIcon("Nut", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);


//# sourceMappingURL=nut.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/octagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Octagon = createLucideIcon("Octagon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ]
]);


//# sourceMappingURL=octagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/option.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Option = createLucideIcon("Option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);


//# sourceMappingURL=option.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/orbit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Orbit = createLucideIcon("Orbit", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);


//# sourceMappingURL=orbit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/outdent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Outdent = createLucideIcon("Outdent", [
  ["polyline", { points: "7 8 3 12 7 16", key: "2j60jr" }],
  ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
  ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
  ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }]
]);


//# sourceMappingURL=outdent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Package2 = createLucideIcon("Package2", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  [
    "path",
    {
      d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9",
      key: "19h2x1"
    }
  ],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);


//# sourceMappingURL=package-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackageCheck = createLucideIcon("PackageCheck", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);


//# sourceMappingURL=package-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackageMinus = createLucideIcon("PackageMinus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);


//# sourceMappingURL=package-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackageOpen = createLucideIcon("PackageOpen", [
  [
    "path",
    {
      d: "M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z",
      key: "1vy178"
    }
  ],
  [
    "path",
    {
      d: "m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z",
      key: "s3bv25"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "13", key: "1o4xyi" }],
  [
    "path",
    {
      d: "M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5",
      key: "1na2nq"
    }
  ]
]);


//# sourceMappingURL=package-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackagePlus = createLucideIcon("PackagePlus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);


//# sourceMappingURL=package-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackageSearch = createLucideIcon("PackageSearch", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);


//# sourceMappingURL=package-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PackageX = createLucideIcon("PackageX", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);


//# sourceMappingURL=package-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/package.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Package = createLucideIcon("Package", [
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);


//# sourceMappingURL=package.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/paint-bucket.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PaintBucket = createLucideIcon("PaintBucket", [
  [
    "path",
    {
      d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z",
      key: "irua1i"
    }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  [
    "path",
    {
      d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z",
      key: "xk76lq"
    }
  ]
]);


//# sourceMappingURL=paint-bucket.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/paintbrush-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Paintbrush2 = createLucideIcon("Paintbrush2", [
  [
    "path",
    {
      d: "M14 19.9V16h3a2 2 0 0 0 2-2v-2H5v2c0 1.1.9 2 2 2h3v3.9a2 2 0 1 0 4 0Z",
      key: "1c8kta"
    }
  ],
  ["path", { d: "M6 12V2h12v10", key: "1esbnf" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }]
]);


//# sourceMappingURL=paintbrush-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/paintbrush.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Paintbrush = createLucideIcon("Paintbrush", [
  [
    "path",
    {
      d: "M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z",
      key: "m6k5sh"
    }
  ],
  ["path", { d: "M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7", key: "arzq70" }],
  ["path", { d: "M14.5 17.5 4.5 15", key: "s7fvrz" }]
]);


//# sourceMappingURL=paintbrush.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/palette.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Palette = createLucideIcon("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", key: "1xcu5" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", key: "736e4u" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", key: "clrty" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", key: "1s4xz9" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);


//# sourceMappingURL=palette.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/palmtree.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Palmtree = createLucideIcon("Palmtree", [
  [
    "path",
    { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }
  ],
  [
    "path",
    {
      d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3",
      key: "18arnh"
    }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z",
      key: "epoumf"
    }
  ],
  [
    "path",
    { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }
  ]
]);


//# sourceMappingURL=palmtree.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-bottom-close.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelBottomClose = createLucideIcon("PanelBottomClose", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);


//# sourceMappingURL=panel-bottom-close.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-bottom-inactive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelBottomInactive = createLucideIcon("PanelBottomInactive", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);


//# sourceMappingURL=panel-bottom-inactive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-bottom-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelBottomOpen = createLucideIcon("PanelBottomOpen", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);


//# sourceMappingURL=panel-bottom-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-bottom.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelBottom = createLucideIcon("PanelBottom", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }]
]);


//# sourceMappingURL=panel-bottom.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-left-close.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelLeftClose = createLucideIcon("PanelLeftClose", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);


//# sourceMappingURL=panel-left-close.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-left-inactive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelLeftInactive = createLucideIcon("PanelLeftInactive", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);


//# sourceMappingURL=panel-left-inactive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-left-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelLeftOpen = createLucideIcon("PanelLeftOpen", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);


//# sourceMappingURL=panel-left-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelLeft = createLucideIcon("PanelLeft", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "9", x2: "9", y1: "3", y2: "21", key: "13tij5" }]
]);


//# sourceMappingURL=panel-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-right-close.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelRightClose = createLucideIcon("PanelRightClose", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "15", x2: "15", y1: "3", y2: "21", key: "1hpv9i" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);


//# sourceMappingURL=panel-right-close.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-right-inactive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelRightInactive = createLucideIcon("PanelRightInactive", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);


//# sourceMappingURL=panel-right-inactive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-right-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelRightOpen = createLucideIcon("PanelRightOpen", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "15", x2: "15", y1: "3", y2: "21", key: "1hpv9i" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);


//# sourceMappingURL=panel-right-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelRight = createLucideIcon("PanelRight", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "15", x2: "15", y1: "3", y2: "21", key: "1hpv9i" }]
]);


//# sourceMappingURL=panel-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-top-close.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelTopClose = createLucideIcon("PanelTopClose", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);


//# sourceMappingURL=panel-top-close.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-top-inactive.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelTopInactive = createLucideIcon("PanelTopInactive", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);


//# sourceMappingURL=panel-top-inactive.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-top-open.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelTopOpen = createLucideIcon("PanelTopOpen", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);


//# sourceMappingURL=panel-top-open.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/panel-top.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PanelTop = createLucideIcon("PanelTop", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }]
]);


//# sourceMappingURL=panel-top.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/paperclip.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Paperclip = createLucideIcon("Paperclip", [
  [
    "path",
    {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
      key: "1u3ebp"
    }
  ]
]);


//# sourceMappingURL=paperclip.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parentheses.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Parentheses = createLucideIcon("Parentheses", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);


//# sourceMappingURL=parentheses.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parking-circle-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ParkingCircleOff = createLucideIcon("ParkingCircleOff", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);


//# sourceMappingURL=parking-circle-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parking-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ParkingCircle = createLucideIcon("ParkingCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);


//# sourceMappingURL=parking-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parking-meter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ParkingMeter = createLucideIcon("ParkingMeter", [
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M11 15h2", key: "199qp6" }],
  [
    "path",
    {
      d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3",
      key: "1l50wn"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);


//# sourceMappingURL=parking-meter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parking-square-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ParkingSquareOff = createLucideIcon("ParkingSquareOff", [
  [
    "path",
    {
      d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41",
      key: "9l1ft6"
    }
  ],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);


//# sourceMappingURL=parking-square-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/parking-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ParkingSquare = createLucideIcon("ParkingSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);


//# sourceMappingURL=parking-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/party-popper.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PartyPopper = createLucideIcon("PartyPopper", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "bpx1uq"
    }
  ],
  [
    "path",
    {
      d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17",
      key: "1pd0s7"
    }
  ],
  [
    "path",
    {
      d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7",
      key: "zq5xbz"
    }
  ],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);


//# sourceMappingURL=party-popper.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pause-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PauseCircle = createLucideIcon("PauseCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);


//# sourceMappingURL=pause-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pause-octagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PauseOctagon = createLucideIcon("PauseOctagon", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z",
      key: "1m7qra"
    }
  ]
]);


//# sourceMappingURL=pause-octagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pause.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pause = createLucideIcon("Pause", [
  ["rect", { width: "4", height: "16", x: "6", y: "4", key: "iffhe4" }],
  ["rect", { width: "4", height: "16", x: "14", y: "4", key: "sjin7j" }]
]);


//# sourceMappingURL=pause.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/paw-print.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PawPrint = createLucideIcon("PawPrint", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);


//# sourceMappingURL=paw-print.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pc-case.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PcCase = createLucideIcon("PcCase", [
  [
    "rect",
    { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }
  ],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);


//# sourceMappingURL=pc-case.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pen-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PenLine = createLucideIcon("PenLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" }
  ]
]);


//# sourceMappingURL=pen-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pen-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PenSquare = createLucideIcon("PenSquare", [
  [
    "path",
    {
      d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
      key: "1qinfi"
    }
  ],
  [
    "path",
    { d: "M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z", key: "w2jsv5" }
  ]
]);


//# sourceMappingURL=pen-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pen-tool.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PenTool = createLucideIcon("PenTool", [
  ["path", { d: "m12 19 7-7 3 3-7 7-3-3z", key: "rklqx2" }],
  ["path", { d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z", key: "1et58u" }],
  ["path", { d: "m2 2 7.586 7.586", key: "etlp93" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);


//# sourceMappingURL=pen-tool.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pen.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pen = createLucideIcon("Pen", [
  [
    "path",
    { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" }
  ]
]);


//# sourceMappingURL=pen.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pencil-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PencilLine = createLucideIcon("PencilLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);


//# sourceMappingURL=pencil-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pencil-ruler.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PencilRuler = createLucideIcon("PencilRuler", [
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  [
    "path",
    {
      d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13",
      key: "orapub"
    }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  [
    "path",
    {
      d: "m2 22 5.5-1.5L21.17 6.83a2.82 2.82 0 0 0-4-4L3.5 16.5Z",
      key: "hes763"
    }
  ],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ]
]);


//# sourceMappingURL=pencil-ruler.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pencil.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pencil = createLucideIcon("Pencil", [
  [
    "path",
    { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);


//# sourceMappingURL=pencil.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pentagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pentagon = createLucideIcon("Pentagon", [
  [
    "path",
    {
      d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z",
      key: "hsj90r"
    }
  ]
]);


//# sourceMappingURL=pentagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/percent-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PercentCircle = createLucideIcon("PercentCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);


//# sourceMappingURL=percent-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/percent-diamond.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PercentDiamond = createLucideIcon("PercentDiamond", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);


//# sourceMappingURL=percent-diamond.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/percent-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PercentSquare = createLucideIcon("PercentSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);


//# sourceMappingURL=percent-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/percent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Percent = createLucideIcon("Percent", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);


//# sourceMappingURL=percent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/person-standing.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PersonStanding = createLucideIcon("PersonStanding", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);


//# sourceMappingURL=person-standing.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-call.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneCall = createLucideIcon("PhoneCall", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);


//# sourceMappingURL=phone-call.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-forwarded.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneForwarded = createLucideIcon("PhoneForwarded", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);


//# sourceMappingURL=phone-forwarded.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-incoming.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneIncoming = createLucideIcon("PhoneIncoming", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);


//# sourceMappingURL=phone-incoming.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-missed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneMissed = createLucideIcon("PhoneMissed", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);


//# sourceMappingURL=phone-missed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneOff = createLucideIcon("PhoneOff", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);


//# sourceMappingURL=phone-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone-outgoing.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PhoneOutgoing = createLucideIcon("PhoneOutgoing", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);


//# sourceMappingURL=phone-outgoing.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/phone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Phone = createLucideIcon("Phone", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);


//# sourceMappingURL=phone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pi-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PiSquare = createLucideIcon("PiSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);


//# sourceMappingURL=pi-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pi.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pi = createLucideIcon("Pi", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);


//# sourceMappingURL=pi.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/picture-in-picture-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PictureInPicture2 = createLucideIcon("PictureInPicture2", [
  [
    "path",
    {
      d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4",
      key: "daa4of"
    }
  ],
  [
    "rect",
    { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }
  ]
]);


//# sourceMappingURL=picture-in-picture-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/picture-in-picture.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PictureInPicture = createLucideIcon("PictureInPicture", [
  [
    "path",
    {
      d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
      key: "bcd8fb"
    }
  ],
  [
    "rect",
    { width: "10", height: "7", x: "12", y: "13.5", ry: "2", key: "136fx3" }
  ]
]);


//# sourceMappingURL=picture-in-picture.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pie-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PieChart = createLucideIcon("PieChart", [
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }],
  ["path", { d: "M22 12A10 10 0 0 0 12 2v10z", key: "1rfc4y" }]
]);


//# sourceMappingURL=pie-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/piggy-bank.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PiggyBank = createLucideIcon("PiggyBank", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z",
      key: "uf6l00"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h0", key: "k2aug8" }]
]);


//# sourceMappingURL=piggy-bank.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pilcrow-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PilcrowSquare = createLucideIcon("PilcrowSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);


//# sourceMappingURL=pilcrow-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pilcrow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pilcrow = createLucideIcon("Pilcrow", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);


//# sourceMappingURL=pilcrow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pill.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pill = createLucideIcon("Pill", [
  [
    "path",
    {
      d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
      key: "wa1lgi"
    }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);


//# sourceMappingURL=pill.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pin-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PinOff = createLucideIcon("PinOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12",
      key: "13x2n8"
    }
  ],
  ["path", { d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89", key: "reo3ki" }]
]);


//# sourceMappingURL=pin-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pin.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pin = createLucideIcon("Pin", [
  ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
  [
    "path",
    {
      d: "M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z",
      key: "13yl11"
    }
  ]
]);


//# sourceMappingURL=pin.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pipette.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pipette = createLucideIcon("Pipette", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);


//# sourceMappingURL=pipette.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pizza.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pizza = createLucideIcon("Pizza", [
  ["path", { d: "M15 11h.01", key: "rns66s" }],
  ["path", { d: "M11 15h.01", key: "k85uqc" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "m2 16 20 6-6-20A20 20 0 0 0 2 16", key: "e4slt2" }],
  ["path", { d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4", key: "rerf8f" }]
]);


//# sourceMappingURL=pizza.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plane-landing.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlaneLanding = createLucideIcon("PlaneLanding", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);


//# sourceMappingURL=plane-landing.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plane-takeoff.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlaneTakeoff = createLucideIcon("PlaneTakeoff", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);


//# sourceMappingURL=plane-takeoff.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plane.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Plane = createLucideIcon("Plane", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);


//# sourceMappingURL=plane.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/play-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlayCircle = createLucideIcon("PlayCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);


//# sourceMappingURL=play-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/play-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlaySquare = createLucideIcon("PlaySquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);


//# sourceMappingURL=play-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/play.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Play = createLucideIcon("Play", [
  ["polygon", { points: "5 3 19 12 5 21 5 3", key: "191637" }]
]);


//# sourceMappingURL=play.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plug-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Plug2 = createLucideIcon("Plug2", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z", key: "nd4hoy" }]
]);


//# sourceMappingURL=plug-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plug-zap-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlugZap2 = createLucideIcon("PlugZap2", [
  ["path", { d: "m13 2-2 2.5h3L12 7", key: "1me98u" }],
  ["path", { d: "M10 14v-3", key: "1mllf3" }],
  ["path", { d: "M14 14v-3", key: "1l3fkq" }],
  [
    "path",
    { d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z", key: "jd5pat" }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);


//# sourceMappingURL=plug-zap-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plug-zap.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlugZap = createLucideIcon("PlugZap", [
  [
    "path",
    {
      d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
      key: "goz73y"
    }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);


//# sourceMappingURL=plug-zap.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plug.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Plug = createLucideIcon("Plug", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);


//# sourceMappingURL=plug.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plus-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlusCircle = createLucideIcon("PlusCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);


//# sourceMappingURL=plus-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plus-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PlusSquare = createLucideIcon("PlusSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);


//# sourceMappingURL=plus-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Plus = createLucideIcon("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);


//# sourceMappingURL=plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pocket-knife.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PocketKnife = createLucideIcon("PocketKnife", [
  [
    "path",
    { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }
  ],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  [
    "path",
    {
      d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z",
      key: "6fykxj"
    }
  ],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);


//# sourceMappingURL=pocket-knife.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pocket.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pocket = createLucideIcon("Pocket", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);


//# sourceMappingURL=pocket.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/podcast.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Podcast = createLucideIcon("Podcast", [
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  [
    "path",
    {
      d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z",
      key: "1n5fvv"
    }
  ],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["path", { d: "M17 18.5a9 9 0 1 0-10 0", key: "jqtxkf" }]
]);


//# sourceMappingURL=podcast.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pointer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pointer = createLucideIcon("Pointer", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "1pp0yd" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1", key: "u654g" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v10", key: "1e2dtv" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);


//# sourceMappingURL=pointer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/popcorn.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Popcorn = createLucideIcon("Popcorn", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);


//# sourceMappingURL=popcorn.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/popsicle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Popsicle = createLucideIcon("Popsicle", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);


//# sourceMappingURL=popsicle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pound-sterling.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PoundSterling = createLucideIcon("PoundSterling", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);


//# sourceMappingURL=pound-sterling.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/power-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const PowerOff = createLucideIcon("PowerOff", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);


//# sourceMappingURL=power-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/power.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Power = createLucideIcon("Power", [
  ["path", { d: "M18.36 6.64a9 9 0 1 1-12.73 0", key: "phirl6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "12", key: "aemgbe" }]
]);


//# sourceMappingURL=power.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/presentation.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Presentation = createLucideIcon("Presentation", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);


//# sourceMappingURL=presentation.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/printer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Printer = createLucideIcon("Printer", [
  ["polyline", { points: "6 9 6 2 18 2 18 9", key: "1306q4" }],
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["rect", { width: "12", height: "8", x: "6", y: "14", key: "5ipwut" }]
]);


//# sourceMappingURL=printer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/projector.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Projector = createLucideIcon("Projector", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);


//# sourceMappingURL=projector.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/puzzle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Puzzle = createLucideIcon("Puzzle", [
  [
    "path",
    {
      d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z",
      key: "i0oyt7"
    }
  ]
]);


//# sourceMappingURL=puzzle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/pyramid.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Pyramid = createLucideIcon("Pyramid", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);


//# sourceMappingURL=pyramid.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/qr-code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const QrCode = createLucideIcon("QrCode", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  [
    "rect",
    { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }
  ],
  [
    "rect",
    { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }
  ],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);


//# sourceMappingURL=qr-code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/quote.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Quote = createLucideIcon("Quote", [
  [
    "path",
    {
      d: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z",
      key: "4rm80e"
    }
  ],
  [
    "path",
    {
      d: "M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z",
      key: "10za9r"
    }
  ]
]);


//# sourceMappingURL=quote.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rabbit.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rabbit = createLucideIcon("Rabbit", [
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1.93 1.93 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1c-1.7 0-3 1.3-3 3",
      key: "1i2yr3"
    }
  ],
  ["path", { d: "M7.61 12.53a3 3 0 1 0-1.6 4.3", key: "9ygxkv" }],
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);


//# sourceMappingURL=rabbit.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radar.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Radar = createLucideIcon("Radar", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);


//# sourceMappingURL=radar.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radiation.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Radiation = createLucideIcon("Radiation", [
  ["path", { d: "M12 12h0", key: "1tz7lj" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);


//# sourceMappingURL=radiation.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radio-receiver.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RadioReceiver = createLucideIcon("RadioReceiver", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  [
    "rect",
    { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }
  ],
  ["path", { d: "M18 12h0", key: "1ucjzd" }]
]);


//# sourceMappingURL=radio-receiver.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radio-tower.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RadioTower = createLucideIcon("RadioTower", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);


//# sourceMappingURL=radio-tower.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radio.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Radio = createLucideIcon("Radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);


//# sourceMappingURL=radio.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/radius.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Radius = createLucideIcon("Radius", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);


//# sourceMappingURL=radius.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rail-symbol.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RailSymbol = createLucideIcon("RailSymbol", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);


//# sourceMappingURL=rail-symbol.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rainbow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rainbow = createLucideIcon("Rainbow", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);


//# sourceMappingURL=rainbow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rat = createLucideIcon("Rat", [
  [
    "path",
    {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7v0c0 2.2 1.8 4 4 4",
      key: "16aj0u"
    }
  ],
  [
    "path",
    {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
      key: "1crdmb"
    }
  ],
  ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }]
]);


//# sourceMappingURL=rat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ratio.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ratio = createLucideIcon("Ratio", [
  [
    "rect",
    { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }
  ],
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }
  ]
]);


//# sourceMappingURL=ratio.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/receipt.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Receipt = createLucideIcon("Receipt", [
  [
    "path",
    {
      d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z",
      key: "wqdwcb"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17V7", key: "pyj7ub" }]
]);


//# sourceMappingURL=receipt.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rectangle-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RectangleHorizontal = createLucideIcon("RectangleHorizontal", [
  [
    "rect",
    { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }
  ]
]);


//# sourceMappingURL=rectangle-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rectangle-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RectangleVertical = createLucideIcon("RectangleVertical", [
  [
    "rect",
    { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }
  ]
]);


//# sourceMappingURL=rectangle-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/recycle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Recycle = createLucideIcon("Recycle", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);


//# sourceMappingURL=recycle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/redo-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Redo2 = createLucideIcon("Redo2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  [
    "path",
    {
      d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13",
      key: "19mnr4"
    }
  ]
]);


//# sourceMappingURL=redo-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/redo-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RedoDot = createLucideIcon("RedoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);


//# sourceMappingURL=redo-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/redo.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Redo = createLucideIcon("Redo", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);


//# sourceMappingURL=redo.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/refresh-ccw-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RefreshCcwDot = createLucideIcon("RefreshCcwDot", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);


//# sourceMappingURL=refresh-ccw-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/refresh-ccw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RefreshCcw = createLucideIcon("RefreshCcw", [
  [
    "path",
    { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }
  ],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  [
    "path",
    { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }
  ],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);


//# sourceMappingURL=refresh-ccw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/refresh-cw-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RefreshCwOff = createLucideIcon("RefreshCwOff", [
  [
    "path",
    {
      d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47",
      key: "1krf6h"
    }
  ],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  [
    "path",
    {
      d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64",
      key: "19q130"
    }
  ],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);


//# sourceMappingURL=refresh-cw-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/refresh-cw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RefreshCw = createLucideIcon("RefreshCw", [
  [
    "path",
    { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }
  ],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  [
    "path",
    { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }
  ],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);


//# sourceMappingURL=refresh-cw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/refrigerator.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Refrigerator = createLucideIcon("Refrigerator", [
  [
    "path",
    {
      d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z",
      key: "fpq118"
    }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);


//# sourceMappingURL=refrigerator.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/regex.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Regex = createLucideIcon("Regex", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    {
      d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z",
      key: "swwfx4"
    }
  ]
]);


//# sourceMappingURL=regex.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/remove-formatting.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RemoveFormatting = createLucideIcon("RemoveFormatting", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);


//# sourceMappingURL=remove-formatting.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/repeat-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Repeat1 = createLucideIcon("Repeat1", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);


//# sourceMappingURL=repeat-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/repeat-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Repeat2 = createLucideIcon("Repeat2", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);


//# sourceMappingURL=repeat-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/repeat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Repeat = createLucideIcon("Repeat", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);


//# sourceMappingURL=repeat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/replace-all.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ReplaceAll = createLucideIcon("ReplaceAll", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  [
    "rect",
    { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }
  ],
  ["path", { d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "1w9p8c" }],
  ["path", { d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "m45eaa" }]
]);


//# sourceMappingURL=replace-all.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/replace.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Replace = createLucideIcon("Replace", [
  ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
  ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
  ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
  ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
  [
    "rect",
    { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" }
  ]
]);


//# sourceMappingURL=replace.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/reply-all.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ReplyAll = createLucideIcon("ReplyAll", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);


//# sourceMappingURL=reply-all.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/reply.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Reply = createLucideIcon("Reply", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);


//# sourceMappingURL=reply.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rewind.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rewind = createLucideIcon("Rewind", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);


//# sourceMappingURL=rewind.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rocket.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rocket = createLucideIcon("Rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);


//# sourceMappingURL=rocket.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rocking-chair.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RockingChair = createLucideIcon("RockingChair", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);


//# sourceMappingURL=rocking-chair.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/roller-coaster.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RollerCoaster = createLucideIcon("RollerCoaster", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  [
    "path",
    {
      d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65",
      key: "1930oh"
    }
  ]
]);


//# sourceMappingURL=roller-coaster.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rotate-3d.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rotate3d = createLucideIcon("Rotate3d", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);


//# sourceMappingURL=rotate-3d.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rotate-ccw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RotateCcw = createLucideIcon("RotateCcw", [
  [
    "path",
    { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }
  ],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);


//# sourceMappingURL=rotate-ccw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rotate-cw.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RotateCw = createLucideIcon("RotateCw", [
  [
    "path",
    { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }
  ],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);


//# sourceMappingURL=rotate-cw.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/router.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Router = createLucideIcon("Router", [
  [
    "rect",
    { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }
  ],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rows.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rows = createLucideIcon("Rows", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }]
]);


//# sourceMappingURL=rows.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/rss.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Rss = createLucideIcon("Rss", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);


//# sourceMappingURL=rss.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ruler.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ruler = createLucideIcon("Ruler", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);


//# sourceMappingURL=ruler.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/russian-ruble.js
/**
 * lucide-react v0.284.0 - ISC
 */



const RussianRuble = createLucideIcon("RussianRuble", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);


//# sourceMappingURL=russian-ruble.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sailboat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sailboat = createLucideIcon("Sailboat", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);


//# sourceMappingURL=sailboat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/salad.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Salad = createLucideIcon("Salad", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  [
    "path",
    { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }
  ]
]);


//# sourceMappingURL=salad.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sandwich.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sandwich = createLucideIcon("Sandwich", [
  ["path", { d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3", key: "34v9d7" }],
  [
    "path",
    {
      d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83",
      key: "1k5vfb"
    }
  ],
  ["path", { d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z", key: "1oe7l6" }],
  [
    "path",
    { d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z", key: "1ts2ri" }
  ]
]);


//# sourceMappingURL=sandwich.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/satellite-dish.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SatelliteDish = createLucideIcon("SatelliteDish", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);


//# sourceMappingURL=satellite-dish.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/satellite.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Satellite = createLucideIcon("Satellite", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);


//# sourceMappingURL=satellite.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/save-all.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SaveAll = createLucideIcon("SaveAll", [
  [
    "path",
    {
      d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z",
      key: "1unput"
    }
  ],
  ["path", { d: "M10 2v4h6", key: "1p5sg6" }],
  ["path", { d: "M18 18v-7h-8v7", key: "1oniuk" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }]
]);


//# sourceMappingURL=save-all.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/save.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Save = createLucideIcon("Save", [
  [
    "path",
    {
      d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z",
      key: "1owoqh"
    }
  ],
  ["polyline", { points: "17 21 17 13 7 13 7 21", key: "1md35c" }],
  ["polyline", { points: "7 3 7 8 15 8", key: "8nz8an" }]
]);


//# sourceMappingURL=save.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scale-3d.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scale3d = createLucideIcon("Scale3d", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M5 7v12h12", key: "vtaa4r" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }]
]);


//# sourceMappingURL=scale-3d.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scale.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scale = createLucideIcon("Scale", [
  [
    "path",
    { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }
  ],
  [
    "path",
    { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);


//# sourceMappingURL=scale.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scaling.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scaling = createLucideIcon("Scaling", [
  ["path", { d: "M21 3 9 15", key: "15kdhq" }],
  ["path", { d: "M12 3H3v18h18v-9", key: "8suug0" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }]
]);


//# sourceMappingURL=scaling.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-barcode.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanBarcode = createLucideIcon("ScanBarcode", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);


//# sourceMappingURL=scan-barcode.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-eye.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanEye = createLucideIcon("ScanEye", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["path", { d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5", key: "nhuolu" }]
]);


//# sourceMappingURL=scan-eye.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-face.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanFace = createLucideIcon("ScanFace", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);


//# sourceMappingURL=scan-face.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-line.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanLine = createLucideIcon("ScanLine", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);


//# sourceMappingURL=scan-line.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanSearch = createLucideIcon("ScanSearch", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);


//# sourceMappingURL=scan-search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan-text.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScanText = createLucideIcon("ScanText", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);


//# sourceMappingURL=scan-text.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scan.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scan = createLucideIcon("Scan", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);


//# sourceMappingURL=scan.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scatter-chart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScatterChart = createLucideIcon("ScatterChart", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", key: "1x97lo" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", key: "56iowl" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", key: "m9xkw9" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", key: "14ln9z" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", key: "14qxqt" }],
  ["path", { d: "M3 3v18h18", key: "1s2lah" }]
]);


//# sourceMappingURL=scatter-chart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/school-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const School2 = createLucideIcon("School2", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  [
    "path",
    {
      d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z",
      key: "8z0lq4"
    }
  ],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "jfgdp0" }]
]);


//# sourceMappingURL=school-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/school.js
/**
 * lucide-react v0.284.0 - ISC
 */



const School = createLucideIcon("School", [
  ["path", { d: "m4 6 8-4 8 4", key: "1q0ilc" }],
  [
    "path",
    { d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2", key: "1vwozw" }
  ],
  ["path", { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4", key: "cpkuc4" }],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);


//# sourceMappingURL=school.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scissors-line-dashed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScissorsLineDashed = createLucideIcon("ScissorsLineDashed", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);


//# sourceMappingURL=scissors-line-dashed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scissors-square-dashed-bottom.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScissorsSquareDashedBottom = createLucideIcon(
  "ScissorsSquareDashedBottom",
  [
    [
      "path",
      {
        d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2",
        key: "1vzg26"
      }
    ],
    ["path", { d: "M10 22H8", key: "euku7a" }],
    ["path", { d: "M16 22h-2", key: "18d249" }],
    ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
    ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
    ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
    ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
    ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
  ]
);


//# sourceMappingURL=scissors-square-dashed-bottom.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scissors-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScissorsSquare = createLucideIcon("ScissorsSquare", [
  [
    "rect",
    { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }
  ],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);


//# sourceMappingURL=scissors-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scissors.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scissors = createLucideIcon("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);


//# sourceMappingURL=scissors.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/screen-share-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScreenShareOff = createLucideIcon("ScreenShareOff", [
  [
    "path",
    {
      d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3",
      key: "i8wdob"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);


//# sourceMappingURL=screen-share-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/screen-share.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScreenShare = createLucideIcon("ScreenShare", [
  [
    "path",
    {
      d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3",
      key: "i8wdob"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);


//# sourceMappingURL=screen-share.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scroll-text.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ScrollText = createLucideIcon("ScrollText", [
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4",
      key: "13a6an"
    }
  ],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M15 12h-5", key: "r7krc0" }]
]);


//# sourceMappingURL=scroll-text.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/scroll.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Scroll = createLucideIcon("Scroll", [
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4",
      key: "13a6an"
    }
  ],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }]
]);


//# sourceMappingURL=scroll.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/search-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SearchCheck = createLucideIcon("SearchCheck", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/search-code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SearchCode = createLucideIcon("SearchCode", [
  ["path", { d: "m9 9-2 2 2 2", key: "17gsfh" }],
  ["path", { d: "m13 13 2-2-2-2", key: "186z8k" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search-code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/search-slash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SearchSlash = createLucideIcon("SearchSlash", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search-slash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/search-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SearchX = createLucideIcon("SearchX", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/search.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Search = createLucideIcon("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/send-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SendHorizontal = createLucideIcon("SendHorizontal", [
  ["path", { d: "m3 3 3 9-3 9 19-9Z", key: "1aobqy" }],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);


//# sourceMappingURL=send-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/send-to-back.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SendToBack = createLucideIcon("SendToBack", [
  [
    "rect",
    { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }
  ],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);


//# sourceMappingURL=send-to-back.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/send.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Send = createLucideIcon("Send", [
  ["path", { d: "m22 2-7 20-4-9-9-4Z", key: "1q3vgg" }],
  ["path", { d: "M22 2 11 13", key: "nzbqef" }]
]);


//# sourceMappingURL=send.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/separator-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SeparatorHorizontal = createLucideIcon("SeparatorHorizontal", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);


//# sourceMappingURL=separator-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/separator-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SeparatorVertical = createLucideIcon("SeparatorVertical", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);


//# sourceMappingURL=separator-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/server-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ServerCog = createLucideIcon("ServerCog", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);


//# sourceMappingURL=server-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/server-crash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ServerCrash = createLucideIcon("ServerCrash", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);


//# sourceMappingURL=server-crash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/server-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ServerOff = createLucideIcon("ServerOff", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  [
    "path",
    { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }
  ],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  [
    "path",
    {
      d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z",
      key: "161ggg"
    }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);


//# sourceMappingURL=server-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/server.js
/**
 * lucide-react v0.284.0 - ISC
 */



const server_Server = createLucideIcon("Server", [
  [
    "rect",
    {
      width: "20",
      height: "8",
      x: "2",
      y: "2",
      rx: "2",
      ry: "2",
      key: "ngkwjq"
    }
  ],
  [
    "rect",
    {
      width: "20",
      height: "8",
      x: "2",
      y: "14",
      rx: "2",
      ry: "2",
      key: "iecqi9"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);


//# sourceMappingURL=server.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/settings-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Settings2 = createLucideIcon("Settings2", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);


//# sourceMappingURL=settings-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/settings.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Settings = createLucideIcon("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);


//# sourceMappingURL=settings.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shapes.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shapes = createLucideIcon("Shapes", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  [
    "rect",
    { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }
  ],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);


//# sourceMappingURL=shapes.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/share-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Share2 = createLucideIcon("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  [
    "line",
    { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }
  ],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);


//# sourceMappingURL=share-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/share.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Share = createLucideIcon("Share", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);


//# sourceMappingURL=share.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sheet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sheet = createLucideIcon("Sheet", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);


//# sourceMappingURL=sheet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shell.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shell = createLucideIcon("Shell", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);


//# sourceMappingURL=shell.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-alert.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldAlert = createLucideIcon("ShieldAlert", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);


//# sourceMappingURL=shield-alert.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-ban.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldBan = createLucideIcon("ShieldBan", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "m4 5 14 12", key: "1ta6nf" }]
]);


//# sourceMappingURL=shield-ban.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldCheck = createLucideIcon("ShieldCheck", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);


//# sourceMappingURL=shield-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-ellipsis.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldEllipsis = createLucideIcon("ShieldEllipsis", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
]);


//# sourceMappingURL=shield-ellipsis.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-half.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldHalf = createLucideIcon("ShieldHalf", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);


//# sourceMappingURL=shield-half.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldMinus = createLucideIcon("ShieldMinus", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);


//# sourceMappingURL=shield-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldOff = createLucideIcon("ShieldOff", [
  ["path", { d: "M19.7 14a6.9 6.9 0 0 0 .3-2V5l-8-3-3.2 1.2", key: "342pvf" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M4.7 4.7 4 5v7c0 6 8 10 8 10a20.3 20.3 0 0 0 5.62-4.38",
      key: "p0ycf4"
    }
  ]
]);


//# sourceMappingURL=shield-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldPlus = createLucideIcon("ShieldPlus", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M12 15V7", key: "1ycneb" }]
]);


//# sourceMappingURL=shield-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-question.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldQuestion = createLucideIcon("ShieldQuestion", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);


//# sourceMappingURL=shield-question.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShieldX = createLucideIcon("ShieldX", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }],
  ["path", { d: "m14.5 9-5 5", key: "1m49dw" }],
  ["path", { d: "m9.5 9 5 5", key: "wyx7zg" }]
]);


//# sourceMappingURL=shield-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shield.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shield = createLucideIcon("Shield", [
  ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10", key: "1irkt0" }]
]);


//# sourceMappingURL=shield.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ship-wheel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShipWheel = createLucideIcon("ShipWheel", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);


//# sourceMappingURL=ship-wheel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ship.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ship = createLucideIcon("Ship", [
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "iegodh"
    }
  ],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76",
      key: "fp8vka"
    }
  ],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }]
]);


//# sourceMappingURL=ship.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shirt.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shirt = createLucideIcon("Shirt", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);


//# sourceMappingURL=shirt.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shopping-bag.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShoppingBag = createLucideIcon("ShoppingBag", [
  [
    "path",
    { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }
  ],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);


//# sourceMappingURL=shopping-bag.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shopping-basket.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShoppingBasket = createLucideIcon("ShoppingBasket", [
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  [
    "path",
    {
      d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4",
      key: "1x2lvw"
    }
  ],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }]
]);


//# sourceMappingURL=shopping-basket.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shopping-cart.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShoppingCart = createLucideIcon("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);


//# sourceMappingURL=shopping-cart.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shovel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shovel = createLucideIcon("Shovel", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    {
      d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2",
      key: "1q8uv5"
    }
  ]
]);


//# sourceMappingURL=shovel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shower-head.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ShowerHead = createLucideIcon("ShowerHead", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);


//# sourceMappingURL=shower-head.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shrink.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shrink = createLucideIcon("Shrink", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);


//# sourceMappingURL=shrink.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shrub.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shrub = createLucideIcon("Shrub", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  [
    "path",
    {
      d: "M17 8v.8A6 6 0 0 1 13.8 20v0H10v0A6.5 6.5 0 0 1 7 8h0a5 5 0 0 1 10 0Z",
      key: "12jcau"
    }
  ],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);


//# sourceMappingURL=shrub.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/shuffle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Shuffle = createLucideIcon("Shuffle", [
  [
    "path",
    {
      d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22",
      key: "1wmou1"
    }
  ],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2", key: "10bdb2" }],
  ["path", { d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8", key: "vgxac0" }],
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }]
]);


//# sourceMappingURL=shuffle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sigma-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SigmaSquare = createLucideIcon("SigmaSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);


//# sourceMappingURL=sigma-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sigma.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sigma = createLucideIcon("Sigma", [
  ["path", { d: "M18 7V4H6l6 8-6 8h12v-3", key: "zis8ev" }]
]);


//# sourceMappingURL=sigma.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/signal-high.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SignalHigh = createLucideIcon("SignalHigh", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);


//# sourceMappingURL=signal-high.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/signal-low.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SignalLow = createLucideIcon("SignalLow", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);


//# sourceMappingURL=signal-low.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/signal-medium.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SignalMedium = createLucideIcon("SignalMedium", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);


//# sourceMappingURL=signal-medium.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/signal-zero.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SignalZero = createLucideIcon("SignalZero", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }]
]);


//# sourceMappingURL=signal-zero.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/signal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Signal = createLucideIcon("Signal", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);


//# sourceMappingURL=signal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/siren.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Siren = createLucideIcon("Siren", [
  ["path", { d: "M7 12a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v6H7v-6Z", key: "rmc51c" }],
  [
    "path",
    { d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2H5v-2Z", key: "yyvmjy" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);


//# sourceMappingURL=siren.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/skip-back.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SkipBack = createLucideIcon("SkipBack", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);


//# sourceMappingURL=skip-back.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/skip-forward.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SkipForward = createLucideIcon("SkipForward", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);


//# sourceMappingURL=skip-forward.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/skull.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Skull = createLucideIcon("Skull", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["path", { d: "M8 20v2h8v-2", key: "ded4og" }],
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20",
      key: "xq9p5u"
    }
  ]
]);


//# sourceMappingURL=skull.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/slack.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Slack = createLucideIcon("Slack", [
  [
    "rect",
    { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }
  ],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  [
    "rect",
    { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }
  ],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  [
    "rect",
    { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }
  ],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  [
    "rect",
    { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }
  ],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);


//# sourceMappingURL=slack.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/slash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Slash = createLucideIcon("Slash", [
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);


//# sourceMappingURL=slash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/slice.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Slice = createLucideIcon("Slice", [
  ["path", { d: "m8 14-6 6h9v-3", key: "zo3j9a" }],
  [
    "path",
    {
      d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z",
      key: "1dzx0j"
    }
  ]
]);


//# sourceMappingURL=slice.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sliders-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SlidersHorizontal = createLucideIcon("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);


//# sourceMappingURL=sliders-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sliders.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sliders = createLucideIcon("Sliders", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);


//# sourceMappingURL=sliders.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/smartphone-charging.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SmartphoneCharging = createLucideIcon("SmartphoneCharging", [
  [
    "rect",
    {
      width: "14",
      height: "20",
      x: "5",
      y: "2",
      rx: "2",
      ry: "2",
      key: "1yt0o3"
    }
  ],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);


//# sourceMappingURL=smartphone-charging.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/smartphone-nfc.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SmartphoneNfc = createLucideIcon("SmartphoneNfc", [
  [
    "rect",
    { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }
  ],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);


//# sourceMappingURL=smartphone-nfc.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/smartphone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Smartphone = createLucideIcon("Smartphone", [
  [
    "rect",
    {
      width: "14",
      height: "20",
      x: "5",
      y: "2",
      rx: "2",
      ry: "2",
      key: "1yt0o3"
    }
  ],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);


//# sourceMappingURL=smartphone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/smile-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SmilePlus = createLucideIcon("SmilePlus", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);


//# sourceMappingURL=smile-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/smile.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Smile = createLucideIcon("Smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);


//# sourceMappingURL=smile.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/snail.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Snail = createLucideIcon("Snail", [
  [
    "path",
    { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }
  ],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);


//# sourceMappingURL=snail.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/snowflake.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Snowflake = createLucideIcon("Snowflake", [
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
  ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
  ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
  ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }]
]);


//# sourceMappingURL=snowflake.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sofa.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sofa = createLucideIcon("Sofa", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z",
      key: "u5qfb7"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);


//# sourceMappingURL=sofa.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/soup.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Soup = createLucideIcon("Soup", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    {
      d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
      key: "97tijn"
    }
  ]
]);


//# sourceMappingURL=soup.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/space.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Space = createLucideIcon("Space", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);


//# sourceMappingURL=space.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/spade.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Spade = createLucideIcon("Spade", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);


//# sourceMappingURL=spade.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sparkle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sparkle = createLucideIcon("Sparkle", [
  [
    "path",
    {
      d: "m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z",
      key: "nraa5p"
    }
  ]
]);


//# sourceMappingURL=sparkle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sparkles.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sparkles = createLucideIcon("Sparkles", [
  [
    "path",
    {
      d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z",
      key: "17u4zn"
    }
  ],
  ["path", { d: "M5 3v4", key: "bklmnn" }],
  ["path", { d: "M19 17v4", key: "iiml17" }],
  ["path", { d: "M3 5h4", key: "nem4j1" }],
  ["path", { d: "M17 19h4", key: "lbex7p" }]
]);


//# sourceMappingURL=sparkles.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/speaker.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Speaker = createLucideIcon("Speaker", [
  [
    "rect",
    {
      width: "16",
      height: "20",
      x: "4",
      y: "2",
      rx: "2",
      ry: "2",
      key: "76otgf"
    }
  ],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["line", { x1: "12", x2: "12.01", y1: "6", y2: "6", key: "16cbga" }]
]);


//# sourceMappingURL=speaker.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/speech.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Speech = createLucideIcon("Speech", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);


//# sourceMappingURL=speech.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/spell-check-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SpellCheck2 = createLucideIcon("SpellCheck2", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);


//# sourceMappingURL=spell-check-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/spell-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SpellCheck = createLucideIcon("SpellCheck", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);


//# sourceMappingURL=spell-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/spline.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Spline = createLucideIcon("Spline", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);


//# sourceMappingURL=spline.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/split-square-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SplitSquareHorizontal = createLucideIcon("SplitSquareHorizontal", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);


//# sourceMappingURL=split-square-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/split-square-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SplitSquareVertical = createLucideIcon("SplitSquareVertical", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);


//# sourceMappingURL=split-square-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/split.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Split = createLucideIcon("Split", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);


//# sourceMappingURL=split.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/spray-can.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SprayCan = createLucideIcon("SprayCan", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  [
    "path",
    { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }
  ],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);


//# sourceMappingURL=spray-can.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sprout.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sprout = createLucideIcon("Sprout", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);


//# sourceMappingURL=sprout.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-asterisk.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareAsterisk = createLucideIcon("SquareAsterisk", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);


//# sourceMappingURL=square-asterisk.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareCode = createLucideIcon("SquareCode", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
  ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }]
]);


//# sourceMappingURL=square-code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-dashed-bottom-code.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareDashedBottomCode = createLucideIcon("SquareDashedBottomCode", [
  ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
  ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }],
  [
    "path",
    {
      d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      key: "as5y1o"
    }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);


//# sourceMappingURL=square-dashed-bottom-code.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-dashed-bottom.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareDashedBottom = createLucideIcon("SquareDashedBottom", [
  [
    "path",
    {
      d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
      key: "as5y1o"
    }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);


//# sourceMappingURL=square-dashed-bottom.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareDot = createLucideIcon("SquareDot", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);


//# sourceMappingURL=square-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-equal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareEqual = createLucideIcon("SquareEqual", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);


//# sourceMappingURL=square-equal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-slash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareSlash = createLucideIcon("SquareSlash", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);


//# sourceMappingURL=square-slash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square-stack.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SquareStack = createLucideIcon("SquareStack", [
  [
    "path",
    {
      d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2",
      key: "4i38lg"
    }
  ],
  [
    "path",
    {
      d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2",
      key: "mlte4a"
    }
  ],
  [
    "rect",
    { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }
  ]
]);


//# sourceMappingURL=square-stack.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Square = createLucideIcon("Square", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ]
]);


//# sourceMappingURL=square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/squirrel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Squirrel = createLucideIcon("Squirrel", [
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ],
  [
    "path",
    {
      d: "M16 20c0-1.7 1.3-3 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4",
      key: "19wibc"
    }
  ],
  ["path", { d: "M15.2 22a3 3 0 0 0-2.2-5", key: "13bpac" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }]
]);


//# sourceMappingURL=squirrel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/stamp.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Stamp = createLucideIcon("Stamp", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    {
      d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13",
      key: "cnxgux"
    }
  ]
]);


//# sourceMappingURL=stamp.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/star-half.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StarHalf = createLucideIcon("StarHalf", [
  ["path", { d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2", key: "nare05" }]
]);


//# sourceMappingURL=star-half.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/star-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StarOff = createLucideIcon("StarOff", [
  [
    "path",
    {
      d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43",
      key: "16m0ql"
    }
  ],
  [
    "path",
    { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=star-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/star.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Star = createLucideIcon("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);


//# sourceMappingURL=star.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/step-back.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StepBack = createLucideIcon("StepBack", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);


//# sourceMappingURL=step-back.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/step-forward.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StepForward = createLucideIcon("StepForward", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);


//# sourceMappingURL=step-forward.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/stethoscope.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Stethoscope = createLucideIcon("Stethoscope", [
  [
    "path",
    {
      d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3",
      key: "1jd90r"
    }
  ],
  ["path", { d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4", key: "126ukv" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);


//# sourceMappingURL=stethoscope.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sticker.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sticker = createLucideIcon("Sticker", [
  [
    "path",
    {
      d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z",
      key: "1wis1t"
    }
  ],
  ["path", { d: "M15 3v6h6", key: "edgan2" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }],
  ["path", { d: "M8 13h0", key: "jdup5h" }],
  ["path", { d: "M16 13h0", key: "l4i2ga" }]
]);


//# sourceMappingURL=sticker.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sticky-note.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StickyNote = createLucideIcon("StickyNote", [
  [
    "path",
    {
      d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z",
      key: "1wis1t"
    }
  ],
  ["path", { d: "M15 3v6h6", key: "edgan2" }]
]);


//# sourceMappingURL=sticky-note.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/stop-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StopCircle = createLucideIcon("StopCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", key: "1wrtvo" }]
]);


//# sourceMappingURL=stop-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/store.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Store = createLucideIcon("Store", [
  [
    "path",
    {
      d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7",
      key: "ztvudi"
    }
  ],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7",
      key: "jon5kx"
    }
  ]
]);


//# sourceMappingURL=store.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/stretch-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StretchHorizontal = createLucideIcon("StretchHorizontal", [
  [
    "rect",
    { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }
  ],
  [
    "rect",
    { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }
  ]
]);


//# sourceMappingURL=stretch-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/stretch-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const StretchVertical = createLucideIcon("StretchVertical", [
  [
    "rect",
    { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }
  ],
  [
    "rect",
    { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }
  ]
]);


//# sourceMappingURL=stretch-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/strikethrough.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Strikethrough = createLucideIcon("Strikethrough", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);


//# sourceMappingURL=strikethrough.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/subscript.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Subscript = createLucideIcon("Subscript", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);


//# sourceMappingURL=subscript.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/subtitles.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Subtitles = createLucideIcon("Subtitles", [
  ["path", { d: "M7 13h4", key: "1m1xj0" }],
  ["path", { d: "M15 13h2", key: "vgjay3" }],
  ["path", { d: "M7 9h2", key: "1q072n" }],
  ["path", { d: "M13 9h4", key: "o7fxw0" }],
  [
    "path",
    {
      d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z",
      key: "5somay"
    }
  ]
]);


//# sourceMappingURL=subtitles.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sun-dim.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SunDim = createLucideIcon("SunDim", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);


//# sourceMappingURL=sun-dim.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sun-medium.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SunMedium = createLucideIcon("SunMedium", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);


//# sourceMappingURL=sun-medium.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sun-moon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SunMoon = createLucideIcon("SunMoon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);


//# sourceMappingURL=sun-moon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sun-snow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SunSnow = createLucideIcon("SunSnow", [
  ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M14 21V3", key: "1llu3z" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 4-3 3", key: "15jcng" }],
  ["path", { d: "m14 17 3 3", key: "6tlq38" }],
  ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }]
]);


//# sourceMappingURL=sun-snow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sun.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sun = createLucideIcon("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);


//# sourceMappingURL=sun.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sunrise.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sunrise = createLucideIcon("Sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);


//# sourceMappingURL=sunrise.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sunset.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sunset = createLucideIcon("Sunset", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);


//# sourceMappingURL=sunset.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/superscript.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Superscript = createLucideIcon("Superscript", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);


//# sourceMappingURL=superscript.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/swiss-franc.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SwissFranc = createLucideIcon("SwissFranc", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);


//# sourceMappingURL=swiss-franc.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/switch-camera.js
/**
 * lucide-react v0.284.0 - ISC
 */



const SwitchCamera = createLucideIcon("SwitchCamera", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);


//# sourceMappingURL=switch-camera.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/sword.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Sword = createLucideIcon("Sword", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);


//# sourceMappingURL=sword.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/swords.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Swords = createLucideIcon("Swords", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);


//# sourceMappingURL=swords.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/syringe.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Syringe = createLucideIcon("Syringe", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  [
    "path",
    {
      d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5",
      key: "1exhtz"
    }
  ],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);


//# sourceMappingURL=syringe.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/table-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Table2 = createLucideIcon("Table2", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);


//# sourceMappingURL=table-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/table-properties.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TableProperties = createLucideIcon("TableProperties", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);


//# sourceMappingURL=table-properties.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/table.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Table = createLucideIcon("Table", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);


//# sourceMappingURL=table.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tablet-smartphone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TabletSmartphone = createLucideIcon("TabletSmartphone", [
  [
    "rect",
    { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }
  ],
  [
    "path",
    {
      d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4",
      key: "1j4zmg"
    }
  ],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);


//# sourceMappingURL=tablet-smartphone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tablet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tablet = createLucideIcon("Tablet", [
  [
    "rect",
    {
      width: "16",
      height: "20",
      x: "4",
      y: "2",
      rx: "2",
      ry: "2",
      key: "76otgf"
    }
  ],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);


//# sourceMappingURL=tablet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tablets.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tablets = createLucideIcon("Tablets", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);


//# sourceMappingURL=tablets.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tag.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tag = createLucideIcon("Tag", [
  [
    "path",
    {
      d: "M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z",
      key: "14b2ls"
    }
  ],
  ["path", { d: "M7 7h.01", key: "7u93v4" }]
]);


//# sourceMappingURL=tag.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tags.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tags = createLucideIcon("Tags", [
  [
    "path",
    {
      d: "M9 5H2v7l6.29 6.29c.94.94 2.48.94 3.42 0l3.58-3.58c.94-.94.94-2.48 0-3.42L9 5Z",
      key: "gt587u"
    }
  ],
  ["path", { d: "M6 9.01V9", key: "1flxpt" }],
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }]
]);


//# sourceMappingURL=tags.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tally-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tally1 = createLucideIcon("Tally1", [
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);


//# sourceMappingURL=tally-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tally-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tally2 = createLucideIcon("Tally2", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);


//# sourceMappingURL=tally-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tally-3.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tally3 = createLucideIcon("Tally3", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);


//# sourceMappingURL=tally-3.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tally-4.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tally4 = createLucideIcon("Tally4", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);


//# sourceMappingURL=tally-4.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tally-5.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tally5 = createLucideIcon("Tally5", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);


//# sourceMappingURL=tally-5.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tangent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tangent = createLucideIcon("Tangent", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);


//# sourceMappingURL=tangent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/target.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Target = createLucideIcon("Target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);


//# sourceMappingURL=target.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tent-tree.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TentTree = createLucideIcon("TentTree", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);


//# sourceMappingURL=tent-tree.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tent.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tent = createLucideIcon("Tent", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);


//# sourceMappingURL=tent.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/terminal-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TerminalSquare = createLucideIcon("TerminalSquare", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ]
]);


//# sourceMappingURL=terminal-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/terminal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Terminal = createLucideIcon("Terminal", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);


//# sourceMappingURL=terminal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/test-tube-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TestTube2 = createLucideIcon("TestTube2", [
  [
    "path",
    {
      d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3",
      key: "dg8b2p"
    }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);


//# sourceMappingURL=test-tube-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/test-tube.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TestTube = createLucideIcon("TestTube", [
  [
    "path",
    {
      d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2",
      key: "187lwq"
    }
  ],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);


//# sourceMappingURL=test-tube.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/test-tubes.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TestTubes = createLucideIcon("TestTubes", [
  [
    "path",
    {
      d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2",
      key: "12z67u"
    }
  ],
  [
    "path",
    {
      d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2",
      key: "1q2nfy"
    }
  ],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);


//# sourceMappingURL=test-tubes.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/text-cursor-input.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TextCursorInput = createLucideIcon("TextCursorInput", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);


//# sourceMappingURL=text-cursor-input.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/text-cursor.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TextCursor = createLucideIcon("TextCursor", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);


//# sourceMappingURL=text-cursor.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/text-quote.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TextQuote = createLucideIcon("TextQuote", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);


//# sourceMappingURL=text-quote.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/text-select.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TextSelect = createLucideIcon("TextSelect", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);


//# sourceMappingURL=text-select.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/text.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Text = createLucideIcon("Text", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);


//# sourceMappingURL=text.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/theater.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Theater = createLucideIcon("Theater", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);


//# sourceMappingURL=theater.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/thermometer-snowflake.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ThermometerSnowflake = createLucideIcon("ThermometerSnowflake", [
  ["path", { d: "M2 12h10", key: "19562f" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
  ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
  ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }]
]);


//# sourceMappingURL=thermometer-snowflake.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/thermometer-sun.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ThermometerSun = createLucideIcon("ThermometerSun", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);


//# sourceMappingURL=thermometer-sun.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/thermometer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Thermometer = createLucideIcon("Thermometer", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);


//# sourceMappingURL=thermometer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/thumbs-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ThumbsDown = createLucideIcon("ThumbsDown", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z",
      key: "s6e0r"
    }
  ]
]);


//# sourceMappingURL=thumbs-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/thumbs-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ThumbsUp = createLucideIcon("ThumbsUp", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z",
      key: "y3tblf"
    }
  ]
]);


//# sourceMappingURL=thumbs-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ticket.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ticket = createLucideIcon("Ticket", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);


//# sourceMappingURL=ticket.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/timer-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TimerOff = createLucideIcon("TimerOff", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);


//# sourceMappingURL=timer-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/timer-reset.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TimerReset = createLucideIcon("TimerReset", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);


//# sourceMappingURL=timer-reset.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/timer.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Timer = createLucideIcon("Timer", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);


//# sourceMappingURL=timer.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/toggle-left.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ToggleLeft = createLucideIcon("ToggleLeft", [
  [
    "rect",
    {
      width: "20",
      height: "12",
      x: "2",
      y: "6",
      rx: "6",
      ry: "6",
      key: "f2vt7d"
    }
  ],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);


//# sourceMappingURL=toggle-left.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/toggle-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ToggleRight = createLucideIcon("ToggleRight", [
  [
    "rect",
    {
      width: "20",
      height: "12",
      x: "2",
      y: "6",
      rx: "6",
      ry: "6",
      key: "f2vt7d"
    }
  ],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);


//# sourceMappingURL=toggle-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tornado.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tornado = createLucideIcon("Tornado", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);


//# sourceMappingURL=tornado.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/torus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Torus = createLucideIcon("Torus", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);


//# sourceMappingURL=torus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/touchpad-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TouchpadOff = createLucideIcon("TouchpadOff", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);


//# sourceMappingURL=touchpad-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/touchpad.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Touchpad = createLucideIcon("Touchpad", [
  [
    "rect",
    { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);


//# sourceMappingURL=touchpad.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tower-control.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TowerControl = createLucideIcon("TowerControl", [
  [
    "path",
    {
      d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z",
      key: "1pledb"
    }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);


//# sourceMappingURL=tower-control.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/toy-brick.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ToyBrick = createLucideIcon("ToyBrick", [
  [
    "rect",
    { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }
  ],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);


//# sourceMappingURL=toy-brick.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tractor.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tractor = createLucideIcon("Tractor", [
  ["path", { d: "M3 4h9l1 7", key: "1ftpo8" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M8 10V4", key: "1y5f7n" }],
  ["path", { d: "M18 5c-.6 0-1 .4-1 1v5.6", key: "10zbvr" }],
  ["path", { d: "m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1", key: "2w242w" }],
  ["circle", { cx: "7", cy: "15", r: ".5", key: "fbsjqy" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }]
]);


//# sourceMappingURL=tractor.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/traffic-cone.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrafficCone = createLucideIcon("TrafficCone", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  [
    "path",
    { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }
  ],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);


//# sourceMappingURL=traffic-cone.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/train-front-tunnel.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrainFrontTunnel = createLucideIcon("TrainFrontTunnel", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  [
    "path",
    {
      d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z",
      key: "hckbmu"
    }
  ],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);


//# sourceMappingURL=train-front-tunnel.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/train-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrainFront = createLucideIcon("TrainFront", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  [
    "path",
    {
      d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z",
      key: "1p0hjs"
    }
  ],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);


//# sourceMappingURL=train-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/train-track.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrainTrack = createLucideIcon("TrainTrack", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);


//# sourceMappingURL=train-track.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tram-front.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TramFront = createLucideIcon("TramFront", [
  [
    "rect",
    { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }
  ],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h0", key: "q9eq1f" }],
  ["path", { d: "M16 15h0", key: "pzrbjg" }]
]);


//# sourceMappingURL=tram-front.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trash-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Trash2 = createLucideIcon("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);


//# sourceMappingURL=trash-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trash.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Trash = createLucideIcon("Trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);


//# sourceMappingURL=trash.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tree-deciduous.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TreeDeciduous = createLucideIcon("TreeDeciduous", [
  [
    "path",
    {
      d: "M8 19h8a4 4 0 0 0 3.8-2.8 4 4 0 0 0-1.6-4.5c1-1.1 1-2.7.4-4-.7-1.2-2.2-2-3.6-1.7a3 3 0 0 0-3-3 3 3 0 0 0-3 3c-1.4-.2-2.9.5-3.6 1.7-.7 1.3-.5 2.9.4 4a4 4 0 0 0-1.6 4.5A4 4 0 0 0 8 19Z",
      key: "12ivfl"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);


//# sourceMappingURL=tree-deciduous.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tree-pine.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TreePine = createLucideIcon("TreePine", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);


//# sourceMappingURL=tree-pine.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trees.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Trees = createLucideIcon("Trees", [
  [
    "path",
    {
      d: "M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
      key: "yh07w9"
    }
  ],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);


//# sourceMappingURL=trees.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trello.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Trello = createLucideIcon("Trello", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);


//# sourceMappingURL=trello.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trending-down.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrendingDown = createLucideIcon("TrendingDown", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);


//# sourceMappingURL=trending-down.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trending-up.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TrendingUp = createLucideIcon("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);


//# sourceMappingURL=trending-up.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/triangle-right.js
/**
 * lucide-react v0.284.0 - ISC
 */



const TriangleRight = createLucideIcon("TriangleRight", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);


//# sourceMappingURL=triangle-right.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/triangle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Triangle = createLucideIcon("Triangle", [
  [
    "path",
    {
      d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
      key: "14u9p9"
    }
  ]
]);


//# sourceMappingURL=triangle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/trophy.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Trophy = createLucideIcon("Trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  [
    "path",
    {
      d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22",
      key: "1nw9bq"
    }
  ],
  [
    "path",
    {
      d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22",
      key: "1np0yb"
    }
  ],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);


//# sourceMappingURL=trophy.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/truck.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Truck = createLucideIcon("Truck", [
  [
    "path",
    {
      d: "M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11",
      key: "hs4xqm"
    }
  ],
  ["path", { d: "M14 9h4l4 4v4c0 .6-.4 1-1 1h-2", key: "11fp61" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }]
]);


//# sourceMappingURL=truck.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/turtle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Turtle = createLucideIcon("Turtle", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);


//# sourceMappingURL=turtle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tv-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tv2 = createLucideIcon("Tv2", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  [
    "rect",
    { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }
  ]
]);


//# sourceMappingURL=tv-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/tv.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Tv = createLucideIcon("Tv", [
  [
    "rect",
    {
      width: "20",
      height: "15",
      x: "2",
      y: "7",
      rx: "2",
      ry: "2",
      key: "10ag99"
    }
  ],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);


//# sourceMappingURL=tv.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/twitch.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Twitch = createLucideIcon("Twitch", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);


//# sourceMappingURL=twitch.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/twitter.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Twitter = createLucideIcon("Twitter", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);


//# sourceMappingURL=twitter.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/type.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Type = createLucideIcon("Type", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);


//# sourceMappingURL=type.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/umbrella.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Umbrella = createLucideIcon("Umbrella", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);


//# sourceMappingURL=umbrella.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/underline.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Underline = createLucideIcon("Underline", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);


//# sourceMappingURL=underline.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/undo-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Undo2 = createLucideIcon("Undo2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  [
    "path",
    {
      d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11",
      key: "llx8ln"
    }
  ]
]);


//# sourceMappingURL=undo-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/undo-dot.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UndoDot = createLucideIcon("UndoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);


//# sourceMappingURL=undo-dot.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/undo.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Undo = createLucideIcon("Undo", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);


//# sourceMappingURL=undo.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unfold-horizontal.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UnfoldHorizontal = createLucideIcon("UnfoldHorizontal", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);


//# sourceMappingURL=unfold-horizontal.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unfold-vertical.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UnfoldVertical = createLucideIcon("UnfoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);


//# sourceMappingURL=unfold-vertical.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/ungroup.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Ungroup = createLucideIcon("Ungroup", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  [
    "rect",
    { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }
  ]
]);


//# sourceMappingURL=ungroup.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unlink-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Unlink2 = createLucideIcon("Unlink2", [
  [
    "path",
    { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }
  ]
]);


//# sourceMappingURL=unlink-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unlink.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Unlink = createLucideIcon("Unlink", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);


//# sourceMappingURL=unlink.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unlock-keyhole.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UnlockKeyhole = createLucideIcon("UnlockKeyhole", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  [
    "rect",
    { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }
  ],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);


//# sourceMappingURL=unlock-keyhole.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unlock.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Unlock = createLucideIcon("Unlock", [
  [
    "rect",
    {
      width: "18",
      height: "11",
      x: "3",
      y: "11",
      rx: "2",
      ry: "2",
      key: "1w4ew1"
    }
  ],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);


//# sourceMappingURL=unlock.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/unplug.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Unplug = createLucideIcon("Unplug", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    {
      d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
      key: "goz73y"
    }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    {
      d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z",
      key: "1snsnr"
    }
  ]
]);


//# sourceMappingURL=unplug.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/upload-cloud.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UploadCloud = createLucideIcon("UploadCloud", [
  [
    "path",
    {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
      key: "1pljnt"
    }
  ],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }]
]);


//# sourceMappingURL=upload-cloud.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/upload.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Upload = createLucideIcon("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);


//# sourceMappingURL=upload.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/usb.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Usb = createLucideIcon("Usb", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);


//# sourceMappingURL=usb.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const User2 = createLucideIcon("User2", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 1 0-16 0", key: "199sx2" }]
]);


//# sourceMappingURL=user-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-check-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCheck2 = createLucideIcon("UserCheck2", [
  ["path", { d: "M14 19a6 6 0 0 0-12 0", key: "vej9p1" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);


//# sourceMappingURL=user-check-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-check.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCheck = createLucideIcon("UserCheck", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);


//# sourceMappingURL=user-check.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-circle-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCircle2 = createLucideIcon("UserCircle2", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);


//# sourceMappingURL=user-circle-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCircle = createLucideIcon("UserCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  [
    "path",
    { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }
  ]
]);


//# sourceMappingURL=user-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-cog-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCog2 = createLucideIcon("UserCog2", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["path", { d: "M10.5 13.5A6 6 0 0 0 2 19", key: "ih5ja7" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);


//# sourceMappingURL=user-cog-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-cog.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserCog = createLucideIcon("UserCog", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);


//# sourceMappingURL=user-cog.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-minus-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserMinus2 = createLucideIcon("UserMinus2", [
  ["path", { d: "M14 19a6 6 0 0 0-12 0", key: "vej9p1" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);


//# sourceMappingURL=user-minus-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-minus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserMinus = createLucideIcon("UserMinus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);


//# sourceMappingURL=user-minus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-plus-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserPlus2 = createLucideIcon("UserPlus2", [
  ["path", { d: "M14 19a6 6 0 0 0-12 0", key: "vej9p1" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);


//# sourceMappingURL=user-plus-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-plus.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserPlus = createLucideIcon("UserPlus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);


//# sourceMappingURL=user-plus.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-square-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserSquare2 = createLucideIcon("UserSquare2", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ]
]);


//# sourceMappingURL=user-square-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserSquare = createLucideIcon("UserSquare", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);


//# sourceMappingURL=user-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-x-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserX2 = createLucideIcon("UserX2", [
  ["path", { d: "M14 19a6 6 0 0 0-12 0", key: "vej9p1" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);


//# sourceMappingURL=user-x-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UserX = createLucideIcon("UserX", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);


//# sourceMappingURL=user-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/user.js
/**
 * lucide-react v0.284.0 - ISC
 */



const User = createLucideIcon("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);


//# sourceMappingURL=user.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/users-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Users2 = createLucideIcon("Users2", [
  ["path", { d: "M14 19a6 6 0 0 0-12 0", key: "vej9p1" }],
  ["circle", { cx: "8", cy: "9", r: "4", key: "143rtg" }],
  ["path", { d: "M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8", key: "hqbn22" }]
]);


//# sourceMappingURL=users-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/users.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Users = createLucideIcon("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);


//# sourceMappingURL=users.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/utensils-crossed.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UtensilsCrossed = createLucideIcon("UtensilsCrossed", [
  [
    "path",
    {
      d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8",
      key: "n7qcjb"
    }
  ],
  [
    "path",
    {
      d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7",
      key: "d0u48b"
    }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);


//# sourceMappingURL=utensils-crossed.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/utensils.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Utensils = createLucideIcon("Utensils", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  [
    "path",
    { d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "1ogz0v" }
  ]
]);


//# sourceMappingURL=utensils.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/utility-pole.js
/**
 * lucide-react v0.284.0 - ISC
 */



const UtilityPole = createLucideIcon("UtilityPole", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);


//# sourceMappingURL=utility-pole.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/variable.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Variable = createLucideIcon("Variable", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);


//# sourceMappingURL=variable.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/vegan.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Vegan = createLucideIcon("Vegan", [
  [
    "path",
    { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }
  ],
  ["path", { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", key: "n7eohy" }],
  ["path", { d: "M17.41 3.6a10 10 0 1 0 3 3", key: "1dion0" }]
]);


//# sourceMappingURL=vegan.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/venetian-mask.js
/**
 * lucide-react v0.284.0 - ISC
 */



const VenetianMask = createLucideIcon("VenetianMask", [
  [
    "path",
    {
      d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z",
      key: "1g6z3j"
    }
  ],
  ["path", { d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z", key: "c2lwnf" }],
  ["path", { d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z", key: "njd9zo" }]
]);


//# sourceMappingURL=venetian-mask.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/vibrate-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const VibrateOff = createLucideIcon("VibrateOff", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=vibrate-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/vibrate.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Vibrate = createLucideIcon("Vibrate", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  [
    "rect",
    { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }
  ]
]);


//# sourceMappingURL=vibrate.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/video-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const VideoOff = createLucideIcon("VideoOff", [
  ["path", { d: "M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8", key: "ubwiq0" }],
  [
    "path",
    {
      d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2l10 10Z",
      key: "1l10zd"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=video-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/video.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Video = createLucideIcon("Video", [
  ["path", { d: "m22 8-6 4 6 4V8Z", key: "50v9me" }],
  [
    "rect",
    {
      width: "14",
      height: "12",
      x: "2",
      y: "6",
      rx: "2",
      ry: "2",
      key: "1rqjg6"
    }
  ]
]);


//# sourceMappingURL=video.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/videotape.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Videotape = createLucideIcon("Videotape", [
  [
    "rect",
    { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }
  ],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);


//# sourceMappingURL=videotape.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/view.js
/**
 * lucide-react v0.284.0 - ISC
 */



const View = createLucideIcon("View", [
  [
    "path",
    {
      d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z",
      key: "vptub8"
    }
  ],
  ["path", { d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", key: "10lhjs" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }]
]);


//# sourceMappingURL=view.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/voicemail.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Voicemail = createLucideIcon("Voicemail", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);


//# sourceMappingURL=voicemail.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/volume-1.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Volume1 = createLucideIcon("Volume1", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }]
]);


//# sourceMappingURL=volume-1.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/volume-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Volume2 = createLucideIcon("Volume2", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }],
  ["path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14", key: "1kegas" }]
]);


//# sourceMappingURL=volume-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/volume-x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const VolumeX = createLucideIcon("VolumeX", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);


//# sourceMappingURL=volume-x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/volume.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Volume = createLucideIcon("Volume", [
  ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }]
]);


//# sourceMappingURL=volume.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/vote.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Vote = createLucideIcon("Vote", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);


//# sourceMappingURL=vote.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wallet-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wallet2 = createLucideIcon("Wallet2", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);


//# sourceMappingURL=wallet-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wallet-cards.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WalletCards = createLucideIcon("WalletCards", [
  [
    "rect",
    { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }
  ],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);


//# sourceMappingURL=wallet-cards.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wallet.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wallet = createLucideIcon("Wallet", [
  ["path", { d: "M21 12V7H5a2 2 0 0 1 0-4h14v4", key: "195gfw" }],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h16v-5", key: "195n9w" }],
  ["path", { d: "M18 12a2 2 0 0 0 0 4h4v-4Z", key: "vllfpd" }]
]);


//# sourceMappingURL=wallet.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wallpaper.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wallpaper = createLucideIcon("Wallpaper", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);


//# sourceMappingURL=wallpaper.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wand-2.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wand2 = createLucideIcon("Wand2", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z",
      key: "1bcowg"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);


//# sourceMappingURL=wand-2.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wand.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wand = createLucideIcon("Wand", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h0", key: "kg5t1u" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);


//# sourceMappingURL=wand.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/warehouse.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Warehouse = createLucideIcon("Warehouse", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);


//# sourceMappingURL=warehouse.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/watch.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Watch = createLucideIcon("Watch", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    {
      d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05",
      key: "18k57s"
    }
  ],
  [
    "path",
    {
      d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05",
      key: "16ny36"
    }
  ]
]);


//# sourceMappingURL=watch.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/waves.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Waves = createLucideIcon("Waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);


//# sourceMappingURL=waves.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/webcam.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Webcam = createLucideIcon("Webcam", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);


//# sourceMappingURL=webcam.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/webhook.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Webhook = createLucideIcon("Webhook", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  [
    "path",
    {
      d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06",
      key: "1go1hn"
    }
  ],
  [
    "path",
    {
      d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8",
      key: "qlwsc0"
    }
  ]
]);


//# sourceMappingURL=webhook.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/weight.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Weight = createLucideIcon("Weight", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);


//# sourceMappingURL=weight.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wheat-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WheatOff = createLucideIcon("WheatOff", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97",
      key: "4wz8re"
    }
  ],
  [
    "path",
    {
      d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62",
      key: "rves66"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=wheat-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wheat.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wheat = createLucideIcon("Wheat", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);


//# sourceMappingURL=wheat.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/whole-word.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WholeWord = createLucideIcon("WholeWord", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);


//# sourceMappingURL=whole-word.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wifi-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WifiOff = createLucideIcon("WifiOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M8.5 16.5a5 5 0 0 1 7 0", key: "sej527" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.17-2.65", key: "11utq1" }],
  ["path", { d: "M10.66 5c4.01-.36 8.14.9 11.34 3.76", key: "hxefdu" }],
  ["path", { d: "M16.85 11.25a10 10 0 0 1 2.22 1.68", key: "q734kn" }],
  ["path", { d: "M5 13a10 10 0 0 1 5.24-2.76", key: "piq4yl" }],
  ["line", { x1: "12", x2: "12.01", y1: "20", y2: "20", key: "of4bc4" }]
]);


//# sourceMappingURL=wifi-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wifi.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wifi = createLucideIcon("Wifi", [
  ["path", { d: "M5 13a10 10 0 0 1 14 0", key: "6v8j51" }],
  ["path", { d: "M8.5 16.5a5 5 0 0 1 7 0", key: "sej527" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["line", { x1: "12", x2: "12.01", y1: "20", y2: "20", key: "of4bc4" }]
]);


//# sourceMappingURL=wifi.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wind.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wind = createLucideIcon("Wind", [
  ["path", { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", key: "1k4u03" }],
  ["path", { d: "M9.6 4.6A2 2 0 1 1 11 8H2", key: "b7d0fd" }],
  ["path", { d: "M12.6 19.4A2 2 0 1 0 14 16H2", key: "1p5cb3" }]
]);


//# sourceMappingURL=wind.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wine-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WineOff = createLucideIcon("WineOff", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=wine-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wine.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wine = createLucideIcon("Wine", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z",
      key: "10ffi3"
    }
  ]
]);


//# sourceMappingURL=wine.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/workflow.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Workflow = createLucideIcon("Workflow", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  [
    "rect",
    { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }
  ]
]);


//# sourceMappingURL=workflow.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wrap-text.js
/**
 * lucide-react v0.284.0 - ISC
 */



const WrapText = createLucideIcon("WrapText", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);


//# sourceMappingURL=wrap-text.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/wrench.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Wrench = createLucideIcon("Wrench", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);


//# sourceMappingURL=wrench.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/x-circle.js
/**
 * lucide-react v0.284.0 - ISC
 */



const XCircle = createLucideIcon("XCircle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);


//# sourceMappingURL=x-circle.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/x-octagon.js
/**
 * lucide-react v0.284.0 - ISC
 */



const XOctagon = createLucideIcon("XOctagon", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);


//# sourceMappingURL=x-octagon.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/x-square.js
/**
 * lucide-react v0.284.0 - ISC
 */



const XSquare = createLucideIcon("XSquare", [
  [
    "rect",
    {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      rx: "2",
      ry: "2",
      key: "1m3agn"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);


//# sourceMappingURL=x-square.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/x.js
/**
 * lucide-react v0.284.0 - ISC
 */



const x_X = createLucideIcon("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);


//# sourceMappingURL=x.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/youtube.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Youtube = createLucideIcon("Youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);


//# sourceMappingURL=youtube.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/zap-off.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ZapOff = createLucideIcon("ZapOff", [
  ["polyline", { points: "12.41 6.75 13 2 10.57 4.92", key: "122m05" }],
  ["polyline", { points: "18.57 12.91 21 10 15.66 10", key: "16r43o" }],
  ["polyline", { points: "8 8 3 14 12 14 11 22 16 16", key: "tmh4bc" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);


//# sourceMappingURL=zap-off.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/zap.js
/**
 * lucide-react v0.284.0 - ISC
 */



const Zap = createLucideIcon("Zap", [
  [
    "polygon",
    { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2", key: "45s27k" }
  ]
]);


//# sourceMappingURL=zap.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/zoom-in.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ZoomIn = createLucideIcon("ZoomIn", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);


//# sourceMappingURL=zoom-in.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/zoom-out.js
/**
 * lucide-react v0.284.0 - ISC
 */



const ZoomOut = createLucideIcon("ZoomOut", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);


//# sourceMappingURL=zoom-out.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/icons/index.js
/**
 * lucide-react v0.284.0 - ISC
 */







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/lucide-react/dist/esm/lucide-react.js
/**
 * lucide-react v0.284.0 - ISC
 */










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//# sourceMappingURL=lucide-react.js.map

;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableIcon.js



const DraggableIcon = ({ item: { props, id }, ...rest }) => {
    const Icon = props?.icon?.name
        ? lucide_react_namespaceObject[props.icon.name]
        : HelpCircle;
    return ((0,jsx_runtime.jsx)(Icon, { "editor-icon": "true", "editor-key": id, "editor-type": "Icon", ...props, className: classNames(props?.className, "min-h-3 min-w-3"), icon: null, ...rest }));
};
/* harmony default export */ var draggableComponents_DraggableIcon = (DraggableIcon);
//# sourceMappingURL=DraggableIcon.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableComponents/DraggableNavbarVertical.js








const DraggableNavbarVertical = ({ item: { props, id }, ...rest }) => {
    const { menus, pages, activePage } = useSite();
    const { mode } = useEditor();
    const menu = menus?.find((m) => m.id === props?.["menu"]?.selected);
    const navbarItems = menu
        ? helpers_navbarItemsRender(JSON.parse(menu?.items), pages)
        : null;
    const fallbackItems = [
        {
            href: "#",
            name: mode === "production" ? "Home" : "Geen menu items gevonden",
            id: 1,
            type: NavbarItemType.Link,
        },
    ];
    const navbarItemsRendered = navbarItems || fallbackItems;
    return ((0,jsx_runtime.jsx)("div", { className: props?.className || "flex flex-1 flex-col", "editor-key": id, "editor-options": JSON.stringify([
            {
                type: "menu",
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst kleur",
                },
            },
            {
                type: SideEditOptions.BackgroundColor,
                config: {
                    key: "bg-active-item",
                    valueKey: "backgroundColor",
                    defaultValue: "bg-site-400",
                    label: "Kleur active item",
                },
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-active-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst active item kleur",
                },
            },
        ]), "editor-text-color": props?.["text-color"] || "text-black", "editor-bg-active-item": props?.["bg-active-item"] || "bg-site-500", "editor-text-active-color": props?.["text-active-color"] || "text-white", "editor-menu-selected": props?.["menu"]?.selected || null, children: (0,jsx_runtime.jsx)("ul", { role: "list", className: "-mx-2 space-y-1", "editor-focuskey": id, children: navbarItemsRendered?.map((item) => ((0,jsx_runtime.jsx)("li", { "editor-focuskey": id, children: (0,jsx_runtime.jsx)(Common_Link, { "editor-focuskey": id, href: item.href, className: classNames(item.href === activePage
                        ? classNames(props?.["bg-active-item"] || "bg-site-500", props?.["text-active-color"] || "text-white")
                        : classNames(props?.["text-color"] || "text-black", "hover:bg-gray-50"), "group flex gap-x-3 rounded-md p-2 pl-3 text-sm leading-6 font-medium"), children: item.name }) }, item.id))) }) }));
};
/* harmony default export */ var draggableComponents_DraggableNavbarVertical = (DraggableNavbarVertical);
//# sourceMappingURL=DraggableNavbarVertical.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/DraggableComponent.js




















const DraggableComponent = ({ item, elementId, }) => {
    const { setDragActive, dragOverComponent, mode, setDragContextMenu, iframeMount, } = useEditor();
    const isEditor = mode !== "production";
    const handleDragStart = (e) => {
        setDragActive(true);
        e.dataTransfer.setData("editor-component-drag-type", item.type);
        e.dataTransfer.setData("editor-component-drag-item", JSON.stringify(item));
    };
    const handleDragOver = (e) => {
        dragOverComponent.current = item.id;
    };
    const handleDragLeave = (e) => {
        dragOverComponent.current = null;
    };
    const handleRightClick = (e) => {
        if (e.type === "contextmenu") {
            e.preventDefault();
            if (e.target?.getAttribute("editor-key") === item.id) {
                if (typeof e.target?.click === "function") {
                    e.target?.click();
                }
                setDragContextMenu({
                    x: e.clientX,
                    y: e.clientY + iframeMount.scrollTop,
                    elementId,
                    item,
                });
            }
        }
    };
    const defaultDragProps = isEditor
        ? {
            draggable: true,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
        }
        : {};
    const defaultRightClickProps = isEditor
        ? {
            onContextMenu: handleRightClick,
        }
        : {};
    switch (item.type) {
        case draggable_DraggableComponentTypes.Text:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableText, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Title:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableTitle, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Div:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableDiv, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case draggable_DraggableComponentTypes.Container:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableContainer, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case draggable_DraggableComponentTypes.Grid:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableGrid, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case draggable_DraggableComponentTypes.GridItem:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableGridItem, { ...item, ...defaultRightClickProps, elementId: elementId }));
        case draggable_DraggableComponentTypes.Image:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableImage, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Link:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableLink, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Button:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableButton, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Form:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableForm, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Svg:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableSvg, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Icon:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableIcon, { item: item, ...defaultDragProps, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.List:
            return (0,jsx_runtime.jsx)(draggableComponents_DraggableList, { item: item, elementId: elementId });
        case draggable_DraggableComponentTypes.Navbar:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableNavbarHorizontal, { item: item, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.NavbarVertical:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableNavbarVertical, { item: item, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.ListItem:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableListItem, { item: item, elementId: elementId, ...defaultRightClickProps }));
        case draggable_DraggableComponentTypes.Html:
            return ((0,jsx_runtime.jsx)(draggableComponents_DraggableHtml, { item: item, elementId: elementId, ...defaultRightClickProps }));
        default:
            return (0,jsx_runtime.jsxs)("div", { children: ["Not found ", item.type] });
    }
};
/* harmony default export */ var draggable_DraggableComponent = (DraggableComponent);
//# sourceMappingURL=DraggableComponent.js.map
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/20/solid/PlusIcon.js
var solid_PlusIcon = __webpack_require__(75909);
;// CONCATENATED MODULE: ../elements/lib/components/draggable/DraggableAddComponent.js




const DraggableAddComponent = ({ draggableId, elementId }) => {
    const { setDragElementMenu, iframeMount, dragElementMenu } = useEditor();
    const handleClick = (e) => {
        setDragElementMenu({
            x: e.clientX,
            y: e.clientY + iframeMount.scrollTop,
            draggableId,
            elementId,
        });
    };
    return ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: (0,jsx_runtime.jsx)("button", { onClick: handleClick, type: "button", className: classNames("focus:ring-app-500 relative flex h-[20px] w-[20px] items-center justify-center rounded-full border text-sm font-medium focus:z-10 focus:outline-none focus:ring-1", dragElementMenu?.draggableId === draggableId
                ? "bg-app-500 border-app-500 text-white"
                : "hover:bg-app-200 bg-white text-black"), children: (0,jsx_runtime.jsx)(solid_PlusIcon, { className: "h-3 w-3", "aria-hidden": "true" }) }) }));
};
/* harmony default export */ var draggable_DraggableAddComponent = (DraggableAddComponent);
//# sourceMappingURL=DraggableAddComponent.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/DraggableBox.js








const DraggableBox = ({ draggableId, elementId, childs = [], className, focusKey, editorKey, type, component: Component = "div", text, style, ...props }) => {
    const { draggableAddComponent, dragActive, mode, editableItem, iframeMount, dragElementMenu, content, addElement, elements, } = useEditor();
    const [activeDragOver, setActiveDragOver] = (0,react.useState)(false);
    const handleDragOver = (e) => {
        const targetId = e.target
            .closest("[editor-draggablebox]")
            ?.getAttribute("editor-draggablebox");
        e.preventDefault();
        if (draggableId === targetId && dragActive) {
            setActiveDragOver(true);
        }
    };
    const handleDragLeave = (e) => {
        setActiveDragOver(false);
    };
    const handleDrop = (e) => {
        const targetId = e.target
            .closest("[editor-draggablebox]")
            ?.getAttribute("editor-draggablebox");
        e.preventDefault();
        if (draggableId === targetId) {
            if (e.dataTransfer.getData("block")) {
                const elementDrag = Object.values(elements)
                    .flat()
                    .find((element) => element?.element === e.dataTransfer.getData("block")) || null;
                const elementData = {
                    id: esm_browser_v4(),
                    type: e.dataTransfer.getData("block"),
                    props: elementDrag?.props ? JSON.parse(elementDrag?.props) : {},
                };
                return addElement(elementData, content.findIndex((c) => c.id === elementId) + 1);
            }
            const componentType = e.dataTransfer.getData("editor-component-drag-type");
            const componentData = e.dataTransfer.getData("editor-component-drag-item");
            setActiveDragOver(false);
            if (componentType) {
                const cData = componentData ? JSON.parse(componentData) : null;
                draggableAddComponent(draggableId, componentType, elementId, cData);
            }
        }
    };
    if (mode === "production") {
        return ((0,jsx_runtime.jsxs)(Component, { ...(className && { className }), ...(style && { style }), children: [childs?.map((item) => ((0,jsx_runtime.jsx)(draggable_DraggableComponent, { item: item, elementId: elementId }, item.id))), text && (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: text })] }));
    }
    const handleGridEdit = () => {
        const target = iframeMount
            ?.querySelector(`[editor-elementid='${elementId}']`)
            ?.querySelector(`[editor-key='${editorKey}']`);
        target?.click();
    };
    return ((0,jsx_runtime.jsxs)(Component, { "editor-focuskey": focusKey, "editor-key": focusKey ? null : editorKey, "editor-draggablebox": draggableId, "editor-has-childs": (childs?.length > 0).toString(), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, 
        // onClick={handleRightClick}
        // onContextMenu={handleRightClick}
        className: mode !== "production"
            ? classNames(className, "editor-drag-grid", activeDragOver &&
                type !== draggable_DraggableComponentTypes.Grid &&
                "editor-drag-selected"
            // childs?.length === 0 && "p-4"
            )
            : className, style: style, ...props, children: [type === draggable_DraggableComponentTypes.Grid &&
                editableItem?.getAttribute("editor-key") !== editorKey &&
                editableItem?.getAttribute("editor-key")?.includes(editorKey) && ((0,jsx_runtime.jsx)("span", { className: "absolute -top-11 right-2 isolate z-10 rounded-xl shadow", children: (0,jsx_runtime.jsx)("button", { onClick: handleGridEdit, type: "button", className: "relative -ml-px inline-flex items-center rounded border border-gray-300 bg-white px-4 py-2 text-xs font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1", children: "Grid instellingen" }) })), childs?.map((item) => ((0,jsx_runtime.jsx)(draggable_DraggableComponent, { item: item, elementId: elementId }, item.id))), text && (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: text }), activeDragOver && (0,jsx_runtime.jsx)("div", { className: "h-[2px] w-full bg-green-500" }), childs?.length === 0 && !text && ((0,jsx_runtime.jsx)("div", { className: "flex w-full justify-center my-4", "editor-focuskey": editorKey, children: (0,jsx_runtime.jsx)(draggable_DraggableAddComponent, { draggableId: draggableId, elementId: elementId }) }))] }));
};
/* harmony default export */ var draggable_DraggableBox = (DraggableBox);
//# sourceMappingURL=DraggableBox.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/RenderDraggableElement.js




const RenderDraggableElement = ({ elementProps, elementId }) => {
    const { mode } = useEditor();
    if (mode === "production") {
        return ((0,jsx_runtime.jsx)(draggable_DraggableBox, { draggableId: "1", elementId: elementId, childs: elementProps?.children || [], component: react.Fragment }));
    }
    return ((0,jsx_runtime.jsx)("div", { "editor-elementid": elementId, className: "editor-draggable", children: (0,jsx_runtime.jsx)("div", { className: "w-full", "editor-elementid": elementId, "editor-draggable": "true", children: (0,jsx_runtime.jsx)(draggable_DraggableBox, { draggableId: "1", elementId: elementId, childs: elementProps?.children || [] }) }) }));
};
/* harmony default export */ var draggable_RenderDraggableElement = (RenderDraggableElement);
//# sourceMappingURL=RenderDraggableElement.js.map
;// CONCATENATED MODULE: ../elements/lib/helpers/htmlToDraggable.js



const convertAttributeToProp = (attribute, value) => {
    switch (attribute) {
        case "class":
            return {
                propName: "className",
                value: value.replace(/dark:[^\s]+/g, '').replace("indigo", 'site'),
            };
        case "style":
            return {
                propName: "style",
                value: null
            };
        case "contenteditable":
            return {};
        default:
            return {
                propName: attribute,
                value,
            };
    }
};
const hasHTML = (htmlString) => {
    var htmlRegex = /<[^>]*>/;
    return htmlRegex.test(htmlString);
};
function htmlToJson(element, parent = null) {
    const obj = {};
    const tagNameMapping = {
        div: DraggableComponentTypes.Div,
        span: DraggableComponentTypes.Div,
        section: DraggableComponentTypes.Div,
        h1: DraggableComponentTypes.Title,
        h2: DraggableComponentTypes.Title,
        h3: DraggableComponentTypes.Title,
        h4: DraggableComponentTypes.Title,
        h5: DraggableComponentTypes.Title,
        h6: DraggableComponentTypes.Title,
        a: DraggableComponentTypes.Link,
        p: DraggableComponentTypes.Text,
        img: DraggableComponentTypes.Image,
        form: DraggableComponentTypes.Form,
        dl: DraggableComponentTypes.Div,
        dt: DraggableComponentTypes.Div,
        dd: DraggableComponentTypes.Div,
        svg: DraggableComponentTypes.Svg,
        ul: DraggableComponentTypes.List,
        li: DraggableComponentTypes.ListItem,
        strong: DraggableComponentTypes.Text,
    };
    const tagName = element.tagName.toLowerCase();
    const componentType = tagNameMapping[tagName];
    if (!componentType) {
        return;
    }
    obj.type = componentType;
    if (parent && [DraggableComponentTypes.Link].includes(parent.type)) {
        return;
    }
    if (parent && parent.type === DraggableComponentTypes.Grid && componentType === DraggableComponentTypes.Div) {
        obj.type = DraggableComponentTypes.GridItem;
    }
    if (parent && parent.type === DraggableComponentTypes.List) {
        obj.type = DraggableComponentTypes.ListItem;
    }
    obj.id = parent ? `${parent.id}/${uuidv4()}` : "1";
    obj.props = { className: " " };
    if (componentType === DraggableComponentTypes.Div ||
        componentType === DraggableComponentTypes.Title) {
        obj.props.component = tagName;
    }
    const attributes = element.attributes;
    if (attributes.length > 0) {
        [...attributes].forEach((attribute) => {
            const convertedProp = convertAttributeToProp(attribute.name, attribute.value);
            obj.props[convertedProp.propName] = convertedProp.value;
        });
        if (obj.props.className.includes("grid")) {
            obj.type = DraggableComponentTypes.Grid;
            obj.props = {
                ...obj.props,
                // gridMobile: "grid-cols-2",
                // gridTablet: "md:grid-cols-2",
                // gridDesktop: "lg:grid-cols-2",
            };
        }
        if (componentType === DraggableComponentTypes.Link) {
            obj.props.link = {
                label: element.innerText.trim().replace(/<svg[^>]*>[\s\S]*?<\/svg>/g, "")
            };
        }
        else if (componentType === DraggableComponentTypes.Image) {
            obj.props.image = {
                src: obj.props?.src.includes("http") ? obj.props?.src : "https://placehold.co/600x400?text=Placeholder",
                alt: obj.props?.alt,
                file: imagePlaceholder.file,
            };
        }
    }
    if (componentType === DraggableComponentTypes.Div && !hasHTML(element.innerHTML)) {
        obj.props.text = element.innerText.trim();
    }
    if (element.innerText && componentType !== DraggableComponentTypes.Div) {
        if ([DraggableComponentTypes.Text, DraggableComponentTypes.Title].includes(obj.type)) {
            obj.props.className += " prose";
        }
        if (componentType !== DraggableComponentTypes.Div) {
            obj.props.text = element.innerText.trim();
        }
    }
    if (obj.type === DraggableComponentTypes.Svg) {
        obj.props.svgContent = element.innerHTML;
    }
    // Clean up
    if (obj.props.className) {
        obj.props.className = obj.props.className.replace(/ {2,}/g, ' ');
        if (obj.props.classsName === " ") {
            delete obj.props.className;
        }
    }
    const childNodes = element.children;
    if (childNodes.length > 0) {
        obj.children = [];
        [...childNodes].forEach((childNode) => {
            if (childNode.nodeType === Node.TEXT_NODE) {
                obj.props.text = childNode.nodeValue;
            }
            else if (childNode.nodeType === Node.ELEMENT_NODE) {
                const child = htmlToJson(childNode, obj);
                if (child) {
                    obj.children.push(child);
                }
            }
        });
    }
    return obj;
}
const htmlToDraggable = (html) => {
    let element = document.createElement("div");
    element.innerHTML = html;
    return {
        id: 1,
        children: [htmlToJson(element.childNodes[0], { id: 1 })],
    };
};
/* harmony default export */ var helpers_htmlToDraggable = ((/* unused pure expression or super */ null && (htmlToDraggable)));
//# sourceMappingURL=htmlToDraggable.js.map
;// CONCATENATED MODULE: ../elements/lib/components/draggable/draggableElements.js


const draggableCategories = {
    structure: "Structuur",
    basic: "Basis",
    typography: "Teksten",
    media: "Media",
    form: "Formulieren",
    navigator: "Navigatie",
    // other: "Overig",
};
const draggableElements = [
    {
        type: draggable_DraggableComponentTypes.Text,
        element: "P",
        name: "Tekst",
        icon: CaseUpper,
        category: draggableCategories.typography,
    },
    {
        type: draggable_DraggableComponentTypes.Title,
        element: "h1",
        name: "H1",
        icon: Heading,
        category: draggableCategories.typography,
    },
    {
        type: draggable_DraggableComponentTypes.Div,
        element: "div",
        name: "Div",
        icon: BoxSelect,
        category: draggableCategories.structure,
    },
    {
        type: draggable_DraggableComponentTypes.Grid,
        element: "grid",
        name: "Grid",
        icon: LayoutPanelTop,
        category: draggableCategories.structure,
    },
    {
        type: draggable_DraggableComponentTypes.Image,
        element: "img",
        name: "Afbeelding",
        icon: Image,
        category: draggableCategories.media,
    },
    {
        type: draggable_DraggableComponentTypes.Link,
        element: "A",
        name: "Link",
        icon: link_Link,
        category: draggableCategories.basic,
    },
    {
        type: draggable_DraggableComponentTypes.Button,
        element: "button",
        name: "Button",
        icon: Square,
        category: draggableCategories.basic,
    },
    {
        type: draggable_DraggableComponentTypes.Form,
        element: "form",
        name: "Formulier",
        icon: FormInput,
        category: draggableCategories.form,
    },
    {
        type: draggable_DraggableComponentTypes.Navbar,
        element: "navbar",
        name: "Navigatie",
        icon: Menu,
        category: draggableCategories.navigator,
    },
    {
        type: draggable_DraggableComponentTypes.NavbarVertical,
        element: "navbarVariant",
        name: "Menu vertical",
        icon: Menu,
        category: draggableCategories.navigator,
    },
    {
        type: draggable_DraggableComponentTypes.Html,
        element: "html",
        name: "HTML",
        icon: Code,
        category: draggableCategories.basic,
    },
    {
        type: draggable_DraggableComponentTypes.Container,
        element: "container",
        name: "Container",
        icon: BoxSelect,
        category: draggableCategories.structure,
    },
    {
        type: draggable_DraggableComponentTypes.Icon,
        element: "icon",
        name: "Icon",
        icon: Sparkle,
        category: draggableCategories.basic,
    },
];
//# sourceMappingURL=draggableElements.js.map
;// CONCATENATED MODULE: ../elements/lib/index.js












const lib_elements = {
    ...components_element,
    ...html,
};

/* harmony default export */ var lib = (lib_elements);
//# sourceMappingURL=index.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(52170), __webpack_exec__(92203); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);